/*!
 * @maptalks/gl v0.124.4
 * LICENSE : UNLICENSED
 * (c) 2016-2026 maptalks.com
 */
import createREGL from '@maptalks/regl';
export { default as createREGL } from '@maptalks/regl';
import { mat4, vec3, vec4, mat3, vec2, quat, glMatrix, mat2, mat2d, quat2 } from 'gl-matrix';
export { mat2, mat2d, mat3, mat4, quat, quat2, vec2, vec3, vec4 } from 'gl-matrix';
import * as maptalks from 'maptalks';
import { Coordinate, Util as Util$1, Point, Polygon, Extent, worker, Map as Map$1, renderer } from 'maptalks';
import { buildTangents, packTangentFrame, buildNormals } from '@maptalks/tbn-packer';
import { GLContext } from '@maptalks/fusiongl';
export { GLContext } from '@maptalks/fusiongl';

const getGlobal$2 = function () {
    if (typeof globalThis !== 'undefined') { return globalThis; }
    if (typeof self !== 'undefined') { return self; }
    if (typeof window !== 'undefined') { return window; }
    if (typeof global !== 'undefined') { return global; }
    throw new Error('unable to locate global object');
};

const globals = getGlobal$2();

const transcoders = globals['gl_trans__coders'] = globals['gl_trans__coders'] || {};


function inject(chunk) {
    // 奇怪的变量名是为了避免与worker源代码中的变量名冲突
    const fnString = chunk.toString();
    const prefixIndex = fnString.indexOf('{') + 1;
    const prefix = fnString.substring(0, prefixIndex);

    const transcoders = globals['gl_trans__coders'] = globals['gl_trans__coders'] || {};
    let injected = `${prefix}
    const _____getGlobal = ${getGlobal$2.toString()};
    const g___lobals = _____getGlobal()
    const tran_____scoders = g___lobals['gl_trans__coders'] = g___lobals['gl_trans__coders'] || {};`;
    for (const p in transcoders) {
        if (p === 'inject' || p === 'getTranscoder' || p === 'registerTranscoder') {
            continue;
        }
        injected += 'tran_____scoders["' + p + '"] =' + transcoders[p].toString() + '\n;';
    }
    const gltfBundle = getGlobal$2()['maptalks_gltf_loader_bundle'];
    injected += '\n(' + gltfBundle.toString() + ')({});\n';
    injected += '\n' + fnString.substring(prefix.length);
    return injected;
}
transcoders['inject'] = inject;

function getTranscoder(name/*, options*/) {
    return transcoders[name];
}

function registerTranscoder(name, fn) {
    transcoders[name] = fn;
}

function registerGLTFLoaderBundle(fn) {
    getGlobal$2()['maptalks_gltf_loader_bundle'] = fn;
}

transcoders.registerTranscoder = registerTranscoder;
transcoders.getTranscoder = getTranscoder;

function gltfLoaderExport(e){var t=function(){return "undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:"undefined"!=typeof window?window:"undefined"!=typeof global?global:void 0};if(t().maptalks_gltf_loader)return;
/*!
	 * @maptalks/gltf-loader v0.124.4
	 * LICENSE : UNLICENSED
	 * (c) 2016-2026 maptalks.org
	 */var s="undefined"!=typeof Float32Array?Float32Array:Array;function r(e,t,s){var r=t[0],n=t[1],i=t[2],a=t[3],o=t[4],f=t[5],u=t[6],h=t[7],c=t[8],l=t[9],d=t[10],m=t[11],g=t[12],p=t[13],b=t[14],_=t[15],y=s[0],x=s[1],w=s[2],T=s[3];return e[0]=y*r+x*o+w*c+T*g,e[1]=y*n+x*f+w*l+T*p,e[2]=y*i+x*u+w*d+T*b,e[3]=y*a+x*h+w*m+T*_,y=s[4],x=s[5],w=s[6],T=s[7],e[4]=y*r+x*o+w*c+T*g,e[5]=y*n+x*f+w*l+T*p,e[6]=y*i+x*u+w*d+T*b,e[7]=y*a+x*h+w*m+T*_,y=s[8],x=s[9],w=s[10],T=s[11],e[8]=y*r+x*o+w*c+T*g,e[9]=y*n+x*f+w*l+T*p,e[10]=y*i+x*u+w*d+T*b,e[11]=y*a+x*h+w*m+T*_,y=s[12],x=s[13],w=s[14],T=s[15],e[12]=y*r+x*o+w*c+T*g,e[13]=y*n+x*f+w*l+T*p,e[14]=y*i+x*u+w*d+T*b,e[15]=y*a+x*h+w*m+T*_,e}function n(){var e=new s(3);return s!=Float32Array&&(e[0]=0,e[1]=0,e[2]=0),e}function i(e,t,r){var n=new s(3);return n[0]=e,n[1]=t,n[2]=r,n}function a(e,t){return e[0]=t[0],e[1]=t[1],e[2]=t[2],e}function o(e,t,s,r){return e[0]=t,e[1]=s,e[2]=r,e}function f(e,t,s){return e[0]=t[0]+s[0],e[1]=t[1]+s[1],e[2]=t[2]+s[2],e}function u(e,t,s){return e[0]=t[0]*s,e[1]=t[1]*s,e[2]=t[2]*s,e}function h(e,t,s,r,n){return e[0]=t,e[1]=s,e[2]=r,e[3]=n,e}function c(e,t,s){var r=t[0],n=t[1],i=t[2],a=t[3];return e[0]=s[0]*r+s[4]*n+s[8]*i+s[12]*a,e[1]=s[1]*r+s[5]*n+s[9]*i+s[13]*a,e[2]=s[2]*r+s[6]*n+s[10]*i+s[14]*a,e[3]=s[3]*r+s[7]*n+s[11]*i+s[15]*a,e}function l(){var e=new s(4);return s!=Float32Array&&(e[0]=0,e[1]=0,e[2]=0),e[3]=1,e}Math.hypot||(Math.hypot=function(){for(var e=0,t=arguments.length;t--;)e+=arguments[t]*arguments[t];return Math.sqrt(e)}),n(),function(){var e;e=new s(4),s!=Float32Array&&(e[0]=0,e[1]=0,e[2]=0,e[3]=0);}();var d,m=function(e,t){return e[0]=t[0],e[1]=t[1],e[2]=t[2],e[3]=t[3],e};n(),i(1,0,0),i(0,1,0),l(),l(),d=new s(9),s!=Float32Array&&(d[1]=0,d[2]=0,d[3]=0,d[5]=0,d[6]=0,d[7]=0),d[0]=1,d[4]=1,d[8]=1;let g=0;function p(e){return null==e}function b(e){return !p(e)}function _(e){return !p(e)&&("string"==typeof e||null!==e.constructor&&e.constructor===String)}function y(e){for(let t=1;t<arguments.length;t++){const s=arguments[t];for(const t in s)e[t]=s[t];}return e}function x(e){switch(e){case 5120:return Int8Array;case 5121:return Uint8Array;case 5122:return Int16Array;case 5123:return Uint16Array;case 5124:return Int32Array;case 5125:return Uint32Array;case 5126:return Float32Array}throw new Error("unsupported bufferView's component type: "+e)}function w(e){return 0===e.indexOf("data:")&&e.indexOf("base64,")>0}function T(e){const t=function(e){return "undefined"!=typeof self?self.atob(e):window.atob(e)}(e.substring(e.indexOf(",")+1)),s=t.length,r=new Uint8Array(s);for(let e=0;e<s;e++)r[e]=t.charCodeAt(e);return r.buffer}const E=[],O=[],I=[],R=[0,0,0],A=function(e){return e[0]=0,e[1]=0,e[2]=0,e[3]=1,e}([]),v=[1,1,1];function q(e,t,s,r,n,i,a){const o=x(a),f=o.BYTES_PER_ELEMENT;if((0===n||n===r*f)&&i%f==0){const n=new o(t,i,s*r);return e.set(n),e}0===n&&(n=r*f);const u=new Uint8Array(r*f);for(let a=0;a<s;a++){let s=null;const h=new Uint8Array(t,n*a+i,r*f);u.set(h),s=new o(u.buffer,0,r);for(let t=0;t<r;t++)e[a*r+t]=s[t];}return e}const B="undefined"!=typeof TextDecoder?new TextDecoder("utf-8"):null;function P(e,t,s){const r=new Uint8Array(e,t,s);return B.decode(r)}const N={get:function(e,t={},s){t||(t={}),t=y({},t);const r=new AbortController,n=r.signal,i=y({},t);i.signal=n,i.method||(i.method="GET"),i.referrerPolicy=i.referrerPolicy||"origin","undefined"==typeof window||i.referrer||(i.referrer=window.location.href),s&&(e=s(e));const a=fetch(e,i).then((e=>{const s=this._parseResponse(e,t.responseType);return s.message?s:s.then((s=>"arraybuffer"===t.responseType?{data:s,cacheControl:e.headers.get("Cache-Control"),expires:e.headers.get("Expires"),contentType:e.headers.get("Content-Type")}:s)).catch((e=>{if(!e.code||e.code!==DOMException.ABORT_ERR)throw e}))})).catch((e=>{if(!e.code||e.code!==DOMException.ABORT_ERR)throw e}));return a.xhr=r,a},_parseResponse:(e,t)=>200!==e.status?{status:e.status,statusText:e.statusText,message:`incorrect http request with status code(${e.status}): ${e.statusText}`}:"arraybuffer"===t?e.arrayBuffer():"json"===t?e.json():e.text(),getArrayBuffer:(e,t={},s)=>(t||(t={}),t.responseType="arraybuffer",N.get(e,t,s)),getJSON:function(e,t={},s){return t&&t.jsonp?N.jsonp(e):((t=t||{}).responseType="json",N.get(e,t,s))},jsonp:function(e){const t="_maptalks_jsonp_"+g++;e.match(/\?/)?e+="&callback="+t:e+="?callback="+t;let s=document.createElement("script");return s.type="text/javascript",s.src=e,new Promise((e=>{window[t]=function(r){document.getElementsByTagName("head")[0].removeChild(s),s=null,delete window[t],e(r);},document.getElementsByTagName("head")[0].appendChild(s);}))}};class S{constructor(e,t,s,r,n){this._requestImage=e,this.decoders=t,this._supportedFormats=s,this.images={},this._imgRequests={},this._fetchOptions=r||{},this._urlModifier=n;}requestImageFromBufferURI(e,t,s){if(this.buffers[e.id]){const r=this.buffers[e.id],n=this._createDataView(t,r);return this.getImageByBuffer(n,s)}if(this._imgRequests[e.id])return this._imgRequests[e.id].then((()=>{const r=this.buffers[e.id],n=this._createDataView(t,r);return this.getImageByBuffer(n,s)}));if(w(e.uri)){const r=this.buffers[e.id]=T(e.uri),n=this._createDataView(t,r);return this.getImageByBuffer(n,s)}let r;const n=e.uri.indexOf("blob:")>=0;return r=e.uri.indexOf("://")>0||n?e.uri:this.rootPath+"/"+e.uri,this._imgRequests[e.id]=N.getArrayBuffer(r,this._fetchOptions,this._urlModifier).then((r=>{const n=this.buffers[e.id]=r.data,i=this._createDataView(t,n);return this.getImageByBuffer(i,s)}))}getImageByBuffer(e,t){if(this.images[t.id])return Promise.resolve(this.images[t.id]);const s=this.decoders;if(s[t.mimeType])return s[t.mimeType](e,{supportedFormats:this._supportedFormats});if("image/crn"===t.mimeType||"image/ktx2"===t.mimeType||"image/cttf"===t.mimeType)throw new Error("missing transcoder for "+t.mimeType,"");return this._getImageInfo(t.id,e)}requestExternalImage(e){if(this.images[e.id])return Promise.resolve(this.images[e.id]);const t=0===e.uri.indexOf("data:image/")?e.uri:this.rootPath+"/"+e.uri;return this._imgRequests[e.id]?this._imgRequests[e.id].then((()=>this.images[e.id])):this._imgRequests[e.id]=this._getImageInfo(e.id,t)}_getImageInfo(e,t){return new Promise(((s,r)=>{let n=t;this._urlModifier&&(n=this._urlModifier(t)),this._requestImage(n,this._fetchOptions,((n,i)=>{n?r(n):(URL.revokeObjectURL(t),this.images[e]=i,s(this.images[e]));}));}))}}const M=["SCALAR",1,"VEC2",2,"VEC3",3,"VEC4",4,"MAT2",4,"MAT3",9,"MAT4",16],V=[];class L{constructor(e,t,s,r,n){this.rootPath=e,this.gltf=t,this._enableInterleave=!1,this.glbBuffer=s,this.buffers={},this.requests={},this.accessors={},this._compareAccessor(),this._fetchOptions=r,this._urlModifier=n;}_requestData(e,t){const s=this.gltf,r=s.accessors[t];if(void 0===r.bufferView)return this.accessors[r.id]=this._toBufferData(e,t,null,0),Promise.resolve(this.accessors[r.id]);if(r&&this.accessors[r.id])return Promise.resolve(this.accessors[r.id]);const n=s.bufferViews[r.bufferView];return this._requestBufferOfBufferView(n).then((s=>{const{buffer:n,byteOffset:i}=s;return this.accessors[r.id]=this._toBufferData(e,t,n,i)}))}_requestBufferOfBufferView(e){const t=this.gltf.buffers[e.buffer];if(this.buffers[t.id]){const e=this.buffers[t.id];return Promise.resolve({buffer:e,byteOffset:0})}if(this.requests[t.id])return this.requests[t.id].then((()=>{const e=this.buffers[t.id];return Promise.resolve({buffer:e,byteOffset:0})}));if("binary_glTF"!==e.buffer&&"KHR_binary_glTF"!==e.buffer&&t.uri){if(w(t.uri)){const e=this.buffers[t.id]=T(t.uri);return Promise.resolve({buffer:e,byteOffset:0})}let e;const s=t.uri.indexOf("blob:")>=0;return e=t.uri.indexOf("://")>0||s?t.uri:this.rootPath+"/"+t.uri,this.requests[t.id]=N.getArrayBuffer(e,this._fetchOptions,!s&&this._urlModifier).then((r=>(s&&URL.revokeObjectURL(e),{buffer:this.buffers[t.id]=r.data,byteOffset:0})))}return Promise.resolve({buffer:this.glbBuffer.buffer,byteOffset:this.glbBuffer.byteOffset})}_toBufferData(e,t,s,r=0){const n=this.gltf,i=n.accessors[t],a=void 0!==i.bufferView?n.bufferViews[i.bufferView]:{},o=(a.byteOffset||0)+r,f=this._getTypeItemSize(i.type),u=x(i.componentType),h=a.byteStride||0,l={array:void 0,name:e,accessorName:t,byteLength:i.count*f*u.BYTES_PER_ELEMENT,componentType:i.componentType,count:i.count,type:i.type,itemSize:f,max:i.max,min:i.min,extensions:i.extensions};if(i.min&&(l.min=i.min),i.max&&(l.max=i.max),s)if(this._enableInterleave)l.byteStride=h,l.byteOffset=o+(i.byteOffset||0),!h||h===f*u.BYTES_PER_ELEMENT||"indices"===e||"input"===e||"output"===e||e.indexOf("morph")>=0?(l.array=this._typedArray(s,i.count,f,o+(i.byteOffset||0),u),l.array.buffer.byteLength===l.byteLength&&(l.byteOffset=0)):l.array=new Uint8Array(s,o,a.byteLength);else if(i.interleaved){l.byteStride=0,l.byteOffset=0;const e=new u(i.count*f);if(l.array=q(e,s,i.count,f,h,o+(i.byteOffset||0),i.componentType),l.extensions&&l.extensions.WEB3D_quantized_attributes&&f>2){const e=new Float32Array(l.array.length),{decodeMatrix:t}=l.extensions.WEB3D_quantized_attributes;for(let s=0;s<l.array.length;s+=f){V[0]=l.array[s],V[1]=l.array[s+1],V[2]=l.array[s+2],V[3]=1;const r=c(V,V,t);e[s]=r[0],e[s+1]=r[1],e[s+2]=r[2];}l.componentType=5126,l.array=e;}}else l.byteStride=0,l.array=this._typedArray(s,i.count,f,o+(i.byteOffset||0),u),l.byteOffset=l.array.byteOffset;else {l.array=new u(i.count);const e=l.min||l.max;e&&(l.array[0]=e[0],l.array[1]=e[1],l.array[2]=e[2]);}return l}_compareAccessor(){const e=this.gltf.accessors;if(Array.isArray(e))for(let t=0;t<e.length;t++)for(let s=0;s<e.length;s++)t!==s&&e[t].bufferView===e[s].bufferView&&(e[t].interleaved=e[s].interleaved=!0);else for(const t in e)for(const s in e)t!==s&&e[t].bufferView===e[s].bufferView&&(e[t].interleaved=e[s].interleaved=!0);}_typedArray(e,t,s,r,n){return r%n.BYTES_PER_ELEMENT!=0&&(e=e.slice(r,r+t*s*n.BYTES_PER_ELEMENT),r=0),new n(e,r,s*t)}_getTypeItemSize(e){const t=M.indexOf(e);return M[t+1]}requestKHRTechniquesWebgl(e){const{shaders:t}=e,s=t.map((e=>{if(void 0!==e.bufferView){const t=this.gltf.bufferViews[e.bufferView],{byteLength:s}=t;return this._requestBufferOfBufferView(t).then((r=>{const{buffer:n,byteOffset:i}=r,a=P(n,i+(t.byteOffset||0),s);return e.content=a,e}))}if(e.uri){if(w(e.uri)){const t=T(e.uri),s=P(t,0,t.byteLength);return e.content=s,Promise.resolve(e)}{const t=this.rootPath+"/"+e.uri;return N.get(t,this._fetchOptions,this._urlModifier).then((t=>(e.content=t,e)))}}return Promise.resolve(e)}));return Promise.all(s).then((()=>e))}}class D extends S{constructor(e,t,s,r,n,i,a,o){super(r,n,i,a,o),this.rootPath=e,this.gltf=t,this.requests={},this.buffers={},this.glbBuffer=s,this.accessor=new L(e,t,s,a,o);}iterate(e,t){const s=this.gltf[t];if(!s)return;let r=0;for(const t in s)e(t,s[t],r++);}createNode(e){const t={};if(b(e.name)&&(t.name=e.name),b(e.children)&&(t.children=e.children),b(e.jointName)&&(t.jointName=e.jointName),b(e.matrix)&&(t.matrix=e.matrix),b(e.rotation)&&(t.rotation=e.rotation),b(e.scale)&&(t.scale=e.scale),b(e.translation)&&(t.translation=e.translation),b(e.extras)&&(t.extras=e.extras),b(e.meshes)&&(t.mesh=e.meshes[0]),t.translation||t.rotation||t.scale){const e=function(e,t){if(t.matrix)return t.matrix;if(t.translation||t.scale||t.rotation){const s=function(e,t){return e[0]=1,e[1]=0,e[2]=0,e[3]=0,e[4]=0,e[5]=1,e[6]=0,e[7]=0,e[8]=0,e[9]=0,e[10]=1,e[11]=0,e[12]=t[0],e[13]=t[1],e[14]=t[2],e[15]=1,e}(E,t.translation||R),n=function(e,t){var s=t[0],r=t[1],n=t[2],i=t[3],a=s+s,o=r+r,f=n+n,u=s*a,h=r*a,c=r*o,l=n*a,d=n*o,m=n*f,g=i*a,p=i*o,b=i*f;return e[0]=1-c-m,e[1]=h+b,e[2]=l-p,e[3]=0,e[4]=h-b,e[5]=1-u-m,e[6]=d+g,e[7]=0,e[8]=l+p,e[9]=d-g,e[10]=1-u-c,e[11]=0,e[12]=0,e[13]=0,e[14]=0,e[15]=1,e}(O,t.rotation||A),i=function(e,t){return e[0]=t[0],e[1]=0,e[2]=0,e[3]=0,e[4]=0,e[5]=t[1],e[6]=0,e[7]=0,e[8]=0,e[9]=0,e[10]=t[2],e[11]=0,e[12]=0,e[13]=0,e[14]=0,e[15]=1,e}(I,t.scale||v);return r(i,n,i),r(e,s,i)}return function(e){return e[0]=1,e[1]=0,e[2]=0,e[3]=0,e[4]=0,e[5]=1,e[6]=0,e[7]=0,e[8]=0,e[9]=0,e[10]=1,e[11]=0,e[12]=0,e[13]=0,e[14]=0,e[15]=1,e}(e)}([],t);delete t.translation,delete t.rotation,delete t.scale,t.matrix=e;}return t}_loadMaterials(e){const t={};for(const s in e){const r=e[s];let n,i;r.instanceTechnique&&r.instanceTechnique.values?(n=r.instanceTechnique,i=n.values.diffuse):(n=r,i=n.values.tex||n.values.diffuseTex||n.values.diffuse);const a={baseColorTexture:{index:i}};r.name&&(a.name=r.name),r.extensions&&(a.extensions=r.extensions),r.extras&&(a.extras=r.extras),t[s]=a;}return t}_loadImage(e){if(e.bufferView||e.extensions&&(e.extensions.KHR_binary_glTF||e.extensions.binary_glTF)){const t=e.bufferView?e:e.extensions.KHR_binary_glTF||e.extensions.binary_glTF;e.extensions&&(e.mimeType=t.mimeType,e.width=t.width,e.height=t.height);const s=this.gltf.bufferViews[t.bufferView],r=(s.byteOffset||0)+this.glbBuffer.byteOffset,n=s.byteLength,i=this.buffers[t.bufferView]=new Uint8Array(this.glbBuffer.buffer,r,n);return this.getImageByBuffer(i,e)}return this.requestExternalImage(e)}_getTexture(e){const t=this.gltf.textures[e];if(!t)return null;const s=this.gltf.images[t.source];return this._loadImage(s).then((e=>{const r=this.gltf.samplers[t.sampler];return {image:{array:e.data,width:e.width,height:e.height,index:t.source,mimeType:s.mimeType,name:s.name,extras:s.extras},sampler:r}}))}getBaseColorTexture(e){const t=this.gltf.materials[e];let s,r;if(t.instanceTechnique&&t.instanceTechnique.values?(s=t.instanceTechnique,r=s.values.diffuse):(s=t,r=s.values.tex||s.values.diffuseTex||s.values.diffuse),void 0===r||void 0===this.gltf.textures)return null;const n=this.gltf.textures[r];if(!n)return null;const i=this.gltf.samplers[n.sampler];return {format:n.format||6408,internalFormat:n.internalFormat||6408,type:n.type||5121,sampler:i,source:this.gltf.images[n.source]}}getMaterial(){return null}getAnimations(){return null}}const U=9729;class C extends S{constructor(e,t,s,r,n,i,a,o){super(r,n,i,a,o),this.rootPath=e,this.gltf=t,this.glbBuffer=s,this.buffers={},this.requests={},this.accessor=new L(e,t,s,a,o);}iterate(e,t){const s=this.gltf[t];if(s)for(let t=0;t<s.length;t++)e(t,s[t],t);}createNode(e){const t={};return y(t,e),!b(e.weights)&&this.gltf.meshes&&b(t.mesh)?t.weights=this.gltf.meshes[t.mesh].weights:e.weights&&(t.weights=e.weights),t}_getTexture(e){const t=this.gltf.textures[e];if(!t)return null;let s=t.source;if(t.extensions&&t.extensions.EXT_texture_webp?s=t.extensions.EXT_texture_webp.source:t.extensions&&t.extensions.KHR_texture_basisu&&(s=t.extensions.KHR_texture_basisu.source),!b(s))return null;const r=this.gltf.images[s];return this._loadImage(r).then((e=>{if(!e)return null;const s={image:{array:e.data,mipmap:e.mipmap,width:e.width,height:e.height,index:t.source,mimeType:r.mimeType,name:r.name,extensions:r.extensions,extras:r.extras}};y(s,t);const n=b(t.sampler)?this.gltf.samplers[t.sampler]:void 0;if(n&&(s.sampler=n,s.sampler.magFilter=n.magFilter||U,s.sampler.minFilter=n.minFilter||9987,s.sampler.wrapS=n.wrapS||10497,s.sampler.wrapT=n.wrapT||10497),"image/ktx2"===s.image.mimeType&&!s.image.mipmap&&s.sampler&&s.sampler.minFilter!==U&&9728!==s.sampler.minFilter){const e=s.sampler.minFilter;s.sampler.minFilter=9984===e||9986===e?9728:U;}if(e.format&&(s.format=e.format),6407===s.format){const e=s.image.array&&s.image.array.length;e&&e===s.image.width*s.image.height*4&&(s.format=6408);}return s}))}_loadImage(e){if(!b(e.bufferView))return this.requestExternalImage(e);{const t=this.gltf.bufferViews[e.bufferView],s=this.gltf.buffers[t.buffer];if(s.uri)return this.requestImageFromBufferURI(s,t,e);if(this.glbBuffer)return this._requestFromGlbBuffer(t,e)}return null}_requestFromGlbBuffer(e,t){const s=this._createDataView(e,this.glbBuffer.buffer,this.glbBuffer.byteOffset);return this.getImageByBuffer(s,t)}_createDataView(e,t,s){s=s||0;const r=(e.byteOffset||0)+s,n=e.byteLength;return new Uint8Array(t,r,n)}_transformArrayBufferToBase64(e,t){const s=new Array(e.byteLength);for(let t=0;t<e.byteLength;t++)s[t]=String.fromCharCode(e[t]);s.join("");const r="data:"+(t=t||"image/png")+";base64,"+function(e){return "undefined"!=typeof self?self.btoa(e):window.btoa(e)}(unescape(encodeURIComponent(s)));return r}getAnimations(e){const t=[];return e.forEach((e=>{t.push(this.getSamplers(e.samplers));})),Promise.all(t).then((t=>{for(let s=0;s<t.length;s++)e[s].samplers=t[s];return e}))}getSamplers(e){const t=[];for(let s=0;s<e.length;s++)(b(e[s].input)||b(e[s].output))&&(t.push(this.accessor._requestData("input",e[s].input)),t.push(this.accessor._requestData("output",e[s].output)));return Promise.all(t).then((t=>{for(let s=0;s<t.length/2;s++)e[s].input=t[2*s],e[s].output=t[2*s+1],e[s].interpolation||(e[s].interpolation="LINEAR");return e}))}}const F="undefined"!=typeof TextDecoder?new TextDecoder("utf-8"):null;class k{static read(e,t=0,s=0){s||(s=e.byteLength);const r=new DataView(e,t,s),n=r.getUint32(4,!0);if(1===n)return k.readV1(r,t);if(2===n)return k.readV2(e,t);throw new Error("Unsupported glb version : "+n)}static readV1(e,t){const s=e.getUint32(8,!0),r=e.getUint32(12,!0);if(s!==e.byteLength)throw new Error("Length in GLB header is inconsistent with glb's byte length.");const n=X(e.buffer,20+t,r);return {json:JSON.parse(n),glbBuffer:{byteOffset:20+t+r,buffer:e.buffer,byteLength:s}}}static readV2(e,t){let s,r,n;const i=new DataView(e,t+12);let a=0;for(;a+8<i.byteLength;){const o=i.getUint32(a,!0);a+=4;const f=i.getUint32(a,!0);if(a+=4,1313821514===f)s=X(e,t+12+a,o);else if(5130562===f){n=t+12+a,r=o;break}a+=o;}return {json:JSON.parse(s),glbBuffer:{byteOffset:n,buffer:e,byteLength:r}}}}function X(e,t,s){if(F){const r=new Uint8Array(e,t,s);return F.decode(r)}return function(e){const t=e.length;let s="";for(let r=0;r<t;){let n=e[r++];if(128&n){let s=K[n>>3&7];if(!(64&n)||!s||r+s>t)return null;for(n&=63>>s;s>0;s-=1){const t=e[r++];if(128!=(192&t))return null;n=n<<6|63&t;}}s+=String.fromCharCode(n);}return s}(new Uint8Array(e,t,s))}const K=[1,1,1,1,2,2,3,0],j=[0,0,0],H=[0,0,0,1],z=[1,1,1],G={TRANSLATION:[0,0,0],ROTATION:[0,0,0,1],SCALE:[1,1,1]},W={PREVIOUS:null,NEXT:null,PREINDEX:null,NEXTINDEX:null,INTERPOLATION:null},Y={_getTRSW(e,t,s,r,n,i,o,f){const u=b(e)?t.animations:[t.animations[0]],h={};for(let t=0;t<u.length;t++){const c=u[t],l=c.name||t;if(b(e)&&l!==e)continue;const d=c.channelsMap[s];if(d)for(let e=0;e<d.length;e++){const t=d[e];"translation"===t.target.path?(this._getAnimateData(n,c.samplers[t.sampler],r,1),h.translation=a(j,n)):"rotation"===t.target.path?(this._getQuaternion(i,c.samplers[t.sampler],r,1),h.rotation=m(H,i)):"scale"===t.target.path?(this._getAnimateData(o,c.samplers[t.sampler],r,1),h.scale=a(z,o)):"weights"===t.target.path&&f&&(this._getAnimateData(f,c.samplers[t.sampler],r,f.length),h.weights=f);}}return h},_getAnimateData(e,t,s,r){switch(t.interpolation){case"LINEAR":{const n=this._getPreNext(W,t,s,1*r);n&&(e=function(e,t,s,r){for(let n=0;n<e.length;n++)e[n]=t[n]+r*(s[n]-t[n]);return e}(e,n.PREVIOUS,n.NEXT,n.INTERPOLATION));break}case"STEP":{const n=this._getPreNext(W,t,s,1*r);n&&(e=function(e,t){for(let s=0;s<e.length;s++)e[s]=t[s];return e}(e,...n.PREVIOUS));break}case"CUBICSPLINE":{const n=this._getPreNext(W,t,s,3*r);n&&(e=this._getCubicSpline(e,n,t.input.array,3*r));break}}return e},_getQuaternion(e,t,s){switch(t.interpolation){case"LINEAR":{const r=this._getPreNext(W,t,s,1);r&&function(e,t,s,r){var n,i,a,o,f,u=t[0],h=t[1],c=t[2],l=t[3],d=s[0],m=s[1],g=s[2],p=s[3];(i=u*d+h*m+c*g+l*p)<0&&(i=-i,d=-d,m=-m,g=-g,p=-p),1-i>1e-6?(n=Math.acos(i),a=Math.sin(n),o=Math.sin((1-r)*n)/a,f=Math.sin(r*n)/a):(o=1-r,f=r),e[0]=o*u+f*d,e[1]=o*h+f*m,e[2]=o*c+f*g,e[3]=o*l+f*p;}(e,r.PREVIOUS,r.NEXT,r.INTERPOLATION);break}case"STEP":{const r=this._getPreNext(W,t,s,1);r&&(e=h(e,...r.PREVIOUS));break}case"CUBICSPLINE":{const r=this._getPreNext(W,t,s,3);if(r){for(let e=0;e<r.PREVIOUS.length;e++)r.PREVIOUS[e]=Math.acos(r.PREVIOUS[e]),r.NEXT[e]=Math.acos(r.NEXT[e]);e=this._getCubicSpline(e,r,t.input.array,3);for(let t=0;t<e.length;t++)e[t]=Math.cos(e[t]);}break}}return e},_search(e,t){const s=e.length;let r,n,i,a=0,o=s-1,f=Math.floor((a+o)/2);for(;a<=s-1&&o>=0;){if(a===o)return null;if(e[f]<=t&&t<=e[f+1]){const s=e[f];return r=f,n=f+1,i=(t-s)/(e[f+1]-s),{preIndx:r,nextIndex:n,interpolation:i}}t<e[f]?(o=f,f=Math.floor((a+o)/2)):e[f+1]<t&&(a=f,f=Math.floor((a+o)/2));}return null},_getPreNext(e,t,s,r){const n=t.input.array,i=t.output.array,a=t.output.itemSize;(s<n[0]||s>n[n.length-1])&&(s=Math.max(n[0],Math.min(n[n.length-1],s))),s===n[n.length-1]&&(s=n[0]);const o=this._search(n,s);if(!o||!o.nextIndex)return null;const{preIndx:f,nextIndex:u,interpolation:h}=o;e.PREINDEX=f,e.NEXTINDEX=u,e.INTERPOLATION=h;const c=a*r;return e.PREVIOUS=i.subarray(e.PREINDEX*c,(e.PREINDEX+1)*c),e.NEXT=i.subarray(e.NEXTINDEX*c,(e.NEXTINDEX+1)*c),e},_getCubicSpline(e,t,s,r){const n=t.INTERPOLATION,i=s[t.PREINDEX],a=s[t.NEXTINDEX];for(let s=0;s<3;s++){const o=t.PREVIOUS[r+s],f=(a-i)*t.PREVIOUS[2*r+s],u=t.NEXT[3+s],h=(a-i)*t.NEXT[s],c=(2*Math.pow(n,3)-3*Math.pow(n,2)+1)*o+(Math.pow(n,3)-2*Math.pow(n,2)+n)*f+(2*-Math.pow(n,3)+3*Math.pow(n,2))*u+(Math.pow(n,3)-Math.pow(n,2))*h;e[s]=c;}return e},getAnimationClip(e,t,s,r){const n=e.nodes[t]&&e.nodes[t].weights;return o(j,...G.TRANSLATION),h(H,...G.ROTATION),o(z,...G.SCALE),this._getTRSW(r,e,t,s,j,H,z,n)},getTimeSpan(e){if(!e.animations)return null;if(e.timeSpan)return e.timeSpan;const t=e.animations;return e.timeSpan={},t.forEach(((t,s)=>{let r=-1/0,n=1/0;const i=t.channels;for(let e=0;e<i.length;e++){const s=i[e],a=t.samplers[s.sampler].input.array;a[a.length-1]>r&&(r=a[a.length-1]),a[0]<n&&(n=a[0]);}const a=t.name||s;e.timeSpan[a]={max:r,min:n};})),e.timeSpan},getTimeSpanByName(e,t){const s=this.getTimeSpan(e);return s?b(t)?s[t]:s[Object.keys(s)[0]]:null}},J="EXT_mesh_gpu_instancing",$="EXT_structural_metadata";let Q=!1;if("undefined"!=typeof OffscreenCanvas){let e;try{e=new OffscreenCanvas(2,2).getContext("2d");}catch(s){}e&&"undefined"!=typeof createImageBitmap&&(Q=!0);}const Z="undefined"==typeof document?null:document.createElement("canvas");function ee(e,t,s){const r=new Image;r.crossOrigin="",r.onload=()=>{if(!Z)return void s(new Error("There is no canvas to draw image!"));Z.width=r.width,Z.height=r.height;const e=Z.getContext("2d",{willReadFrequently:!0});e.drawImage(r,0,0,r.width,r.height);const t=e.getImageData(0,0,r.width,r.height),n={width:r.width,height:r.height,data:new Uint8Array(t.data)};s(null,n);},r.onerror=function(e){s(e);},r.src=e;}function te(e,t,s){return N.getJSON(e,t,s)}const se=[],re=[],ne=30;let ie,ae;function oe(e,t,s){ie||(ie=new OffscreenCanvas(2,2),ae=ie.getContext("2d",{willReadFrequently:!0}));let r=null;if(_(e))this.options.urlModifier&&(e=this.options.urlModifier(e)),se.push([e,t,s,this]),fe();else {const t=new Blob([e]);r=createImageBitmap(t),r.then(ue.bind(this)).then((e=>{s(null,e);})).catch((e=>{console.warn(e),s(e);}));}}function fe(){if(!se.length||re.length>ne)return;const e=se.shift(),[t,s,r,n]=e;re.push(e),fetch(t,s).then((e=>e.arrayBuffer())).then((e=>{const t=new Blob([new Uint8Array(e)]);return createImageBitmap(t)})).then(ue.bind(n)).then((t=>{r.call(n,null,t);const s=re.indexOf(e);re.splice(s,1),fe();})).catch((t=>{console.warn(t),r.call(n,t);const s=re.indexOf(e);re.splice(s,1),fe();}));}function ue(e){let{width:t,height:s}=e;he(t)||(t=ce(t)),he(s)||(s=ce(s));const r=this.options.maxTextureSize;r&&(t=Math.min(r,t),s=Math.min(r,s)),ie.width=t,ie.height=s,ae.drawImage(e,0,0,t,s),e.close();const n=ae.getImageData(0,0,t,s);return {width:t,height:s,data:new Uint8Array(n.data)}}function he(e){return !(e&e-1)&&0!==e}function ce(e){return Math.pow(2,Math.floor(Math.log(e)/Math.LN2))}function le(e,t){for(const s in e)if(e[s]===t)return s;return t}e.Ajax=N,e.GLTFLoader=class{constructor(e,t,s){if(this.options=s||{},this.options.decoders||(this.options.decoders={}),this._fetchOptions=this.options.fetchOptions||{},t.buffer instanceof ArrayBuffer){const{json:s,glbBuffer:r}=k.read(t.buffer,t.byteOffset,t.byteLength);this._init(e,s,r);}else this._init(e,t);this._accessor=new L(this.rootPath,this.gltf,this.glbBuffer,this._fetchOptions,this.options.urlModifier),this._checkExtensions();}_checkExtensions(){const e=this.gltf.extensionsRequired;if(e){if(e.indexOf("KHR_draco_mesh_compression")>=0&&!this.options.decoders.draco)throw new Error("KHR_draco_mesh_compression is required but @maptalks/transcoders.draco is not loaded");if(e.indexOf("KHR_texture_basisu")>=0&&!this.options.decoders["image/ktx2"])throw new Error("KHR_texture_basisu is required but @maptalks/transcoders.ktx2 is not loaded");if(e.indexOf("EXT_meshopt_compression")>=0)throw new Error("EXT_meshopt_compression extension is not supported yet.")}}_loadExtensions(){const e=this.gltf.extensions;return e&&e.KHR_techniques_webgl?this._accessor.requestKHRTechniquesWebgl(e.KHR_techniques_webgl).then((t=>(e.KHR_techniques_webgl=t,e))):Promise.resolve(e)}_convertKhrTechiqueToTechiques(){if(!Array.isArray(this.gltf.programs))return;const e=this.gltf.materials;for(let t=0;t<e.length;t++)e[t]&&e[t].extensions&&e[t].extensions.KHR_technique_webgl&&(e[t].extensions.KHR_techniques_webgl=e[t].extensions.KHR_technique_webgl,delete e[t].extensions.KHR_technique_webgl);const t=this.gltf.extensions||{},s=this.gltf.techniques;t.KHR_techniques_webgl={programs:this.gltf.programs,shaders:this.gltf.shaders,techniques:s};for(let t=0;t<e.length;t++){const n=(r=e[t])&&r.extensions&&r.extensions.KHR_techniques_webgl;if(n){const{values:e,technique:t}=n,r=s[t];if(!r||!e)continue;const{uniforms:i,parameters:a}=r,o={};for(const t in e){const s=le(i,t);o[s]=e[t],a[t]&&35678===a[t].type&&(o[s]={index:e[t]});}n.values=o;}}var r;for(let e=0;e<s.length;e++){const t=s[e];if(!t)continue;const{attributes:r,uniforms:n,parameters:i}=t;if(r)for(const e in r){const t=r[e];r[e]=i[t];}if(n)for(const e in n){const t=n[e];n[e]=i[t];}delete t.parameters;}return delete this.gltf.programs,delete this.gltf.shaders,delete this.gltf.techniques,this.gltf.extensions=t,t}load(e){e=e||{},this._convertKhrTechiqueToTechiques();const t=this._loadScene(e),s=this._loadAnimations(),r=this._loadTextures(),n=this._loadExtensions(),i=this._loadStructuralMetadata();return Promise.all([t,s,r,n,i]).then((e=>(e[0].animations=e[1],e[0].textures=e[2],e[0].extensions=e[3],e[0].transferables=this.transferables||[],e[0].structuralMetadata=e[4],this.createChannelsMap(e[0]),e[0])))}createChannelsMap(e){const t=e.animations;if(t)for(let e=0;e<t.length;e++){const s=t[e];s.channelsMap={};for(let e=0;e<s.channels.length;e++){const t=s.channels[e];s.channelsMap[t.target.node]||(s.channelsMap[t.target.node]=[]),s.channelsMap[t.target.node].push(t);}}}getExternalResources(){const e=[];if(this.gltf){const{buffers:t,images:s}=this.gltf;for(let s=0;s<t.length;s++)t[s].uri&&t[s].uri.indexOf("data:application/octet-stream;base64")<0&&e.push({type:"buffer",uri:t[s].uri});for(let t=0;t<s.length;t++)s[t].uri&&s[t].uri.indexOf("data:image/")<0&&e.push({type:"image",uri:s[t].uri});}return e}static getAnimationClip(e,t,s,r){return Y.getAnimationClip(e,t,s,r)}static getAnimationTimeSpan(e,t){return Y.getTimeSpanByName(e,t)}static getTypedArrayCtor(e){return x(e)}static readInterleavedArray(e,t,s,r,n,i,a){return q(e,t,s,r,n,i,a)}_init(e,t,s){this.gltf=t,this.glbBuffer=s,this.version=t.asset?+t.asset.version:1,this.rootPath=e,this.buffers={},this.requests={},this.options.requestImage=Q?oe.bind(this):this.options.requestImage||ee,this.options.fetchSchema=this.options.fetchSchema||te,this.options.transferable&&(this.transferables=[]),2===this.version?(this.adapter=new C(e,t,s,this.options.requestImage,this.options.decoders||{},this.options.supportedFormats||{},this._fetchOptions,this.options.urlModifier),this.adapter.iterate(((e,t,s)=>{t.id="buffer_"+s;}),"buffers"),this.adapter.iterate(((e,t,s)=>{t.id="image_"+s;}),"images"),this.adapter.iterate(((e,t,s)=>{t.id="accessor_"+s;}),"accessors")):(this.adapter=new D(e,t,s,this.options.requestImage,this.options.decoders||{},this.options.supportedFormats||{},this._fetchOptions,this.options.urlModifier),this.adapter.iterate(((e,t,s)=>{t.id="accessor_"+s;}),"accessors"),this.adapter.iterate(((e,t,s)=>{t.id="image_"+s;}),"images"));}_parseNodes(e,t){if(e.children&&e.children.length>0){if(!("number"==typeof(s=e.children[0])&&isFinite(s)||_(e.children[0])))return e;const r=e.children.map((e=>{const s=t[e];return s.nodeIndex=e,this._parseNodes(s,t)}));e.children=r;}var s;return e}_loadScene(e){return this._loadNodes(e).then((e=>{const t=this.scenes=[];let s;for(const t in e)e[t]=this._parseNodes(e[t],e),e[t].nodeIndex=Number(t)?Number(t):t;this.adapter.iterate(((r,n,i)=>{const a={};n.name&&(a.name=n.name),n.nodes&&(a.nodes=n.nodes.map((t=>e[t]))),this.gltf.scene===r&&(s=i),t.push(a);}),"scenes");const r={textures:this.gltf.textures,asset:this.gltf.asset,scene:s,scenes:t,nodes:e,meshes:this.meshes,materials:this.gltf.materials,skins:this.skins,extensionsRequired:this.gltf.extensionsRequired,extensionsUsed:this.gltf.extensionsUsed};if(this.gltf.extensions&&(r.extensions=this.gltf.extensions),1===this.version){const e=this.adapter._loadMaterials(this.gltf.materials);r.materials=e;}return delete this.gltf.buffers,r.json=this.gltf,r}))}_loadNodes(e){return this._loadMeshes(e).then((()=>{const e=this.nodes={},t=[];return this.adapter.iterate(((s,r)=>{const n=this.adapter.createNode(r,this.meshes,this.skins);e[s]=n;const i=function(e){return e?.extensions?.[J]}(r);if(i){const e=this._loadGpuInstancingData(i).then((e=>{n.extensions||(n.extensions={}),n.extensions[J]=e;}));t.push(e);}}),"nodes"),Promise.all(t).then((()=>e))}))}_loadGpuInstancingData(e){const t=function(e){return e?.attributes?Object.entries(e.attributes).map((([e,t])=>({name:e,accessorIndex:t}))):[]}(e);if(0===t.length)return Promise.resolve({attributes:{}});const s=t.map((({name:e,accessorIndex:t})=>this.adapter.accessor._requestData(e,t).then((t=>(t&&t.array&&t.array.buffer&&this.transferables&&this.transferables.indexOf(t.array.buffer)<0&&this.transferables.push(t.array.buffer),{name:e,data:t})))));return Promise.all(s).then((e=>{const t={};return e.forEach((({name:e,data:s})=>{t[e]=s;})),{attributes:t}}))}_loadSkins(){this.skins=[];const e=[];return this.adapter.iterate(((t,s,r)=>{e.push(this._loadSkin(s).then((e=>{e.index=r,this.skins.push(e);})));}),"skins"),e}_loadSkin(e){const t=e.inverseBindMatrices;return this.adapter.accessor._requestData("inverseBindMatrices",t).then((t=>(e.inverseBindMatrices=t,t&&t.buffer&&this.transferables&&this.transferables.indexOf(t.buffer)<0&&this.transferables.push(t.buffer),e)))}_loadAnimations(){const e=this.gltf.animations;return b(e)?this.adapter.getAnimations(e):null}_loadMeshes(e){this.meshes={};let t=[];return this.adapter.iterate(((s,r,n)=>{t.push(this._loadMesh(r,e).then((e=>{e.index=n,this.meshes[s]=e;})));}),"meshes"),t=t.concat(this._loadSkins()),Promise.all(t)}_loadMesh(e,t){const s=e.primitives.map((e=>this._loadPrimitive(e,t))).filter((e=>!!e));return Promise.all(s).then((t=>{const s={};return y(s,e),s.primitives=t,s}))}_loadTextures(){const e=this.gltf.textures;if(!e)return null;const t=[];for(const s in e)t.push(this.adapter._getTexture(s));return Promise.all(t).then((t=>{if(this.transferables)for(let e=0;e<t.length;e++){const s=t[e]&&t[e].image.array;if(s){let e;e=s instanceof ImageBitmap?s:s.buffer,e&&this.transferables.indexOf(e)<0&&this.transferables.push(e);}}if(!Array.isArray(e)){const s={},r=Object.keys(e);for(let e=0;e<t.length;e++)t[e]&&(s[r[e]]=t[e]);return s}return t}))}_loadPrimitive(e,t){let s;const r=[],n=e.extensions;if(b(e.targets))for(let t=0;t<e.targets.length;t++){const s=e.targets[t];for(const e in s){const n=this.adapter.accessor._requestData(`morphTargets_${e}_${t}`,s[e]);n&&r.push(n);}}if(n&&n.KHR_draco_mesh_compression){if(!this.options.decoders.draco&&(!this.gltf.extensionsRequired||!this.gltf.extensionsRequired.indexOf("KHR_draco_mesh_compression")<0))return null;const e=this.options.decoders.draco,{bufferView:i,attributes:a}=n.KHR_draco_mesh_compression,o=this.gltf.bufferViews[i],f=this._accessor._requestBufferOfBufferView(o).then((s=>{const{buffer:r,byteOffset:n}=s;let{byteOffset:i}=o;const f=o.byteLength;i||(i=0);const u=new DataView(r,n+i,f),h={attributes:a,useUniqueIDs:!1,skipAttributeTransform:t.skipAttributeTransform};return e(u,h).then((e=>{const t=Object.values(e.attributes);return e.indices&&t.push(e.indices),t}))}));r.push(f),s=Promise.all(r);}else {const t=e.attributes;for(const e in t){const s=this.adapter.accessor._requestData(e,t[e]);s&&r.push(s);}if(b(e.indices)){const t=this.adapter.accessor._requestData("indices",e.indices);t&&r.push(t);}s=Promise.all(r);}return s.then((t=>{if(n&&n.KHR_draco_mesh_compression){const s=e.targets?e.targets.length:0;t[s]=t[s].concat(t.slice(0,s)),t=t[s];}let s,r;const i={attributes:t.reduce(((e,t)=>{if("indices"===t.name)s=t;else if(t.name.indexOf("morphTargets_")>-1)r=r||{},r[t.name.slice(13)]=t;else {if(!("POSITION"!==t.name||t.min&&t.max)){const e=[1/0,1/0,1/0],s=[-1/0,-1/0,-1/0],{itemSize:r,array:n}=t,i=n.length/r;for(let t=0;t<i;t++)for(let i=0;i<r;i++){const a=t*r+i;n[a]<e[i]&&(e[i]=n[a]),n[a]>s[i]&&(s[i]=n[a]);}if(t.quantization){const r=t.quantization,n=r.range/(1<<r.quantizationBits),i=r.minValues;u(e,e,n),f(e,e,i),u(s,s,n),f(s,s,i);}t.min=e,t.max=s;}e[t.name]=t;}return this.transferables&&t.array.buffer&&this.transferables.indexOf(t.array.buffer)<0&&this.transferables.push(t.array.buffer),e}),{}),material:e.material};return s&&(i.indices=s),r&&(i.morphTargets=r),i.mode=b(e.mode)?e.mode:4,b(e.extras)&&(i.extras=e.extras),e.extensions&&(i.extensions=e.extensions),i}))}_loadStructuralMetadata(){const e=this.gltf.extensionsUsed||[],t=e.includes("EXT_mesh_features"),s=e.includes($);if(!t&&!s)return Promise.resolve();const r=[];if(s){const e=this.gltf.extensions?.[$];e?.propertyTables&&r.push(this._loadPropertyTableBuffers(e.propertyTables));}return Promise.all(r).then((e=>{const t=e[0]||[];if(s)return async function(e,t,s,r,n,i){const a=e?.extensions?.[$];if(!a)return null;if(a.schemaUri){let e=a.schemaUri;return e.includes("://")||e.startsWith("blob:")||(e=s+e),{schema:await i(e,r,n),propertyTables:a.propertyTables||[],buffers:t}}return {schema:a.schema,propertyTables:a.propertyTables||[],buffers:t}}(this.gltf,t,this.rootPath,this._fetchOptions,this.options.urlModifier,this.options.fetchSchema).then((e=>(e&&t.forEach((e=>{e&&this.transferables.indexOf(e)<0&&this.transferables.push(e);})),e)))}))}_loadPropertyTableBuffers(e){const t=this.gltf.bufferViews||[],s=function(e){const t=new Set;if(!e)return t;for(const s of e){const e=s.properties;if(e)for(const s of Object.values(e))void 0!==s.values&&t.add(s.values),void 0!==s.arrayOffsets&&t.add(s.arrayOffsets),void 0!==s.stringOffsets&&t.add(s.stringOffsets);}return t}(e),r=new Array(t.length).fill(null),n=[];return s.forEach((e=>{const s=t[e];if(!s)return;const i=this._accessor._requestBufferOfBufferView(s).then((t=>{const{buffer:n,byteOffset:i}=t,a=(s.byteOffset||0)+i;r[e]=n.slice(a,a+s.byteLength);}));n.push(i);})),Promise.all(n).then((()=>r))}},t().maptalks_gltf_loader=e;}gltfLoaderExport({});

const getGlobal$1 = function () {
    if (typeof globalThis !== 'undefined') {
        return globalThis;
    }
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    throw new Error('unable to locate global object');
};
function getGLTFLoaderBundle() {
    return getGlobal$1()['maptalks_gltf_loader'];
}

/**
 * 对象是否是字符串
 * @english
 * Check whether the object is a string
 * @param obj
 */
function isString(obj) {
    if (isNil$2(obj)) {
        return false;
    }
    return typeof obj === 'string' || (obj.constructor !== null && obj.constructor === String);
}
/**
 * 对象是否是null或undefined
 * @english
 * Whether the object is null or undefined.
 * @param  obj - object
 */
function isNil$2(obj) {
    return obj == null;
}
function defined(obj) {
    return !isNil$2(obj);
}
/**
 * 对象是否是函数
 * @english
 * Check whether the object is a function
 * @param obj
 */
function isFunction$1(obj) {
    if (isNil$2(obj)) {
        return false;
    }
    return typeof obj === 'function' || (obj.constructor !== null && obj.constructor === Function);
}
/**
 * 将后续所有对象属性合并到第一个dest对象中
 * @english
 * Merges the properties of sources into destination object.
 * @param dest - object to extend
 * @param src - sources
 */
function extend$1(dest, ...src) {
    Object.assign(dest, ...src);
    return dest;
}
/**
 * 将后续所有对象属性合并到第一个dest对象中，但忽略undefined或null的属性
 * @english
 * Merges the properties of sources into destination object without nil properties.
 * @param dest - object to extend
 * @param src - sources
 */
function extendWithoutNil(dest, ...args) {
    for (let i = 0; i < args.length; i++) {
        const src = args[i];
        for (const k in src) {
            if (src[k] !== undefined && src[k] !== null) {
                dest[k] = src[k];
            }
        }
    }
    return dest;
}
// export function extend2(dest) {
//     for (let i = 1; i < arguments.length; i++) {
//         const src = arguments[i];
//         for (const k in src) {
//             if (dest[k] === undefined) {
//                 dest[k] = src[k];
//             }
//         }
//     }
//     return dest;
// }
/**
 * 检查是否是个数值
 * @english
 * Whether val is a number and not a NaN.
 * @param  val - val
 */
function isNumber$2(val) {
    return (typeof val === 'number') && !isNaN(val);
}
/**
 * 计算值的log2
 * @english
 * compute value's log2
 * @param x - value to log
 * @returns
 */
function log2(x) {
    return Math.log2(x);
}
/**
 * 归一化数组
 * @english
 * normalize a number array
 * @param out - array receives result
 * @param arr - array
 * @returns out
 */
function normalize(out, arr) {
    let sum = 0;
    for (let i = 0, l = arr.length; i < l; i++) {
        sum += arr[i];
    }
    for (let i = 0, l = arr.length; i < l; i++) {
        out[i] = arr[i] / sum;
    }
    return out;
}
/**
 * 两个数值之间的比例推算
 *
 * @english
 * Interpolate between two number.
 *
 * @param from  - from value
 * @param to    - to value
 * @param t     - interpolation factor between 0 and 1
 * @returns     interpolated value
 */
function interpolate$1(a, b, t) {
    return (a * (1 - t)) + (b * t);
}
/**
 * 检查对象是否是数组或者类型数组
 * @english
 * Check if is an Array or a TypedArray
 * @param arr - input object
 * @returns
 */
function isArray(arr) {
    return Array.isArray(arr) ||
        (arr instanceof Uint8Array) ||
        (arr instanceof Int8Array) ||
        (arr instanceof Uint16Array) ||
        (arr instanceof Int16Array) ||
        (arr instanceof Uint32Array) ||
        (arr instanceof Int32Array) ||
        (arr instanceof Uint8ClampedArray) ||
        (arr instanceof Float32Array) ||
        (arr instanceof Float64Array);
}
function getArrayCtor(arr) {
    return Array.isArray(arr) && Array ||
        (arr instanceof Uint8Array) && Uint8Array ||
        (arr instanceof Int8Array) && Int8Array ||
        (arr instanceof Uint16Array) && Uint16Array ||
        (arr instanceof Int16Array) && Int16Array ||
        (arr instanceof Uint32Array) && Uint32Array ||
        (arr instanceof Int32Array) && Int32Array ||
        (arr instanceof Uint8ClampedArray) && Uint8ClampedArray ||
        (arr instanceof Float32Array) && Float32Array ||
        (arr instanceof Float64Array) && Float64Array;
}
/**
 * 对两个矢量执行线性推算
 *
 * @english
 * Performs a linear interpolation between two number's
 *
 * @param out   - the receiving vector
 * @param a     - the first operand
 * @param b     - the second operand
 * @param t     - interpolation amount, in the range [0-1], between the two inputs
 * @returns out
 */
function lerp$1(out, a, b, t) {
    for (let i = 0; i < out.length; i++) {
        out[i] = a[i] + t * (b[i] - a[i]);
    }
    return out;
}
/**
 * 将input数组的值设置给out
 * @english
 * Set input array's value to out
 * @param out - the receiving array
 * @param input - input array
 * @returns out
 */
function set(out, input) {
    for (let i = 0; i < out.length; i++) {
        out[i] = input[i];
    }
    return out;
}
/**
 * 根据Position的最大值，选择一个合适的TypedArray
 * @english
 * Choose a TypedArray for position according to its max value
 * @param max - position's max value
 * @returns
 */
function getPosArrayType(max) {
    max = Math.abs(max);
    if (max < 128)
        return Int8Array;
    if (max < 65536 / 2)
        return Int16Array;
    return Float32Array;
}
/**
 * n大于max时返回max，n小于min时返回min，否则返回n
 * @english
 * Clamp input value between min and max
 * @param n - input value
 * @param min - min value
 * @param max - max value
 */
function clamp$1(n, min, max) {
    return Math.min(max, Math.max(min, n));
}
/**
 * 检查当前环境是否支持VAO
 * @english
 * Check if current context supports VAO
 * @param regl regl context
 * @returns
 */
function _isSupportVAO(regl) {
    if (globalThis['MAPTALKS_DISABLE_VAO']) {
        return false;
    }
    if (regl.wgpu) {
        return false;
    }
    // return false;
    return regl && regl.hasExtension && regl.hasExtension('oes_vertex_array_object');
}
function isSupportVAO(regl) {
    if (regl.supportVAO === undefined) {
        regl.supportVAO = _isSupportVAO(regl);
    }
    return regl.supportVAO;
}
/**
 * Object.hasOwnProperty的包装方法
 * @english
 * Check if object hasOwnProperty of property
 * @param obj - object
 * @param prop - property
 * @returns
 */
function hasOwn$1(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
/**
 * 获取buffer的byte大小
 * @english
 * Get buffer's size in bytes
 * @param buffer
 */
function getBufferSize(buffer) {
    if (buffer.data) {
        buffer = buffer;
        if (buffer.data.BYTES_PER_ELEMENT) {
            return buffer.data.length * buffer.data.BYTES_PER_ELEMENT;
        }
        else if (buffer.data.length) {
            return buffer.data.length * 4;
        }
    }
    else if (buffer.BYTES_PER_ELEMENT) {
        return buffer.length * buffer.BYTES_PER_ELEMENT;
    }
    else if (buffer.length) {
        // FLOAT32 in default
        return buffer.length * 4;
    }
    else if (buffer.buffer && buffer.buffer.destroy) {
        const reglBuffer = buffer.buffer['_buffer'];
        if (reglBuffer) {
            // regl
            return reglBuffer.byteLength;
        }
        else {
            // webgpu
            return buffer.buffer.size;
        }
    }
    return 0;
}
/**
 * 获取regl texture对象的bytes大小
 * @english
 * Get regl texture size in bytes
 * @param tex - regl rexture
 * @returns
 */
function getTexMemorySize(tex) {
    return tex.width * tex.height * getTextureChannels(tex.format) * getTextureByteWidth(tex.type) * (tex['_reglType'] === 'textureCube' ? 6 : 1);
}
/**
 * 获取regl texture的byte width
 * @english
 * Get regl texture's byte width
 * @param type - regl texture's type
 * @returns
 */
function getTextureByteWidth(type) {
    if (type === 'uint8') {
        return 1;
    }
    else if (type === 'uint16' || type === 'float16' || type === 'half float') {
        return 2;
    }
    else if (type === 'uint32' || type === 'float' || type === 'float32') {
        return 4;
    }
    return 0;
}
/**
 * 获取regl texture 的channels数量
 * @english
 * Get regl texture's number of channels
 * @param format - regl texture's format
 * @returns
 */
function getTextureChannels(format) {
    if (format === 'depth' || format === 'alpha' || format === 'luminance') {
        return 1;
    }
    else if (format === 'luminance alpha' || format === 'depth stencil') {
        return 2;
    }
    else if (format === 'srgba' || format === 'rgb5 a1' || format.substring(0, 4) === 'rgba') {
        return 4;
    }
    else if (format === 'srgb' || format.substring(0, 3) === 'rgb') {
        return 3;
    }
    return 1;
}
/**
 * 检查该attribute数据是否处于interleaved数据中
 * @english
 * Check if this attribute data is in interleaved stride
 * @param dataObj attribute object
 * @returns
 */
function isInStride(dataObj) {
    // if (!array || !array.buffer) {
    //     return false;
    // }
    // const bytesLen = array.length * array.BYTES_PER_ELEMENT;
    // const bufLen = array.buffer.byteLength;
    // return bytesLen < bufLen;
    if (!dataObj.componentType) {
        return false;
    }
    const gltf = getGLTFLoaderBundle();
    const ctor = gltf.GLTFLoader.getTypedArrayCtor(dataObj.componentType);
    return dataObj.byteStride > 0 && dataObj.byteStride !== dataObj.itemSize * ctor.BYTES_PER_ELEMENT;
}
/**
 * 检查该attribute数据是否是interleaved
 * @english
 * Check if this attribute data is an interleaved data
 * @param dataObj attribute object
 * @returns
 */
function isInterleaved(dataObj) {
    return dataObj && (dataObj.stride > 0 || isInStride(dataObj));
    // const { stride, componentType, count, size } = dataObj;
    // const bytesPerElement = gltf.GLTFLoader.getTypedArrayCtor(componentType).BYTES_PER_ELEMENT;
    // return stride > bytesPerElement * count * size;
}
/**
 * 获取该webgl上下文支持的压缩纹理格式
 * @english
 * Get webgl context's supported formats for compressed texture
 * @param gl
 * @returns
 */
function getSupportedFormats(gl) {
    const webgl = gl.getExtension && gl;
    const webgpu = !webgl && gl;
    const prefixWebGL = 'WEBGL_compressed_texture_';
    const prefixWebGPU = 'texture-compression-';
    const formats = {
        'etc': webgl ? !!webgl.getExtension(prefixWebGL + 'etc') : !!webgpu.features.has(prefixWebGPU + 'etc2'),
        'etc1': webgl ? !!webgl.getExtension(prefixWebGL + 'etc1') : !!webgpu.features.has(prefixWebGPU + 'etc2'),
        's3tc': webgl ? !!webgl.getExtension(prefixWebGL + 's3tc') : !!webgpu.features.has(prefixWebGPU + 'bc'),
        'pvrtc': webgl ? !!webgl.getExtension(prefixWebGL + 'pvrtc') : false,
        'astc': webgl ? !!webgl.getExtension(prefixWebGL + 'astc') : !!webgpu.features.has(prefixWebGPU + 'astc'),
        'bc7': webgl ? !!webgl.getExtension('EXT_texture_compression_bptc') : !!webgpu.features.has(prefixWebGPU + 'bc'),
    };
    formats[prefixWebGL + 'etc'] = formats['etc'];
    formats[prefixWebGL + 'etc1'] = formats['etc1'];
    formats[prefixWebGL + 's3tc'] = formats['s3tc'];
    formats[prefixWebGL + 'pvrtc'] = formats['pvrtc'];
    formats[prefixWebGL + 'astc'] = formats['astc'];
    formats[prefixWebGL + 'bc7'] = formats['bc7'];
    return formats;
}
/**
 * 获取字符串的hash值
 * @english
 * Get string's hash code
 * @param s input string
 * @returns
 */
function hashCode(s) {
    let hash = 0;
    const strlen = s && s.length || 0;
    if (!strlen) {
        return hash;
    }
    let c;
    for (let i = 0; i < strlen; i++) {
        c = s.charCodeAt(i);
        hash = ((hash << 5) - hash) + c;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}
/**
 * 值是否是2的n次幂
 * @english
 * Get the nearest power of 2 that is less than this value
 * @param value - input value
 * @returns
 */
function isPowerOfTwo$1(value) {
    return (value & (value - 1)) === 0 && value !== 0;
}
/**
 * 获取小于该值的最接近的2次幂
 * @english
 * Get power of 2 that smaller than
 * @param value - input value
 * @returns
 */
function floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
// function ceilPowerOfTwo(value) {
//     return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
// }
function resizeFromArray(arr, width, height) {
    let newWidth = width;
    let newHeight = height;
    if (!isPowerOfTwo$1(width)) {
        newWidth = floorPowerOfTwo(width);
    }
    if (!isPowerOfTwo$1(height)) {
        newHeight = floorPowerOfTwo(height);
    }
    const imageData = new ImageData(new Uint8ClampedArray(arr), width, height);
    const srcCanvas = document.createElement('canvas');
    srcCanvas.width = width;
    srcCanvas.height = height;
    srcCanvas.getContext('2d').putImageData(imageData, 0, 0);
    const canvas = document.createElement('canvas');
    canvas.width = newWidth;
    canvas.height = newHeight;
    canvas.getContext('2d').drawImage(srcCanvas, 0, 0, width, height, 0, 0, newHeight, newHeight);
    console.warn(`Texture's size is not power of two, resize from (${width}, ${height}) to (${newWidth}, ${newHeight})`);
    let debugCanvas = document.getElementById('_debug_resize_canvas');
    if (!debugCanvas) {
        debugCanvas = document.createElement('canvas');
        debugCanvas.id = '_debug_resize_canvas';
        document.body.appendChild(debugCanvas);
    }
    debugCanvas.width = newWidth;
    debugCanvas.height = newHeight;
    debugCanvas.getContext('2d').drawImage(canvas, 0, 0);
    return canvas;
}
function resizeToPowerOfTwo(image, width, height) {
    if (isArray(image)) {
        image = image;
        if (!isPowerOfTwo$1(width) || !isPowerOfTwo$1(height)) {
            return resizeFromArray(image, width, height);
        }
        else {
            return image;
        }
    }
    image = image;
    if (isPowerOfTwo$1(image.width) && isPowerOfTwo$1(image.height)) {
        return image;
    }
    width = image.width;
    height = image.height;
    if (!isPowerOfTwo$1(width)) {
        width = floorPowerOfTwo(width);
    }
    if (!isPowerOfTwo$1(height)) {
        height = floorPowerOfTwo(height);
    }
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').drawImage(image, 0, 0, width, height);
    const url = image.src;
    const idx = url.lastIndexOf('/') + 1;
    const filename = url.substring(idx);
    console.warn(`Texture(${filename})'s size is not power of two, resize from (${image.width}, ${image.height}) to (${width}, ${height})`);
    return canvas;
}
function supportNPOT(regl) {
    if (regl.wgpu) {
        return true;
    }
    return !regl['_gl'] || (regl['_gl'] instanceof WebGL2RenderingContext);
}
function isTextureDestroyed(texture) {
    if (texture.device) {
        return !texture.texture;
    }
    if (texture['_texture']) {
        return !texture['_texture'].texture;
    }
    return true;
}
function isTextureLike(texture) {
    // not a GPUBuffer or a REGLBuffer
    return texture && !texture.mapAsync && (texture.dispose || texture.destroy);
}

var Util = /*#__PURE__*/Object.freeze({
    __proto__: null,
    clamp: clamp$1,
    defined: defined,
    extend: extend$1,
    extendWithoutNil: extendWithoutNil,
    getArrayCtor: getArrayCtor,
    getBufferSize: getBufferSize,
    getPosArrayType: getPosArrayType,
    getSupportedFormats: getSupportedFormats,
    getTexMemorySize: getTexMemorySize,
    getTextureByteWidth: getTextureByteWidth,
    getTextureChannels: getTextureChannels,
    hasOwn: hasOwn$1,
    hashCode: hashCode,
    interpolate: interpolate$1,
    isArray: isArray,
    isFunction: isFunction$1,
    isInStride: isInStride,
    isInterleaved: isInterleaved,
    isNil: isNil$2,
    isNumber: isNumber$2,
    isPowerOfTwo: isPowerOfTwo$1,
    isString: isString,
    isSupportVAO: isSupportVAO,
    isTextureDestroyed: isTextureDestroyed,
    isTextureLike: isTextureLike,
    lerp: lerp$1,
    log2: log2,
    normalize: normalize,
    resizeToPowerOfTwo: resizeToPowerOfTwo,
    set: set,
    supportNPOT: supportNPOT
});

function Eventable (Base) {
    return class EventableMixin extends Base {
        on(type, handler) {
            if (!this._events) {
                this._events = {
                    type: [handler]
                };
            }
            this._events[type] = this._events[type] || [];
            this._events[type].push(handler);
            return this;
        }
        once(type, handler) {
            return this.on(type, this._wrapOnce(type, handler));
        }
        off(type, handler) {
            if (!this._events || !this._events[type]) {
                return this;
            }
            this._events[type].splice(this._events[type].indexOf(handler), 1);
            return this;
        }
        fire(type, params = {}) {
            if (!this._events || !this._events[type]) {
                return this;
            }
            if (!params.target) {
                params.target = this;
            }
            const queue = this._events[type].slice(0);
            for (const p of queue) {
                p(params);
            }
            return this;
        }
        //@internal
        _wrapOnce(type, handler) {
            const self = this;
            let called = false;
            const fn = function onceHandler(params) {
                if (called) {
                    return;
                }
                called = true;
                handler(params);
                self.off(type, onceHandler);
            };
            return fn;
        }
    };
}

const KEY_DISPOSED = '__reshader_disposed';
const WEBGL_EXTENSIONS = [
    'ANGLE_instanced_arrays',
    'OES_element_index_uint',
    'OES_standard_derivatives'
];
const WEBGL_OPTIONAL_EXTENSIONS = [
    'OES_vertex_array_object',
    'OES_texture_half_float', 'OES_texture_half_float_linear',
    'OES_texture_float', 'OES_texture_float_linear',
    'WEBGL_depth_texture', /*'WEBGL_draw_buffers', */ 'EXT_shader_texture_lod', 'EXT_texture_filter_anisotropic'
];
const ERROR_NOT_IMPLEMENTED = 'not implemented';

var Constants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ERROR_NOT_IMPLEMENTED: ERROR_NOT_IMPLEMENTED,
    KEY_DISPOSED: KEY_DISPOSED,
    WEBGL_EXTENSIONS: WEBGL_EXTENSIONS,
    WEBGL_OPTIONAL_EXTENSIONS: WEBGL_OPTIONAL_EXTENSIONS
});

const REF_COUNT_KEY$1 = '_reshader_refCount';
let Base$1 = class Base {
};
/**
 * Abstract Texture
 * Common methods for Texture2D and TextureCube
 * @abstract
 */
class AbstractTexture extends Eventable(Base$1) {
    constructor(config, resLoader) {
        super();
        //TODO add video support
        if (isFunction$1(config)) {
            //an out-of-box regl texture
            this._texture = config;
            config = this.config = {};
            for (const p in this._texture) {
                if (hasOwn$1(this._texture, p)) {
                    //parse texture config values from regl texture
                    if (!isFunction$1(this._texture[p])) {
                        config[p] = this._texture[p];
                    }
                }
            }
        }
        else {
            this.config = config || {};
            this.resLoader = resLoader;
            if ((config.url || config.promise) && !config.data) {
                this._loading = true;
                const self = this;
                let promise;
                if (config.promise) {
                    promise = config.promise;
                }
                else {
                    let loadFn;
                    if (config.arrayBuffer) {
                        loadFn = resLoader.getArrayBuffer;
                    }
                    else {
                        loadFn = resLoader.get;
                    }
                    promise = loadFn.call(resLoader, config.url);
                }
                config.data = resLoader.getDefaultTexture(config.url);
                this.promise = promise;
                promise.then(data => {
                    delete this.promise;
                    self._loading = false;
                    if (!self.config) {
                        //disposed
                        return data;
                    }
                    self.onLoad(data);
                    if (!Array.isArray(data)) {
                        data = [data];
                    }
                    self.fire('complete', { target: this, resources: data });
                    return data;
                }).catch(err => {
                    console.error('error when loading texture image.', err);
                    self.fire('error', { target: this, error: err });
                });
            }
        }
    }
    //eslint-disable-next-line
    onLoad(data) { }
    isReady() {
        return !this._loading;
    }
    set(k, v) {
        this.config[k] = v;
        this.dirty = true;
        return this;
    }
    get(k) {
        return this.config[k];
    }
    //eslint-disable-next-line
    createREGLTexture(regl) {
        return null;
    }
    getREGLTexture(regl) {
        if (!this._texture) {
            this._texture = this.createREGLTexture(regl);
            if (!this.config.persistent) {
                // delete persistent data to save memories
                if (this.config.data) {
                    // imageBitmap
                    if (!(this.config.data instanceof ImageBitmap)) {
                        this.config.data = [];
                        // this.config.data.close();
                    }
                }
                // if (this.config.faces) {
                //     this.config.faces = null;
                // }
                if (this.config.image) {
                    this.config.image.array = [];
                }
                if (this.config.mipmap) {
                    delete this.config.mipmap;
                }
            }
        }
        if (this.dirty) {
            this._update();
        }
        return this._texture;
    }
    getMemorySize() {
        if (!this.config) {
            return 0;
        }
        const { width, height, type, format } = this.config;
        const byteWidth = getTextureByteWidth(type || 'uint8');
        const channels = getTextureChannels(format || 'rgba');
        // if (this.config.faces) {
        //     // texture cube
        //     return width * height * byteWidth * channels * 6;
        // } else {
        return width * height * byteWidth * channels;
        // }
    }
    _update() {
        throw new Error(ERROR_NOT_IMPLEMENTED);
    }
    dispose() {
        if (this.config && this.config.url) {
            URL.revokeObjectURL(this.config.url);
            this.resLoader.disposeRes(this.config.url);
        }
        if (this.config && (this.config.data instanceof ImageBitmap)) {
            this.config.data.close();
            this.config.data = [];
        }
        if (this._texture && !this._texture[KEY_DISPOSED]) {
            if (this._texture[REF_COUNT_KEY$1]) {
                this._texture[REF_COUNT_KEY$1]--;
            }
            if (!this._texture[REF_COUNT_KEY$1]) {
                this._texture.destroy();
                this._texture[KEY_DISPOSED] = true;
                delete this._texture;
            }
        }
        delete this.resLoader;
        delete this._regl;
        const url = this.config && this.config.url;
        delete this.config;
        if (url) {
            this.fire('disposed', { target: this, url });
        }
    }
}

const TEMP_MATRIX = mat4.identity([]);
const IDENTITY_MATRIX = mat4.identity([]);
class BoundingBox {
    constructor(min, max) {
        this.min = min || [Infinity, Infinity, Infinity];
        this.max = max || [-Infinity, -Infinity, -Infinity];
        this.updateVertex();
    }
    static copy(out, bbox) {
        vec3.copy(out.min, bbox.min);
        vec3.copy(out.max, bbox.max);
        for (let i = 0; i < bbox.vertex.length; i++) {
            vec3.copy(out.vertex[i], bbox.vertex[i]);
        }
        return out;
    }
    combine(bbox) {
        if (!bbox) {
            return this;
        }
        let min, max;
        if (Array.isArray(bbox)) {
            min = bbox[0];
            max = bbox[1];
        }
        else {
            min = bbox.min;
            max = bbox.max;
        }
        if (min[0] < this.min[0]) {
            this.min[0] = min[0];
            this._dirty = true;
        }
        if (min[1] < this.min[1]) {
            this.min[1] = min[1];
            this._dirty = true;
        }
        if (min[2] < this.min[2]) {
            this.min[2] = min[2];
            this._dirty = true;
        }
        if (max[0] > this.max[0]) {
            this.max[0] = max[0];
            this._dirty = true;
        }
        if (max[1] > this.max[1]) {
            this.max[1] = max[1];
            this._dirty = true;
        }
        if (max[2] > this.max[2]) {
            this.max[2] = max[2];
            this._dirty = true;
        }
        return this;
    }
    dirty() {
        this._dirty = true;
        return this;
    }
    /**
     * Get center of the bounding box
     * @returns {Number[]} center
     */
    getCenter() {
        if (!this.center) {
            this.center = [0, 0, 0];
            this._dirty = true;
        }
        if (this._dirty) {
            vec3.add(this.center, this.min, this.max);
            vec3.scale(this.center, this.center, 0.5);
        }
        this._dirty = false;
        return this.center;
    }
    /**
     * 判断BBox是否包含给定的坐标
     * @english
     * If contain point entirely
     * @param  point
     */
    containPoint(p) {
        const min = this.min;
        const max = this.max;
        return min[0] <= p[0] && min[1] <= p[1] && min[2] <= p[2] &&
            max[0] >= p[0] && max[1] >= p[1] && max[2] >= p[2];
    }
    /**
     * BBox的值是否是Infinite
     * @english
     * If bounding box is finite
     */
    isFinite() {
        const min = this.min;
        const max = this.max;
        return isFinite(min[0]) && isFinite(min[1]) && isFinite(min[2]) &&
            isFinite(max[0]) && isFinite(max[1]) && isFinite(max[2]);
    }
    updateVertex() {
        if (!this.vertex) {
            this.vertex = [];
            for (let i = 0; i < 8; i++) {
                this.vertex.push([0, 0, 0]);
            }
        }
        this.vertex[0][0] = this.min[0];
        this.vertex[0][1] = this.min[1];
        this.vertex[0][2] = this.min[2];
        this.vertex[1][0] = this.min[0];
        this.vertex[1][1] = this.min[1];
        this.vertex[1][2] = this.max[2];
        this.vertex[2][0] = this.min[0];
        this.vertex[2][1] = this.max[1];
        this.vertex[2][2] = this.max[2];
        this.vertex[3][0] = this.min[0];
        this.vertex[3][1] = this.max[1];
        this.vertex[3][2] = this.min[2];
        this.vertex[4][0] = this.max[0];
        this.vertex[4][1] = this.min[1];
        this.vertex[4][2] = this.min[2];
        this.vertex[5][0] = this.max[0];
        this.vertex[5][1] = this.min[1];
        this.vertex[5][2] = this.max[2];
        this.vertex[6][0] = this.max[0];
        this.vertex[6][1] = this.max[1];
        this.vertex[6][2] = this.max[2];
        this.vertex[7][0] = this.max[0];
        this.vertex[7][1] = this.max[1];
        this.vertex[7][2] = this.min[2];
        return this.vertex;
    }
    copy(out) {
        if (out) {
            return BoundingBox.copy(out, this);
        }
        return new BoundingBox(this.min.slice(), this.max.slice());
    }
    equals(box) {
        if (!vec3.equals(this.min, box.min) || !vec3.equals(this.max, box.max)) {
            return false;
        }
        const vertex = box.vertex;
        for (let i = 0; i < this.vertex.length; i++) {
            if (!vec3.equals(vertex[i], this.vertex[i])) {
                return false;
            }
        }
        return true;
    }
    transform(positionMatrix, modelMatrix) {
        positionMatrix = positionMatrix || IDENTITY_MATRIX;
        modelMatrix = modelMatrix || IDENTITY_MATRIX;
        if (!modelMatrix[1] && !modelMatrix[2] && !modelMatrix[4] && !modelMatrix[6] && !modelMatrix[8] && !modelMatrix[9]) {
            const matrix = mat4.multiply(TEMP_MATRIX, modelMatrix, positionMatrix);
            vec3.transformMat4(this.min, this.min, matrix);
            vec3.transformMat4(this.max, this.max, matrix);
        }
        else {
            const boxVertex = this.vertex;
            const matrix = mat4.multiply(TEMP_MATRIX, modelMatrix, positionMatrix);
            for (let i = 0; i < boxVertex.length; i++) {
                vec3.transformMat4(this.vertex[i], this.vertex[i], matrix);
            }
            const xVertex = this.vertex.map(v => v[0]);
            const yVertex = this.vertex.map(v => v[1]);
            const zVertex = this.vertex.map(v => v[2]);
            const minX = Math.min(...xVertex), maxX = Math.max(...xVertex);
            const minY = Math.min(...yVertex), maxY = Math.max(...yVertex);
            const minZ = Math.min(...zVertex), maxZ = Math.max(...zVertex);
            vec3.set(this.min, minX, minY, minZ);
            vec3.set(this.max, maxX, maxY, maxZ);
        }
        return this;
    }
}

function earcut$1(data, holeIndices, dim = 2) {

    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = linkedList(data, 0, outerLen, dim, true);
    const triangles = [];

    if (!outerNode || outerNode.next === outerNode.prev) return triangles;

    let minX, minY, invSize;

    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);

    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = Infinity;
        minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;

        for (let i = dim; i < outerLen; i += dim) {
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }

        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }

    earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);

    return triangles;
}

// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise) {
    let last;

    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
        for (let i = start; i < end; i += dim) last = insertNode(i / dim | 0, data[i], data[i + 1], last);
    } else {
        for (let i = end - dim; i >= start; i -= dim) last = insertNode(i / dim | 0, data[i], data[i + 1], last);
    }

    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }

    return last;
}

// eliminate colinear or duplicate points
function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;

    let p = start,
        again;
    do {
        again = false;

        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;

        } else {
            p = p.next;
        }
    } while (again || p !== end);

    return end;
}

// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;

    // interlink polygon nodes in z-order
    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);

    let stop = ear;

    // iterate through ears, slicing them one by one
    while (ear.prev !== ear.next) {
        const prev = ear.prev;
        const next = ear.next;

        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle

            removeNode(ear);

            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;

            continue;
        }

        ear = next;

        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) {
                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);

            // if this didn't work, try curing all small self-intersections locally
            } else if (pass === 1) {
                ear = cureLocalIntersections(filterPoints(ear), triangles);
                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);

            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) {
                splitEarcut(ear, triangles, dim, minX, minY, invSize);
            }

            break;
        }
    }
}

// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {
    const a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;

    // triangle bbox
    const x0 = Math.min(ax, bx, cx),
        y0 = Math.min(ay, by, cy),
        x1 = Math.max(ax, bx, cx),
        y1 = Math.max(ay, by, cy);

    let p = c.next;
    while (p !== a) {
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 &&
            pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) &&
            area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }

    return true;
}

function isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;

    // triangle bbox
    const x0 = Math.min(ax, bx, cx),
        y0 = Math.min(ay, by, cy),
        x1 = Math.max(ax, bx, cx),
        y1 = Math.max(ay, by, cy);

    // z-order range for the current triangle bbox;
    const minZ = zOrder(x0, y0, minX, minY, invSize),
        maxZ = zOrder(x1, y1, minX, minY, invSize);

    let p = ear.prevZ,
        n = ear.nextZ;

    // look for points inside the triangle in both directions
    while (p && p.z >= minZ && n && n.z <= maxZ) {
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c &&
            pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;

        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c &&
            pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    // look for remaining points in decreasing z-order
    while (p && p.z >= minZ) {
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c &&
            pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }

    // look for remaining points in increasing z-order
    while (n && n.z <= maxZ) {
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c &&
            pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    return true;
}

// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev,
            b = p.next.next;

        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {

            triangles.push(a.i, p.i, b.i);

            // remove two nodes involved
            removeNode(p);
            removeNode(p.next);

            p = start = b;
        }
        p = p.next;
    } while (p !== start);

    return filterPoints(p);
}

// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while (b !== a.prev) {
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = splitPolygon(a, b);

                // filter colinear points around the cuts
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);

                // run earcut on each half
                earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    } while (a !== start);
}

// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];

    for (let i = 0, len = holeIndices.length; i < len; i++) {
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push(getLeftmost(list));
    }

    queue.sort(compareXYSlope);

    // process holes from left to right
    for (let i = 0; i < queue.length; i++) {
        outerNode = eliminateHole(queue[i], outerNode);
    }

    return outerNode;
}

function compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}

// find a bridge between vertices that connects hole with an outer ring and and link it
function eliminateHole(hole, outerNode) {
    const bridge = findHoleBridge(hole, outerNode);
    if (!bridge) {
        return outerNode;
    }

    const bridgeReverse = splitPolygon(bridge, hole);

    // filter collinear points around the cuts
    filterPoints(bridgeReverse, bridgeReverse.next);
    return filterPoints(bridge, bridge.next);
}

// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;

    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if (equals(hole, p)) return p;
    do {
        if (equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    } while (p !== outerNode);

    if (!m) return null;

    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point

    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;

    p = m;

    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x &&
                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {

            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential

            if (locallyInside(p, hole) &&
                (tan < tanMin || (tan === tanMin && (p.x > m.x || (p.x === m.x && sectorContainsSector(m, p)))))) {
                m = p;
                tanMin = tan;
            }
        }

        p = p.next;
    } while (p !== stop);

    return m;
}

// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector(m, p) {
    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}

// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    } while (p !== start);

    p.prevZ.nextZ = null;
    p.prevZ = null;

    sortLinked(p);
}

// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {
    let numMerges;
    let inSize = 1;

    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;

        while (p) {
            numMerges++;
            let q = p;
            let pSize = 0;
            for (let i = 0; i < inSize; i++) {
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;

            while (pSize > 0 || (qSize > 0 && q)) {

                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }

                if (tail) tail.nextZ = e;
                else list = e;

                e.prevZ = tail;
                tail = e;
            }

            p = q;
        }

        tail.nextZ = null;
        inSize *= 2;

    } while (numMerges > 1);

    return list;
}

// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;

    x = (x | (x << 8)) & 0x00FF00FF;
    x = (x | (x << 4)) & 0x0F0F0F0F;
    x = (x | (x << 2)) & 0x33333333;
    x = (x | (x << 1)) & 0x55555555;

    y = (y | (y << 8)) & 0x00FF00FF;
    y = (y | (y << 4)) & 0x0F0F0F0F;
    y = (y | (y << 2)) & 0x33333333;
    y = (y | (y << 1)) & 0x55555555;

    return x | (y << 1);
}

// find the leftmost node of a polygon ring
function getLeftmost(start) {
    let p = start,
        leftmost = start;
    do {
        if (p.x < leftmost.x || (p.x === leftmost.x && p.y < leftmost.y)) leftmost = p;
        p = p.next;
    } while (p !== start);

    return leftmost;
}

// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) &&
           (ax - px) * (by - py) >= (bx - px) * (ay - py) &&
           (bx - px) * (cy - py) >= (cx - px) * (by - py);
}

// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}

// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
           (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
            (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
            equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
}

// signed area of a triangle
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}

// check if two points are equal
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}

// check if two segments intersect
function intersects(p1, q1, p2, q2) {
    const o1 = sign(area(p1, q1, p2));
    const o2 = sign(area(p1, q1, q2));
    const o3 = sign(area(p2, q2, p1));
    const o4 = sign(area(p2, q2, q1));

    if (o1 !== o2 && o3 !== o4) return true; // general case

    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2

    return false;
}

// for collinear points p, q, r, check if point q lies on segment pr
function onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}

function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}

// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
                intersects(p, p.next, a, b)) return true;
        p = p.next;
    } while (p !== a);

    return false;
}

// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ?
        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}

// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
                (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
            inside = !inside;
        p = p.next;
    } while (p !== a);

    return inside;
}

// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {
    const a2 = createNode(a.i, a.x, a.y),
        b2 = createNode(b.i, b.x, b.y),
        an = a.next,
        bp = b.prev;

    a.next = b;
    b.prev = a;

    a2.next = an;
    an.prev = a2;

    b2.next = a2;
    a2.prev = b2;

    bp.next = b2;
    b2.prev = bp;

    return b2;
}

// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {
    const p = createNode(i, x, y);

    if (!last) {
        p.prev = p;
        p.next = p;

    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}

function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;

    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}

function createNode(i, x, y) {
    return {
        i, // vertex index in coordinates array
        x, y, // vertex coordinates
        prev: null, // previous and next vertex nodes in a polygon ring
        next: null,
        z: 0, // z-order curve value
        prevZ: null, // previous and next nodes in z-order
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}

function signedArea(data, start, end, dim) {
    let sum = 0;
    for (let i = start, j = end - dim; i < end; i += dim) {
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}

// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
function flatten(data) {
    const vertices = [];
    const holes = [];
    const dimensions = data[0][0].length;
    let holeIndex = 0;
    let prevLen = 0;

    for (const ring of data) {
        for (const p of ring) {
            for (let d = 0; d < dimensions; d++) vertices.push(p[d]);
        }
        if (prevLen) {
            holeIndex += prevLen;
            holes.push(holeIndex);
        }
        prevLen = ring.length;
    }
    return {vertices, holes, dimensions};
}

function getGPUVertexType(array) {
    let format;
    if (Array.isArray(array) || array instanceof Float32Array) {
        format = 'float32';
    }
    else if (array instanceof Uint32Array) {
        format = 'uint32';
    }
    else if (array instanceof Int32Array) {
        format = 'sint32';
    }
    else if (array instanceof Uint16Array) {
        format = 'uint16';
    }
    else if (array instanceof Int16Array) {
        format = 'sint16';
    }
    else if (array instanceof Uint8Array) {
        format = 'uint8';
    }
    else if (array instanceof Int8Array) {
        format = 'sint8';
    }
    return format;
}
const component_ctors = {
    5120: { name: 'sint8', bytes: 1 },
    5122: { name: 'sint16', bytes: 2 },
    5124: { name: 'sint32', bytes: 4 },
    5121: { name: 'uint8', bytes: 1 },
    5123: { name: 'uint16', bytes: 2 },
    5125: { name: 'uint32', bytes: 4 },
    5126: { name: 'float32', bytes: 4 }
};
function getFormatFromGLTFAccessor(componentType, itemSize) {
    const format = component_ctors[componentType].name;
    if (itemSize > 1) {
        return format + 'x' + itemSize;
    }
    else {
        return format;
    }
}
function getBytesPerElementFromGLTFAccessor(componentType) {
    return component_ctors[componentType].bytes;
}
const PADDING_TYPES = {
    mat2x3f: { pad: [3, 1] },
    mat2x3h: { pad: [3, 1] },
    mat3x3f: { pad: [3, 1] },
    mat3x3h: { pad: [3, 1] },
    mat4x3f: { pad: [3, 1] },
    mat4x3h: { pad: [3, 1] },
    mat3x4f: { pad: [3, 1] },
    mat3x4h: { pad: [3, 1] },
};
function isPaddingType(type) {
    return PADDING_TYPES[type.name];
}

/**
     * Rounds a number up to nearest multiple.
     *
     * @param numToRound - The number to round up.
     * @param multiple - The multiple to round up to.
     * @returns A number rounded up to nearest multiple.
     */
function roundUp(numToRound, multiple) {
    if (multiple === 0) {
        return numToRound;
    }
    return Math.ceil(numToRound / multiple) * multiple;
}

const EMPTY_VAO_BUFFER = [];
const REGL_TYPES = {
    5120: 'int8',
    5122: 'int16',
    5124: 'int32',
    5121: 'uint8',
    5123: 'uint16',
    5125: 'uint32',
    5126: 'float'
};
const REGL_TYPE_WIDTH = {
    5120: 1,
    5122: 2,
    5124: 4,
    5121: 1,
    5123: 2,
    5125: 4,
    5126: 4
};
const DEFAULT_DESC = {
    'positionSize': 3,
    'primitive': 'triangles',
    //name of position attribute
    'positionAttribute': 'aPosition',
    'normalAttribute': 'aNormal',
    'uv0Attribute': 'aTexCoord',
    'uv1Attribute': 'aTexCoord1',
    'color0Attribute': 'aColor0',
    'tangentAttribute': 'aTangent',
    'pickingIdAttribute': 'aPickingId',
    'textureCoordMatrixAttribute': 'aTextureCoordMatrix'
};
let GPU_ELEMENTS = new Uint16Array(1024);
function getSemantic(desc) {
    const semantic = {};
    for (const p in DEFAULT_DESC) {
        if (p.endsWith('Attribute')) {
            semantic[desc[p]] = DEFAULT_DESC[p];
        }
    }
    return semantic;
}
let UID = 1;
function GUID() {
    return UID++;
}
const REF_COUNT_KEY = '_reshader_refCount';
const arrays = {};
function getTempParamArray(ctor, length) {
    const name = ctor.name;
    if (!arrays[name] || arrays[name].length < length) {
        arrays[name] = new ctor(length);
    }
    const arr = arrays[name].subarray(0, length);
    arr.fill(0);
    return arr;
}
class Geometry {
    static padGPUGLTFAttribute(attribute) {
        const array = attribute.array;
        const newArray = Geometry.padGPUBufferAlignment(array, attribute.count);
        if (array !== newArray) {
            const itemSize = newArray.length / attribute.count;
            attribute.array = newArray;
            attribute.byteLength = newArray.byteLength;
            attribute.itemSize = itemSize;
            const type = attribute.type;
            attribute.type = type.substring(0, type.length - 1) + attribute.itemSize;
            //TODO attributes[name].byteStride 可能不为0
        }
        return attribute;
    }
    static createElementBuffer(device, elements) {
        if (device.wgpu) {
            if (Array.isArray(elements)) {
                const ctor = findElementConstructor(elements);
                elements = new ctor(elements);
            }
            return createGPUBuffer(device, elements, GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST, 'index buffer');
        }
        else {
            // regl
            return device.elements(elements);
        }
    }
    static createBuffer(device, data, name) {
        if (device.wgpu) {
            return createGPUBuffer(device, data, GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST, name);
        }
        else {
            // regl
            return device.buffer(data);
        }
    }
    static padGPUBufferAlignment(array, vertexCount, transient = false) {
        if (vertexCount === 0) {
            return array;
        }
        const itemBytes = array.byteLength / vertexCount;
        if (itemBytes % 4 === 0) {
            return array;
        }
        const ctor = array.constructor;
        const itemSize = array.length / vertexCount;
        const bytesPerElement = itemBytes / itemSize;
        // 无法对齐时，itemSize 一定是1,2,3，不可能是4
        if (itemSize === 3) {
            // itemSize 为 3时，补位为 4，wgsl中需要相应修改类型声明
            const newItemSize = ensureAlignment(itemSize, bytesPerElement);
            let newArray;
            if (transient) {
                newArray = getTempParamArray(ctor, newItemSize * vertexCount); //new ctor(newItemSize * vertexCount);
            }
            else {
                newArray = new ctor(newItemSize * vertexCount);
            }
            for (let i = 0; i < vertexCount; i++) {
                for (let ii = 0; ii < itemSize; ii++) {
                    newArray[i * newItemSize + ii] = array[i * itemSize + ii];
                }
            }
            return newArray;
        }
        else {
            // itemSize 为 1或2时，提升数组的类型，不影响wgsl中的类型声明
            const newCtor = getPadArrayCtor(ctor, itemSize);
            let newArray;
            if (transient) {
                newArray = getTempParamArray(newCtor, itemSize * vertexCount); //new newCtor(itemSize * vertexCount);
            }
            else {
                newArray = new newCtor(itemSize * vertexCount);
            }
            newArray.set(array);
            return newArray;
        }
    }
    constructor(data, elements, count, desc) {
        this._version = 0;
        this.data = data;
        this.elements = elements;
        this.desc = extend$1({}, DEFAULT_DESC, desc);
        this.semantic = getSemantic(this.desc);
        const pos = this._getPosAttribute();
        this.data[this.desc.positionAttribute] = pos;
        if (!count) {
            if (this.elements) {
                count = getElementLength(this.elements);
            }
            else if (pos && pos.length) {
                count = pos.length / this.desc.positionSize;
            }
            else if (pos && pos.interleavedArray) {
                count = pos.interleavedArray.length / this.desc.positionSize;
            }
            else if (pos && pos.array) {
                count = pos.array.length / this.desc.positionSize;
            }
        }
        this.count = count;
        if (!this.elements) {
            this.elements = count;
        }
        this._isIndexed = !isNumber$2(this.elements);
        this.properties = {};
        this._buffers = {};
        this._vao = {};
        this.getVertexCount();
        this._prepareData(true);
        this.updateBoundingBox();
    }
    set version(v) {
        throw new Error('Geometry.version is read only.');
    }
    get version() {
        return this._version;
    }
    // set elements(e) {
    //     throw new Error('Geometry.elements is read only, use setElements instead.');
    // }
    //@internal
    _getPosAttribute() {
        return this.data[this.desc.positionAttribute];
    }
    //@internal
    _prepareData(toUpdateRefCount) {
        if (!this.data) {
            return;
        }
        //TODO 可以直接从POSITION的min/max读出bbox，省去遍历
        const buffers = this._buffers || {};
        for (const attr in this.data) {
            const attribute = this.data[attr];
            if (!attribute) {
                continue;
            }
            if (attribute.buffer && attribute.buffer.destroy) {
                const buffer = attribute.buffer;
                if (!buffer[REF_COUNT_KEY]) {
                    buffer[REF_COUNT_KEY] = 0;
                }
                if (toUpdateRefCount) {
                    buffer[REF_COUNT_KEY]++;
                }
            }
            else if (attribute && attribute.array) {
                if (isInStride(attribute)) {
                    let id = attribute.array.buffer['__id'];
                    if (!id) {
                        id = attribute.array.buffer['__id'] = GUID();
                    }
                    this.data[attr] = {
                        buffer: id,
                        offset: attribute.byteOffset,
                        stride: attribute.byteStride,
                        type: REGL_TYPES[attribute.componentType],
                        size: attribute.itemSize,
                        count: attribute.count,
                        componentType: attribute.componentType
                    };
                    if (!buffers[id]) {
                        buffers[id] = {
                            data: attribute.array.buffer
                        };
                    }
                }
                else {
                    this.data[attr] = attribute.array;
                }
            }
        }
        this._buffers = buffers;
        const elements = this.elements;
        if (elements && elements.array) {
            this.elements = elements.array;
        }
    }
    getBuffer(name) {
        return this.data[name] && this.data[name].buffer;
    }
    getAttrData(activeAttributes) {
        const key = activeAttributes.key;
        const updated = !this._reglData || !this._reglData[key];
        if (!this._reglData) {
            this._reglData = {};
        }
        if (updated) {
            const reglData = this._reglData[key] = {};
            const data = this.data;
            const { positionAttribute, normalAttribute, uv0Attribute, uv1Attribute, tangentAttribute, color0Attribute, pickingIdAttribute, textureCoordMatrixAttribute } = this.desc;
            extend$1(reglData, this.data);
            reglData['aPosition'] = data[positionAttribute];
            if (data[normalAttribute]) {
                reglData['aNormal'] = data[normalAttribute];
            }
            if (data[uv0Attribute]) {
                reglData['aTexCoord'] = data[uv0Attribute];
            }
            if (data[uv1Attribute]) {
                reglData['aTexCoord1'] = data[uv1Attribute];
            }
            if (data[tangentAttribute]) {
                reglData['aTangent'] = data[tangentAttribute];
            }
            if (data[color0Attribute]) {
                reglData['aColor0'] = data[color0Attribute];
            }
            if (data[pickingIdAttribute]) {
                reglData['aPickingId'] = data[pickingIdAttribute];
            }
            if (data[textureCoordMatrixAttribute]) {
                reglData['aTextureCoordMatrix'] = data[textureCoordMatrixAttribute];
            }
        }
        return this._reglData[key];
    }
    getREGLData(regl, activeAttributes, disableVAO) {
        this.getAttrData(activeAttributes);
        //support vao
        if (isSupportVAO(regl) && !disableVAO) {
            const updated = !this._reglData || !this._reglData[activeAttributes.key];
            const key = activeAttributes && activeAttributes.key || 'default';
            if (!this._vao[key] || updated || this._vao[key].dirty) {
                const reglData = this._reglData[activeAttributes.key];
                const vertexCount = this._vertexCount;
                const buffers = [];
                for (let i = 0; i < activeAttributes.length; i++) {
                    const p = activeAttributes[i];
                    const attr = p.name;
                    const buffer = reglData[attr] && reglData[attr].buffer;
                    if (!buffer || !buffer.destroy) {
                        const data = reglData[attr];
                        if (!data) {
                            if (this.desc.fillEmptyDataInMissingAttribute) {
                                // 某些老版本浏览器（例如3dtiles中的electron），数据不能传空字符串，否则会报错
                                // glDrawElements: attempt to access out of range vertices in attribute 1
                                buffers.push(new Uint8Array(vertexCount * 4));
                            }
                            else {
                                buffers.push(EMPTY_VAO_BUFFER);
                            }
                            continue;
                        }
                        const dimension = (data.data && isArray(data.data) ? data.data.length : data.length) / vertexCount;
                        if (data.data) {
                            data.dimension = dimension;
                            buffers.push(data);
                        }
                        else {
                            buffers.push({
                                data,
                                dimension
                            });
                        }
                    }
                    else if (reglData[attr].stride !== undefined) {
                        buffers.push(reglData[attr]);
                    }
                    else {
                        buffers.push(buffer);
                    }
                }
                const vaoData = {
                    attributes: buffers,
                    primitive: this.getPrimitive()
                };
                if (this.elements && !isNumber$2(this.elements)) {
                    if (this.elements.destroy) {
                        vaoData.elements = this.elements;
                    }
                    else {
                        vaoData.elements = {
                            primitive: this.getPrimitive(),
                            data: this.elements
                        };
                        const type = this.getElementsType(this.elements);
                        if (type) {
                            vaoData.elements.type = type;
                        }
                    }
                }
                if (!this._vao[key]) {
                    this._vao[key] = {
                        vao: regl.vao(vaoData)
                    };
                }
                else {
                    this._vao[key].vao(vaoData);
                }
            }
            delete this._vao[key].dirty;
            return this._vao[key];
        }
        return this._reglData[activeAttributes.key];
    }
    //@internal
    _isAttrChanged(activeAttributes) {
        if (activeAttributes === this._activeAttributes) {
            return false;
        }
        if (activeAttributes.length !== this._activeAttributes.length) {
            return true;
        }
        for (let i = 0; i < activeAttributes.length; i++) {
            if (activeAttributes[i] !== this._activeAttributes[i]) {
                return true;
            }
        }
        return false;
    }
    generateBuffers(device) {
        this._bufferGen = true;
        const isWebGPU = !!device.wgpu;
        //generate regl buffers beforehand to avoid repeated bufferData
        //提前处理addBuffer插入的arraybuffer
        const allocatedBuffers = this._buffers;
        for (const p in allocatedBuffers) {
            if (!allocatedBuffers[p].buffer) {
                allocatedBuffers[p].buffer = Geometry.createBuffer(device, allocatedBuffers[p].data, p);
            }
            delete allocatedBuffers[p].data;
        }
        const positionName = this.desc.positionAttribute;
        const altitudeName = this.desc.altitudeAttribute;
        const data = this.data;
        const vertexCount = this._vertexCount;
        const buffers = {};
        for (const key in data) {
            if (!data[key]) {
                continue;
            }
            if (Array.isArray(data[key])) {
                data[key] = new Float32Array(data[key]);
            }
            //如果调用过addBuffer，buffer有可能是ArrayBuffer
            if (data[key].buffer !== undefined && !(data[key].buffer instanceof ArrayBuffer)) {
                if (data[key].buffer.destroy) {
                    buffers[key] = data[key];
                }
                else if (allocatedBuffers[data[key].buffer]) {
                    //多个属性共用同一个ArrayBuffer(interleaved)
                    buffers[key] = extend$1({}, data[key]);
                    buffers[key].buffer = allocatedBuffers[data[key].buffer].buffer;
                }
            }
            else {
                let arr = data[key].data ? data[key].data : data[key];
                const dimension = Math.floor(arr.length / vertexCount);
                if (dimension * vertexCount !== arr.length) {
                    arr = arr.slice(0, vertexCount * dimension);
                    if (data[key].data) {
                        data[key].data = arr;
                    }
                    else {
                        data[key] = arr;
                    }
                }
                let bufferData = arr;
                if (isWebGPU) {
                    bufferData = Geometry.padGPUBufferAlignment(arr, vertexCount, true);
                }
                const info = data[key].data ? data[key] : {};
                info.data = bufferData;
                info.dimension = dimension;
                const buffer = Geometry.createBuffer(device, info, key);
                buffer[REF_COUNT_KEY] = 1;
                buffers[key] = {
                    buffer
                };
                if (key === positionName || key === altitudeName) { //vt中positionSize=2,z存在altitude中，也需要一并保存
                    buffers[key].array = data[key];
                }
            }
            if (this.desc.static || key !== positionName) { //保存POSITION原始数据，用来做额外计算
                delete data[key].array;
            }
        }
        this.data = buffers;
        delete this._reglData;
        // const supportVAO = isSupportVAO(regl);
        // const excludeElementsInVAO = options && options.excludeElementsInVAO;
        if (this.elements && !isNumber$2(this.elements)) {
            ({
                primitive: this.getPrimitive(),
                data: this.elements
            });
            this.getElementsType(this.elements);
            if (!this.desc.static && !this.elements.destroy) {
                const elements = this.elements;
                let ctor;
                if (Array.isArray(this.elements)) {
                    ctor = findElementConstructor(this.elements);
                }
                else {
                    ctor = this.elements.constructor;
                }
                if (elements instanceof ctor) {
                    //2x faster by new TypeArray(typearray)
                    //https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Uint32Array
                    this.indices = new ctor(elements);
                }
                else {
                    this.indices = new ctor(elements.length);
                    for (let i = 0; i < elements.length; i++) {
                        this.indices[i] = elements[i];
                    }
                }
            }
            this.elements = this.elements.destroy ? this.elements : Geometry.createElementBuffer(device, this.elements);
            const elements = this.elements;
            if (!elements[REF_COUNT_KEY]) {
                elements[REF_COUNT_KEY] = 0;
            }
            elements[REF_COUNT_KEY]++;
        }
    }
    isBufferGenerated() {
        return this._bufferGen;
    }
    getVertexCount() {
        const { positionAttribute, positionSize, color0Attribute } = this.desc;
        let data = this.data[positionAttribute];
        if (data.data) {
            data = data.data;
        }
        if (data.array) {
            data = data.array;
        }
        if (isArray(data)) {
            // 因为data可能被转成regl buffer，需要保存到this._vertexCount
            // 在 updateData时再更新
            this._vertexCount = Math.ceil(data.length / positionSize);
        }
        else if (data && data.count !== undefined) {
            this._vertexCount = data.count;
        }
        const key = color0Attribute;
        if (this.data[key]) {
            const arr = this.data[key].data || this.data[key].array || this.data[key];
            if (Array.isArray(arr)) {
                this._color0Size = arr.length / this._vertexCount;
            }
            else if (this.data[key].buffer && this.data[key].buffer.destroy) {
                this._color0Size = this.data[key].buffer['_buffer'].dimension;
            }
            else if (arr && arr.itemSize) {
                this._color0Size = arr.itemSize;
            }
        }
        return this._vertexCount;
    }
    getColor0Size() {
        return this._color0Size || 0;
    }
    /**
     * 手动设置geometry的buffer，用于多个属性共用一个ArrayBuffer(interleaved)
     * @param {String} key - 属性
     * @param {ArrayBuffer|REGLBuffer} data - 数据
     */
    // addBuffer(key: string, data: ArrayBuffer | REGL.Buffer): this {
    //     this._buffers[key] = {
    //         data
    //     };
    //     delete this._reglData;
    //     this._deleteVAO();
    //     return this;
    // }
    // updateBuffer(key: string, data: ArrayBuffer | REGL.Buffer): this {
    //     if (!this._buffers[key]) {
    //         throw new Error(`invalid buffer ${key} in geometry`);
    //     }
    //     // this._buffers[key].data = data;
    //     if (this._buffers[key].buffer) {
    //         this._buffers[key].buffer.subdata(data);
    //     } else {
    //         this._buffers[key].data = data;
    //     }
    //     delete this._reglData;
    //     this._deleteVAO();
    //     return this;
    // }
    deleteData(name) {
        const buf = this.data[name];
        if (!buf) {
            return this;
        }
        this._incrVersion();
        if (buf.buffer && buf.buffer.destroy) {
            buf.buffer.destroy();
        }
        delete this.data[name];
        delete this._reglData;
        this._markVAODirty(false);
        return this;
    }
    /**
     * Replace data or refill attribute data buffer
     * @param {String} name - data's name
     * @param {Number[] | Object} data - data to update
     * @returns this
     */
    updateData(name, data) {
        const buf = this.data[name];
        if (!buf) {
            return this;
        }
        this._incrVersion();
        let buffer;
        this.data[name] = data;
        if (buf.buffer && buf.buffer.destroy) {
            buffer = buf;
        }
        const isPosition = name === this.desc.positionAttribute;
        if (isPosition) {
            this.updateBoundingBox();
        }
        this.getVertexCount();
        if (buffer) {
            if (buffer.buffer.mapState) {
                //webgpu buffer
                data = Geometry.padGPUBufferAlignment(data, this._vertexCount, true);
                buffer.buffer = this._updateGPUBuffer(buffer.buffer, data, 0, data.buffer.byteLength);
            }
            else {
                buffer.buffer(data);
            }
            this.data[name] = buffer;
            if (isPosition) {
                this.data[name].array = data;
            }
        }
        this._prepareData(false);
        if (isPosition) {
            this._posDirty = true;
        }
        delete this._reglData;
        return this;
    }
    _updateGPUBuffer(buffer, data, offset, byteLength) {
        if (Array.isArray(data)) {
            data = new Float32Array(data);
            byteLength = data.length * 4;
        }
        const device = buffer.device;
        if (byteLength > buffer.size) {
            const newBuffer = createGPUBuffer(device, data, buffer.usage, buffer.label);
            delete buffer.device;
            buffer.destroy();
            return newBuffer;
        }
        device.wgpu.queue.writeBuffer(buffer, offset, data.buffer, 0, byteLength);
        return buffer;
    }
    updateSubData(name, data, offset) {
        const buf = this.data[name];
        if (!buf) {
            return this;
        }
        this._incrVersion();
        let buffer;
        if (buf.buffer && buf.buffer.destroy) {
            buffer = buf;
        }
        if (name === this.desc.positionAttribute) {
            this._updateSubBoundingBox(data);
        }
        if (buffer) {
            if (buffer.buffer.mapState) {
                const itemSize = buffer.buffer.itemCount / this._vertexCount;
                const itemCount = data.length / itemSize;
                //webgpu buffer
                data = Geometry.padGPUBufferAlignment(data, itemCount, true);
                const byteWidth = buffer.buffer.bytesPerElement;
                if (data.BYTES_PER_ELEMENT !== byteWidth) {
                    const ctor = getTypeCtor(data, byteWidth);
                    data = new ctor(data);
                }
                buffer.buffer = this._updateGPUBuffer(buffer.buffer, data, offset * byteWidth, data.length * byteWidth);
            }
            else {
                const byteWidth = REGL_TYPE_WIDTH[buffer.buffer['_buffer'].dtype];
                if (data.BYTES_PER_ELEMENT !== byteWidth) {
                    const ctor = getTypeCtor(data, byteWidth);
                    data = new ctor(data);
                }
                buffer.buffer.subdata(data, offset * byteWidth);
            }
        }
        else {
            const arr = this.data[name].data ? this.data[name].data : this.data[name];
            for (let i = 0; i < data.length; i++) {
                arr[offset + i] = data[i];
            }
        }
        this._prepareData(false);
        if (this.desc.positionAttribute === name) {
            this._posDirty = true;
        }
        delete this._reglData;
        return this;
    }
    getPrimitive() {
        return this.desc.primitive;
    }
    getElements() {
        return this.elements;
    }
    setElements(elements, count) {
        if (!elements) {
            throw new Error('elements data is invalid');
        }
        this._incrVersion();
        const e = this.elements;
        this.count = count === undefined ? getElementLength(elements) : count;
        if (elements && elements.destroy) {
            this.elements = elements;
        }
        else if (e.destroy) {
            if (e.mapState) {
                //webgpu
                if (Array.isArray(elements)) {
                    const ctor = findElementConstructor(elements);
                    elements = new ctor(elements);
                }
                let data = elements;
                let byteLen = elements.buffer.byteLength;
                if (byteLen % 4 > 0) {
                    // byteLen % 4 !== 0 时 webgpu 会报错。
                    // elements % 4 > 0 只可能是 Uint16
                    byteLen = 4 * Math.ceil(byteLen / 4);
                    if (GPU_ELEMENTS.buffer.byteLength < byteLen) {
                        GPU_ELEMENTS = new Uint16Array(byteLen / 2);
                    }
                    GPU_ELEMENTS.fill(0);
                    data = GPU_ELEMENTS.subarray(0, byteLen / 2);
                    data.set(elements);
                }
                this.elements = this._updateGPUBuffer(e, data, 0, byteLen);
            }
            else {
                this.elements = e(elements);
            }
        }
        else {
            this.elements = elements;
        }
        this._markVAODirty(true);
        this._isIndexed = !isNumber$2(elements);
        return this;
    }
    isIndexedElements() {
        return this._isIndexed;
    }
    deleteElements() {
        if (!this.elements || this.elements.length === 0) {
            return this;
        }
        this._incrVersion();
        if (this.elements && this.elements.destroy && !this.elements[KEY_DISPOSED]) {
            this.elements.destroy();
            this.elements[KEY_DISPOSED] = 1;
        }
        this.elements = [];
        this._markVAODirty(true);
        return this;
    }
    //@internal
    _markVAODirty(forceDelete) {
        if (this._vao) {
            for (const key in this._vao) {
                if (forceDelete) {
                    this._vao[key].vao.destroy();
                }
                else {
                    this._vao[key].dirty = true;
                }
            }
            if (forceDelete) {
                this._vao = {};
            }
        }
    }
    setDrawCount(count) {
        this._incrVersion();
        this.count1 = count;
        return this;
    }
    getDrawCount() {
        return this.count1 >= 0 ? this.count1 : this.count;
    }
    setDrawOffset(offset) {
        this._incrVersion();
        this.offset = offset;
        return this;
    }
    getDrawOffset() {
        return this.offset || 0;
    }
    dispose() {
        this._deleteVAO();
        this._forEachBuffer(buffer => {
            if (!buffer[KEY_DISPOSED]) {
                let refCount = buffer[REF_COUNT_KEY];
                if (refCount) {
                    refCount--;
                }
                if (refCount <= 0) {
                    buffer[KEY_DISPOSED] = true;
                    buffer.destroy();
                }
                else {
                    buffer[REF_COUNT_KEY] = refCount;
                }
            }
        });
        if (this.properties) {
            // resource saved by highlight.js
            const oldElements = this.properties.oldElementsBeforeHighlight;
            if (oldElements && !oldElements[KEY_DISPOSED]) {
                if (oldElements.destroy) {
                    oldElements.destroy();
                    oldElements[KEY_DISPOSED] = true;
                }
            }
            delete this.properties.oldElementsBeforeHighlight;
            delete this.properties.hasInvisible;
        }
        this.data = {};
        this._buffers = {};
        delete this._reglData;
        this.count = 0;
        this.elements = [];
        delete this._tempPosArray;
        this._disposed = true;
    }
    //@internal
    _deleteVAO() {
        for (const p in this._vao) {
            this._vao[p].vao.destroy();
        }
        this._vao = {};
    }
    isDisposed() {
        return !!this._disposed;
    }
    /**
     * Update boundingBox of Geometry
     */
    updateBoundingBox() {
        let bbox = this.boundingBox;
        if (!bbox) {
            bbox = this.boundingBox = new BoundingBox();
        }
        const posAttr = this.desc.positionAttribute;
        let posArr = this.data[posAttr];
        let posMin, posMax;
        if (!isArray(posArr)) {
            // form of object: { usage : 'static', data : [...] }
            if (posArr.data) {
                posArr = posArr.data;
            }
            else if (isInterleaved(posArr)) {
                posArr = this._getAttributeData(this.desc.positionAttribute);
            }
            else if (posArr.array) {
                posMin = posArr.min;
                posMax = posArr.max;
                posArr = posArr.array;
            }
        }
        if (posArr && posArr.length) {
            //TODO only support size of 3 now
            const min = bbox.min;
            const max = bbox.max;
            if (posMin && posMax) {
                vec3.set(min, ...posMin);
                vec3.set(max, ...posMax);
            }
            else {
                vec3.set(min, posArr[0], posArr[1], posArr[2]);
                vec3.set(max, posArr[0], posArr[1], posArr[2]);
                for (let i = 3; i < posArr.length;) {
                    const x = posArr[i++];
                    const y = posArr[i++];
                    const z = posArr[i++];
                    if (x < min[0]) {
                        min[0] = x;
                    }
                    if (y < min[1]) {
                        min[1] = y;
                    }
                    if (z < min[2]) {
                        min[2] = z;
                    }
                    if (x > max[0]) {
                        max[0] = x;
                    }
                    if (y > max[1]) {
                        max[1] = y;
                    }
                    if (z > max[2]) {
                        max[2] = z;
                    }
                }
            }
            bbox.updateVertex();
            bbox.dirty();
        }
    }
    //@internal
    _updateSubBoundingBox(data) {
        const bbox = this.boundingBox;
        const min = bbox.min;
        const max = bbox.max;
        const positionSize = this.desc.positionSize;
        for (let i = 0; i < data.length;) {
            const x = data[i++];
            const y = data[i++];
            let z = 0;
            if (positionSize === 3) {
                z = data[i++];
            }
            if (x < min[0]) {
                min[0] = x;
            }
            if (y < min[1]) {
                min[1] = y;
            }
            if (z < min[2]) {
                min[2] = z;
            }
            if (x > max[0]) {
                max[0] = x;
            }
            if (y > max[1]) {
                max[1] = y;
            }
            if (z > max[2]) {
                max[2] = z;
            }
        }
        bbox.updateVertex();
        bbox.dirty();
    }
    //attribute上结构有2种,对于interleaved结构的数组，可以按需加载，节约内存
    // 1. 数组或者类型数组
    // 2. Object形式（regl的buffer定义）
    //@internal
    _getAttributeData(name) {
        const gltf = getGLTFLoaderBundle();
        const data = this.data[name] && this.data[name].array ? this.data[name].array : this.data[name];
        const bufKey = data.buffer;
        if (!isInterleaved(data)) {
            return data;
        }
        else {
            const attribute = this._buffers[bufKey] ? this._buffers[bufKey].data : data.array;
            const { count, size, stride, offset, componentType } = data;
            const ctor = gltf.GLTFLoader.getTypedArrayCtor(componentType);
            if ((stride === 0 || stride === size * ctor.BYTES_PER_ELEMENT) && offset % ctor.BYTES_PER_ELEMENT === 0) {
                return new ctor(attribute, offset, count * size);
            }
            //对于POSITION数据，为避免updateBBox时频繁创建临时数组，采用缓存tempPosArray的策略获取interleavedArray,
            //对于非POSITION的数据，直接readInterleavedArray读取即可
            if (name === this.desc.positionAttribute) {
                if (!this._tempPosArray || (this._tempPosArray && this._tempPosArray.length < size * count)) {
                    this._tempPosArray = new ctor(size * count);
                    return gltf.GLTFLoader.readInterleavedArray(this._tempPosArray, attribute, count, size, stride, offset, componentType);
                }
                if (!this._posDirty) {
                    return this._tempPosArray;
                }
                this._posDirty = false;
                return gltf.GLTFLoader.readInterleavedArray(this._tempPosArray, attribute, count, size, stride, offset, componentType);
            }
            else {
                const tempArray = new ctor(size * count);
                return gltf.GLTFLoader.readInterleavedArray(tempArray, attribute, count, size, stride, offset, componentType);
            }
        }
    }
    createTangent(name = 'aTangent', tangentsDataArray) {
        this._incrVersion();
        //TODO data 可能是含stride的interleaved类型
        const { normalAttribute, positionAttribute, uv0Attribute } = this.desc;
        const normals = this._getAttributeData(normalAttribute);
        const positions = this._getAttributeData(positionAttribute);
        let tangents;
        if (tangentsDataArray && tangentsDataArray.length) {
            tangents = tangentsDataArray;
        }
        else {
            tangents = buildTangents(positions, normals, this.data[uv0Attribute], this.elements);
        }
        const aTangent = this.data[name] = new Float32Array(tangents.length);
        const t = [0, 0, 0, 0], n = [0, 0, 0], q = [0, 0, 0, 0];
        for (let i = 0; i < tangents.length; i += 4) {
            const ni = i / 4 * 3;
            vec3.set(n, normals[ni], normals[ni + 1], normals[ni + 2]);
            vec4.set(t, tangents[i], tangents[i + 1], tangents[i + 2], tangents[i + 3]);
            packTangentFrame(q, n, t);
            vec4.copy(aTangent.subarray(i, i + 4), q);
        }
        delete this._reglData;
    }
    createNormal(name = 'aNormal') {
        this._incrVersion();
        //TODO data 可能是含stride的interleaved类型
        const pos = this._getAttributeData(this.desc.positionAttribute);
        this.data[name] = buildNormals(pos.array || pos, this.elements);
        delete this._reglData;
    }
    /**
     * Create barycentric attribute data
     * @param {String} name - attribute name for barycentric attribute
     */
    createBarycentric(name = 'aBarycentric') {
        if (this.desc.primitive !== 'triangles') {
            throw new Error('Primitive must be triangles to create bary centric data');
        }
        this._incrVersion();
        const bary = new Uint8Array(this._vertexCount * 3);
        for (let i = 0, l = this.elements.length; i < l;) {
            for (let j = 0; j < 3; j++) {
                const ii = this.elements[i++];
                bary[ii * 3 + j] = 1;
            }
        }
        this.data[name] = bary;
        delete this._reglData;
    }
    /**
     * Build unique vertex data for each attribute
     */
    buildUniqueVertex() {
        this._incrVersion();
        const data = this.data;
        const indices = this.elements;
        if (!isArray(indices)) {
            throw new Error('elements must be array to build unique vertex.');
        }
        const keys = Object.keys(data);
        const oldData = {};
        let pos = data[this.desc.positionAttribute];
        pos = pos.length ? pos : pos.array; //存在两种结构 array或者 { array }
        if (!isArray(pos)) {
            throw new Error(this.desc.positionAttribute + ' must be array to build unique vertex.');
        }
        const vertexCount = this._vertexCount;
        const l = indices.length;
        for (let i = 0; i < keys.length; i++) {
            const name = keys[i];
            const attr = isArray(data[name]) ? data[name] : data[name].array; //存在两种结构 array或者 { array }
            const size = attr.length / vertexCount;
            if (!isArray(attr)) {
                throw new Error(name + ' must be array to build unique vertex.');
            }
            oldData[name] = attr;
            const ctor = getArrayCtor(attr);
            data[name] = new ctor(l * size);
        }
        let cursor = 0;
        for (let i = 0; i < l; i++) {
            const idx = indices[i];
            for (let ii = 0; ii < keys.length; ii++) {
                const name = keys[ii];
                const array = data[name];
                const size = oldData[name].length / vertexCount;
                for (let k = 0; k < size; k++) {
                    array[cursor * size + k] = oldData[name][idx * size + k];
                }
            }
            indices[i] = cursor++;
        }
        pos = this.data[this.desc.positionAttribute];
        this._vertexCount = Math.ceil(pos.length / this.desc.positionSize);
        delete this._reglData;
    }
    getMemorySize() {
        let size = 0;
        for (const p in this.data) {
            if (hasOwn$1(this.data, p)) {
                size += getBufferSize(this.data[p]);
            }
        }
        if (this.elements) {
            const elements = this.elements;
            if (elements.destroy) {
                if (elements['_elements']) {
                    //regl
                    size += elements['_elements'].buffer.byteLength;
                }
                else {
                    size += elements.size;
                }
            }
            else if (elements.BYTES_PER_ELEMENT) {
                size += elements.length * elements.BYTES_PER_ELEMENT;
            }
            else if (elements.length) {
                // uint32 in default
                size += elements.length * 4;
            }
        }
        return size;
    }
    //@internal
    _forEachBuffer(fn) {
        if (this.elements && this.elements.destroy) {
            fn(this.elements);
        }
        for (const p in this.data) {
            if (hasOwn$1(this.data, p)) {
                if (this.data[p] && this.data[p].buffer && this.data[p].buffer.destroy) {
                    fn(this.data[p].buffer);
                }
            }
        }
        for (const p in this._buffers) {
            if (hasOwn$1(this._buffers, p)) {
                if (this._buffers[p] && this._buffers[p].buffer && this._buffers[p].buffer.destroy) {
                    fn(this._buffers[p].buffer);
                }
            }
        }
    }
    getElementsType(elements) {
        if (elements instanceof Uint8Array) {
            return 'uint8';
        }
        else if (elements instanceof Uint16Array) {
            return 'uint16';
        }
        else if (elements instanceof Uint32Array) {
            return 'uint32';
        }
        else {
            return undefined;
        }
    }
    //@internal
    _incrVersion() {
        this._version++;
    }
    getCommandKey(device) {
        if (device && device.wgpu) {
            // 因为attribute组织方式会影响pipeline的创建，所以attributes组织方式不同时，需要创建不同的command key
            // 我们这里暂时不考虑Geometry会更新attributes组织方式的情况，因为在maptalks的使用场景不会出现
            // 可能有些attribute没有被wgsl使用，但组织方式不同，这里也不考虑这种情况
            const keys = [];
            for (const p in this.data) {
                const attr = this.data[p];
                if (attr.byteStride) {
                    keys.push(`${p}(${attr.byteOffset}/${attr.byteStride}})`);
                }
                else {
                    keys.push(p);
                }
            }
            return keys.sort().join('-');
        }
        else {
            // regl
            return '';
        }
    }
    getBufferDescriptor(vertexInfo) {
        const attrInfos = [];
        for (const p in vertexInfo) {
            const info = vertexInfo[p];
            attrInfos[info.location] = info;
        }
        const data = this.data;
        const bufferDesc = [];
        const bufferMapping = {};
        // bufferDesc的顺序需要和wgsl中的location对应
        for (let i = 0; i < attrInfos.length; i++) {
            if (!attrInfos[i]) {
                continue;
            }
            const p = attrInfos[i].geoAttrName;
            const attr = data[p];
            if (!attr) {
                continue;
            }
            const infoName = this.semantic[p] || p;
            const info = vertexInfo[infoName];
            if (!info) {
                continue;
            }
            const accessorName = attr.accessorName;
            const byteStride = attr.byteStride;
            if (byteStride && accessorName) {
                // a GLTF accessor style attribute
                const format = getFormatFromGLTFAccessor(attr.componentType, attr.itemSize);
                let desc = bufferMapping[accessorName];
                if (desc) {
                    desc.attributes.push({
                        shaderLocation: info.location,
                        format,
                        offset: attr.byteOffset
                    });
                }
                else {
                    desc = {
                        arrayStride: byteStride,
                        attributes: [
                            {
                                shaderLocation: info.location,
                                format,
                                offset: attr.byteOffset
                            }
                        ]
                    };
                    bufferMapping[accessorName] = desc;
                    bufferDesc[i] = desc;
                }
            }
            else {
                const desc = getAttrBufferDescriptor(attr, info);
                bufferDesc[i] = desc;
            }
        }
        return bufferDesc;
    }
}
function getElementLength(elements) {
    if (isNumber$2(elements)) {
        return elements;
    }
    else if (elements.count !== undefined) {
        // object buffer form
        return elements.count;
    }
    else if (elements.destroy) {
        if (elements['_elements']) {
            // a regl element buffer
            return elements['_elements'].vertCount;
        }
        else {
            //GPUBuffer
            return elements.itemCount;
        }
    }
    else if (elements.length !== undefined) {
        return elements.length;
    }
    else if (elements.data) {
        return elements.data.length;
    }
    throw new Error('invalid elements length');
}
function getTypeCtor(arr, byteWidth) {
    if (arr instanceof Uint8Array || arr instanceof Uint16Array || arr instanceof Uint32Array || arr instanceof Uint8ClampedArray) {
        return byteWidth === 1 ? Uint8Array : byteWidth === 2 ? Uint16Array : Uint32Array;
    }
    if (arr instanceof Int8Array || arr instanceof Int16Array || arr instanceof Int32Array) {
        return byteWidth === 1 ? Int8Array : byteWidth === 2 ? Int16Array : Int32Array;
    }
    if (arr instanceof Float32Array || arr instanceof Float64Array) {
        return byteWidth === 4 ? Float32Array : Float64Array;
    }
    return null;
}
function getAttrBufferDescriptor(attr, info) {
    const array = attr.data || attr.array || attr;
    let itemSize = info.itemSize;
    if (attr.buffer && !isArray(attr)) {
        const bytesPerElement = attr.buffer.bytesPerElement;
        itemSize = ensureAlignment(itemSize, bytesPerElement);
        const format = getItemFormat(attr, itemSize);
        return {
            arrayStride: itemSize * bytesPerElement,
            attributes: [
                {
                    shaderLocation: info.location,
                    format,
                    offset: 0
                }
            ]
        };
    }
    else if (isArray(array)) {
        let format, bytesPerElement;
        if (attr.componentType) {
            format = getFormatFromGLTFAccessor(attr.componentType, attr.itemSize);
            bytesPerElement = getBytesPerElementFromGLTFAccessor(attr.componentType);
        }
        else {
            format = getItemFormat(array, itemSize);
            bytesPerElement = getBytesPerElement(array);
        }
        itemSize = ensureAlignment(itemSize, bytesPerElement);
        return {
            arrayStride: itemSize * bytesPerElement,
            attributes: [
                {
                    shaderLocation: info.location,
                    format,
                    offset: 0
                }
            ]
        };
    }
}
function getBytesPerElement(data) {
    const array = getAttrArray(data);
    if (array.destroy) {
        return array.bytesPerElement;
    }
    if (array.BYTES_PER_ELEMENT) {
        return array.BYTES_PER_ELEMENT;
    }
    else if (Array.isArray(array)) {
        // float
        return 4;
    }
    else {
        const item = array;
        const gltf = getGLTFLoaderBundle();
        const ctor = gltf.GLTFLoader.getTypedArrayCtor(item.componentType);
        return ctor.BYTES_PER_ELEMENT;
    }
}
function getItemFormat(data, itemSize) {
    const array = getAttrArray(data);
    let format;
    if (array.destroy) {
        format = array.itemType;
    }
    else {
        format = getGPUVertexType(array);
    }
    return itemSize > 1 ? (format + 'x' + itemSize) : format;
}
function getAttrArray(data) {
    return data.data || (data.buffer && data.buffer.destroy && data.buffer) || data;
}
function createGPUBuffer(device, data, usage, label) {
    data = data.data || data;
    if (Array.isArray(data[0])) {
        data = flatten(data);
    }
    if (Array.isArray(data)) {
        data = new Float32Array(data);
    }
    const ctor = data.constructor;
    // f32 in default
    const byteLength = data.byteLength;
    // mappedAtCreation requires size is a multiplier of 4
    // https://github.com/gpuweb/gpuweb/issues/5105
    const size = roundUp(byteLength, 4);
    const buffer = device.wgpu.createBuffer({
        label,
        size,
        usage,
        mappedAtCreation: true
    });
    buffer.device = device;
    new ctor(buffer.getMappedRange()).set(data);
    buffer.unmap();
    buffer.itemCount = data.length;
    buffer.itemType = getGPUVertexType(data); // uint8, sint8, uint16, sint16, uint32, sint32, float32
    buffer.bytesPerElement = getBytesPerElement(data);
    return buffer;
}
function findElementConstructor(data) {
    let max = -Infinity;
    for (let i = 0; i < data.length; i++) {
        if (data[i] > max) {
            max = data[i];
        }
    }
    return getIndexArrayType(max);
}
function getIndexArrayType(max) {
    if (max < 65536)
        return Uint16Array;
    return Uint32Array;
}
function ensureAlignment(itemSize, bytesPerElement) {
    const itemBytes = itemSize * bytesPerElement;
    if (itemBytes % 4 === 0) {
        return itemSize;
    }
    return itemSize + (4 - (itemBytes % 4)) / bytesPerElement;
}
// itemSize 只可能是1，2
function getPadArrayCtor(ctor, itemSize) {
    if (ctor === Uint8Array || ctor === Uint8ClampedArray) {
        if (itemSize === 1) {
            return Uint32Array;
        }
        else {
            return Uint16Array;
        }
    }
    else if (ctor === Int8Array) {
        if (itemSize === 1) {
            return Int32Array;
        }
        else {
            return Int16Array;
        }
    }
    else if (ctor === Uint16Array) {
        return Uint32Array;
    }
    else if (ctor === Int16Array) {
        return Int32Array;
    }
    else {
        throw new Error('sth unexpected in getPadArrayCtor');
    }
}

const reglPrimitives = ['points', 'lines', 'line strip', 'line loop', 'triangles', 'triangle strip', 'triangle fan'];
function getPrimitive(mode) {
    return reglPrimitives[mode];
}

const materialTypes = {
    0x1401: 'uint8',
    0x1403: 'uint16',
    0x1405: 'uint32',
    0x1406: 'float',
    0x8D61: 'half float'
};
function getMaterialType(type) {
    return materialTypes[type];
}


function getArrayType(array) {
    if (array instanceof Uint8Array) {
        return 'uint8';
    } else if (array instanceof Int8Array) {
        return 'int8';
    } else if (array instanceof Uint16Array) {
        return 'uint16';
    } else if (array instanceof Int16Array) {
        return 'int16';
    } else {
        return 'float';
    }
}

const materialFormats = {
    0x1906: 'alpha',
    0x1907: 'rgb',
    0x1908: 'rgba',
    0x1909: 'luminance',
    0x190A: 'luminance alpha',
    0x83f0: 'rgb s3tc dxt1',
    0x83f1: 'rgba s3tc dxt1',
    0x83f2: 'rgba s3tc dxt3',
    0x83f3: 'rgba s3tc dxt5',
    0x8c00: 'rgb pvrtc 4bppv1',
    0x8c01: 'rgb pvrtc 2bppv1',
    0x8c02: 'rgba pvrtc 4bppv1',
    0x8c03: 'rgba pvrtc 2bppv1',
    0x8c92: 'rgb atc',
    0x8C93: 'rgba atc explicit alpha',
    0x87EE: 'rgba atc interpolated alpha',
    0x8D64: 'rgb etc1',
    0x9274: 'rgb etc2'
};
function getMaterialFormat(format) {
    return materialFormats[format];
}


const textureMagFilters = {
    0x2601: 'linear',
    0x2600: 'nearest'
};
function getTextureMagFilter(filter) {
    return textureMagFilters[filter];
}


const textureMinFilters = {
    0x2601: 'linear',
    0x2600: 'nearest',
    0x2700: 'nearest mipmap nearest',
    0x2701: 'linear mipmap nearest',
    0x2702: 'nearest mipmap linear',
    0x2703: 'linear mipmap linear',
};
function getTextureMinFilter(filter) {
    return textureMinFilters[filter];
}

const textureWrap = {
    0x2901: 'repeat',
    0x812F: 'clamp',
    0x8370: 'mirror'
};
function getTextureWrap(wrap) {
    return textureWrap[wrap];
}

const BUFFER_KEY = '__reshader_webgl_buffer';
const TEXTURE_KEY = '__reshader_webgl_tex';
// 避免重复创建webgl buffer
function getUniqueREGLBuffer(regl, data, options) {
    let array;
    if (isArray(data)) {
        if (data.buffer && data.byteOffset !== undefined) {
            array = data;
        }
    } else if (data.array && data.array.buffer && data.array.byteOffset !== undefined) {
        array = data.array;
    }
    if (!array) {
        return null;
    }
    const arrayBuffer = array.buffer;
    const byteOffset = array.byteOffset;
    if (!arrayBuffer[BUFFER_KEY]) {
        arrayBuffer[BUFFER_KEY] = {};
    }
    let buffer = arrayBuffer[BUFFER_KEY][byteOffset];
    if (!buffer) {
        const info = {};
        if (options)  {
            extend$1(info, options);
        }
        info.data = array;
        if (!info.type) {
            info.type = getArrayType(array);
        }
        buffer = regl.buffer(info);
        // console.log(count++, (array.byteLength / 1024 / 1024).toFixed(1));
        arrayBuffer[BUFFER_KEY][byteOffset] = buffer;
    }
    return buffer;
}

function getUniqueTexture(regl, texConfig) {
    const array = texConfig.data;
    if (!array || !array.buffer) {
        // 数据非类型数组，直接创建texture并返回
        return regl.texture(texConfig);
    }
    const arrayBuffer = array.buffer;
    const byteOffset = array.byteOffset;
    if (!arrayBuffer[TEXTURE_KEY]) {
        arrayBuffer[TEXTURE_KEY] = {};
    }
    let reglTex = arrayBuffer[TEXTURE_KEY][byteOffset];
    if (!reglTex) {
        reglTex = regl.texture(texConfig);
        arrayBuffer[TEXTURE_KEY][byteOffset] = reglTex;
    }
    return reglTex;
}

var REGLHelper = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getArrayType: getArrayType,
    getMaterialFormat: getMaterialFormat,
    getMaterialType: getMaterialType,
    getPrimitive: getPrimitive,
    getTextureMagFilter: getTextureMagFilter,
    getTextureMinFilter: getTextureMinFilter,
    getTextureWrap: getTextureWrap,
    getUniqueREGLBuffer: getUniqueREGLBuffer,
    getUniqueTexture: getUniqueTexture
});

const thresholdAngle = 0.8;
const VEC3_1 = [0, 0, 0], VEC3_2 = [0, 0, 0], NORMAL = [0, 0, 0], VERTEX_A = [], VERTEX_B = [], VERTEX_C = [];
const vertKeys = ['a', 'b', 'c'];
class EdgeGeometry extends Geometry {
    constructor(data, elements, count, desc) {
        super(data, elements, count, {
            primitive: getPrimitive(1),
            positionAttribute: desc.positionAttribute
        });
    }
    //@internal
    _getPosAttribute() {
        const pos = this.data[this.desc.positionAttribute];
        if (!pos.length) {
            return [];
        }
        const precisionPoints = 4;
        const precision = Math.pow(10, precisionPoints);
        const thresholdDot = Math.cos(Math.PI / 180 * thresholdAngle);
        const indexAttr = this.elements;
        const positionAttr = pos.length ? pos : pos.array;
        const indexCount = !indexAttr.length ? indexAttr : (indexAttr ? indexAttr.length : positionAttr.length / 3);
        const indexArr = [0, 0, 0];
        const hashes = new Array(3);
        const edgeData = {};
        const vertices = [];
        const triangle = new Triangle();
        for (let i = 0; i < indexCount; i += 3) {
            if (indexAttr.length) {
                indexArr[0] = indexAttr[i];
                indexArr[1] = indexAttr[i + 1];
                indexArr[2] = indexAttr[i + 2];
            }
            else {
                indexArr[0] = i;
                indexArr[1] = i + 1;
                indexArr[2] = i + 2;
            }
            triangle.a = setPositionValue(VERTEX_A, positionAttr, indexArr[0]);
            triangle.b = setPositionValue(VERTEX_B, positionAttr, indexArr[1]);
            triangle.c = setPositionValue(VERTEX_C, positionAttr, indexArr[2]);
            const normal = triangle.getNormal();
            const a = triangle.a, b = triangle.b, c = triangle.c;
            hashes[0] = `${Math.round(a[0] * precision)},${Math.round(a[1] * precision)},${Math.round(a[2] * precision)}`;
            hashes[1] = `${Math.round(b[0] * precision)},${Math.round(b[1] * precision)},${Math.round(b[2] * precision)}`;
            hashes[2] = `${Math.round(c[0] * precision)},${Math.round(c[1] * precision)},${Math.round(c[2] * precision)}`;
            if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) {
                continue;
            }
            for (let i = 0; i < 3; i++) {
                this._calEdgeData(i, indexArr, triangle, edgeData, hashes, thresholdDot, normal, vertices);
            }
        }
        for (const key in edgeData) {
            if (edgeData[key]) {
                const { index0, index1 } = edgeData[key];
                vertices.push(positionAttr[index0 * 3], positionAttr[index0 * 3 + 1], positionAttr[index0 * 3 + 2]);
                vertices.push(positionAttr[index1 * 3], positionAttr[index1 * 3 + 1], positionAttr[index1 * 3 + 2]);
            }
        }
        this.elements = this._createElements(vertices);
        return vertices;
    }
    //@internal
    _calEdgeData(index, indexArr, triangle, edgeData, hashes, thresholdDot, normal, vertices) {
        const next = (index + 1) % 3;
        const vecHash0 = hashes[index];
        const vecHash1 = hashes[next];
        const v0 = triangle[vertKeys[index]];
        const v1 = triangle[vertKeys[next]];
        const hash = `${vecHash0}_${vecHash1}`;
        const reverseHash = `${vecHash1}_${vecHash0}`;
        if (reverseHash in edgeData && edgeData[reverseHash]) {
            const thre = vec3.dot(normal, edgeData[reverseHash].normal);
            if (thre <= thresholdDot) {
                vertices.push(v0[0], v0[1], v0[2]);
                vertices.push(v1[0], v1[1], v1[2]);
            }
            edgeData[reverseHash] = null;
        }
        else if (!(hash in edgeData)) {
            edgeData[hash] = {
                index0: indexArr[index],
                index1: indexArr[next],
                normal: vec3.copy([0, 0, 0], normal),
            };
        }
    }
    //@internal
    _createElements(vertices) {
        const elements = [];
        const len = vertices.length / 3;
        for (let i = 0; i < len; i++) {
            elements.push(i);
        }
        return elements;
    }
}
class Triangle {
    constructor(a = [0, 0, 0], b = [0, 0, 0], c = [0, 0, 0]) {
        this.a = a;
        this.b = b;
        this.c = c;
    }
    getNormal() {
        const ab = vec3.sub(VEC3_1, this.a, this.b);
        const ac = vec3.sub(VEC3_2, this.a, this.c);
        vec3.cross(NORMAL, ab, ac);
        const len = vec3.length(NORMAL);
        return vec3.set(NORMAL, NORMAL[0] / len, NORMAL[1] / len, NORMAL[2] / len); //normalizd
    }
}
function setPositionValue(out, positionAttr, index) {
    return vec3.set(out, positionAttr[index * 3], positionAttr[index * 3 + 1], positionAttr[index * 3 + 2]);
}

class Base {
}
class Material extends Eventable(Base) {
    constructor(uniforms = {}, defaultUniforms) {
        super();
        this._version = 0;
        this._propVerion = 0;
        this._texVersion = 0;
        this.uniforms = extendWithoutNil({}, defaultUniforms || {}, uniforms);
        for (const p in uniforms) {
            const getter = Object.getOwnPropertyDescriptor(uniforms, p).get;
            if (getter) {
                Object.defineProperty(this.uniforms, p, {
                    get: getter
                });
            }
        }
        this.unlit = false;
        this._reglUniforms = {};
        this.refCount = 0;
        this._bindedOnTextureComplete = (...args) => {
            return this._onTextureComplete.call(this, ...args);
        };
        this._genUniformKeys();
        this._checkTextures();
    }
    set version(v) {
        throw new Error('Material.version is read only.');
    }
    get version() {
        return this._version;
    }
    get propVersion() {
        return this._propVerion;
    }
    get textureVersion() {
        return this._texVersion;
    }
    set doubleSided(value) {
        this.uniforms.doubleSided = value;
    }
    get doubleSided() {
        return !!this.uniforms.doubleSided;
    }
    getUniforms(device) {
        if (this._reglUniforms && !this.isDirty()) {
            return this._reglUniforms;
        }
        const uniforms = this.uniforms;
        const realUniforms = {};
        for (const p in uniforms) {
            if (this.isTexture(p)) {
                Object.defineProperty(realUniforms, p, {
                    enumerable: true,
                    configurable: true,
                    get: function () {
                        return uniforms[p].getREGLTexture(device);
                    }
                });
            }
            else {
                const descriptor = Object.getOwnPropertyDescriptor(uniforms, p);
                if (descriptor.get) {
                    Object.defineProperty(realUniforms, p, {
                        enumerable: true,
                        configurable: true,
                        get: function () {
                            return uniforms[p];
                        }
                    });
                }
                else {
                    realUniforms[p] = uniforms[p];
                }
            }
        }
        this._reglUniforms = realUniforms;
        this._uniformVer = this.version;
        return realUniforms;
    }
    getMemorySize() {
        const uniforms = this.uniforms;
        let size = 0;
        for (const p in uniforms) {
            if (this.isTexture(p)) {
                size += uniforms[p].getMemorySize();
            }
            else if (this.uniforms[p] && this.uniforms[p].destroy) {
                size += getTexMemorySize(this.uniforms[p]);
            }
        }
        return size;
    }
    isReady() {
        return this._loadingCount <= 0;
    }
    hasUniform(k) {
        return Object.prototype.hasOwnProperty.call(this.uniforms, k);
    }
    setUniform(k, v) {
        return this.set(k, v);
    }
    getUniform(k) {
        return this.get(k);
    }
    set(k, v, isDispose = true) {
        if (this.get(k) === v) {
            return this;
        }
        const dirty = isNil$2(this.uniforms[k]) && !isNil$2(v) ||
            !isNil$2(this.uniforms[k]) && isNil$2(v);
        if (this.uniforms[k] && this.isTexture(k) && isDispose) {
            this.uniforms[k].dispose();
        }
        if (!isNil$2(v)) {
            this.uniforms[k] = v;
            if (this._reglUniforms) {
                const descriptor = Object.getOwnPropertyDescriptor(this._reglUniforms, k);
                if (descriptor && !descriptor.get) {
                    this._propVerion++;
                    this._reglUniforms[k] = v;
                }
            }
        }
        else if (!isNil$2(this.uniforms[k])) {
            // dirty is true in this case
            delete this.uniforms[k];
        }
        if (this.isTexture(k)) {
            this._checkTextures();
            this._texVersion++;
        }
        if (dirty) {
            this._genUniformKeys();
            this._incrVersion();
        }
        return this;
    }
    setFunctionUniform(k, fn) {
        this._genUniformKeys();
        this._incrVersion();
        Object.defineProperty(this.uniforms, k, {
            enumerable: true,
            get: fn
        });
        return this;
    }
    hasFunctionUniform(k) {
        if (!this.uniforms) {
            return false;
        }
        return Object.prototype.hasOwnProperty.call(this.uniforms, k);
    }
    get(k) {
        return this.uniforms[k];
    }
    isDirty() {
        return this._uniformVer !== this.version;
    }
    /**
     * Get shader defines
     * @return {Object}
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    appendDefines(defines, _geometry) {
        const uniforms = this.uniforms;
        if (!uniforms) {
            return defines;
        }
        if (uniforms['jointTexture']) {
            defines['HAS_SKIN'] = 1;
        }
        if (uniforms['morphWeights1']) {
            defines['HAS_MORPH'] = 1;
        }
        if (uniforms['khr_offset'] || uniforms['khr_rotation'] || uniforms['khr_scale']) { //对纹理坐标转换的扩展的支持
            defines['HAS_KHR_TEXTURE_TRANSFORM'] = 1;
        }
        return defines;
    }
    hasSkinAnimation() {
        return !!(this.uniforms && this.uniforms['jointTexture'] && this.uniforms['skinAnimation']);
    }
    isTexture(k) {
        const v = this.uniforms[k];
        if (v instanceof AbstractTexture) {
            return true;
        }
        return false;
    }
    dispose() {
        for (const p in this.uniforms) {
            const u = this.uniforms[p];
            if (u) {
                if (u.dispose) {
                    u.dispose();
                }
                else if (u.destroy && !u[KEY_DISPOSED]) {
                    //a normal regl texture
                    u.destroy();
                    u[KEY_DISPOSED] = true;
                }
            }
        }
        delete this.uniforms;
        delete this._reglUniforms;
        delete this._bindedOnTextureComplete;
        this._disposed = true;
    }
    isDisposed() {
        return !!this._disposed;
    }
    //@internal
    _checkTextures() {
        this._loadingCount = 0;
        for (const p in this.uniforms) {
            if (this.isTexture(p)) {
                const texture = this.uniforms[p];
                if (!texture.isReady()) {
                    this._loadingCount++;
                    texture.on('complete', this._bindedOnTextureComplete);
                }
            }
        }
    }
    //@internal
    _onTextureComplete() {
        this._loadingCount--;
        this._incrVersion();
        if (this._loadingCount <= 0) {
            if (!this._disposed) {
                this.fire('complete');
            }
        }
    }
    getUniformKeys() {
        return this._uniformKeys;
    }
    //@internal
    _genUniformKeys() {
        const keys = [];
        for (const p in this.uniforms) {
            if (hasOwn$1(this.uniforms, p) && !isNil$2(this.uniforms[p])) {
                keys.push(p);
            }
        }
        this._uniformKeys = keys.join();
    }
    //@internal
    _incrVersion() {
        this._version++;
    }
}

const DEFAULT_UNIFORMS$4 = {
    'time': 0,
    'seeThrough': true,
    'thickness': 0.03,
    'fill': [1.0, 0.5137254902, 0.98, 1.0],
    'stroke': [0.7019607843, 0.9333333333, 0.2274509804, 1.0],
    'dashEnabled': false,
    'dashAnimate': false,
    'dashRepeats': 1,
    'dashLength': 0.8,
    'dashOverlap': true,
    'insideAltColor': false,
    'squeeze': false,
    'squeezeMin': 0.5,
    'squeezeMax': 1,
    'dualStroke': false,
    'secondThickness': 0.05,
    'opacity': 1.0,
    'noiseEnable': false
};
class WireFrameMaterial extends Material {
    constructor(uniforms) {
        super(uniforms, DEFAULT_UNIFORMS$4);
    }
}

const DEFAULT_UNIFORMS$3 = {
    'baseColorFactor': [1, 1, 1, 1],
    'materialShininess': 32.0,
    'environmentExposure': 1,
    'specularStrength': 32,
    'opacity': 1.0,
    'extrusionOpacity': 0,
    'extrusionOpacityRange': [0, 1.8],
    'baseColorTexture': null,
    'normalTexture': null,
    'emissiveTexture': null,
    'occlusionTexture': null,
    'uvScale': [1, 1],
    'uvOffset': [0, 0],
    'alphaTest': 0
};
class PhongMaterial extends Material {
    constructor(uniforms) {
        super(uniforms, DEFAULT_UNIFORMS$3);
    }
    static convertFrom(standardMaterial) {
        const matUniforms = {};
        for (const u in DEFAULT_UNIFORMS$3) {
            matUniforms[u] = standardMaterial.get(u);
        }
        return new PhongMaterial(matUniforms);
    }
    appendDefines(defines, geometry) {
        super.appendDefines(defines, geometry);
        const uniforms = this.uniforms;
        const position = geometry.data[geometry.desc.positionAttribute];
        const positionItemType = position && position.buffer && position.buffer.itemType;
        if (positionItemType) {
            if (positionItemType.startsWith('sint')) {
                defines['POSITION_IS_INT'] = 1;
            }
            else if (positionItemType.startsWith('uint')) {
                defines['POSITION_IS_UINT'] = 1;
            }
        }
        const normal = geometry.data[geometry.desc.normalAttribute];
        const normalItemType = normal && normal.buffer && normal.buffer.itemType;
        if (normalItemType) {
            if (normalItemType.startsWith('sint')) {
                defines['NORMAL_IS_INT'] = 1;
            }
            else if (normalItemType.startsWith('uint')) {
                defines['NORMAL_IS_UINT'] = 1;
            }
        }
        if (this.unlit) {
            defines['SHADING_MODEL_UNLIT'] = 1;
        }
        if (uniforms['extrusionOpacity']) {
            defines['HAS_EXTRUSION_OPACITY'] = 1;
        }
        if (geometry.data[geometry.desc.colorAttribute]) {
            defines['HAS_COLOR'] = 1;
        }
        const color0 = geometry.data[geometry.desc.color0Attribute];
        if (color0) {
            defines['HAS_COLOR0'] = 1;
            defines['COLOR0_SIZE'] = geometry.getColor0Size();
        }
        if (geometry.data['aVertexColorType']) {
            defines['HAS_VERTEX_COLOR'] = 1;
        }
        if (geometry.data[geometry.desc.tangentAttribute]) {
            defines['HAS_TANGENT'] = 1;
        }
        else if (geometry.data[geometry.desc.normalAttribute]) {
            defines['HAS_NORMAL'] = 1;
        }
        if (!geometry.data[geometry.desc.uv0Attribute]) {
            return defines;
        }
        if (uniforms['baseColorTexture']) {
            defines['HAS_BASECOLOR_MAP'] = 1;
        }
        if (uniforms['occlusionTexture'] && geometry.data[geometry.desc['uv1Attribute']]) {
            defines['HAS_AO_MAP'] = 1;
        }
        if (uniforms['emissiveTexture']) {
            defines['HAS_EMISSIVE_MAP'] = 1;
        }
        if (uniforms['normalTexture']) {
            defines['HAS_NORMAL_MAP'] = 1;
        }
        if (defines['HAS_BASECOLOR_MAP'] ||
            defines['HAS_AO_MAP'] ||
            defines['HAS_EMISSIVE_MAP'] ||
            defines['HAS_NORMAL_MAP']) {
            defines['HAS_MAP'] = 1;
        }
        return defines;
    }
}

const DEFAULT_UNIFORMS$2 = {
    'baseColorFactor': [1, 1, 1, 1],
    'uvScale': [1, 1],
    'uvOffset': [0, 0],
    'opacity': 1,
    'envMapExposure': 128,
    'emissiveFactor': [0.1, 0.1, 0.1],
    'specularFactor': [0, 0, 0],
    'envRotationSin': 0,
    'envRotationCos': 1,
    'reflectivity': 0.01,
    'themingColor': [0, 0, 0, 0],
    'exposureBias': 0.6
};
class StandardLiteMaterial extends Material {
    constructor(uniforms) {
        super(uniforms, DEFAULT_UNIFORMS$2);
    }
    appendDefines(defines, geometry) {
        super.appendDefines(defines, geometry);
        const uniforms = this.uniforms;
        if (uniforms['extrusionOpacity']) {
            defines['HAS_EXTRUSION_OPACITY'] = 1;
        }
        if (geometry.data[geometry.desc.colorAttribute]) {
            defines['HAS_COLOR'] = 1;
        }
        const color0 = geometry.data[geometry.desc.color0Attribute];
        if (color0) {
            defines['HAS_COLOR0'] = 1;
            defines['COLOR0_SIZE'] = geometry.getColor0Size();
        }
        if (!geometry.data[geometry.desc.uv0Attribute]) {
            return defines;
        }
        if (uniforms['baseColorTexture']) {
            defines['HAS_BASECOLOR_MAP'] = 1;
        }
        if (uniforms['occlusionTexture'] && geometry.data[geometry.desc['uv1Attribute']]) {
            defines['HAS_AO_MAP'] = 1;
        }
        if (uniforms['emissiveTexture']) {
            defines['HAS_EMISSIVE_MAP'] = 1;
        }
        if (uniforms['normalTexture']) {
            defines['HAS_NORMAL_MAP'] = 1;
        }
        if (defines['HAS_BASECOLOR_MAP'] ||
            defines['HAS_AO_MAP'] ||
            defines['HAS_EMISSIVE_MAP'] ||
            defines['HAS_NORMAL_MAP']) {
            defines['HAS_MAP'] = 1;
        }
        defines['ALPHATEST'] = 0.01;
        defines['GAMMA_INPUT'] = 1;
        defines['GAMMA_FACTOR'] = 1;
        defines['TONEMAP_OUTPUT'] = 1;
        defines['ENVMAP_MODE_REFLECTION'] = 1;
        defines['ENV_RGBM'] = 1;
        defines['IRR_RGBM'] = 1;
        return defines;
    }
}

const DEFAULT_UNIFORMS$1 = {
    //KHR_materials_pbrSpecularGlossiness
    'diffuseFactor': [1, 1, 1, 1],
    'specularFactor': [1, 1, 1],
    'glossinessFactor': 1,
    'diffuseTexture': null,
    'specularGlossinessTexture': null,
    'normalTexture': null,
    'emissiveTexture': null,
    'occlusionTexture': null,
};
function SpecularGlossinessMixin (Base) {
    return class SpecularGlossinessMixin extends Base {
        constructor(...args) {
            let uniforms = args[0];
            uniforms = extend$1({}, DEFAULT_UNIFORMS$1, uniforms || {});
            super(uniforms, args);
        }
        appendDefines(defines, geometry) {
            //@ts-expect-error 该方法只会由Material的子类调用，所以 super 一定是 Material
            super.appendDefines(defines, geometry);
            defines['SHADING_MODEL_SPECULAR_GLOSSINESS'] = 1;
            if (!geometry.data[geometry.desc.uv0Attribute]) {
                return defines;
            }
            const uniforms = this.uniforms;
            if (uniforms['diffuseTexture']) {
                defines['HAS_DIFFUSE_MAP'] = 1;
            }
            if (uniforms['specularGlossinessTexture']) {
                defines['HAS_SPECULARGLOSSINESS_MAP'] = 1;
            }
            if (defines['HAS_SPECULARGLOSSINESS_MAP'] ||
                defines['HAS_DIFFUSE_MAP']) {
                defines['HAS_MAP'] = 1;
            }
            return defines;
        }
    };
}

class PhongSpecularGlossinessMaterial extends SpecularGlossinessMixin(PhongMaterial) {
}

class ParseContext {
    constructor() {
        this.constants = new Map();
        this.aliases = new Map();
        this.structs = new Map();
    }
}
/**
 * @class Node
 * @category AST
 * Base class for AST nodes parsed from a WGSL shader.
 */
class Node {
    constructor() { }
    get isAstNode() {
        return true;
    }
    get astNodeType() {
        return "";
    }
    evaluate(context) {
        throw new Error("Cannot evaluate node");
    }
    evaluateString(context) {
        return this.evaluate(context).toString();
    }
    search(callback) { }
    searchBlock(block, callback) {
        if (block) {
            callback(_BlockStart.instance);
            for (const node of block) {
                if (node instanceof Array) {
                    this.searchBlock(node, callback);
                }
                else {
                    node.search(callback);
                }
            }
            callback(_BlockEnd.instance);
        }
    }
}
// For internal use only
class _BlockStart extends Node {
}
_BlockStart.instance = new _BlockStart();
// For internal use only
class _BlockEnd extends Node {
}
_BlockEnd.instance = new _BlockEnd();
/**
 * @class Statement
 * @extends Node
 * @category AST
 */
class Statement extends Node {
    constructor() {
        super();
    }
}
/**
 * @class Function
 * @extends Statement
 * @category AST
 */
let Function$1 = class Function extends Statement {
    constructor(name, args, returnType, body, startLine, endLine) {
        super();
        this.calls = new Set();
        this.name = name;
        this.args = args;
        this.returnType = returnType;
        this.body = body;
        this.startLine = startLine;
        this.endLine = endLine;
    }
    get astNodeType() {
        return "function";
    }
    search(callback) {
        this.searchBlock(this.body, callback);
    }
};
/**
 * @class StaticAssert
 * @extends Statement
 * @category AST
 */
class StaticAssert extends Statement {
    constructor(expression) {
        super();
        this.expression = expression;
    }
    get astNodeType() {
        return "staticAssert";
    }
    search(callback) {
        this.expression.search(callback);
    }
}
/**
 * @class While
 * @extends Statement
 * @category AST
 */
class While extends Statement {
    constructor(condition, body) {
        super();
        this.condition = condition;
        this.body = body;
    }
    get astNodeType() {
        return "while";
    }
    search(callback) {
        this.condition.search(callback);
        this.searchBlock(this.body, callback);
    }
}
/**
 * @class Continuing
 * @extends Statement
 * @category AST
 */
class Continuing extends Statement {
    constructor(body) {
        super();
        this.body = body;
    }
    get astNodeType() {
        return "continuing";
    }
    search(callback) {
        this.searchBlock(this.body, callback);
    }
}
/**
 * @class For
 * @extends Statement
 * @category AST
 */
class For extends Statement {
    constructor(init, condition, increment, body) {
        super();
        this.init = init;
        this.condition = condition;
        this.increment = increment;
        this.body = body;
    }
    get astNodeType() {
        return "for";
    }
    search(callback) {
        var _a, _b, _c;
        (_a = this.init) === null || _a === void 0 ? void 0 : _a.search(callback);
        (_b = this.condition) === null || _b === void 0 ? void 0 : _b.search(callback);
        (_c = this.increment) === null || _c === void 0 ? void 0 : _c.search(callback);
        this.searchBlock(this.body, callback);
    }
}
/**
 * @class Var
 * @extends Statement
 * @category AST
 */
class Var extends Statement {
    constructor(name, type, storage, access, value) {
        super();
        this.name = name;
        this.type = type;
        this.storage = storage;
        this.access = access;
        this.value = value;
    }
    get astNodeType() {
        return "var";
    }
    search(callback) {
        var _a;
        callback(this);
        (_a = this.value) === null || _a === void 0 ? void 0 : _a.search(callback);
    }
}
/**
 * @class Override
 * @extends Statement
 * @category AST
 */
class Override extends Statement {
    constructor(name, type, value) {
        super();
        this.name = name;
        this.type = type;
        this.value = value;
    }
    get astNodeType() {
        return "override";
    }
    search(callback) {
        var _a;
        (_a = this.value) === null || _a === void 0 ? void 0 : _a.search(callback);
    }
}
/**
 * @class Let
 * @extends Statement
 * @category AST
 */
class Let extends Statement {
    constructor(name, type, storage, access, value) {
        super();
        this.name = name;
        this.type = type;
        this.storage = storage;
        this.access = access;
        this.value = value;
    }
    get astNodeType() {
        return "let";
    }
    search(callback) {
        var _a;
        callback(this);
        (_a = this.value) === null || _a === void 0 ? void 0 : _a.search(callback);
    }
}
/**
 * @class Const
 * @extends Statement
 * @category AST
 */
class Const extends Statement {
    constructor(name, type, storage, access, value) {
        super();
        this.name = name;
        this.type = type;
        this.storage = storage;
        this.access = access;
        this.value = value;
    }
    get astNodeType() {
        return "const";
    }
    evaluate(context) {
        return this.value.evaluate(context);
    }
    search(callback) {
        var _a;
        callback(this);
        (_a = this.value) === null || _a === void 0 ? void 0 : _a.search(callback);
    }
}
var IncrementOperator;
(function (IncrementOperator) {
    IncrementOperator["increment"] = "++";
    IncrementOperator["decrement"] = "--";
})(IncrementOperator || (IncrementOperator = {}));
(function (IncrementOperator) {
    function parse(val) {
        const key = val;
        if (key == "parse")
            throw new Error("Invalid value for IncrementOperator");
        return IncrementOperator[key];
    }
    IncrementOperator.parse = parse;
})(IncrementOperator || (IncrementOperator = {}));
/**
 * @class Increment
 * @extends Statement
 * @category AST
 */
class Increment extends Statement {
    constructor(operator, variable) {
        super();
        this.operator = operator;
        this.variable = variable;
    }
    get astNodeType() {
        return "increment";
    }
    search(callback) {
        this.variable.search(callback);
    }
}
var AssignOperator;
(function (AssignOperator) {
    AssignOperator["assign"] = "=";
    AssignOperator["addAssign"] = "+=";
    AssignOperator["subtractAssin"] = "-=";
    AssignOperator["multiplyAssign"] = "*=";
    AssignOperator["divideAssign"] = "/=";
    AssignOperator["moduloAssign"] = "%=";
    AssignOperator["andAssign"] = "&=";
    AssignOperator["orAssign"] = "|=";
    AssignOperator["xorAssign"] = "^=";
    AssignOperator["shiftLeftAssign"] = "<<=";
    AssignOperator["shiftRightAssign"] = ">>=";
})(AssignOperator || (AssignOperator = {}));
(function (AssignOperator) {
    function parse(val) {
        const key = val;
        if (key == "parse") {
            throw new Error("Invalid value for AssignOperator");
        }
        //return AssignOperator[key];
        return key;
    }
    AssignOperator.parse = parse;
})(AssignOperator || (AssignOperator = {}));
/**
 * @class Assign
 * @extends Statement
 * @category AST
 */
class Assign extends Statement {
    constructor(operator, variable, value) {
        super();
        this.operator = operator;
        this.variable = variable;
        this.value = value;
    }
    get astNodeType() {
        return "assign";
    }
    search(callback) {
        this.variable.search(callback);
        this.value.search(callback);
    }
}
/**
 * @class Call
 * @extends Statement
 * @category AST
 */
class Call extends Statement {
    constructor(name, args) {
        super();
        this.name = name;
        this.args = args;
    }
    get astNodeType() {
        return "call";
    }
    search(callback) {
        for (const node of this.args) {
            node.search(callback);
        }
        callback(this);
    }
}
/**
 * @class Loop
 * @extends Statement
 * @category AST
 */
class Loop extends Statement {
    constructor(body, continuing) {
        super();
        this.body = body;
        this.continuing = continuing;
    }
    get astNodeType() {
        return "loop";
    }
}
/**
 * @class Switch
 * @extends Statement
 * @category AST
 */
class Switch extends Statement {
    constructor(condition, body) {
        super();
        this.condition = condition;
        this.body = body;
    }
    get astNodeType() {
        return "body";
    }
}
/**
 * @class If
 * @extends Statement
 * @category AST
 */
class If extends Statement {
    constructor(condition, body, elseif, _else) {
        super();
        this.condition = condition;
        this.body = body;
        this.elseif = elseif;
        this.else = _else;
    }
    get astNodeType() {
        return "if";
    }
    search(callback) {
        this.condition.search(callback);
        this.searchBlock(this.body, callback);
        this.searchBlock(this.elseif, callback);
        this.searchBlock(this.else, callback);
    }
}
/**
 * @class Return
 * @extends Statement
 * @category AST
 */
class Return extends Statement {
    constructor(value) {
        super();
        this.value = value;
    }
    get astNodeType() {
        return "return";
    }
    search(callback) {
        var _a;
        (_a = this.value) === null || _a === void 0 ? void 0 : _a.search(callback);
    }
}
/**
 * @class Enable
 * @extends Statement
 * @category AST
 */
class Enable extends Statement {
    constructor(name) {
        super();
        this.name = name;
    }
    get astNodeType() {
        return "enable";
    }
}
/**
 * @class Requires
 * @extends Statement
 * @category AST
 */
class Requires extends Statement {
    constructor(extensions) {
        super();
        this.extensions = extensions;
    }
    get astNodeType() {
        return "requires";
    }
}
/**
 * @class Diagnostic
 * @extends Statement
 * @category AST
 */
class Diagnostic extends Statement {
    constructor(severity, rule) {
        super();
        this.severity = severity;
        this.rule = rule;
    }
    get astNodeType() {
        return "diagnostic";
    }
}
/**
 * @class Alias
 * @extends Statement
 * @category AST
 */
class Alias extends Statement {
    constructor(name, type) {
        super();
        this.name = name;
        this.type = type;
    }
    get astNodeType() {
        return "alias";
    }
}
/**
 * @class Discard
 * @extends Statement
 * @category AST
 */
class Discard extends Statement {
    constructor() {
        super();
    }
    get astNodeType() {
        return "discard";
    }
}
/**
 * @class Break
 * @extends Statement
 * @category AST
 */
class Break extends Statement {
    constructor() {
        super();
    }
    get astNodeType() {
        return "break";
    }
}
/**
 * @class Continue
 * @extends Statement
 * @category AST
 */
class Continue extends Statement {
    constructor() {
        super();
    }
    get astNodeType() {
        return "continue";
    }
}
/**
 * @class Type
 * @extends Statement
 * @category AST
 */
class Type extends Statement {
    constructor(name) {
        super();
        this.name = name;
    }
    get astNodeType() {
        return "type";
    }
    get isStruct() {
        return false;
    }
    get isArray() {
        return false;
    }
}
/**
 * @class StructType
 * @extends Type
 * @category AST
 */
class Struct extends Type {
    constructor(name, members, startLine, endLine) {
        super(name);
        this.members = members;
        this.startLine = startLine;
        this.endLine = endLine;
    }
    get astNodeType() {
        return "struct";
    }
    get isStruct() {
        return true;
    }
    /// Return the index of the member with the given name, or -1 if not found.
    getMemberIndex(name) {
        for (let i = 0; i < this.members.length; i++) {
            if (this.members[i].name == name)
                return i;
        }
        return -1;
    }
}
/**
 * @class TemplateType
 * @extends Type
 * @category AST
 */
class TemplateType extends Type {
    constructor(name, format, access) {
        super(name);
        this.format = format;
        this.access = access;
    }
    get astNodeType() {
        return "template";
    }
}
/**
 * @class PointerType
 * @extends Type
 * @category AST
 */
class PointerType extends Type {
    constructor(name, storage, type, access) {
        super(name);
        this.storage = storage;
        this.type = type;
        this.access = access;
    }
    get astNodeType() {
        return "pointer";
    }
}
/**
 * @class ArrayType
 * @extends Type
 * @category AST
 */
class ArrayType extends Type {
    constructor(name, attributes, format, count) {
        super(name);
        this.attributes = attributes;
        this.format = format;
        this.count = count;
    }
    get astNodeType() {
        return "array";
    }
    get isArray() {
        return true;
    }
}
/**
 * @class SamplerType
 * @extends Type
 * @category AST
 */
class SamplerType extends Type {
    constructor(name, format, access) {
        super(name);
        this.format = format;
        this.access = access;
    }
    get astNodeType() {
        return "sampler";
    }
}
/**
 * @class Expression
 * @extends Node
 * @category AST
 */
class Expression extends Node {
    constructor() {
        super();
    }
}
/**
 * @class StringExpr
 * @extends Expression
 * @category AST
 */
class StringExpr extends Expression {
    constructor(value) {
        super();
        this.value = value;
    }
    get astNodeType() {
        return "stringExpr";
    }
    toString() {
        return this.value;
    }
    evaluateString() {
        return this.value;
    }
}
/**
 * @class CreateExpr
 * @extends Expression
 * @category AST
 */
class CreateExpr extends Expression {
    constructor(type, args) {
        super();
        this.type = type;
        this.args = args;
    }
    get astNodeType() {
        return "createExpr";
    }
    search(callback) {
        callback(this);
        if (this.args) {
            for (const node of this.args) {
                node.search(callback);
            }
        }
    }
    evaluate(context) {
        return this.args[0].evaluate(context);
    }
}
/**
 * @class CallExpr
 * @extends Expression
 * @category AST
 */
class CallExpr extends Expression {
    constructor(name, args) {
        super();
        this.name = name;
        this.args = args;
    }
    get astNodeType() {
        return "callExpr";
    }
    evaluate(context) {
        switch (this.name) {
            case "abs":
                return Math.abs(this.args[0].evaluate(context));
            case "acos":
                return Math.acos(this.args[0].evaluate(context));
            case "acosh":
                return Math.acosh(this.args[0].evaluate(context));
            case "asin":
                return Math.asin(this.args[0].evaluate(context));
            case "asinh":
                return Math.asinh(this.args[0].evaluate(context));
            case "atan":
                return Math.atan(this.args[0].evaluate(context));
            case "atan2":
                return Math.atan2(this.args[0].evaluate(context), this.args[1].evaluate(context));
            case "atanh":
                return Math.atanh(this.args[0].evaluate(context));
            case "ceil":
                return Math.ceil(this.args[0].evaluate(context));
            case "clamp":
                return Math.min(Math.max(this.args[0].evaluate(context), this.args[1].evaluate(context)), this.args[2].evaluate(context));
            case "cos":
                return Math.cos(this.args[0].evaluate(context));
            //case "cross":
            //TODO: (x[i] * y[j] - x[j] * y[i])
            case "degrees":
                return (this.args[0].evaluate(context) * 180) / Math.PI;
            //case "determinant":
            //TODO implement
            case "distance":
                return Math.sqrt(Math.pow(this.args[0].evaluate(context) - this.args[1].evaluate(context), 2));
            case "dot":
            //TODO: (x[i] * y[i])
            case "exp":
                return Math.exp(this.args[0].evaluate(context));
            case "exp2":
                return Math.pow(2, this.args[0].evaluate(context));
            //case "extractBits":
            //TODO: implement
            //case "firstLeadingBit":
            //TODO: implement
            case "floor":
                return Math.floor(this.args[0].evaluate(context));
            case "fma":
                return (this.args[0].evaluate(context) * this.args[1].evaluate(context) +
                    this.args[2].evaluate(context));
            case "fract":
                return (this.args[0].evaluate(context) -
                    Math.floor(this.args[0].evaluate(context)));
            //case "frexp":
            //TODO: implement
            case "inverseSqrt":
                return 1 / Math.sqrt(this.args[0].evaluate(context));
            //case "length":
            //TODO: implement
            case "log":
                return Math.log(this.args[0].evaluate(context));
            case "log2":
                return Math.log2(this.args[0].evaluate(context));
            case "max":
                return Math.max(this.args[0].evaluate(context), this.args[1].evaluate(context));
            case "min":
                return Math.min(this.args[0].evaluate(context), this.args[1].evaluate(context));
            case "mix":
                return (this.args[0].evaluate(context) *
                    (1 - this.args[2].evaluate(context)) +
                    this.args[1].evaluate(context) * this.args[2].evaluate(context));
            case "modf":
                return (this.args[0].evaluate(context) -
                    Math.floor(this.args[0].evaluate(context)));
            case "pow":
                return Math.pow(this.args[0].evaluate(context), this.args[1].evaluate(context));
            case "radians":
                return (this.args[0].evaluate(context) * Math.PI) / 180;
            case "round":
                return Math.round(this.args[0].evaluate(context));
            case "sign":
                return Math.sign(this.args[0].evaluate(context));
            case "sin":
                return Math.sin(this.args[0].evaluate(context));
            case "sinh":
                return Math.sinh(this.args[0].evaluate(context));
            case "saturate":
                return Math.min(Math.max(this.args[0].evaluate(context), 0), 1);
            case "smoothstep":
                return (this.args[0].evaluate(context) *
                    this.args[0].evaluate(context) *
                    (3 - 2 * this.args[0].evaluate(context)));
            case "sqrt":
                return Math.sqrt(this.args[0].evaluate(context));
            case "step":
                return this.args[0].evaluate(context) < this.args[1].evaluate(context)
                    ? 0
                    : 1;
            case "tan":
                return Math.tan(this.args[0].evaluate(context));
            case "tanh":
                return Math.tanh(this.args[0].evaluate(context));
            case "trunc":
                return Math.trunc(this.args[0].evaluate(context));
            default:
                throw new Error("Non const function: " + this.name);
        }
    }
    search(callback) {
        for (const node of this.args) {
            node.search(callback);
        }
        callback(this);
    }
}
/**
 * @class VariableExpr
 * @extends Expression
 * @category AST
 */
class VariableExpr extends Expression {
    constructor(name) {
        super();
        this.name = name;
    }
    get astNodeType() {
        return "varExpr";
    }
    search(callback) {
        callback(this);
        if (this.postfix) {
            this.postfix.search(callback);
        }
    }
    evaluate(context) {
        const constant = context.constants.get(this.name);
        if (!constant) {
            throw new Error("Cannot evaluate node");
        }
        return constant.evaluate(context);
    }
}
/**
 * @class ConstExpr
 * @extends Expression
 * @category AST
 */
class ConstExpr extends Expression {
    constructor(name, initializer) {
        super();
        this.name = name;
        this.initializer = initializer;
    }
    get astNodeType() {
        return "constExpr";
    }
    evaluate(context) {
        var _a, _b;
        if (this.initializer instanceof CreateExpr) {
            // This is a struct constant
            const property = (_a = this.postfix) === null || _a === void 0 ? void 0 : _a.evaluateString(context);
            const type = (_b = this.initializer.type) === null || _b === void 0 ? void 0 : _b.name;
            const struct = context.structs.get(type);
            const memberIndex = struct === null || struct === void 0 ? void 0 : struct.getMemberIndex(property);
            if (memberIndex !== undefined && memberIndex != -1) {
                const value = this.initializer.args[memberIndex].evaluate(context);
                return value;
            }
            else {
                return this.initializer.evaluate(context);
            }
        }
        return this.initializer.evaluate(context);
    }
    search(callback) {
        this.initializer.search(callback);
    }
}
/**
 * @class LiteralExpr
 * @extends Expression
 * @category AST
 */
class LiteralExpr extends Expression {
    constructor(value) {
        super();
        this.value = value;
    }
    get astNodeType() {
        return "literalExpr";
    }
    evaluate() {
        return this.value;
    }
}
/**
 * @class BitcastExpr
 * @extends Expression
 * @category AST
 */
class BitcastExpr extends Expression {
    constructor(type, value) {
        super();
        this.type = type;
        this.value = value;
    }
    get astNodeType() {
        return "bitcastExpr";
    }
    search(callback) {
        this.value.search(callback);
    }
}
/**
 * @class GroupingExpr
 * @extends Expression
 * @category AST
 */
class GroupingExpr extends Expression {
    constructor(contents) {
        super();
        this.contents = contents;
    }
    get astNodeType() {
        return "groupExpr";
    }
    evaluate(context) {
        return this.contents[0].evaluate(context);
    }
    search(callback) {
        this.searchBlock(this.contents, callback);
    }
}
/**
 * @class ArrayIndex
 * @extends Expression
 * @category AST
 */
class ArrayIndex extends Expression {
    constructor(index) {
        super();
        this.index = index;
    }
    search(callback) {
        this.index.search(callback);
    }
}
/**
 * @class Operator
 * @extends Expression
 * @category AST
 */
class Operator extends Expression {
    constructor() {
        super();
    }
}
/**
 * @class UnaryOperator
 * @extends Operator
 * @category AST
 * @property {string} operator +, -, !, ~
 */
class UnaryOperator extends Operator {
    constructor(operator, right) {
        super();
        this.operator = operator;
        this.right = right;
    }
    get astNodeType() {
        return "unaryOp";
    }
    evaluate(context) {
        switch (this.operator) {
            case "+":
                return this.right.evaluate(context);
            case "-":
                return -this.right.evaluate(context);
            case "!":
                return this.right.evaluate(context) ? 0 : 1;
            case "~":
                return ~this.right.evaluate(context);
            default:
                throw new Error("Unknown unary operator: " + this.operator);
        }
    }
    search(callback) {
        this.right.search(callback);
    }
}
/**
 * @class BinaryOperator
 * @extends Operator
 * @category AST
 * @property {string} operator +, -, *, /, %, ==, !=, <, >, <=, >=, &&, ||
 */
class BinaryOperator extends Operator {
    constructor(operator, left, right) {
        super();
        this.operator = operator;
        this.left = left;
        this.right = right;
    }
    get astNodeType() {
        return "binaryOp";
    }
    evaluate(context) {
        switch (this.operator) {
            case "+":
                return this.left.evaluate(context) + this.right.evaluate(context);
            case "-":
                return this.left.evaluate(context) - this.right.evaluate(context);
            case "*":
                return this.left.evaluate(context) * this.right.evaluate(context);
            case "/":
                return this.left.evaluate(context) / this.right.evaluate(context);
            case "%":
                return this.left.evaluate(context) % this.right.evaluate(context);
            case "==":
                return this.left.evaluate(context) == this.right.evaluate(context)
                    ? 1
                    : 0;
            case "!=":
                return this.left.evaluate(context) != this.right.evaluate(context)
                    ? 1
                    : 0;
            case "<":
                return this.left.evaluate(context) < this.right.evaluate(context)
                    ? 1
                    : 0;
            case ">":
                return this.left.evaluate(context) > this.right.evaluate(context)
                    ? 1
                    : 0;
            case "<=":
                return this.left.evaluate(context) <= this.right.evaluate(context)
                    ? 1
                    : 0;
            case ">=":
                return this.left.evaluate(context) >= this.right.evaluate(context)
                    ? 1
                    : 0;
            case "&&":
                return this.left.evaluate(context) && this.right.evaluate(context)
                    ? 1
                    : 0;
            case "||":
                return this.left.evaluate(context) || this.right.evaluate(context)
                    ? 1
                    : 0;
            default:
                throw new Error(`Unknown operator ${this.operator}`);
        }
    }
    search(callback) {
        this.left.search(callback);
        this.right.search(callback);
    }
}
/**
 * @class SwitchCase
 * @extends Node
 * @category AST
 */
class SwitchCase extends Node {
    constructor() {
        super();
    }
}
/**
 * @class Case
 * @extends SwitchCase
 * @category AST
 */
class Case extends SwitchCase {
    constructor(selector, body) {
        super();
        this.selector = selector;
        this.body = body;
    }
    get astNodeType() {
        return "case";
    }
    search(callback) {
        this.searchBlock(this.body, callback);
    }
}
/**
 * @class Default
 * @extends SwitchCase
 * @category AST
 */
class Default extends SwitchCase {
    constructor(body) {
        super();
        this.body = body;
    }
    get astNodeType() {
        return "default";
    }
    search(callback) {
        this.searchBlock(this.body, callback);
    }
}
/**
 * @class Argument
 * @extends Node
 * @category AST
 */
class Argument extends Node {
    constructor(name, type, attributes) {
        super();
        this.name = name;
        this.type = type;
        this.attributes = attributes;
    }
    get astNodeType() {
        return "argument";
    }
}
/**
 * @class ElseIf
 * @extends Node
 * @category AST
 */
class ElseIf extends Node {
    constructor(condition, body) {
        super();
        this.condition = condition;
        this.body = body;
    }
    get astNodeType() {
        return "elseif";
    }
    search(callback) {
        this.condition.search(callback);
        this.searchBlock(this.body, callback);
    }
}
/**
 * @class Member
 * @extends Node
 * @category AST
 */
class Member extends Node {
    constructor(name, type, attributes) {
        super();
        this.name = name;
        this.type = type;
        this.attributes = attributes;
    }
    get astNodeType() {
        return "member";
    }
}
/**
 * @class Attribute
 * @extends Node
 * @category AST
 */
class Attribute extends Node {
    constructor(name, value) {
        super();
        this.name = name;
        this.value = value;
    }
    get astNodeType() {
        return "attribute";
    }
}

var _a;
var TokenClass;
(function (TokenClass) {
    TokenClass[TokenClass["token"] = 0] = "token";
    TokenClass[TokenClass["keyword"] = 1] = "keyword";
    TokenClass[TokenClass["reserved"] = 2] = "reserved";
})(TokenClass || (TokenClass = {}));
class TokenType {
    constructor(name, type, rule) {
        this.name = name;
        this.type = type;
        this.rule = rule;
    }
    toString() {
        return this.name;
    }
}
/// Catalog of defined token types, keywords, and reserved words.
class TokenTypes {
}
_a = TokenTypes;
TokenTypes.none = new TokenType("", TokenClass.reserved, "");
TokenTypes.eof = new TokenType("EOF", TokenClass.token, "");
TokenTypes.reserved = {
    asm: new TokenType("asm", TokenClass.reserved, "asm"),
    bf16: new TokenType("bf16", TokenClass.reserved, "bf16"),
    do: new TokenType("do", TokenClass.reserved, "do"),
    enum: new TokenType("enum", TokenClass.reserved, "enum"),
    f16: new TokenType("f16", TokenClass.reserved, "f16"),
    f64: new TokenType("f64", TokenClass.reserved, "f64"),
    handle: new TokenType("handle", TokenClass.reserved, "handle"),
    i8: new TokenType("i8", TokenClass.reserved, "i8"),
    i16: new TokenType("i16", TokenClass.reserved, "i16"),
    i64: new TokenType("i64", TokenClass.reserved, "i64"),
    mat: new TokenType("mat", TokenClass.reserved, "mat"),
    premerge: new TokenType("premerge", TokenClass.reserved, "premerge"),
    regardless: new TokenType("regardless", TokenClass.reserved, "regardless"),
    typedef: new TokenType("typedef", TokenClass.reserved, "typedef"),
    u8: new TokenType("u8", TokenClass.reserved, "u8"),
    u16: new TokenType("u16", TokenClass.reserved, "u16"),
    u64: new TokenType("u64", TokenClass.reserved, "u64"),
    unless: new TokenType("unless", TokenClass.reserved, "unless"),
    using: new TokenType("using", TokenClass.reserved, "using"),
    vec: new TokenType("vec", TokenClass.reserved, "vec"),
    void: new TokenType("void", TokenClass.reserved, "void"),
};
TokenTypes.keywords = {
    array: new TokenType("array", TokenClass.keyword, "array"),
    atomic: new TokenType("atomic", TokenClass.keyword, "atomic"),
    bool: new TokenType("bool", TokenClass.keyword, "bool"),
    f32: new TokenType("f32", TokenClass.keyword, "f32"),
    i32: new TokenType("i32", TokenClass.keyword, "i32"),
    mat2x2: new TokenType("mat2x2", TokenClass.keyword, "mat2x2"),
    mat2x3: new TokenType("mat2x3", TokenClass.keyword, "mat2x3"),
    mat2x4: new TokenType("mat2x4", TokenClass.keyword, "mat2x4"),
    mat3x2: new TokenType("mat3x2", TokenClass.keyword, "mat3x2"),
    mat3x3: new TokenType("mat3x3", TokenClass.keyword, "mat3x3"),
    mat3x4: new TokenType("mat3x4", TokenClass.keyword, "mat3x4"),
    mat4x2: new TokenType("mat4x2", TokenClass.keyword, "mat4x2"),
    mat4x3: new TokenType("mat4x3", TokenClass.keyword, "mat4x3"),
    mat4x4: new TokenType("mat4x4", TokenClass.keyword, "mat4x4"),
    ptr: new TokenType("ptr", TokenClass.keyword, "ptr"),
    sampler: new TokenType("sampler", TokenClass.keyword, "sampler"),
    sampler_comparison: new TokenType("sampler_comparison", TokenClass.keyword, "sampler_comparison"),
    struct: new TokenType("struct", TokenClass.keyword, "struct"),
    texture_1d: new TokenType("texture_1d", TokenClass.keyword, "texture_1d"),
    texture_2d: new TokenType("texture_2d", TokenClass.keyword, "texture_2d"),
    texture_2d_array: new TokenType("texture_2d_array", TokenClass.keyword, "texture_2d_array"),
    texture_3d: new TokenType("texture_3d", TokenClass.keyword, "texture_3d"),
    texture_cube: new TokenType("texture_cube", TokenClass.keyword, "texture_cube"),
    texture_cube_array: new TokenType("texture_cube_array", TokenClass.keyword, "texture_cube_array"),
    texture_multisampled_2d: new TokenType("texture_multisampled_2d", TokenClass.keyword, "texture_multisampled_2d"),
    texture_storage_1d: new TokenType("texture_storage_1d", TokenClass.keyword, "texture_storage_1d"),
    texture_storage_2d: new TokenType("texture_storage_2d", TokenClass.keyword, "texture_storage_2d"),
    texture_storage_2d_array: new TokenType("texture_storage_2d_array", TokenClass.keyword, "texture_storage_2d_array"),
    texture_storage_3d: new TokenType("texture_storage_3d", TokenClass.keyword, "texture_storage_3d"),
    texture_depth_2d: new TokenType("texture_depth_2d", TokenClass.keyword, "texture_depth_2d"),
    texture_depth_2d_array: new TokenType("texture_depth_2d_array", TokenClass.keyword, "texture_depth_2d_array"),
    texture_depth_cube: new TokenType("texture_depth_cube", TokenClass.keyword, "texture_depth_cube"),
    texture_depth_cube_array: new TokenType("texture_depth_cube_array", TokenClass.keyword, "texture_depth_cube_array"),
    texture_depth_multisampled_2d: new TokenType("texture_depth_multisampled_2d", TokenClass.keyword, "texture_depth_multisampled_2d"),
    texture_external: new TokenType("texture_external", TokenClass.keyword, "texture_external"),
    u32: new TokenType("u32", TokenClass.keyword, "u32"),
    vec2: new TokenType("vec2", TokenClass.keyword, "vec2"),
    vec3: new TokenType("vec3", TokenClass.keyword, "vec3"),
    vec4: new TokenType("vec4", TokenClass.keyword, "vec4"),
    bitcast: new TokenType("bitcast", TokenClass.keyword, "bitcast"),
    block: new TokenType("block", TokenClass.keyword, "block"),
    break: new TokenType("break", TokenClass.keyword, "break"),
    case: new TokenType("case", TokenClass.keyword, "case"),
    continue: new TokenType("continue", TokenClass.keyword, "continue"),
    continuing: new TokenType("continuing", TokenClass.keyword, "continuing"),
    default: new TokenType("default", TokenClass.keyword, "default"),
    diagnostic: new TokenType("diagnostic", TokenClass.keyword, "diagnostic"),
    discard: new TokenType("discard", TokenClass.keyword, "discard"),
    else: new TokenType("else", TokenClass.keyword, "else"),
    enable: new TokenType("enable", TokenClass.keyword, "enable"),
    fallthrough: new TokenType("fallthrough", TokenClass.keyword, "fallthrough"),
    false: new TokenType("false", TokenClass.keyword, "false"),
    fn: new TokenType("fn", TokenClass.keyword, "fn"),
    for: new TokenType("for", TokenClass.keyword, "for"),
    function: new TokenType("function", TokenClass.keyword, "function"),
    if: new TokenType("if", TokenClass.keyword, "if"),
    let: new TokenType("let", TokenClass.keyword, "let"),
    const: new TokenType("const", TokenClass.keyword, "const"),
    loop: new TokenType("loop", TokenClass.keyword, "loop"),
    while: new TokenType("while", TokenClass.keyword, "while"),
    private: new TokenType("private", TokenClass.keyword, "private"),
    read: new TokenType("read", TokenClass.keyword, "read"),
    read_write: new TokenType("read_write", TokenClass.keyword, "read_write"),
    return: new TokenType("return", TokenClass.keyword, "return"),
    requires: new TokenType("requires", TokenClass.keyword, "requires"),
    storage: new TokenType("storage", TokenClass.keyword, "storage"),
    switch: new TokenType("switch", TokenClass.keyword, "switch"),
    true: new TokenType("true", TokenClass.keyword, "true"),
    alias: new TokenType("alias", TokenClass.keyword, "alias"),
    type: new TokenType("type", TokenClass.keyword, "type"),
    uniform: new TokenType("uniform", TokenClass.keyword, "uniform"),
    var: new TokenType("var", TokenClass.keyword, "var"),
    override: new TokenType("override", TokenClass.keyword, "override"),
    workgroup: new TokenType("workgroup", TokenClass.keyword, "workgroup"),
    write: new TokenType("write", TokenClass.keyword, "write"),
    r8unorm: new TokenType("r8unorm", TokenClass.keyword, "r8unorm"),
    r8snorm: new TokenType("r8snorm", TokenClass.keyword, "r8snorm"),
    r8uint: new TokenType("r8uint", TokenClass.keyword, "r8uint"),
    r8sint: new TokenType("r8sint", TokenClass.keyword, "r8sint"),
    r16uint: new TokenType("r16uint", TokenClass.keyword, "r16uint"),
    r16sint: new TokenType("r16sint", TokenClass.keyword, "r16sint"),
    r16float: new TokenType("r16float", TokenClass.keyword, "r16float"),
    rg8unorm: new TokenType("rg8unorm", TokenClass.keyword, "rg8unorm"),
    rg8snorm: new TokenType("rg8snorm", TokenClass.keyword, "rg8snorm"),
    rg8uint: new TokenType("rg8uint", TokenClass.keyword, "rg8uint"),
    rg8sint: new TokenType("rg8sint", TokenClass.keyword, "rg8sint"),
    r32uint: new TokenType("r32uint", TokenClass.keyword, "r32uint"),
    r32sint: new TokenType("r32sint", TokenClass.keyword, "r32sint"),
    r32float: new TokenType("r32float", TokenClass.keyword, "r32float"),
    rg16uint: new TokenType("rg16uint", TokenClass.keyword, "rg16uint"),
    rg16sint: new TokenType("rg16sint", TokenClass.keyword, "rg16sint"),
    rg16float: new TokenType("rg16float", TokenClass.keyword, "rg16float"),
    rgba8unorm: new TokenType("rgba8unorm", TokenClass.keyword, "rgba8unorm"),
    rgba8unorm_srgb: new TokenType("rgba8unorm_srgb", TokenClass.keyword, "rgba8unorm_srgb"),
    rgba8snorm: new TokenType("rgba8snorm", TokenClass.keyword, "rgba8snorm"),
    rgba8uint: new TokenType("rgba8uint", TokenClass.keyword, "rgba8uint"),
    rgba8sint: new TokenType("rgba8sint", TokenClass.keyword, "rgba8sint"),
    bgra8unorm: new TokenType("bgra8unorm", TokenClass.keyword, "bgra8unorm"),
    bgra8unorm_srgb: new TokenType("bgra8unorm_srgb", TokenClass.keyword, "bgra8unorm_srgb"),
    rgb10a2unorm: new TokenType("rgb10a2unorm", TokenClass.keyword, "rgb10a2unorm"),
    rg11b10float: new TokenType("rg11b10float", TokenClass.keyword, "rg11b10float"),
    rg32uint: new TokenType("rg32uint", TokenClass.keyword, "rg32uint"),
    rg32sint: new TokenType("rg32sint", TokenClass.keyword, "rg32sint"),
    rg32float: new TokenType("rg32float", TokenClass.keyword, "rg32float"),
    rgba16uint: new TokenType("rgba16uint", TokenClass.keyword, "rgba16uint"),
    rgba16sint: new TokenType("rgba16sint", TokenClass.keyword, "rgba16sint"),
    rgba16float: new TokenType("rgba16float", TokenClass.keyword, "rgba16float"),
    rgba32uint: new TokenType("rgba32uint", TokenClass.keyword, "rgba32uint"),
    rgba32sint: new TokenType("rgba32sint", TokenClass.keyword, "rgba32sint"),
    rgba32float: new TokenType("rgba32float", TokenClass.keyword, "rgba32float"),
    static_assert: new TokenType("static_assert", TokenClass.keyword, "static_assert"),
    // WGSL grammar has a few keywords that have different token names than the strings they
    // represent. Aliasing them here.
    /*int32: new TokenType("i32", TokenClass.keyword, "i32"),
        uint32: new TokenType("u32", TokenClass.keyword, "u32"),
        float32: new TokenType("f32", TokenClass.keyword, "f32"),
        pointer: new TokenType("ptr", TokenClass.keyword, "ptr"),*/
};
TokenTypes.tokens = {
    decimal_float_literal: new TokenType("decimal_float_literal", TokenClass.token, /((-?[0-9]*\.[0-9]+|-?[0-9]+\.[0-9]*)((e|E)(\+|-)?[0-9]+)?f?)|(-?[0-9]+(e|E)(\+|-)?[0-9]+f?)|([0-9]+f)/),
    hex_float_literal: new TokenType("hex_float_literal", TokenClass.token, /-?0x((([0-9a-fA-F]*\.[0-9a-fA-F]+|[0-9a-fA-F]+\.[0-9a-fA-F]*)((p|P)(\+|-)?[0-9]+f?)?)|([0-9a-fA-F]+(p|P)(\+|-)?[0-9]+f?))/),
    int_literal: new TokenType("int_literal", TokenClass.token, /-?0x[0-9a-fA-F]+|0i?|-?[1-9][0-9]*i?/),
    uint_literal: new TokenType("uint_literal", TokenClass.token, /0x[0-9a-fA-F]+u|0u|[1-9][0-9]*u/),
    ident: new TokenType("ident", TokenClass.token, /[_a-zA-Z][0-9a-zA-Z_]*/),
    and: new TokenType("and", TokenClass.token, "&"),
    and_and: new TokenType("and_and", TokenClass.token, "&&"),
    arrow: new TokenType("arrow ", TokenClass.token, "->"),
    attr: new TokenType("attr", TokenClass.token, "@"),
    forward_slash: new TokenType("forward_slash", TokenClass.token, "/"),
    bang: new TokenType("bang", TokenClass.token, "!"),
    bracket_left: new TokenType("bracket_left", TokenClass.token, "["),
    bracket_right: new TokenType("bracket_right", TokenClass.token, "]"),
    brace_left: new TokenType("brace_left", TokenClass.token, "{"),
    brace_right: new TokenType("brace_right", TokenClass.token, "}"),
    colon: new TokenType("colon", TokenClass.token, ":"),
    comma: new TokenType("comma", TokenClass.token, ","),
    equal: new TokenType("equal", TokenClass.token, "="),
    equal_equal: new TokenType("equal_equal", TokenClass.token, "=="),
    not_equal: new TokenType("not_equal", TokenClass.token, "!="),
    greater_than: new TokenType("greater_than", TokenClass.token, ">"),
    greater_than_equal: new TokenType("greater_than_equal", TokenClass.token, ">="),
    shift_right: new TokenType("shift_right", TokenClass.token, ">>"),
    less_than: new TokenType("less_than", TokenClass.token, "<"),
    less_than_equal: new TokenType("less_than_equal", TokenClass.token, "<="),
    shift_left: new TokenType("shift_left", TokenClass.token, "<<"),
    modulo: new TokenType("modulo", TokenClass.token, "%"),
    minus: new TokenType("minus", TokenClass.token, "-"),
    minus_minus: new TokenType("minus_minus", TokenClass.token, "--"),
    period: new TokenType("period", TokenClass.token, "."),
    plus: new TokenType("plus", TokenClass.token, "+"),
    plus_plus: new TokenType("plus_plus", TokenClass.token, "++"),
    or: new TokenType("or", TokenClass.token, "|"),
    or_or: new TokenType("or_or", TokenClass.token, "||"),
    paren_left: new TokenType("paren_left", TokenClass.token, "("),
    paren_right: new TokenType("paren_right", TokenClass.token, ")"),
    semicolon: new TokenType("semicolon", TokenClass.token, ";"),
    star: new TokenType("star", TokenClass.token, "*"),
    tilde: new TokenType("tilde", TokenClass.token, "~"),
    underscore: new TokenType("underscore", TokenClass.token, "_"),
    xor: new TokenType("xor", TokenClass.token, "^"),
    plus_equal: new TokenType("plus_equal", TokenClass.token, "+="),
    minus_equal: new TokenType("minus_equal", TokenClass.token, "-="),
    times_equal: new TokenType("times_equal", TokenClass.token, "*="),
    division_equal: new TokenType("division_equal", TokenClass.token, "/="),
    modulo_equal: new TokenType("modulo_equal", TokenClass.token, "%="),
    and_equal: new TokenType("and_equal", TokenClass.token, "&="),
    or_equal: new TokenType("or_equal", TokenClass.token, "|="),
    xor_equal: new TokenType("xor_equal", TokenClass.token, "^="),
    shift_right_equal: new TokenType("shift_right_equal", TokenClass.token, ">>="),
    shift_left_equal: new TokenType("shift_left_equal", TokenClass.token, "<<="),
};
TokenTypes.simpleTokens = {
    "@": _a.tokens.attr,
    "{": _a.tokens.brace_left,
    "}": _a.tokens.brace_right,
    ":": _a.tokens.colon,
    ",": _a.tokens.comma,
    "(": _a.tokens.paren_left,
    ")": _a.tokens.paren_right,
    ";": _a.tokens.semicolon,
};
TokenTypes.literalTokens = {
    "&": _a.tokens.and,
    "&&": _a.tokens.and_and,
    "->": _a.tokens.arrow,
    "/": _a.tokens.forward_slash,
    "!": _a.tokens.bang,
    "[": _a.tokens.bracket_left,
    "]": _a.tokens.bracket_right,
    "=": _a.tokens.equal,
    "==": _a.tokens.equal_equal,
    "!=": _a.tokens.not_equal,
    ">": _a.tokens.greater_than,
    ">=": _a.tokens.greater_than_equal,
    ">>": _a.tokens.shift_right,
    "<": _a.tokens.less_than,
    "<=": _a.tokens.less_than_equal,
    "<<": _a.tokens.shift_left,
    "%": _a.tokens.modulo,
    "-": _a.tokens.minus,
    "--": _a.tokens.minus_minus,
    ".": _a.tokens.period,
    "+": _a.tokens.plus,
    "++": _a.tokens.plus_plus,
    "|": _a.tokens.or,
    "||": _a.tokens.or_or,
    "*": _a.tokens.star,
    "~": _a.tokens.tilde,
    "_": _a.tokens.underscore,
    "^": _a.tokens.xor,
    "+=": _a.tokens.plus_equal,
    "-=": _a.tokens.minus_equal,
    "*=": _a.tokens.times_equal,
    "/=": _a.tokens.division_equal,
    "%=": _a.tokens.modulo_equal,
    "&=": _a.tokens.and_equal,
    "|=": _a.tokens.or_equal,
    "^=": _a.tokens.xor_equal,
    ">>=": _a.tokens.shift_right_equal,
    "<<=": _a.tokens.shift_left_equal,
};
TokenTypes.regexTokens = {
    decimal_float_literal: _a.tokens.decimal_float_literal,
    hex_float_literal: _a.tokens.hex_float_literal,
    int_literal: _a.tokens.int_literal,
    uint_literal: _a.tokens.uint_literal,
    ident: _a.tokens.ident,
};
TokenTypes.storage_class = [
    _a.keywords.function,
    _a.keywords.private,
    _a.keywords.workgroup,
    _a.keywords.uniform,
    _a.keywords.storage,
];
TokenTypes.access_mode = [
    _a.keywords.read,
    _a.keywords.write,
    _a.keywords.read_write,
];
TokenTypes.sampler_type = [
    _a.keywords.sampler,
    _a.keywords.sampler_comparison,
];
TokenTypes.sampled_texture_type = [
    _a.keywords.texture_1d,
    _a.keywords.texture_2d,
    _a.keywords.texture_2d_array,
    _a.keywords.texture_3d,
    _a.keywords.texture_cube,
    _a.keywords.texture_cube_array,
];
TokenTypes.multisampled_texture_type = [
    _a.keywords.texture_multisampled_2d,
];
TokenTypes.storage_texture_type = [
    _a.keywords.texture_storage_1d,
    _a.keywords.texture_storage_2d,
    _a.keywords.texture_storage_2d_array,
    _a.keywords.texture_storage_3d,
];
TokenTypes.depth_texture_type = [
    _a.keywords.texture_depth_2d,
    _a.keywords.texture_depth_2d_array,
    _a.keywords.texture_depth_cube,
    _a.keywords.texture_depth_cube_array,
    _a.keywords.texture_depth_multisampled_2d,
];
TokenTypes.texture_external_type = [_a.keywords.texture_external];
TokenTypes.any_texture_type = [
    ..._a.sampled_texture_type,
    ..._a.multisampled_texture_type,
    ..._a.storage_texture_type,
    ..._a.depth_texture_type,
    ..._a.texture_external_type,
];
TokenTypes.texel_format = [
    _a.keywords.r8unorm,
    _a.keywords.r8snorm,
    _a.keywords.r8uint,
    _a.keywords.r8sint,
    _a.keywords.r16uint,
    _a.keywords.r16sint,
    _a.keywords.r16float,
    _a.keywords.rg8unorm,
    _a.keywords.rg8snorm,
    _a.keywords.rg8uint,
    _a.keywords.rg8sint,
    _a.keywords.r32uint,
    _a.keywords.r32sint,
    _a.keywords.r32float,
    _a.keywords.rg16uint,
    _a.keywords.rg16sint,
    _a.keywords.rg16float,
    _a.keywords.rgba8unorm,
    _a.keywords.rgba8unorm_srgb,
    _a.keywords.rgba8snorm,
    _a.keywords.rgba8uint,
    _a.keywords.rgba8sint,
    _a.keywords.bgra8unorm,
    _a.keywords.bgra8unorm_srgb,
    _a.keywords.rgb10a2unorm,
    _a.keywords.rg11b10float,
    _a.keywords.rg32uint,
    _a.keywords.rg32sint,
    _a.keywords.rg32float,
    _a.keywords.rgba16uint,
    _a.keywords.rgba16sint,
    _a.keywords.rgba16float,
    _a.keywords.rgba32uint,
    _a.keywords.rgba32sint,
    _a.keywords.rgba32float,
];
TokenTypes.const_literal = [
    _a.tokens.int_literal,
    _a.tokens.uint_literal,
    _a.tokens.decimal_float_literal,
    _a.tokens.hex_float_literal,
    _a.keywords.true,
    _a.keywords.false,
];
TokenTypes.literal_or_ident = [
    _a.tokens.ident,
    _a.tokens.int_literal,
    _a.tokens.uint_literal,
    _a.tokens.decimal_float_literal,
    _a.tokens.hex_float_literal,
];
TokenTypes.element_count_expression = [
    _a.tokens.int_literal,
    _a.tokens.uint_literal,
    _a.tokens.ident,
];
TokenTypes.template_types = [
    _a.keywords.vec2,
    _a.keywords.vec3,
    _a.keywords.vec4,
    _a.keywords.mat2x2,
    _a.keywords.mat2x3,
    _a.keywords.mat2x4,
    _a.keywords.mat3x2,
    _a.keywords.mat3x3,
    _a.keywords.mat3x4,
    _a.keywords.mat4x2,
    _a.keywords.mat4x3,
    _a.keywords.mat4x4,
    _a.keywords.atomic,
    _a.keywords.bitcast,
    ..._a.any_texture_type,
];
// The grammar calls out 'block', but attribute grammar is defined to use a 'ident'.
// The attribute grammar should be ident | block.
TokenTypes.attribute_name = [_a.tokens.ident, _a.keywords.block, _a.keywords.diagnostic];
TokenTypes.assignment_operators = [
    _a.tokens.equal,
    _a.tokens.plus_equal,
    _a.tokens.minus_equal,
    _a.tokens.times_equal,
    _a.tokens.division_equal,
    _a.tokens.modulo_equal,
    _a.tokens.and_equal,
    _a.tokens.or_equal,
    _a.tokens.xor_equal,
    _a.tokens.shift_right_equal,
    _a.tokens.shift_left_equal,
];
TokenTypes.increment_operators = [
    _a.tokens.plus_plus,
    _a.tokens.minus_minus,
];
/// A token parsed by the WgslScanner.
class Token {
    constructor(type, lexeme, line) {
        this.type = type;
        this.lexeme = lexeme;
        this.line = line;
    }
    toString() {
        return this.lexeme;
    }
    isTemplateType() {
        return TokenTypes.template_types.indexOf(this.type) != -1;
    }
    isArrayType() {
        return this.type == TokenTypes.keywords.array;
    }
    isArrayOrTemplateType() {
        return this.isArrayType() || this.isTemplateType();
    }
}
/// Lexical scanner for the WGSL language. This takes an input source text and generates a list
/// of Token objects, which can then be fed into the WgslParser to generate an AST.
class WgslScanner {
    constructor(source) {
        this._tokens = [];
        this._start = 0;
        this._current = 0;
        this._line = 1;
        this._source = source !== null && source !== void 0 ? source : "";
    }
    /// Scan all tokens from the source.
    scanTokens() {
        while (!this._isAtEnd()) {
            this._start = this._current;
            if (!this.scanToken()) {
                throw `Invalid syntax at line ${this._line}`;
            }
        }
        this._tokens.push(new Token(TokenTypes.eof, "", this._line));
        return this._tokens;
    }
    /// Scan a single token from the source.
    scanToken() {
        // Find the longest consecutive set of characters that match a rule.
        let lexeme = this._advance();
        // Skip line-feed, adding to the line counter.
        if (lexeme == "\n") {
            this._line++;
            return true;
        }
        // Skip whitespace
        if (this._isWhitespace(lexeme)) {
            return true;
        }
        if (lexeme == "/") {
            // If it's a // comment, skip everything until the next line-feed.
            if (this._peekAhead() == "/") {
                while (lexeme != "\n") {
                    if (this._isAtEnd()) {
                        return true;
                    }
                    lexeme = this._advance();
                }
                // skip the linefeed
                this._line++;
                return true;
            }
            else if (this._peekAhead() == "*") {
                // If it's a / * block comment, skip everything until the matching * /,
                // allowing for nested block comments.
                this._advance();
                let commentLevel = 1;
                while (commentLevel > 0) {
                    if (this._isAtEnd()) {
                        return true;
                    }
                    lexeme = this._advance();
                    if (lexeme == "\n") {
                        this._line++;
                    }
                    else if (lexeme == "*") {
                        if (this._peekAhead() == "/") {
                            this._advance();
                            commentLevel--;
                            if (commentLevel == 0) {
                                return true;
                            }
                        }
                    }
                    else if (lexeme == "/") {
                        if (this._peekAhead() == "*") {
                            this._advance();
                            commentLevel++;
                        }
                    }
                }
                return true;
            }
        }
        // Shortcut single character tokens
        const simpleToken = TokenTypes.simpleTokens[lexeme];
        if (simpleToken) {
            this._addToken(simpleToken);
            return true;
        }
        // Shortcut keywords and identifiers
        let matchType = TokenTypes.none;
        const isAlpha = this._isAlpha(lexeme);
        const isUnderscore = lexeme === "_";
        if (this._isAlphaNumeric(lexeme)) {
            let nextChar = this._peekAhead();
            while (this._isAlphaNumeric(nextChar)) {
                lexeme += this._advance();
                nextChar = this._peekAhead();
            }
        }
        if (isAlpha) {
            const matchedType = TokenTypes.keywords[lexeme];
            if (matchedType) {
                this._addToken(matchedType);
                return true;
            }
        }
        if (isAlpha || isUnderscore) {
            this._addToken(TokenTypes.tokens.ident);
            return true;
        }
        // Scan for the next valid token type
        for (;;) {
            let matchedType = this._findType(lexeme);
            // An exception to "longest lexeme" rule is '>>'. In the case of 1>>2, it's a
            // shift_right.
            // In the case of array<vec4<f32>>, it's two greater_than's (one to close the vec4,
            // and one to close the array).
            // Another ambiguity is '>='. In the case of vec2<i32>=vec2(1,2),
            // it's a greather_than and an equal, not a greater_than_equal.
            // Another ambiguity is '-'. In the case of a-2, it's a minus; in the case of a*-2, it's a -2;
            // in the case of foo()->int, it's a ->; in the case of foo-- or --foo, it's a -- decrement.
            // WGSL requires context sensitive parsing to resolve these ambiguities. Both of these cases
            // are predicated on it the > either closing a template, or being part of an operator.
            // The solution here is to check if there was a less_than up to some number of tokens
            // previously, and the token prior to that is a keyword that requires a '<', then it will be
            // split into two operators; otherwise it's a single operator.
            const nextLexeme = this._peekAhead();
            if (lexeme == "-" && this._tokens.length > 0) {
                if (nextLexeme == "=") {
                    this._current++;
                    lexeme += nextLexeme;
                    this._addToken(TokenTypes.tokens.minus_equal);
                    return true;
                }
                if (nextLexeme == "-") {
                    this._current++;
                    lexeme += nextLexeme;
                    this._addToken(TokenTypes.tokens.minus_minus);
                    return true;
                }
                const ti = this._tokens.length - 1;
                const isIdentOrLiteral = TokenTypes.literal_or_ident.indexOf(this._tokens[ti].type) != -1;
                if ((isIdentOrLiteral || this._tokens[ti].type == TokenTypes.tokens.paren_right) && nextLexeme != ">") {
                    this._addToken(matchedType);
                    return true;
                }
            }
            if (lexeme == ">" && (nextLexeme == ">" || nextLexeme == "=")) {
                let foundLessThan = false;
                let ti = this._tokens.length - 1;
                for (let count = 0; count < 5 && ti >= 0; ++count, --ti) {
                    if (TokenTypes.assignment_operators.indexOf(this._tokens[ti].type) !== -1) {
                        break;
                    }
                    if (this._tokens[ti].type === TokenTypes.tokens.less_than) {
                        if (ti > 0 && this._tokens[ti - 1].isArrayOrTemplateType()) {
                            foundLessThan = true;
                        }
                        break;
                    }
                }
                // If there was a less_than in the recent token history, then this is probably a
                // greater_than.
                if (foundLessThan) {
                    this._addToken(matchedType);
                    return true;
                }
            }
            // The current lexeme may not match any rule, but some token types may be invalid for
            // part of the string but valid after a few more characters.
            // For example, 0x.5 is a hex_float_literal. But as it's being scanned,
            // "0" is a int_literal, then "0x" is invalid. If we stopped there, it would return
            // the int_literal "0", but that's incorrect. So if we look forward a few characters,
            // we'd get "0x.", which is still invalid, followed by "0x.5" which is the correct
            // hex_float_literal. So that means if we hit an non-matching string, we should look
            // ahead up to two characters to see if the string starts matching a valid rule again.
            if (matchedType === TokenTypes.none) {
                let lookAheadLexeme = lexeme;
                let lookAhead = 0;
                const maxLookAhead = 2;
                for (let li = 0; li < maxLookAhead; ++li) {
                    lookAheadLexeme += this._peekAhead(li);
                    matchedType = this._findType(lookAheadLexeme);
                    if (matchedType !== TokenTypes.none) {
                        lookAhead = li;
                        break;
                    }
                }
                if (matchedType === TokenTypes.none) {
                    if (matchType === TokenTypes.none) {
                        return false;
                    }
                    this._current--;
                    this._addToken(matchType);
                    return true;
                }
                lexeme = lookAheadLexeme;
                this._current += lookAhead + 1;
            }
            matchType = matchedType;
            if (this._isAtEnd()) {
                break;
            }
            lexeme += this._advance();
        }
        // We got to the end of the input stream. Then the token we've ready so far is it.
        if (matchType === TokenTypes.none) {
            return false;
        }
        this._addToken(matchType);
        return true;
    }
    _findType(lexeme) {
        for (const name in TokenTypes.regexTokens) {
            const type = TokenTypes.regexTokens[name];
            if (this._match(lexeme, type.rule)) {
                return type;
            }
        }
        const type = TokenTypes.literalTokens[lexeme];
        if (type) {
            return type;
        }
        return TokenTypes.none;
    }
    _match(lexeme, rule) {
        const match = rule.exec(lexeme);
        return match && match.index == 0 && match[0] == lexeme;
    }
    _isAtEnd() {
        return this._current >= this._source.length;
    }
    _isAlpha(c) {
        return (c >= "a" && c <= "z") || (c >= "A" && c <= "Z");
    }
    _isAlphaNumeric(c) {
        return (c >= "a" && c <= "z") || (c >= "A" && c <= "Z") || c == "_" || (c >= "0" && c <= "9");
    }
    _isWhitespace(c) {
        return c == " " || c == "\t" || c == "\r";
    }
    _advance(amount = 0) {
        let c = this._source[this._current];
        amount = amount || 0;
        amount++;
        this._current += amount;
        return c;
    }
    _peekAhead(offset = 0) {
        offset = offset || 0;
        if (this._current + offset >= this._source.length) {
            return "\0";
        }
        return this._source[this._current + offset];
    }
    _addToken(type) {
        const text = this._source.substring(this._start, this._current);
        this._tokens.push(new Token(type, text, this._line));
    }
}

/**
 * @author Brendan Duncan / https://github.com/brendan-duncan
 */
/// Parse a sequence of tokens from the WgslScanner into an Abstract Syntax Tree (AST).
class WgslParser {
    constructor() {
        this._tokens = [];
        this._current = 0;
        this._currentLine = 0;
        this._context = new ParseContext();
        this._deferArrayCountEval = [];
    }
    parse(tokensOrCode) {
        this._initialize(tokensOrCode);
        this._deferArrayCountEval.length = 0;
        const statements = [];
        while (!this._isAtEnd()) {
            const statement = this._global_decl_or_directive();
            if (!statement) {
                break;
            }
            statements.push(statement);
        }
        // Since constants can be declared after they are used, and
        // constants can be used to size arrays, defer calculating the
        // size until after the shader has finished parsing.
        if (this._deferArrayCountEval.length > 0) {
            for (const arrayDecl of this._deferArrayCountEval) {
                const arrayType = arrayDecl["arrayType"];
                const countNode = arrayDecl["countNode"];
                if (countNode instanceof VariableExpr) {
                    const variable = countNode;
                    const name = variable.name;
                    const constant = this._context.constants.get(name);
                    if (constant) {
                        try {
                            const count = constant.evaluate(this._context);
                            arrayType.count = count;
                        }
                        catch (e) {
                        }
                    }
                }
            }
            this._deferArrayCountEval.length = 0;
        }
        return statements;
    }
    _initialize(tokensOrCode) {
        if (tokensOrCode) {
            if (typeof tokensOrCode == "string") {
                const scanner = new WgslScanner(tokensOrCode);
                this._tokens = scanner.scanTokens();
            }
            else {
                this._tokens = tokensOrCode;
            }
        }
        else {
            this._tokens = [];
        }
        this._current = 0;
    }
    _error(token, message) {
        return {
            token,
            message,
            toString: function () {
                return `${message}`;
            },
        };
    }
    _isAtEnd() {
        return (this._current >= this._tokens.length ||
            this._peek().type == TokenTypes.eof);
    }
    _match(types) {
        if (types instanceof TokenType) {
            if (this._check(types)) {
                this._advance();
                return true;
            }
            return false;
        }
        for (let i = 0, l = types.length; i < l; ++i) {
            const type = types[i];
            if (this._check(type)) {
                this._advance();
                return true;
            }
        }
        return false;
    }
    _consume(types, message) {
        if (this._check(types)) {
            return this._advance();
        }
        throw this._error(this._peek(), message);
    }
    _check(types) {
        if (this._isAtEnd()) {
            return false;
        }
        const tk = this._peek();
        if (types instanceof Array) {
            const t = tk.type;
            const index = types.indexOf(t);
            return index != -1;
        }
        return tk.type == types;
    }
    _advance() {
        var _a, _b;
        this._currentLine = (_b = (_a = this._peek()) === null || _a === void 0 ? void 0 : _a.line) !== null && _b !== void 0 ? _b : -1;
        if (!this._isAtEnd()) {
            this._current++;
        }
        return this._previous();
    }
    _peek() {
        return this._tokens[this._current];
    }
    _previous() {
        return this._tokens[this._current - 1];
    }
    _global_decl_or_directive() {
        // semicolon
        // global_variable_decl semicolon
        // global_constant_decl semicolon
        // type_alias semicolon
        // struct_decl
        // function_decl
        // enable_directive
        // Ignore any stand-alone semicolons
        while (this._match(TokenTypes.tokens.semicolon) && !this._isAtEnd())
            ;
        if (this._match(TokenTypes.keywords.alias)) {
            const type = this._type_alias();
            this._consume(TokenTypes.tokens.semicolon, "Expected ';'");
            return type;
        }
        if (this._match(TokenTypes.keywords.diagnostic)) {
            const directive = this._diagnostic();
            this._consume(TokenTypes.tokens.semicolon, "Expected ';'");
            return directive;
        }
        if (this._match(TokenTypes.keywords.requires)) {
            const requires = this._requires_directive();
            this._consume(TokenTypes.tokens.semicolon, "Expected ';'");
            return requires;
        }
        if (this._match(TokenTypes.keywords.enable)) {
            const enable = this._enable_directive();
            this._consume(TokenTypes.tokens.semicolon, "Expected ';'");
            return enable;
        }
        // The following statements have an optional attribute*
        const attrs = this._attribute();
        if (this._check(TokenTypes.keywords.var)) {
            const _var = this._global_variable_decl();
            if (_var != null) {
                _var.attributes = attrs;
            }
            this._consume(TokenTypes.tokens.semicolon, "Expected ';'.");
            return _var;
        }
        if (this._check(TokenTypes.keywords.override)) {
            const _override = this._override_variable_decl();
            if (_override != null) {
                _override.attributes = attrs;
            }
            this._consume(TokenTypes.tokens.semicolon, "Expected ';'.");
            return _override;
        }
        if (this._check(TokenTypes.keywords.let)) {
            const _let = this._global_let_decl();
            if (_let != null) {
                _let.attributes = attrs;
            }
            this._consume(TokenTypes.tokens.semicolon, "Expected ';'.");
            return _let;
        }
        if (this._check(TokenTypes.keywords.const)) {
            const _const = this._global_const_decl();
            if (_const != null) {
                _const.attributes = attrs;
            }
            this._consume(TokenTypes.tokens.semicolon, "Expected ';'.");
            return _const;
        }
        if (this._check(TokenTypes.keywords.struct)) {
            const _struct = this._struct_decl();
            if (_struct != null) {
                _struct.attributes = attrs;
            }
            return _struct;
        }
        if (this._check(TokenTypes.keywords.fn)) {
            const _fn = this._function_decl();
            if (_fn != null) {
                _fn.attributes = attrs;
            }
            return _fn;
        }
        return null;
    }
    _function_decl() {
        // attribute* function_header compound_statement
        // function_header: fn ident paren_left param_list? paren_right (arrow attribute* type_decl)?
        if (!this._match(TokenTypes.keywords.fn)) {
            return null;
        }
        const startLine = this._currentLine;
        const name = this._consume(TokenTypes.tokens.ident, "Expected function name.").toString();
        this._consume(TokenTypes.tokens.paren_left, "Expected '(' for function arguments.");
        const args = [];
        if (!this._check(TokenTypes.tokens.paren_right)) {
            do {
                if (this._check(TokenTypes.tokens.paren_right)) {
                    break;
                }
                const argAttrs = this._attribute();
                const name = this._consume(TokenTypes.tokens.ident, "Expected argument name.").toString();
                this._consume(TokenTypes.tokens.colon, "Expected ':' for argument type.");
                const typeAttrs = this._attribute();
                const type = this._type_decl();
                if (type != null) {
                    type.attributes = typeAttrs;
                    args.push(new Argument(name, type, argAttrs));
                }
            } while (this._match(TokenTypes.tokens.comma));
        }
        this._consume(TokenTypes.tokens.paren_right, "Expected ')' after function arguments.");
        let _return = null;
        if (this._match(TokenTypes.tokens.arrow)) {
            const attrs = this._attribute();
            _return = this._type_decl();
            if (_return != null) {
                _return.attributes = attrs;
            }
        }
        const body = this._compound_statement();
        const endLine = this._currentLine;
        return new Function$1(name, args, _return, body, startLine, endLine);
    }
    _compound_statement() {
        // brace_left statement* brace_right
        const statements = [];
        this._consume(TokenTypes.tokens.brace_left, "Expected '{' for block.");
        while (!this._check(TokenTypes.tokens.brace_right)) {
            const statement = this._statement();
            if (statement !== null) {
                statements.push(statement);
            }
        }
        this._consume(TokenTypes.tokens.brace_right, "Expected '}' for block.");
        return statements;
    }
    _statement() {
        // semicolon
        // return_statement semicolon
        // if_statement
        // switch_statement
        // loop_statement
        // for_statement
        // func_call_statement semicolon
        // variable_statement semicolon
        // break_statement semicolon
        // continue_statement semicolon
        // continuing_statement compound_statement
        // discard semicolon
        // assignment_statement semicolon
        // compound_statement
        // increment_statement semicolon
        // decrement_statement semicolon
        // static_assert_statement semicolon
        // Ignore any stand-alone semicolons
        while (this._match(TokenTypes.tokens.semicolon) && !this._isAtEnd())
            ;
        if (this._check(TokenTypes.tokens.attr)) {
            this._attribute();
        }
        if (this._check(TokenTypes.keywords.if)) {
            return this._if_statement();
        }
        if (this._check(TokenTypes.keywords.switch)) {
            return this._switch_statement();
        }
        if (this._check(TokenTypes.keywords.loop)) {
            return this._loop_statement();
        }
        if (this._check(TokenTypes.keywords.for)) {
            return this._for_statement();
        }
        if (this._check(TokenTypes.keywords.while)) {
            return this._while_statement();
        }
        if (this._check(TokenTypes.keywords.continuing)) {
            return this._continuing_statement();
        }
        if (this._check(TokenTypes.keywords.static_assert)) {
            return this._static_assert_statement();
        }
        if (this._check(TokenTypes.tokens.brace_left)) {
            return this._compound_statement();
        }
        let result = null;
        if (this._check(TokenTypes.keywords.return)) {
            result = this._return_statement();
        }
        else if (this._check([
            TokenTypes.keywords.var,
            TokenTypes.keywords.let,
            TokenTypes.keywords.const,
        ])) {
            result = this._variable_statement();
        }
        else if (this._match(TokenTypes.keywords.discard)) {
            result = new Discard();
        }
        else if (this._match(TokenTypes.keywords.break)) {
            result = new Break();
        }
        else if (this._match(TokenTypes.keywords.continue)) {
            result = new Continue();
        }
        else {
            result =
                this._increment_decrement_statement() ||
                    this._func_call_statement() ||
                    this._assignment_statement();
        }
        if (result != null) {
            this._consume(TokenTypes.tokens.semicolon, "Expected ';' after statement.");
        }
        return result;
    }
    _static_assert_statement() {
        if (!this._match(TokenTypes.keywords.static_assert)) {
            return null;
        }
        const expression = this._optional_paren_expression();
        return new StaticAssert(expression);
    }
    _while_statement() {
        if (!this._match(TokenTypes.keywords.while)) {
            return null;
        }
        const condition = this._optional_paren_expression();
        if (this._check(TokenTypes.tokens.attr)) {
            this._attribute();
        }
        const block = this._compound_statement();
        return new While(condition, block);
    }
    _continuing_statement() {
        if (!this._match(TokenTypes.keywords.continuing)) {
            return null;
        }
        const block = this._compound_statement();
        return new Continuing(block);
    }
    _for_statement() {
        // for paren_left for_header paren_right compound_statement
        if (!this._match(TokenTypes.keywords.for)) {
            return null;
        }
        this._consume(TokenTypes.tokens.paren_left, "Expected '('.");
        // for_header: (variable_statement assignment_statement func_call_statement)? semicolon short_circuit_or_expression? semicolon (assignment_statement func_call_statement)?
        const init = !this._check(TokenTypes.tokens.semicolon)
            ? this._for_init()
            : null;
        this._consume(TokenTypes.tokens.semicolon, "Expected ';'.");
        const condition = !this._check(TokenTypes.tokens.semicolon)
            ? this._short_circuit_or_expression()
            : null;
        this._consume(TokenTypes.tokens.semicolon, "Expected ';'.");
        const increment = !this._check(TokenTypes.tokens.paren_right)
            ? this._for_increment()
            : null;
        this._consume(TokenTypes.tokens.paren_right, "Expected ')'.");
        if (this._check(TokenTypes.tokens.attr)) {
            this._attribute();
        }
        const body = this._compound_statement();
        return new For(init, condition, increment, body);
    }
    _for_init() {
        // (variable_statement assignment_statement func_call_statement)?
        return (this._variable_statement() ||
            this._func_call_statement() ||
            this._assignment_statement());
    }
    _for_increment() {
        // (assignment_statement func_call_statement increment_statement)?
        return (this._func_call_statement() ||
            this._increment_decrement_statement() ||
            this._assignment_statement());
    }
    _variable_statement() {
        // variable_decl
        // variable_decl equal short_circuit_or_expression
        // let (ident variable_ident_decl) equal short_circuit_or_expression
        // const (ident variable_ident_decl) equal short_circuit_or_expression
        if (this._check(TokenTypes.keywords.var)) {
            const _var = this._variable_decl();
            if (_var === null) {
                throw this._error(this._peek(), "Variable declaration expected.");
            }
            let value = null;
            if (this._match(TokenTypes.tokens.equal)) {
                value = this._short_circuit_or_expression();
            }
            return new Var(_var.name, _var.type, _var.storage, _var.access, value);
        }
        if (this._match(TokenTypes.keywords.let)) {
            const name = this._consume(TokenTypes.tokens.ident, "Expected name for let.").toString();
            let type = null;
            if (this._match(TokenTypes.tokens.colon)) {
                const typeAttrs = this._attribute();
                type = this._type_decl();
                if (type != null) {
                    type.attributes = typeAttrs;
                }
            }
            this._consume(TokenTypes.tokens.equal, "Expected '=' for let.");
            const value = this._short_circuit_or_expression();
            return new Let(name, type, null, null, value);
        }
        if (this._match(TokenTypes.keywords.const)) {
            const name = this._consume(TokenTypes.tokens.ident, "Expected name for const.").toString();
            let type = null;
            if (this._match(TokenTypes.tokens.colon)) {
                const typeAttrs = this._attribute();
                type = this._type_decl();
                if (type != null) {
                    type.attributes = typeAttrs;
                }
            }
            this._consume(TokenTypes.tokens.equal, "Expected '=' for const.");
            const value = this._short_circuit_or_expression();
            return new Const(name, type, null, null, value);
        }
        return null;
    }
    _increment_decrement_statement() {
        const savedPos = this._current;
        const _var = this._unary_expression();
        if (_var == null) {
            return null;
        }
        if (!this._check(TokenTypes.increment_operators)) {
            this._current = savedPos;
            return null;
        }
        const token = this._consume(TokenTypes.increment_operators, "Expected increment operator");
        return new Increment(token.type === TokenTypes.tokens.plus_plus
            ? IncrementOperator.increment
            : IncrementOperator.decrement, _var);
    }
    _assignment_statement() {
        // (unary_expression underscore) equal short_circuit_or_expression
        let _var = null;
        if (this._check(TokenTypes.tokens.brace_right)) {
            return null;
        }
        let isUnderscore = this._match(TokenTypes.tokens.underscore);
        if (!isUnderscore) {
            _var = this._unary_expression();
        }
        if (!isUnderscore && _var == null) {
            return null;
        }
        const type = this._consume(TokenTypes.assignment_operators, "Expected assignment operator.");
        const value = this._short_circuit_or_expression();
        return new Assign(AssignOperator.parse(type.lexeme), _var, value);
    }
    _func_call_statement() {
        // ident argument_expression_list
        if (!this._check(TokenTypes.tokens.ident)) {
            return null;
        }
        const savedPos = this._current;
        const name = this._consume(TokenTypes.tokens.ident, "Expected function name.");
        const args = this._argument_expression_list();
        if (args === null) {
            this._current = savedPos;
            return null;
        }
        return new Call(name.lexeme, args);
    }
    _loop_statement() {
        // loop brace_left statement* continuing_statement? brace_right
        if (!this._match(TokenTypes.keywords.loop)) {
            return null;
        }
        if (this._check(TokenTypes.tokens.attr)) {
            this._attribute();
        }
        this._consume(TokenTypes.tokens.brace_left, "Expected '{' for loop.");
        // statement*
        const statements = [];
        let statement = this._statement();
        while (statement !== null) {
            if (Array.isArray(statement)) {
                for (let s of statement) {
                    statements.push(s);
                }
            }
            else {
                statements.push(statement);
            }
            statement = this._statement();
        }
        // continuing_statement: continuing compound_statement
        let continuing = null;
        if (this._match(TokenTypes.keywords.continuing)) {
            continuing = this._compound_statement();
        }
        this._consume(TokenTypes.tokens.brace_right, "Expected '}' for loop.");
        return new Loop(statements, continuing);
    }
    _switch_statement() {
        // switch optional_paren_expression brace_left switch_body+ brace_right
        if (!this._match(TokenTypes.keywords.switch)) {
            return null;
        }
        const condition = this._optional_paren_expression();
        if (this._check(TokenTypes.tokens.attr)) {
            this._attribute();
        }
        this._consume(TokenTypes.tokens.brace_left, "Expected '{' for switch.");
        const body = this._switch_body();
        if (body == null || body.length == 0) {
            throw this._error(this._previous(), "Expected 'case' or 'default'.");
        }
        this._consume(TokenTypes.tokens.brace_right, "Expected '}' for switch.");
        return new Switch(condition, body);
    }
    _switch_body() {
        // case case_selectors colon brace_left case_body? brace_right
        // default colon brace_left case_body? brace_right
        const cases = [];
        if (this._match(TokenTypes.keywords.case)) {
            const selector = this._case_selectors();
            this._match(TokenTypes.tokens.colon); // colon is optional
            if (this._check(TokenTypes.tokens.attr)) {
                this._attribute();
            }
            this._consume(TokenTypes.tokens.brace_left, "Exected '{' for switch case.");
            const body = this._case_body();
            this._consume(TokenTypes.tokens.brace_right, "Exected '}' for switch case.");
            cases.push(new Case(selector, body));
        }
        if (this._match(TokenTypes.keywords.default)) {
            this._match(TokenTypes.tokens.colon); // colon is optional
            if (this._check(TokenTypes.tokens.attr)) {
                this._attribute();
            }
            this._consume(TokenTypes.tokens.brace_left, "Exected '{' for switch default.");
            const body = this._case_body();
            this._consume(TokenTypes.tokens.brace_right, "Exected '}' for switch default.");
            cases.push(new Default(body));
        }
        if (this._check([TokenTypes.keywords.default, TokenTypes.keywords.case])) {
            const _cases = this._switch_body();
            cases.push(_cases[0]);
        }
        return cases;
    }
    _case_selectors() {
        // const_literal (comma const_literal)* comma?
        const selectors = [
            this._shift_expression(), //?.evaluate(this._context).toString() ?? "",
        ];
        while (this._match(TokenTypes.tokens.comma)) {
            selectors.push(this._shift_expression());
        }
        return selectors;
    }
    _case_body() {
        // statement case_body?
        // fallthrough semicolon
        if (this._match(TokenTypes.keywords.fallthrough)) {
            this._consume(TokenTypes.tokens.semicolon, "Expected ';'");
            return [];
        }
        let statement = this._statement();
        if (statement == null) {
            return [];
        }
        if (!(statement instanceof Array)) {
            statement = [statement];
        }
        const nextStatement = this._case_body();
        if (nextStatement.length == 0) {
            return statement;
        }
        return [...statement, nextStatement[0]];
    }
    _if_statement() {
        // if optional_paren_expression compound_statement elseif_statement? else_statement?
        if (!this._match(TokenTypes.keywords.if)) {
            return null;
        }
        const condition = this._optional_paren_expression();
        if (this._check(TokenTypes.tokens.attr)) {
            this._attribute();
        }
        const block = this._compound_statement();
        let elseif = [];
        if (this._match_elseif()) {
            if (this._check(TokenTypes.tokens.attr)) {
                this._attribute();
            }
            elseif = this._elseif_statement(elseif);
        }
        let _else = null;
        if (this._match(TokenTypes.keywords.else)) {
            if (this._check(TokenTypes.tokens.attr)) {
                this._attribute();
            }
            _else = this._compound_statement();
        }
        return new If(condition, block, elseif, _else);
    }
    _match_elseif() {
        if (this._tokens[this._current].type === TokenTypes.keywords.else &&
            this._tokens[this._current + 1].type === TokenTypes.keywords.if) {
            this._advance();
            this._advance();
            return true;
        }
        return false;
    }
    _elseif_statement(elseif = []) {
        // else_if optional_paren_expression compound_statement elseif_statement?
        const condition = this._optional_paren_expression();
        const block = this._compound_statement();
        elseif.push(new ElseIf(condition, block));
        if (this._match_elseif()) {
            if (this._check(TokenTypes.tokens.attr)) {
                this._attribute();
            }
            this._elseif_statement(elseif);
        }
        return elseif;
    }
    _return_statement() {
        // return short_circuit_or_expression?
        if (!this._match(TokenTypes.keywords.return)) {
            return null;
        }
        const value = this._short_circuit_or_expression();
        return new Return(value);
    }
    _short_circuit_or_expression() {
        // short_circuit_and_expression
        // short_circuit_or_expression or_or short_circuit_and_expression
        let expr = this._short_circuit_and_expr();
        while (this._match(TokenTypes.tokens.or_or)) {
            expr = new BinaryOperator(this._previous().toString(), expr, this._short_circuit_and_expr());
        }
        return expr;
    }
    _short_circuit_and_expr() {
        // inclusive_or_expression
        // short_circuit_and_expression and_and inclusive_or_expression
        let expr = this._inclusive_or_expression();
        while (this._match(TokenTypes.tokens.and_and)) {
            expr = new BinaryOperator(this._previous().toString(), expr, this._inclusive_or_expression());
        }
        return expr;
    }
    _inclusive_or_expression() {
        // exclusive_or_expression
        // inclusive_or_expression or exclusive_or_expression
        let expr = this._exclusive_or_expression();
        while (this._match(TokenTypes.tokens.or)) {
            expr = new BinaryOperator(this._previous().toString(), expr, this._exclusive_or_expression());
        }
        return expr;
    }
    _exclusive_or_expression() {
        // and_expression
        // exclusive_or_expression xor and_expression
        let expr = this._and_expression();
        while (this._match(TokenTypes.tokens.xor)) {
            expr = new BinaryOperator(this._previous().toString(), expr, this._and_expression());
        }
        return expr;
    }
    _and_expression() {
        // equality_expression
        // and_expression and equality_expression
        let expr = this._equality_expression();
        while (this._match(TokenTypes.tokens.and)) {
            expr = new BinaryOperator(this._previous().toString(), expr, this._equality_expression());
        }
        return expr;
    }
    _equality_expression() {
        // relational_expression
        // relational_expression equal_equal relational_expression
        // relational_expression not_equal relational_expression
        const expr = this._relational_expression();
        if (this._match([TokenTypes.tokens.equal_equal, TokenTypes.tokens.not_equal])) {
            return new BinaryOperator(this._previous().toString(), expr, this._relational_expression());
        }
        return expr;
    }
    _relational_expression() {
        // shift_expression
        // relational_expression less_than shift_expression
        // relational_expression greater_than shift_expression
        // relational_expression less_than_equal shift_expression
        // relational_expression greater_than_equal shift_expression
        let expr = this._shift_expression();
        while (this._match([
            TokenTypes.tokens.less_than,
            TokenTypes.tokens.greater_than,
            TokenTypes.tokens.less_than_equal,
            TokenTypes.tokens.greater_than_equal,
        ])) {
            expr = new BinaryOperator(this._previous().toString(), expr, this._shift_expression());
        }
        return expr;
    }
    _shift_expression() {
        // additive_expression
        // shift_expression shift_left additive_expression
        // shift_expression shift_right additive_expression
        let expr = this._additive_expression();
        while (this._match([TokenTypes.tokens.shift_left, TokenTypes.tokens.shift_right])) {
            expr = new BinaryOperator(this._previous().toString(), expr, this._additive_expression());
        }
        return expr;
    }
    _additive_expression() {
        // multiplicative_expression
        // additive_expression plus multiplicative_expression
        // additive_expression minus multiplicative_expression
        let expr = this._multiplicative_expression();
        while (this._match([TokenTypes.tokens.plus, TokenTypes.tokens.minus])) {
            expr = new BinaryOperator(this._previous().toString(), expr, this._multiplicative_expression());
        }
        return expr;
    }
    _multiplicative_expression() {
        // unary_expression
        // multiplicative_expression star unary_expression
        // multiplicative_expression forward_slash unary_expression
        // multiplicative_expression modulo unary_expression
        let expr = this._unary_expression();
        while (this._match([
            TokenTypes.tokens.star,
            TokenTypes.tokens.forward_slash,
            TokenTypes.tokens.modulo,
        ])) {
            expr = new BinaryOperator(this._previous().toString(), expr, this._unary_expression());
        }
        return expr;
    }
    _unary_expression() {
        // singular_expression
        // minus unary_expression
        // bang unary_expression
        // tilde unary_expression
        // star unary_expression
        // and unary_expression
        if (this._match([
            TokenTypes.tokens.minus,
            TokenTypes.tokens.bang,
            TokenTypes.tokens.tilde,
            TokenTypes.tokens.star,
            TokenTypes.tokens.and,
        ])) {
            return new UnaryOperator(this._previous().toString(), this._unary_expression());
        }
        return this._singular_expression();
    }
    _singular_expression() {
        // primary_expression postfix_expression ?
        const expr = this._primary_expression();
        const p = this._postfix_expression();
        if (p) {
            expr.postfix = p;
        }
        return expr;
    }
    _postfix_expression() {
        // bracket_left short_circuit_or_expression bracket_right postfix_expression?
        if (this._match(TokenTypes.tokens.bracket_left)) {
            const expr = this._short_circuit_or_expression();
            this._consume(TokenTypes.tokens.bracket_right, "Expected ']'.");
            const arrayIndex = new ArrayIndex(expr);
            const p = this._postfix_expression();
            if (p) {
                arrayIndex.postfix = p;
            }
            return arrayIndex;
        }
        // period ident postfix_expression?
        if (this._match(TokenTypes.tokens.period)) {
            const name = this._consume(TokenTypes.tokens.ident, "Expected member name.");
            const p = this._postfix_expression();
            const expr = new StringExpr(name.lexeme);
            if (p) {
                expr.postfix = p;
            }
            return expr;
        }
        return null;
    }
    _getStruct(name) {
        if (this._context.aliases.has(name)) {
            const alias = this._context.aliases.get(name).type;
            return alias;
        }
        if (this._context.structs.has(name)) {
            const struct = this._context.structs.get(name);
            return struct;
        }
        return null;
    }
    _primary_expression() {
        // ident argument_expression_list?
        if (this._match(TokenTypes.tokens.ident)) {
            const name = this._previous().toString();
            if (this._check(TokenTypes.tokens.paren_left)) {
                const args = this._argument_expression_list();
                const struct = this._getStruct(name);
                if (struct != null) {
                    return new CreateExpr(struct, args);
                }
                return new CallExpr(name, args);
            }
            if (this._context.constants.has(name)) {
                const c = this._context.constants.get(name);
                return new ConstExpr(name, c.value);
            }
            return new VariableExpr(name);
        }
        // const_literal
        if (this._match(TokenTypes.const_literal)) {
            return new LiteralExpr(parseFloat(this._previous().toString()));
        }
        // paren_expression
        if (this._check(TokenTypes.tokens.paren_left)) {
            return this._paren_expression();
        }
        // bitcast less_than type_decl greater_than paren_expression
        if (this._match(TokenTypes.keywords.bitcast)) {
            this._consume(TokenTypes.tokens.less_than, "Expected '<'.");
            const type = this._type_decl();
            this._consume(TokenTypes.tokens.greater_than, "Expected '>'.");
            const value = this._paren_expression();
            return new BitcastExpr(type, value);
        }
        // type_decl argument_expression_list
        const type = this._type_decl();
        const args = this._argument_expression_list();
        return new CreateExpr(type, args);
    }
    _argument_expression_list() {
        // paren_left ((short_circuit_or_expression comma)* short_circuit_or_expression comma?)? paren_right
        if (!this._match(TokenTypes.tokens.paren_left)) {
            return null;
        }
        const args = [];
        do {
            if (this._check(TokenTypes.tokens.paren_right)) {
                break;
            }
            const arg = this._short_circuit_or_expression();
            args.push(arg);
        } while (this._match(TokenTypes.tokens.comma));
        this._consume(TokenTypes.tokens.paren_right, "Expected ')' for agument list");
        return args;
    }
    _optional_paren_expression() {
        // [paren_left] short_circuit_or_expression [paren_right]
        this._match(TokenTypes.tokens.paren_left);
        const expr = this._short_circuit_or_expression();
        this._match(TokenTypes.tokens.paren_right);
        return new GroupingExpr([expr]);
    }
    _paren_expression() {
        // paren_left short_circuit_or_expression paren_right
        this._consume(TokenTypes.tokens.paren_left, "Expected '('.");
        const expr = this._short_circuit_or_expression();
        this._consume(TokenTypes.tokens.paren_right, "Expected ')'.");
        return new GroupingExpr([expr]);
    }
    _struct_decl() {
        // attribute* struct ident struct_body_decl
        if (!this._match(TokenTypes.keywords.struct)) {
            return null;
        }
        const startLine = this._currentLine;
        const name = this._consume(TokenTypes.tokens.ident, "Expected name for struct.").toString();
        // struct_body_decl: brace_left (struct_member comma)* struct_member comma? brace_right
        this._consume(TokenTypes.tokens.brace_left, "Expected '{' for struct body.");
        const members = [];
        while (!this._check(TokenTypes.tokens.brace_right)) {
            // struct_member: attribute* variable_ident_decl
            const memberAttrs = this._attribute();
            const memberName = this._consume(TokenTypes.tokens.ident, "Expected variable name.").toString();
            this._consume(TokenTypes.tokens.colon, "Expected ':' for struct member type.");
            const typeAttrs = this._attribute();
            const memberType = this._type_decl();
            if (memberType != null) {
                memberType.attributes = typeAttrs;
            }
            if (!this._check(TokenTypes.tokens.brace_right))
                this._consume(TokenTypes.tokens.comma, "Expected ',' for struct member.");
            else
                this._match(TokenTypes.tokens.comma); // trailing comma optional.
            members.push(new Member(memberName, memberType, memberAttrs));
        }
        this._consume(TokenTypes.tokens.brace_right, "Expected '}' after struct body.");
        const endLine = this._currentLine;
        const structNode = new Struct(name, members, startLine, endLine);
        this._context.structs.set(name, structNode);
        return structNode;
    }
    _global_variable_decl() {
        // attribute* variable_decl (equal const_expression)?
        const _var = this._variable_decl();
        if (_var && this._match(TokenTypes.tokens.equal)) {
            _var.value = this._const_expression();
        }
        return _var;
    }
    _override_variable_decl() {
        // attribute* override_decl (equal const_expression)?
        const _override = this._override_decl();
        if (_override && this._match(TokenTypes.tokens.equal)) {
            _override.value = this._const_expression();
        }
        return _override;
    }
    _global_const_decl() {
        // attribute* const (ident variable_ident_decl) global_const_initializer?
        if (!this._match(TokenTypes.keywords.const)) {
            return null;
        }
        const name = this._consume(TokenTypes.tokens.ident, "Expected variable name");
        let type = null;
        if (this._match(TokenTypes.tokens.colon)) {
            const attrs = this._attribute();
            type = this._type_decl();
            if (type != null) {
                type.attributes = attrs;
            }
        }
        let value = null;
        if (this._match(TokenTypes.tokens.equal)) {
            const valueExpr = this._short_circuit_or_expression();
            if (valueExpr instanceof CreateExpr) {
                value = valueExpr;
            }
            else if (valueExpr instanceof ConstExpr &&
                valueExpr.initializer instanceof CreateExpr) {
                value = valueExpr.initializer;
            }
            else {
                try {
                    const constValue = valueExpr.evaluate(this._context);
                    value = new LiteralExpr(constValue);
                }
                catch (_a) {
                    value = valueExpr;
                }
            }
        }
        const c = new Const(name.toString(), type, "", "", value);
        this._context.constants.set(c.name, c);
        return c;
    }
    _global_let_decl() {
        // attribute* let (ident variable_ident_decl) global_const_initializer?
        if (!this._match(TokenTypes.keywords.let)) {
            return null;
        }
        const name = this._consume(TokenTypes.tokens.ident, "Expected variable name");
        let type = null;
        if (this._match(TokenTypes.tokens.colon)) {
            const attrs = this._attribute();
            type = this._type_decl();
            if (type != null) {
                type.attributes = attrs;
            }
        }
        let value = null;
        if (this._match(TokenTypes.tokens.equal)) {
            value = this._const_expression();
        }
        return new Let(name.toString(), type, "", "", value);
    }
    _const_expression() {
        // type_decl paren_left ((const_expression comma)* const_expression comma?)? paren_right
        // const_literal
        return this._short_circuit_or_expression();
    }
    _variable_decl() {
        // var variable_qualifier? (ident variable_ident_decl)
        if (!this._match(TokenTypes.keywords.var)) {
            return null;
        }
        // variable_qualifier: less_than storage_class (comma access_mode)? greater_than
        let storage = "";
        let access = "";
        if (this._match(TokenTypes.tokens.less_than)) {
            storage = this._consume(TokenTypes.storage_class, "Expected storage_class.").toString();
            if (this._match(TokenTypes.tokens.comma))
                access = this._consume(TokenTypes.access_mode, "Expected access_mode.").toString();
            this._consume(TokenTypes.tokens.greater_than, "Expected '>'.");
        }
        const name = this._consume(TokenTypes.tokens.ident, "Expected variable name");
        let type = null;
        if (this._match(TokenTypes.tokens.colon)) {
            const attrs = this._attribute();
            type = this._type_decl();
            if (type != null) {
                type.attributes = attrs;
            }
        }
        return new Var(name.toString(), type, storage, access, null);
    }
    _override_decl() {
        // override (ident variable_ident_decl)
        if (!this._match(TokenTypes.keywords.override)) {
            return null;
        }
        const name = this._consume(TokenTypes.tokens.ident, "Expected variable name");
        let type = null;
        if (this._match(TokenTypes.tokens.colon)) {
            const attrs = this._attribute();
            type = this._type_decl();
            if (type != null) {
                type.attributes = attrs;
            }
        }
        return new Override(name.toString(), type, null);
    }
    _diagnostic() {
        // diagnostic(severity_control_name, diagnostic_rule_name)
        this._consume(TokenTypes.tokens.paren_left, "Expected '('");
        const severity = this._consume(TokenTypes.tokens.ident, "Expected severity control name.");
        this._consume(TokenTypes.tokens.comma, "Expected ','");
        const rule = this._consume(TokenTypes.tokens.ident, "Expected diagnostic rule name.");
        this._consume(TokenTypes.tokens.paren_right, "Expected ')'");
        return new Diagnostic(severity.toString(), rule.toString());
    }
    _enable_directive() {
        // enable ident semicolon
        const name = this._consume(TokenTypes.tokens.ident, "identity expected.");
        return new Enable(name.toString());
    }
    _requires_directive() {
        // requires extension [, extension]* semicolon
        const extensions = [this._consume(TokenTypes.tokens.ident, "identity expected.").toString()];
        while (this._match(TokenTypes.tokens.comma)) {
            const name = this._consume(TokenTypes.tokens.ident, "identity expected.");
            extensions.push(name.toString());
        }
        return new Requires(extensions);
    }
    _type_alias() {
        // type ident equal type_decl
        const name = this._consume(TokenTypes.tokens.ident, "identity expected.");
        this._consume(TokenTypes.tokens.equal, "Expected '=' for type alias.");
        let aliasType = this._type_decl();
        if (aliasType === null) {
            throw this._error(this._peek(), "Expected Type for Alias.");
        }
        if (this._context.aliases.has(aliasType.name)) {
            aliasType = this._context.aliases.get(aliasType.name).type;
        }
        const aliasNode = new Alias(name.toString(), aliasType);
        this._context.aliases.set(aliasNode.name, aliasNode);
        return aliasNode;
    }
    _type_decl() {
        // ident
        // bool
        // float32
        // int32
        // uint32
        // vec2 less_than type_decl greater_than
        // vec3 less_than type_decl greater_than
        // vec4 less_than type_decl greater_than
        // mat2x2 less_than type_decl greater_than
        // mat2x3 less_than type_decl greater_than
        // mat2x4 less_than type_decl greater_than
        // mat3x2 less_than type_decl greater_than
        // mat3x3 less_than type_decl greater_than
        // mat3x4 less_than type_decl greater_than
        // mat4x2 less_than type_decl greater_than
        // mat4x3 less_than type_decl greater_than
        // mat4x4 less_than type_decl greater_than
        // atomic less_than type_decl greater_than
        // pointer less_than storage_class comma type_decl (comma access_mode)? greater_than
        // array_type_decl
        // texture_sampler_types
        if (this._check([
            TokenTypes.tokens.ident,
            ...TokenTypes.texel_format,
            TokenTypes.keywords.bool,
            TokenTypes.keywords.f32,
            TokenTypes.keywords.i32,
            TokenTypes.keywords.u32,
        ])) {
            const type = this._advance();
            const typeName = type.toString();
            if (this._context.structs.has(typeName)) {
                return this._context.structs.get(typeName);
            }
            if (this._context.aliases.has(typeName)) {
                return this._context.aliases.get(typeName).type;
            }
            return new Type(type.toString());
        }
        // texture_sampler_types
        let type = this._texture_sampler_types();
        if (type) {
            return type;
        }
        if (this._check(TokenTypes.template_types)) {
            let type = this._advance().toString();
            let format = null;
            let access = null;
            if (this._match(TokenTypes.tokens.less_than)) {
                format = this._type_decl();
                access = null;
                if (this._match(TokenTypes.tokens.comma)) {
                    access = this._consume(TokenTypes.access_mode, "Expected access_mode for pointer").toString();
                }
                this._consume(TokenTypes.tokens.greater_than, "Expected '>' for type.");
            }
            return new TemplateType(type, format, access);
        }
        // pointer less_than storage_class comma type_decl (comma access_mode)? greater_than
        if (this._match(TokenTypes.keywords.ptr)) {
            let pointer = this._previous().toString();
            this._consume(TokenTypes.tokens.less_than, "Expected '<' for pointer.");
            const storage = this._consume(TokenTypes.storage_class, "Expected storage_class for pointer");
            this._consume(TokenTypes.tokens.comma, "Expected ',' for pointer.");
            const decl = this._type_decl();
            let access = null;
            if (this._match(TokenTypes.tokens.comma)) {
                access = this._consume(TokenTypes.access_mode, "Expected access_mode for pointer").toString();
            }
            this._consume(TokenTypes.tokens.greater_than, "Expected '>' for pointer.");
            return new PointerType(pointer, storage.toString(), decl, access);
        }
        // The following type_decl's have an optional attribyte_list*
        const attrs = this._attribute();
        // attribute* array
        // attribute* array less_than type_decl (comma element_count_expression)? greater_than
        if (this._match(TokenTypes.keywords.array)) {
            let format = null;
            let countInt = -1;
            const array = this._previous();
            let countNode = null;
            if (this._match(TokenTypes.tokens.less_than)) {
                format = this._type_decl();
                if (this._context.aliases.has(format.name)) {
                    format = this._context.aliases.get(format.name).type;
                }
                let count = "";
                if (this._match(TokenTypes.tokens.comma)) {
                    countNode = this._shift_expression();
                    // If we can't evaluate the node, defer evaluating it until after the shader has
                    // finished being parsed, because const statements can be declared **after** they
                    // are used.
                    try {
                        count = countNode.evaluate(this._context).toString();
                        countNode = null;
                    }
                    catch (e) {
                        count = "1";
                    }
                }
                this._consume(TokenTypes.tokens.greater_than, "Expected '>' for array.");
                countInt = count ? parseInt(count) : 0;
            }
            const arrayType = new ArrayType(array.toString(), attrs, format, countInt);
            if (countNode) {
                this._deferArrayCountEval.push({ arrayType, countNode });
            }
            return arrayType;
        }
        return null;
    }
    _texture_sampler_types() {
        // sampler_type
        if (this._match(TokenTypes.sampler_type)) {
            return new SamplerType(this._previous().toString(), null, null);
        }
        // depth_texture_type
        if (this._match(TokenTypes.depth_texture_type)) {
            return new SamplerType(this._previous().toString(), null, null);
        }
        // sampled_texture_type less_than type_decl greater_than
        // multisampled_texture_type less_than type_decl greater_than
        if (this._match(TokenTypes.sampled_texture_type) ||
            this._match(TokenTypes.multisampled_texture_type)) {
            const sampler = this._previous();
            this._consume(TokenTypes.tokens.less_than, "Expected '<' for sampler type.");
            const format = this._type_decl();
            this._consume(TokenTypes.tokens.greater_than, "Expected '>' for sampler type.");
            return new SamplerType(sampler.toString(), format, null);
        }
        // storage_texture_type less_than texel_format comma access_mode greater_than
        if (this._match(TokenTypes.storage_texture_type)) {
            const sampler = this._previous();
            this._consume(TokenTypes.tokens.less_than, "Expected '<' for sampler type.");
            const format = this._consume(TokenTypes.texel_format, "Invalid texel format.").toString();
            this._consume(TokenTypes.tokens.comma, "Expected ',' after texel format.");
            const access = this._consume(TokenTypes.access_mode, "Expected access mode for storage texture type.").toString();
            this._consume(TokenTypes.tokens.greater_than, "Expected '>' for sampler type.");
            return new SamplerType(sampler.toString(), format, access);
        }
        return null;
    }
    _attribute() {
        // attr ident paren_left (literal_or_ident comma)* literal_or_ident paren_right
        // attr ident
        let attributes = [];
        while (this._match(TokenTypes.tokens.attr)) {
            const name = this._consume(TokenTypes.attribute_name, "Expected attribute name");
            const attr = new Attribute(name.toString(), null);
            if (this._match(TokenTypes.tokens.paren_left)) {
                // literal_or_ident
                attr.value = this._consume(TokenTypes.literal_or_ident, "Expected attribute value").toString();
                if (this._check(TokenTypes.tokens.comma)) {
                    this._advance();
                    do {
                        const v = this._consume(TokenTypes.literal_or_ident, "Expected attribute value").toString();
                        if (!(attr.value instanceof Array)) {
                            attr.value = [attr.value];
                        }
                        attr.value.push(v);
                    } while (this._match(TokenTypes.tokens.comma));
                }
                this._consume(TokenTypes.tokens.paren_right, "Expected ')'");
            }
            attributes.push(attr);
        }
        if (attributes.length == 0) {
            return null;
        }
        return attributes;
    }
}

/**
 * @author Brendan Duncan / https://github.com/brendan-duncan
 */
class TypeInfo {
    constructor(name, attributes) {
        this.name = name;
        this.attributes = attributes;
        this.size = 0;
    }
    get isArray() {
        return false;
    }
    get isStruct() {
        return false;
    }
    get isTemplate() {
        return false;
    }
}
class MemberInfo {
    constructor(name, type, attributes) {
        this.name = name;
        this.type = type;
        this.attributes = attributes;
        this.offset = 0;
        this.size = 0;
    }
    get isArray() {
        return this.type.isArray;
    }
    get isStruct() {
        return this.type.isStruct;
    }
    get isTemplate() {
        return this.type.isTemplate;
    }
    get align() {
        return this.type.isStruct ? this.type.align : 0;
    }
    get members() {
        return this.type.isStruct ? this.type.members : null;
    }
    get format() {
        return this.type.isArray
            ? this.type.format
            : this.type.isTemplate
                ? this.type.format
                : null;
    }
    get count() {
        return this.type.isArray ? this.type.count : 0;
    }
    get stride() {
        return this.type.isArray ? this.type.stride : this.size;
    }
}
class StructInfo extends TypeInfo {
    constructor(name, attributes) {
        super(name, attributes);
        this.members = [];
        this.align = 0;
        this.startLine = -1;
        this.endLine = -1;
        this.inUse = false;
    }
    get isStruct() {
        return true;
    }
}
class ArrayInfo extends TypeInfo {
    constructor(name, attributes) {
        super(name, attributes);
        this.count = 0;
        this.stride = 0;
    }
    get isArray() {
        return true;
    }
}
class TemplateInfo extends TypeInfo {
    constructor(name, format, attributes, access) {
        super(name, attributes);
        this.format = format;
        this.access = access;
    }
    get isTemplate() {
        return true;
    }
}
var ResourceType;
(function (ResourceType) {
    ResourceType[ResourceType["Uniform"] = 0] = "Uniform";
    ResourceType[ResourceType["Storage"] = 1] = "Storage";
    ResourceType[ResourceType["Texture"] = 2] = "Texture";
    ResourceType[ResourceType["Sampler"] = 3] = "Sampler";
    ResourceType[ResourceType["StorageTexture"] = 4] = "StorageTexture";
})(ResourceType || (ResourceType = {}));
class VariableInfo {
    constructor(name, type, group, binding, attributes, resourceType, access) {
        this.name = name;
        this.type = type;
        this.group = group;
        this.binding = binding;
        this.attributes = attributes;
        this.resourceType = resourceType;
        this.access = access;
    }
    get isArray() {
        return this.type.isArray;
    }
    get isStruct() {
        return this.type.isStruct;
    }
    get isTemplate() {
        return this.type.isTemplate;
    }
    get size() {
        return this.type.size;
    }
    get align() {
        return this.type.isStruct ? this.type.align : 0;
    }
    get members() {
        return this.type.isStruct ? this.type.members : null;
    }
    get format() {
        return this.type.isArray
            ? this.type.format
            : this.type.isTemplate
                ? this.type.format
                : null;
    }
    get count() {
        return this.type.isArray ? this.type.count : 0;
    }
    get stride() {
        return this.type.isArray ? this.type.stride : this.size;
    }
}
class AliasInfo {
    constructor(name, type) {
        this.name = name;
        this.type = type;
    }
}
class _TypeSize {
    constructor(align, size) {
        this.align = align;
        this.size = size;
    }
}
class InputInfo {
    constructor(name, type, locationType, location) {
        this.name = name;
        this.type = type;
        this.locationType = locationType;
        this.location = location;
        this.interpolation = null;
    }
}
class OutputInfo {
    constructor(name, type, locationType, location) {
        this.name = name;
        this.type = type;
        this.locationType = locationType;
        this.location = location;
    }
}
class OverrideInfo {
    constructor(name, type, attributes, id) {
        this.name = name;
        this.type = type;
        this.attributes = attributes;
        this.id = id;
    }
}
class ArgumentInfo {
    constructor(name, type) {
        this.name = name;
        this.type = type;
    }
}
class FunctionInfo {
    constructor(name, stage = null) {
        this.stage = null;
        this.inputs = [];
        this.outputs = [];
        this.arguments = [];
        this.returnType = null;
        this.resources = [];
        this.overrides = [];
        this.startLine = -1;
        this.endLine = -1;
        this.inUse = false;
        this.calls = new Set();
        this.name = name;
        this.stage = stage;
    }
}
class EntryFunctions {
    constructor() {
        this.vertex = [];
        this.fragment = [];
        this.compute = [];
    }
}
class _FunctionResources {
    constructor(node) {
        this.resources = null;
        this.inUse = false;
        this.info = null;
        this.node = node;
    }
}
class WgslReflect {
    constructor(code) {
        /// All top-level uniform vars in the shader.
        this.uniforms = [];
        /// All top-level storage vars in the shader.
        this.storage = [];
        /// All top-level texture vars in the shader;
        this.textures = [];
        // All top-level sampler vars in the shader.
        this.samplers = [];
        /// All top-level type aliases in the shader.
        this.aliases = [];
        /// All top-level overrides in the shader.
        this.overrides = [];
        /// All top-level structs in the shader.
        this.structs = [];
        /// All entry functions in the shader: vertex, fragment, and/or compute.
        this.entry = new EntryFunctions();
        /// All functions in the shader, including entry functions.
        this.functions = [];
        this._types = new Map();
        this._functions = new Map();
        if (code) {
            this.update(code);
        }
    }
    _isStorageTexture(type) {
        return (type.name == "texture_storage_1d" ||
            type.name == "texture_storage_2d" ||
            type.name == "texture_storage_2d_array" ||
            type.name == "texture_storage_3d");
    }
    update(code) {
        const parser = new WgslParser();
        const ast = parser.parse(code);
        for (const node of ast) {
            if (node instanceof Function$1) {
                this._functions.set(node.name, new _FunctionResources(node));
            }
        }
        for (const node of ast) {
            if (node instanceof Struct) {
                const info = this._getTypeInfo(node, null);
                if (info instanceof StructInfo) {
                    this.structs.push(info);
                }
            }
        }
        for (const node of ast) {
            if (node instanceof Alias) {
                this.aliases.push(this._getAliasInfo(node));
                continue;
            }
            if (node instanceof Override) {
                const v = node;
                const id = this._getAttributeNum(v.attributes, "id", 0);
                const type = v.type != null ? this._getTypeInfo(v.type, v.attributes) : null;
                this.overrides.push(new OverrideInfo(v.name, type, v.attributes, id));
                continue;
            }
            if (this._isUniformVar(node)) {
                const v = node;
                const g = this._getAttributeNum(v.attributes, "group", 0);
                const b = this._getAttributeNum(v.attributes, "binding", 0);
                const type = this._getTypeInfo(v.type, v.attributes);
                const varInfo = new VariableInfo(v.name, type, g, b, v.attributes, ResourceType.Uniform, v.access);
                this.uniforms.push(varInfo);
                continue;
            }
            if (this._isStorageVar(node)) {
                const v = node;
                const g = this._getAttributeNum(v.attributes, "group", 0);
                const b = this._getAttributeNum(v.attributes, "binding", 0);
                const type = this._getTypeInfo(v.type, v.attributes);
                const isStorageTexture = this._isStorageTexture(type);
                const varInfo = new VariableInfo(v.name, type, g, b, v.attributes, isStorageTexture ? ResourceType.StorageTexture : ResourceType.Storage, v.access);
                this.storage.push(varInfo);
                continue;
            }
            if (this._isTextureVar(node)) {
                const v = node;
                const g = this._getAttributeNum(v.attributes, "group", 0);
                const b = this._getAttributeNum(v.attributes, "binding", 0);
                const type = this._getTypeInfo(v.type, v.attributes);
                const isStorageTexture = this._isStorageTexture(type);
                const varInfo = new VariableInfo(v.name, type, g, b, v.attributes, isStorageTexture ? ResourceType.StorageTexture : ResourceType.Texture, v.access);
                if (isStorageTexture) {
                    this.storage.push(varInfo);
                }
                else {
                    this.textures.push(varInfo);
                }
                continue;
            }
            if (this._isSamplerVar(node)) {
                const v = node;
                const g = this._getAttributeNum(v.attributes, "group", 0);
                const b = this._getAttributeNum(v.attributes, "binding", 0);
                const type = this._getTypeInfo(v.type, v.attributes);
                const varInfo = new VariableInfo(v.name, type, g, b, v.attributes, ResourceType.Sampler, v.access);
                this.samplers.push(varInfo);
                continue;
            }
            if (node instanceof Function$1) {
                const vertexStage = this._getAttribute(node, "vertex");
                const fragmentStage = this._getAttribute(node, "fragment");
                const computeStage = this._getAttribute(node, "compute");
                const stage = vertexStage || fragmentStage || computeStage;
                const fn = new FunctionInfo(node.name, stage === null || stage === void 0 ? void 0 : stage.name);
                fn.startLine = node.startLine;
                fn.endLine = node.endLine;
                this.functions.push(fn);
                this._functions.get(node.name).info = fn;
                if (stage) {
                    this._functions.get(node.name).inUse = true;
                    fn.inUse = true;
                    fn.resources = this._findResources(node, !!stage);
                    fn.inputs = this._getInputs(node.args);
                    fn.outputs = this._getOutputs(node.returnType);
                    this.entry[stage.name].push(fn);
                }
                else {
                    fn.arguments = node.args.map((arg) => new ArgumentInfo(arg.name, this._getTypeInfo(arg.type, arg.attributes)));
                    fn.returnType = node.returnType
                        ? this._getTypeInfo(node.returnType, node.attributes)
                        : null;
                }
                continue;
            }
        }
        for (const fn of this._functions.values()) {
            if (fn.info) {
                fn.info.inUse = fn.inUse;
                this._addCalls(fn.node, fn.info.calls);
            }
        }
        for (const fn of this._functions.values()) {
            fn.node.search((node) => {
                var _a;
                if (node.astNodeType === "varExpr") {
                    const v = node;
                    for (const override of this.overrides) {
                        if (v.name == override.name) {
                            (_a = fn.info) === null || _a === void 0 ? void 0 : _a.overrides.push(override);
                        }
                    }
                }
            });
        }
        for (const u of this.uniforms) {
            this._markStructsInUse(u.type);
        }
        for (const s of this.storage) {
            this._markStructsInUse(s.type);
        }
    }
    _markStructsInUse(type) {
        if (!type) {
            return;
        }
        if (type.isStruct) {
            type.inUse = true;
            if (type.members) {
                for (const m of type.members) {
                    this._markStructsInUse(m.type);
                }
            }
        }
        else if (type.isArray) {
            this._markStructsInUse(type.format);
        }
        else if (type.isTemplate) {
            if (type.format) {
                this._markStructsInUse(type.format);
            }
        }
        else {
            const alias = this._getAlias(type.name);
            if (alias) {
                this._markStructsInUse(alias);
            }
        }
    }
    _addCalls(fn, calls) {
        var _a;
        for (const call of fn.calls) {
            const info = (_a = this._functions.get(call.name)) === null || _a === void 0 ? void 0 : _a.info;
            if (info) {
                calls.add(info);
            }
        }
    }
    /// Find a resource by its group and binding.
    findResource(group, binding) {
        for (const u of this.uniforms) {
            if (u.group == group && u.binding == binding) {
                return u;
            }
        }
        for (const s of this.storage) {
            if (s.group == group && s.binding == binding) {
                return s;
            }
        }
        for (const t of this.textures) {
            if (t.group == group && t.binding == binding) {
                return t;
            }
        }
        for (const s of this.samplers) {
            if (s.group == group && s.binding == binding) {
                return s;
            }
        }
        return null;
    }
    _findResource(name) {
        for (const u of this.uniforms) {
            if (u.name == name) {
                return u;
            }
        }
        for (const s of this.storage) {
            if (s.name == name) {
                return s;
            }
        }
        for (const t of this.textures) {
            if (t.name == name) {
                return t;
            }
        }
        for (const s of this.samplers) {
            if (s.name == name) {
                return s;
            }
        }
        return null;
    }
    _markStructsFromAST(type) {
        const info = this._getTypeInfo(type, null);
        this._markStructsInUse(info);
    }
    _findResources(fn, isEntry) {
        const resources = [];
        const self = this;
        const varStack = [];
        fn.search((node) => {
            if (node instanceof _BlockStart) {
                varStack.push({});
            }
            else if (node instanceof _BlockEnd) {
                varStack.pop();
            }
            else if (node instanceof Var) {
                const v = node;
                if (isEntry && v.type !== null) {
                    this._markStructsFromAST(v.type);
                }
                if (varStack.length > 0) {
                    varStack[varStack.length - 1][v.name] = v;
                }
            }
            else if (node instanceof CreateExpr) {
                const c = node;
                if (isEntry && c.type !== null) {
                    this._markStructsFromAST(c.type);
                }
            }
            else if (node instanceof Let) {
                const v = node;
                if (isEntry && v.type !== null) {
                    this._markStructsFromAST(v.type);
                }
                if (varStack.length > 0) {
                    varStack[varStack.length - 1][v.name] = v;
                }
            }
            else if (node instanceof VariableExpr) {
                const v = node;
                // Check to see if the variable is a local variable before checking to see if it's
                // a resource.
                if (varStack.length > 0) {
                    const varInfo = varStack[varStack.length - 1][v.name];
                    if (varInfo) {
                        return;
                    }
                }
                const varInfo = self._findResource(v.name);
                if (varInfo) {
                    resources.push(varInfo);
                }
            }
            else if (node instanceof CallExpr) {
                const c = node;
                const callFn = self._functions.get(c.name);
                if (callFn) {
                    if (isEntry) {
                        callFn.inUse = true;
                    }
                    fn.calls.add(callFn.node);
                    if (callFn.resources === null) {
                        callFn.resources = self._findResources(callFn.node, isEntry);
                    }
                    resources.push(...callFn.resources);
                }
            }
            else if (node instanceof Call) {
                const c = node;
                const callFn = self._functions.get(c.name);
                if (callFn) {
                    if (isEntry) {
                        callFn.inUse = true;
                    }
                    fn.calls.add(callFn.node);
                    if (callFn.resources === null) {
                        callFn.resources = self._findResources(callFn.node, isEntry);
                    }
                    resources.push(...callFn.resources);
                }
            }
        });
        return [...new Map(resources.map(r => [r.name, r])).values()];
    }
    getBindGroups() {
        const groups = [];
        function _makeRoom(group, binding) {
            if (group >= groups.length) {
                groups.length = group + 1;
            }
            if (groups[group] === undefined) {
                groups[group] = [];
            }
            if (binding >= groups[group].length) {
                groups[group].length = binding + 1;
            }
        }
        for (const u of this.uniforms) {
            _makeRoom(u.group, u.binding);
            const group = groups[u.group];
            group[u.binding] = u;
        }
        for (const u of this.storage) {
            _makeRoom(u.group, u.binding);
            const group = groups[u.group];
            group[u.binding] = u;
        }
        for (const t of this.textures) {
            _makeRoom(t.group, t.binding);
            const group = groups[t.group];
            group[t.binding] = t;
        }
        for (const t of this.samplers) {
            _makeRoom(t.group, t.binding);
            const group = groups[t.group];
            group[t.binding] = t;
        }
        return groups;
    }
    _getOutputs(type, outputs = undefined) {
        if (outputs === undefined) {
            outputs = [];
        }
        if (type instanceof Struct) {
            this._getStructOutputs(type, outputs);
        }
        else {
            const output = this._getOutputInfo(type);
            if (output !== null) {
                outputs.push(output);
            }
        }
        return outputs;
    }
    _getStructOutputs(struct, outputs) {
        for (const m of struct.members) {
            if (m.type instanceof Struct) {
                this._getStructOutputs(m.type, outputs);
            }
            else {
                const location = this._getAttribute(m, "location") || this._getAttribute(m, "builtin");
                if (location !== null) {
                    const typeInfo = this._getTypeInfo(m.type, m.type.attributes);
                    const locationValue = this._parseInt(location.value);
                    const info = new OutputInfo(m.name, typeInfo, location.name, locationValue);
                    outputs.push(info);
                }
            }
        }
    }
    _getOutputInfo(type) {
        const location = this._getAttribute(type, "location") ||
            this._getAttribute(type, "builtin");
        if (location !== null) {
            const typeInfo = this._getTypeInfo(type, type.attributes);
            const locationValue = this._parseInt(location.value);
            const info = new OutputInfo("", typeInfo, location.name, locationValue);
            return info;
        }
        return null;
    }
    _getInputs(args, inputs = undefined) {
        if (inputs === undefined) {
            inputs = [];
        }
        for (const arg of args) {
            if (arg.type instanceof Struct) {
                this._getStructInputs(arg.type, inputs);
            }
            else {
                const input = this._getInputInfo(arg);
                if (input !== null) {
                    inputs.push(input);
                }
            }
        }
        return inputs;
    }
    _getStructInputs(struct, inputs) {
        for (const m of struct.members) {
            if (m.type instanceof Struct) {
                this._getStructInputs(m.type, inputs);
            }
            else {
                const input = this._getInputInfo(m);
                if (input !== null) {
                    inputs.push(input);
                }
            }
        }
    }
    _getInputInfo(node) {
        const location = this._getAttribute(node, "location") ||
            this._getAttribute(node, "builtin");
        if (location !== null) {
            const interpolation = this._getAttribute(node, "interpolation");
            const type = this._getTypeInfo(node.type, node.attributes);
            const locationValue = this._parseInt(location.value);
            const info = new InputInfo(node.name, type, location.name, locationValue);
            if (interpolation !== null) {
                info.interpolation = this._parseString(interpolation.value);
            }
            return info;
        }
        return null;
    }
    _parseString(s) {
        if (s instanceof Array) {
            s = s[0];
        }
        return s;
    }
    _parseInt(s) {
        if (s instanceof Array) {
            s = s[0];
        }
        const n = parseInt(s);
        return isNaN(n) ? s : n;
    }
    _getAlias(name) {
        for (const a of this.aliases) {
            if (a.name == name) {
                return a.type;
            }
        }
        return null;
    }
    _getAliasInfo(node) {
        return new AliasInfo(node.name, this._getTypeInfo(node.type, null));
    }
    _getTypeInfo(type, attributes) {
        if (this._types.has(type)) {
            return this._types.get(type);
        }
        if (type instanceof ArrayType) {
            const a = type;
            const t = a.format ? this._getTypeInfo(a.format, a.attributes) : null;
            const info = new ArrayInfo(a.name, attributes);
            info.format = t;
            info.count = a.count;
            this._types.set(type, info);
            this._updateTypeInfo(info);
            return info;
        }
        if (type instanceof Struct) {
            const s = type;
            const info = new StructInfo(s.name, attributes);
            info.startLine = s.startLine;
            info.endLine = s.endLine;
            for (const m of s.members) {
                const t = this._getTypeInfo(m.type, m.attributes);
                info.members.push(new MemberInfo(m.name, t, m.attributes));
            }
            this._types.set(type, info);
            this._updateTypeInfo(info);
            return info;
        }
        if (type instanceof SamplerType) {
            const s = type;
            const formatIsType = s.format instanceof Type;
            const format = s.format
                ? formatIsType
                    ? this._getTypeInfo(s.format, null)
                    : new TypeInfo(s.format, null)
                : null;
            const info = new TemplateInfo(s.name, format, attributes, s.access);
            this._types.set(type, info);
            this._updateTypeInfo(info);
            return info;
        }
        if (type instanceof TemplateType) {
            const t = type;
            const format = t.format ? this._getTypeInfo(t.format, null) : null;
            const info = new TemplateInfo(t.name, format, attributes, t.access);
            this._types.set(type, info);
            this._updateTypeInfo(info);
            return info;
        }
        const info = new TypeInfo(type.name, attributes);
        this._types.set(type, info);
        this._updateTypeInfo(info);
        return info;
    }
    _updateTypeInfo(type) {
        var _a, _b;
        const typeSize = this._getTypeSize(type);
        type.size = (_a = typeSize === null || typeSize === void 0 ? void 0 : typeSize.size) !== null && _a !== void 0 ? _a : 0;
        if (type instanceof ArrayInfo) {
            if (type["format"]) {
                const formatInfo = this._getTypeSize(type["format"]);
                type.stride = (_b = formatInfo === null || formatInfo === void 0 ? void 0 : formatInfo.size) !== null && _b !== void 0 ? _b : 0;
                this._updateTypeInfo(type["format"]);
            }
        }
        if (type instanceof StructInfo) {
            this._updateStructInfo(type);
        }
    }
    _updateStructInfo(struct) {
        var _a;
        let offset = 0;
        let lastSize = 0;
        let lastOffset = 0;
        let structAlign = 0;
        for (let mi = 0, ml = struct.members.length; mi < ml; ++mi) {
            const member = struct.members[mi];
            const sizeInfo = this._getTypeSize(member);
            if (!sizeInfo) {
                continue;
            }
            (_a = this._getAlias(member.type.name)) !== null && _a !== void 0 ? _a : member.type;
            const align = sizeInfo.align;
            const size = sizeInfo.size;
            offset = this._roundUp(align, offset + lastSize);
            lastSize = size;
            lastOffset = offset;
            structAlign = Math.max(structAlign, align);
            member.offset = offset;
            member.size = size;
            this._updateTypeInfo(member.type);
        }
        struct.size = this._roundUp(structAlign, lastOffset + lastSize);
        struct.align = structAlign;
    }
    _getTypeSize(type) {
        var _a, _b;
        if (type === null || type === undefined) {
            return null;
        }
        const explicitSize = this._getAttributeNum(type.attributes, "size", 0);
        const explicitAlign = this._getAttributeNum(type.attributes, "align", 0);
        if (type instanceof MemberInfo) {
            type = type.type;
        }
        if (type instanceof TypeInfo) {
            const alias = this._getAlias(type.name);
            if (alias !== null) {
                type = alias;
            }
        }
        {
            const info = WgslReflect._typeInfo[type.name];
            if (info !== undefined) {
                const divisor = ((_a = type["format"]) === null || _a === void 0 ? void 0 : _a.name) === "f16" ? 2 : 1;
                return new _TypeSize(Math.max(explicitAlign, info.align / divisor), Math.max(explicitSize, info.size / divisor));
            }
        }
        {
            const info = WgslReflect._typeInfo[type.name.substring(0, type.name.length - 1)];
            if (info) {
                const divisor = type.name[type.name.length - 1] === "h" ? 2 : 1;
                return new _TypeSize(Math.max(explicitAlign, info.align / divisor), Math.max(explicitSize, info.size / divisor));
            }
        }
        if (type instanceof ArrayInfo) {
            let arrayType = type;
            let align = 8;
            let size = 8;
            // Type                 AlignOf(T)          Sizeof(T)
            // array<E, N>          AlignOf(E)          N * roundUp(AlignOf(E), SizeOf(E))
            // array<E>             AlignOf(E)          N * roundUp(AlignOf(E), SizeOf(E))  (N determined at runtime)
            //
            // @stride(Q)
            // array<E, N>          AlignOf(E)          N * Q
            //
            // @stride(Q)
            // array<E>             AlignOf(E)          Nruntime * Q
            //const E = type.format.name;
            const E = this._getTypeSize(arrayType.format);
            if (E !== null) {
                size = E.size;
                align = E.align;
            }
            const N = arrayType.count;
            const stride = this._getAttributeNum((_b = type === null || type === void 0 ? void 0 : type.attributes) !== null && _b !== void 0 ? _b : null, "stride", this._roundUp(align, size));
            size = N * stride;
            if (explicitSize) {
                size = explicitSize;
            }
            return new _TypeSize(Math.max(explicitAlign, align), Math.max(explicitSize, size));
        }
        if (type instanceof StructInfo) {
            let align = 0;
            let size = 0;
            // struct S     AlignOf:    max(AlignOfMember(S, M1), ... , AlignOfMember(S, MN))
            //              SizeOf:     roundUp(AlignOf(S), OffsetOfMember(S, L) + SizeOfMember(S, L))
            //                          Where L is the last member of the structure
            let offset = 0;
            let lastSize = 0;
            let lastOffset = 0;
            for (const m of type.members) {
                const mi = this._getTypeSize(m.type);
                if (mi !== null) {
                    align = Math.max(mi.align, align);
                    offset = this._roundUp(mi.align, offset + lastSize);
                    lastSize = mi.size;
                    lastOffset = offset;
                }
            }
            size = this._roundUp(align, lastOffset + lastSize);
            return new _TypeSize(Math.max(explicitAlign, align), Math.max(explicitSize, size));
        }
        return null;
    }
    _isUniformVar(node) {
        return node instanceof Var && node.storage == "uniform";
    }
    _isStorageVar(node) {
        return node instanceof Var && node.storage == "storage";
    }
    _isTextureVar(node) {
        return (node instanceof Var &&
            node.type !== null &&
            WgslReflect._textureTypes.indexOf(node.type.name) != -1);
    }
    _isSamplerVar(node) {
        return (node instanceof Var &&
            node.type !== null &&
            WgslReflect._samplerTypes.indexOf(node.type.name) != -1);
    }
    _getAttribute(node, name) {
        const obj = node;
        if (!obj || !obj["attributes"]) {
            return null;
        }
        const attrs = obj["attributes"];
        for (let a of attrs) {
            if (a.name == name) {
                return a;
            }
        }
        return null;
    }
    _getAttributeNum(attributes, name, defaultValue) {
        if (attributes === null) {
            return defaultValue;
        }
        for (let a of attributes) {
            if (a.name == name) {
                let v = a !== null && a.value !== null ? a.value : defaultValue;
                if (v instanceof Array) {
                    v = v[0];
                }
                if (typeof v === "number") {
                    return v;
                }
                if (typeof v === "string") {
                    return parseInt(v);
                }
                return defaultValue;
            }
        }
        return defaultValue;
    }
    _roundUp(k, n) {
        return Math.ceil(n / k) * k;
    }
}
// Type                 AlignOf(T)          Sizeof(T)
// i32, u32, or f32     4                   4
// atomic<T>            4                   4
// vec2<T>              8                   8
// vec3<T>              16                  12
// vec4<T>              16                  16
// mat2x2<f32>          8                   16
// mat3x2<f32>          8                   24
// mat4x2<f32>          8                   32
// mat2x3<f32>          16                  32
// mat3x3<f32>          16                  48
// mat4x3<f32>          16                  64
// mat2x4<f32>          16                  32
// mat3x4<f32>          16                  48
// mat4x4<f32>          16                  64
WgslReflect._typeInfo = {
    f16: { align: 2, size: 2 },
    i32: { align: 4, size: 4 },
    u32: { align: 4, size: 4 },
    f32: { align: 4, size: 4 },
    atomic: { align: 4, size: 4 },
    vec2: { align: 8, size: 8 },
    vec3: { align: 16, size: 12 },
    vec4: { align: 16, size: 16 },
    mat2x2: { align: 8, size: 16 },
    mat3x2: { align: 8, size: 24 },
    mat4x2: { align: 8, size: 32 },
    mat2x3: { align: 16, size: 32 },
    mat3x3: { align: 16, size: 48 },
    mat4x3: { align: 16, size: 64 },
    mat2x4: { align: 16, size: 32 },
    mat3x4: { align: 16, size: 48 },
    mat4x4: { align: 16, size: 64 },
};
WgslReflect._textureTypes = TokenTypes.any_texture_type.map((t) => {
    return t.name;
});
WgslReflect._samplerTypes = TokenTypes.sampler_type.map((t) => {
    return t.name;
});

class DynamicBuffer {
    constructor(bindgroupMapping, pool) {
        this.version = 0;
        this.bindgroupMapping = bindgroupMapping;
        this.pool = pool;
        this.allocation = {};
    }
    writeBuffer(uniformValues, dynamicOffsets) {
        const mapping = this.bindgroupMapping;
        const totalSize = mapping.totalSize;
        const gpuBuffer = this.allocation.gpuBuffer;
        const bufferAlignment = this.pool.bufferAlignment;
        this.pool.alloc(this.allocation, totalSize);
        if (gpuBuffer !== this.allocation.gpuBuffer) {
            this.version++;
        }
        let dynamicOffset = this.allocation.offset;
        const storage = this.allocation.storage;
        for (let i = 0; i < mapping.length; i++) {
            const uniform = mapping[i];
            const binding = uniform.binding;
            // if (mesh) {
            //     const key = uniform.group + '-' + binding;
            //     const format = mesh && mesh.getGPUUniformFormat(commandID, key);
            //     if (format) {
            //         // mesh 中已经缓存过该uniform结构体的 arraybuffer
            //         dynamicOffsets.addItem(binding, dynamicOffset);
            //         // format中的值和dynamicBuffer中的值是一致的，因此不再需要整体更新
            //         const needFlush = format.dynamicOffset !== dynamicOffset || format.bufferVersion !== bufferVersion;
            //         const { buffer, outsideUniforms } = format;
            //         if (needFlush) {
            //             const array = new Float32Array(storage, dynamicOffset, buffer.byteLength / 4);
            //             array.set(new Float32Array(buffer));
            //         }
            //         if (outsideUniforms.length) {
            //             for (let j = 0; j < outsideUniforms.length; j++) {
            //                 const offset = outsideUniforms[j].offset + dynamicOffset;
            //                 const value = uniformValues[outsideUniforms[j].name] as number | number[];
            //                 if (value === undefined) {
            //                     console.warn(`Uniform value ${outsideUniforms[j].name} is not provided`);
            //                 }
            //                 this._fillValue(outsideUniforms[j].type, storage, offset, outsideUniforms[j].size, value);
            //             }
            //         }
            //         format.bufferVersion = bufferVersion;
            //         format.dynamicOffset = dynamicOffset;
            //         const uniformSize = isFunction(uniform.size) ? uniform.size() : uniform.size;
            //         dynamicOffset += roundUp(uniformSize, bufferAlignment);
            //         continue;
            //     }
            // }
            const members = uniform.members;
            if (members) {
                dynamicOffsets.addItem(binding, dynamicOffset);
                for (let j = 0; j < members.length; j++) {
                    const member = members[j];
                    const value = uniformValues[member.name];
                    if (value === undefined) {
                        console.warn(`Uniform value ${member.name} is not provided`);
                    }
                    const offset = dynamicOffset + member.offset;
                    const size = member.size;
                    this._fillValue(member.type, storage, offset, size, value);
                }
                dynamicOffset += roundUp(uniform.size, bufferAlignment);
            }
            else if (uniform.resourceType === ResourceType.Uniform) {
                dynamicOffsets.addItem(binding, dynamicOffset);
                const value = uniformValues[uniform.name];
                const size = isFunction$1(uniform.size) ? uniform.size() : uniform.size;
                this._fillValue(uniform.type, storage, dynamicOffset, size, value);
                dynamicOffset += roundUp(size, bufferAlignment);
            }
        }
        // console.log(debugInfo.join());
    }
    _fillValue(type, buffer, offset, size, value) {
        // we always use f32 in WGSL
        const view = new Float32Array(buffer, offset, size / 4);
        if (isArray(value)) {
            const padding = isPaddingType(type);
            if (!padding) {
                view.set(value);
                return;
            }
            // 需要padding的类型参考:
            // https://github.com/greggman/webgpu-utils/blob/dev/src/wgsl-types.ts
            // wgsl 1.0中只会隔3个字节，pad一个字节
            for (let i = 0; i < value.length; i++) {
                const col = Math.floor(i / 3);
                const row = i % 3;
                view[col * 4 + row] = value[i];
            }
        }
        else {
            view[0] = value;
        }
    }
    dispose() {
        delete this.pool;
        delete this.allocation;
    }
}

const tempMat4 = new Array(16);
let uuid$1 = 0;
/**
 * Config:
 *  transparent, castShadow
 */
class Mesh {
    constructor(geometry, material, config = {}) {
        this._version = 0;
        this._texVersion = 0;
        this._geometry = geometry;
        this._material = material;
        // this._bindedOnMaterialUpdate = (...args) => {
        //     return this._OnMaterialUpdate.call(this, ...args);
        // };
        // if (material) {
        //     material.on('set', this._bindedOnMaterialUpdate);
        // }
        // this.config = config;
        this.transparent = !!config.transparent;
        this.bloom = !!config.bloom;
        this.ssr = !!config.ssr;
        this._castShadow = isNil$2(config.castShadow) || config.castShadow;
        this.needUpdateShadow = false;
        this.picking = !!config.picking;
        this.disableVAO = !!config.disableVAO;
        this.uniforms = {};
        this._localTransform = mat4.identity(new Array(16));
        this._positionMatrix = mat4.identity(new Array(16));
        this.properties = {};
        this._dirtyUniforms = true;
        this._dirtyGeometry = true;
        Object.defineProperty(this, 'uuid', {
            value: uuid$1++
        });
        if (uuid$1 > Number.MAX_VALUE - 10) {
            uuid$1 = 0;
        }
    }
    set material(v) {
        if (this._material !== v) {
            // if (this._material) {
            //     this._material.off('set', this._bindedOnMaterialUpdate);
            // }
            // if (v) {
            //     v.on('set', this._bindedOnMaterialUpdate);
            // }
            this.setMaterial(v);
        }
    }
    get material() {
        return this._material;
    }
    set version(v) {
        throw new Error('Mesh.version is read only.');
    }
    get version() {
        return this._version;
    }
    get textureVersion() {
        return this._texVersion;
    }
    get geometry() {
        return this._geometry;
    }
    set geometry(geo) {
        if (this._geometry !== geo) {
            this._incrVersion();
            this._dirtyGeometry = true;
        }
        this._geometry = geo;
    }
    set localTransform(m) {
        if (!this._prevTMat) {
            this._prevTMat = new Array(16);
        }
        if (Array.isArray(m) && !mat4.exactEquals(this._prevTMat, m)) {
            this._incrVersion();
            this._prevTMat = mat4.copy(this._prevTMat, m);
        }
        this._localTransform = m;
    }
    get localTransform() {
        return isFunction$1(this._localTransform) ? this._localTransform() : this._localTransform;
    }
    set positionMatrix(m) {
        if (!this._prevPMat) {
            this._prevPMat = new Array(16);
        }
        if (Array.isArray(m) && !mat4.exactEquals(this._prevPMat, m)) {
            this._incrVersion();
            this._prevPMat = mat4.copy(this._prevPMat, m);
        }
        this._positionMatrix = m;
    }
    get positionMatrix() {
        return isFunction$1(this._positionMatrix) ? this._positionMatrix() : this._positionMatrix;
    }
    get config() {
        if (!this._options) {
            this._options = {};
        }
        this._options['transparent'] = this.transparent;
        this._options['castShadow'] = this.castShadow;
        this._options['bloom'] = this.bloom;
        this._options['ssr'] = this.ssr;
        this._options['picking'] = this.picking;
        return this._options;
    }
    get defines() {
        return this._getDefines();
    }
    set defines(v) {
        this.setDefines(v);
    }
    get castShadow() {
        return this._castShadow && (!this.material || !this.material.unlit);
    }
    set castShadow(v) {
        this._castShadow = v;
    }
    setMaterial(material) {
        this._material = material;
        this._dirtyUniforms = true;
        delete this._materialVer;
        this.dirtyDefines = true;
        return this;
    }
    setParent(parent) {
        this.parent = parent;
        return this;
    }
    setLocalTransform(transform) {
        this.localTransform = transform;
        return this;
    }
    setPositionMatrix(matrix) {
        this.positionMatrix = matrix;
    }
    setUniform(k, v) {
        if (this.uniforms[k] === v) {
            return this;
        }
        if (isTextureLike(v)) {
            this._texVersion++;
        }
        this._updateUniformState(k);
        this.uniforms[k] = v;
        // this._updateGPUUniformFormat(k, v);
        return this;
    }
    setFunctionUniform(k, fn) {
        // if (!Object.getOwnPropertyDescriptor(this.uniforms, k)) {
        //     if (this._meshUniformFormats) {
        //         this._meshUniformFormats = {};
        //     }
        // }
        this._updateUniformState(k);
        Object.defineProperty(this.uniforms, k, {
            enumerable: true,
            get: fn
        });
        return this;
    }
    hasFunctionUniform(k) {
        if (!this.uniforms) {
            return false;
        }
        return Object.prototype.hasOwnProperty.call(this.uniforms, k);
    }
    //@internal
    _updateUniformState(k) {
        if (this.uniforms[k] === undefined) {
            this._dirtyUniforms = true;
        }
        else {
            this._dirtyProps = this._dirtyProps || [];
            this._dirtyProps.push(k);
        }
    }
    hasUniform(k) {
        if (this._realUniforms) {
            return this._realUniforms[k] !== undefined;
        }
        return this.uniforms[k] !== undefined;
    }
    getUniform(k) {
        return this.uniforms[k];
    }
    getDefines() {
        const defines = {};
        extend$1(defines, this._getDefines());
        if (this._material && this._geometry) {
            this._material.appendDefines(defines, this._geometry);
        }
        return defines;
    }
    //@internal
    _getDefines() {
        if (!this._defines) {
            this._defines = {};
        }
        const geometry = this._geometry;
        const { positionAttribute, uv0Attribute, normalAttribute } = geometry.desc;
        const position = geometry.data[positionAttribute], texcoord = geometry.data[uv0Attribute], normal = geometry.data[normalAttribute];
        if (position && position.quantization) {
            this._defines['HAS_DRACO_POSITION'] = 1;
        }
        if (texcoord && texcoord.quantization) {
            this._defines['HAS_DRACO_TEXCOORD'] = 1;
        }
        if (normal && normal.quantization) {
            this._defines['HAS_DRACO_NORMAL'] = 1;
        }
        return this._defines;
    }
    setDefines(defines) {
        const bak = this._bakDefines;
        this._defines = defines;
        this.dirtyDefines = !!bak !== !!defines || !equalDefine(bak, defines);
        return this;
    }
    hasSkinAnimation() {
        return this._material && this._material.hasSkinAnimation();
    }
    //@internal
    _getDefinesKey() {
        this._bakDefines = extend$1({}, this._defines);
        this.dirtyDefines = false;
        return this._createDefinesKey(this.getDefines());
    }
    //eslint-disable-next-line
    getCommandKey(device) {
        if (!this._commandKey || this.dirtyDefines || (this._material && this._materialKeys !== this._material.getUniformKeys())) {
            //TODO geometry的data变动也可能会改变commandKey，但鉴于geometry一般不会发生变化，暂时不管
            let dKey = this.geometry.getCommandKey(device) + '_' + this._getDefinesKey();
            const elementType = isNumber$2(this.getElements()) ? 'count' : 'elements';
            dKey += '_' + elementType;
            dKey += '_' + +(!!this.disableVAO);
            if (this._material) {
                dKey += '_' + +(!!this._material.doubleSided);
            }
            this._commandKey = dKey;
            if (this._material) {
                this._materialKeys = this._material.getUniformKeys();
            }
        }
        return this._commandKey;
    }
    // getUniforms(regl) {
    //     const uniforms = {
    //         'modelMatrix': this._localTransform
    //     };
    //     if (this._material) {
    //         const materialUniforms = this._material.getUniforms(regl);
    //         extend(uniforms, materialUniforms);
    //     }
    //     extend(uniforms, this.uniforms);
    //     return uniforms;
    // }
    getRenderProps(device) {
        const props = this.getUniforms(device);
        props.meshProperties = this.properties;
        props.geometryProperties = this._geometry.properties;
        props.meshConfig = this.config;
        props.count = this._geometry.getDrawCount();
        props.offset = this._geometry.getDrawOffset();
        // command primitive : triangle, triangle strip, etc
        props.primitive = this._geometry.getPrimitive();
        return props;
    }
    //@internal
    _getGeometryAttributes(device, activeAttributes) {
        return this._geometry.getREGLData(device, activeAttributes, this.disableVAO);
    }
    appendGeoAttributes(props, device, activeAttributes) {
        extend$1(props, this._getGeometryAttributes(device, activeAttributes));
        if (!isSupportVAO(device) || this.disableVAO) {
            props.elements = this._geometry.getElements();
        }
    }
    getUniforms(device) {
        if (this._dirtyUniforms || this._dirtyGeometry || this._material && this._materialVer !== this._material.version) {
            this._uniformDescriptors = new Set();
            this._realUniforms = {};
            this._prepareUniformsForDraco();
            const uniforms = this.uniforms;
            for (const p in this.uniforms) {
                if (hasOwn$1(this.uniforms, p)) {
                    const descriptor = Object.getOwnPropertyDescriptor(uniforms, p);
                    if (descriptor.get) {
                        this._uniformDescriptors.add(p);
                        Object.defineProperty(this._realUniforms, p, {
                            enumerable: true,
                            configurable: true,
                            get: function () {
                                return uniforms[p];
                            }
                        });
                    }
                    else {
                        this._realUniforms[p] = uniforms[p];
                    }
                }
            }
            if (this._material) {
                const materialUniforms = this._material.getUniforms(device);
                for (const p in materialUniforms) {
                    if (hasOwn$1(materialUniforms, p) && !hasOwn$1(this._realUniforms, p)) {
                        const descriptor = Object.getOwnPropertyDescriptor(materialUniforms, p);
                        if (descriptor.get) {
                            this._uniformDescriptors.add(p);
                            Object.defineProperty(this._realUniforms, p, {
                                enumerable: true,
                                configurable: true,
                                get: function () {
                                    return materialUniforms[p];
                                }
                            });
                        }
                        else if (this._realUniforms[p] === undefined) {
                            this._realUniforms[p] = materialUniforms[p];
                        }
                    }
                }
            }
            this._dirtyUniforms = false;
            this._dirtyGeometry = false;
            this._materialVer = this._material && this._material.version;
            this._materialPropVer = this._material && this._material.propVersion;
            this._dirtyProps = null;
        }
        else if (this._dirtyProps || this._material && this._material.propVersion !== this._materialPropVer) {
            if (this._dirtyProps) {
                for (const p of this._dirtyProps) {
                    this._realUniforms[p] = this.uniforms[p];
                }
            }
            if (this._material && this._material.propVersion !== this._materialPropVer) {
                const materialUniforms = this._material.getUniforms(device);
                for (const p in materialUniforms) {
                    if (hasOwn$1(materialUniforms, p) && !this._uniformDescriptors.has(p)) {
                        const descriptor = Object.getOwnPropertyDescriptor(materialUniforms, p);
                        if (!descriptor.get && this._realUniforms[p] !== materialUniforms[p]) {
                            this._realUniforms[p] = materialUniforms[p];
                        }
                    }
                }
                this._materialPropVer = this._material.propVersion;
            }
            this._dirtyProps = null;
        }
        this._realUniforms['modelMatrix'] = this.localTransform;
        this._realUniforms['positionMatrix'] = this.positionMatrix;
        return this._realUniforms;
    }
    //@internal
    _prepareUniformsForDraco() {
        const geometry = this._geometry;
        const position = geometry.data[geometry.desc.positionAttribute], texcoord = geometry.data[geometry.desc.uv0Attribute], normal = geometry.data[geometry.desc.normalAttribute];
        if (position && position.quantization) {
            const quantization = position.quantization;
            const gltf_u_dec_position_normConstant = quantization.range / (1 << quantization.quantizationBits);
            this._realUniforms['minValues_pos'] = quantization.minValues;
            this._realUniforms['gltf_u_dec_position_normConstant'] = gltf_u_dec_position_normConstant;
        }
        if (texcoord && texcoord.quantization) {
            const quantization = texcoord.quantization;
            this._realUniforms['minValues_tex'] = quantization.minValues;
            const gltf_u_dec_texcoord_0_normConstant = quantization.range / (1 << quantization.quantizationBits);
            this._realUniforms['gltf_u_dec_texcoord_0_normConstant'] = gltf_u_dec_texcoord_0_normConstant;
        }
        if (normal && normal.quantization) {
            const quantization = normal.quantization;
            const gltf_u_dec_normal_rangeConstant = (1 << quantization.quantizationBits) - 1.0;
            this._realUniforms['gltf_u_dec_normal_rangeConstant'] = gltf_u_dec_normal_rangeConstant;
        }
    }
    getMaterial() {
        return this._material;
    }
    getElements() {
        return this._geometry.getElements();
    }
    dispose() {
        delete this._geometry;
        // if (this._material) {
        //     this._material.off('set', this._bindedOnMaterialUpdate);
        // }
        delete this._material;
        delete this._bindGroupCache;
        delete this._commandKeyCache;
        this.uniforms = null;
        if (this._meshBuffer) {
            for (const key in this._meshBuffer) {
                this._meshBuffer[key].dispose();
            }
            delete this._meshBuffer;
        }
        return this;
    }
    isValid() {
        return this._geometry && !this._geometry.isDisposed() && (!this._material || !this._material.isDisposed());
    }
    getBoundingBox() {
        if (!this._geometry) {
            return null;
        }
        if (!this._bbox) {
            this.updateBoundingBox();
        }
        mat4.multiply(tempMat4, this.localTransform, this.positionMatrix);
        //如果Mesh的localTransform * positionMatrix发生了变化，或者geometry的boundingBox发生变化，则需要更新bbox
        if (!mat4.exactEquals(tempMat4, this._currentTransform) || !this._geometry.boundingBox.equals(this._geoBox)) {
            this.updateBoundingBox();
        }
        return this._bboxArr;
    }
    updateBoundingBox() {
        const box = this._geometry.boundingBox;
        if (!this._bbox) {
            this._bbox = new BoundingBox();
        }
        if (!this._bboxArr) {
            this._bboxArr = [[0, 0, 0], [0, 0, 0]];
        }
        if (!this._geoBox) {
            this._geoBox = new BoundingBox();
        }
        BoundingBox.copy(this._bbox, box);
        this._bbox.updateVertex();
        if (this.constructor.name === 'InstancedMesh') {
            this._bbox.transform(this.localTransform, this.positionMatrix);
            this._currentTransform = mat4.multiply(this._currentTransform || new Array(16), this.positionMatrix, this.localTransform);
        }
        else {
            this._bbox.transform(this.positionMatrix, this.localTransform);
            this._currentTransform = mat4.multiply(this._currentTransform || new Array(16), this.localTransform, this.positionMatrix);
        }
        BoundingBox.copy(this._geoBox, box);
        vec3.copy(this._bboxArr[0], this._bbox.min);
        vec3.copy(this._bboxArr[1], this._bbox.max);
    }
    //@internal
    _createDefinesKey(defines) {
        const v = [];
        for (const p in defines) {
            v.push(p, defines[p]);
        }
        return v.join(',');
    }
    //@internal
    _incrVersion() {
        this._version++;
    }
    getMemorySize() {
        return (this.geometry && this.geometry.getMemorySize() || 0) + (this.material && this.material.getMemorySize() || 0);
    }
    getWorldTransform() {
        const parent = this.parent;
        if (parent) {
            return mat4.multiply(new Array(16), parent.getWorldTransform(), this.localTransform);
        }
        return this.localTransform;
    }
    // 实现webgpu相关的逻辑
    writeDynamicBuffer(commandUID, renderProps, bindGroupMapping, pool, dynamicOffsets) {
        if (!this._meshBuffer) {
            this._meshBuffer = {};
        }
        let meshBuffer = this._meshBuffer[commandUID];
        if (!meshBuffer) {
            meshBuffer = this._meshBuffer[commandUID] = new DynamicBuffer(bindGroupMapping, pool);
        }
        // this.setGPUUniformFormat(commandUID, bindGroupMapping);
        // meshBuffer.writeMeshBuffer(renderProps, dynamicOffsets, commandUID, this);
        meshBuffer.writeBuffer(renderProps, dynamicOffsets);
        return meshBuffer;
    }
    getBindGroup(key) {
        if (!this._bindGroupCache) {
            this._bindGroupCache = {};
        }
        return this._bindGroupCache[key];
    }
    setBindGroup(key, bindGroup) {
        this._bindGroupCache[key] = bindGroup;
        return this;
    }
    getShaderFnValues(shaderUID) {
        if (!this._commandKeyCache) {
            return null;
        }
        return this._commandKeyCache[shaderUID];
    }
    setShaderFnValues(shaderUID, fnValues) {
        if (!this._commandKeyCache) {
            this._commandKeyCache = {};
        }
        this._commandKeyCache[shaderUID] = fnValues;
        return this;
    }
}
function equalDefine(obj0, obj1) {
    if (!obj0 && !obj1) {
        return true;
    }
    const props0 = Object.getOwnPropertyNames(obj0);
    const props1 = Object.getOwnPropertyNames(obj1);
    if (props0.length !== props1.length) {
        return false;
    }
    for (let i = 0; i < props0.length; i++) {
        if (obj0[props0[i]] !== obj1[props0[i]]) {
            return false;
        }
    }
    return true;
}

class InstancedMesh extends Mesh {
    constructor(instancedData, instanceCount, geometry, material, config = {}) {
        super(geometry, material, config);
        this._instanceCount = instanceCount;
        this.instancedData = instancedData || {};
        this._checkInstancedProp();
        this._vao = {};
    }
    get instanceCount() {
        return this._instanceCount;
    }
    set instanceCount(count) {
        this._incrVersion();
        this._instanceCount = count;
    }
    getMemorySize() {
        // TODO 需要确认是否是 mesh.memorySize * instanceCount
        return super.getMemorySize() + this._getInstanceMemorySize();
    }
    //@internal
    _getInstanceMemorySize() {
        let size = 0;
        for (const p in this.instancedData) {
            if (hasOwn$1(this.instancedData, p)) {
                size += getBufferSize(this.instancedData[p]);
            }
        }
        return size;
    }
    //@internal
    _checkInstancedProp() {
        for (const p in this.instancedData) {
            if (this.geometry.data[p]) {
                throw new Error(`Duplicate attribute ${p} defined in geometry and instanced data`);
            }
        }
    }
    //@internal
    appendGeoAttributes(props, regl, activeAttributes) {
        // 只需要获得 geometry的 attr 数据，不需要elements
        const geoBuffers = this.geometry.getAttrData(activeAttributes);
        if (isSupportVAO(regl)) {
            const key = activeAttributes.key;
            if (!this._vao[key] || this._vao[key].dirty) {
                const attributes = activeAttributes.map(attr => attr.name);
                const buffers = [];
                for (let i = 0; i < attributes.length; i++) {
                    const data = geoBuffers[attributes[i]];
                    const buffer = data && data.buffer || this.instancedData[attributes[i]];
                    buffers.push(buffer);
                }
                const vaoData = {
                    attributes: buffers,
                    primitive: this.geometry.getPrimitive()
                };
                // const elements = this.geometry.getElements();
                // if (elements && !isNumber(elements)) {
                //     vaoData.elements = {
                //         primitive: this.geometry.getPrimitive(),
                //         data: elements
                //     };
                //     const type = this.geometry.getElementsType(elements);
                //     if (type) {
                //         vaoData.elements.type = type;
                //     }
                // }
                // console.log(vaoData);
                if (this._vao[key]) {
                    this._vao[key].vao(vaoData);
                }
                else {
                    this._vao[key] = {
                        vao: regl.vao(vaoData)
                    };
                }
                delete this._vao[key].dirty;
            }
            extend$1(props, this._vao[key]);
        }
        else {
            extend$1(props, geoBuffers);
        }
    }
    getDefines() {
        const defines = super.getDefines();
        defines['HAS_INSTANCE'] = 1;
        return defines;
    }
    getCommandKey(device) {
        return 'i_' + super.getCommandKey(device);
    }
    //因为 updateBoundingBox 需要， 不再自动生成buffer，而是把原有的buffer销毁
    //调用 updateInstancedData 后，需要调用 updateBoundingBox 更新bbox, 再调用 generateInstancedBuffers 来重新生成 buffer
    updateInstancedData(name, data) {
        const buf = this.instancedData[name];
        // if (!buf) {
        //     return this;
        // }
        this._incrVersion();
        // let buffer;
        this.instancedData[name] = data;
        if (buf && buf.buffer && buf.buffer.destroy) {
            buf.buffer.destroy();
        }
        // if (buffer) {
        //     const bytesPerElement = this._getBytesPerElement(buffer.buffer._buffer.dtype);
        //     const len = buffer.buffer._buffer.byteLength / bytesPerElement;
        //     if (len >= data.length && bytesPerElement >= (data.BYTES_PER_ELEMENT || 0)) {
        //         buffer.buffer.subdata(data);
        //     } else {
        //         buffer.buffer(data);
        //     }
        //     this.instancedData[name] = buffer;
        // }
        if (this._vao) {
            for (const key in this._vao) {
                this._vao[key].dirty = true;
            }
        }
        return this;
    }
    getInstancedBuffer(name) {
        return this.instancedData[name] && this.instancedData[name].buffer;
    }
    generateInstancedBuffers(device) {
        const isWebGPU = !!device && device.wgpu;
        const data = this.instancedData;
        const instanceCount = this.instanceCount;
        const buffers = {};
        for (const key in data) {
            if (!data[key]) {
                continue;
            }
            if (Array.isArray(data[key])) {
                data[key] = new Float32Array(data[key]);
            }
            else if (isWebGPU && isArray(data[key])) {
                data[key] = Geometry.padGPUBufferAlignment(data[key], instanceCount, true);
            }
            const attrBuf = data[key];
            if (attrBuf.buffer !== undefined && attrBuf.buffer.destroy) {
                buffers[key] = attrBuf;
                if (buffers[key].divisor) {
                    buffers[key].divisor = 1;
                }
            }
            else if (data[key].destroy) {
                buffers[key] = {
                    buffer: data[key],
                    divisor: 1
                };
            }
            else {
                const bufferOptions = {
                    data: data[key],
                    dimension: data[key].length / this._instanceCount
                };
                buffers[key] = {
                    buffer: Geometry.createBuffer(device, bufferOptions, key),
                    divisor: 1
                };
            }
        }
        this.instancedData = buffers;
        return this;
    }
    getRenderProps(regl) {
        const props = super.getRenderProps(regl);
        if (!isSupportVAO(regl)) {
            extend$1(props, this.instancedData);
        }
        props.elements = this.geometry.getElements();
        props.instances = this._instanceCount;
        return props;
    }
    disposeInstancedData() {
        const buffers = this.instancedData;
        if (buffers) {
            for (const p in buffers) {
                if (!buffers[p]) {
                    continue;
                }
                const buffer = buffers[p].destroy ? buffers[p] : buffers[p].buffer;
                if (buffer.destroy && !buffer[KEY_DISPOSED]) {
                    buffer[KEY_DISPOSED] = 1;
                    buffer.destroy();
                }
            }
        }
        this.instancedData = {};
        for (const p in this._vao) {
            this._vao[p].vao.destroy();
        }
        this._vao = {};
    }
    getBufferDescriptor(vertexInfo) {
        const attrInfos = [];
        for (const p in vertexInfo) {
            const info = vertexInfo[p];
            attrInfos[info.location] = info;
        }
        const data = this.instancedData;
        const bufferDesc = [];
        for (let i = 0; i < attrInfos.length; i++) {
            if (!attrInfos[i]) {
                continue;
            }
            const p = attrInfos[i].geoAttrName;
            const attr = data[p];
            if (!attr) {
                continue;
            }
            const info = vertexInfo[p];
            const desc = getAttrBufferDescriptor(attr, info);
            desc.stepMode = 'instance';
            bufferDesc[i] = desc;
        }
        return bufferDesc;
    }
}

const EMPTY_UNIFORMS = {};
/**
 * A basic renderer to render meshes in fashion of forward rendering
 */
class Renderer {
    constructor(device) {
        this.device = device;
    }
    render(shader, uniforms, scene, framebuffer) {
        //rendering of large number of lights can be accelarated by clip-space quadtree
        //https://stackoverflow.com/questions/30594511/webgl-fragment-shader-for-multiple-light-sources
        shader.setUniforms(uniforms || EMPTY_UNIFORMS);
        shader.setFramebuffer(framebuffer);
        let count = 0;
        if (scene) {
            const { opaques, transparents } = scene.getSortedMeshes();
            count += shader.draw(this.device, opaques);
            count += shader.draw(this.device, transparents);
        }
        else {
            count += shader.draw(this.device);
        }
        return count;
    }
    clear(options) {
        this.device.clear(options);
    }
    isWebGPU() {
        return !!this.device.wgpu;
    }
}

const Ajax =  {
    getArrayBuffer(url, cb) {
        return Ajax.get(url, {
            responseType : 'arraybuffer'
        }, cb);
    },

    get: function (url, options, cb) {
        const client = Ajax._getClient(cb);
        client.open('GET', url, true);
        if (options) {
            for (const k in options.headers) {
                client.setRequestHeader(k, options.headers[k]);
            }
            client.withCredentials = options.credentials === 'include';
            if (options['responseType']) {
                client.responseType = options['responseType'];
            }
        }
        client.send(null);
        return client;
    },

    _wrapCallback: function (client, cb) {
        return function () {
            if (client.readyState === 4) {
                if (client.status === 200) {
                    if (client.responseType === 'arraybuffer') {
                        const response = client.response;
                        if (response.byteLength === 0) {
                            cb(new Error('http status 200 returned without content.'));
                        } else {
                            cb(null, {
                                data: client.response,
                                cacheControl: client.getResponseHeader('Cache-Control'),
                                expires: client.getResponseHeader('Expires'),
                                contentType : client.getResponseHeader('Content-Type')
                            });
                        }
                    } else {
                        cb(null, client.responseText);
                    }
                } else {
                    cb(new Error(client.statusText + ',' + client.status));
                }
            }
        };
    },

    _getClient: function (cb) {
        /*eslint-disable no-empty, no-undef*/
        let client;
        try {
            client = new XMLHttpRequest();
        } catch (e) {
            try { client = new ActiveXObject('Msxml2.XMLHTTP'); } catch (e) {
                try { client = new ActiveXObject('Microsoft.XMLHTTP'); } catch (e) {}
            }
        }
        client.onreadystatechange = Ajax._wrapCallback(client, cb);
        return client;
        /*eslint-enable no-empty, no-undef*/
    },
};

class InnerResourceLoader {
    constructor(DEFAULT_TEXTURE, urlModifier) {
        this.defaultTexture = DEFAULT_TEXTURE;
        this.defaultCubeTexture = new Array(6);
        this.urlModifier = urlModifier;
        //TODO 把this.resources换成LRU队列，控制缓存的资源数量
        this.resources = {};
    }
    setURLModifier(urlModifier) {
        this.urlModifier = urlModifier;
    }
    get(url) {
        if (Array.isArray(url)) {
            return this._loadImages(url);
        }
        else {
            return this._loadImage(url);
        }
    }
    getArrayBuffer(url) {
        if (Array.isArray(url)) {
            const promises = url.map(u => this.getArrayBuffer(u));
            return Promise.all(promises);
        }
        else {
            return new Promise((resolve, reject) => {
                let realUrl = url;
                if (this.urlModifier) {
                    realUrl = this.urlModifier(url);
                }
                Ajax.getArrayBuffer(realUrl, (err, buffer) => {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve({ url, data: buffer });
                    }
                });
            });
        }
    }
    disposeRes(url) {
        if (Array.isArray(url)) {
            url.forEach(u => this._disposeOne(u));
        }
        else {
            this._disposeOne(url);
        }
        return this;
    }
    isLoading() {
        return this._count && this._count > 0;
    }
    getDefaultTexture(url) {
        if (!Array.isArray(url)) {
            return this.defaultTexture;
        }
        else {
            return this._getBlankTextures(url.length);
        }
    }
    //@internal
    _disposeOne(url) {
        const resources = this.resources;
        if (!resources[url]) {
            return;
        }
        resources[url].count--;
        if (resources[url].count <= 0) {
            delete resources[url];
        }
    }
    //@internal
    _loadImage(url) {
        const resources = this.resources;
        if (resources[url]) {
            return Promise.resolve({ url, data: resources[url].image });
        }
        const promise = new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = function () {
                resources[url] = {
                    image: img,
                    count: 1
                };
                resolve({ url, data: img });
            };
            img.onerror = function (err) {
                reject(err);
            };
            img.onabort = function () {
                reject(`image(${url}) loading aborted.`);
            };
            if (this.urlModifier) {
                img.src = this.urlModifier(url);
            }
            else {
                img.src = url;
            }
        });
        return promise;
    }
    //@internal
    _loadImages(urls) {
        const promises = urls.map(url => this._loadImage(url));
        const promise = Promise.all(promises);
        return promise;
    }
    //@internal
    _getBlankTextures(count) {
        const t = new Array(count);
        for (let i = 0; i < 6; i++) {
            t.push(this.defaultTexture);
        }
        return t;
    }
}
class ResourceLoader extends Eventable(InnerResourceLoader) {
}

const P0 = [0, 0, 0], P1 = [0, 0, 0];
let uid$2 = 0;
let CAM_POS;
function compare(a, b) {
    vec3.transformMat4(P0, a.geometry.boundingBox.getCenter(), a.localTransform);
    vec3.transformMat4(P1, b.geometry.boundingBox.getCenter(), b.localTransform);
    return vec3.dist(P1, CAM_POS) - vec3.dist(P0, CAM_POS);
}
class Scene {
    constructor(meshes) {
        this._id = uid$2++;
        this.sortedMeshes = {};
        this.setMeshes(meshes);
        this.dirty();
    }
    setMeshes(meshes) {
        this.clear();
        if (!meshes || (Array.isArray(meshes) && !meshes.length) || meshes === this.meshes) {
            return this;
        }
        meshes = Array.isArray(meshes) ? meshes : [meshes];
        this.meshes = [];
        for (let i = 0; i < meshes.length; i++) {
            const mesh = meshes[i];
            if (!mesh) {
                continue;
            }
            // mesh._scenes = mesh._scenes || {};
            // mesh._scenes[this._id] = 1;
            this.meshes.push(mesh);
        }
        this.dirty();
        return this;
    }
    addMesh(mesh) {
        if (!mesh || (Array.isArray(mesh) && !mesh.length)) {
            return this;
        }
        const meshes = Array.isArray(mesh) ? mesh : [mesh];
        for (let i = 0, len = meshes.length; i < len; i++) {
            const mesh = meshes[i];
            if (mesh && this.meshes.indexOf(mesh) === -1) {
                this.meshes.push(mesh);
                this.dirty();
            }
        }
        return this;
    }
    removeMesh(mesh) {
        if (!mesh || (Array.isArray(mesh) && !mesh.length)) {
            return this;
        }
        const meshes = Array.isArray(mesh) ? mesh : [mesh];
        const needRemoveMehes = [];
        for (let i = 0; i < meshes.length; i++) {
            const mesh = meshes[i];
            if (mesh && this.meshes.indexOf(mesh) >= 0) {
                needRemoveMehes.push(mesh);
            }
        }
        if (needRemoveMehes.length > 0) {
            const filterMeshes = [];
            for (let i = 0; i < this.meshes.length; i++) {
                const mesh = this.meshes[i];
                if (needRemoveMehes.indexOf(mesh) === -1) {
                    filterMeshes.push(mesh);
                }
            }
            this.meshes = filterMeshes;
            this.dirty();
        }
        return this;
    }
    // addMesh(mesh: Mesh | Mesh[]) {
    //     if (!mesh || (Array.isArray(mesh) && !mesh.length)) {
    //         return this;
    //     }
    //     const meshes = Array.isArray(mesh) ? mesh : [mesh];
    //     for (let i = 0, len = meshes.length; i < len; i++) {
    //         const m = meshes[i];
    //         const scenes = (m as any)._scenes = (m as any)._scenes || {};
    //         if (!scenes[this._id]) {
    //             scenes[this._id] = 1;
    //             this.meshes.push(m);
    //             this.dirty();
    //         }
    //     }
    //     return this;
    // }
    // removeMesh(mesh?: Mesh | Mesh[]) {
    //     if (!mesh || (Array.isArray(mesh) && !mesh.length)) { return this; }
    //     if (Array.isArray(mesh)) {
    //         let hit = false;
    //         for (let i = 0; i < mesh.length; i++) {
    //             const scenes = (mesh[i] as any)._scenes;
    //             if (scenes && scenes[this._id]) {
    //                 hit = true;
    //                 this.dirty();
    //                 delete scenes[this._id];
    //             }
    //         }
    //         if (hit) {
    //             this.meshes = this.meshes.filter(el => {
    //                 return mesh.indexOf(el) < 0;
    //             });
    //         }
    //     } else {
    //         const scenes = (mesh as any)._scenes;
    //         if (!scenes || !scenes[this._id]) {
    //             return this;
    //         }
    //         const idx = this.meshes.indexOf(mesh);
    //         if (idx >= 0) {
    //             this.meshes.splice(idx, 1);
    //         }
    //         delete scenes[this._id];
    //         this.dirty();
    //     }
    //     return this;
    // }
    getMeshes() {
        return this.meshes || [];
    }
    clear() {
        // if (this.meshes) {
        //     for (let i = 0; i < this.meshes.length; i++) {
        //         delete (this.meshes[i] as any)._scenes[this._id];
        //     }
        // }
        this.meshes = [];
        this.sortedMeshes.opaques = [];
        this.sortedMeshes.transparents = [];
        return this;
    }
    dirty() {
        this._dirty = true;
        return this;
    }
    sortMeshes(cameraPosition) {
        const meshes = this.meshes;
        if (this.sortFunction) {
            meshes.sort(this.sortFunction);
        }
        //sort meshes by defines
        let transparents = this.sortedMeshes.transparents;
        if (this._dirty) {
            const opaques = this.sortedMeshes.opaques = [];
            transparents = this.sortedMeshes.transparents = [];
            for (let i = 0, l = meshes.length; i < l; i++) {
                if (meshes[i].transparent) {
                    transparents.push(meshes[i]);
                }
                else {
                    opaques.push(meshes[i]);
                }
            }
        }
        // 即使是opaques，渲染顺序也不能随便改变，因为可能有stencil测试，或者depthMask等会因渲染顺序影响渲染效果的设置
        // opaques.sort((a, b) => {
        //     if (a.getDefinesKey() === b.getDefinesKey()) {
        //         return 0;
        //     }
        //     return 1;
        // });
        if (cameraPosition && transparents.length > 1) {
            CAM_POS = cameraPosition;
            transparents.sort(compare);
        }
        this._dirty = false;
    }
    getSortedMeshes() {
        if (this._dirty) {
            this.sortMeshes();
        }
        return this.sortedMeshes || {};
    }
}

/* eslint-disable no-var */
// import { clamp } from './Util.js';
const toChar = String.fromCharCode;
const MINELEN = 8;
const MAXELEN = 0x7fff;
function rgbe2float(rgbe, buffer, offset, exposure) {
    if (rgbe[3] > 0) {
        const f = Math.pow(2.0, rgbe[3] - 128 - 8 + exposure);
        buffer[offset + 0] = rgbe[0] * f;
        buffer[offset + 1] = rgbe[1] * f;
        buffer[offset + 2] = rgbe[2] * f;
    }
    else {
        buffer[offset + 0] = 0;
        buffer[offset + 1] = 0;
        buffer[offset + 2] = 0;
    }
    buffer[offset + 3] = 1.0;
    return buffer;
}
// function encodeRGBM(buffer: number[], offset: number, range: number) {
//     const r = buffer[offset] / range;
//     const g = buffer[offset + 1] / range;
//     const b = buffer[offset + 2] / range;
//     let a = clamp(Math.max(Math.max(r, g), Math.max(b, 1E-6)), 0, 1);
//     a = Math.ceil(a * 255) / 255;
//     buffer[offset] = Math.min(255, r / a * 255);
//     buffer[offset + 1] = Math.min(255, g / a * 255);
//     buffer[offset + 2] = Math.min(255, b / a * 255);
//     buffer[offset + 3] = Math.min(255, a * 255);
// }
function uint82string(array, offset, size) {
    let str = '';
    for (let i = offset; i < size; i++) {
        str += toChar(array[i]);
    }
    return str;
}
function copyrgbe(s, t) {
    t[0] = s[0];
    t[1] = s[1];
    t[2] = s[2];
    t[3] = s[3];
}
// TODO : check
function oldReadColors(scan, buffer, offset, xmax) {
    let rshift = 0, x = 0, len = xmax;
    while (len > 0) {
        scan[x][0] = buffer[offset++];
        scan[x][1] = buffer[offset++];
        scan[x][2] = buffer[offset++];
        scan[x][3] = buffer[offset++];
        if (scan[x][0] === 1 && scan[x][1] === 1 && scan[x][2] === 1) {
            // exp is count of repeated pixels
            for (let i = (scan[x][3] << rshift) >>> 0; i > 0; i--) {
                copyrgbe(scan[x - 1], scan[x]);
                x++;
                len--;
            }
            rshift += 8;
        }
        else {
            x++;
            len--;
            rshift = 0;
        }
    }
    return offset;
}
function readColors(scan, buffer, offset, xmax) {
    //@ts-expect-error 原始逻辑如此，忽略ts里的报错
    if ((xmax < MINELEN) | (xmax > MAXELEN)) {
        return oldReadColors(scan, buffer, offset, xmax);
    }
    let i = buffer[offset++];
    if (i !== 2) {
        return oldReadColors(scan, buffer, offset - 1, xmax);
    }
    scan[0][1] = buffer[offset++];
    scan[0][2] = buffer[offset++];
    i = buffer[offset++];
    if ((((scan[0][2] << 8) >>> 0) | i) >>> 0 !== xmax) {
        return null;
    }
    for (let i = 0; i < 4; i++) {
        for (let x = 0; x < xmax;) {
            let code = buffer[offset++];
            if (code > 128) {
                code = (code & 127) >>> 0;
                const val = buffer[offset++];
                while (code--) {
                    scan[x++][i] = val;
                }
            }
            else {
                while (code--) {
                    scan[x++][i] = buffer[offset++];
                }
            }
        }
    }
    return offset;
}
// http://www.graphics.cornell.edu/~bjw/rgbe.html
// Blender source
// http://radsite.lbl.gov/radiance/refer/Notes/picture_format.html
function parseRGBE(arrayBuffer, exposure = 0) {
    const data = new Uint8Array(arrayBuffer);
    const size = data.length;
    if (uint82string(data, 0, 2) !== '#?') {
        return null;
    }
    // find empty line, next line is resolution info
    for (var i = 2; i < size; i++) {
        if (toChar(data[i]) === '\n' && toChar(data[i + 1]) === '\n') {
            break;
        }
    }
    if (i >= size) { // not found
        return null;
    }
    // find resolution info line
    i += 2;
    let str = '';
    for (; i < size; i++) {
        const _char = toChar(data[i]);
        if (_char === '\n') {
            break;
        }
        str += _char;
    }
    // -Y M +X N
    const tmp = str.split(' ');
    const height = parseInt(tmp[1]);
    const width = parseInt(tmp[3]);
    if (!width || !height) {
        return null;
    }
    // read and decode actual data
    let offset = i + 1;
    const scanline = [];
    // memzero
    for (let x = 0; x < width; x++) {
        scanline[x] = [];
        for (let j = 0; j < 4; j++) {
            scanline[x][j] = 0;
        }
    }
    // let range = 0;
    const pixels = new Float32Array(width * height * 4);
    let offset2 = 0;
    for (let y = 0; y < height; y++) {
        offset = readColors(scanline, data, offset, width);
        if (!offset) {
            return null;
        }
        for (let x = 0; x < width; x++) {
            rgbe2float(scanline[x], pixels, offset2, exposure);
            // range = Math.max(range, pixels[offset2], pixels[offset2 + 1], pixels[offset2 + 2], pixels[offset2 + 3]);
            offset2 += 4;
        }
    }
    // range = Math.min(range, maxRange);
    // offset2 = 0;
    // for (let y = 0; y < height; y++) {
    //     for (let x = 0; x < width; x++) {
    //         encodeRGBM(pixels, offset2, range);
    //         offset2 += 4;
    //     }
    // }
    return {
        width: width,
        height: height,
        pixels: pixels
    };
}

// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf

const _tables = /*@__PURE__*/ _generateTables();

function _generateTables() {

	// float32 to float16 helpers

	const buffer = new ArrayBuffer( 4 );
	const floatView = new Float32Array( buffer );
	const uint32View = new Uint32Array( buffer );

	const baseTable = new Uint32Array( 512 );
	const shiftTable = new Uint32Array( 512 );

	for ( let i = 0; i < 256; ++ i ) {

		const e = i - 127;

		// very small number (0, -0)

		if ( e < - 27 ) {

			baseTable[ i ] = 0x0000;
			baseTable[ i | 0x100 ] = 0x8000;
			shiftTable[ i ] = 24;
			shiftTable[ i | 0x100 ] = 24;

			// small number (denorm)

		} else if ( e < - 14 ) {

			baseTable[ i ] = 0x0400 >> ( - e - 14 );
			baseTable[ i | 0x100 ] = ( 0x0400 >> ( - e - 14 ) ) | 0x8000;
			shiftTable[ i ] = - e - 1;
			shiftTable[ i | 0x100 ] = - e - 1;

			// normal number

		} else if ( e <= 15 ) {

			baseTable[ i ] = ( e + 15 ) << 10;
			baseTable[ i | 0x100 ] = ( ( e + 15 ) << 10 ) | 0x8000;
			shiftTable[ i ] = 13;
			shiftTable[ i | 0x100 ] = 13;

			// large number (Infinity, -Infinity)

		} else if ( e < 128 ) {

			baseTable[ i ] = 0x7c00;
			baseTable[ i | 0x100 ] = 0xfc00;
			shiftTable[ i ] = 24;
			shiftTable[ i | 0x100 ] = 24;

			// stay (NaN, Infinity, -Infinity)

		} else {

			baseTable[ i ] = 0x7c00;
			baseTable[ i | 0x100 ] = 0xfc00;
			shiftTable[ i ] = 13;
			shiftTable[ i | 0x100 ] = 13;

		}

	}

	// float16 to float32 helpers

	const mantissaTable = new Uint32Array( 2048 );
	const exponentTable = new Uint32Array( 64 );
	const offsetTable = new Uint32Array( 64 );

	for ( let i = 1; i < 1024; ++ i ) {

		let m = i << 13; // zero pad mantissa bits
		let e = 0; // zero exponent

		// normalized
		while ( ( m & 0x00800000 ) === 0 ) {

			m <<= 1;
			e -= 0x00800000; // decrement exponent

		}

		m &= ~ 0x00800000; // clear leading 1 bit
		e += 0x38800000; // adjust bias

		mantissaTable[ i ] = m | e;

	}

	for ( let i = 1024; i < 2048; ++ i ) {

		mantissaTable[ i ] = 0x38000000 + ( ( i - 1024 ) << 13 );

	}

	for ( let i = 1; i < 31; ++ i ) {

		exponentTable[ i ] = i << 23;

	}

	exponentTable[ 31 ] = 0x47800000;
	exponentTable[ 32 ] = 0x80000000;

	for ( let i = 33; i < 63; ++ i ) {

		exponentTable[ i ] = 0x80000000 + ( ( i - 32 ) << 23 );

	}

	exponentTable[ 63 ] = 0xc7800000;

	for ( let i = 1; i < 64; ++ i ) {

		if ( i !== 32 ) {

			offsetTable[ i ] = 1024;

		}

	}

	return {
		floatView: floatView,
		uint32View: uint32View,
		baseTable: baseTable,
		shiftTable: shiftTable,
		mantissaTable: mantissaTable,
		exponentTable: exponentTable,
		offsetTable: offsetTable
	};

}

// float32 to float16

function toHalfFloat( val ) {

	if ( Math.abs( val ) > 65504 ) console.warn( 'THREE.DataUtils.toHalfFloat(): Value out of range.' );

	val = clamp$1( val, - 65504, 65504 );

	_tables.floatView[ 0 ] = val;
	const f = _tables.uint32View[ 0 ];
	const e = ( f >> 23 ) & 0x1ff;
	return _tables.baseTable[ e ] + ( ( f & 0x007fffff ) >> _tables.shiftTable[ e ] );

}

// float16 to float32

function fromHalfFloat( val ) {

	const m = val >> 10;
	_tables.uint32View[ 0 ] = _tables.mantissaTable[ _tables.offsetTable[ m ] + ( val & 0x3ff ) ] + _tables.exponentTable[ m ];
	return _tables.floatView[ 0 ];

}

const DataUtils = {
	toHalfFloat: toHalfFloat,
	fromHalfFloat: fromHalfFloat,
};

const GL_NEAREST = 0x2600;
const GL_LINEAR = 0x2601;
const GL_LINEAR_MIPMAP_LINEAR = 0x2703;
const MAG_FILTER = 0x2800;
const MIN_FILTER = 0x2801;

var WebGLConstants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    GL_LINEAR: GL_LINEAR,
    GL_LINEAR_MIPMAP_LINEAR: GL_LINEAR_MIPMAP_LINEAR,
    GL_NEAREST: GL_NEAREST,
    MAG_FILTER: MAG_FILTER,
    MIN_FILTER: MIN_FILTER
});

/**
 * config properties:
 * https://github.com/regl-project/regl/blob/gh-pages/API.md#textures
 */
class Texture2D extends AbstractTexture {
    constructor() {
        super(...arguments);
        this._version = 0;
    }
    get version() {
        return this._version;
    }
    set version(version) {
        throw new Error('Texture2D.version is read only.');
    }
    onLoad({ data }) {
        const config = this.config;
        if (!config) {
            //disposed
            return;
        }
        if (config.hdr) {
            data = parseRGBE(data.data, 0);
            if (!data) {
                throw new Error('Invalid hdr data' + (config.url ? ':' + config.url : ''));
            }
            else {
                const uint16 = new Uint16Array(data.pixels.length);
                for (let i = 0; i < data.pixels.length; i++) {
                    uint16[i] = Math.min(DataUtils.toHalfFloat(data.pixels[i]), 65504);
                }
                config.data = uint16;
                config.type = 'float16';
                config.colorSpace = 'browser';
                config.min = 'linear';
                config.mag = 'linear';
            }
        }
        else {
            config.data = data;
        }
        //refresh width / height
        config.width = config.width || data.width;
        config.height = config.height || data.height;
        if (this._regl) {
            this._checkNPOT(this._regl);
        }
        this._update();
    }
    setConfig(config) {
        const data = config.data;
        config.image = data;
        config.width = config.width || data.width;
        config.height = config.height || data.height;
        this.config = config;
        this.dirty = !!this._texture;
    }
    //@internal
    _update() {
        if (this._texture && !this._texture[KEY_DISPOSED]) {
            this._version++;
            if (isFunction$1(this._texture)) {
                this._texture(this.config);
            }
            else {
                this._texture.update(this.config);
            }
        }
        this.dirty = false;
    }
    setMinFilter(value) {
        this.config.min = getTextureMinFilter(value);
        if (this._texture && this._texture.updateFilter) {
            this._texture.updateFilter();
        }
        if (this._texture && this._texture.texParameteri) {
            this._texture.texParameteri(MIN_FILTER, value);
        }
    }
    setMagFilter(value) {
        this.config.mag = getTextureMagFilter(value);
        if (this._texture && this._texture.updateFilter) {
            this._texture.updateFilter();
        }
        if (this._texture && this._texture.texParameteri) {
            this._texture.texParameteri(MAG_FILTER, value);
        }
    }
    createREGLTexture(regl) {
        this._regl = regl;
        this._checkNPOT(regl);
        if (isArray(this.config.data) || isArray(this.config.mipmap)) {
            const tex = getUniqueTexture(regl, this.config);
            if (!tex[REF_COUNT_KEY$1]) {
                tex[REF_COUNT_KEY$1] = 0;
            }
            tex[REF_COUNT_KEY$1]++;
            return tex;
        }
        return regl.texture(this.config);
    }
    _checkNPOT(regl) {
        const config = this.config;
        if (config.data && this._needPowerOf2(regl)) {
            if ((config.data instanceof Image)) {
                config.data = resizeToPowerOfTwo(config.data);
                config.width = config.data.width;
                config.height = config.data.height;
            }
            else if (!config.hdr && isArray(config.data) && (!isPowerOfTwo$1(config.width) || !isPowerOfTwo$1(config.height))) {
                config.data = resizeToPowerOfTwo(config.data, config.width, config.height);
                config.width = config.data.width;
                config.height = config.data.height;
            }
        }
    }
    //@internal
    _needPowerOf2(regl) {
        if (supportNPOT(regl)) {
            return false;
        }
        const config = this.config;
        const isRepeat = config.wrap && config.wrap !== 'clamp' || config.wrapS && config.wrapS !== 'clamp' ||
            config.wrapT && config.wrapT !== 'clamp';
        return isRepeat || config.min && config.min !== 'nearest' && config.min !== 'linear';
    }
}

class Plane extends Geometry {
    constructor(z) {
        z = z || 0;
        super({
            //width and height are both 1
            aPosition: new Float32Array([
                -1, -1, z, // left bottom
                1, -1, z, // right bottom
                -1, 1, z, // left top
                1, 1, z, // right top
            ]),
            // Normal
            aNormal: new Float32Array([
                0, 0, 1,
                0, 0, 1,
                0, 0, 1,
                0, 0, 1,
            ])
        }, new Uint16Array([0, 1, 3, 3, 2, 0]));
    }
}

var vsm_shadow_vert = "\nuniform mat4 shadow_lightProjViewModelMatrix;\nvarying vec4 shadow_vLightSpacePos;\nvoid shadow_computeShadowPars(vec4 position) {\n    shadow_vLightSpacePos = shadow_lightProjViewModelMatrix * position;\n}";

var vsm_shadow_frag = "\nuniform sampler2D shadow_shadowMap;\nuniform float shadow_opacity;\nuniform vec3 shadow_color;\n#if defined(USE_ESM)\n    uniform float esm_shadow_threshold;\n#endif\nvarying vec4 shadow_vLightSpacePos;\n#ifdef PACK_FLOAT\n    #include <common_pack_float>\n#endif\n#if defined(USE_ESM)\nfloat esm(vec3 projCoords, vec4 shadowTexel) {\n    float compare = projCoords.z;\n    float c = 120.0;\n    #ifdef PACK_FLOAT\n        float depth = common_decodeDepth(shadowTexel);\n        if (depth >= 1.0 - 1E-6 || compare <= depth) {\n            return 1.0;\n        }\n    #else\n        float depth = shadowTexel.r;\n    #endif\n    depth = exp(-c * min(compare - depth, 0.05));\n    return clamp(depth, esm_shadow_threshold, 1.0);\n}\n#endif\nfloat shadow_computeShadow_coeff(sampler2D shadowMap, vec3 projCoords) {\n    vec2 uv = projCoords.xy;\n    vec4 shadowTexel = texture2D(shadowMap, uv);\n    #if defined(USE_ESM)\n        float esm_coeff = esm(projCoords, shadowTexel);\n        float coeff = esm_coeff * esm_coeff;\n    #endif\n    return 1.0 - (1.0 - coeff) * shadow_opacity;\n}\nfloat shadow_computeShadow() {\n    vec3 projCoords = shadow_vLightSpacePos.xyz / shadow_vLightSpacePos.w;\n    projCoords = projCoords * 0.5 + 0.5;\n    if(projCoords.z >= 1.0 || projCoords.x < 0.0 || projCoords.x > 1.0 || projCoords.y < 0.0 || projCoords.y > 1.0) return 1.0;\n    return shadow_computeShadow_coeff(shadow_shadowMap, projCoords);\n}\nvec3 shadow_blend(vec3 color, float coeff) {\n    color = color * coeff + shadow_color * shadow_opacity * (1.0 - coeff);\n    return color;\n}";

var fbo_picking_vert = "\n#ifdef ENABLE_PICKING\n#if HAS_PICKING_ID == 1\n    attribute float aPickingId;\n#elif HAS_PICKING_ID == 2\n    uniform float uPickingId;\n#endif\n    varying float vPickingId;\n    varying float vFbo_picking_viewZ;\n    varying float vFbo_picking_visible;\n#endif\n    varying float vFbo_picking_fragDepth;\nvoid fbo_picking_setData(float viewPosZ, bool visible) {\n    #ifdef ENABLE_PICKING\n    #if HAS_PICKING_ID == 1\n        vPickingId = aPickingId;\n    #elif HAS_PICKING_ID == 2\n        vPickingId = uPickingId;\n    #endif\n        vFbo_picking_viewZ = viewPosZ;\n        vFbo_picking_visible = visible ? 1.0 : 0.0;\n    #endif\n    vFbo_picking_fragDepth = viewPosZ + 1.0;\n}";

var common_pack_float$1 = "const float COMMON_FLOAT_MAX =  1.70141184e38;\nconst float COMMON_FLOAT_MIN = 1.17549435e-38;\nvec4 common_unpackFloat(highp float v) {\n    highp float av = abs(v);\n    if(av < COMMON_FLOAT_MIN) {\n        return vec4(0.0, 0.0, 0.0, 0.0);\n    } else if(v > COMMON_FLOAT_MAX) {\n        return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\n    } else if(v < -COMMON_FLOAT_MAX) {\n        return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\n    }\n    highp vec4 c = vec4(0,0,0,0);\n    highp float e = floor(log2(av));\n    highp float m = av * pow(2.0, -e) - 1.0;\n    c[1] = floor(128.0 * m);\n    m -= c[1] / 128.0;\n    c[2] = floor(32768.0 * m);\n    m -= c[2] / 32768.0;\n    c[3] = floor(8388608.0 * m);\n    highp float ebias = e + 127.0;\n    c[0] = floor(ebias / 2.0);\n    ebias -= c[0] * 2.0;\n    c[1] += floor(ebias) * 128.0;\n    c[0] += 128.0 * step(0.0, -v);\n    return c / 255.0;\n}\nvec4 common_encodeDepth(const in float depth) {\n    float alpha = 1.0;\n    vec4 pack = vec4(0.0);\n    pack.a = alpha;\n    const vec3 code = vec3(1.0, 255.0, 65025.0);\n    pack.rgb = vec3(code * depth);\n    pack.gb = fract(pack.gb);\n    pack.rg -= pack.gb * (1.0 / 256.0);\n    pack.b -= mod(pack.b, 4.0 / 255.0);\n    return pack;\n}\nfloat common_decodeDepth(const in vec4 pack) {\n    return pack.r + pack.g / 255.0;\n}\nvec4 encodeFloat32(float f) {\n    float e =5.0;\n    float F = abs(f);\n    float Sign = step(0.0,-f);\n    float Exponent = floor(log2(F));\n    float Mantissa = (exp2(- Exponent) * F);\n    Exponent = floor(log2(F) + 127.0) + floor(log2(Mantissa));\n    vec4 rgba;\n    rgba[0] = 128.0 * Sign  + floor(Exponent*exp2(-1.0));\n    rgba[1] = 128.0 * mod(Exponent,2.0) + mod(floor(Mantissa*128.0),128.0);\n    rgba[2] = floor(mod(floor(Mantissa*exp2(23.0 -8.0)),exp2(8.0)));\n    rgba[3] = floor(exp2(23.0)*mod(Mantissa,exp2(-15.0)));\n    return rgba / 255.0;\n}\nfloat decodeFloat32(vec4 rgba) {\n    rgba *= 255.0;\n    float Sign = 1.0 - step(128.0,rgba[0])*2.0;\n    float Exponent = 2.0 * mod(rgba[0],128.0) + step(128.0,rgba[1]) - 127.0;\n    float Mantissa = mod(rgba[1],128.0)*65536.0 + rgba[2]*256.0 +rgba[3] + float(0x800000);\n    float Result =  Sign * exp2(Exponent) * (Mantissa * exp2(-23.0 ));\n    return Result;\n}";

var invert_matrix$1 = "mat4 invert_matrix(mat4 matrix) {\n    #if __VERSION__ == 300\n        return inverse(matrix);\n    #else\n        vec4 vector1 = matrix[0], vector2 = matrix[1], vector3 = matrix[2], vector4 = matrix[3];\n        float a00 = vector1.x, a01 = vector1.y, a02 = vector1.z, a03 = vector1.w;\n        float a10 = vector2.x, a11 = vector2.y, a12 = vector2.z, a13 = vector2.w;\n        float a20 = vector3.x, a21 = vector3.y, a22 = vector3.z, a23 = vector3.w;\n        float a30 = vector4.x, a31 = vector4.y, a32 = vector4.z, a33 = vector4.w;\n        float b00 = a00 * a11 - a01 * a10;\n        float b01 = a00 * a12 - a02 * a10;\n        float b02 = a00 * a13 - a03 * a10;\n        float b03 = a01 * a12 - a02 * a11;\n        float b04 = a01 * a13 - a03 * a11;\n        float b05 = a02 * a13 - a03 * a12;\n        float b06 = a20 * a31 - a21 * a30;\n        float b07 = a20 * a32 - a22 * a30;\n        float b08 = a20 * a33 - a23 * a30;\n        float b09 = a21 * a32 - a22 * a31;\n        float b10 = a21 * a33 - a23 * a31;\n        float b11 = a22 * a33 - a23 * a32;\n        float det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;\n        det = 1.0 / det;\n        mat4 m = mat4(\n            (a11 * b11 - a12 * b10 + a13 * b09) * det,\n            (a02 * b10 - a01 * b11 - a03 * b09) * det,\n            (a31 * b05 - a32 * b04 + a33 * b03) * det,\n            (a22 * b04 - a21 * b05 - a23 * b03) * det,\n            (a12 * b08 - a10 * b11 - a13 * b07) * det,\n            (a00 * b11 - a02 * b08 + a03 * b07) * det,\n            (a32 * b02 - a30 * b05 - a33 * b01) * det,\n            (a20 * b05 - a22 * b02 + a23 * b01) * det,\n            (a10 * b10 - a11 * b08 + a13 * b06) * det,\n            (a01 * b08 - a00 * b10 - a03 * b06) * det,\n            (a30 * b04 - a31 * b02 + a33 * b00) * det,\n            (a21 * b02 - a20 * b04 - a23 * b00) * det,\n            (a11 * b07 - a10 * b09 - a12 * b06) * det,\n            (a00 * b09 - a01 * b07 + a02 * b06) * det,\n            (a31 * b01 - a30 * b03 - a32 * b00) * det,\n            (a20 * b03 - a21 * b01 + a22 * b00) * det\n        );\n        return m;\n    #endif\n}\nmat4 transpose_matrix(mat4 matrix) {\n    #if __VERSION__ == 300\n        return transpose(matrix);\n    #else\n        vec4 vector1 = matrix[0], vector2 = matrix[1], vector3 = matrix[2], vector4 = matrix[3];\n        float a01 = vector1.y, a02 = vector1.z, a03 = vector1.w;\n        float a12 = vector2.z, a13 = vector2.w;\n        float a23 = vector3.w;\n        mat4 m = mat4(\n            vector1.x,\n            vector2.x,\n            vector3.x,\n            vector4.x,\n            a01,\n            vector2.y,\n            vector3.y,\n            vector4.y,\n            a02,\n            a12,\n            vector3.z,\n            vector4.z,\n            a03,\n            a13,\n            a23,\n            vector4.w\n        );\n        return m;\n    #endif\n}";

var get_output$1 = "#include <invert_matrix>\n#include <draco_decode_vert>\n#ifdef HAS_INSTANCE\n    #include <instance_vert>\n    #ifdef HAS_INSTANCE_COLOR\n        varying vec4 vInstanceColor;\n    #endif\n#endif\n#ifdef HAS_SKIN\n    uniform int skinAnimation;\n    #include <skin_vert>\n#endif\n#include <mask_vert>\n#ifdef HAS_MORPH\n    attribute vec3 POSITION0;\n    attribute vec3 POSITION1;\n    attribute vec3 POSITION2;\n    attribute vec3 POSITION3;\n    attribute vec3 POSITION4;\n    attribute vec3 POSITION5;\n    attribute vec3 POSITION6;\n    attribute vec3 POSITION7;\n    #ifdef HAS_MORPHNORMALS\n        attribute vec3 NORMAL0;\n        attribute vec3 NORMAL1;\n        attribute vec3 NORMAL2;\n        attribute vec3 NORMAL3;\n    #endif\n    uniform vec4 morphWeights1;\n    uniform vec4 morphWeights2;\n#endif\n#ifdef HAS_TERRAIN_ALTITUDE\nattribute float aTerrainAltitude;\n#endif\nmat4 getPositionMatrix() {\n    mat4 worldMatrix;\n    #ifdef HAS_INSTANCE\n        #ifdef HAS_INSTANCE_COLOR\n            vInstanceColor = instance_getInstanceColor();\n        #endif\n        mat4 attributeMatrix = instance_getAttributeMatrix();\n        #ifdef HAS_SKIN\n            if (skinAnimation == 1) {\n                worldMatrix = attributeMatrix * positionMatrix * skin_getSkinMatrix();\n            } else {\n                worldMatrix = attributeMatrix * positionMatrix;\n            }\n        #else\n            worldMatrix = attributeMatrix * positionMatrix;\n        #endif\n    #else\n        #ifdef HAS_SKIN\n            if (skinAnimation == 1) {\n                worldMatrix = skin_getSkinMatrix() * positionMatrix;\n            } else {\n                worldMatrix = positionMatrix;\n            }\n        #else\n            worldMatrix = positionMatrix;\n        #endif\n    #endif\n    return worldMatrix;\n}\n#ifdef HAS_MIN_ALTITUDE\n    uniform float minAltitude;\n#endif\n#ifdef HAS_TERRAIN_FLAT_MASK\n    uniform sampler2D flatMask;\n#endif\nvec4 getPosition(vec3 aPosition) {\n    vec3 position = decode_getPosition(aPosition);\n    #ifdef HAS_MORPH\n        vec4 POSITION = vec4(position + morphWeights1[0] * POSITION0 + morphWeights1[1] * POSITION1 + morphWeights1[2] * POSITION2 + morphWeights1[3] * POSITION3\n        + morphWeights2[0] * POSITION4 + morphWeights2[1] * POSITION5 + morphWeights2[2] * POSITION6 + morphWeights2[3] * POSITION7\n        , 1.0);\n    #else\n        vec4 POSITION = vec4(position, 1.0);\n    #endif\n    #ifdef HAS_TERRAIN_ALTITUDE\n        POSITION.z += aTerrainAltitude * 100.0;\n    #endif\n    #ifdef HAS_TERRAIN_FLAT_MASK\n        vec2 uv = aTexCoord;\n        uv.y = 1.0 - uv.y;\n        vec4 encodedHeight = texture2D(flatMask, uv);\n        if (length(encodedHeight) < 2.0) {\n            float maskHeight = decodeFloat32(encodedHeight);\n            POSITION.z = min(POSITION.z, maskHeight);\n        }\n    #endif\n    #ifdef HAS_MIN_ALTITUDE\n        POSITION.z += minAltitude * 100.0;\n    #endif\n    return POSITION;\n}\nvec3 appendMorphNormal(vec3 NORMAL) {\n    #ifdef HAS_MORPHNORMALS\n        vec3 normal = NORMAL + morphWeights1[0] * NORMAL0 + morphWeights1[1] * NORMAL1 + morphWeights1[2] * NORMAL2 + morphWeights1[3] * NORMAL3;\n    #else\n        vec3 normal = NORMAL;\n    #endif\n    return normal;\n}";

var instance_vert = "attribute vec4 instance_vectorA;\nattribute vec4 instance_vectorB;\nattribute vec4 instance_vectorC;\n#ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\nattribute float aTerrainAltitude;\nuniform float terrainAltitudeScale;\n#endif\nmat4 instance_getAttributeMatrix() {\n    mat4 mat =  mat4(\n        instance_vectorA.x, instance_vectorB.x, instance_vectorC.x, 0.0,\n        instance_vectorA.y, instance_vectorB.y, instance_vectorC.y, 0.0,\n        instance_vectorA.z, instance_vectorB.z, instance_vectorC.z, 0.0,\n        instance_vectorA.w, instance_vectorB.w, instance_vectorC.w, 1.0\n    );\n    #ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\n        mat4 terrainMat = mat4(\n            1., 0., 0., 0.,\n            0., 1., 0., 0.,\n            0., 0., 1., 0.,\n            0., 0., aTerrainAltitude * terrainAltitudeScale, 1.\n        );\n        mat = terrainMat * mat;\n    #endif\n    return mat;\n}\n#ifdef HAS_INSTANCE_HIGHLIGHT\n    attribute vec4 highlight_color;\n#endif\n#ifdef HAS_INSTANCE_COLOR\n   \n    attribute vec4 instance_color;\n    vec4 instance_getInstanceColor() {\n        vec4 color = instance_color;\n        #ifdef HAS_INSTANCE_HIGHLIGHT\n            color = instance_color * highlight_color;\n        #endif\n        return color;\n    }\n#endif";

var skin_vert = "attribute vec4 WEIGHTS_0;\nattribute vec4 JOINTS_0;\nuniform sampler2D jointTexture;\nuniform vec2 jointTextureSize;\nuniform float numJoints;\n#define ROW0_U ((0.5 + 0.0) / 4.)\n#define ROW1_U ((0.5 + 1.0) / 4.)\n#define ROW2_U ((0.5 + 2.0) / 4.)\n#define ROW3_U ((0.5 + 3.0) / 4.)\nmat4 skin_getBoneMatrix(float jointNdx) {\n    float v = (jointNdx + 0.5) / numJoints;\n    return mat4(\n        texture2D(jointTexture, vec2(ROW0_U, v)),\n        texture2D(jointTexture, vec2(ROW1_U, v)),\n        texture2D(jointTexture, vec2(ROW2_U, v)),\n        texture2D(jointTexture, vec2(ROW3_U, v)));\n}\nmat4 skin_getSkinMatrix() {\n        mat4 skinMatrix = skin_getBoneMatrix(JOINTS_0[0]) * WEIGHTS_0[0] +\n                        skin_getBoneMatrix(JOINTS_0[1]) * WEIGHTS_0[1] +\n                        skin_getBoneMatrix(JOINTS_0[2]) * WEIGHTS_0[2] +\n                        skin_getBoneMatrix(JOINTS_0[3]) * WEIGHTS_0[3];\n        return skinMatrix;\n}";

var heatmap_render_frag = "#ifdef HAS_HEATMAP\nuniform sampler2D heatmap_inputTexture;\nuniform sampler2D heatmap_colorRamp;\nuniform float heatmap_heatmapOpacity;\nvarying vec2 heatmap_vTexCoord;\nvec4 heatmap_getColor(vec4 color) {\n    float t = texture2D(heatmap_inputTexture, heatmap_vTexCoord).r;\n    vec4 heatmapColor = texture2D(heatmap_colorRamp, vec2(t, 0.5)) * heatmap_heatmapOpacity;\n    return color * (1.0 - heatmapColor.a) + heatmapColor * heatmapColor.a;\n}\n#endif";

var heatmap_render_vert = "#ifdef HAS_HEATMAP\nvarying vec2 heatmap_vTexCoord;\nvoid heatmap_compute(mat4 matrix, vec3 position) {\n    vec4 pos = matrix * vec4(position.xy, 0., 1.);\n    heatmap_vTexCoord = (1. + pos.xy / pos.w) / 2.;\n}\n#endif";

var line_extrusion_vert = "#ifdef IS_LINE_EXTRUSION\n    #define ALTITUDE_SCALE 32767.0;\n    #define EXTRUDE_SCALE 63.0;\n    attribute vec2 aExtrude;\n    #ifdef HAS_LINE_WIDTH\n        attribute float aLineWidth;\n    #else\n        uniform float lineWidth;\n    #endif\n    #ifdef HAS_LINE_HEIGHT\n        attribute float aLineHeight;\n    #else\n        uniform float lineHeight;\n    #endif\n    uniform float linePixelScale;\n    vec3 getLineExtrudePosition(vec3 position) {\n        #ifdef HAS_LINE_WIDTH\n            float lineWidth = aLineWidth / 2.0;\n        #endif\n        #ifdef HAS_LINE_HEIGHT\n            float lineHeight = aLineHeight / 10.0;\n        #endif\n        float halfwidth = lineWidth / 2.0;\n        float outset = halfwidth;\n        vec2 dist = outset * aExtrude / EXTRUDE_SCALE;\n        position.z *= lineHeight / ALTITUDE_SCALE;\n        return position + vec3(dist, 0.0) * linePixelScale;\n    }\n#endif";

var gl2_vert = "#if __VERSION__ == 300\n    #define texture2D texture\n    #define varying out\n    #define attribute in\n#endif";

var gl2_frag = "#if __VERSION__ == 300\n    #define varying in\n    #define gl_FragDepthEXT gl_FragDepth\n    #define texture2D texture\n    #define textureCube texture\n    #define texture2DProj textureProj\n    #define texture2DLodEXT textureLod\n    #define texture2DProjLodEXT textureProjLod\n    #define textureCubeLodEXT textureLod\n    #define texture2DGradEXT textureGrad\n    #define texture2DProjGradEXT textureProjGrad\n    #define textureCubeGradEXT textureGrad\n    out vec4 glFragColor;\n#else\n    vec4 glFragColor;\n#endif";

var hsv_frag = "\nconst mediump vec4 HSV_K0 = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);\nconst mediump vec4 HSV_K1 = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\nconst mediump float HSV_E = 1.0e-10;\nvec3 hsv_rgb2hsv(vec3 c) {\n    vec4 K = HSV_K0;\n    vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));\n    vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));\n    float d = q.x - min(q.w, q.y);\n    float e = HSV_E;\n    return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);\n}\nvec3 hsv_hsv2rgb(vec3 c) {\n    vec4 K = HSV_K1;\n    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);\n}\nvec4 hsv_apply(vec4 c, vec3 hsvOffset) {\n    vec3 hsv = hsv_rgb2hsv(c.rgb);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, 0.0, 1.0);\n    return vec4(hsv_hsv2rgb(hsv), c.a);\n}\nvec3 hsv_apply(vec3 c, vec3 hsvOffset) {\n    vec3 hsv = hsv_rgb2hsv(c.rgb);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, 0.0, 1.0);\n    return hsv_hsv2rgb(hsv);\n}\nmat4 contrastMatrix(float contrast)\n{\n    float t = (1.0 - contrast) / 2.0;\n    return mat4(\n        contrast, 0., 0., 0.,\n        0., contrast, 0., 0.,\n        0., 0., contrast, 0.,\n        t, t, t, 1\n    );\n}";

var snow_frag = "#ifdef HAS_SNOW\n    float lerp(float a, float b, float w) {\n        return a + w * (b - a);\n    }\n    vec3 snow(vec4 sceneColor, vec3 normalColor, float height) {\n        float snowIntense = normalColor.b;\n        vec3 fixedC = vec3(1.0, 1.0, 1.0);\n        if (height < 1.0) {\n            float r = lerp(0.5, fixedC.x, snowIntense);\n            float g = lerp(0.5, fixedC.y, snowIntense);\n            float b = lerp(0.5, fixedC.z, snowIntense);\n            return vec3(r, g, b);\n        } else {\n            float r = lerp(sceneColor.r, fixedC.x, snowIntense);\n            float g = lerp(sceneColor.g, fixedC.y, snowIntense);\n            float b = lerp(sceneColor.b, fixedC.z, snowIntense);\n            return vec3(r, g, b);\n        }\n    }\n#endif";

var draco_decode_vert = "#if defined(HAS_TANGENT)\n    attribute vec4 aTangent;\n#elif defined(HAS_NORMAL)\n    #ifdef HAS_DRACO_NORMAL\n        attribute vec2 aNormal;\n        uniform float gltf_u_dec_normal_rangeConstant;\n    #else\n        attribute vec3 aNormal;\n    #endif\n#endif\n#ifdef HAS_DRACO_POSITION\n    uniform float gltf_u_dec_position_normConstant;\n    uniform vec3 minValues_pos;\n    vec3 decodeDracoPosition(vec3 aPosition) {\n        return minValues_pos + aPosition * gltf_u_dec_position_normConstant;\n    }\n#endif\n#ifdef HAS_DRACO_TEXCOORD\n    uniform vec2 minValues_tex;\n    uniform float gltf_u_dec_texcoord_0_normConstant;\n    vec2 decodeDracoTexcoord(vec2 aTexCoord) {\n        return minValues_tex + aTexCoord * gltf_u_dec_texcoord_0_normConstant;\n    }\n#endif\n#ifdef HAS_WEB3D_quantized_attributes_TEXCOORD\n    uniform mat3 decodeMatrix;\n#endif\n#ifdef HAS_DRACO_NORMAL\n    float czm_signNotZero(float value) {\n        return value >= 0.0 ? 1.0 : -1.0;\n    }\n    vec2 czm_signNotZero(vec2 value) {\n        return vec2(czm_signNotZero(value.x), czm_signNotZero(value.y));\n    }\n    vec3 decodeDracoNormal(vec2 encoded, float range)\n    {\n        if (encoded.x == 0.0 && encoded.y == 0.0) {\n            return vec3(0.0, 0.0, 0.0);\n        }\n        encoded = encoded / range * 2.0 - 1.0;\n        vec3 v = vec3(encoded.x, encoded.y, 1.0 - abs(encoded.x) - abs(encoded.y));\n        if (v.z < 0.0) {\n            v.xy = (1.0 - abs(v.yx)) * czm_signNotZero(v.xy);\n        }\n        return normalize(v);\n    }\n    vec3 decode_getNormal(vec2 aNormal) {\n        return decodeDracoNormal(aNormal, gltf_u_dec_normal_rangeConstant).zxy;\n    }\n#endif\n#ifdef HAS_COMPRESSED_INT16\n    #ifdef HAS_COMPRESSED_INT16_POSITION\n      uniform vec2 compressedPositionRange;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_TEXCOORD_0\n      uniform vec2 compressedTexcoordRange_0;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_TEXCOORD_1\n      uniform vec2 compressedTexcoordRange_1;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\n      uniform vec2 compressedNormalRange;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_RATIO\n      uniform float compressed_ratio;\n    #endif\n    float int16ToFloat32(float value, vec2 range) {\n        float v = (value >= 32768.0) ? -(65536.0 - value) / 32768.0 : value / 32767.0;\n        return (v + 1.0) * (range.y - range.x) / 2.0 + range.x;\n    }\n#endif\nvec3 decode_getPosition(vec3 aPosition) {\n    vec3 position = aPosition;\n    #if defined(HAS_COMPRESSED_INT16) && defined(HAS_COMPRESSED_INT16_POSITION)\n        float x = int16ToFloat32(aPosition.x, compressedPositionRange);\n        float y = int16ToFloat32(aPosition.y, compressedPositionRange);\n        float z = int16ToFloat32(aPosition.z, compressedPositionRange);\n        #ifdef HAS_COMPRESSED_INT16_RATIO\n          position = vec3(x / compressed_ratio, y / compressed_ratio, z);\n        #else\n          position = vec3(x, y, z);\n        #endif\n    #endif\n    #ifdef HAS_DRACO_POSITION\n        return decodeDracoPosition(position);\n    #else\n        return position;\n    #endif\n}\nvec2 decode_getTexcoord(vec2 aTexCoord) {\n    vec2 texcoord = aTexCoord;\n    #if defined(HAS_COMPRESSED_INT16) && (defined(HAS_COMPRESSED_INT16_TEXCOORD_0) || defined(HAS_COMPRESSED_INT16_TEXCOORD_1))\n        float x = int16ToFloat32(aTexCoord.x, compressedTexcoordRange_0);\n        float y = int16ToFloat32(aTexCoord.y, compressedTexcoordRange_0);\n        texcoord = vec2(x, y);\n    #endif\n    #ifdef HAS_DRACO_TEXCOORD\n        return decodeDracoTexcoord(texcoord);\n    #elif defined(HAS_WEB3D_quantized_attributes_TEXCOORD)\n        vec3 web3dTexcoord = decodeMatrix * vec3(texcoord, 1.0);\n        return vec2(web3dTexcoord.x, web3dTexcoord.y);\n    #else\n        return texcoord;\n    #endif\n}\nvec3 decode_getNormal(vec3 aNormal) {\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\n        aNormal.x = int16ToFloat32(aNormal.x, compressedNormalRange);\n        aNormal.y = int16ToFloat32(aNormal.y, compressedNormalRange);\n        aNormal.z = int16ToFloat32(aNormal.z, compressedNormalRange);\n    #endif\n    return aNormal;\n}";

var highlight_vert = "#if defined(HAS_HIGHLIGHT_COLOR)\n    attribute vec4 aHighlightColor;\n    varying vec4 vHighlightColor;\n#endif\n#if defined(HAS_HIGHLIGHT_OPACITY)\n    attribute float aHighlightOpacity;\n    varying float vHighlightOpacity;\n#endif\nvoid highlight_setVarying() {\n    #if defined(HAS_HIGHLIGHT_COLOR)\n        vHighlightColor = aHighlightColor / 255.0;\n    #endif\n    #if defined(HAS_HIGHLIGHT_OPACITY)\n        vHighlightOpacity = aHighlightOpacity / 255.0;\n    #endif\n}";

var highlight_frag = "#if defined(HAS_HIGHLIGHT_COLOR)\n\tvarying vec4 vHighlightColor;\n#endif\n#if defined(HAS_HIGHLIGHT_OPACITY)\n    varying float vHighlightOpacity;\n#endif\nvec4 highlight_blendColor(vec4 color) {\n\tvec4 outColor;\n\t#if defined(HAS_HIGHLIGHT_COLOR)\n\t\tcolor.rgb = color.rgb * (1.0 - vHighlightColor.a) + vHighlightColor.rgb * vHighlightColor.a;\n\t\t#ifndef HAS_HIGHLIGHT_COLOR_POINT\n        \tcolor.a = color.a * (1.0 - vHighlightColor.a) + vHighlightColor.a;\n        #endif\n        outColor = color;\n\t#else\n\t\toutColor = color;\n\t#endif\n\t#if defined(HAS_HIGHLIGHT_OPACITY)\n\t\toutColor *= vHighlightOpacity;\n\t#endif\n\treturn outColor;\n}";

var mask_vert = "#ifdef HAS_MASK_EXTENT\n    uniform vec4 mask_extent;\n    uniform sampler2D mask_colorExtent;\n    uniform sampler2D mask_modeExtent;\n    uniform float mask_maskMode;\n    uniform float mask_hasFlatOut;\n    uniform mat4 viewMatrix;\n    uniform float mask_heightRatio;\n    uniform float mask_heightOffset;\n    varying vec4 vWorldPosition;\n    varying vec2 vUVInExtent;\n    varying float vHeightRatio;\n    varying float vHeightOffset;\n    const float CLIPINSIDE_MODE = 0.2;\n    const float FLATINSIDE_MODE = 0.3;\n    const float FLATOUTSIDE_MODE = 0.4;\n    const float ELEVATE_MODE = 0.7;\n    float random (vec2 st) {\n        return fract(sin(dot(st.xy,vec2(12.9898,78.233)))*43758.5453123) * 0.1;\n    }\n    bool isInExtent(vec4 color) {\n        return length(color.rgb) > 0.0;\n    }\n    float getFlatHeight(float maskMode, float flatHeight, float height) {\n      if (maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n          return flatHeight + height;\n      } else {\n        return flatHeight;\n      }\n    }\n    vec4 getNoErrorPosition(vec4 position, vec4 wPosition) {\n      vec4 realPos = modelViewMatrix * position;      vec4 pos = viewMatrix * wPosition;      vec4 tempPos = viewMatrix * modelMatrix * position;      float deltaX = realPos.x - tempPos.x;\n      float deltaY = realPos.y - tempPos.y;\n      float deltaZ = realPos.z - tempPos.z;\n      pos.x = pos.x + deltaX;\n      pos.y = pos.y + deltaY;\n      pos.z = pos.z + deltaZ;\n      return pos;\n    }\n    vec4 getMaskPosition(vec4 position, mat4 modelMatrix) {\n        vWorldPosition = modelMatrix * position;\n        float w = mask_extent.z - mask_extent.x;\n        float h = mask_extent.y - mask_extent.w;\n        vec2 uvInExtent = vec2((vWorldPosition.x - mask_extent.x) / abs(w), 1.0 - (vWorldPosition.y - mask_extent.w) / h);\n        vec4 extentColor = texture2D(mask_colorExtent, uvInExtent);\n        vec3 maskOptionColor = texture2D(mask_modeExtent, uvInExtent).rgb;\n        float maskMode = maskOptionColor.r;\n        float flatHeight = maskOptionColor.g / mask_heightRatio + mask_heightOffset;\n        float height = getFlatHeight(maskMode, flatHeight, vWorldPosition.z);\n        vec4 wPosition = vec4(vWorldPosition.x, vWorldPosition.y, height, vWorldPosition.w);\n        vUVInExtent = uvInExtent;\n        vHeightRatio = mask_heightRatio;\n        vHeightOffset = mask_heightOffset;\n        if (maskMode <= FLATOUTSIDE_MODE && maskMode > FLATINSIDE_MODE) {\n            return modelViewMatrix * position;;\n        } else if (mask_hasFlatOut == 1.0) {\n            return getNoErrorPosition(position, wPosition);\n        }\n        if (isInExtent(extentColor) == true && maskMode <= FLATINSIDE_MODE && maskMode > CLIPINSIDE_MODE) {\n            return getNoErrorPosition(position, wPosition);\n        } if (isInExtent(extentColor) == true && maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n            return getNoErrorPosition(position, wPosition);\n        } else {\n            return modelViewMatrix * position;\n        }\n    }\n#endif";

var mask_frag = "#ifdef HAS_MASK_EXTENT\n    uniform sampler2D mask_colorExtent;\n    uniform sampler2D mask_modeExtent;\n    uniform float mask_hasClipOut;\n    varying float vHeightRatio;\n    varying float vHeightOffset;\n    varying vec2 vUVInExtent;\n    varying vec4 vWorldPosition;\n    const float CLIPINSIDE_MODE = 0.1;\n    const float CLIPOUTSIDE_MODE = 0.2;\n    const float FLATINSIDE_MODE = 0.3;\n    const float FLATOUTSIDE_MODE = 0.4;\n    const float COLOR_MODE = 0.5;\n    const float VIDEO_MODE = 0.6;\n    bool isInExtent(vec4 color) {\n        return length(color.rgb) > 0.0;\n    }\n    vec4 setMask(vec4 glFragColor) {\n        vec4 extentColor = texture2D(mask_colorExtent, vUVInExtent);\n        vec4 modeColor = texture2D(mask_modeExtent, vUVInExtent);\n        float maskMode = modeColor.r;\n        float minHeight = modeColor.b / vHeightRatio + vHeightOffset;\n        float maxHeight = modeColor.a / vHeightRatio + vHeightOffset;\n        if (maskMode > CLIPINSIDE_MODE && maskMode <= CLIPOUTSIDE_MODE) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                return glFragColor;\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                return glFragColor;\n            } else {\n              discard;\n            }\n        } else if (mask_hasClipOut == 1.0) {\n            discard;\n        }\n        if (isInExtent(extentColor) == true && maskMode <= CLIPINSIDE_MODE && maskMode > 0.0) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                discard;\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                discard;\n            } else {\n              return glFragColor;\n            }\n        } else if (isInExtent(extentColor) == true && maskMode <= VIDEO_MODE && maskMode > FLATOUTSIDE_MODE) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                glFragColor = vec4(mix(extentColor.rgb, glFragColor.rgb, 1.0 - extentColor.a), glFragColor.a);\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                glFragColor = vec4(mix(extentColor.rgb, glFragColor.rgb, 1.0 - extentColor.a), glFragColor.a);\n            }\n        }\n        return glFragColor;\n    }\n#endif";

var compute_texcoord_frag = "#ifdef HAS_KHR_TEXTURE_TRANSFORM\n    uniform vec2 khr_offset;\n    uniform float khr_rotation;\n    uniform vec2 khr_scale;\n    vec2 khr_tex_transformTexCoord(vec2 texCoords, vec2 offset, float rotation, vec2 scale) {\n        rotation = -rotation;\n        mat3 transform = mat3(\n        cos(rotation) * scale.x, sin(rotation) * scale.x, 0.0, -sin(rotation) * scale.y, cos(rotation) * scale.y, 0.0, offset.x, offset.y, 1.0);\n        vec2 transformedTexCoords = (transform * vec3(fract(texCoords), 1.0)).xy;\n        return transformedTexCoords;\n    }\n#endif\nvarying highp vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\n    varying vec4 vUvRegion;\n#endif\nvec2 computeTexCoord(vec2 texCoord) {\n    #ifdef HAS_I3S_UVREGION\n        vec2 atlasScale = vUvRegion.zw - vUvRegion.xy;\n        vec2 uvAtlas = fract(texCoord) * atlasScale + vUvRegion.xy;\n        return uvAtlas;\n    #elif defined(HAS_KHR_TEXTURE_TRANSFORM)\n        return khr_tex_transformTexCoord(texCoord, khr_offset, khr_rotation, khr_scale);\n    #else\n        return texCoord;\n    #endif\n}";

var terrain_normal_frag = "#ifdef HAS_TERRAIN_NORMAL\n    uniform sampler2D terrainHeightTexture;\n    uniform vec2 terrainHeightMapResolution;\n    uniform vec2 terrainResolution;\n    uniform vec4 terrainUnpackFactors;\n    float getHeight(vec2 uv) {\n        vec4 color = texture2D(terrainHeightTexture, uv) * 255.0;\n        color.a = -1.0;\n        return dot(color, terrainUnpackFactors) / 4.0;\n    }\n    vec3 convertTerrainHeightToNormalMap(vec2 uv) {\n        uv.y = 1.0 - uv.y;\n        vec2 epsilon = 1.0 / terrainHeightMapResolution;\n        float a = getHeight(uv + vec2(-epsilon.x, -epsilon.y));\n        float b = getHeight(uv + vec2(0, -epsilon.y));\n        float c = getHeight(uv + vec2(epsilon.x, -epsilon.y));\n        float d = getHeight(uv + vec2(-epsilon.x, 0));\n        float e = getHeight(uv + vec2(epsilon.x, 0));\n        float f = getHeight(uv + vec2(-epsilon.x, epsilon.y));\n        float g = getHeight(uv + vec2(0, epsilon.y));\n        float h = getHeight(uv + vec2(epsilon.x, epsilon.y));\n        vec2 dxy = vec2(\n            (c + e + e + h) - (a + d + d + f),\n            (f + g + g + h) - (a + b + b + c)\n        );\n        return normalize(vec3(dxy / epsilon, terrainResolution ));\n    }\n#endif";

var vertex_color_vert = "#ifdef HAS_VERTEX_COLOR\nattribute float aVertexColorType;\nuniform vec4 vertexColorsOfType[VERTEX_TYPES_COUNT];\nvarying vec4 vertexColor_color;\nvoid vertexColor_update() {\n    vertexColor_color = vertexColorsOfType[int(aVertexColorType)];\n}\n#endif\n//用于识别顶点颜色类型: topPolygonFill 还是 bottomPolygonFill";

var vertex_color_frag = "#ifdef HAS_VERTEX_COLOR\nvarying vec4 vertexColor_color;\nvec4 vertexColor_get() {\n\treturn vertexColor_color;\n}\n#endif";

var excavate_vert = "#ifdef HAS_EXCAVATE_ANALYSIS\n  uniform vec4 excavateExtent;\n  varying vec2 vCoordinateTexcoord;\n  varying float vExcavateHeight;\n  float getWorldHeight(vec4 localPosition) {\n    vec4 wPosition = modelMatrix * localPosition;\n    return wPosition.z;\n  }\n  vec2 getCoordinateTexcoord(vec4 localPosition) {\n    vec4 wPosition = modelMatrix * localPosition;\n    float x = (wPosition.x - excavateExtent.x) / (excavateExtent.z - excavateExtent.x);\n    float y = (wPosition.y - excavateExtent.y) / (excavateExtent.w - excavateExtent.y);\n    return vec2(x, y);\n  }\n#endif";

var excavate_frag = "#ifdef HAS_EXCAVATE_ANALYSIS\n  uniform sampler2D heightmap;\n  uniform float excavateHeight;\n  varying vec2 vCoordinateTexcoord;\n  varying float vExcavateHeight;\n  const vec2 range = vec2(-100.0, 1000.0);\n  float decodeHeight(const in vec4 pack) {\n      return pack.r + pack.g / 255.0;\n  }\n  vec4 excavateColor(vec4 fragColor) {\n      float samplerHeight = decodeHeight(texture2D(heightmap, vCoordinateTexcoord));\n      float realHeight = samplerHeight * (range.y - range.x) + range.x;\n      if(realHeight < range.x || realHeight > range.y) {\n          realHeight = 0.0;\n      }\n      if(vExcavateHeight > realHeight) {\n          discard;\n      }\n      return fragColor;\n  }\n#endif";

var srgb_frag = "vec3 linearTosRGB(const in vec3 color) {\n    return vec3(\n        color.r < 0.0031308 ? color.r * 12.92 : 1.055 * pow(color.r, 1.0/2.4) - 0.055,\n        color.g < 0.0031308 ? color.g * 12.92 : 1.055 * pow(color.g, 1.0/2.4) - 0.055,\n        color.b < 0.0031308 ? color.b * 12.92 : 1.055 * pow(color.b, 1.0/2.4) - 0.055\n    );\n}\nvec3 sRGBToLinear(const in vec3 color) {\n    return vec3(\n        color.r < 0.04045 ? color.r * (1.0 / 12.92) : pow((color.r + 0.055) * (1.0 / 1.055), 2.4),\n        color.g < 0.04045 ? color.g * (1.0 / 12.92) : pow((color.g + 0.055) * (1.0 / 1.055), 2.4),\n        color.b < 0.04045 ? color.b * (1.0 / 12.92) : pow((color.b + 0.055) * (1.0 / 1.055), 2.4)\n    );\n}";

var rgbm_frag = "vec4 encodeRGBM(const in vec3 color, const in float range) {\n    if(range <= 0.0) return vec4(color, 1.0);\n    vec4 rgbm;\n    vec3 col = color / range;\n    rgbm.a = clamp( max( max( col.r, col.g ), max( col.b, 1e-6 ) ), 0.0, 1.0 );\n    rgbm.a = ceil( rgbm.a * 255.0 ) / 255.0;\n    rgbm.rgb = col / rgbm.a;\n    return rgbm;\n}\nvec3 decodeRGBM(const in vec4 color, const in float range) {\n    if(range <= 0.0) return color.rgb;\n    return range * color.rgb * color.a;\n}";

var mesh_picking_vert = "attribute vec3 aPosition;\nuniform mat4 projViewModelMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 modelViewMatrix;\n#include <fbo_picking_vert>\n#include <get_output>\nvoid main()\n{\n    mat4 localPositionMatrix = getPositionMatrix();\n    vec4 localPosition = getPosition(aPosition);\n    gl_Position = projViewModelMatrix * localPositionMatrix * localPosition;\n    fbo_picking_setData(gl_Position.w, true);\n}";

/* eslint-disable camelcase */


//Shader Chunks for includes
const ShaderChunk$1 = {
    vsm_shadow_vert,
    vsm_shadow_frag,
    fbo_picking_vert,
    common_pack_float: common_pack_float$1,

    invert_matrix: invert_matrix$1,
    get_output: get_output$1,
    instance_vert,
    skin_vert,
    heatmap_render_vert,
    heatmap_render_frag,

    line_extrusion_vert,

    // fog_render_vert,
    // fog_render_frag,

    gl2_vert,
    gl2_frag,

    //颜色饱和度
    hsv_frag,
    snow_frag,
    //draco解压相关
    draco_decode_vert,

    highlight_vert,
    highlight_frag,

    mask_vert,
    mask_frag,

    compute_texcoord_frag,

    terrain_normal_frag,

    vertex_color_vert,
    vertex_color_frag,

    excavate_vert,
    excavate_frag,

    srgb_frag,
    mesh_picking_vert,

    rgbm_frag
};
/* eslint-enable camelcase */

var ShaderLib = {
    /**
     * Register a new shader segment for includes for 3rd parties
     * @param {String} name key name
     * @param {String} source shader segment source
     */
    register(name, source) {
        if (ShaderChunk$1[name]) {
            throw new Error(`Key of ${name} is already registered in ShaderLib.`);
        }
        ShaderChunk$1[name] = source;
    },

    /**
     * Compile the given source, replace #include with registered shader sources
     * @param {String} source source to compile
     */
    compile(source) {
        return parseIncludes(source);
    },

    get(name) {
        return ShaderChunk$1[name];
    }
};

const pattern$1 = /^[ \t]*#include +<([\w\d.]+)>/gm;

function parseIncludes(string) {
    return string.replace(pattern$1, replace);
}

function replace(match, include) {
    const replace = ShaderChunk$1[include];
    if (!replace) {
        throw new Error('Can not resolve #include <' + include + '>');
    }
    return parseIncludes(replace);
}

const vert$q = `
    #ifdef POSITION_IS_INT
        @location($i) aPosition: vec4i,
    #elif POSITION_IS_UINT
        @location($i) aPosition: vec4u,
    #else
        @location($i) aPosition: vec3f,
    #endif
`;
var position = {
    vert: vert$q
};

const vert$p = /* wgsl */ `
@group(0) @binding($b) var<uniform> terrainAltitudeScale: f32;

// 获取实例属性矩阵函数
fn instance_getAttributeMatrix(
    input: VertexInput
) -> mat4x4f {
    let vectorA = input.instance_vectorA;
    let vectorB = input.instance_vectorB;
    let vectorC = input.instance_vectorC;
    var mat = mat4x4f(
        vectorA.x, vectorB.x, vectorC.x, 0.0,
        vectorA.y, vectorB.y, vectorC.y, 0.0,
        vectorA.z, vectorB.z, vectorC.z, 0.0,
        vectorA.w, vectorB.w, vectorC.w, 1.0
    );

#ifdef HAS_INSTANCE_TERRAIN_ALTITUDE
    var terrainMat = mat4x4f(
        1.0, 0.0, 0.0, 0.0,
        0.0, 1.0, 0.0, 0.0,
        0.0, 0.0, 1.0, 0.0,
        0.0, 0.0, aTerrainAltitude * terrainAltitudeScale, 1.0
    );
    mat = terrainMat * mat;
#endif

    return mat;
}

#ifdef HAS_INSTANCE_COLOR
// 获取实例颜色函数
fn instance_getInstanceColor(instance_color: vec4f) -> vec4f {
    var color = instance_color;
#ifdef HAS_INSTANCE_HIGHLIGHT
    color = instance_color * highlight_color;
#endif
    return color;
}
#endif
`;
const attributes$5 = [
    {
        name: 'instance_vectorA',
        type: 'vec4f',
    },
    {
        name: 'instance_vectorB',
        type: 'vec4f',
    },
    {
        name: 'instance_vectorC',
        type: 'vec4f',
    },
    {
        defines: ['HAS_INSTANCE_TERRAIN_ALTITUDE'],
        name: 'aTerrainAltitude',
        type: 'f32'
    },
    {
        defines: ['HAS_INSTANCE_HIGHLIGHT'],
        name: 'highlight_color',
        type: 'vec4f'
    },
    {
        defines: ['HAS_INSTANCE_COLOR'],
        name: 'instance_color',
        type: 'vec4f'
    }
];
var instance = {
    vert: vert$p, attributes: attributes$5,
    defines: ['HAS_INSTANCE']
};

const vert$o = /* wgsl */ `
// 矩阵求逆函数
fn invert_matrix(matrix: mat4x4f) -> mat4x4f {
    let vector1 = matrix[0];
    let vector2 = matrix[1];
    let vector3 = matrix[2];
    let vector4 = matrix[3];

    let a00 = vector1.x;
    let a01 = vector1.y;
    let a02 = vector1.z;
    let a03 = vector1.w;

    let a10 = vector2.x;
    let a11 = vector2.y;
    let a12 = vector2.z;
    let a13 = vector2.w;

    let a20 = vector3.x;
    let a21 = vector3.y;
    let a22 = vector3.z;
    let a23 = vector3.w;

    let a30 = vector4.x;
    let a31 = vector4.y;
    let a32 = vector4.z;
    let a33 = vector4.w;

    let b00 = a00 * a11 - a01 * a10;
    let b01 = a00 * a12 - a02 * a10;
    let b02 = a00 * a13 - a03 * a10;
    let b03 = a01 * a12 - a02 * a11;
    let b04 = a01 * a13 - a03 * a11;
    let b05 = a02 * a13 - a03 * a12;
    let b06 = a20 * a31 - a21 * a30;
    let b07 = a20 * a32 - a22 * a30;
    let b08 = a20 * a33 - a23 * a30;
    let b09 = a21 * a32 - a22 * a31;
    let b10 = a21 * a33 - a23 * a31;
    let b11 = a22 * a33 - a23 * a32;

    // 计算行列式
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    det = 1.0 / det;

    let m = mat4x4f(
        (a11 * b11 - a12 * b10 + a13 * b09) * det,
        (a02 * b10 - a01 * b11 - a03 * b09) * det,
        (a31 * b05 - a32 * b04 + a33 * b03) * det,
        (a22 * b04 - a21 * b05 - a23 * b03) * det,
        (a12 * b08 - a10 * b11 - a13 * b07) * det,
        (a00 * b11 - a02 * b08 + a03 * b07) * det,
        (a32 * b02 - a30 * b05 - a33 * b01) * det,
        (a20 * b05 - a22 * b02 + a23 * b01) * det,
        (a10 * b10 - a11 * b08 + a13 * b06) * det,
        (a01 * b08 - a00 * b10 - a03 * b06) * det,
        (a30 * b04 - a31 * b02 + a33 * b00) * det,
        (a21 * b02 - a20 * b04 - a23 * b00) * det,
        (a11 * b07 - a10 * b09 - a12 * b06) * det,
        (a00 * b09 - a01 * b07 + a02 * b06) * det,
        (a31 * b01 - a30 * b03 - a32 * b00) * det,
        (a20 * b03 - a21 * b01 + a22 * b00) * det
    );

    return m;
}

// 矩阵转置函数
fn transpose_matrix(matrix: mat4x4f) -> mat4x4f {
    let vector1 = matrix[0];
    let vector2 = matrix[1];
    let vector3 = matrix[2];
    let vector4 = matrix[3];

    let a01 = vector1.y;
    let a02 = vector1.z;
    let a03 = vector1.w;

    let a12 = vector2.z;
    let a13 = vector2.w;

    let a23 = vector3.w;

    let m = mat4x4f(
        vector1.x,
        vector2.x,
        vector3.x,
        vector4.x,
        a01,
        vector2.y,
        vector3.y,
        vector4.y,
        a02,
        a12,
        vector3.z,
        vector4.z,
        a03,
        a13,
        a23,
        vector4.w
    );

    return m;
}
`;
const frag$t = vert$o;
var invert_matrix = {
    vert: vert$o, frag: frag$t
};

const vert$n = /* wgsl */ `
    #define ALTITUDE_SCALE 32767.0
    #define EXTRUDE_SCALE 63.0

    struct LineExtrusionVertex {
        linePixelScale: f32,
        #if HAS_LINE_WIDTH
        #else
            lineWidth: f32,
        #endif
        #if HAS_LINE_HEIGHT
        #else
            lineHeight: f32,
        #endif
    }

    @group(0) @binding($b) var<uniform> lineExtrusionVertex : LineExtrusionVertex;

    fn getLineExtrudePosition(position: vec3f, input: VertexInput) -> vec3f {
        let uniforms = lineExtrusionVertex;
        #if HAS_LINE_WIDTH
            let lineWidth = f32(input.aLineWidth) / 2.0;
        #else
            let lineWidth = uniforms.lineWidth;
        #endif
        #if HAS_LINE_HEIGHT
            // aLineHeight单位是分米
            let lineHeight = f32(input.aLineHeight) / 10.0;
        #else
            let lineHeight = uniforms.lineHeight;
        #endif

        let halfwidth = lineWidth / 2.0;
        let outset = halfwidth;
        let dist = outset * vec2f(input.aExtrude.xy) / EXTRUDE_SCALE;
        let z_scaled = position.z * (lineHeight / ALTITUDE_SCALE);
        return position + vec3f(dist, 0.0) * uniforms.linePixelScale;
    }
`;
const attributes$4 = [
    {
        name: 'aExtrude',
        type: 'vec2i',
    },
    {
        defines: ['HAS_LINE_WIDTH'],
        name: 'aLineWidth',
        type: 'u32',
    },
    {
        defines: ['HAS_LINE_HEIGHT'],
        name: 'aLineHeight',
        type: 'f32',
    }
];
var line_extrusion = {
    vert: vert$n,
    attributes: attributes$4,
    defines: ['IS_LINE_EXTRUSION']
};

const vert$m = /* wgsl */ `
#ifdef HAS_MASK_EXTENT
struct MaskUniforms {
    mask_extent: vec4f,
    mask_maskMode: f32,
    mask_hasFlatOut: f32,
    viewMatrix: mat4x4f,
    mask_heightRatio: f32,
    mask_heightOffset: f32,
};

@group(0) @binding($b) var<uniform> maskUniforms: MaskUniforms;
@group(0) @binding($b) var mask_colorExtentSampler: sampler;
@group(0) @binding($b) var mask_colorExtent: texture_2d<f32>;
@group(0) @binding($b) var mask_modeExtentSampler: sampler;
@group(0) @binding($b) var mask_modeExtent: texture_2d<f32>;

const CLIPINSIDE_MODE: f32 = 0.2;
const FLATINSIDE_MODE: f32 = 0.3;
const FLATOUTSIDE_MODE: f32 = 0.4;
const ELEVATE_MODE: f32 = 0.7;

fn random(st: vec2f) -> f32 {
    return fract(sin(dot(st, vec2f(12.9898, 78.233))) * 43758.5453123) * 0.1;
}

fn isInExtent(color: vec4f) -> bool {
    return length(color.rgb) > 0.0;
}

fn getFlatHeight(maskMode: f32, flatHeight: f32, height: f32) -> f32 {
    if (maskMode <= ELEVATE_MODE && maskMode > 0.6) {
        return flatHeight + height;
    } else {
        return flatHeight;
    }
}

fn getNoErrorPosition(position: vec4f, wPosition: vec4f) -> vec4f {
    let realPos = uniforms.modelViewMatrix * position; // 未压平，采用 vm 矩阵的坐标
    let pos = maskUniforms.viewMatrix * wPosition; // 压平的坐标
    let tempPos = maskUniforms.viewMatrix * uniforms.modelMatrix * position; // 未压平而采用 v*m 矩阵的坐标
    let deltaX = realPos.x - tempPos.x;
    let deltaY = realPos.y - tempPos.y;
    let deltaZ = realPos.z - tempPos.z;
    pos.x = pos.x + deltaX;
    pos.y = pos.y + deltaY;
    pos.z = pos.z + deltaZ;
    return pos;
}

fn getMaskPosition(position: vec4f, modelMatrix: mat4x4f, vertexOutput: VertexOutput) -> vec4f {
    vertexOutput.vWorldPosition = modelMatrix * position;
    let w = maskUniforms.mask_extent.z - maskUniforms.mask_extent.x;
    let h = maskUniforms.mask_extent.y - maskUniforms.mask_extent.w;
    let uvInExtent = vec2f((vertexOutput.vWorldPosition.x - maskUniforms.mask_extent.x) / abs(w), 1.0 - (vertexOutput.vWorldPosition.y - maskUniforms.mask_extent.w) / h);
    let extentColor = textureSample(mask_colorExtent, mask_colorExtentSampler, uvInExtent);
    let maskOptionColor = textureSample(mask_modeExtent, mask_modeExtentSampler, uvInExtent).rgb;
    let maskMode = maskOptionColor.r;
    let flatHeight = maskOptionColor.g / maskUniforms.mask_heightRatio + maskUniforms.mask_heightOffset;
    let height = getFlatHeight(maskMode, flatHeight, vertexOutput.vWorldPosition.z);
    let wPosition = vec4f(vertexOutput.vWorldPosition.x, vertexOutput.vWorldPosition.y, height, vertexOutput.vWorldPosition.w);
    vertexOutput.vUVInExtent = uvInExtent;
    vertexOutput.vHeightRatio = maskUniforms.mask_heightRatio;
    vertexOutput.vHeightOffset = maskUniforms.mask_heightOffset;
    if (maskMode <= FLATOUTSIDE_MODE && maskMode > FLATINSIDE_MODE) {
        return uniforms.modelViewMatrix * position;
    } else if (maskUniforms.mask_hasFlatOut == 1.0) {
        return getNoErrorPosition(position, wPosition);
    }
    if (isInExtent(extentColor) && maskMode <= FLATINSIDE_MODE && maskMode > CLIPINSIDE_MODE) {
        return getNoErrorPosition(position, wPosition);
    }
    if (isInExtent(extentColor) && maskMode <= ELEVATE_MODE && maskMode > 0.6) {
        return getNoErrorPosition(position, wPosition);
    } else {
        return uniforms.modelViewMatrix * position;
    }
}
#endif
`;
const varyings$4 = [
    {
        name: 'vWorldPosition',
        type: 'vec4f'
    },
    {
        name: 'vUVInExtent',
        type: 'vec2f'
    },
    {
        name: 'vHeightRatio',
        type: 'f32'
    },
    {
        name: 'vHeightOffset',
        type: 'f32'
    }
];
var mask = {
    defines: ['HAS_MASK_EXTENT'],
    vert: vert$m,
    varyings: varyings$4
};

const vert$l = /* wgsl */ `
#include <invert_matrix>
#include <draco_decode_vert>

#include <instance_vert>

#ifdef HAS_SKIN
    struct SkinUniforms {
        skinAnimation: i32,
    };
    @group(0) @binding($b) var<uniform> skinUniforms: SkinUniforms;
    #include <skin_vert>
#endif

#include <mask_vert>

#ifdef HAS_MORPH
    struct MorphUniforms {
        morphWeights1: vec4f,
        morphWeights2: vec4f,
    };
    @group(0) @binding($b) var<uniform> morphUniforms: MorphUniforms;
#endif

#ifdef HAS_MIN_ALTITUDE
    struct AltitudeUniforms {
        minAltitude: f32,
    };
    @group(0) @binding($b) var<uniform> altitudeUniforms: AltitudeUniforms;
#endif

#ifdef HAS_TERRAIN_FLAT_MASK
    struct TerrainMaskUniforms {
        maskResolution: vec2f
    };
    @group(0) @binding($b) var<uniform> terrainMaskUniforms: TerrainMaskUniforms;
    @group(0) @binding($b) var flatMask: texture_2d<f32>;
#endif

fn getPositionMatrix(input: VertexInput, vertexOutput: ptr<function, VertexOutput>, positionMatrix: mat4x4f) -> mat4x4f {
    var worldMatrix: mat4x4f;
#ifdef HAS_INSTANCE
    let attributeMatrix = instance_getAttributeMatrix(input);
    #ifdef HAS_INSTANCE_COLOR
        vertexOutput.vInstanceColor = instance_getInstanceColor();
    #endif
    #ifdef HAS_SKIN
        if (skinUniforms.skinAnimation == 1) {
            worldMatrix = attributeMatrix * positionMatrix * skin_getSkinMatrix();
        } else {
            worldMatrix = attributeMatrix * positionMatrix;
        }
    #else
        worldMatrix = attributeMatrix * positionMatrix;
    #endif
#else
    #ifdef HAS_SKIN
        if (skinUniforms.skinAnimation == 1) {
            worldMatrix = skin_getSkinMatrix() * positionMatrix;
        } else {
            worldMatrix = positionMatrix;
        }
    #else
        worldMatrix = positionMatrix;
    #endif
#endif
    return worldMatrix;
}

fn getPosition(inputPosition: vec3f, vertexInput: VertexInput) -> vec4f {
    var position = decode_getPosition(inputPosition);
    #ifdef HAS_MORPH
        let outputPosition = vec4f(position +
            morphUniforms.morphWeights1[0] * vertexInput.POSITION0 +
            morphUniforms.morphWeights1[1] * vertexInput.POSITION1 +
            morphUniforms.morphWeights1[2] * vertexInput.POSITION2 +
            morphUniforms.morphWeights1[3] * vertexInput.POSITION3 +
            morphUniforms.morphWeights2[0] * vertexInput.POSITION4 +
            morphUniforms.morphWeights2[1] * vertexInput.POSITION5 +
            morphUniforms.morphWeights2[2] * vertexInput.POSITION6 +
            morphUniforms.morphWeights2[3] * vertexInput.POSITION7, 1.0);
    #else
        var outputPosition = vec4f(position, 1.0);
    #endif
    #ifdef HAS_TERRAIN_ALTITUDE
        outputPosition.z += vertexInput.aTerrainAltitude * 100.0;
    #endif
    #ifdef HAS_TERRAIN_FLAT_MASK
        var uv = vertexInput.aTexCoord;
        uv.y = 1.0 - uv.y;
        let texCoord = vec2i(uv * terrainMaskUniforms.maskResolution);
        let encodedHeight = textureLoad(flatMask, texCoord, 0);
        if (length(encodedHeight) < 2.0) {
            let maskHeight = decodeFloat32(encodedHeight);
            outputPosition.z = min(outputPosition.z, maskHeight);
        }
    #endif
    #ifdef HAS_MIN_ALTITUDE
        outputPosition.z += altitudeUniforms.minAltitude * 100.0;
    #endif
    return outputPosition;
}

fn appendMorphNormal(inputNormal: vec3f, vertexInput: VertexInput) -> vec3f {
    #ifdef HAS_MORPHNORMALS
        let normal = inputNormal +
            morphUniforms.morphWeights1[0] * vertexInput.NORMAL0 +
            morphUniforms.morphWeights1[1] * vertexInput.NORMAL1 +
            morphUniforms.morphWeights1[2] * vertexInput.NORMAL2 +
            morphUniforms.morphWeights1[3] * vertexInput.NORMAL3;
    #else
        let normal = inputNormal;
    #endif
    return normal;
}
`;
const varyings$3 = [
    {
        defines: ['HAS_INSTANCE_COLOR', 'HAS_INSTANCE'],
        name: 'vInstanceColor',
        type: 'vec4f'
    }
];
const attributes$3 = [
    {
        defines: ['HAS_MORPH'],
        name: 'POSITION0',
        type: 'vec3f'
    },
    {
        defines: ['HAS_MORPH'],
        name: 'POSITION0',
        type: 'vec3f'
    },
    {
        defines: ['HAS_MORPH'],
        name: 'POSITION1',
        type: 'vec3f'
    },
    {
        defines: ['HAS_MORPH'],
        name: 'POSITION2',
        type: 'vec3f'
    },
    {
        defines: ['HAS_MORPH'],
        name: 'POSITION3',
        type: 'vec3f'
    },
    {
        defines: ['HAS_MORPH'],
        name: 'POSITION4',
        type: 'vec3f'
    },
    {
        defines: ['HAS_MORPH'],
        name: 'POSITION5',
        type: 'vec3f'
    },
    {
        defines: ['HAS_MORPH'],
        name: 'POSITION6',
        type: 'vec3f'
    },
    {
        defines: ['HAS_MORPH'],
        name: 'POSITION7',
        type: 'vec3f'
    },
    {
        defines: ['HAS_MORPH', 'HAS_MORPHNORMALS'],
        name: 'NORMAL0',
        type: 'vec3f'
    },
    {
        defines: ['HAS_MORPH', 'HAS_MORPHNORMALS'],
        name: 'NORMAL0',
        type: 'vec3f'
    },
    {
        defines: ['HAS_MORPH', 'HAS_MORPHNORMALS'],
        name: 'NORMAL1',
        type: 'vec3f'
    },
    {
        defines: ['HAS_MORPH', 'HAS_MORPHNORMALS'],
        name: 'NORMAL2',
        type: 'vec3f'
    },
    {
        defines: ['HAS_TERRAIN_ALTITUDE'],
        name: 'aTerrainAltitude',
        type: 'f32'
    }
];
var get_output = {
    attributes: attributes$3,
    varyings: varyings$3,
    vert: vert$l
};

const vert$k = /* wgsl */ `
// 定义 uniform 变量
struct JoinUniforms {
    numJoints: f32,                     // 关节数量
};

@group(0) @binding($b) var<uniform> joinUniforms: JoinUniforms;

// 定义采样器
@group(0) @binding($b) var jointTextureSampler: sampler;
@group(0) @binding($b) var jointTexture: texture_2df,      // 关节纹理

// 定义采样点坐标
#define ROW0_U ((0.5 + 0.0) / 4.)
#define ROW1_U ((0.5 + 1.0) / 4.)
#define ROW2_U ((0.5 + 2.0) / 4.)
#define ROW3_U ((0.5 + 3.0) / 4.)

// 获取骨骼矩阵函数
fn skin_getBoneMatrix(jointNdx: f32) -> mat4x4f {
    let v = (jointNdx + 0.5) / joinUniforms.numJoints;
    return mat4x4f(
        textureSample(jointTexture, jointTextureSampler, vec2f(ROW0_U, v)),
        textureSample(jointTexture, jointTextureSampler, vec2f(ROW1_U, v)),
        textureSample(jointTexture, jointTextureSampler, vec2f(ROW2_U, v)),
        textureSample(jointTexture, jointTextureSampler, vec2f(ROW3_U, v))
    );
}

// 获取皮肤矩阵函数
fn skin_getSkinMatrix(JOINTS_0: vec4f, WEIGHTS_0: vec4f) -> mat4x4f {
    var skinMatrix = skin_getBoneMatrix(JOINTS_0[0]) * WEIGHTS_0[0] +
                     skin_getBoneMatrix(JOINTS_0[1]) * WEIGHTS_0[1] +
                     skin_getBoneMatrix(JOINTS_0[2]) * WEIGHTS_0[2] +
                     skin_getBoneMatrix(JOINTS_0[3]) * WEIGHTS_0[3];
    return skinMatrix;
}
`;
const attributes$2 = [
    {
        name: 'WEIGHTS_0',
        type: 'vec4f',
    },
    {
        name: 'JOINTS_0',
        type: 'vec4f',
    }
];
var skin = {
    vert: vert$k,
    attributes: attributes$2,
    defines: ['HAS_SKIN']
};

//用于识别顶点颜色类型: topPolygonFill 还是 bottomPolygonFill
const vert$j = /* wgsl */ `
struct VertexColorsUniforms {
    vertexColorsOfType: array<vec4f, VERTEX_TYPES_COUNT>
}

@group(0) @binding($b) var<uniform> vertexColors: VertexColorsUniforms;

fn vertexColor_update(input: VertexInput, output: ptr<function, VertexOutput>) {
    // 将 aVertexColorType 转换为整数索引
    let index: i32 = i32(input.aVertexColorType);
    // 获取对应的颜色
    output.vertexColorColor = vertexColors.vertexColorsOfType[index];
}

`;
const frag$s = /* wgsl */ `
fn vertexColor_get(input: VertexOutput) -> vec4<f32> {
    return input.vertexColorColor;
}
`;
const attributes$1 = [
    {
        name: 'aVertexColorType',
        type: 'u32',
    }
];
const varyings$2 = [
    {
        name: 'vertexColorColor',
        type: 'vec4f'
    }
];
var vertex_color = {
    vert: vert$j, frag: frag$s, attributes: attributes$1, varyings: varyings$2,
    defines: ['HAS_VERTEX_COLOR']
};

const vert$i = /* wgsl */ `
struct ShadowUniforms {
    shadow_lightProjViewModelMatrix: mat4x4f,
};

@group(0) @binding($b) var<uniform> shadowUniforms: ShadowUniforms;

fn shadow_computeShadowPars(position: vec4f, vertexOutput: ptr<function, VertexOutput>) {
    vertexOutput.shadow_vLightSpacePos = shadowUniforms.shadow_lightProjViewModelMatrix * position;
}
`;
const frag$r = /* wgsl */ `
struct ShadowUniforms {
    shadow_opacity: f32,
    shadow_color: vec3f,
    esm_shadow_threshold: f32
};

@group(0) @binding($b) var<uniform> shadowUniforms: ShadowUniforms;
@group(0) @binding($b) var shadow_shadowMapSampler: sampler;
@group(0) @binding($b) var shadow_shadowMap: texture_2d<f32>;


#ifdef PACK_FLOAT
#include <common_pack_float>
#endif

fn esm(projCoords: vec3f, shadowTexel: vec4f) -> f32 {
    let compare = projCoords.z;
    let c = 120.0;
#ifdef PACK_FLOAT
    var depth = common_decodeDepth(shadowTexel);
    if (depth >= 1.0 - 1E-6 || compare <= depth) {
        return 1.0;
    }
#else
    var depth = shadowTexel.r;
#endif

    depth = exp(-c * min(compare - depth, 0.05));
    return clamp(depth, shadowUniforms.esm_shadow_threshold, 1.0);
}

fn shadow_computeShadow_coeff(shadowMap: texture_2d<f32>, projCoords: vec3f) -> f32 {
    var uv = projCoords.xy;
    let shadowTexel = textureSample(shadowMap, shadow_shadowMapSampler, uv);
    let esm_coeff = esm(projCoords, shadowTexel);
    let coeff = esm_coeff * esm_coeff;
    return 1.0 - (1.0 - coeff) * shadowUniforms.shadow_opacity;

    // return shadowTexel.r;
}

fn shadow_computeShadow(vertexOutput: VertexOutput) -> f32 {
    var projCoords = vertexOutput.shadow_vLightSpacePos.xyz / vertexOutput.shadow_vLightSpacePos.w;
    // projCoords = projCoords * 0.5 + 0.5;
    projCoords = vec3(projCoords.xy * 0.5 + 0.5, projCoords.z);
    let coeff = shadow_computeShadow_coeff(shadow_shadowMap, projCoords);
    if (projCoords.z >= 1.0 || projCoords.x < 0.0 || projCoords.x > 1.0 || projCoords.y < 0.0 || projCoords.y > 1.0) {
        return 1.0;
    }
    return coeff;
}

fn shadow_blend(color: vec3f, coeff: f32) -> vec3f {
    return color * coeff + shadowUniforms.shadow_color * shadowUniforms.shadow_opacity * (1.0 - coeff);
}
`;
const varyings$1 = [
    {
        name: 'shadow_vLightSpacePos',
        type: 'vec4f',
        defines: ['HAS_SHADOWING']
    }
];
var vsm_shadow = {
    defines: (defines) => {
        return defines['HAS_SHADOWING'] && !defines['HAS_BLOOM'];
    },
    vert: vert$i, frag: frag$r, varyings: varyings$1
};

const vert$h = /* wgsl */ `
#if HAS_DRACO_NORMAL || HAS_DRACO_POSITION || HAS_DRACO_TEXCOORD || HAS_WEB3D_QUANTIZED_ATTRIBUTES_TEXCOORD || HAS_COMPRESSED_INT16
    // 定义 uniform 变量
    struct DracoUniforms {
        #if HAS_DRACO_NORMAL
            gltf_u_dec_normal_rangeConstant: f32,
        #endif

        #if HAS_DRACO_POSITION
            minValues_pos: vec3f,
            gltf_u_dec_position_normConstant: f32,
        #endif

        #if HAS_DRACO_TEXCOORD
            minValues_tex: vec2f,
            gltf_u_dec_texcoord_0_normConstant: f32,
        #endif

        #if HAS_WEB3D_QUANTIZED_ATTRIBUTES_TEXCOORD
            decodeMatrix: mat3x3f,
        #endif

    #if HAS_COMPRESSED_INT16
        #if HAS_COMPRESSED_INT16_POSITION
            compressedPositionRange: vec2f, // 压缩位置范围
        #endif
        #if HAS_COMPRESSED_INT16_TEXCOORD_0
            compressedTexcoordRange_0: vec2f, // 压缩纹理坐标范围 0
        #endif
        #if HAS_COMPRESSED_INT16_TEXCOORD_1
            compressedTexcoordRange_1: vec2f, // 压缩纹理坐标范围 1
        #endif
        #if HAS_COMPRESSED_INT16_NORMAL
            compressedNormalRange: vec2f, // 压缩法线范围
        #endif
        #if HAS_COMPRESSED_INT16_RATIO
            compressed_ratio: f32, // 压缩比例
        #endif
    #endif
    };

    @group(0) @binding($b) var<uniform> dracoUniforms: DracoUniforms;
#endif

    // Draco 位置解码函数
    #ifdef HAS_DRACO_POSITION
    fn decodeDracoPosition(aPosition: vec3f) -> vec3f {
        return dracoUniforms.minValues_pos + aPosition * dracoUniforms.gltf_u_dec_position_normConstant;
    }
    #endif

    // Draco 纹理坐标解码函数
    #ifdef HAS_DRACO_TEXCOORD
    fn decodeDracoTexcoord(aTexCoord: vec2f) -> vec2f {
        return dracoUniforms.minValues_tex + aTexCoord * dracoUniforms.gltf_u_dec_texcoord_0_normConstant;
    }
    #endif

    // Draco 法线解码函数
    #ifdef HAS_DRACO_NORMAL
    fn czm_signNotZero1(value: f32) -> f32 {
        return select(-1.0, 1.0, value >= 0.0);
    }

    fn czm_signNotZero(value: vec2f) -> vec2f {
        return vec2f(czm_signNotZero1(value.x), czm_signNotZero1(value.y));
    }

    fn decodeDracoNormal(encoded: vec2f, range: f32) -> vec3f {
        if (encoded.x == 0.0 && encoded.y == 0.0) {
            return vec3f(0.0, 0.0, 0.0);
        }
        let value = encoded / range * 2.0 - 1.0;
        var v = vec3f(value.x, value.y, 1.0 - abs(value.x) - abs(value.y));
        if (v.z < 0.0) {
            v = vec3f((1.0 - abs(v.yx)) * czm_signNotZero(v.xy), v.z);
        }
        return normalize(v);
    }

    fn decode_getNormal2(aNormal: vec2f) -> vec3f {
        return decodeDracoNormal(aNormal, dracoUniforms.gltf_u_dec_normal_rangeConstant).zxy;
    }
    #endif

    // 压缩属性解码函数
    #ifdef HAS_COMPRESSED_INT16
    fn int16ToFloat32(value: f32, range: vec2f) -> f32 {
        let v = select(value / 32767.0, -(65536.0 - value) / 32768.0, value >= 32768.0);
        return (v + 1.0) * (range.y - range.x) / 2.0 + range.x;
    }
    #endif

    // 顶点位置解码函数
    fn decode_getPosition(aPosition: vec3f) -> vec3f {
        var position = aPosition;
    #if HAS_COMPRESSED_INT16 && HAS_COMPRESSED_INT16_POSITION
        let x = int16ToFloat32(aPosition.x, dracoUniforms.compressedPositionRange);
        let y = int16ToFloat32(aPosition.y, dracoUniforms.compressedPositionRange);
        let z = int16ToFloat32(aPosition.z, dracoUniforms.compressedPositionRange);
        #ifdef HAS_COMPRESSED_INT16_RATIO
            position = vec3f(x / dracoUniforms.compressed_ratio, y / dracoUniforms.compressed_ratio, z);
        #else
            position = vec3f(x, y, z);
        #endif
    #endif
    #ifdef HAS_DRACO_POSITION
        return decodeDracoPosition(position);
    #else
        return position;
    #endif
    }

    // 纹理坐标解码函数
    fn decode_getTexcoord(aTexCoord: vec2f) -> vec2f {
        var texcoord = aTexCoord;
    // if HAS_COMPRESSED_INT16 && (HAS_COMPRESSED_INT16_TEXCOORD_0 || HAS_COMPRESSED_INT16_TEXCOORD_1)
    #if HAS_COMPRESSED_INT16
        #if HAS_COMPRESSED_INT16_TEXCOORD_0 || HAS_COMPRESSED_INT16_TEXCOORD_1
            let x = int16ToFloat32(aTexCoord.x, dracoUniforms.compressedTexcoordRange_0);
            let y = int16ToFloat32(aTexCoord.y, dracoUniforms.compressedTexcoordRange_0);
            texcoord = vec2f(x, y);
        #endif
    #endif
    #ifdef HAS_DRACO_TEXCOORD
        return decodeDracoTexcoord(texcoord);
    #else
        #if HAS_WEB3D_QUANTIZED_ATTRIBUTES_TEXCOORD
            let web3dTexcoord = dracoUniforms.decodeMatrix * vec3f(texcoord, 1.0);
            return vec2f(web3dTexcoord.x, web3dTexcoord.y);
        #else
            return texcoord;
        #endif
    #endif
    }

    // 法线解码函数
    fn decode_getNormal(aNormal: vec3f) -> vec3f {
    #ifdef HAS_COMPRESSED_INT16_NORMAL
        aNormal.x = int16ToFloat32(aNormal.x, dracoUniforms.compressedNormalRange);
        aNormal.y = int16ToFloat32(aNormal.y, dracoUniforms.compressedNormalRange);
        aNormal.z = int16ToFloat32(aNormal.z, dracoUniforms.compressedNormalRange);
    #endif
        return aNormal;
    }
`;
var draco_decode = {
    vert: vert$h
};

const vert$g = /* wgsl */ `

    // 顶点着色器函数
    fn highlight_setVarying(input: VertexInput, output: ptr<function, VertexOutput>) {
        // 如果有高亮颜色
    #if HAS_HIGHLIGHT_COLOR
        output.vHighlightColor = vec4f(input.aHighlightColor) / 255.0;
    #endif

        // 如果有高亮透明度
    #if HAS_HIGHLIGHT_OPACITY
        output.vHighlightOpacity = f32(input.aHighlightOpacity) / 255.0;
    #endif
    }
`;
const frag$q = /* wgsl */ `
    // 高亮颜色混合函数
    fn highlight_blendColor(color: vec4f, output: VertexOutput) -> vec4f {
        var outColor: vec4f = color;

        // 如果有高亮颜色
        #if HAS_HIGHLIGHT_COLOR
            let highlightColor = output.vHighlightColor;
            let opacity = highlightColor.a;
            outColor = vec4f(outColor.rgb * (1.0 - opacity) + highlightColor.rgb * opacity, outColor.a);
            #ifndef HAS_HIGHLIGHT_COLOR_POINT
                // 如果没有高亮颜色点
                outColor.a = outColor.a * (1.0 - opacity) + opacity;
            #endif
        #endif

            // 如果有高亮透明度
        #if HAS_HIGHLIGHT_OPACITY
            outColor *= output.vHighlightOpacity;
        #endif

        return outColor;
    }
`;
const attributes = [
    {
        defines: ['HAS_HIGHLIGHT_COLOR'],
        name: 'aHighlightColor',
        type: 'vec4u'
    },
    {
        defines: ['HAS_HIGHLIGHT_OPACITY'],
        name: 'aHighlightOpacity',
        type: 'u32'
    }
];
const varyings = [
    {
        defines: ['HAS_HIGHLIGHT_COLOR'],
        name: 'vHighlightColor',
        type: 'vec4f'
    },
    {
        defines: ['HAS_HIGHLIGHT_OPACITY'],
        name: 'vHighlightOpacity',
        type: 'f32'
    }
];
var highlight$1 = {
    defines: (defines) => {
        return defines['HAS_HIGHLIGHT_OPACITY'] || defines['HAS_HIGHLIGHT_COLOR'];
    },
    vert: vert$g, frag: frag$q, attributes, varyings
};

const frag$p = /* wgsl */ `
#ifdef HAS_KHR_TEXTURE_TRANSFORM
    struct TextureTransformUniforms {
        offset: vec2f,
        rotation: f32,
        scale: vec2f,
    };

    @group(0) @binding($b) var<uniform> textureTransformUniforms: TextureTransformUniforms;

    fn khr_tex_transformTexCoord(texCoords: vec2f, offset: vec2f, rotation: f32, scale: vec2f) -> vec2f {
        rotation = -rotation;
        let transform = mat3x3f(
            cos(rotation) * scale.x, sin(rotation) * scale.x, 0.0,
            -sin(rotation) * scale.y, cos(rotation) * scale.y, 0.0,
            offset.x, offset.y, 1.0
        );
        let transformedTexCoords = (transform * vec3f(fract(texCoords), 1.0)).xy;
        return transformedTexCoords;
    }
#endif

fn computeTexCoord(texCoord: vec2f, vertexOutput: VertexOutput) -> vec2f {
    #ifdef HAS_I3S_UVREGION
        let atlasScale = vertexOutput.vUvRegion.zw - vertexOutput.vUvRegion.xy;
        let uvAtlas = fract(texCoord) * atlasScale + vertexOutput.vUvRegion.xy;
        return uvAtlas;
    #elif HAS_KHR_TEXTURE_TRANSFORM
        let uniforms = textureTransformUniforms;
        return khr_tex_transformTexCoord(texCoord, uniforms.offset, uniforms.rotation, uniforms.scale);
    #else
        return texCoord;
    #endif
}
`;
var compute_texcoord = {
    defines: ['HAS_MAP'],
    frag: frag$p
};

const vert$f = /*wgsl*/ `
//--------------------------
// Picking
//
// #define ENABLE_PICKING 整型 是否开启PICKING
//
// uniform int batchId geometry的批次id
//
//
// fn fbo_picking_setData(viewPosZ: f32, visible: bool)
//   设置picking数据,必须在设置gl_Position后调用
//
// 示例：
// fbo_picking_setData(output.position.w, true);
//--------------------------

#ifdef ENABLE_PICKING
#if HAS_PICKING_ID == 2
    struct PickingUniforms {
        uPickingId: f32,
    }
    @group(0) @binding($b) var<uniform> pickingUniforms: PickingUniforms;
#endif
#endif

fn fbo_picking_setData(input: VertexInput, output: ptr<function, VertexOutput>, viewPosZ: f32, visible: bool) {
    #ifdef ENABLE_PICKING
    #if HAS_PICKING_ID == 1
       output.vPickingId = input.aPickingId;
    #elif HAS_PICKING_ID == 2
        output.vPickingId = pickingUniforms.uPickingId;
    #endif
        output.vFbo_picking_viewZ = viewPosZ;
        output.vFbo_picking_visible = select(0.0, 1.0, visible);
    #endif
    output.vFbo_picking_fragDepth = viewPosZ + 1.0;
}
`;
var fbo_picking = {
    vert: vert$f,
    attributes: [
        {
            defines: (defines) => {
                return defines.HAS_PICKING_ID === 1;
            },
            name: 'aPickingId',
            type: 'f32'
        }
    ],
    varyings: [
        {
            defines: ['ENABLE_PICKING'],
            name: 'vFbo_picking_visible',
            type: 'f32'
        },
        {
            defines: ['ENABLE_PICKING'],
            name: 'vPickingId',
            type: 'f32'
        },
        {
            defines: ['ENABLE_PICKING'],
            name: 'vFbo_picking_viewZ',
            type: 'f32'
        },
        {
            name: 'vFbo_picking_fragDepth',
            type: 'f32'
        },
    ]
};

const vert$e = /* wgsl */ `
const COMMON_FLOAT_MAX: f32 = 1.70141184e38;
const COMMON_FLOAT_MIN: f32 = 1.17549435e-38;

fn common_packFloat(val: vec4f) -> f32 {
    let scl = floor(255.0 * val + 0.5);
    let sgn = select(-1.0, 1.0, scl.a < 128.0);
    let exn = (scl.a * 2.0 % 256.0) + floor(scl.b / 128.0) - 127.0;
    let man = 1.0 +
        (scl.r / 8388608.0) +
        (scl.g / 32768.0) +
        (scl.b % 128.0) / 128.0;
    return sgn * man * pow(2.0, exn);
}

fn common_unpackFloat(v: f32) -> vec4f {
    let av = abs(v);

    // Handle special cases
    if (av < COMMON_FLOAT_MIN) {
        return vec4f(0.0, 0.0, 0.0, 0.0);
    } else if (v > COMMON_FLOAT_MAX) {
        return vec4f(127.0, 128.0, 0.0, 0.0) / 255.0;
    } else if (v < -COMMON_FLOAT_MAX) {
        return vec4f(255.0, 128.0, 0.0, 0.0) / 255.0;
    }

    var c = vec4f(0.0, 0.0, 0.0, 0.0);

    // Compute exponent and mantissa
    let e = floor(log2(av));
    var m = av * pow(2.0, -e) - 1.0;

    // Unpack mantissa
    c[1] = floor(128.0 * m);
    m -= c[1] / 128.0;
    c[2] = floor(32768.0 * m);
    m -= c[2] / 32768.0;
    c[3] = floor(8388608.0 * m);

    // Unpack exponent
    var ebias = e + 127.0;
    c[0] = floor(ebias / 2.0);
    ebias -= c[0] * 2.0;
    c[1] += floor(ebias) * 128.0;

    // Unpack sign bit
    c[0] += 128.0 * step(0.0, -v);

    // Scale back to range
    return c / 255.0;
}

fn common_encodeDepth(depth: f32) -> vec4f {
    let alpha = 1.0;
    var pack = vec4f(0.0);
    pack.a = alpha;
    const code = vec3f(1.0, 255.0, 65025.0);
    pack = vec4f(vec3f(code * depth), pack.a);
    pack = vec4f(pack.r, fract(pack.gb), pack.a);
    pack.r -= pack.g * (1.0 / 256.0);
    pack.g -= pack.b * (1.0 / 256.0);
    pack.b -= (pack.b % (4.0 / 255.0));
    return pack;
}

fn common_decodeDepth(pack: vec4f) -> f32 {
    return pack.r + pack.g / 255.0;
}

// https://cloud.tencent.com/developer/ask/sof/103481834
fn encodeFloat32(f: f32) -> vec4f {
    var e = 5.0;

    var F = abs(f);
    var Sign = step(0.0, -f);
    var Exponent = floor(log2(F));
    var Mantissa = (exp2(- Exponent) * F);
    Exponent = floor(log2(F) + 127.0) + floor(log2(Mantissa));
    var rgba = vec4(0.0);
    rgba[0] = 128.0 * Sign  + floor(Exponent*exp2(-1.0));
    rgba[1] = 128.0 * (Exponent % 2.0) + (floor(Mantissa*128.0) % 128.0);
    rgba[2] = floor((floor(Mantissa*exp2(23.0 -8.0)) % exp2(8.0)));
    rgba[3] = floor(exp2(23.0)*(Mantissa % exp2(-15.0)));
    return rgba / 255.0;
}

fn decodeFloat32(inputRgba: vec4f) -> f32 {
    var rgba = inputRgba * 255.0;
    var Sign = 1.0 - step(128.0,rgba[0])*2.0;
    var Exponent = 2.0 * (rgba[0] % 128.0) + step(128.0,rgba[1]) - 127.0;
    var Mantissa = (rgba[1] % 128.0)*65536.0 + rgba[2]*256.0 +rgba[3] + 0x800000;
    var Result =  Sign * exp2(Exponent) * (Mantissa * exp2(-23.0 ));
    return Result;
}
`;
const frag$o = vert$e;
var common_pack_float = {
    vert: vert$e, frag: frag$o
};

const vert$d = /*wgsl*/ `
#ifdef HAS_EXCAVATE_ANALYSIS
struct ExcavateUniforms {
    excavateExtent: vec4f
};

@group(0) @binding($b) var<uniform> excavateUniforms: ExcavateUniforms;

fn getWorldHeight(localPosition: vec4f, modelMatrix: mat4x4f) -> f32 {
    let wPosition = uniforms.modelMatrix * localPosition;
    return wPosition.z;
}

fn getCoordinateTexcoord(localPosition: vec4f, modelMatrix: mat4x4f) -> vec2f {
    let wPosition = modelMatrix * localPositionMatrix;
    let x = (wPosition.x - excavateUniforms.excavateExtent.x) /
           (excavateUniforms.excavateExtent.z - excavateUniforms.excavateExtent.x);
    let y = (wPosition.y - excavateUniforms.excavateExtent.y) /
           (excavateUniforms.excavateExtent.w - excavateUniforms.excavateExtent.y);
    return vec2f(x, y);
}

#endif
`;
const frag$n = /*wgsl*/ `
#ifdef HAS_EXCAVATE_ANALYSIS
struct ExcavateUniforms {
    excavateHeight: f32,
    heightRange: vec2f  // Replaces the const range
};

@group(0) @binding($b) var<uniform> excavateUniforms: ExcavateUniforms;
@group(0) @binding($b) var heightmap: texture_2d<f32>;
@group(0) @binding($b) var heightmapSampler: sampler;


fn decodeHeight(pack: vec4f) -> f32 {
    return pack.r + pack.g / 255.0;
}

fn excavateColor(fragColor: vec4f, vertexOutput: VertexOutput) -> vec4f {
    let samplerHeight = decodeHeight(textureSample(heightmap, heightmapSampler, vertexOutput.vCoordinateTexcoord));
    let realHeight = samplerHeight * (excavateUniforms.heightRange.y - excavateUniforms.heightRange.x) + excavateUniforms.heightRange.x;

    let validHeight = select(
        0.0,
        realHeight,
        realHeight >= excavateUniforms.heightRange.x && realHeight <= excavateUniforms.heightRange.y
    );

    if (vertexOutput.vExcavateHeight > validHeight) {
        discard;
    }
    return fragColor;
}
#endif
`;
var excavate = {
    defines: ['HAS_EXCAVATE_ANALYSIS'],
    vert: vert$d,
    frag: frag$n,
    varyings: [
        {
            name: 'vCoordinateTexcoord',
            type: 'vec2f'
        },
        {
            name: 'vExcavateHeight',
            type: 'f32'
        }
    ]
};

const frag$m = /*wgsl*/ `
const HSV_K0 = vec4f(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);
const HSV_K1 = vec4f(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
const HSV_E = 1.0e-10;

fn hsv_rgb2hsv(c: vec3f) -> vec3f {
    var K = HSV_K0;
    var p = mix(vec4f(c.bg, K.wz), vec4f(c.gb, K.xy), select(0.0, 1.0, c.b <= c.g));
    var q = mix(vec4f(p.xyw, c.r), vec4f(c.r, p.yzx), select(0.0, 1.0, p.x <= c.r));

    // Alternative implementation commented out
    // var p = select(vec4f(c.gb, K.xy), vec4f(c.bg, K.wz), c.g < c.b);
    // var q = select(vec4f(c.r, p.yzx), vec4f(p.xyw, c.r), c.r < p.x);

    let d = q.x - min(q.w, q.y);
    let e = HSV_E;
    return vec3f(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);
}

fn hsv_hsv2rgb(c: vec3f) -> vec3f {
    let K = HSV_K1;
    let p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
    return c.z * mix(K.xxx, clamp(p - K.xxx, vec3f(0.0), vec3f(1.0)), c.y);
}

fn hsv_apply4(c: vec4f, hsvOffset: vec3f) -> vec4f {
    var hsv = hsv_rgb2hsv(c.rgb);
    hsv += hsv * hsvOffset;
    hsv = clamp(hsv, vec3f(0), vec3f(1));
    return vec4f(hsv_hsv2rgb(hsv), c.a);
}

fn hsv_apply3(c: vec3f, hsvOffset: vec3f) -> vec3f {
    var hsv = hsv_rgb2hsv(c);
    hsv += hsv * hsvOffset;
    hsv = clamp(hsv, vec3f(0), vec3f(1));
    return hsv_hsv2rgb(hsv);
}

fn contrastMatrix(contrast: f32) -> mat4x4f {
    let t = (1.0 - contrast) / 2.0;
    return mat4x4f(
        vec4f(contrast, 0.0, 0.0, 0.0),
        vec4f(0.0, contrast, 0.0, 0.0),
        vec4f(0.0, 0.0, contrast, 0.0),
        vec4f(t, t, t, 1.0)
    );
}
`;
var hsv = {
    frag: frag$m
};

const frag$l = /*wgsl*/ `
fn linearTosRGB(color: vec3f) -> vec3f {
    return vec3f(
        select(1.055 * pow(color.r, 1.0/2.4) - 0.055, color.r * 12.92, color.r < 0.0031308),
        select(1.055 * pow(color.g, 1.0/2.4) - 0.055, color.g * 12.92, color.g < 0.0031308),
        select(1.055 * pow(color.b, 1.0/2.4) - 0.055, color.b * 12.92, color.b < 0.0031308)
    );
}

fn sRGBToLinear(color: vec3f) -> vec3f {
    return vec3f(
        select(pow((color.r + 0.055) * (1.0 / 1.055), 2.4), color.r * (1.0 / 12.92), color.r < 0.04045),
        select(pow((color.g + 0.055) * (1.0 / 1.055), 2.4), color.g * (1.0 / 12.92), color.g < 0.04045),
        select(pow((color.b + 0.055) * (1.0 / 1.055), 2.4), color.b * (1.0 / 12.92), color.b < 0.04045)
    );
}
`;
var srgb = {
    frag: frag$l
};

const frag$k = /*wgsl*/ `
#ifdef HAS_SNOW
fn lerp(a: f32, b: f32, w: f32) -> f32 {
    return a + w * (b - a);
}

fn snow(sceneColor: vec4f, normalColor: vec3f, height: f32) -> vec3f {
    let snowIntense = normalColor.b;
    let fixedC = vec3f(1.0, 1.0, 1.0);

    if (height < 1.0) {
        let r = lerp(0.5, fixedC.x, snowIntense);
        let g = lerp(0.5, fixedC.y, snowIntense);
        let b = lerp(0.5, fixedC.z, snowIntense);
        return vec3f(r, g, b);
    } else {
        let r = lerp(sceneColor.r, fixedC.x, snowIntense);
        let g = lerp(sceneColor.g, fixedC.y, snowIntense);
        let b = lerp(sceneColor.b, fixedC.z, snowIntense);
        return vec3f(r, g, b);
    }
}
#endif
`;
var snow = {
    defines: ['HAS_SNOW'],
    frag: frag$k
};

const frag$j = /*wgsl*/ `
#ifdef HAS_TERRAIN_NORMAL
struct TerrainNormalUniforms {
    terrainHeightMapResolution: vec2f,
    terrainResolution: vec2f,
    terrainUnpackFactors: vec4f
};

@group(0) @binding($b) var<uniform> terrainNormalUniforms: TerrainNormalUniforms;
@group(0) @binding($b) var terrainHeightTexture: texture_2d<f32>;
@group(0) @binding($b) var terrainHeightTextureSampler: sampler;

fn getHeight(uv: vec2f) -> f32 {
    let color = textureSample(terrainHeightTexture, terrainHeightTextureSampler, uv) * 255.0;
    let colorWithAlpha = vec4f(color.rgb, -1.0);
    return dot(colorWithAlpha, terrainNormalUniforms.terrainUnpackFactors) / 4.0;
}

fn convertTerrainHeightToNormalMap(uv: vec2f) -> vec3f {
    let flippedUV = vec2f(uv.x, 1.0 - uv.y);
    let epsilon = 1.0 / terrainNormalUniforms.terrainHeightMapResolution;

    let a = getHeight(flippedUV + vec2f(-epsilon.x, -epsilon.y));
    let b = getHeight(flippedUV + vec2f(0.0, -epsilon.y));
    let c = getHeight(flippedUV + vec2f(epsilon.x, -epsilon.y));
    let d = getHeight(flippedUV + vec2f(-epsilon.x, 0.0));
    let e = getHeight(flippedUV + vec2f(epsilon.x, 0.0));
    let f = getHeight(flippedUV + vec2f(-epsilon.x, epsilon.y));
    let g = getHeight(flippedUV + vec2f(0.0, epsilon.y));
    let h = getHeight(flippedUV + vec2f(epsilon.x, epsilon.y));

    let dxy = vec2f(
        (c + e + e + h) - (a + d + d + f),
        (f + g + g + h) - (a + b + b + c)
    );
    return normalize(vec3f(dxy / epsilon, terrainNormalUniforms.terrainResolution.x));
}
#endif
`;
var terrain_normal = {
    defines: ['HAS_TERRAIN_NORMAL'],
    frag: frag$j
};

const vert$c = /*wgsl*/ `
#include <fbo_picking_vert>
#include <get_output>

struct VertexInput {
    #include <position_vert>
}

struct Uniforms {
    projViewModelMatrix: mat4x4f,
    modelMatrix: mat4x4f,
    positionMatrix: mat4x4f,
}

@group(0) @binding($b) var<uniform> uniforms: Uniforms;

struct VertexOutput {
    @builtin(position) position: vec4f,
    // 其他varying变量可以在这里添加
}

@vertex
fn main(input: VertexInput) -> VertexOutput {
    var output: VertexOutput;

    let localPositionMatrix = getPositionMatrix(input, &output, uniforms.positionMatrix);
    let localPosition = getPosition(vec3f(input.aPosition.xyz), input);

    output.position = uniforms.projViewModelMatrix * localPositionMatrix * localPosition;
    // 传入Position的depth值
    fbo_picking_setData(input, &output, output.position.w, true);

    return output;
}
`;
var mesh_picking = {
    vert: vert$c
};

const frag$i = /*wgsl*/ `
fn encodeRGBM(color: vec3f, range: f32) -> vec4f {
    if (range <= 0.0) {
        return vec4f(color, 1.0);
    }
    var rgbm: vec4f;
    let col = color / range;
    rgbm.a = clamp(max(max(col.r, col.g), max(col.b, 1e-6)), 0.0, 1.0);
    rgbm.a = ceil(rgbm.a * 255.0) / 255.0;
    rgbm = vec4f(col / rgbm.a, rgbm.a);
    return rgbm;
}

fn decodeRGBM(color: vec4f, range: f32) -> vec3f {
    if (range <= 0.0) {
        return color.rgb;
    }
    return range * color.rgb * color.a;
}
`;
var rgbm = {
    frag: frag$i
};

/* eslint-disable camelcase */
//Shader Chunks for includes
const ShaderChunk = {
    position,
    instance,
    invert_matrix,
    line_extrusion,
    mask,
    get_output,
    skin,
    vertex_color,
    vsm_shadow,
    draco_decode,
    highlight: highlight$1,
    compute_texcoord,
    fbo_picking,
    common_pack_float,
    excavate,
    hsv,
    srgb,
    snow,
    terrain_normal,
    mesh_picking,
    rgbm
};
/* eslint-enable camelcase */
var WgslShaderLib = {
    register(name, segment) {
        if (ShaderChunk[name]) {
            throw new Error(`Key of ${name} is already registered in WgslShaderLib.`);
        }
        ShaderChunk[name] = segment;
    },
    /**
     * Compile the given source, replace #include with registered shader sources
     * @param {String} source source to compile
     */
    compile(source, defines) {
        return new SourceCompiler(source, defines).compile();
        // return parseIncludes(source);
    },
    get(name) {
        return ShaderChunk[name];
    }
};
const pattern = /^[ \t]*#include +<([\w\d.]+)>/gm;
const attrInputPattern = /\bstruct\s+AttributeInput\b/;
const vertexInputPattern = /\bstruct\s+VertexInput\b/;
const vertexOutputPattern = /\bstruct\s+VertexOutput\b/;
class SourceCompiler {
    constructor(source, defines) {
        this.defines = defines;
        this.source = source;
        this.isVert = source.indexOf('@vertex') > -1;
        this.varyings = [];
        this.attributes = [];
    }
    compile() {
        let source = this.source;
        source = this.parseIncludes(source);
        // source中的 #include 预处理已经替换为了实际的代码
        if (this.isVert) {
            source = this.fillAttributes(source);
            source = this.fillVaryings(source);
        }
        return source;
    }
    parseIncludes(string) {
        return string.replace(pattern, (match, include) => {
            let key = include;
            if (include.endsWith('_vert')) {
                key = include.substring(0, include.length - 5);
            }
            else if (include.endsWith('_frag')) {
                key = include.substring(0, include.length - 5);
            }
            const replace = ShaderChunk[key];
            if (!replace) {
                throw new Error('Can not resolve #include <' + include + '>');
            }
            // 1. 用include中的代码替换原有的 #include <foo> 预处理语句
            if (replace.defines) {
                // 代码中定义的defines是否满足include中的defines条件
                if (!this.checkDefines(replace.defines)) {
                    return '';
                }
            }
            // 2. 将include中的varyings和attributes添加到当前的varyings和attributes中
            if (replace.varyings) {
                for (let i = 0; i < replace.varyings.length; i++) {
                    const varying = replace.varyings[i];
                    if (varying.defines && !this.checkDefines(varying.defines)) {
                        continue;
                    }
                    this.varyings.push(varying);
                }
            }
            if (replace.attributes) {
                for (let i = 0; i < replace.attributes.length; i++) {
                    const attr = replace.attributes[i];
                    if (attr.defines && !this.checkDefines(attr.defines)) {
                        continue;
                    }
                    this.attributes.push(attr);
                }
            }
            return this.parseIncludes(this.isVert ? replace.vert : replace.frag);
        });
    }
    fillAttributes(source) {
        if (source.indexOf('AttributeInput') > 0) {
            return this.fillStruct(source, attrInputPattern, '$i', this.attributes);
        }
        return this.fillStruct(source, vertexInputPattern, '$i', this.attributes);
    }
    fillVaryings(source) {
        const varName = this.isVert ? '$o' : '$i';
        return this.fillStruct(source, vertexOutputPattern, varName, this.varyings);
    }
    fillStruct(source, reg, varName, items) {
        if (!items.length) {
            return source;
        }
        const structBeginIndex = source.search(reg);
        const endIndex = source.indexOf('}', structBeginIndex);
        const firstPart = source.substring(0, endIndex);
        const secondPart = source.substring(endIndex);
        const attributes = [];
        for (let i = 0; i < items.length; i++) {
            const { name, type } = items[i];
            attributes.push(`@location(${varName}) ${name}: ${type},`);
        }
        return firstPart + attributes.join('\n') + '\n' + secondPart;
    }
    checkDefines(defines) {
        if (Array.isArray(defines)) {
            // 如果是数组，defines中所有的key都需要被定义
            for (let i = 0; i < defines.length; i++) {
                const def = defines[i];
                if (!this.defines[def]) {
                    return false;
                }
            }
        }
        else if (!defines(this.defines)) {
            // 输入的defines也可以是函数
            return false;
        }
        return true;
    }
}

const DEPTH_DICTIONARY = {
    '=': 'equal',
    '<': 'less',
    '<=': 'less-equal',
    'lequal': 'less-equal',
    '>': 'greater',
    '!=': 'not-equal',
    'notequal': 'not-equal',
    '>=': 'greater-equal',
    'gequal': 'greater-equal'
};
function toGPUCompareFunction(func) {
    return DEPTH_DICTIONARY[func] || func;
}
const TOPOLOGY_DICTIONARY = {
    // 'points': 'point-list',
    'triangles': 'triangle-list',
    'triangle strip': 'triangle-strip',
    'lines': 'line-list',
    // 'line strip': 'line-strip'
};
function toTopology(primitive) {
    return TOPOLOGY_DICTIONARY[primitive] || 'triangle-list';
}
const BLENDFACTOR_DICTIONARY = {
    0: 'zero',
    1: 'one',
    'src color': 'src',
    'one minus src color': 'one-minus-src',
    'src alpha': 'src-alpha',
    'one minus src alpha': 'one-minus-src-alpha',
    'dst color': 'dst',
    'one minus dst color': 'one-minus-dst',
    'dst alpha': 'dst-alpha',
    'one minus dst alpha': 'one-minus-dst-alpha'
    // 其实还有一些别的值，但因为没用到，这里就不用继续翻译了
};
function toGPUBlendFactor(blendFactor) {
    return BLENDFACTOR_DICTIONARY[blendFactor] || blendFactor;
}
const ADDRESS_MODE_DICTIONARY = {
    'clamp': 'clamp-to-edge',
    'mirror': 'mirror-repeat'
};
function toGPUSampler(minFilter, magFilter, wrapS, wrapT, compare) {
    const sampler = {
        magFilter
    };
    if (minFilter === 'nearest' || minFilter === 'linear') {
        sampler.minFilter = minFilter;
    }
    else if (minFilter === 'linear mipmap linear' || minFilter === 'mipmap') {
        sampler.minFilter = 'linear';
        sampler.mipmapFilter = 'linear';
    }
    else if (minFilter === 'nearest mipmap nearest') {
        sampler.minFilter = 'linear';
        sampler.mipmapFilter = 'nearest';
    }
    else if (minFilter === 'nearest mipmap linear') {
        sampler.minFilter = 'nearest';
        sampler.mipmapFilter = 'linear';
    }
    else if (minFilter === 'linear mipmap nearest') {
        sampler.minFilter = 'linear';
        sampler.mipmapFilter = 'nearest';
    }
    sampler.addressModeU = ADDRESS_MODE_DICTIONARY[wrapS || 'clamp'] || wrapS;
    sampler.addressModeV = ADDRESS_MODE_DICTIONARY[wrapT || 'clamp'] || wrapT;
    if (compare) {
        sampler.compare = compare;
    }
    return sampler;
}
function toTextureFormat(format, type) {
    format = format || 'rgba';
    type = type || 'uint8';
    if (format === 'depth stencil' || format === 'depth24 stencil8') {
        return { format: 'depth24plus-stencil8', bytesPerTexel: 4, isDepthStencil: true };
    }
    else if (format === 'depth') {
        return { format: 'depth24plus', bytesPerTexel: 4, isDepthStencil: false };
    }
    else if (format === 'alpha') {
        return { format: 'r8unorm', bytesPerTexel: 1, isDepthStencil: false };
    }
    if (type === 'uint8') {
        let texFormat = format;
        if (format === 'rgba') {
            texFormat = 'rgba8unorm';
        }
        return { format: texFormat, bytesPerTexel: 4, isDepthStencil: false };
    }
    else if (type === 'float16' || type === 'half float') {
        return { format: 'r16float', bytesPerTexel: 2, isDepthStencil: false };
    }
    else if (type === 'float') {
        return { format: 'r32float', bytesPerTexel: 4, isDepthStencil: false };
    }
    return { format, bytesPerTexel: 4, isDepthStencil: false };
}

// Pipeline states we cared
class PipelineDescriptor {
    readFromREGLCommand(commandProps, mesh, uniformValues, fbo) {
        if (!commandProps) {
            commandProps = {};
        }
        const material = mesh.getMaterial();
        let doubleSided = false;
        if (material) {
            doubleSided = material.doubleSided;
        }
        const primitive = mesh.geometry.desc.primitive;
        this.topology = toTopology(primitive);
        const depthEnabled = !fbo || !!fbo.depthTexture;
        const stencilEnabled = !fbo || fbo.depthTexture && fbo.depthTexture.gpuFormat.isDepthStencil;
        // 保存函数类型的command prop，用于在getShaderCommandKey中检查缓存的command key是否失效
        this.functionProps = [];
        let depthBias, depthBiasSlopeScale;
        // depthBias
        if (depthEnabled && commandProps.polygonOffset && isEnable(commandProps.polygonOffset.enable, uniformValues)) {
            if (!this.topology.startsWith('triangle')) {
                // depthBias for line and point primitive must be 0
                // https://github.com/gpuweb/gpuweb/issues/4729
                depthBias = 0;
                depthBiasSlopeScale = 0;
            }
            else {
                const offsetProps = commandProps.polygonOffset.offset;
                if (isFunction$1(offsetProps)) {
                    const offset = offsetProps(null, uniformValues);
                    depthBias = offset.units;
                    depthBiasSlopeScale = offset.factor;
                    this.functionProps.push({ func: (_, props) => { return offsetProps(null, props).units; }, v: depthBias });
                    this.functionProps.push({ func: (_, props) => { return offsetProps(null, props).factor; }, v: depthBiasSlopeScale });
                }
                else {
                    if (offsetProps && !isNil$2(offsetProps.units)) {
                        if (isFunction$1(offsetProps.units)) {
                            depthBias = offsetProps.units(null, uniformValues);
                            this.functionProps.push({ func: offsetProps.units, v: depthBias });
                        }
                        else {
                            depthBias = offsetProps.units;
                        }
                    }
                    if (offsetProps && !isNil$2(offsetProps.factor)) {
                        if (isFunction$1(offsetProps.factor)) {
                            depthBiasSlopeScale = offsetProps.factor(null, uniformValues);
                            this.functionProps.push({ func: offsetProps.factor, v: depthBiasSlopeScale });
                        }
                        else {
                            depthBiasSlopeScale = offsetProps.factor;
                        }
                    }
                }
            }
        }
        this.depthBias = depthBias;
        this.depthBiasSlopeScale = depthBiasSlopeScale;
        let depthCompare = 'less';
        let depthWriteEnable = true;
        const depthProps = commandProps.depth;
        if (depthEnabled && depthProps && isEnable(depthProps.enable, uniformValues)) {
            if (depthProps.func) {
                let depthFunc = depthProps.func;
                if (isFunction$1(depthProps.func)) {
                    depthFunc = depthFunc(null, uniformValues);
                    this.functionProps.push({ func: depthProps.func, v: depthFunc });
                }
                depthCompare = toGPUCompareFunction(depthFunc);
            }
            depthWriteEnable = true;
            if (!isNil$2(depthProps.mask)) {
                if (isFunction$1(depthProps.mask)) {
                    depthWriteEnable = depthProps.mask(null, uniformValues);
                    this.functionProps.push({ func: depthProps.mask, v: depthWriteEnable });
                }
                else {
                    depthWriteEnable = !!depthProps.mask;
                }
            }
        }
        else if (depthProps && !isEnable(depthProps.enable, uniformValues)) {
            depthCompare = 'always';
            depthWriteEnable = false;
        }
        this.depthCompare = depthCompare;
        this.depthWriteEnabled = depthWriteEnable;
        let stencilFrontCompare = 'always';
        let stencilFrontPassOp = 'keep';
        const stencilProps = commandProps.stencil;
        if (stencilEnabled && stencilProps && isEnable(stencilProps.enable, uniformValues)) {
            if (stencilProps.op) {
                // 目前还没遇到op是函数的情况，所以可以直接读取
                stencilFrontPassOp = stencilProps.op.zpass;
                if (isFunction$1(stencilFrontPassOp)) {
                    const stencilFrontPassOpFn = stencilFrontPassOp;
                    stencilFrontPassOp = stencilFrontPassOpFn(null, uniformValues);
                    this.functionProps.push({ func: stencilProps.op.zpass, v: stencilFrontPassOp });
                }
            }
            if (stencilProps.func) {
                let stencilCmp = stencilProps.func.cmp;
                if (!stencilCmp) {
                    stencilCmp = 'always';
                }
                let stencilFunc = stencilCmp;
                if (isFunction$1(stencilFunc)) {
                    stencilFunc = stencilCmp(null, uniformValues);
                    this.functionProps.push({ func: stencilCmp, v: stencilFunc });
                }
                stencilFrontCompare = toGPUCompareFunction(stencilFunc);
            }
        }
        this.stencilFrontCompare = stencilFrontCompare;
        this.stencilFrontPassOp = stencilFrontPassOp;
        let blendAlphaSrc, blendAlphaDst;
        let blendColorSrc, blendColorDst;
        const blendProps = commandProps.blend;
        if (blendProps && isEnable(blendProps.enable, uniformValues)) {
            if (blendProps.func) {
                const blendFunc = blendProps.func;
                if (blendFunc.src) {
                    let blendSrc = blendFunc.src;
                    if (isFunction$1(blendFunc.src)) {
                        blendSrc = blendFunc.src(null, uniformValues);
                        this.functionProps.push({ func: blendFunc.src, v: blendSrc });
                    }
                    blendAlphaSrc = toGPUBlendFactor(blendSrc);
                    blendColorSrc = blendAlphaSrc;
                }
                if (blendFunc.dst) {
                    let blendDst = blendFunc.dst;
                    if (isFunction$1(blendFunc.dst)) {
                        blendDst = blendFunc.dst(null, uniformValues);
                        this.functionProps.push({ func: blendFunc.dst, v: blendDst });
                    }
                    blendAlphaDst = toGPUBlendFactor(blendDst);
                    blendColorDst = blendAlphaDst;
                }
                if (blendFunc.srcAlpha) {
                    let blendSrcAlpha = blendFunc.srcAlpha;
                    if (isFunction$1(blendFunc.srcAlpha)) {
                        blendSrcAlpha = blendFunc.srcAlpha(null, uniformValues) ||
                            this.functionProps.push({ func: blendFunc.srcAlpha, v: blendSrcAlpha });
                    }
                    blendAlphaSrc = toGPUBlendFactor(blendSrcAlpha);
                }
                if (blendFunc.srcRGB) {
                    let blendSrcRGB = blendFunc.srcRGB;
                    if (isFunction$1(blendFunc.srcRGB)) {
                        blendSrcRGB = blendFunc.srcRGB(null, uniformValues) ||
                            this.functionProps.push({ func: blendFunc.srcRGB, v: blendSrcRGB });
                    }
                    blendColorSrc = toGPUBlendFactor(blendSrcRGB);
                }
                if (blendFunc.dstAlpha) {
                    let blendDstAlpha = blendFunc.dstAlpha;
                    if (isFunction$1(blendFunc.dstAlpha)) {
                        blendDstAlpha = blendFunc.dstAlpha(null, uniformValues) ||
                            this.functionProps.push({ func: blendFunc.dstAlpha, v: blendDstAlpha });
                    }
                    blendAlphaDst = toGPUBlendFactor(blendDstAlpha);
                }
                if (blendFunc.dstRGB) {
                    let blendDstRGB = blendFunc.dstRGB;
                    if (isFunction$1(blendFunc.dstRGB)) {
                        blendDstRGB = blendFunc.dstRGB(null, uniformValues) ||
                            this.functionProps.push({ func: blendFunc.dstRGB, v: blendDstRGB });
                    }
                    blendColorDst = toGPUBlendFactor(blendDstRGB);
                }
            }
        }
        this.blendAlphaDst = blendAlphaDst;
        this.blendAlphaSrc = blendAlphaSrc;
        this.blendColorDst = blendColorDst;
        this.blendColorSrc = blendColorSrc;
        let cullMode = 'none';
        if (!doubleSided) {
            const cullProps = commandProps.cull;
            if (cullProps && isEnable(cullProps.enable, uniformValues)) {
                cullMode = 'back';
                if (cullProps.face) {
                    cullMode = cullProps.face;
                    if (isFunction$1(cullProps.face)) {
                        cullMode = cullProps.face(null, uniformValues) ||
                            this.functionProps.push({ func: cullProps.face, v: cullMode });
                    }
                }
            }
        }
        this.cullMode = cullMode;
        // frontFace不存在函数的情况，所以可以直接读取
        this.frontFace = commandProps.frontFace;
        let colorMask = commandProps.colorMask;
        if (colorMask) {
            if (isFunction$1(colorMask)) {
                colorMask = colorMask(null, uniformValues);
                this.functionProps.push({ func: commandProps.colorMask, v: colorMask });
            }
            let writeMask = 0;
            if (colorMask[0]) {
                writeMask |= GPUColorWrite.RED;
            }
            if (colorMask[1]) {
                writeMask |= GPUColorWrite.GREEN;
            }
            if (colorMask[2]) {
                writeMask |= GPUColorWrite.BLUE;
            }
            if (colorMask[3]) {
                writeMask |= GPUColorWrite.ALPHA;
            }
            this.writeMask = writeMask;
        }
        //TODO mesh中buffer的组织方式也需要考虑进来
    }
    generateValuesKey(values) {
        return values.map((v) => { return Array.isArray(v) ? v.join() : v; }).join('-');
    }
    getFnValuesKey() {
        return this.generateValuesKey(this.functionProps.map(item => item.v));
    }
    getSignatureKey() {
        return (this.depthBias || 0) + '-' + (this.depthBiasSlopeScale || 0) + '-' + (this.depthCompare || 0) + '-' + (this.depthWriteEnabled || 0) +
            (this.stencilFrontCompare || 0) + '-' + (this.stencilFrontPassOp || 0) +
            (this.blendAlphaSrc || 0) + '-' + (this.blendAlphaDst || 0) + '-' + (this.blendColorSrc || 0) + '-' + (this.blendColorDst || 0) +
            (this.cullMode || 0) + '-' + (this.frontFace || 0) + '-' + (this.topology || 0) + '-' + (this.writeMask || 0);
    }
}
function isEnable(enable, props) {
    if (!isFunction$1(enable)) {
        return !!enable;
    }
    enable = enable(null, props);
    return !!enable;
}

const arrayBuffer = new ArrayBuffer(1024 * 1024 * 4);
const flipYBuffer = new ArrayBuffer(1024 * 1024 * 4);
class GraphicsTexture {
    constructor(device, config) {
        this.version = 0;
        this.device = device;
        this.config = config;
        this.gpuFormat = toTextureFormat(config.format, config.type);
        this.dirty = false;
        this._updateTexture();
    }
    get width() {
        return this.texture && this.texture.width || this.config && this.config.width;
    }
    get height() {
        return this.texture && this.texture.height || this.config && this.config.height;
    }
    get arrayLayers() {
        return 1;
    }
    // called when minFilter or magFilter changed
    updateFilter() {
        if (this.texture) {
            this.version++;
        }
    }
    resize(width, height) {
        if (this.texture && this.texture.width === width && this.texture.height === height) {
            return;
        }
        this.dirty = true;
        this.config.width = width;
        this.config.height = height;
        this._updateTexture();
    }
    update(config) {
        if (this.texture) {
            this.dirty = this._isDirty(config);
        }
        const { width, height } = this._getSize(config);
        extend$1(this.config, config);
        this.config.width = width;
        this.config.height = height;
        this.gpuFormat = toTextureFormat(this.config.format, this.config.type);
        this._updateTexture();
    }
    _updateTexture() {
        const config = this.config;
        const { width, height } = this._getSize(config);
        const device = this.device.wgpu;
        if (this.dirty) {
            this.version++;
            this.device.addToDestroyList(this.texture);
            this.texture = null;
            this.dirty = false;
        }
        let texture = this.texture;
        {
            const format = this.gpuFormat.format;
            const isDepth = format === 'depth24plus' || format === 'depth24plus-stencil8';
            const usage = isDepth ?
                GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.RENDER_ATTACHMENT
                :
                    GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT;
            const options = {
                size: [width, height, this.arrayLayers],
                format,
                usage,
                mipLevelCount: this.getMipLevelCount()
            };
            if (config.sampleCount) {
                options.sampleCount = config.sampleCount;
            }
            texture = texture || device.createTexture(options);
            this.fillData(texture, width, height);
        }
        this.texture = texture;
    }
    _isDirty(newConfig) {
        if (!this.texture) {
            return false;
        }
        const { width, height } = this._getSize(newConfig);
        if (width !== this.texture.width) {
            return true;
        }
        if (height !== this.texture.height) {
            return true;
        }
        if (newConfig.format && newConfig.format !== this.config.format) {
            return true;
        }
        if (newConfig.type && newConfig.type !== this.config.type) {
            return true;
        }
        if (this.getMipLevelCount(newConfig.data) !== this.getMipLevelCount()) {
            return true;
        }
        return false;
    }
    _getSize(config) {
        let width = isFunction$1(config.width) ? config.width() : config.width;
        let height = isFunction$1(config.height) ? config.height() : config.height;
        if (width === undefined || height === undefined) {
            const data = config.data;
            if (!data) {
                width = height = 1;
            }
            else if (isArray(config.data)) {
                const length = config.data.length;
                width = Math.sqrt(length / 4);
                height = width;
            }
            else {
                width = data.videoWidth || data.width;
                height = data.videoHeight || data.height;
            }
        }
        return { width, height };
    }
    getMipLevelCount(data) {
        data = data || this.config.data;
        if (data && data.mipmap) {
            return data.mipmap.length;
        }
        return 1;
    }
    fillData(texture, width, height) {
        const config = this.config;
        const origin = [0, 0, 0];
        if (config.data) {
            if (this.isArrayData(config.data)) {
                this.fillArrayData(texture, config.data, width, height, origin);
            }
            else {
                this.fillImageData(texture, config.data, width, height, origin);
            }
        }
    }
    fillImageData(texture, data, width, height, origin) {
        const device = this.device.wgpu;
        const flipY = !!this.config.flipY;
        const premultipliedAlpha = !!this.config.premultiplyAlpha;
        if (data.mipmap) {
            const mipmap = data.mipmap;
            for (let i = 0; i < mipmap.length; i++) {
                device.queue.copyExternalImageToTexture({ source: mipmap[i], flipY }, { texture, premultipliedAlpha, mipLevel: i, origin }, [Math.max(1, width >> i), Math.max(1, height >> i)]);
            }
        }
        else {
            device.queue.copyExternalImageToTexture({ source: data, flipY }, { texture: texture, premultipliedAlpha, origin }, [width, height]);
        }
    }
    fillArrayData(texture, data, width, height, origin) {
        if (data.mipmap) {
            for (let i = 0; i < data.mipmap.length; i++) {
                this._fillMipmap(texture, i, data.mipmap[i], Math.max(1, texture.width >> i), Math.max(1, texture.width >> i), origin);
            }
        }
        else {
            this._fillMipmap(texture, 0, data, width, height, origin);
        }
    }
    _fillMipmap(texture, mipLevel, data, width, height, origin) {
        const device = this.device.wgpu;
        const dataToWrite = this.formatTextureArray(data, arrayBuffer, width, height);
        device.queue.writeTexture({ texture, mipLevel, origin }, dataToWrite, {
            bytesPerRow: width * this.gpuFormat.bytesPerTexel
        }, [width, height]);
    }
    formatTextureArray(data, arrayBuffer, width, height) {
        const config = this.config;
        const isUint8 = !config.type || config.type === 'uint8';
        let byteLength;
        if (Array.isArray(data)) {
            byteLength = isUint8 ? data.length : data.length * 4;
        }
        else {
            byteLength = data.byteLength;
        }
        const isRGBA = !config.format || config.format === 'rgba';
        const isPremultipliedAlpha = isRGBA && config.premultiplyAlpha;
        let dataToWrite;
        if (isPremultipliedAlpha || Array.isArray(data)) {
            if (arrayBuffer.byteLength < byteLength) {
                arrayBuffer.resize(byteLength);
            }
            if (isUint8) {
                dataToWrite = new Uint8Array(arrayBuffer, 0, byteLength);
            }
            else {
                dataToWrite = new Float32Array(arrayBuffer, 0, byteLength / 4);
            }
        }
        if (isPremultipliedAlpha) {
            const ratio = isUint8 ? 255 : 1;
            for (let i = 0; i < data.length; i += 4) {
                const alpha = data[i + 3] / ratio;
                dataToWrite[i] = data[i] * alpha;
                dataToWrite[i + 1] = data[i + 1] * alpha;
                dataToWrite[i + 2] = data[i + 2] * alpha;
                dataToWrite[i + 3] = data[i + 3];
            }
        }
        else {
            if (Array.isArray(data)) {
                for (let i = 0; i < data.length; i++) {
                    dataToWrite[i] = data[i];
                }
            }
            else {
                dataToWrite = data;
            }
        }
        if (this.config.flipY) {
            dataToWrite = flipY(dataToWrite, width, height, byteLength);
        }
        return dataToWrite;
    }
    isArrayData(data) {
        if (!data.mipmap && !isArray(data)) {
            return false;
        }
        if (data.mipmap) {
            return isArray(data.mipmap[0]);
        }
        return true;
    }
    getView(descriptor) {
        return this.texture.createView(descriptor);
    }
    destroy() {
        if (this.texture) {
            this.texture.destroy();
            delete this.texture;
        }
    }
}
/**
 * 对Uint8Array图像数据进行垂直翻转
 * @param imageData - 原始图像数据
 * @param width - 图像宽度（像素）
 * @param height - 图像高度（像素）
 * @param bytesPerPixel - 每像素字节数（通常为3-RGB或4-RGBA）
 * @returns {Uint8Array} - 垂直翻转后的图像数据
 */
function flipY(imageData, width, height, byteLength) {
    if (flipYBuffer.byteLength < arrayBuffer.byteLength) {
        flipYBuffer.resize(arrayBuffer.byteLength);
    }
    const bytesPerPixel = imageData instanceof Float32Array ? 4 * 4 : 4;
    // 创建相同大小的新数组
    let flippedData;
    if (imageData instanceof Float32Array) {
        flippedData = new Float32Array(flipYBuffer, 0, byteLength / 4);
    }
    else {
        flippedData = new Uint8Array(flipYBuffer, 0, byteLength);
    }
    // 每行的字节数
    const rowBytes = width * bytesPerPixel;
    // 遍历每一行
    for (let y = 0; y < height; y++) {
        // 原始数据的行起始位置
        const originalRowStart = y * rowBytes;
        // 翻转后数据的行起始位置（从底部开始）
        const flippedRowStart = (height - 1 - y) * rowBytes;
        // 复制整行数据
        flippedData.set(imageData.subarray(originalRowStart, originalRowStart + rowBytes), flippedRowStart);
    }
    return flippedData;
}

class GraphicsFramebuffer {
    constructor(device, options) {
        this.device = device;
        this.options = options;
        this._update();
    }
    get color() {
        return [this.colorTexture];
    }
    resize(width, height) {
        if (this.colorTexture && width === this.colorTexture.width && height === this.colorTexture.height) {
            return;
        }
        this.options.width = width;
        this.options.height = height;
        this.width = width;
        this.height = height;
        if (this.colorTexture) {
            this.colorTexture.resize(width, height);
        }
        if (this.depthTexture) {
            this.depthTexture.resize(width, height);
        }
        if (this._renderPass) {
            const colorAttachment = this._renderPass.colorAttachments[0];
            if (colorAttachment && colorAttachment.view && this.colorTexture) {
                colorAttachment.view = this.colorTexture.getView();
            }
            const depthAttchment = this._renderPass.depthStencilAttachment;
            if (depthAttchment && depthAttchment.view && this.depthTexture) {
                depthAttchment.view = this.depthTexture.getView();
            }
        }
    }
    getCommandKey() {
        if (this._cmdKey) {
            return this._cmdKey;
        }
        const colorTexture = this.colorTexture;
        const depthTexture = this.depthTexture;
        let key = '';
        if (colorTexture) {
            key += `${colorTexture.gpuFormat.format}-${colorTexture.config.sampleCount};`;
        }
        if (depthTexture) {
            key += `${depthTexture.gpuFormat.format};`;
        }
        this._cmdKey = key;
        return key;
    }
    _update() {
        let color = this.options.colors && this.options.colors[0] || this.options.color;
        const colorFormat = this.options.colorFormat;
        const colorType = this.options.colorType;
        let width, height;
        if (color) {
            width = color.width;
            height = color.height;
        }
        else if (colorFormat || colorType) {
            color = true;
        }
        if (!isNil$2(this.options.width)) {
            width = this.options.width;
        }
        if (!isNil$2(this.options.height)) {
            height = this.options.height;
        }
        this.width = width;
        this.height = height;
        if (color && !(color instanceof GraphicsTexture)) {
            if (color === true) {
                color = {
                    width,
                    height
                };
            }
            if (!color.width) {
                color.width = width;
            }
            if (!color.height) {
                color.height = height;
            }
            if (!color.format) {
                color.format = colorFormat || 'rgba';
            }
            if (!color.type) {
                color.type = colorType || 'uint8';
            }
            this._ownColor = true;
            color = new GraphicsTexture(this.device, color);
        }
        let depth = this.options.depth;
        if (depth) {
            if (depth === true) {
                this._ownDepthTexture = true;
                depth = new GraphicsTexture(this.device, { width, height, format: 'depth' });
            }
            else {
                if (!(depth instanceof GraphicsTexture)) {
                    this._ownDepthTexture = true;
                    depth = new GraphicsTexture(this.device, depth);
                }
            }
        }
        // we assume depth and depthStencil won't be used at the same time
        const depthStencil = this.options.depthStencil;
        if (depthStencil) {
            if (depthStencil === true) {
                this._ownDepthTexture = true;
                depth = new GraphicsTexture(this.device, { width, height, format: 'depth stencil' });
            }
            else {
                if (depthStencil instanceof GraphicsTexture) {
                    depth = depthStencil;
                }
                else {
                    this._ownDepthTexture = true;
                    depth = new GraphicsTexture(this.device, depthStencil);
                }
            }
        }
        this.colorTexture = color;
        this.depthTexture = depth;
        this._renderPass = {
            colorAttachments: []
        };
        if (color !== null) {
            this._renderPass.colorAttachments[0] = {
                view: this.colorTexture && this.colorTexture.getView(), // Assigned later
                clearValue: [0, 0, 0, 0],
                loadOp: 'load',
                storeOp: 'store',
            };
        }
        if (depth) {
            const depthAttchment = this._renderPass.depthStencilAttachment = {
                view: this.depthTexture.getView(),
                depthClearValue: 1,
                depthLoadOp: 'load',
                depthStoreOp: 'store'
            };
            if (depth.gpuFormat.isDepthStencil) {
                depthAttchment.stencilReadOnly = false;
                depthAttchment.stencilClearValue = 0;
                depthAttchment.stencilLoadOp = 'load';
                depthAttchment.stencilStoreOp = 'store';
            }
        }
    }
    getRenderPassDescriptor() {
        const colorAttachment = this._renderPass.colorAttachments[0];
        const depthStencilAttachment = this._renderPass.depthStencilAttachment;
        let width, height;
        if (!this.colorTexture) {
            // a default texture view
            const colorTexture = this.device.context.getCurrentTexture();
            width = colorTexture.width;
            height = colorTexture.height;
            colorAttachment.view = colorTexture.createView();
            colorAttachment.view.label = 'default canvas view';
        }
        if (colorAttachment) {
            colorAttachment.loadOp = this.colorLoadOp || 'load';
            colorAttachment.clearValue = this.colorClearValue || [0, 0, 0, 0];
        }
        if (depthStencilAttachment) {
            depthStencilAttachment.depthLoadOp = this.depthLoadOp || 'load';
            depthStencilAttachment.depthClearValue = isNumber$2(this.depthClearValue) ? this.depthClearValue : 1;
            const depthTexture = this.depthTexture;
            if (depthTexture && depthTexture.gpuFormat.isDepthStencil) {
                depthStencilAttachment.stencilLoadOp = this.stencilLoadOp || 'load';
                depthStencilAttachment.stencilClearValue = isNumber$2(this.stencilClearValue) ? this.stencilClearValue : 0;
            }
            if (depthTexture && width && height && (depthTexture.width !== width || depthTexture.height !== height)) {
                // depth texture size may be not consistent with canvas
                depthTexture.resize(width, height);
                depthStencilAttachment.view = depthTexture.getView();
            }
        }
        this.resetClearOptions();
        return this._renderPass;
    }
    setClearOptions(options) {
        if (options.color) {
            this.colorLoadOp = 'clear';
            this.colorClearValue = options.color;
        }
        if (isNumber$2(options.depth)) {
            this.depthLoadOp = 'clear';
            this.depthClearValue = options.depth;
        }
        if (isNumber$2(options.stencil)) {
            this.stencilLoadOp = 'clear';
            this.stencilClearValue = options.stencil;
        }
    }
    resetClearOptions() {
        this.colorLoadOp = null;
        this.colorClearValue = null;
        this.depthLoadOp = null;
        this.depthClearValue = null;
        this.stencilLoadOp = null;
        this.stencilClearValue = null;
    }
    destroy() {
        if (this._ownColor && this.colorTexture) {
            this.colorTexture.destroy();
            delete this.colorTexture;
        }
        if (this._ownDepthTexture && this.depthTexture) {
            this.depthTexture.destroy();
            delete this.depthTexture;
            delete this._ownDepthTexture;
        }
        this._destroyed = true;
    }
    isDestroyed() {
        return !!this._destroyed;
    }
}

let uuid = 0;
class BindGroupFormat {
    constructor(name, bindGroupMapping, minUniformBufferOffsetAlignment) {
        this.name = name;
        this.uuid = uuid++;
        this.groups = bindGroupMapping.groups;
        this.alignment = minUniformBufferOffsetAlignment;
        this._parse(bindGroupMapping);
    }
    getShaderUniforms() {
        return this._shaderUniforms;
    }
    getMeshUniforms() {
        return this._meshUniforms;
    }
    _parse(bindGroupMapping) {
        this._shaderUniforms = [];
        this._shaderUniforms.index = 0;
        this._shaderUniforms.totalSize = 0;
        this._meshUniforms = [];
        this._meshUniforms.index = 0;
        this._meshUniforms.totalSize = 0;
        const groups = bindGroupMapping.groups;
        if (!groups) {
            return;
        }
        const group = groups[0];
        if (!group) {
            return;
        }
        for (let i = 0; i < group.length; i++) {
            const uniform = group[i];
            if (!uniform) {
                continue;
            }
            if (uniform.isGlobal) {
                let index = this._shaderUniforms.index;
                this._shaderUniforms[index++] = uniform;
                this._shaderUniforms.index = index;
                this._shaderUniforms.totalSize += roundUp(uniform.size, this.alignment);
            }
            else {
                let index = this._meshUniforms.index;
                this._meshUniforms[index++] = uniform;
                this._meshUniforms.index = index;
                this._meshUniforms.totalSize += roundUp(uniform.size, this.alignment);
            }
        }
    }
    createFormatBindGroup(device, mesh, shaderUniforms, layout, shaderBuffer, meshBuffer) {
        const label = this.name + '-' + mesh.uuid;
        if (!this.groups) {
            return {
                bindGroup: device.wgpu.createBindGroup({
                    layout,
                    label,
                    entries: []
                }),
                uniformTextures: {}
            };
        }
        const groups = this.groups[0];
        const entries = [];
        for (let i = 0; i < groups.length; i++) {
            const group = groups[i];
            if (!group) {
                continue;
            }
            const name = group.name;
            if (group.resourceType === ResourceType.Sampler) {
                // we assume sampler's name always be [textureName]Sampler
                const textureName = name.substring(0, name.length - 7);
                let texture = shaderUniforms && shaderUniforms[textureName] || (mesh.getUniform(textureName) || mesh.material && mesh.material.getUniform(textureName));
                //TODO texture是否存在
                if (texture instanceof GraphicsFramebuffer) {
                    texture = texture.colorTexture;
                }
                if (!texture) {
                    continue;
                }
                const { min, mag, compare, wrap } = texture.config;
                let { wrapS, wrapT } = texture.config;
                if (wrap && !wrapS) {
                    wrapS = wrap;
                }
                if (wrap && !wrapT) {
                    wrapT = wrap;
                }
                const filters = toGPUSampler(min, mag, wrapS, wrapT, compare);
                const sampler = device.wgpu.createSampler(filters);
                entries.push({
                    binding: group.binding,
                    resource: sampler
                });
            }
            else if (group.resourceType === ResourceType.Texture) {
                const texture = shaderUniforms && shaderUniforms[name] || (mesh.getUniform(name) || mesh.material && mesh.material.getUniform(name));
                let graphicsTexture = texture;
                if (graphicsTexture instanceof AbstractTexture) {
                    graphicsTexture = texture.getREGLTexture(device);
                }
                if (graphicsTexture instanceof GraphicsFramebuffer) {
                    graphicsTexture = graphicsTexture.colorTexture;
                }
                if (!graphicsTexture) {
                    continue;
                }
                let descriptor;
                if (graphicsTexture.gpuFormat.isDepthStencil) {
                    descriptor = {
                        aspect: 'depth-only'
                    };
                }
                else if (group.type.name === 'texture_cube') {
                    descriptor = {
                        dimension: 'cube'
                    };
                }
                entries.push({
                    binding: group.binding,
                    resource: graphicsTexture.getView(descriptor)
                });
            }
            else {
                const allocation = group.isGlobal ? shaderBuffer.allocation : meshBuffer.allocation;
                entries.push({
                    binding: group.binding,
                    resource: {
                        buffer: allocation.gpuBuffer,
                        // offset 永远设为0，在setBindGroup中设置dynamicOffsets
                        // offset: 0,
                        size: roundUp(group.size, this.alignment)
                    }
                });
            }
        }
        const bindGroup = device.wgpu.createBindGroup({
            layout,
            label,
            entries
        });
        return { bindGroup, uniformTextures: {} };
    }
    copyTextures(bindGroup, props) {
        for (const p in props) {
            if (p === 'meshObject') {
                continue;
            }
            let v;
            try {
                v = props[p];
            }
            catch (e) {
                continue;
            }
            // fbo
            if (v instanceof GraphicsFramebuffer) {
                v = v.colorTexture;
                bindGroup.uniformTextures[p] = { texture: v, version: v.version };
            }
            else if (isTextureLike(v)) {
                bindGroup.uniformTextures[p] = { texture: v, version: v.version };
            }
        }
    }
    dispose() {
        delete this._shaderUniforms;
        delete this._meshUniforms;
        delete this.groups;
    }
}

const defineConstantRexg = /\s*#define\s+(\w+)\s+([^\n]+)/g;
const preprocessorSymbols = /#([^\s]*)(\s*)/gm;
// eslint-disable-next-line no-useless-escape
const usedDefineRexg = /#[^\s]*\s*\b[0-9A-Z][0-9A-Z_&&\|=! ]+\b/g;
const isNumeric = (n) => !isNaN(n);
function WGSLParseDefines(shader, meshDefines) {
    var _a;
    if (!shader)
        return undefined;
    // extract define const in shader
    const matches = shader.matchAll(defineConstantRexg);
    const defineConsts = {};
    for (const match of matches) {
        defineConsts[match[1]] = match[2];
    }
    // delete define const in shader
    shader = shader.replace(/#define.*$/gm, "");
    // parse shader inner const define
    let notDefineConstShader = ParseDefinesConst(shader, defineConsts);
    // filter "&&","||",number
    const rexgDefines = (_a = notDefineConstShader
        .match(usedDefineRexg)) === null || _a === void 0 ? void 0 : _a.filter((define) => !isNumeric(define) && define != "").map((define) => {
        const firstSpace = define.indexOf(" ");
        // remove #foo
        return define.substring(firstSpace).trim();
    });
    // normallize defines
    const { normalizeDefines, constValues } = getNormalizeDefines(rexgDefines, meshDefines);
    // const define defined by mesh
    notDefineConstShader = ParseDefinesConst(notDefineConstShader, constValues);
    // split Shader
    const shaderStrs = splitShaderStrsByDefine(notDefineConstShader, rexgDefines);
    // parse conditional macro definition
    return shaderStrs.length > 0
        ? ParseDefines(shaderStrs, normalizeDefines)
        : notDefineConstShader;
}
class ConditionalState {
    constructor(initialExpression) {
        this.elseIsValid = true;
        this.branches = [];
        this.pushBranch("if", initialExpression);
    }
    pushBranch(token, expression) {
        if (!this.elseIsValid) {
            throw new Error(`#${token} not preceeded by an #if or #elif`);
        }
        this.elseIsValid = token === "if" || token === "elif";
        this.branches.push({
            expression: !!expression,
            string: "",
        });
    }
    appendStringToCurrentBranch(...strings) {
        for (const string of strings) {
            this.branches[this.branches.length - 1].string += string;
        }
    }
    resolve() {
        for (const branch of this.branches) {
            if (branch.expression) {
                return branch.string;
            }
        }
        return "";
    }
}
function ParseDefines(strings, values) {
    const stateStack = [];
    let state = new ConditionalState(true);
    state.elseIsValid = false;
    // let depth = 1;
    const assertTemplateFollows = (match, string) => {
        if (match.index + match[0].length != string.length) {
            throw new Error(`#${match[1]} must be immediately followed by a template expression (${string})`);
        }
    };
    for (let i = 0; i < strings.length; ++i) {
        const string = strings[i];
        const matchedSymbols = string.matchAll(preprocessorSymbols);
        let lastIndex = 0;
        let valueConsumed = false;
        for (const match of matchedSymbols) {
            state.appendStringToCurrentBranch(string.substring(lastIndex, match.index));
            switch (match[1]) {
                case "if":
                case "ifdef":
                case "ifndef":
                    assertTemplateFollows(match, string);
                    valueConsumed = true;
                    stateStack.push(state);
                    // eslint-disable-next-line no-case-declarations
                    const value = match[1] === 'ifndef' ? !values[i] : !!values[i];
                    state = new ConditionalState(value);
                    break;
                case "elif":
                    assertTemplateFollows(match, string);
                    valueConsumed = true;
                    state.pushBranch(match[1], values[i]);
                    break;
                case "else":
                    state.pushBranch(match[1], true);
                    state.appendStringToCurrentBranch(match[2]);
                    break;
                case "endif":
                    if (!stateStack.length) {
                        throw new Error(`#${match[1]} not preceeded by an #if`);
                    }
                    // eslint-disable-next-line no-case-declarations
                    const result = state.resolve();
                    state = stateStack.pop();
                    state.appendStringToCurrentBranch(result, match[2]);
                    break;
                default:
                    // Unknown preprocessor symbol. Emit it back into the output string unchanged.
                    state.appendStringToCurrentBranch(match[0]);
                    break;
            }
            lastIndex = match.index + match[0].length;
        }
        // If the string didn't end on one of the preprocessor symbols append the rest of it here.
        if (lastIndex != string.length) {
            state.appendStringToCurrentBranch(string.substring(lastIndex, string.length));
        }
        // If the next value wasn't consumed by the preprocessor symbol, append it here.
        if (!valueConsumed && values.length > i) {
            state.appendStringToCurrentBranch(values[i]);
        }
    }
    if (stateStack.length) {
        throw new Error("Mismatched #if/#endif count");
    }
    return state.resolve();
}
function ParseDefinesConst(sourceShader, defines) {
    var _a;
    if (!defines)
        return sourceShader;
    let result = sourceShader;
    const keys = Object.keys(defines);
    (_a = keys === null || keys === void 0 ? void 0 : keys.forEach) === null || _a === void 0 ? void 0 : _a.call(keys, (key) => {
        const regex = new RegExp("\\b" + key + "\\b", "g");
        result = result.replace(regex, defines[key] + "");
    });
    return result;
}
function getNormalizeDefines(rexgDefines, defines) {
    var _a;
    const usedDefines = new Set();
    const normalizeDefines = (_a = rexgDefines === null || rexgDefines === void 0 ? void 0 : rexgDefines.map) === null || _a === void 0 ? void 0 : _a.call(rexgDefines, (define) => {
        return getDefineConditionValue(define, defines, usedDefines);
    });
    const constValues = {};
    for (const p in defines) {
        if (!usedDefines.has(p)) {
            constValues[p] = defines[p];
        }
    }
    return { normalizeDefines, constValues };
}
function getDefineConditionValue(define, defines, usedDefines) {
    if ((define === null || define === void 0 ? void 0 : define.includes("&&")) || (define === null || define === void 0 ? void 0 : define.includes("||"))) {
        if (define.includes("&&")) {
            const splitDefines = define
                .split("&&")
                .map((key) => key.trim());
            return getAndDefineValue(splitDefines, defines, usedDefines);
        }
        const splitDefines = define.split("||").map((key) => key.trim());
        return !getOrDefineValue(splitDefines, defines, usedDefines);
    }
    return getDefineValue(defines, define, usedDefines);
}
function getAndDefineValue(splitDefines, defines, usedDefines) {
    var _a;
    let total = 0;
    (_a = splitDefines === null || splitDefines === void 0 ? void 0 : splitDefines.forEach) === null || _a === void 0 ? void 0 : _a.call(splitDefines, (defineKey) => (total +=
        Number(getDefineValue(defines, defineKey, usedDefines) || 0) > 1
            ? 1
            : Number(getDefineValue(defines, defineKey, usedDefines) || 0)));
    return total === splitDefines.length;
}
function getDefineValue(defines, defineKey, usedDefines) {
    if (defineKey && defineKey.startsWith && defineKey.startsWith("!")) {
        defineKey = defineKey.substring(1);
        if (usedDefines) {
            usedDefines.add(defineKey);
        }
        return !defines[defineKey];
    }
    else if (defineKey && defineKey.includes && (defineKey.includes("==") || defineKey.includes("!="))) {
        // 解析 FOO == 1 或者 FOO != 1 形式的define
        const isEqual = defineKey.includes("==");
        const parts = defineKey.split(isEqual ? "==" : "!=").map(key => key.trim());
        if (usedDefines) {
            usedDefines.add(parts[0]);
        }
        if (isEqual) {
            return defines[parts[0]] === +parts[1];
        }
        else {
            return defines[parts[0]] !== +parts[1];
        }
    }
    else {
        if (usedDefines) {
            usedDefines.add(defineKey);
        }
        return defines[defineKey];
    }
}
function getOrDefineValue(splitDefines, defines, usedDefines) {
    var _a;
    let total = 0;
    (_a = splitDefines === null || splitDefines === void 0 ? void 0 : splitDefines.forEach) === null || _a === void 0 ? void 0 : _a.call(splitDefines, (defineKey) => {
        const value = getDefineValue(defines, defineKey, usedDefines);
        return (total += value ? 1 : 0);
    });
    return total === 0;
}
function splitShaderStrsByDefine(shader, defines) {
    let currentShaderStr = shader;
    const shaderStrs = (defines === null || defines === void 0 ? void 0 : defines.map((define) => {
        const length = currentShaderStr.indexOf(define);
        const sliceStr = currentShaderStr.slice(0, length);
        currentShaderStr = currentShaderStr.slice(length + define.length);
        return sliceStr;
    })) || [];
    if (shaderStrs === null || shaderStrs === void 0 ? void 0 : shaderStrs.length)
        shaderStrs.push(currentShaderStr);
    return shaderStrs;
}

var WGSLParseDefines$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    WGSLParseDefines: WGSLParseDefines,
    getDefineConditionValue: getDefineConditionValue
});

const GLOBAL_IN_MESH_ERROR = 'Found a global uniform in mesh struct:';
const MESH_IN_GLOBAL_ERROR = 'Found a mesh uniform in global struct:';
const vertexOutputRegex = /struct\s+VertexOutput\s*\{[\s\S]*?\}/;
class CommandBuilder {
    constructor(name, device, vert, frag, mesh, contextDesc, defines, uniformValues) {
        this.name = name;
        this.device = device;
        this.vert = vert;
        this.frag = frag;
        this.mesh = mesh;
        this.contextDesc = contextDesc;
        this.defines = defines;
        this.uniformValues = uniformValues;
    }
    build(pipelineDesc, fbo) {
        const mesh = this.mesh;
        const device = this.device;
        const defines = this.defines;
        //FIXME 如何在wgsl中实现defined
        let vert = removeComment(this.vert);
        let frag = removeComment(this.frag);
        try {
            vert = WGSLParseDefines(vert, defines);
        }
        catch (error) {
            error.message = this.name + '(vert):' + error.message;
            console.error(error);
            throw error;
        }
        try {
            frag = WGSLParseDefines(frag, defines);
        }
        catch (error) {
            error.message = this.name + '(frag):' + error.message;
            console.error(error);
            throw error;
        }
        // dynamically assign location index with $in and $out
        vert = parseLocationIndex(vert);
        if (frag) {
            frag = parseLocationIndex(frag);
        }
        // dynamically assign binding index with $bi
        const { source, index } = parseBindingIndex(vert, 0);
        vert = source;
        if (frag) {
            const { source: fragSource } = parseBindingIndex(frag, index);
            frag = fragSource;
            // fill vertexOutput struct from vertex shader
            const match = vert.match(vertexOutputRegex);
            if (match) {
                const structStartIndex = findLastDefineIndex(vert);
                frag = frag.substring(0, structStartIndex) + match[0] + '\n' + frag.substring(structStartIndex);
            }
        }
        // console.log('vert', vert);
        // console.log('frag', frag);
        let vertReflect;
        try {
            vertReflect = new WgslReflect(vert);
        }
        catch (error) {
            console.error('WGSL Reflect vert error in ' + this.name, error);
            console.error(vert);
            throw error;
        }
        const vertexInfo = this._formatBufferInfo(vertReflect, mesh);
        let fragReflect;
        if (frag) {
            try {
                fragReflect = new WgslReflect(frag);
            }
            catch (error) {
                console.error('WGSL Reflect frag error in ' + this.name, error);
                console.error(frag);
                throw error;
            }
        }
        const vertGroups = vertReflect.getBindGroups();
        let fragGroups = [];
        if (fragReflect) {
            fragGroups = fragReflect.getBindGroups();
        }
        // generate bind group layout
        const layout = this._createCommandBindGroupLayout(vertGroups, fragGroups, mesh, this.uniformValues);
        const pipeline = this._createCommandPipeline(device, vert, vertexInfo, frag, layout, mesh, pipelineDesc, fbo);
        const bindGroupMapping = this._createBindGroupMapping(vertGroups, fragGroups, mesh);
        const alignment = device.wgpu.limits.minUniformBufferOffsetAlignment;
        const bindGroupFormat = new BindGroupFormat(this.name, bindGroupMapping, alignment);
        const activeAttributes = this._getActiveAttributes( /* vertexInfo */);
        return {
            uid: -1 + '',
            layout,
            pipeline,
            vertexInfo,
            bindGroupFormat,
            bindGroupMapping,
            activeAttributes
        };
    }
    _getActiveAttributes( /* vertexInfo */) {
        //TODO
        const attributes = [{ name: 'position', type: 1 }];
        attributes.key = attributes.map(attr => attr.name).join();
        return attributes;
    }
    _createCommandBindGroupLayout(vertGroups, fragGroups, mesh, uniformValues) {
        const entries = [];
        for (let i = 0; i < vertGroups.length; i++) {
            const groupInfo = vertGroups[i];
            for (let ii = 0; ii < groupInfo.length; ii++) {
                const uniform = groupInfo[ii];
                if (!uniform) {
                    continue;
                }
                const entry = this._createLayoutEntry(uniform.binding, GPUShaderStage.VERTEX, uniform, mesh, uniformValues);
                entries.push(entry);
            }
        }
        for (let i = 0; i < fragGroups.length; i++) {
            const groupInfo = fragGroups[i];
            for (let ii = 0; ii < groupInfo.length; ii++) {
                const uniform = groupInfo[ii];
                if (!uniform) {
                    continue;
                }
                const entry = this._createLayoutEntry(uniform.binding, GPUShaderStage.FRAGMENT, uniform, mesh, uniformValues);
                entries.push(entry);
            }
        }
        // sort by binding
        entries.sort(sortByBinding);
        return this.device.wgpu.createBindGroupLayout({
            label: this.name + '-bindgrouplayout',
            entries
        });
    }
    _createLayoutEntry(binding, visibility, groupInfo, mesh, uniformValues) {
        if (groupInfo.resourceType === ResourceType.Sampler) {
            const sampler = {};
            if (groupInfo.type && groupInfo.type.name === 'sampler_comparison') {
                sampler.type = 'comparison';
            }
            else {
                const name = groupInfo.name.replace('Sampler', '');
                const { format } = this._getTextureInfo(name, mesh, uniformValues);
                if (format && format.startsWith('depth')) {
                    sampler.type = 'non-filtering';
                }
            }
            return {
                binding,
                visibility,
                sampler
            };
        }
        else if (groupInfo.resourceType === ResourceType.Texture) {
            const name = groupInfo.name;
            const { format, multisampled } = this._getTextureInfo(name, mesh, uniformValues);
            // https://gpuweb.github.io/gpuweb/#dictdef-gputexturebindinglayout
            // 根据规范，如果 multisampled 为真，sampleType 不能是float
            let sampleType = multisampled ? 'unfilterable-float' : 'float';
            if (format && format.startsWith('depth')) {
                sampleType = 'depth';
            }
            const texture = {
                multisampled,
                sampleType
            };
            if (groupInfo.type && groupInfo.type.name === 'texture_cube') {
                texture.viewDimension = 'cube';
            }
            return {
                binding,
                visibility,
                texture
            };
        }
        else {
            return {
                binding,
                visibility,
                buffer: {
                    type: 'uniform',
                    hasDynamicOffset: true
                }
            };
        }
    }
    _getTextureInfo(name, mesh, uniformValues) {
        let texture = uniformValues[name] || mesh.material && mesh.material.get(name);
        let format;
        let multisampled = false;
        if (texture instanceof GraphicsFramebuffer) {
            texture = texture.colorTexture;
        }
        if (texture) {
            if (texture instanceof Texture2D) {
                format = texture.config.type;
            }
            else if (texture instanceof GraphicsTexture) {
                format = texture.gpuFormat.format;
            }
            multisampled = !!(texture.config && texture.config.sampleCount > 1);
        }
        return { format, multisampled };
    }
    // 从vertex的entry function读出vertex的信息（如location，format等）
    _formatBufferInfo(vertReflect, mesh) {
        const vertEntryFuncion = vertReflect.entry.vertex[0];
        const inputs = vertEntryFuncion.inputs;
        const inputMapping = {};
        for (let i = 0; i < inputs.length; i++) {
            const name = inputs[i].name;
            inputMapping[name] = inputs[i];
        }
        const vertexInfo = {};
        const data = mesh.geometry.data;
        const semantic = mesh.geometry.semantic;
        const visited = new Set();
        for (const name in data) {
            const attr = semantic[name] || name;
            const info = inputMapping[attr];
            if (info) {
                visited.add(attr);
                vertexInfo[attr] = {
                    geoAttrName: name,
                    location: info.location,
                    itemSize: getItemSize(info.type)
                };
            }
        }
        for (const name in inputMapping) {
            if (!visited.has(name)) {
                const info = inputMapping[name];
                vertexInfo[name] = {
                    geoAttrName: name,
                    location: info.location,
                    itemSize: getItemSize(info.type)
                };
            }
        }
        if (mesh instanceof InstancedMesh) {
            const data = mesh.instancedData;
            for (const name in data) {
                if (inputMapping[name]) {
                    vertexInfo[name] = {
                        geoAttrName: name,
                        location: inputMapping[name].location,
                        itemSize: getItemSize(inputMapping[name].type)
                    };
                }
            }
        }
        return vertexInfo;
    }
    _createBindGroupMapping(vertGroups, fragGroups, mesh) {
        const mapping = {};
        // 解析vertInfo和fragInfo，生成一个 bindGroupMapping，用于mesh在运行时，生成bindGroup
        // mapping 中包含 uniform 变量名对应的 group index 和 binding index
        this._parseGroupMapping(mapping, vertGroups[0], mesh, 'vert');
        this._parseGroupMapping(mapping, fragGroups[0], mesh, 'frag');
        return mapping;
    }
    _parseGroupMapping(mapping, groupReflect, mesh, shaderType) {
        if (!groupReflect) {
            return;
        }
        for (let i = 0; i < groupReflect.length; i++) {
            const groupInfo = groupReflect[i];
            if (!groupInfo) {
                continue;
            }
            const { group, binding } = groupInfo;
            const members = groupInfo.members;
            let isGlobal = false;
            if (members && members.length) {
                for (let ii = 0; ii < members.length; ii++) {
                    const name = members[ii].name;
                    if (!meshHasUniform(mesh, name, this.contextDesc)) {
                        if (!isGlobal && ii > 0) {
                            throw new Error(GLOBAL_IN_MESH_ERROR + name + '(' + groupInfo.name + ') in ' + this.name + '_' + shaderType);
                        }
                        isGlobal = true;
                    }
                    else if (isGlobal) {
                        throw new Error(MESH_IN_GLOBAL_ERROR + name + '(' + groupInfo.name + ') in ' + this.name + '_' + shaderType);
                    }
                }
            }
            else {
                const name = groupInfo.name;
                if (!meshHasUniform(mesh, name, this.contextDesc)) {
                    isGlobal = true;
                }
            }
            mapping.groups = mapping.groups || [];
            mapping.groups[group] = mapping.groups[group] || [];
            groupInfo.isGlobal = isGlobal;
            groupInfo.index =
                // we assume all the members in the same struct is all global or mesh owned
                mapping.groups[group][binding] = groupInfo; //extend({
        }
    }
    // 运行时调用，生成 uniform buffer， 用来存放全局 uniform 变量的值
    _createCommandPipeline(graphicsDevice, vert, vertInfo, frag, layout, mesh, pipelineDesc, fbo) {
        const device = graphicsDevice.wgpu;
        const vertModule = device.createShaderModule({
            label: this.name + '-vertmodule',
            code: vert,
        });
        let fragModule;
        if (frag) {
            fragModule = device.createShaderModule({
                label: this.name + '-fragmodule',
                code: frag,
            });
        }
        if (!this._presentationFormat) {
            this._presentationFormat = navigator.gpu.getPreferredCanvasFormat();
        }
        const buffers = mesh.geometry.getBufferDescriptor(vertInfo);
        if (mesh instanceof InstancedMesh) {
            const instanceBuffers = mesh.getBufferDescriptor(vertInfo);
            for (let i = 0; i < instanceBuffers.length; i++) {
                if (!instanceBuffers[i]) {
                    continue;
                }
                buffers[i] = instanceBuffers[i];
            }
        }
        const pipelineLayout = device.createPipelineLayout({
            label: this.name + '-pipelinelayout',
            bindGroupLayouts: [layout]
        });
        const pipelineOptions = {
            label: this.name + '-pipeline',
            layout: pipelineLayout,
            vertex: {
                module: vertModule,
                buffers
            },
            primitive: {
                topology: pipelineDesc.topology,
                cullMode: pipelineDesc.cullMode,
                frontFace: pipelineDesc.frontFace
            }
        };
        const sampleCount = fbo && fbo.colorTexture && fbo.colorTexture.config.sampleCount;
        if (sampleCount) {
            pipelineOptions.multisample = { count: sampleCount };
        }
        const depthEnabled = !fbo || !!fbo.depthTexture;
        if (depthEnabled) {
            const depthTexture = fbo && fbo.depthTexture;
            pipelineOptions.depthStencil = {
                depthBias: pipelineDesc.depthBias,
                depthBiasSlopeScale: pipelineDesc.depthBiasSlopeScale,
                depthWriteEnabled: pipelineDesc.depthWriteEnabled,
                depthCompare: pipelineDesc.depthCompare,
                format: (!depthTexture || depthTexture.gpuFormat.isDepthStencil) ? 'depth24plus-stencil8' : 'depth24plus'
            };
        }
        if (fragModule) {
            const fboPresentationFormat = fbo && fbo.colorTexture && fbo.colorTexture.gpuFormat.format;
            const writeMask = pipelineDesc.writeMask;
            pipelineOptions.fragment = {
                module: fragModule,
                targets: [
                    {
                        format: fboPresentationFormat || this._presentationFormat,
                        writeMask: isNil$2(writeMask) ? GPUColorWrite.ALL : writeMask
                    }
                ],
            };
        }
        if (pipelineOptions.depthStencil && pipelineDesc.stencilFrontCompare) {
            pipelineOptions.depthStencil.stencilBack =
                pipelineOptions.depthStencil.stencilFront = {
                    compare: pipelineDesc.stencilFrontCompare,
                    passOp: pipelineDesc.stencilFrontPassOp
                };
        }
        if (fragModule && pipelineDesc.blendAlphaDst) {
            const fragTargets = pipelineOptions.fragment.targets;
            for (const target of fragTargets) {
                target.blend = {
                    color: {
                        srcFactor: pipelineDesc.blendColorSrc,
                        dstFactor: pipelineDesc.blendColorDst,
                        operation: 'add'
                    },
                    alpha: {
                        srcFactor: pipelineDesc.blendAlphaSrc,
                        dstFactor: pipelineDesc.blendAlphaDst,
                        operation: 'add'
                    }
                };
            }
        }
        return device.createRenderPipeline(pipelineOptions);
    }
}
function meshHasUniform(mesh, name, contextDesc) {
    if (name === 'modelMatrix' || name === 'positionMatrix' ||
        name === 'projViewModelMatrix' || name === 'modelViewMatrix' ||
        name === 'modelNormalMatrix' ||
        name === 'polygonFill' || name === 'polygonOpacity' ||
        name === 'lineColor' || name === 'lineOpacity') {
        return true;
    }
    return contextDesc[name] && !contextDesc[name].global || mesh.hasUniform(name) || (mesh.material && mesh.material.hasUniform(name));
}
function getItemSize(type) {
    if (type.name.startsWith('vec')) {
        return parseInt(type.name[3]);
    }
    else {
        return 1;
    }
}
function sortByBinding(a, b) {
    return a.binding - b.binding;
}
let locIndex = 0;
const indexAutoInc = () => '' + locIndex++;
function parseLocationIndex(code) {
    locIndex = 0;
    const parsedIn = code.replaceAll('$i', indexAutoInc);
    locIndex = 0;
    const parsedOut = parsedIn.replaceAll('$o', indexAutoInc);
    return parsedOut;
}
function parseBindingIndex(code, index) {
    locIndex = index;
    return {
        source: code.replaceAll('$b', indexAutoInc),
        index: locIndex
    };
}
function removeComment(str) {
    if (!str) {
        return str;
    }
    return str.replace(/[ \t]*\/\/.*\n/g, '') // remove //
        .replace(/[ \t]*\/\*[\s\S]*?\*\//g, ''); // remove /* */
}
function findLastDefineIndex(code) {
    // 找到最后一个 #define 的位置
    const lastDefineIndex = code.lastIndexOf('#define');
    if (lastDefineIndex !== -1) {
        // 从该位置开始查找换行符
        const newlineIndex = code.indexOf('\n', lastDefineIndex);
        return newlineIndex + 1; // 返回换行符后的索引位置
    }
    return 0;
}

class DynamicOffsets {
    constructor() {
        this.items = [];
        this.offsets = [];
        this.index = 0;
    }
    reset() {
        this.index = 0;
    }
    addItem(binding, offset) {
        const index = this.index++;
        const obj = this.items[index];
        if (!obj) {
            this.items[index] = { binding, offset };
        }
        else {
            obj.binding = binding;
            obj.offset = offset;
        }
    }
    addItems(items) {
        for (let i = 0; i < items.length; i++) {
            this.addItem(items[i].binding, items[i].offset);
        }
    }
    getItems() {
        return this.items.slice(0, this.index);
    }
    getDynamicOffsets() {
        const items = this.getItems();
        items.sort((a, b) => a.binding - b.binding);
        this.offsets.length = items.length;
        for (let i = 0; i < items.length; i++) {
            this.offsets[i] = items[i].offset;
        }
        return this.offsets;
    }
}

const UNIFORM_TYPE = {
    function: 'function',
    array: 'array'
};
let uid$1 = 0;
const activeVarsCache = {};
class GLShader {
    constructor({ vert, frag, wgslVert, wgslFrag, uniforms, defines, extraCommandProps, name }) {
        this.name = name;
        this.vert = vert;
        this.frag = frag;
        this.wgslVert = wgslVert;
        this.wgslFrag = wgslFrag;
        this.commandId = 0;
        const shaderId = uid$1++;
        Object.defineProperty(this, 'uid', {
            enumerable: true,
            configurable: false,
            get: () => {
                return shaderId;
            }
        });
        //defines besides meshes : lights, etc
        // this.shaderDefines = defines && extend({}, defines) || {};
        this.setDefines(defines && extend$1({}, defines) || {});
        uniforms = this.uniforms = (uniforms || []).slice();
        this.contextDesc = {};
        for (let i = 0, l = uniforms.length; i < l; i++) {
            const p = uniforms[i];
            if (isString(p)) {
                if (p.indexOf('[') > 0) {
                    // array
                    const { name, len } = parseArrayName(p);
                    this.contextDesc[name] = { name, type: 'array', length: len };
                }
                else {
                    this.contextDesc[p] = null;
                }
            }
            else if (p.name.indexOf('[') > 0) {
                // array function
                const { name, len } = parseArrayName(p.name);
                this.contextDesc[name] = { name, type: 'array', length: len, fn: p.fn };
            }
            else {
                // e.g.
                // {
                //     name : 'foo',
                //     type : 'function',
                //     fn : (context, props) => { ... }
                // }
                this.contextDesc[p.name] = p;
            }
        }
        this.extraCommandProps = extraCommandProps && extend$1({}, extraCommandProps) || {};
        this.commands = {};
        this._compileSource();
    }
    set shaderDefines(defines) {
        this._shaderDefines = defines;
        this.dkey = Object.keys(this._shaderDefines).join();
    }
    get shaderDefines() {
        return this._shaderDefines || {};
    }
    setDefines(defines) {
        this.shaderDefines = defines;
    }
    /**
     * The framebuffer object to render to
     * Set to null to render to default display
     * @param framebuffer
     */
    setFramebuffer(framebuffer) {
        this.context.framebuffer = framebuffer;
        return this;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    run(regl, command, props) {
        return command(props);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getShaderCommandKey(device, mesh, uniformValues) {
        return this.dkey || 'default';
    }
    getVersion(regl, source) {
        const versionDefined = source.substring(0, 8) === '#version';
        if (versionDefined) {
            return '';
        }
        const isWebGL2 = regl.limits['version'].indexOf('WebGL 2.0') === 0;
        if (isWebGL2 && this.version === 300) {
            return '#version 300 es\n';
        }
        else {
            return '#version 100\n';
        }
    }
    getActiveVars(regl, vert, frag, hash) {
        const cacheKey = hash;
        if (activeVarsCache[cacheKey]) {
            return activeVarsCache[cacheKey];
        }
        const gl = regl['_gl'];
        const program = gl.createProgram();
        const vertShader = gl.createShader(35633);
        gl.shaderSource(vertShader, vert);
        gl.compileShader(vertShader);
        const fragShader = gl.createShader(35632);
        gl.shaderSource(fragShader, frag);
        gl.compileShader(fragShader);
        gl.attachShader(program, fragShader);
        gl.attachShader(program, vertShader);
        gl.linkProgram(program);
        // active attributes
        const numAttributes = gl.getProgramParameter(program, 0x8B89);
        const activeAttributes = [];
        for (let i = 0; i < numAttributes; ++i) {
            const info = gl.getActiveAttrib(program, i);
            if (info) {
                activeAttributes.push({
                    name: info.name,
                    type: info.type
                });
            }
        }
        // active uniforms
        const numUniforms = gl.getProgramParameter(program, 0x8B86);
        const activeUniforms = [];
        for (let i = 0; i < numUniforms; ++i) {
            const uniformInfo = gl.getActiveUniform(program, i);
            let name = uniformInfo.name;
            if (uniformInfo.name.indexOf('[') > 0) {
                name = name.replace('[0]', '');
                // array
                // const { name, len } = parseArrayName(uniformInfo.name.replace('[0]', `[${uniformInfo.size}]`));
                // for (let ii = 0; ii < len; ii++) {
                //     activeUniforms.push(name + `[${ii}]`);
                // }
            }
            activeUniforms.push(name);
        }
        gl.deleteProgram(program);
        gl.deleteShader(vertShader);
        gl.deleteShader(fragShader);
        activeVarsCache[cacheKey] = {
            activeUniforms,
            activeAttributes
        };
        return activeVarsCache[cacheKey];
    }
    _insertDefines(source, defines) {
        const defineHeaders = [];
        for (const p in defines) {
            if (hasOwn$1(defines, p) && !isFunction$1(defines[p])) {
                defineHeaders.push(`#define ${p} ${defines[p]}\n`);
            }
        }
        return defineHeaders.join('') + source;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    createMeshCommand(regl, mesh, commandProps = {}, _uniformValues) {
        const materialDefines = mesh.getDefines();
        const elements = mesh.getElements();
        const isInstanced = mesh instanceof InstancedMesh;
        const disableVAO = mesh.disableVAO;
        const isVAO = isSupportVAO(regl) && !disableVAO;
        const defines = extend$1({}, this.shaderDefines || {}, materialDefines || {});
        const vertSource = this._insertDefines(this.vert, defines);
        const vert = this.getVersion(regl, vertSource) + vertSource;
        const fragSource = this._insertDefines(this.frag, defines);
        const frag = this.getVersion(regl, fragSource) + fragSource;
        const vHash = hashCode(vert);
        const fHash = hashCode(frag);
        const hash = vHash + '_' + fHash;
        const { activeAttributes, activeUniforms } = this.getActiveVars(regl, vert, frag, hash);
        const attributes = {};
        activeAttributes.forEach((p, idx) => {
            const name = p.name;
            if (isVAO) {
                attributes[name] = idx;
            }
            else {
                attributes[name] = regl.prop(name);
            }
        });
        const uniforms = {};
        activeUniforms.forEach(p => {
            uniforms[p] = regl.prop(p);
        });
        const desc = this.contextDesc;
        for (const p in desc) {
            if (desc[p] && desc[p].type === UNIFORM_TYPE['function']) {
                uniforms[p] = desc[p]['fn'];
            }
            else if (desc[p] && desc[p].type === UNIFORM_TYPE['array']) {
                // an array uniform
                // split to foo[0], foo[1], .... as regl requires
                // https://github.com/regl-project/regl/issues/258
                const name = desc[p].name, len = desc[p].length;
                for (let i = 0; i < len; i++) {
                    const key = `${name}[${i}]`;
                    uniforms[key] = regl.prop(key);
                }
            }
            else {
                uniforms[p] = regl.prop(p);
            }
        }
        const command = {
            vert, frag, uniforms, attributes
        };
        if (isVAO) {
            command['vao'] = regl.prop('vao');
        }
        if ((!isVAO || isInstanced) && elements && !isNumber$2(elements)) {
            command.elements = regl.prop('elements');
        }
        command.count = regl.prop('count');
        command.offset = regl.prop('offset');
        command.primitive = regl.prop('primitive');
        command.framebuffer = regl.prop('framebuffer');
        if (isInstanced) {
            command.instances = regl.prop('instances');
        }
        extend$1(command, this.extraCommandProps, commandProps);
        const reglCommand = regl(command);
        activeAttributes.key = activeAttributes.map(attr => attr.name).join();
        reglCommand.activeAttributes = activeAttributes;
        return reglCommand;
    }
    dispose() {
        for (const p in this.commands) {
            const command = this.commands[p];
            if (!command) {
                continue;
            }
            if (command.destroy && !command[KEY_DISPOSED]) {
                command[KEY_DISPOSED] = true;
                command.destroy();
            }
        }
        this.commands = {};
        delete this.vert;
        delete this.frag;
    }
    /**
     * Get shader's context uniforms values
     * @param {Object} meshProps - mesh uniforms
     */
    appendDescUniforms(regl, meshProps) {
        // const context = this.context;
        //TODO 这里以前是extend2，需要明确改用extend后是否会有bug
        // const props = extend(meshProps, context);
        const uniforms = meshProps;
        const desc = this.contextDesc;
        for (const p in desc) {
            if (!desc[p]) {
                continue;
            }
            if (desc[p].type === 'array') {
                //an array uniform's value
                const name = p, len = desc[p].length;
                // change uniform value to the following form as regl requires:
                // foo[0]: 'value'
                // foo[1]: 'value'
                // foo[2]: 'value'
                let values = meshProps[p];
                if (desc[p].fn) {
                    // an array function
                    values = desc[p].fn(null, meshProps);
                }
                if (!values) {
                    continue;
                }
                if (values.length !== len) {
                    throw new Error(`${name} uniform's length is not ${len}`);
                }
                uniforms[name] = uniforms[name] || {};
                for (let i = 0; i < len; i++) {
                    uniforms[name][`${i}`] = values[i].getREGLTexture ? values[i].getREGLTexture(regl) : values[i];
                }
            }
            else if (desc[p].type === 'function') {
                if (!Object.getOwnPropertyDescriptor(uniforms, p)) {
                    Object.defineProperty(uniforms, p, {
                        configurable: false,
                        enumerable: true,
                        get: function () {
                            return desc[p].fn(null, meshProps);
                        }
                    });
                }
            }
        }
        return uniforms;
    }
    /**
     * Set or get context uniform to or from the shader
     * @returns {this}
     */
    setUniforms(uniforms) {
        if (uniforms['modelMatrix'] || uniforms['positionMatrix']) {
            throw new Error('modelMatrix or positionMatrix is reserved uniform name for Mesh, please change to another name');
        }
        this.contextKeys = uniforms ? Object.keys(uniforms).join() : null;
        this.context = uniforms;
        return this;
    }
    _compileSource() {
        if (this.vert) {
            this.vert = ShaderLib.compile(this.vert);
        }
        if (this.frag) {
            this.frag = ShaderLib.compile(this.frag);
        }
    }
}
function parseArrayName(p) {
    const l = p.indexOf('['), r = p.indexOf(']');
    const name = p.substring(0, l), len = +p.substring(l + 1, r);
    return { name, len };
}
const pipelineDesc = new PipelineDescriptor();
class GPUShader extends GLShader {
    getShaderCommandKey(device, mesh, renderProps) {
        if (device && device.wgpu) {
            let fboKey = '';
            if (this._gpuFramebuffer) {
                fboKey = `-${this._gpuFramebuffer.getCommandKey()}`;
            }
            // 获取pipeline所需要的特征变量，即任何变量发生变化后，就需要创建新的pipeline
            const fnValues = mesh.getShaderFnValues(this.uid);
            if (fnValues) {
                const { funcs, key, commandKey } = fnValues;
                if (!funcs.length) {
                    return commandKey + fboKey;
                }
                const values = funcs.map(func => func(null, renderProps));
                const currentKey = pipelineDesc.generateValuesKey(values);
                if (currentKey === key) {
                    return commandKey + fboKey;
                }
            }
            const fbo = this._gpuFramebuffer;
            const commandProps = this.extraCommandProps;
            pipelineDesc.readFromREGLCommand(commandProps, mesh, renderProps, fbo);
            const commandKey = pipelineDesc.getSignatureKey();
            mesh.setShaderFnValues(this.uid, {
                funcs: pipelineDesc.functionProps.map(item => item.func),
                key: pipelineDesc.getFnValuesKey(),
                commandKey
            });
            return commandKey + fboKey;
        }
        else {
            // regl
            return super.getShaderCommandKey(device, mesh, renderProps);
        }
    }
    createMeshCommand(device, mesh, commandProps, renderProps) {
        if (device && device.wgpu) {
            // 生成期：
            // 1. 负责对 wgsl 做预处理，生成最终执行的wgsl代码
            // 2. 解析wgsl，生成 bind group mapping 信息，用于运行时，mesh生成bind group
            // 3. 解析wgsl，获得全局 uniform 变量名和类型
            // 4. 生成 layout 和 pipeline
            // preprocess vert and frag codes
            const uniformValues = this.context;
            const fbo = this._gpuFramebuffer;
            // 不同于glsl，因为不支持预处理指令，wgsl需要在创建command时编译源代码
            const defines = extend$1({}, this.shaderDefines || {}, mesh.getDefines());
            const { vert, frag } = this._compileWGSLSource(defines);
            const builder = new CommandBuilder(this.name, device, vert, frag, mesh, this.contextDesc, defines, uniformValues);
            const pipelineDesc = new PipelineDescriptor();
            const extraCommandProps = extend$1({}, this.extraCommandProps || {}, commandProps || {});
            pipelineDesc.readFromREGLCommand(extraCommandProps, mesh, renderProps, fbo);
            const command = builder.build(pipelineDesc, fbo);
            command.uid = this.uid + '-' + this.commandId++;
            return command;
        }
        else {
            // regl
            return super.createMeshCommand(device, mesh, commandProps);
        }
    }
    _compileWGSLSource(defines) {
        if (!this.wgslVert) {
            throw new Error(`(${this.name}) WGSL vertex shader source is not provided.`);
        }
        const vert = WgslShaderLib.compile(this.wgslVert, defines);
        let frag;
        if (this.wgslFrag) {
            frag = WgslShaderLib.compile(this.wgslFrag, defines);
        }
        return { vert, frag };
    }
    run(deviceOrRegl, command, props) {
        if (!deviceOrRegl.wgpu) {
            // regl command
            return super.run(deviceOrRegl, command, props);
        }
        if (!props || !props.length) {
            return;
        }
        // const shaderUniforms = this.context;
        const device = deviceOrRegl;
        this.isGPU = true;
        const buffersPool = device.dynamicBufferPool;
        const renderPass = this._getCurrentRenderPassEncoder(device);
        renderPass.setPipeline(command.pipeline);
        const { uid, bindGroupFormat, vertexInfo, layout } = command;
        // 1. 生成shader uniform 需要的dynamic buffer
        if (!this._buffers) {
            this._buffers = {};
        }
        let shaderBuffer = this._buffers[uid];
        if (!shaderBuffer) {
            shaderBuffer = this._buffers[uid] = new DynamicBuffer(bindGroupFormat.getShaderUniforms(), buffersPool);
        }
        if (!this._dynamicOffsets) {
            this._dynamicOffsets = new DynamicOffsets();
        }
        if (!this._shaderDynamicOffsets) {
            this._shaderDynamicOffsets = new DynamicOffsets();
        }
        this._shaderDynamicOffsets.reset();
        // 向buffer中填入shader uniform值
        shaderBuffer.writeBuffer(props[0], this._shaderDynamicOffsets);
        const shaderDynamicOffsets = this._shaderDynamicOffsets.getItems();
        const stencil = this.extraCommandProps['stencil'];
        for (let i = 0; i < props.length; i++) {
            this._dynamicOffsets.reset();
            const mesh = props[i].meshObject;
            // 获取mesh的dynamicBuffer
            const meshBuffer = mesh.writeDynamicBuffer(uid, props[i], bindGroupFormat.getMeshUniforms(), buffersPool, this._dynamicOffsets);
            const groupKey = bindGroupFormat.uuid + '-' + meshBuffer.version + '-' + shaderBuffer.version + '-'
                + mesh.textureVersion + '-' + (mesh.material && mesh.material.textureVersion || 0);
            // 获取或者生成bind group
            let bindGroup = mesh.getBindGroup(groupKey);
            if (bindGroup && this._checkBindGroupOutdated(bindGroup, props[i])) {
                bindGroup = null;
            }
            if (!bindGroup) {
                bindGroup = bindGroupFormat.createFormatBindGroup(device, mesh, props[i], layout, shaderBuffer, meshBuffer);
                bindGroupFormat.copyTextures(bindGroup, props[i]);
                // 缓存bind group，只要buffer和texture没有发生变化，即可以重用
                mesh.setBindGroup(groupKey, bindGroup);
            }
            // 获取 dynamicOffsets
            this._dynamicOffsets.addItems(shaderDynamicOffsets);
            const dynamicOffsets = this._dynamicOffsets.getDynamicOffsets();
            renderPass.setBindGroup(0, bindGroup.bindGroup, dynamicOffsets);
            let instancedMesh;
            if (mesh instanceof InstancedMesh) {
                instancedMesh = mesh;
            }
            for (const name in vertexInfo) {
                const vertex = vertexInfo[name];
                let vertexBuffer = mesh.geometry.getBuffer(vertex.geoAttrName || name);
                if (!vertexBuffer && instancedMesh) {
                    vertexBuffer = instancedMesh.getInstancedBuffer(name);
                }
                renderPass.setVertexBuffer(vertex.location, vertexBuffer, 0, vertexBuffer.byteLength);
            }
            if (stencil && isEnable(stencil.enable, props[i])) {
                let ref = stencil.func && stencil.func.ref;
                if (ref !== undefined) {
                    if (isFunction$1(ref)) {
                        ref = ref(null, props[i]);
                    }
                    if (ref >= 0) {
                        renderPass.setStencilReference(ref);
                    }
                }
            }
            const elements = mesh.getElements();
            const drawOffset = mesh.geometry.getDrawOffset();
            const drawCount = mesh.geometry.getDrawCount();
            let instanceCount = 1;
            if (instancedMesh) {
                instanceCount = instancedMesh.instanceCount;
            }
            if (mesh.geometry.isIndexedElements()) {
                renderPass.setIndexBuffer(elements, elements.itemType);
                renderPass.drawIndexed(drawCount, instanceCount, drawOffset);
            }
            else {
                renderPass.draw(drawCount, instanceCount, drawOffset);
            }
            device.incrDrawCall();
        }
        renderPass.end();
    }
    _checkBindGroupOutdated(bindGroup, props) {
        if (!bindGroup.uniformTextures) {
            return false;
        }
        // 当纹理的version不同，或纹理不同时，则认为bindGroup过期，需要重新创建
        const uniformTextures = bindGroup.uniformTextures;
        for (const p in uniformTextures) {
            if (uniformTextures[p].texture !== props[p] || uniformTextures[p].version !== props[p].version) {
                return true;
            }
        }
        return false;
    }
    _getCurrentRenderPassEncoder(device) {
        // stencilLoadOp?: GPULoadOp,
        // stencilClearValue?: number,
        // colorLoadOp?: GPULoadOp,
        // depthLoadOp?: GPULoadOp
        return device.getRenderPassEncoder(this._gpuFramebuffer);
    }
    setFramebuffer(framebuffer) {
        if (!framebuffer) {
            if (this._gpuFramebuffer) {
                this._gpuFramebuffer = null;
                return this;
            }
            return super.setFramebuffer(framebuffer);
        }
        if (!framebuffer.getRenderPassDescriptor) {
            return super.setFramebuffer(framebuffer);
        }
        this._gpuFramebuffer = framebuffer;
        return this;
    }
    dispose() {
        if (!this.isGPU) {
            super.dispose();
            return;
        }
        for (const key in this._buffers) {
            if (this._buffers[key]) {
                this._buffers[key].dispose();
            }
        }
        const commands = this.gpuCommands;
        if (!commands) {
            return;
        }
        for (let i = 0; i < commands.length; i++) {
            if (!commands[i]) {
                continue;
            }
            if (commands[i].bindGroupFormat) {
                commands[i].bindGroupFormat.dispose();
            }
        }
    }
}

class MeshShader extends GPUShader {

    draw(device, meshes) {
        if (!meshes || !meshes.length) {
            return 0;
        }
        const props = [];
        let count = 0;
        let preCommand;
        for (let i = 0, l = meshes.length; i < l; i++) {
            if (!meshes[i].isValid()) {
                if (i === l - 1 && preCommand && props.length) {
                    this.run(device, preCommand, props);
                }
                continue;
            }
            //尽可能的不要用get 方法，性能损失较大
            const geometry = meshes[i]._geometry;
            if (!geometry.getDrawCount() || !this._runFilter(meshes[i])) {
                //此处device有个潜在的bug:
                //如果count为0的geometry不过滤掉，device生成的函数中，bind的texture不会执行unbind
                if (i === l - 1 && preCommand && props.length) {
                    this.run(device, preCommand, props);
                }
                continue;
            }

            const v = meshes[i].getRenderProps(device);
            this._ensureContextDefines(v);
            v.shaderContext = this.context;
            v.meshObject = meshes[i];
            this.appendDescUniforms(device, v);

            const command = this.getMeshCommand(device, meshes[i], v);
            meshes[i].appendGeoAttributes(v, device, command.activeAttributes);

            //run command one by one, for debug
            // const props = extend({}, this.context, meshes[i].getRenderProps());
            // console.log(i);
            // command(props);

            if (props.length && preCommand !== command) {
                //batch mode
                this.run(device, preCommand, props);
                props.length = 0;
            }

            props.push(v);
            count++;

            if (i < l - 1) {
                preCommand = command;
            } else if (i === l - 1) {
                this.run(device, command, props);
            }
        }
        return count;
    }

    _ensureContextDefines(v) {
        if (!this.context) {
            return;
        }
        if (!v.contextKeys) {
            v.contextKeys = {};
        }
        if (v.contextKeys[this.uid] === this.contextKeys) {
            return;
        }
        for (const p in this.context) {
            if (p !== 'framebuffer' && !Object.getOwnPropertyDescriptor(v, p)) {
                Object.defineProperty(v, p, {
                    configurable: false,
                    enumerable: true,
                    get: function () {
                        return this.shaderContext[p];
                    }
                });
            }
        }

        if (!Object.getOwnPropertyDescriptor(v, 'framebuffer')) {
            Object.defineProperty(v, 'framebuffer', {
                configurable: false,
                enumerable: true,
                get: function () {
                    return this['targetFramebuffer'] || this.shaderContext && this.shaderContext['framebuffer'];
                }
            });
        }

        v.contextKeys[this.uid] = this.contextKeys;
    }

    // filter() {
    //     return true;
    // }

    _runFilter(m) {
        const filters = this.filter;
        if (!filters) {
            return true;
        }
        if (Array.isArray(filters)) {
            for (let i = 0; i < filters.length; i++) {
                if (!filters[i](m)) {
                    return false;
                }
            }
            return true;
        }
        return filters(m);
    }

    getMeshCommand(device, mesh, renderProps) {
        if (!this._cmdKeys) {
            this._cmdKeys = {};
        }
        const material = mesh.getMaterial();
        let doubleSided = false;
        if (material) {
            doubleSided = material.doubleSided;
        }
        const key = this.getShaderCommandKey(device, mesh, renderProps);
        let storedKeys = this._cmdKeys[key];
        if (!storedKeys) {
            storedKeys = this._cmdKeys[key] = {};
        }
        const meshKey = mesh.getCommandKey(device);
        if (!storedKeys[meshKey]) {
            storedKeys[meshKey] = key + '_' + meshKey;
        }
        const dKey = storedKeys[meshKey];
        // const key = this.dkey || '';
        // const dKey = key + '_' + mesh.getCommandKey();
        let command = this.commands[dKey];
        if (!command) {


            const commandProps = {};
            if (doubleSided && this.extraCommandProps) {
                commandProps.cull = { enable: false };
            }
            command = this.commands[dKey] = this.createMeshCommand(device, mesh, commandProps, renderProps);
        }
        return command;
    }
}

var wireframeFrag = "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec3 vBarycentric;\nuniform float time;\nuniform float thickness;\nuniform float secondThickness;\nuniform float dashRepeats;\nuniform float dashLength;\nuniform bool dashOverlap;\nuniform bool dashEnabled;\nuniform bool dashAnimate;\nuniform bool seeThrough;\nuniform bool insideAltColor;\nuniform bool dualStroke;\nuniform bool squeeze;\nuniform float squeezeMin;\nuniform float squeezeMax;\nuniform vec4 stroke;\nuniform vec4 fill;\nuniform float opacity;\nuniform bool noiseEnable;\nvarying vec3 vPosition;\n#ifdef HAS_INSTANCE\nvarying vec4 vInstanceColor;\n#endif\n#include <mask_frag>\n#define F4 0.309016994374947451\n#define halfDist 0.5\nvec4 c(vec4 x) {\n  return x - floor(x * (1. / 289.)) * 289.;\n}\nfloat c(float x) {\n  return x - floor(x * (1. / 289.)) * 289.;\n}\nvec4 d(vec4 x) {\n  return c((x * 34. + 1.) * x);\n}\nfloat d(float x) {\n  return c((x * 34. + 1.) * x);\n}\nvec4 e(vec4 r) {\n  return 1.79284291400159 - .85373472095314 * r;\n}\nfloat e(float r) {\n  return 1.79284291400159 - .85373472095314 * r;\n}\nvec4 f(float h, vec4 i) {\n  const vec4 k = vec4(1., 1., 1., -1.);\n  vec4 p, s;\n  p.xyz = floor(fract(vec3(h) * i.xyz) * 7.) * i.z - 1.;\n  p.w = 1.5 - dot(abs(p.xyz), k.xyz);\n  s = vec4(lessThan(p, vec4(.0)));\n  p.xyz = p.xyz + (s.xyz * 2. - 1.) * s.www;\n  return p;\n}\nfloat l(vec4 m) {\n  const vec4 n = vec4(.138196601125011, .276393202250021, .414589803375032, -.447213595499958);\n  vec4 o = floor(m + dot(m, vec4(F4)));\n  vec4 u = m - o + dot(o, n.xxxx);\n  vec4 A;\n  vec3 B = step(u.yzw, u.xxx);\n  vec3 D = step(u.zww, u.yyz);\n  A.x = B.x + B.y + B.z;\n  A.yzw = 1. - B;\n  A.y += D.x + D.y;\n  A.zw += 1. - D.xy;\n  A.z += D.z;\n  A.w += 1. - D.z;\n  vec4 E = clamp(A, .0, 1.);\n  vec4 F = clamp(A - 1., .0, 1.);\n  vec4 G = clamp(A - 2., .0, 1.);\n  vec4 H = u - G + n.xxxx;\n  vec4 I = u - F + n.yyyy;\n  vec4 J = u - E + n.zzzz;\n  vec4 K = u + n.wwww;\n  o = c(o);\n  float L = d(d(d(d(o.w) + o.z) + o.y) + o.x);\n  vec4 M = d(d(d(d(o.w + vec4(G.w, F.w, E.w, 1.)) + o.z + vec4(G.z, F.z, E.z, 1.)) + o.y + vec4(G.y, F.y, E.y, 1.)) + o.x + vec4(G.x, F.x, E.x, 1.));\n  vec4 i = vec4(1. / 294., 1. / 49., 1. / 7., .0);\n  vec4 N = f(L, i);\n  vec4 O = f(M.x, i);\n  vec4 P = f(M.y, i);\n  vec4 Q = f(M.z, i);\n  vec4 R = f(M.w, i);\n  vec4 S = e(vec4(dot(N, N), dot(O, O), dot(P, P), dot(Q, Q)));\n  N *= S.x;\n  O *= S.y;\n  P *= S.z;\n  Q *= S.w;\n  R *= e(dot(R, R));\n  vec3 T = max(.6 - vec3(dot(u, u), dot(H, H), dot(I, I)), .0);\n  vec2 U = max(.6 - vec2(dot(J, J), dot(K, K)), .0);\n  T = T * T;\n  U = U * U;\n  return 49. * (dot(T * T, vec3(dot(N, u), dot(O, H), dot(P, I))) + dot(U * U, vec2(dot(Q, J), dot(R, K))));\n}\nconst float V = 3.14159265359;\nfloat W(float X, float Y) {\n  float Z = fwidth(Y) * halfDist;\n  return smoothstep(X - Z, X + Z, Y);\n}\nvec4 ba(vec3 bb) {\n  float bc = min(min(bb.x, bb.y), bb.z);\n  float bd = .0;\n  if(noiseEnable)\n    bd += l(vec4(vPosition.xyz * 80.0, time * halfDist)) * .12;\n  bc += bd;\n  float be = max(bb.x, bb.y);\n  if(bb.y < bb.x && bb.y < bb.z) {\n    be = 1. - be;\n  }\n  float bf = thickness;\n  if(squeeze) {\n    bf *= mix(squeezeMin, squeezeMax, (1. - sin(be * V)));\n  }\n  if(dashEnabled) {\n    float bg = 1. / dashRepeats * dashLength / 2.;\n    if(!dashOverlap) {\n      bg += 1. / dashRepeats / 2.;\n    }\n    if(dashAnimate) {\n      bg += time * .22;\n    }\n    float bh = fract((be + bg) * dashRepeats);\n    bf *= 1. - W(dashLength, bh);\n  }\n  float bi = 1. - W(bf, bc);\n#ifdef HAS_INSTANCE\nvec4 bj = vInstanceColor;\n#else\nvec4 bj = stroke;\n#endif\nvec4 bk = vec4(.0);\n  if(seeThrough) {\n    bk = vec4(bj.xyz, bi);\n    if(insideAltColor && !gl_FrontFacing) {\n      bk.rgb = fill.xyz;\n    }\n  } else {\n    vec3 bl = mix(fill.xyz, bj.xyz, bi);\n    bk.a = fill.a;\n    if(dualStroke) {\n      float bm = 1. - W(secondThickness, bc);\n      vec3 bn = mix(fill.xyz, stroke.xyz, abs(bm - bi));\n      bk.rgb = bn;\n    } else {\n      bk.rgb = bl;\n    }\n  }\n  return bk;\n}\nvoid main() {\n  glFragColor = ba(vBarycentric);\n  glFragColor *= halfDist + opacity;\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

var wireframeVert = "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec3 aBarycentric;\nvarying vec3 vBarycentric;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 projMatrix;\nuniform mat4 positionMatrix;\nvarying vec3 vPosition;\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n  vec4 d = getPosition(aPosition);\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(c * d, modelMatrix);\n#else\ngl_Position = projMatrix * modelViewMatrix * c * d;\n#endif\nvBarycentric = aBarycentric;\n  vPosition = aPosition;\n}";

//http://codeflow.org/entries/2012/aug/02/easy-wireframe-display-with-barycentric-coordinates/
class WireframeShader extends MeshShader {

    constructor(config = {}) {
        let extraCommandProps = config.extraCommandProps || {};
        const modelViewMatrix = [];
        extraCommandProps = extend$1({}, extraCommandProps, {
            blend: {
                enable: true,
                func: {
                    src: 'src alpha',
                    dst: 'one minus src alpha'
                },
                equation: 'add'
            },
            sample: {
                alpha: true
            }
        });
        super({
            vert: wireframeVert,
            frag: wireframeFrag,
            uniforms: [
                {
                    name: 'modelViewMatrix',
                    type: 'function',
                    fn: (context, props) => {
                        return mat4.multiply(modelViewMatrix, props['viewMatrix'], props['modelMatrix']);
                    }
                }
            ],
            extraCommandProps
        });
        this.version = 300;
    }
}

const getGlobal = function () {
    if (typeof globalThis !== 'undefined') { return globalThis; }
    if (typeof self !== 'undefined') { return self; }
    if (typeof window !== 'undefined') { return window; }
    throw new Error('unable to locate global object');
};

const WGSL_KEY = 'maptalks_wgsl_sources';

const sources = getGlobal()[WGSL_KEY] || {};

function getWGSLSource(name) {
    return sources[name];
}

function registerWGSLSource(name, source) {
    if (sources[name]) {
        throw new Error('WGSL source ' + name + ' has been registered already.');
    }
    return sources[name] = source;
}

getGlobal()[WGSL_KEY] = sources;

var phongFrag = "precision mediump float;\n#include <gl2_frag>\nuniform vec4 baseColorFactor;\nuniform float materialShininess;\nuniform float environmentExposure;\nuniform float specularStrength;\nuniform vec3 light0_viewDirection;\nuniform vec3 ambientColor;\nuniform vec4 light0_diffuse;\nuniform vec3 lightSpecular;\nuniform vec3 cameraPosition;\nuniform float alphaTest;\n#ifdef HAS_TOON\nuniform float toons;\nuniform float specularToons;\n#endif\n#ifdef HAS_TANGENT\nvarying vec4 vTangent;\n#endif\n#ifdef HAS_MAP\n#include <compute_texcoord_frag>\n#endif\nvarying vec3 vNormal;\nvarying vec3 vFragPos;\n#ifdef HAS_INSTANCE_COLOR\nvarying vec4 vInstanceColor;\n#endif\n#ifdef HAS_BASECOLOR_MAP\nuniform sampler2D baseColorTexture;\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nuniform vec2 extrusionOpacityRange;\nvarying float vExtrusionOpacity;\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvarying vec4 vColor;\n#elif defined(IS_LINE_EXTRUSION)\nuniform vec4 lineColor;\n#else\nuniform vec4 polygonFill;\n#endif\n#ifdef HAS_LAYER_OPACITY\nuniform float layerOpacity;\n#endif\n#ifdef IS_LINE_EXTRUSION\nuniform float lineOpacity;\n#else\nuniform float polygonOpacity;\n#endif\n#ifdef HAS_AO_MAP\nuniform sampler2D occlusionTexture;\nvarying vec2 vTexCoord1;\n#endif\n#ifdef HAS_NORMAL_MAP\nuniform sampler2D normalTexture;\n#endif\n#ifdef HAS_EMISSIVE_MAP\nuniform sampler2D emissiveTexture;\n#endif\n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\nuniform vec4 diffuseFactor;\nuniform vec3 specularFactor;\n#ifdef HAS_DIFFUSE_MAP\nuniform sampler2D diffuseTexture;\n#endif\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\n#include <heatmap_render_frag>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#include <highlight_frag>\n#include <mask_frag>\n#include <vertex_color_frag>\nvec3 c() {\n  \n#if defined(HAS_NORMAL_MAP)\nvec3 d = normalize(vNormal);\n  vec3 e = texture2D(normalTexture, computeTexCoord(vTexCoord)).xyz * 2. - 1.;\n#if defined(HAS_TANGENT)\nvec3 t = normalize(vTangent.xyz);\n  vec3 b = normalize(cross(d, t) * sign(vTangent.w));\n  mat3 f = mat3(t, b, d);\n  return normalize(f * e);\n#else\nreturn normalize(e);\n#endif\n#else\nreturn normalize(vNormal);\n#endif\n}\nvec4 h() {\n  \n#if defined(HAS_BASECOLOR_MAP)\nreturn texture2D(baseColorTexture, computeTexCoord(vTexCoord));\n#elif defined(HAS_DIFFUSE_MAP)\nreturn texture2D(diffuseTexture, computeTexCoord(vTexCoord));\n#elif defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn diffuseFactor;\n#else\nreturn baseColorFactor;\n#endif\n}\nvec3 i() {\n  \n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nreturn texture2D(specularGlossinessTexture, computeTexCoord(vTexCoord)).rgb;\n#elif defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn specularFactor;\n#else\nreturn vec3(1.);\n#endif\n}\nvoid main() {\n  vec4 j = h();\n#ifdef SHADING_MODEL_UNLIT\nvec3 k = vec3(1.);\n#else\nvec3 k = ambientColor;\n#endif\nvec3 l = environmentExposure * k * j.rgb;\n#ifdef HAS_INSTANCE_COLOR\nl *= vInstanceColor.rgb;\n#endif\nvec3 m = c();\n  vec3 o = normalize(-light0_viewDirection);\n  float u = max(dot(m, o), .0);\n#ifdef HAS_TOON\nfloat v = floor(u * toons);\n  u = v / toons;\n#endif\n#ifdef SHADING_MODEL_UNLIT\nvec3 A = vec3(.0);\n#else\nvec3 A = light0_diffuse.rgb;\n#endif\nvec3 B = A * u * j.rgb;\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvec3 C = vColor.rgb;\n#elif defined(IS_LINE_EXTRUSION)\nvec3 C = lineColor.rgb;\n#else\nvec3 C = polygonFill.rgb;\n#endif\n#ifdef HAS_INSTANCE_COLOR\nC *= vInstanceColor.rgb;\n#endif\nl *= C.rgb;\n  B *= C.rgb;\n  vec3 D = normalize(cameraPosition - vFragPos);\n  vec3 E = normalize(o + D);\n  float F = pow(max(dot(m, E), .0), materialShininess);\n#ifdef HAS_TOON\nfloat G = floor(F * specularToons);\n  F = G / specularToons;\n#endif\n#ifdef SHADING_MODEL_UNLIT\nvec3 H = vec3(.0);\n#else\nvec3 H = lightSpecular;\n#endif\nvec3 I = specularStrength * H * F * i();\n#ifdef HAS_OCCLUSION_MAP\nfloat J = texture2D(occlusionTexture, computeTexCoord(vTexCoord1)).r;\n  l *= J;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat K = shadow_computeShadow();\n  B = shadow_blend(B, K).rgb;\n  I = shadow_blend(I, K).rgb;\n  l = shadow_blend(l, K).rgb;\n#endif\nvec3 L = l + B + I;\n#ifdef HAS_EMISSIVE_MAP\nvec3 M = texture2D(emissiveTexture, computeTexCoord(vTexCoord)).rgb;\n  L += M;\n#endif\n#ifdef IS_LINE_EXTRUSION\nglFragColor = vec4(L, lineOpacity * j.a);\n#else\nglFragColor = vec4(L, polygonOpacity * j.a);\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nfloat N = vColor.a;\n#elif defined(IS_LINE_EXTRUSION)\nfloat N = lineColor.a;\n#else\nfloat N = polygonFill.a;\n#endif\nglFragColor *= N;\n#ifdef HAS_EXTRUSION_OPACITY\nfloat O = extrusionOpacityRange.x;\n  float P = extrusionOpacityRange.y;\n  float Q = O + vExtrusionOpacity * (P - O);\n  Q = clamp(Q, .0, 1.);\n  glFragColor *= Q;\n#endif\nif(glFragColor.a < alphaTest) {\n    discard;\n  }\n#ifdef HAS_VERTEX_COLOR\nglFragColor *= vertexColor_get();\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\nglFragColor = highlight_blendColor(glFragColor);\n#ifdef HAS_LAYER_OPACITY\nglFragColor *= layerOpacity;\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

var phongVert = "#include <gl2_vert>\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\n#ifdef HAS_MAP\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#if defined(HAS_AO_MAP)\nattribute vec2 aTexCoord1;\nvarying vec2 vTexCoord1;\n#endif\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\nvarying vec4 vColor;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\n#else\nattribute vec4 aColor0;\n#endif\nvarying vec4 vColor;\n#endif\nvarying vec3 vFragPos;\nvarying vec3 vNormal;\nuniform mat4 projMatrix;\nuniform mat3 modelNormalMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform vec2 halton;\nuniform vec2 outSize;\nuniform mat4 projViewMatrix;\n#include <highlight_vert>\n#include <get_output>\n#include <heatmap_render_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nattribute float aExtrusionOpacity;\nvarying float vExtrusionOpacity;\n#endif\n#if defined(HAS_TANGENT)\nvarying vec4 vTangent;\n#endif\nvoid c(const highp vec4 q, out highp vec3 d) {\n  d = vec3(.0, .0, 1.) + vec3(2., -2., -2.) * q.x * q.zwx + vec3(2., 2., -2.) * q.y * q.wzy;\n}\nvoid c(const highp vec4 q, out highp vec3 d, out highp vec3 t) {\n  c(q, d);\n  t = vec3(1., .0, .0) + vec3(-2., 2., -2.) * q.y * q.yxw + vec3(-2., 2., 2.) * q.z * q.zwx;\n}\n#include <vertex_color_vert>\nvoid main() {\n  \n#ifdef IS_LINE_EXTRUSION\nvec4 e = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 e = getPosition(aPosition);\n#endif\nmat4 f = getPositionMatrix();\n  vFragPos = vec3(modelMatrix * f * e);\n#if defined(HAS_NORMAL) || defined(HAS_TANGENT)\nmat3 h = modelNormalMatrix * mat3(f);\n  vec3 i;\n#if defined(HAS_TANGENT)\nvec3 t;\n  c(aTangent, i, t);\n  vTangent = vec4(h * t, aTangent.w);\n#else\ni = decode_getNormal(aNormal);\n#endif\nvec3 j = appendMorphNormal(i);\n  vNormal = normalize(h * j);\n#else\nvNormal = vec3(.0);\n#endif\nmat4 k = projMatrix;\n  k[2].xy += halton.xy / outSize.xy;\n#ifdef HAS_MASK_EXTENT\ngl_Position = k * getMaskPosition(f * e, modelMatrix);\n#else\ngl_Position = k * modelViewMatrix * f * e;\n#endif\n#ifdef HAS_MAP\nvec2 l = decode_getTexcoord(aTexCoord);\n  vTexCoord = l * uvScale + uvOffset;\n#endif\n#ifdef HAS_AO_MAP\nvec2 m = decode_getTexcoord(aTexCoord1);\n  vTexCoord1 = m * uvScale + uvOffset;\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nvExtrusionOpacity = aExtrusionOpacity;\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvColor = vec4(aColor0 / 255., 1.);\n#else\nvColor = aColor0 / 255.;\n#endif\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(f * e);\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * f, e);\n#endif\n#ifdef HAS_I3S_UVREGION\nvUvRegion = uvRegion / 65535.;\n#endif\nhighlight_setVarying();\n#ifdef HAS_VERTEX_COLOR\nvertexColor_update();\n#endif\n}";

class PhongShader extends MeshShader {
    constructor(config = {}) {
        const normalMatrix = [];
        const modelViewMatrix = [];
        const extraUniforms = config.uniforms;
        const uniforms = [
            {
                name: 'modelNormalMatrix',
                type: 'function',
                fn: function (context, props) {
                    return mat3.fromMat4(normalMatrix, props['modelMatrix']);
                }
            },
            {
                name: 'modelViewMatrix',
                type: 'function',
                fn: function (context, props) {
                    return mat4.multiply(modelViewMatrix, props['viewMatrix'], props['modelMatrix']);
                }
            }
        ];
        if (extraUniforms) {
            uniforms.push(...extraUniforms);
        }
        super({
            name: 'phong',
            vert: config.vert || phongVert,
            frag: config.frag || phongFrag,
            wgslVert: getWGSLSource('gl_phong_vert'),
            wgslFrag: getWGSLSource('gl_phong_frag'),
            uniforms,
            defines: config.defines || {},
            extraCommandProps: config.extraCommandProps || {}
        });
        this.version = 300;
    }

    getGeometryDefines(geometry) {
        const defines = {};
        if (geometry.data[geometry.desc.tangentAttribute]) {
            defines['HAS_TANGENT'] = 1;
        } else if (geometry.data[geometry.desc.normalAttribute]) {
            defines['HAS_NORMAL'] = 1;
        }
        return defines;
    }
}

var pointLineFrag = "precision mediump float;\n#include <gl2_frag>\n#if defined(HAS_COLOR0)\nvarying vec4 vColor;\n#endif\n#include <heatmap_render_frag>\nuniform vec4 baseColorFactor;\n#if defined(HAS_MAP)\n#if defined(HAS_ALBEDO_MAP)\nuniform sampler2D baseColorTexture;\n#endif\n#if defined(HAS_DIFFUSE_MAP)\nuniform sampler2D diffuseTexture;\n#endif\nvarying vec2 vTexCoord;\n#endif\n#include <mask_frag>\nvoid main() {\n  \n#ifdef HAS_COLOR0\nglFragColor = vColor * baseColorFactor;\n#else\nglFragColor = vec4(1.) * baseColorFactor;\n#endif\n#ifdef HAS_MAP\n#ifdef HAS_ALBEDO_MAP\nglFragColor *= texture2D(baseColorTexture, vTexCoord);\n#endif\n#ifdef HAS_DIFFUSE_MAP\nglFragColor *= texture2D(diffuseTexture, vTexCoord);\n#endif\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

var pointLineVert = "attribute vec3 aPosition;\n#ifdef HAS_COLOR0\nattribute vec4 aColor0;\nvarying vec4 vColor;\n#endif\nuniform mat4 modelMatrix;\nuniform mat4 projMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform float pointSize;\n#if defined(HAS_MAP)\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#endif\n#include <get_output>\n#include <heatmap_render_vert>\n#ifdef HAS_FLOODANALYSE\nvarying float vHeight;\n#endif\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_PointSize = pointSize;\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(d * c, modelMatrix);\n#else\ngl_Position = projViewModelMatrix * d * c;\n#endif\n#ifdef HAS_COLOR0\nvColor = aColor0 / 255.;\n#endif\n#ifdef HAS_MAP\nvTexCoord = aTexCoord;\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * d, c);\n#endif\n}";

class PointLineShader extends MeshShader {
    constructor(config = {}) {
        const projViewModelMatrix = [];
        super({
            vert: pointLineVert,
            frag: pointLineFrag,
            uniforms: [
                {
                    name: 'projViewModelMatrix',
                    type: 'function',
                    fn: (context, props) => {
                        return mat4.multiply(projViewModelMatrix, props['projViewMatrix'], props['modelMatrix']);
                    }
                }
            ],
            defines: config.defines || {},
            extraCommandProps: config.extraCommandProps || {}
        });
    }
}

var vert$b = "#if __VERSION__ == 300\n#define attribute in\n#define varying out\n#endif\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nvoid main() {\n  gl_Position = vec4(aPosition, 0., 1.);\n  vTexCoord = aTexCoord;\n}";

const quadVertices$1 = new Float32Array([
    // positions
    -1.0,  1.0,
    -1.0, -1.0,
    1.0,  1.0,
    1.0,  1.0,
    -1.0, -1.0,
    1.0, -1.0,
]);
const quadTexcoords$1 = new Float32Array([
    0.0, 1.0,
    0.0, 0.0,
    1.0, 1.0,
    1.0, 1.0,
    0.0, 0.0,
    1.0, 0.0,
]);

class QuadShader extends MeshShader {
    constructor(config) {
        config.vert = config.vert || vert$b;
        config.wgslVert = config.wgslVert || getWGSLSource('gl_quad_vert');
        config.extraCommandProps = config.extraCommandProps || {};
        if (!config.extraCommandProps.depth) {
            //disable depth
            config.extraCommandProps.depth = {
                enable: false,
                mask: false
            };
        }
        if (!config.extraCommandProps.stencil) {
            //disable stencil
            config.extraCommandProps.stencil = {
                enable: false
            };
        }
        super(config);
    }

    draw(regl) {
        if (!this._quadMesh) {
            this._createQuadMesh(regl);
        }
        return super.draw(regl, this._quadMesh);
    }

    getMeshCommand(regl, mesh, renderProps) {
        const key = this.dkey || '';
        const shaderKey = this.getShaderCommandKey(regl, mesh, renderProps);
        const cmdKey = key + shaderKey + '_quad';
        if (!this.commands[cmdKey]) {
            this.commands[cmdKey] = this.createMeshCommand(regl, mesh);
        }
        return this.commands[cmdKey];
    }

    _createQuadMesh(regl) {
        const geometry = new Geometry(
            {
                aPosition : quadVertices$1,
                aTexCoord : quadTexcoords$1
            },
            null,
            quadVertices$1.length / 2,
            {
                positionSize: 2,
                primitive : 'triangles'
            }
        );
        geometry.generateBuffers(regl);
        this._quadMesh = [new Mesh(geometry)];
    }

    dispose() {
        if (this._quadMesh) {
            const mesh = this._quadMesh[0];
            mesh.geometry.dispose();
            mesh.dispose();
        }
        delete this._quadMesh;
        return super.dispose();
    }
}

var frag$h = "#define SHADER_NAME FXAA\nprecision mediump float;\nvarying vec2 vTexCoord;\nuniform float enableFXAA;\nuniform float enableToneMapping;\nuniform float enableSharpen;\nuniform vec2 resolution;\nuniform sampler2D textureSource;\n#ifdef HAS_NOAA_TEX\nuniform sampler2D noAaTextureSource;\n#endif\n#ifdef HAS_POINT_TEX\nuniform sampler2D pointTextureSource;\n#endif\n#ifdef HAS_TAA_TEX\nuniform sampler2D taaTextureSource;\n#ifdef HAS_FXAA_TEX\nuniform sampler2D fxaaTextureSource;\n#endif\n#endif\nuniform float pixelRatio;\nuniform float sharpFactor;\n#ifdef HAS_OUTLINE_TEX\nuniform sampler2D textureOutline;\nuniform float highlightFactor;\nuniform float outlineFactor;\nuniform float outlineWidth;\nuniform vec3 outlineColor;\n#endif\nvec2 c;\nvec4 d(vec2 e) {\n  \n#ifdef HAS_TAA_TEX\nvec4 f = texture2D(textureSource, e);\n  vec4 taa = texture2D(taaTextureSource, e);\n#ifdef HAS_FXAA_TEX\nvec4 h = texture2D(fxaaTextureSource, e);\n#else\nvec4 h = vec4(.0);\n#endif\nvec4 i = taa + f * (1. - taa.a);\n  return h + i * (1. - h.a);\n#else\nreturn texture2D(textureSource, e);\n#endif\n}\nvec3 j(const in vec3 k, const float l) {\n  vec2 m = pixelRatio / resolution.xy;\n  float n = .0;\n  vec4 o = texture2D(textureSource, c + m * vec2(-1., -1.));\n  o.rgb = mix(vec3(.0), o.rgb, sign(o.a));\n  n += mix(.0, 1., sign(o.a));\n  vec4 u = texture2D(textureSource, c + m * vec2(1.));\n  u.rgb = mix(vec3(.0), u.rgb, sign(u.a));\n  n += mix(.0, 1., sign(u.a));\n  vec4 v = texture2D(textureSource, c + m * vec2(1., -1.));\n  v.rgb = mix(vec3(.0), v.rgb, sign(v.a));\n  n += mix(.0, 1., sign(v.a));\n  vec4 A = texture2D(textureSource, c + m * vec2(-1., 1.));\n  A.rgb = mix(vec3(.0), A.rgb, sign(A.a));\n  n += mix(.0, 1., sign(A.a));\n  return k + l * (n * k - o.rgb - v.rgb - A.rgb - u.rgb);\n}\nvec4 B(const in vec4 k) {\n  return vec4(j(k.rgb, sharpFactor), k.a);\n}\nvec3 C(const vec3 x) {\n  const float a = 2.51;\n  const float b = .03;\n  const float D = 2.43;\n  const float E = .59;\n  const float F = .14;\n  return (x * (a * x + b)) / (x * (D * x + E) + F);\n}\nvec3 G(vec3 k) {\n  k = k / (k + vec3(1.));\n  return k = pow(k, vec3(1. / 2.2));\n}\n#ifdef HAS_OUTLINE_TEX\nvec4 H() {\n  float I = 2.;\n  float J = 1.;\n  float K = pixelRatio / resolution[0] * outlineWidth;\n  float L = pixelRatio / resolution[1] * outlineWidth;\n  vec4 M = (texture2D(textureOutline, c + vec2(K, L)));\n  vec4 N = (texture2D(textureOutline, c + vec2(K, .0)));\n  vec4 O = (texture2D(textureOutline, c + vec2(K, -L)));\n  vec4 P = (texture2D(textureOutline, c + vec2(.0, -L)));\n  vec4 Q = (texture2D(textureOutline, c + vec2(-K, -L)));\n  vec4 R = (texture2D(textureOutline, c + vec2(-K, .0)));\n  vec4 S = (texture2D(textureOutline, c + vec2(-K, L)));\n  vec4 T = (texture2D(textureOutline, c + vec2(.0, L)));\n  vec4 U = -I * R + I * N + -J * S + J * M + -J * Q + J * O;\n  vec4 V = -I * P + I * T + -J * Q + J * S + -J * O + J * M;\n  float W = sqrt(dot(V, V) + dot(U, U));\n  bool X = W < 1. / 65025.;\n  vec3 Y = (texture2D(textureOutline, c)).r * outlineColor;\n  if(Y == vec3(.0) || (highlightFactor == .0 && X)) {\n    return vec4(.0);\n  }\n  float Z = X ? highlightFactor : min(1., sqrt(W) * outlineFactor);\n  return Z * vec4(Y, 1.);\n}\nvec4 ba(const in vec4 k) {\n  vec4 H = H();\n  return H + vec4(k) * (1. - H.a);\n}\n#endif\nvoid main() {\n  c = vTexCoord;\n  vec4 k;\n  if(enableFXAA == 1.) {\n    \n  } else {\n    k = d(vTexCoord);\n  }\n  if(enableSharpen == 1.) {\n    k = B(k);\n  }\n#if defined(HAS_NOAA_TEX) || defined(HAS_POINT_TEX)\nvec4 bb = vec4(.0);\n  vec4 bc = vec4(.0);\n#ifdef HAS_POINT_TEX\nbb = texture2D(pointTextureSource, vTexCoord);\n#endif\n#ifdef HAS_NOAA_TEX\nbc = texture2D(noAaTextureSource, vTexCoord);\n#endif\nvec4 bd = bb + bc * (1. - bb.a);\n  k = bd + k * (1. - bd.a);\n#endif\nif(enableToneMapping == 1.) {\n    k.rgb = G(k.rgb);\n  }\n#ifdef HAS_OUTLINE_TEX\nk = ba(k);\n#endif\ngl_FragColor = k;\n}";

class FxaaShader extends QuadShader {
    constructor() {
        super({
            name: 'fxaa',
            frag: frag$h, wgslFrag: getWGSLSource('gl_fxaa_frag'),
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (_, props) => {
                        return props['resolution'][0];
                    },
                    height: (_, props) => {
                        return props['resolution'][1];
                    }
                }
            }
        });
    }
}

var frag$g = "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D textureSource;\nuniform vec2 resolution;\nuniform float ignoreTransparent;\nvoid main() {\n  vec4 c = vec4(.0);\n  float d = .0;\n  for(int x = -BOXBLUR_OFFSET; x <= BOXBLUR_OFFSET; ++x)\n    for(int y = -BOXBLUR_OFFSET; y <= BOXBLUR_OFFSET; ++y) {\n      vec2 e = vTexCoord.st + vec2(float(x) / resolution.x, float(y) / resolution.y);\n      e = clamp(e, .0, 1.);\n      vec4 f = texture2D(textureSource, e);\n      float h;\n      if(ignoreTransparent == 1.) {\n        h = sign(f.a);\n      } else {\n        h = 1.;\n      }\n      d += h;\n      c += h * f;\n    }\n  gl_FragColor = c / max(d, 1.) * clamp(sign(d - 1.), .0, 1.);\n}";

class BoxBlurShader extends QuadShader {

    constructor({ blurOffset }) {
        super({
            vert: vert$b, frag: frag$g,
            defines : {
                'BOXBLUR_OFFSET' : blurOffset || 2
            },
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (context, props) => {
                        return props['resolution'][0];
                    },
                    height: (context, props) => {
                        return props['resolution'][1];
                    }
                }
            }
        });
        this._blurOffset = blurOffset || 2;
    }

    getMeshCommand(regl, mesh) {
        const key = 'box_blur_' + this._blurOffset;
        if (!this.commands[key]) {
            this.commands[key] = this.createMeshCommand(regl, mesh);
        }
        return this.commands[key];
    }
}

var vert$a = "#include <gl2_vert>\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\nuniform mat4 projViewModelMatrix;\nvarying vec2 vTexCoord;\nvoid main() {\n  gl_Position = projViewModelMatrix * vec4(aPosition, 0., 1.);\n  vTexCoord = aTexCoord;\n}";

var frag$f = "precision mediump float;\n#include <gl2_frag>\nuniform sampler2D baseColorTexture;\nuniform float opacity;\nuniform vec4 baseColor;\nuniform float alphaTest;\n#ifdef HAS_DEBUG\nuniform sampler2D debugTexture;\n#endif\nvarying vec2 vTexCoord;\nvoid main() {\n  glFragColor = texture2D(baseColorTexture, vTexCoord);\n  glFragColor *= baseColor;\n#ifdef HAS_DEBUG\nvec4 c = texture2D(debugTexture, vTexCoord);\n  glFragColor = vec4(c.rgb + glFragColor.rgb * (1. - c.a), c.a + glFragColor.a * (1. - c.a));\n#endif\nif(glFragColor.a < alphaTest) {\n    discard;\n  }\n  glFragColor *= opacity;\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

class ImageShader extends MeshShader {
    constructor(config) {
        const projViewModelMatrix = [];
        const extraCommandProps = config ? config.extraCommandProps || {} : {};
        config.vert = vert$a;
        config.frag = frag$f;
        super({
            name: 'image',
            vert: vert$a,
            frag: frag$f,
            wgslVert: getWGSLSource('gl_image_vert'),
            wgslFrag: getWGSLSource('gl_image_frag'),
            uniforms: [
                {
                    name: 'projViewModelMatrix',
                    type: 'function',
                    fn: function (context, props) {
                        return mat4.multiply(projViewModelMatrix, props['projViewMatrix'], props['modelMatrix']);
                    }
                }
            ],
            extraCommandProps
        });
    }

    getMeshCommand(regl, mesh, renderProps) {
        const key = this.getShaderCommandKey(regl, mesh, renderProps);
        const meshKey = mesh.getCommandKey(regl);
        const dKey = key + '_' + meshKey;
        if (!this.commands['image_' + dKey]) {
            this.commands['image_' + dKey] = this.createMeshCommand(regl, mesh, null, renderProps);
        }
        return this.commands['image_' + dKey];
    }
}

var frag$e = "precision mediump float;\nvarying vec2 vTexCoord;\nuniform vec2 resolution;\nuniform sampler2D textureSource;\nuniform float enableVignette;\nuniform float enableGrain;\nuniform float enableLut;\nuniform float timeGrain;\nuniform float grainFactor;\nuniform vec2 lensRadius;\nuniform float frameMod;\nuniform sampler2D lookupTable;\n#include <srgb_frag>\nfloat c(const in vec2 d) {\n  vec3 e = fract(vec3(d.xyx) * .1031);\n  e += dot(e, e.yzx + 19.19);\n  return fract((e.x + e.y) * e.z);\n}\nfloat f() {\n  float h = c(gl_FragCoord.xy + 1000.0 * fract(timeGrain));\n  float i = h * 2. - 1.;\n  h = i * inversesqrt(abs(i));\n  h = max(-1., h);\n  h = h - sign(i) + .5;\n  return (h + .5) * .5;\n}\nvec4 j(const in vec4 k) {\n  float l = f();\n  return vec4(mix(k.rgb, k.rgb * (k.rgb + (1. - k.rgb) * 2. * l), grainFactor), k.a);\n}\nfloat m(const in vec2 d, const in float n) {\n  vec3 o = vec3(.06711056, .00583715, 52.9829189);\n  return fract(o.z * fract(dot(d.xy + n * vec2(47., 17.) * .695, o.xy)));\n}\nfloat u() {\n  vec2 v = lensRadius;\n  v.y = min(v.y, v.x - 1e-4);\n  float A = m(gl_FragCoord.xy, frameMod);\n  A = (v.x - v.y) * (v.x + v.y) * .07 * (A - .5);\n  return smoothstep(v.x, v.y, A + distance(vTexCoord, vec2(.5)));\n}\nvec4 B(const in vec4 k) {\n  float l = u();\n  return vec4(linearTosRGB(sRGBToLinear(k.rgb) * l), clamp(k.a + (1. - l), .0, 1.));\n}\nvec4 C(in vec4 D, in sampler2D E) {\n  mediump float F = D.b * 63.;\n  mediump vec2 G;\n  G.y = floor(floor(F) / 8.);\n  G.x = floor(F) - G.y * 8.;\n  mediump vec2 H;\n  H.y = floor(ceil(F) / 8.);\n  H.x = ceil(F) - H.y * 8.;\n  highp vec2 I;\n  I.x = G.x * .125 + .5 / 512. + (.125 - 1. / 512.) * D.r;\n  I.y = G.y * .125 + .5 / 512. + (.125 - 1. / 512.) * D.g;\n#ifdef LUT_FLIP_Y\nI.y = 1. - I.y;\n#endif\nhighp vec2 J;\n  J.x = H.x * .125 + .5 / 512. + (.125 - 1. / 512.) * D.r;\n  J.y = H.y * .125 + .5 / 512. + (.125 - 1. / 512.) * D.g;\n#ifdef LUT_FLIP_Y\nJ.y = 1. - J.y;\n#endif\nlowp vec4 K = texture2D(E, I);\n  lowp vec4 L = texture2D(E, J);\n  lowp vec4 M = mix(K, L, fract(F));\n  return M;\n}\nvoid main() {\n  vec4 k = texture2D(textureSource, vTexCoord);\n  if(enableLut == 1.) {\n    k = C(k, lookupTable);\n  }\n  if(enableVignette == 1.) {\n    k = B(k);\n  }\n  if(enableGrain == 1.) {\n    k = j(k);\n  }\n  gl_FragColor = k;\n}";

class PostProcessShader extends QuadShader {
    constructor() {
        super({
            vert: vert$b, frag: frag$e,
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (context, props) => {
                        return props['resolution'][0];
                    },
                    height: (context, props) => {
                        return props['resolution'][1];
                    }
                }
            }
        });
    }

    getMeshCommand(regl, mesh) {
        if (!this.commands['postprocess']) {
            this.commands['postprocess'] = this.createMeshCommand(regl, mesh);
        }
        return this.commands['postprocess'];
    }
}

const SAMPLES = [
    [.263385, -.0252475],
    [-.38545, .054485],
    [-.139795, -.5379925],
    [-.2793775, .6875475],
    [.7139025, .4710925],
    [.90044, -.16422],
    [.4481775, -.82799],
    [-.9253375, -.2910625],
    [.3468025, 1.02292],
    [-1.13742, .33522],
    [-.7676225, -.9123175],
    [-.2005775, -1.1774125],
    [-.926525, .96876],
    [1.12909, -.7500325],
    [.9603, 1.14625]
];

const SAMPLE_COUNT = SAMPLES.length;

const AVG = [0, 0];
for (let i = 0; i < SAMPLES.length; i++) {
    AVG[0] += SAMPLES[i][0];
    AVG[1] += SAMPLES[i][1];
}
AVG[0] /= SAMPLE_COUNT;
AVG[1] /= SAMPLE_COUNT;

class Jitter {
    constructor(ratio) {
        this._frameNum = 0;
        // this._ratio = 0.05;
        this._ratio = ratio || 0.05;
        this._avg = [AVG[0] * this._ratio, AVG[1] * this._ratio];
    }

    getRatio() {
        return this._ratio;
    }

    setRatio(ratio) {
        if (this._ratio !== ratio) {
            this._ratio = ratio;
            this.reset();
        }
        this._avg = [AVG[0] * this._ratio, AVG[1] * this._ratio];
    }

    getAverage() {
        return this._avg;
    }

    reset() {
        this._frameNum = 0;
    }

    getJitter(out) {
        const t = this._frameNum % SAMPLE_COUNT;
        const r = this._ratio;
        vec2.set(out, SAMPLES[t][0] * r, SAMPLES[t][1] * r);
        // out[0] = out[1] = 0;
        return out;
    }

    frame() {
        this._frameNum++;
        if (this._frameNum % SAMPLE_COUNT === 0) {
            this._frameNum = 0;
        }
    }

    getSampleCount() {
        return SAMPLE_COUNT;
    }
}


////jitter generation from:
////https://github.com/playdeadgames/temporal/blob/4795aa0007d464371abe60b7b28a1cf893a4e349/Assets/Scripts/FrustumJitter.cs
// function transformPattern(seq, theta, scale) {
//     const cs = Math.cos(theta);
//     const sn = Math.sin(theta);
//     const n = seq.length;
//     for (let i = 0, j = 1; i !== n; i += 2, j += 2) {
//         const x = scale * seq[i];
//         const y = scale * seq[j];
//         seq[i] = x * cs - y * sn;
//         seq[j] = x * sn + y * cs;
//     }
// }

// function initializeHalton_2_3(seq) {
//     for (let i = 0, n = seq.length / 2; i !== n; i++) {
//         const u = haltonSeq(2, i + 1) - 0.5;
//         const v = haltonSeq(3, i + 1) - 0.5;
//         seq[2 * i + 0] = u;
//         seq[2 * i + 1] = v;
//     }
// }

// function haltonSeq(prime, index = 1/* NOT! zero-based */) {
//     let r = 0.0;
//     let f = 1.0;
//     let i = index;
//     while (i > 0) {
//         f /= prime;
//         r += f * (i % prime);
//         i = Math.floor(i / prime);
//     }
//     return r;
// }

// const POINTS_PENTAGRAM = [
//     0.000000 * 0.5,  0.525731 * 0.5, // head
//     -0.309017 * 0.5, -0.425325 * 0.5, // lleg
//     0.500000 * 0.5,  0.162460 * 0.5, // rarm
//     -0.500000 * 0.5,  0.162460 * 0.5, // larm
//     0.309017 * 0.5, -0.425325 * 0.5, // rleg
// ];

// function jitter() {
//     const vh = [POINTS_PENTAGRAM[0] - POINTS_PENTAGRAM[2], POINTS_PENTAGRAM[1] - POINTS_PENTAGRAM[3]];
//     const vu = [0.0, 1.0];
//     const angle = vec2.angle(vu, vh);
//     transformPattern(POINTS_PENTAGRAM, 0.5 * angle, 1);

//     const points_Halton_2_3_x8 = new Array(8 * 2);
//     const points_Halton_2_3_x16 = new Array(16 * 2);
//     const points_Halton_2_3_x32 = new Array(32 * 2);
//     const points_Halton_2_3_x256 = new Array(256 * 2);
//     // points_Halton_2_3_xN
//     initializeHalton_2_3(points_Halton_2_3_x8);
//     initializeHalton_2_3(points_Halton_2_3_x16);
//     // initializeHalton_2_3(points_Halton_2_3_x32);
//     // initializeHalton_2_3(points_Halton_2_3_x256);

//     console.log(points_Halton_2_3_x8);
//     console.log(points_Halton_2_3_x16);
//     // console.log(points_Halton_2_3_x32);
//     // console.log(points_Halton_2_3_x256);
// }

var blur0Frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\nuniform float inputRGBM;\nuniform float luminThreshold;\n#define SHADER_NAME GAUSSIAN_BLUR0\nconst vec3 c = vec3(.2126, .7152, .0722);\nfloat d(const in vec3 e) {\n  return dot(e, c);\n}\nvec4 f(vec4 e) {\n  float h = max(sign(d(e.rgb) - luminThreshold), .0);\n  return e * h;\n}\nvec2 i;\nvec4 j(const in vec3 e, const in float k) {\n  vec4 l;\n  vec3 m = e / k;\n  l.a = clamp(max(max(m.r, m.g), max(m.b, 1e-6)), .0, 1.);\n  l.a = ceil(l.a * 255.) / 255.;\n  l.rgb = m / l.a;\n  return l;\n}\nvec3 n(const in vec4 e, const in float k) {\n  if(inputRGBM == .0)\n    return e.rgb;\n  return k * e.rgb * e.a;\n}\nvec4 o() {\n  vec3 u = .375 * (f(vec4(n(texture2D(TextureBlurInput, i.xy), rgbmRange), 1.))).rgb;\n  vec2 v;\n  vec2 A = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  v = A * 1.2;\n  u += .3125 * (f(vec4(n(texture2D(TextureBlurInput, i.xy + v.xy), rgbmRange), 1.))).rgb;\n  u += .3125 * (f(vec4(n(texture2D(TextureBlurInput, i.xy - v.xy), rgbmRange), 1.))).rgb;\n  return vec4(u, 1.);\n}\nvoid main(void) {\n  i = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = o();\n  e = j(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}";

var blur1Frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR1\nvec2 c;\n#include <rgbm_frag>\nvec4 d() {\n  vec3 e = .3125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 f;\n  vec2 h = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  f = h * 1.2857142857142858;\n  e += .328125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .328125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  return vec4(e, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 i = d();\n  i = encodeRGBM(i.rgb, rgbmRange);\n  gl_FragColor = i;\n}";

var blur2Frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR2\nvec2 c;\n#include <rgbm_frag>\nvec4 d() {\n  vec3 e = .2734375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 f;\n  vec2 h = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  f = h * 1.3333333333333333;\n  e += .328125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .328125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 3.111111111111111;\n  e += .03515625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .03515625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  return vec4(e, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 i = d();\n  i = encodeRGBM(i.rgb, rgbmRange);\n  gl_FragColor = i;\n}";

var blur3Frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR3\nvec2 c;\n#include <rgbm_frag>\nvec4 d() {\n  vec3 e = .24609375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 f;\n  vec2 h = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  f = h * 1.3636363636363635;\n  e += .322265625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .322265625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 3.1818181818181817;\n  e += .0537109375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .0537109375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  return vec4(e, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 i = d();\n  i = encodeRGBM(i.rgb, rgbmRange);\n  gl_FragColor = i;\n}";

var blur4Frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR4\nvec2 c;\n#include <rgbm_frag>\nvec4 d() {\n  vec3 e = .2255859375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 f;\n  vec2 h = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  f = h * 1.3846153846153846;\n  e += .314208984375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .314208984375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 3.230769230769231;\n  e += .06982421875 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .06982421875 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 5.076923076923077;\n  e += .003173828125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .003173828125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  return vec4(e, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 i = d();\n  i = encodeRGBM(i.rgb, rgbmRange);\n  gl_FragColor = i;\n}";

var blur5Frag = "precision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 outSize;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR5\nvec2 c;\n#include <rgbm_frag>\nvec4 d() {\n  vec3 e = .20947265625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 f;\n  vec2 h = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  h *= outSize.y * .00075;\n  f = h * 1.4;\n  e += .30548095703125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .30548095703125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 3.2666666666666666;\n  e += .08331298828125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .08331298828125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 5.133333333333334;\n  e += .00640869140625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .00640869140625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  return vec4(e, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 i = d();\n  i = encodeRGBM(i.rgb, rgbmRange);\n  gl_FragColor = i;\n}";

var blur6Frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 outSize;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR6\nvec2 c;\n#include <rgbm_frag>\nvec4 d() {\n  vec3 e = .196380615234375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 f;\n  vec2 h = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  h *= outSize.y * .00075;\n  f = h * 1.411764705882353;\n  e += .2967529296875 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .2967529296875 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 3.2941176470588234;\n  e += .09442138671875 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .09442138671875 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 5.176470588235294;\n  e += .0103759765625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .0103759765625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  return vec4(e, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 i = d();\n  i = encodeRGBM(i.rgb, rgbmRange);\n  gl_FragColor = i;\n}";

class BlurPass {
    constructor(regl, inputRGBM, level = 5) {
        this._regl = regl;
        this._renderer = new Renderer(regl);
        this._inputRGBM = inputRGBM;
        this._level = level;
    }

    render(sourceTex, luminThreshold) {
        this._initShaders();
        this._createTextures(sourceTex);

        //blur
        this._blur(sourceTex, luminThreshold || 0);

        const result = {
            blurTex0: this._blur01Tex,
            blurTex1: this._blur11Tex,
            blurTex2: this._blur21Tex,
            blurTex3: this._blur31Tex,
            blurTex4: this._blur41Tex
        };
        if (this._level > 5) {
            result.blurTex5 = this._blur51Tex;
            result.blurTex6 = this._blur61Tex;
        }
        return result;
    }

    _blur(curTex, luminThreshold) {
        let uniforms = this._blurUniforms;
        if (!uniforms) {
            uniforms = this._blurUniforms = {
                'rgbmRange': 7,
                'blurDir': [0, 0],
                'outSize': [0, 0],
                'pixelRatio': [1, 1],
                'outputSize': [0, 0],
            };
        }
        vec2.set(uniforms['outSize'], curTex.width, curTex.height);

        if (curTex.config && curTex.config.sampleCount > 1) {
            const defines = {
                'HAS_MULTISAMPLED': 1
            };
            this._blur0Shader.setDefines(defines);
        } else {
            this._blur0Shader.setDefines({});
        }

        //只有第一次blur需要用 luminThreshold 过滤像素
        this._blurOnce(this._blur0Shader, curTex, this._blur00FBO, this._blur01FBO, 0.5, luminThreshold);
        this._blurOnce(this._blur1Shader, this._blur01FBO.color[0], this._blur10FBO, this._blur11FBO, 0.5);
        this._blurOnce(this._blur2Shader, this._blur11FBO.color[0], this._blur20FBO, this._blur21FBO, 0.5);
        this._blurOnce(this._blur3Shader, this._blur21FBO.color[0], this._blur30FBO, this._blur31FBO, 0.5);
        this._blurOnce(this._blur4Shader, this._blur31FBO.color[0], this._blur40FBO, this._blur41FBO, 0.5);
        // this._boxOnce(this._blur11FBO.color[0], this._blur21FBO, 0.5);
        // this._boxOnce(this._blur21FBO.color[0], this._blur31FBO, 0.5);
        // this._boxOnce(this._blur31FBO.color[0], this._blur41FBO, 0.5);
        if (this._level > 5) {
            this._blurOnce(this._blur5Shader, this._blur41FBO.color[0], this._blur50FBO, this._blur51FBO, 0.5);
            this._blurOnce(this._blur6Shader, this._blur51FBO.color[0], this._blur60FBO, this._blur51FBO, 0.5);
        }
    }

    _blurOnce(shader, inputTex, output0, output1, sizeRatio, luminThreshold) {
        const w = Math.ceil(sizeRatio * inputTex.width);
        const h = Math.ceil(sizeRatio * inputTex.height);
        if (output0.width !== w || output0.height !== h) {
            output0.resize(w, h);
        }
        if (output1.width !== w || output1.height !== h) {
            output1.resize(w, h);
        }

        const uniforms = this._blurUniforms;
        uniforms['luminThreshold'] = luminThreshold;
        uniforms['TextureBlurInput'] = inputTex;
        //第一次输入是否需要decode rgbm
        uniforms['inputRGBM'] = +this._inputRGBM;
        vec2.set(uniforms['blurDir'], 0, 1);
        vec2.set(uniforms['outputSize'], output0.width, output0.height);
        this._renderer.render(shader, uniforms, null, output0);

        if (shader.shaderDefines && shader.shaderDefines['HAS_MULTISAMPLED']) {
            shader.setDefines({});
        }
        uniforms['luminThreshold'] = 0;
        uniforms['inputRGBM'] = 1;
        vec2.set(uniforms['blurDir'], 1, 0);
        uniforms['TextureBlurInput'] = output0.color[0];
        this._renderer.render(shader, uniforms, null, output1);
    }

    // _boxOnce(inputTex, output, sizeRatio) {
    //     const w = Math.ceil(sizeRatio * inputTex.width);
    //     const h = Math.ceil(sizeRatio * inputTex.height);
    //     if (output.width !== w || output.height !== h) {
    //         output.resize(w, h);
    //     }

    //     if (!this._boxUniforms) {
    //         this._boxUniforms = {
    //             ignoreTransparent: 0,
    //             resolution: [0, 0]
    //         };
    //     }

    //     const uniforms = this._boxUniforms;
    //     uniforms['textureSource'] = inputTex;
    //     vec2.set(uniforms['resolution'], output.width, output.height);
    //     this._renderer.render(this._boxShader, uniforms, null, output);
    // }

    dispose() {
        if (this._blur0Shader) {
            this._blur0Shader.dispose();
            delete this._blur0Shader;
            this._blur1Shader.dispose();
            this._blur2Shader.dispose();
            this._blur3Shader.dispose();
            this._blur4Shader.dispose();
            if (this._blur5Shader) {
                this._blur5Shader.dispose();
                this._blur6Shader.dispose();
                delete this._blur5Shader;
            }
            // this._boxShader.dispose();
        }
        if (this._blur00Tex) {
            delete this._blur00Tex;
            this._blur00FBO.destroy();
            this._blur01FBO.destroy();
            this._blur10FBO.destroy();
            this._blur11FBO.destroy();
            this._blur20FBO.destroy();
            this._blur21FBO.destroy();
            this._blur30FBO.destroy();
            this._blur31FBO.destroy();
            this._blur40FBO.destroy();
            this._blur41FBO.destroy();
            if (this._blur50FBO) {
                this._blur50FBO.destroy();
                this._blur51FBO.destroy();
                this._blur60FBO.destroy();
                this._blur61FBO.destroy();
            }
        }
    }

    _createTextures(tex) {
        if (this._blur00Tex) {
            return;
        }
        let w = tex.width, h = tex.height;

        this._blur00Tex = this._createColorTex(tex, w, h);
        this._blur00FBO = this._createBlurFBO(this._blur00Tex);
        this._blur01Tex = this._createColorTex(tex);
        this._blur01FBO = this._createBlurFBO(this._blur01Tex);

        w = Math.ceil(w / 2);
        h = Math.ceil(h / 2);
        this._blur10Tex = this._createColorTex(tex, w, h);
        this._blur10FBO = this._createBlurFBO(this._blur10Tex);
        this._blur11Tex = this._createColorTex(tex, w, h);
        this._blur11FBO = this._createBlurFBO(this._blur11Tex);

        w = Math.ceil(w / 2);
        h = Math.ceil(h / 2);
        this._blur20Tex = this._createColorTex(tex, w, h);
        this._blur20FBO = this._createBlurFBO(this._blur20Tex);
        this._blur21Tex = this._createColorTex(tex, w, h);
        this._blur21FBO = this._createBlurFBO(this._blur21Tex);

        w = Math.ceil(w / 2);
        h = Math.ceil(h / 2);
        this._blur30Tex = this._createColorTex(tex, w, h);
        this._blur30FBO = this._createBlurFBO(this._blur30Tex);
        this._blur31Tex = this._createColorTex(tex, w, h);
        this._blur31FBO = this._createBlurFBO(this._blur31Tex);

        w = Math.ceil(w / 2);
        h = Math.ceil(h / 2);
        this._blur40Tex = this._createColorTex(tex, w, h);
        this._blur40FBO = this._createBlurFBO(this._blur40Tex);
        this._blur41Tex = this._createColorTex(tex, w, h);
        this._blur41FBO = this._createBlurFBO(this._blur41Tex);

        if (this._level > 5) {
            w = Math.ceil(w / 2);
            h = Math.ceil(h / 2);
            this._blur50Tex = this._createColorTex(tex, w, h);
            this._blur50FBO = this._createBlurFBO(this._blur50Tex);
            this._blur51Tex = this._createColorTex(tex, w, h);
            this._blur51FBO = this._createBlurFBO(this._blur51Tex);

            w = Math.ceil(w / 2);
            h = Math.ceil(h / 2);
            this._blur60Tex = this._createColorTex(tex, w, h);
            this._blur60FBO = this._createBlurFBO(this._blur60Tex);
            this._blur61Tex = this._createColorTex(tex, w, h);
            this._blur61FBO = this._createBlurFBO(this._blur61Tex);
        }

    }

    _createColorTex(curTex, w, h) {
        const regl = this._regl;
        const type = 'uint8';
        const width = w || curTex.width, height = h || curTex.height;
        const color = regl.texture({
            min: 'linear',
            mag: 'linear',
            type,
            width,
            height
        });
        return color;
    }

    _createBlurFBO(tex) {
        const regl = this._regl;
        return regl.framebuffer({
            width: tex.width,
            height: tex.height,
            colors: [tex],
            depth: false,
            stencil: false
        });
    }

    _initShaders() {
        if (!this._blur0Shader) {
            const config = {
                vert: vert$b,
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width : (context, props) => {
                            return props['outputSize'][0];
                        },
                        height : (context, props) => {
                            return props['outputSize'][1];
                        }
                    }
                }
            };

            config.frag = blur0Frag;
            config.wgslFrag = getWGSLSource('gl_blur0_frag');
            config.name = 'blur0';
            this._blur0Shader = new QuadShader(config);
            config.frag = blur1Frag;
            config.wgslFrag = getWGSLSource('gl_blur1_frag');
            config.name = 'blur1';
            this._blur1Shader = new QuadShader(config);
            config.frag = blur2Frag;
            config.wgslFrag = getWGSLSource('gl_blur2_frag');
            config.name = 'blur2';
            this._blur2Shader = new QuadShader(config);
            config.frag = blur3Frag;
            config.wgslFrag = getWGSLSource('gl_blur3_frag');
            config.name = 'blur3';
            this._blur3Shader = new QuadShader(config);
            config.frag = blur4Frag;
            config.wgslFrag = getWGSLSource('gl_blur4_frag');
            config.name = 'blur4';
            this._blur4Shader = new QuadShader(config);

            if (this._level > 5) {
                config.frag = blur5Frag;
                config.wgslFrag = getWGSLSource('gl_blur5_frag');
                config.name = 'blur5';
                this._blur5Shader = new QuadShader(config);

                config.frag = blur6Frag;
                config.wgslFrag = getWGSLSource('gl_blur6_frag');
                config.name = 'blur6';
                this._blur6Shader = new QuadShader(config);
            }

            // this._boxShader = new BoxBlurShader({ blurOffset: 1 });
        }
    }
}

var combineFrag = "precision highp float;\nuniform float bloomFactor;\nuniform float bloomRadius;\nuniform float rgbmRange;\nuniform sampler2D TextureBloomBlur1;\nuniform sampler2D TextureBloomBlur2;\nuniform sampler2D TextureBloomBlur3;\nuniform sampler2D TextureBloomBlur4;\nuniform sampler2D TextureBloomBlur5;\nuniform sampler2D TextureInput;\nuniform sampler2D TextureSource;\nuniform float enableAA;\nuniform vec2 outputSize;\n#define SHADER_NAME bloomCombine\nvec2 c;\n#include <srgb_frag>\nvec3 d(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nfloat h(const float i, const float j) {\n  return mix(i, j * 2. - i, bloomRadius);\n}\nvec4 k() {\n  vec3 l = vec3(.0);\n  const float m = .6;\n  const float n = 1.1;\n  const float o = .9;\n  const float u = .6;\n  const float v = .3;\n  const float A = .1;\n  l += (vec4(d(texture2D(TextureBloomBlur1, c), rgbmRange), 1.)).rgb * h(n, m);\n  l += (vec4(d(texture2D(TextureBloomBlur2, c), rgbmRange), 1.)).rgb * h(o, m);\n  l += (vec4(d(texture2D(TextureBloomBlur3, c), rgbmRange), 1.)).rgb * h(u, m);\n  l += (vec4(d(texture2D(TextureBloomBlur4, c), rgbmRange), 1.)).rgb * h(v, m);\n  l += (vec4(d(texture2D(TextureBloomBlur5, c), rgbmRange), 1.)).rgb * h(A, m);\n  vec4 B;\n  if(enableAA == 1.) {\n    \n  } else {\n    B = texture2D(TextureInput, c);\n  }\n  B.rgb = mix(vec3(.0), B.rgb, sign(B.a));\n  vec4 C = texture2D(TextureSource, c);\n  float D = sqrt((l.r + l.g + l.b) / 3.);\n  vec4 E = vec4(linearTosRGB(l * bloomFactor), D);\n  return B + C * (1. - B.a) + E;\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  gl_FragColor = e;\n}";

class BloomPass {
    constructor(regl) {
        this._regl = regl;
        this._renderer = new Renderer(regl);
    }

    render(sourceTex, bloomTex, bloomThreshold, bloomFactor, bloomRadius, noAaSource, pointSource, enableAA, paintToScreen) {
        this._initShaders();
        this._createTextures(sourceTex);

        //blur
        const blurTexes = this._blurPass.render(bloomTex, bloomThreshold);

        //combine
        const output = this._combine(sourceTex, blurTexes, bloomTex, bloomFactor, bloomRadius, noAaSource, pointSource, enableAA, paintToScreen);

        return output;
    }

    _combine(sourceTex, blurTexes, inputTex, bloomFactor, bloomRadius, noAaSource, pointSource, enableAA, paintToScreen) {
        if (!paintToScreen) {
            if (this._combineTex.width !== sourceTex.width || this._combineTex.height !== sourceTex.height) {
                this._combineFBO.resize(sourceTex.width, sourceTex.height);
            }
        }


        let uniforms = this._combineUniforms;
        const { blurTex0, blurTex1, blurTex2, blurTex3, blurTex4 } = blurTexes;
        if (!uniforms) {
            uniforms = this._combineUniforms = {
                'bloomFactor': 0,
                'bloomRadius': 0,
                'rgbmRange': 7,
                'TextureBloomBlur1': blurTex0,
                'TextureBloomBlur2': blurTex1,
                'TextureBloomBlur3': blurTex2,
                'TextureBloomBlur4': blurTex3,
                'TextureBloomBlur5': blurTex4,
                'TextureInput': null,
                'TextureSource': null,
                'outputSize': [0, 0],
            };
        }
        uniforms['noAaTextureSource'] = noAaSource;
        uniforms['pointTextureSource'] = pointSource;
        uniforms['enableAA'] = enableAA;
        uniforms['bloomFactor'] = bloomFactor;
        uniforms['bloomRadius'] = bloomRadius;
        uniforms['TextureInput'] = inputTex;
        uniforms['TextureSource'] = sourceTex;
        vec2.set(uniforms['outputSize'], sourceTex.width, sourceTex.height);

        const shaderDefines = {};
        if (sourceTex.config && sourceTex.config.sampleCount > 1) {
            shaderDefines['HAS_MULTISAMPLED'] = 1;
        }
        this._combineShader.setDefines(shaderDefines);
        this._renderer.render(this._combineShader, uniforms, null, paintToScreen ? null : this._combineFBO);
        return paintToScreen ? null : this._combineTex;
    }

    dispose() {
        if (this._combineFBO) {
            this._combineFBO.destroy();
            delete this._combineFBO;
        }
        if (this._blurPass) {
            this._blurPass.dispose();
            delete this._blurPass;
        }
        delete this._uniforms;
    }


    _createTextures(tex) {
        if (this._combineTex) {
            return;
        }
        const w = tex.width, h = tex.height;

        this._combineTex = this._createColorTex(tex, w, h, 'uint8');
        this._combineFBO = this._createBlurFBO(this._combineTex);

    }

    _createColorTex(curTex, w, h, dataType) {
        const regl = this._renderer.device;
        const type = dataType;
        const width = w || curTex.width, height = h || curTex.height;
        const color = regl.texture({
            min: 'linear',
            mag: 'linear',
            type,
            width,
            height
        });
        return color;
    }

    _createBlurFBO(tex) {
        const regl = this._renderer.device;
        return regl.framebuffer({
            width: tex.width,
            height: tex.height,
            colors: [tex],
            depth: false,
            stencil: false
        });
    }

    _initShaders() {
        if (!this._combineShader) {
            const viewport = {
                x: 0,
                y: 0,
                width : (context, props) => {
                    return props['outputSize'][0];
                },
                height : (context, props) => {
                    return props['outputSize'][1];
                }
            };
            this._blurPass = new BlurPass(this._regl, false);
            this._combineShader = new QuadShader({
                name: 'bloom-combine',
                vert: vert$b,
                frag: combineFrag,
                wgslVert: getWGSLSource('gl_quad_vert'),
                wgslFrag: getWGSLSource('gl_bloom_combine_frag'),
                extraCommandProps: {
                    viewport
                }
            });
        }
    }
}

var frag$d = "precision highp float;\n#include <gl2_frag>\n#define SHADER_NAME COPY_DEPTH\nuniform sampler2D TextureDepth;\nuniform vec2 textureSize;\n#include <common_pack_float>\nvoid main(void) {\n  vec2 c = gl_FragCoord.xy / textureSize.xy;\n  float d = texture2D(TextureDepth, c).r;\n  glFragColor = common_encodeDepth(d);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

class CopyDepthShader extends QuadShader {
    constructor() {
        const size = [];
        super({
            name: 'copy-depth',
            vert: vert$b, frag: frag$d,
            wgslVert: getWGSLSource('gl_quad_vert'), wgslFrag: getWGSLSource('gl_copy_depth_frag'),
            uniforms: [
                {
                    name: 'textureSize',
                    type: 'function',
                    fn: (context, props) => {
                        size[0] = props['TextureDepth'].width;
                        size[1] = props['TextureDepth'].height;
                        return size;
                    }
                }
            ],
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width : (context, props) => {
                        return props['TextureDepth'].width;
                    },
                    height : (context, props) => {
                        return props['TextureDepth'].height;
                    }
                }
            }
        });
        this.version = 300;
    }

    getMeshCommand(regl, mesh) {
        if (!this.commands['copy_depth']) {
            this.commands['copy_depth'] = this.createMeshCommand(regl, mesh);
        }
        return this.commands['copy_depth'];
    }
}

var quadFrag = "#version 100\nprecision mediump float;\nuniform sampler2D TextureInput;\nuniform vec2 outputSize;\n#define SHADER_NAME QUAD\nvec2 c;\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 d = texture2D(TextureInput, c.xy);\n  gl_FragColor = d;\n}";

class SsrPass {

    static getUniformDeclares() {
        const corners = [[0, 0, 0, 0], [0, 0, 0, 0]];
        const invProjMatrix = new Array(16);
        return [
            {
                name: 'invProjMatrix',
                type : 'function',
                fn : (context, props) => {
                    return mat4.invert(invProjMatrix, props['projMatrix']);
                }
            },
            {
                name: 'outputFovInfo',
                type: 'array',
                length: 2,
                fn: function (context, props) {
                    const cornerY = Math.tan(0.5 * props['fov']);
                    const width = props['outSize'][0];
                    const height = props['outSize'][1];
                    const aspect = width / height;
                    const cornerX = aspect * cornerY;
                    vec4.set(corners[0], cornerX, cornerY, cornerX, -cornerY);
                    vec4.set(corners[1], -cornerX, cornerY, -cornerX, -cornerY);
                    return corners;
                }
            },
            {
                name: 'reprojViewProjMatrix',
                type : 'function',
                fn : (context, props) => {
                    return mat4.multiply([], props['prevProjViewMatrix'], props['cameraWorldMatrix']);
                }
            }
        ];
    }

    static getDefines() {
        return {
            'HAS_SSR': 1
        };
    }

    constructor(regl) {
        this._regl = regl;
        this._renderer = new Renderer(regl);
        this._inputRGBM = 0;
    }

    setup(sourceTex) {
        this._initShaders();
        this._createTextures(sourceTex);
    }

    getSSRUniforms(map, factor, quality) {
        if (!this._depthCopy) {
            return null;
        }
        const depthTex = this._depthCopy;
        const texture = this.getMipmapTexture();
        // const thickness = map.distanceToPoint(50, 0, map.getGLZoom());
        const uniforms = {
            'TextureDepth': depthTex,
            // 'TextureSource': currentTex,
            'TextureReflected': texture,
            'ssrFactor': factor || 1,
            'ssrQuality': quality || 2,
            // 'uPreviousGlobalTexSize': [texture.width, texture.height / 2],
            'outSize': [depthTex.width, depthTex.height],
            // 'uTextureReflectedSize': [texture.width, texture.height],
            'fov': map.getFov() * Math.PI / 180,
            'prevProjViewMatrix': this._projViewMatrix || map.projViewMatrix,
            'cameraWorldMatrix': map.cameraWorldMatrix
            // 'ssrThickness': thickness.x
        };
        return uniforms;
    }

    genMipMap(sourceTex, depthTex, projViewMatrix) {
        this.setup(sourceTex);
        this._mipmap(sourceTex);
        this.copyDepthTex(depthTex);
        if (!this._projViewMatrix) {
            this._projViewMatrix = [];
        }
        mat4.copy(this._projViewMatrix, projViewMatrix);
        delete this._depthCopied;
        return this._outputTex;
    }

    getPrevProjViewMatrix() {
        return this._projViewMatrix;
    }

    copyDepthTex(depthTex) {
        // 说明depth已经在drawSSR阶段复制过了
        if (this._depthCopied) {
            return null;
        }
        this.setup(depthTex);
        if (!this._depthCopy) {
            const info = {
                min: 'nearest',
                mag: 'nearest',
                mipmap: false,
                type: 'uint8',
                width: depthTex.width,
                height: depthTex.height,
            };
            this._depthCopy = this._regl.texture(info);
            const fboInfo = {
                width: depthTex.width,
                height: depthTex.height,
                colors: [this._depthCopy],
                // stencil: true,
                // colorCount,
                colorFormat: 'rgba'
            };
            this._depthCopyFBO = this._regl.framebuffer(fboInfo);
        } else if (depthTex.width !== this._depthCopy.width || depthTex.height !== this._depthCopy.height) {
            this._depthCopyFBO.resize(depthTex.width, depthTex.height);
        }
        const defines = {};
        if (depthTex.texture && depthTex.texture.sampleCount > 1) {
            defines['HAS_MULTISAMPLED'] = 1;
        }
        this._copyDepthShader.setDefines(defines);
        this._renderer.render(this._copyDepthShader, {
            'TextureDepth': depthTex
        }, null, this._depthCopyFBO);
        this._depthCopied = true;
        return this._depthCopy;
    }

    _mipmap(inputTex) {
        const output = this._targetFBO;

        const sizeRatio = 0.5;
        const w = Math.ceil(sizeRatio * inputTex.width);
        const h = Math.ceil(sizeRatio * inputTex.height);
        if (output.width !== w || output.height !== h) {
            output.resize(w, h);
        }

        let uniforms = this._blurUniforms;
        if (!uniforms) {
            uniforms = this._blurUniforms = {
                'rgbmRange': 7,
                'outputSize': [0, 0],
                'inputSize': [0, 0]
            };
        }

        uniforms['TextureInput'] = inputTex;
        uniforms['inputRGBM'] = +this._inputRGBM;
        vec2.set(uniforms['outputSize'], output.width, output.height);
        vec2.set(uniforms['inputSize'], inputTex.width, inputTex.height);
        const defines = {};
        if (inputTex.texture && inputTex.texture.sampleCount > 1) {
            defines['HAS_MULTISAMPLED'] = 1;
        }
        this._ssrQuadShader.setDefines(defines);
        this._renderer.render(this._ssrQuadShader, uniforms, null, output);
    }

    getMipmapTexture() {
        if (!this._outputTex) {
            this._outputTex = this._renderer.regl.texture({
                type: 'uint8',
                width: 2,
                height: 2
            });
        }
        return this._outputTex;
    }

    dispose() {
        if (this._copyDepthShader) {
            this._ssrQuadShader.dispose();
            this._copyDepthShader.dispose();

            this._targetFBO.destroy();

            delete this._copyDepthShader;
        }
        if (this._depthCopy) {
            this._depthCopyFBO.destroy();
            delete this._depthCopy;
            delete this._depthCopyFBO;
        }
    }

    _initShaders() {
        if (!this._copyDepthShader) {
            this._copyDepthShader = new CopyDepthShader();

            const config = {
                name: 'ssr-mipmap-quad',
                frag: quadFrag,
                wgslFrag: getWGSLSource('gl_quad_frag'),
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width : (context, props) => {
                            return props['outputSize'][0];
                        },
                        height : (context, props) => {
                            return props['outputSize'][1];
                        }
                    }
                }
            };
            this._ssrQuadShader = new QuadShader(config);
        }
    }

    _createTextures(sourceTex) {
        if (!this._targetFBO) {
            const regl = this._regl;

            if (this._outputTex) {
                this._outputTex.destroy();
            }

            this._outputTex = regl.texture({
                min: 'linear',
                mag: 'linear',
                type: 'uint8',
                width: sourceTex.width,
                height: sourceTex.height
            });

            this._targetFBO = regl.framebuffer({
                width: sourceTex.width,
                height: sourceTex.height,
                colors: [this._outputTex],
                depth: false,
                stencil: false
            });
        }
    }
}

var vert$9 = "#define SHADER_NAME HEATMAP\nuniform mat4 projViewModelMatrix;\nuniform float extrudeScale;\nuniform float heatmapIntensity;\nattribute vec3 aPosition;\nvarying vec2 vExtrude;\n#ifdef HAS_HEAT_WEIGHT\nattribute highp float aWeight;\nvarying highp float weight;\n#else\nuniform highp float heatmapWeight;\n#endif\nuniform mediump float heatmapRadius;\nconst highp float c = 1. / 255. / 16.;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n  \n#ifdef HAS_HEAT_WEIGHT\nhighp float d = aWeight / 255.;\n  weight = d;\n#else\nhighp float d = heatmapWeight;\n#endif\nmediump float e = heatmapRadius;\n  vec2 f = vec2(mod(aPosition.xy, 2.) * 2. - 1.);\n  float h = sqrt(-2. * log(c / d / heatmapIntensity / GAUSS_COEF)) / 3.;\n  vExtrude = h * f;\n  vec2 i = vExtrude * e * extrudeScale;\n  vec4 j = vec4(floor(aPosition.xy * .5) + i, aPosition.z, 1);\n  gl_Position = projViewModelMatrix * j;\n}";

var frag$c = "#define SHADER_NAME HEATMAP\nprecision mediump float;\nuniform highp float heatmapIntensity;\nvarying vec2 vExtrude;\n#ifdef HAS_HEAT_WEIGHT\nvarying highp float weight;\n#else\nuniform highp float heatmapWeight;\n#endif\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n  \n#ifdef HAS_HEAT_WEIGHT\nhighp float c = weight;\n#else\nhighp float c = heatmapWeight;\n#endif\nfloat d = -.5 * 3. * 3. * dot(vExtrude, vExtrude);\n  float e = c * heatmapIntensity * GAUSS_COEF * exp(d);\n  gl_FragColor = vec4(e, 1., 1., 1.);\n}";

class HeatmapShader extends MeshShader {
    constructor(config) {
        const extraCommandProps = config ? config.extraCommandProps || {} : {};
        const projViewModelMatrix = [];
        super({
            vert: vert$9, frag: frag$c,
            uniforms: [
                {
                    name: 'extrudeScale',
                    type: 'function',
                    fn: function (context, props) {
                        return  props['resolution'] / props['dataResolution'] * props['tileRatio'];
                    }
                },
                {
                    name: 'projViewModelMatrix',
                    type: 'function',
                    fn: function (context, props) {
                        return mat4.multiply(projViewModelMatrix, props['projViewMatrix'], props['modelMatrix']);
                    }
                }
            ],
            extraCommandProps: extend$1({}, extraCommandProps, {
                blend: {
                    enable: true,
                    func: {
                        src: 'one',
                        dst: 'one'
                    },
                    equation: 'add'
                }
            })
        });
    }
}

var skyboxData = {
    vertices : [
        // positions
        -1.0,  1.0, -1.0,
        -1.0, -1.0, -1.0,
        1.0, -1.0, -1.0,
        1.0, -1.0, -1.0,
        1.0,  1.0, -1.0,
        -1.0,  1.0, -1.0,

        -1.0, -1.0,  1.0,
        -1.0, -1.0, -1.0,
        -1.0,  1.0, -1.0,
        -1.0,  1.0, -1.0,
        -1.0,  1.0,  1.0,
        -1.0, -1.0,  1.0,

        1.0, -1.0, -1.0,
        1.0, -1.0,  1.0,
        1.0,  1.0,  1.0,
        1.0,  1.0,  1.0,
        1.0,  1.0, -1.0,
        1.0, -1.0, -1.0,

        -1.0, -1.0,  1.0,
        -1.0,  1.0,  1.0,
        1.0,  1.0,  1.0,
        1.0,  1.0,  1.0,
        1.0, -1.0,  1.0,
        -1.0, -1.0,  1.0,

        -1.0,  1.0, -1.0,
        1.0,  1.0, -1.0,
        1.0,  1.0,  1.0,
        1.0,  1.0,  1.0,
        -1.0,  1.0,  1.0,
        -1.0,  1.0, -1.0,

        -1.0, -1.0, -1.0,
        -1.0, -1.0,  1.0,
        1.0, -1.0, -1.0,
        1.0, -1.0, -1.0,
        -1.0, -1.0,  1.0,
        1.0, -1.0,  1.0
    ]
};

var vert$8 = "#include <gl2_vert>\nattribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nuniform mat3 transformMatrix;\nvarying vec3 vWorldPos;\nvoid main() {\n  vWorldPos = aPosition;\n  mat4 c = mat4(mat3(viewMatrix) * transformMatrix);\n  vec4 d = projMatrix * c * vec4(vWorldPos, 1.);\n  gl_Position = d.xyww;\n}";

var skyboxRawFrag = "#define SHADER_NAME SKYBOX\n#if __VERSION__ == 100\n#ifdef GL_EXT_shader_texture_lod\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\nprecision highp float;\n#define saturate(x)        clamp(x, 0.0, 1.0)\n#include <gl2_frag>\n#include <hsv_frag>\nuniform vec3 hsv;\nvarying vec3 vWorldPos;\n#ifdef USE_AMBIENT\nuniform vec3 diffuseSPH[9];\n#else\nuniform samplerCube cubeMap;\nuniform float bias;\nuniform float size;\n#endif\nuniform float environmentExposure;\nuniform float backgroundIntensity;\nvec4 c(const in samplerCube d, const in vec3 e, const in float f, const in float h) {\n  vec3 i = e;\n  return textureCubeLod(d, i, h);\n}\nvec3 j(const in vec3 k, const in vec3 l[9]) {\n  float x = k.x;\n  float y = k.y;\n  float z = k.z;\n  vec3 m = (l[0] + l[1] * x + l[2] * y + l[3] * z + l[4] * z * x + l[5] * y * z + l[6] * y * x + l[7] * (3. * z * z - 1.) + l[8] * (x * x - y * y));\n  return max(m, vec3(.0));\n}\nfloat n(const in vec2 o) {\n  vec3 u = fract(vec3(o.xyx) * .1031);\n  u += dot(u, u.yzx + 19.19);\n  return fract((u.x + u.y) * u.z);\n}\n#if defined(TONE_MAPPING)\nconst float v = 1.;\nvec3 A(vec3 B) {\n  vec3 a = B * (B + .0245786) - .000090537;\n  vec3 b = B * (.983729 * B + .4329510) + .238081;\n  return a / b;\n}\nvec3 C(vec3 D) {\n  const mat3 E = mat3(vec3(.59719, .07600, .02840), vec3(.35458, .90834, .13383), vec3(.04823, .01566, .83777));\n  const mat3 F = mat3(vec3(1.60475, -.10208, -.00327), vec3(-.53108, 1.10813, -.07276), vec3(-.07367, -.00605, 1.07602));\n  D *= v / .6;\n  D = E * D;\n  D = A(D);\n  D = F * D;\n  return saturate(D);\n}\nvec3 G(vec3 D) {\n  return C(D);\n}\nvec4 H(in vec4 I) {\n  return vec4(mix(pow(I.rgb, vec3(.41666)) * 1.055 - vec3(.055), I.rgb * 12.92, vec3(lessThanEqual(I.rgb, vec3(.0031308)))), I.a);\n}\nvec4 J(vec4 I) {\n  return (H(I));\n}\n#endif\nvoid main() {\n  vec4 K;\n#ifdef USE_AMBIENT\nvec3 k = normalize(vWorldPos + mix(-.5 / 255., .5 / 255., n(gl_FragCoord.xy)) * 2.);\n  K = vec4(j(k, diffuseSPH), 1.);\n#else\nK = c(cubeMap, vWorldPos, size, bias);\n#endif\nK.rgb *= environmentExposure;\n  K.rgb *= backgroundIntensity;\n  glFragColor = K;\n  if(length(hsv) > .0) {\n    glFragColor.rgb = hsv_apply(clamp(glFragColor.rgb, .0, 1.), hsv);\n  }\n#if defined(TONE_MAPPING)\nglFragColor.rgb = G(glFragColor.rgb);\n  glFragColor = J(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

class SkyboxShader extends MeshShader {
    constructor() {
        const config = {
            name: 'skybox',
            vert: vert$8,
            frag: skyboxRawFrag,
            wgslVert: getWGSLSource('gl_skybox_vert'),
            wgslFrag: getWGSLSource('gl_skybox_frag'),
            extraCommandProps: {
                depth: {
                    enable : true,
                    range: [1, 1],
                    func : 'lequal'
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: (_, props) => { return props.resolution[0]; },
                    height: (_, props) => { return props.resolution[1]; },
                }
            }
        };
        super(config);
        this.version = 300;
    }

    /**
    * @param inputRGBM 输入的cubemap是否是rgbm格式
    * @param mode 模式，0： ambient模式， 1: lod模式
    */
    setMode(toneMapping, mode) {
        const defines = {};
        if (toneMapping) {
            defines['TONE_MAPPING'] = 1;
        }
        if (mode === 0) {
            defines['USE_AMBIENT'] = 1;
        }
        if (this._skyboxMesh) {
            this._skyboxMesh[0].setDefines(defines);
        } else {
            this._meshDefines = defines;
        }
        return this;
    }

    draw(regl) {
        if (!this._skyboxMesh) {
            this._createSkyboxMesh(regl);
        }
        return super.draw(regl, this._skyboxMesh);
    }

    _createSkyboxMesh(regl) {
        const geometry = new Geometry(
            {
                aPosition: new Float32Array(skyboxData.vertices)
            },
            null,
            skyboxData.vertices.length / 3
        );
        geometry.generateBuffers(regl);
        this._skyboxMesh = [new Mesh(geometry)];
        if (this._meshDefines) {
            this._skyboxMesh[0].setDefines(this._meshDefines);
            delete this._meshDefines;
        }
    }

    dispose() {
        if (this._skyboxMesh) {
            const mesh = this._skyboxMesh[0];
            mesh.geometry.dispose();
            mesh.dispose();
        }
        delete this._skyboxMesh;
        return super.dispose();
    }
}

var vert$7 = "#define SHADER_NAME HEATMAP_DISPLAY\nuniform mat4 projViewModelMatrix;\nattribute vec3 aPosition;\nvoid main() {\n  gl_Position = projViewModelMatrix * vec4(aPosition, 1.);\n}";

var frag$b = "#define SHADER_NAME HEATMAP_DISPLAY\nprecision mediump float;\nuniform sampler2D inputTexture;\nuniform sampler2D colorRamp;\nuniform vec2 textureOutputSize;\nuniform float heatmapOpacity;\nvoid main() {\n  vec2 c = gl_FragCoord.xy / textureOutputSize.xy;\n  float t = texture2D(inputTexture, c).r;\n  vec4 d = texture2D(colorRamp, vec2(t, .5));\n  gl_FragColor = d * heatmapOpacity;\n}";

class HeatmapDisplayShader extends MeshShader {
    constructor(viewport, config) {
        const extraCommandProps = {
            blend: {
                enable: true,
                func: {
                    src: 'one',
                    dst: 'one minus src alpha'
                },
                equation: 'add'
            },
            viewport
        };
        if (config && config.extraCommandProps) {
            extend$1(extraCommandProps, config.extraCommandProps);
        }
        const projViewModelMatrix = [];
        super({
            vert: vert$7, frag: frag$b,
            uniforms: [
                {
                    name: 'projViewModelMatrix',
                    type: 'function',
                    fn: function (context, props) {
                        return mat4.multiply(projViewModelMatrix, props['projViewMatrix'], props['modelMatrix']);
                    }
                }
            ],
            extraCommandProps
        });
    }
}

var waterVert = "const float c = 3.141592653589793;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nuniform mat4 modelMatrix;\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nattribute vec3 aNormal;\nvarying vec2 vuv;\nvarying vec3 vpos;\nvarying vec3 vnormal;\nvarying mat3 vtbnMatrix;\nvec4 d(mat4 e, mat4 f, vec3 h) {\n  return e * modelMatrix * f * vec4(h, 1.);\n}\nvec3 i(in vec3 h, in vec3 j) {\n  return normalize(h + j);\n}\nmat3 k(in vec3 l) {\n  vec3 t = normalize(cross(vec3(.0, .0, 1.), l));\n  vec3 b = normalize(cross(l, t));\n  return mat3(t, b, l);\n}\nvoid m() {\n  \n}\nvoid main(void) {\n  vuv = aTexCoord;\n  vpos = (modelMatrix * vec4(aPosition, 1.)).xyz;\n  vnormal = aNormal;\n  vtbnMatrix = k(vnormal);\n  gl_Position = d(projMatrix, viewMatrix, vpos);\n  m();\n}";

var waterFrag = "precision highp float;\nprecision highp sampler2D;\nuniform sampler2D texWaveNormal;\nuniform sampler2D texWavePerturbation;\nuniform vec3 octaveTextureRepeat;\nuniform vec4 waveParams;\nuniform vec2 waveDirection;\nuniform vec4 waterColor;\nuniform vec3 lightingDirection;\nuniform vec3 lightingIntensity;\nuniform vec3 camPos;\nuniform float timeElapsed;\nvarying vec2 vuv;\nvarying vec3 vpos;\nvarying vec3 vnormal;\nvarying mat3 vtbnMatrix;\nconst vec2 c = vec2(6. / 25., 5. / 24.);\nvec2 d(sampler2D e, vec2 f) {\n  return 2. * texture2D(e, f).rg - 1.;\n}\nfloat h(vec2 f) {\n  return texture2D(texWavePerturbation, f).b;\n}\nvec3 i(sampler2D e, vec2 f) {\n  return 2. * texture2D(e, f).rgb - 1.;\n}\nfloat j(vec2 f, float k) {\n  return fract(k);\n}\nfloat l(vec2 f, float k) {\n  float m = j(f, k);\n  return 1. - abs(1. - 2. * m);\n}\nvec3 n(sampler2D o, vec2 f, float k, float u) {\n  float v = waveParams[2];\n  float A = waveParams[3];\n  vec2 B = d(o, f) * v;\n  float m = j(f, k + u);\n  float C = l(f, k + u);\n  vec2 D = f;\n  D -= B * (m + A);\n  D += u;\n  D += (k - m) * c;\n  return vec3(D, C);\n}\nconst float E = .3737;\nconst float F = 7.77;\nvec3 G(sampler2D H, sampler2D I, vec2 f, vec2 J, float k) {\n  float K = waveParams[0];\n  vec2 L = k * -J;\n  float M = h(f * E) * F;\n  vec3 N = n(I, f + L, k + M, .0);\n  vec3 O = n(I, f + L, k + M, .5);\n  vec3 P = i(H, N.xy) * N.z;\n  vec3 Q = i(H, O.xy) * O.z;\n  vec3 R = normalize(P + Q);\n  R.xy *= K;\n  R.z = sqrt(1. - dot(R.xy, R.xy));\n  return R;\n}\nvec3 S(vec2 f, float k) {\n  float T = waveParams[1];\n  return G(texWaveNormal, texWavePerturbation, f * T, waveDirection, k);\n}\nconst float U = 3.141592653589793;\nconst float V = 1. / U;\nconst float W = .3183098861837907;\nconst float X = 1.570796326794897;\nstruct PBRShadingWater {\n  float NdotL;\n  float NdotV;\n  float NdotH;\n  float VdotH;\n  float LdotH;\n  float VdotN;\n};\nfloat Y = 2.2;\nvec3 Z(float ba, vec3 bb, float bc) {\n  return bb + (bc - bb) * pow(1. - ba, 5.);\n}\nfloat bd(float be, float bf) {\n  float bg = bf * bf;\n  float bh = be * be;\n  float bi = pow((bh * (bg - 1.) + 1.), Y) * U;\n  return bg / bi;\n}\nfloat bj(float bk) {\n  return .25 / (bk * bk);\n}\nvec3 bl(in PBRShadingWater bm, float bf, vec3 bn, float bo) {\n  vec3 bp = Z(bm.VdotH, bn, bo);\n  float bq = bd(bm.NdotH, bf);\n  float br = bj(bm.LdotH);\n  return (bq * br) * bp;\n}\nvec3 bs(const vec3 x) {\n  return (x * (2.51 * x + .03)) / (x * (2.43 * x + .59) + .14);\n}\nconst float bt = 2.2;\nconst float bu = .4545454545;\nvec4 bv(vec4 bw) {\n  return vec4(pow(bw.rgb, vec3(bu)), bw.w);\n}\nvec3 bx(vec3 bw) {\n  return pow(bw, vec3(bt));\n}\nconst vec3 by = vec3(.02, 1., 5.);\nconst vec2 bz = vec2(.02, .1);\nconst float bf = .06;\nconst vec3 bA = vec3(0, .6, .9);\nconst vec3 bB = vec3(.72, .92, 1.);\nPBRShadingWater bC;\nvec3 bD(in float bE, in vec3 bF, in vec3 bG) {\n  float bH = pow((1. - bE), by[2]);\n  return mix(bG, bF, bH);\n}\nvec3 bI(in vec3 bJ, in vec3 bK, in vec3 bL, vec3 bw, in vec3 bM, in vec3 bN, in float bO) {\n  vec3 bP = bx(bw);\n  vec3 bQ = normalize(bL + bK);\n  bC.NdotL = clamp(dot(bJ, bL), .0, 1.);\n  bC.NdotV = clamp(dot(bJ, bK), .001, 1.);\n  bC.VdotN = clamp(dot(bK, bJ), .001, 1.);\n  bC.NdotH = clamp(dot(bJ, bQ), .0, 1.);\n  bC.VdotH = clamp(dot(bK, bQ), .0, 1.);\n  bC.LdotH = clamp(dot(bL, bQ), .0, 1.);\n  float bR = max(dot(bN, bK), .0);\n  vec3 bS = bx(bB);\n  vec3 bT = bx(bA);\n  vec3 bB = bD(bR, bS, bT);\n  float bU = max(dot(bN, bL), .0);\n  bB *= .1 + bU * .9;\n  float bV = clamp(bO, .8, 1.);\n  vec3 bW = Z(bC.VdotN, vec3(by[0]), by[1]) * bB * bV;\n  vec3 bX = bP * mix(bB, bU * bM * V, 2. / 3.) * bV;\n  vec3 bY = vec3(.0);\n  if(bR > .0 && bU > .0) {\n    vec3 bZ = bl(bC, bf, vec3(bz[0]), bz[1]);\n    vec3 ca = bM * V * bO;\n    bY = bC.NdotL * ca * bZ;\n  }\n  return bs(bW + bX + bY);\n}\nvoid main() {\n  vec3 bN = vnormal;\n  vec3 cb = S(vuv, timeElapsed);\n  vec3 bJ = normalize(vtbnMatrix * cb);\n  vec3 bK = -normalize(vpos - camPos);\n  vec3 bL = normalize(-lightingDirection);\n  float bO = 1.;\n  vec4 cc = vec4(bI(bJ, bK, bL, waterColor.rgb, lightingIntensity, bN, bO), waterColor.w);\n  gl_FragColor = bv(cc);\n}";

class WaterShader extends MeshShader {
    constructor(config = {}) {
        super({
            vert: waterVert,
            frag: waterFrag,
            defines: config.defines || {},
            extraCommandProps: config.extraCommandProps || {}
        });
    }
}

var frag$a = "precision highp float;\nuniform sampler2D texture;\nuniform vec2 size;\nuniform float enableSharpen;\nuniform float sharpFactor;\nuniform float pixelRatio;\nvec2 c;\nvec3 d(const in vec3 e, const float f) {\n  vec2 h = pixelRatio / size.xy;\n  float i = .0;\n  vec4 j = texture2D(texture, c + h * vec2(-1., -1.));\n  j.rgb = mix(vec3(.0), j.rgb, sign(j.a));\n  i += mix(.0, 1., sign(j.a));\n  vec4 k = texture2D(texture, c + h * vec2(1.));\n  k.rgb = mix(vec3(.0), k.rgb, sign(k.a));\n  i += mix(.0, 1., sign(k.a));\n  vec4 l = texture2D(texture, c + h * vec2(1., -1.));\n  l.rgb = mix(vec3(.0), l.rgb, sign(l.a));\n  i += mix(.0, 1., sign(l.a));\n  vec4 m = texture2D(texture, c + h * vec2(-1., 1.));\n  m.rgb = mix(vec3(.0), m.rgb, sign(m.a));\n  i += mix(.0, 1., sign(m.a));\n  return e + f * (i * e - j.rgb - l.rgb - m.rgb - k.rgb);\n}\nvoid main() {\n  c = gl_FragCoord.xy / size;\n  vec4 e = texture2D(texture, c);\n  if(enableSharpen == 1.) {\n    e.rgb = d(e.rgb, sharpFactor);\n  }\n  gl_FragColor = e;\n}";

class CopyShader extends QuadShader {
    constructor() {
        super({
            name: 'copy',
            wgslFrag: getWGSLSource('gl_copy_frag'),
            frag: frag$a,
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (_, props) => {
                        return props['size'][0];
                    },
                    height: (_, props) => {
                        return props['size'][1];
                    }
                }
            }
        });
    }

    getMeshCommand(regl, mesh) {
        const key = this.dkey || '';
        const cmdKey = key + '_copy';
        if (!this.commands[cmdKey]) {
            this.commands[cmdKey] = this.createMeshCommand(regl, mesh);
        }
        return this.commands[cmdKey];
    }
}

var frag$9 = "precision mediump float;\nuniform vec4 lineColor;\nuniform float lineOpacity;\nvoid main() {\n  gl_FragColor = lineColor;\n  gl_FragColor.a *= lineOpacity;\n}";

var vert$6 = "attribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 modelViewMatrix;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n}";

class EdgeShader extends MeshShader {
    constructor(config = {}) {
        const modelViewMatrix = [];
        const extraUniforms = config.uniforms;
        const uniforms = [
            {
                name: 'modelViewMatrix',
                type: 'function',
                fn: function (context, props) {
                    return mat4.multiply(modelViewMatrix, props['viewMatrix'], props['modelMatrix']);
                }
            }
        ];
        if (extraUniforms) {
            uniforms.push(...extraUniforms);
        }
        super({
            vert: vert$6,
            frag: frag$9,
            uniforms,
            defines: config.defines || {},
            extraCommandProps: config.extraCommandProps || {}
        });
    }
}

var frag$8 = "#if __VERSION__ == 100\n#if defined(GL_EXT_shader_texture_lod)\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#if defined(GL_OES_standard_derivatives)\n#extension GL_OES_standard_derivatives : enable\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\n#define saturate(x)        clamp(x, 0.0, 1.0)\nprecision mediump float;\n#include <gl2_frag>\n#include <hsv_frag>\nuniform vec3 hsv;\n#define GET_BASEMAP(UV) (texture2D(baseColorTexture, (UV)))\nuniform mat4 viewMatrix;\nuniform mat4 projMatrix;\nuniform vec3 cameraPosition;\n#if defined(HAS_IBL_LIGHTING)\nuniform mat4 viewMatrixInverse;\n#endif\nuniform vec4 baseColorFactor;\nuniform vec3 emissiveFactor;\nuniform vec3 specularFactor;\nuniform float opacity;\nuniform float envRotationSin;\nuniform float envRotationCos;\nuniform float rgbmRange;\n#if defined(HAS_MAP)\n#include <compute_texcoord_frag>\n#endif\n#ifdef HAS_BASECOLOR_MAP\nuniform sampler2D baseColorTexture;\n#endif\n#ifdef HAS_NORMAL_MAP\nuniform sampler2D normalTexture;\nvec3 c(vec3 d, vec3 e) {\n  vec3 f = dFdx(d.xyz);\n  vec3 h = dFdy(d.xyz);\n  vec3 i = normalize(f - h);\n  vec3 j = normalize(-f + h);\n  vec3 k = normalize(e);\n  vec3 l = texture2D(normalTexture, computeTexCoord(vTexCoord)).rgb * 2. - 1.;\n  mat3 m = mat3(i, j, k);\n  return normalize(m * l);\n}\n#endif\n#ifdef HAS_EMISSIVE_MAP\nuniform sampler2D emissiveTexture;\n#endif\n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\nuniform vec4 diffuseFactor;\n#ifdef HAS_DIFFUSE_MAP\nuniform sampler2D diffuseTexture;\n#endif\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvarying vec4 vColor;\n#endif\n#ifdef GAMMA_INPUT\nvec3 n(vec3 o) {\n  return o * o;\n}\nfloat n(float o) {\n  return o * o;\n}\n#else\nvec3 n(vec3 o) {\n  return o;\n}\nfloat n(float o) {\n  return o;\n}\n#endif\nvec3 u() {\n  \n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nreturn texture2D(specularGlossinessTexture, computeTexCoord(vTexCoord)).rgb;\n#else\nreturn specularFactor;\n#endif\n#else\nreturn specularFactor;\n#endif\n}\nvec3 v() {\n  \n#ifdef HAS_EMISSIVE_MAP\nreturn texture2D(emissiveTexture, computeTexCoord(vTexCoord)).rgb;\n#else\nreturn emissiveFactor;\n#endif\n}\n#if defined(TONEMAP_OUTPUT)\n#if TONEMAP_OUTPUT > 0\nuniform float exposureBias;\nfloat A(vec3 rgb) {\n  return dot(rgb, vec3(.299, .587, .114));\n}\nfloat B(vec3 rgb) {\n  return dot(rgb, vec3(.212671, .715160, .072169));\n}\nvec3 C(vec3 xyz) {\n  vec3 D = vec3(3.240479, -1.53715, -.498535);\n  vec3 E = vec3(-.969256, 1.875992, .041556);\n  vec3 F = vec3(.055648, -.204043, 1.057311);\n  vec3 rgb;\n  rgb.b = dot(xyz, F);\n  rgb.g = dot(xyz, E);\n  rgb.r = dot(xyz, D);\n  return rgb;\n}\nvec3 H(vec3 rgb) {\n  vec3 I = vec3(.412453, .35758, .180423);\n  vec3 J = vec3(.212671, .71516, .0721688);\n  vec3 K = vec3(.0193338, .119194, .950227);\n  vec3 xyz;\n  xyz.x = dot(rgb, I);\n  xyz.y = dot(rgb, J);\n  xyz.z = dot(rgb, K);\n  return xyz;\n}\nvec3 L(vec3 xyz) {\n  float M = xyz.x + xyz.y + xyz.z;\n  M = 1. / M;\n  vec3 O;\n  O.z = xyz.y;\n  O.x = xyz.x * M;\n  O.y = xyz.y * M;\n  return O;\n}\nvec3 P(vec3 O) {\n  float x = O.x;\n  float y = O.y;\n  float J = O.z;\n  vec3 xyz;\n  xyz.y = J;\n  xyz.x = x * (J / y);\n  xyz.z = (1. - x - y) * (J / y);\n  return xyz;\n}\nfloat Q(float x) {\n  float U = pow(x, 1.60525727);\n  float V = ((1.05542877 * 4.68037409) * U) / (4.68037409 * U + 1.);\n  return clamp(V, .0, 1.);\n}\nconst float W = 1. / .18;\nfloat ba(float x) {\n  x *= W;\n  const float bb = .2;\n  const float F = .34;\n  const float bc = .002;\n  const float bd = 1.68;\n  const float be = .0005;\n  const float bf = .252;\n  const float bg = 1. / .833837;\n  return ((x * (bb * x + bc * F) + bd * be) / (x * (bb * x + F) + bd * bf) - be / bf) * bg;\n}\nvec3 bh(vec3 x) {\n  x *= W;\n  const float bb = .27;\n  const float F = .29;\n  const float bc = .052;\n  const float bd = .2;\n  const float bf = .18;\n  const float bg = 1. / .897105;\n  return ((x * (bb * x + bc * F)) / (x * (bb * x + F) + bd * bf)) * bg;\n}\nvec3 bi(vec3 x) {\n  vec3 bj = x.rgb;\n  bj = min(bj, vec3(3.));\n  float bk = B(bj);\n  if(bk > .0) {\n    float bl = Q(bk);\n    bj = bj * (bl / bk);\n    bj = clamp(bj, vec3(.0), vec3(1.));\n  }\n  float bm = 1. / 2.2;\n  bj = pow(bj, vec3(bm));\n  return bj;\n}\n#endif\n#endif\n#if defined(IRR_RGBM) || defined(ENV_RGBM) || defined(ENV_GAMMA) || defined(IRR_GAMMA)\nuniform float envMapExposure;\n#endif\nuniform vec4 themingColor;\nuniform mat3 environmentTransform;\nvec3 bn(vec3 bo, vec3 bp) {\n  \n#if defined(HAS_SHADOWMAP)\nfloat bq = dot(shadowLightDir, bp);\n  float br = (bq + 1.) / 2.;\n  br = min(1., br * 1.5);\n  float bs = 1.;\n  vec3 bt = bo * min(bs, br);\n  return bt;\n#else\nreturn bo;\n#endif\n}\n#ifdef HAS_IBL_LIGHTING\nuniform float reflectivity;\nuniform vec3 hdrHSV;\nuniform samplerCube prefilterMap;\nuniform vec3 diffuseSPH[9];\nuniform vec2 prefilterMiplevel;\nuniform vec2 prefilterSize;\n#else\nuniform vec3 ambientColor;\n#endif\n#if defined(HAS_IBL_LIGHTING)\nvec3 bu(const in vec3 bv) {\n  vec3 bw = environmentTransform * bv;\n  float x = bw.x;\n  float y = bw.y;\n  float z = bw.z;\n  vec3 bt = (diffuseSPH[0] + diffuseSPH[1] * x + diffuseSPH[2] * y + diffuseSPH[3] * z + diffuseSPH[4] * z * x + diffuseSPH[5] * y * z + diffuseSPH[6] * y * x + diffuseSPH[7] * (3. * z * z - 1.) + diffuseSPH[8] * (x * x - y * y));\n  if(length(hdrHSV) > .0) {\n    bt = hsv_apply(bt, hdrHSV);\n  }\n  return max(bt, vec3(.0));\n}\nvec3 bx(const in vec4 by, const in float bz) {\n  if(bz <= .0)\n    return by.rgb;\n  return bz * by.rgb * by.a;\n}\nfloat bA(const in float bB) {\n  return bB;\n}\nvec3 bC(const in float bD, const in vec3 D) {\n  vec3 bE = D;\n  float bF = prefilterMiplevel.x;\n  float bG = min(bF, bA(bD) * prefilterMiplevel.y);\n  vec3 bH = bx(textureCubeLod(prefilterMap, bE, bG), rgbmRange);\n  if(length(hdrHSV) > .0) {\n    return hsv_apply(bH, hdrHSV);\n  } else {\n    return bH;\n  }\n}\nvec3 bI(const in vec3 k, const in vec3 D, const in float bJ) {\n  float bK = 1. - bJ;\n  float bL = bK * (sqrt(bK) + bJ);\n  return mix(k, D, bL);\n}\nvec3 bM(const in vec3 bv, const in vec3 bN, const in float bO, const in vec3 bP) {\n  vec3 D = reflect(-bN, bv);\n  D = bI(bv, D, bO);\n  vec3 bQ = bC(bO, environmentTransform * D);\n  float bR = clamp(1. + dot(D, bP), .0, 1.);\n  bQ *= bR * bR;\n  return bQ;\n}\n#else\nvec3 bM(const in vec3 bv, const in vec3 bN, const in float bO, const in vec3 bP) {\n  return ambientColor;\n}\n#endif\nvarying highp vec3 vViewPosition;\nvec3 bS(vec3 bT, float bU) {\n  float bV = max(1. - bU, .0);\n  return bT + (1. - bT) * pow(bV, 5.);\n}\nfloat bW(float bT, float bU) {\n  float bV = max(1. - bU, .0);\n  return bT + (1. - bT) * pow(bV, 5.);\n}\n#include <srgb_frag>\nvoid main() {\n  glFragColor = vec4(vec3(1.), opacity);\n#ifdef HAS_BASECOLOR_MAP\nvec4 bX = GET_BASEMAP(computeTexCoord(vTexCoord));\n#ifdef GAMMA_INPUT\nbX.xyz *= bX.xyz;\n#endif\nglFragColor = glFragColor * bX;\n#endif\n#ifdef ALPHATEST\nif(glFragColor.a < ALPHATEST)\n    discard;\n  \n#endif\nfloat bY = 1.;\n  vec3 bZ = dFdx(vViewPosition);\n  vec3 ca = dFdy(vViewPosition);\n  vec3 bv = normalize(cross(bZ, ca));\n  vec3 cb;\n  if(projMatrix[3][3] == .0) {\n    cb = normalize(vViewPosition);\n  } else {\n    cb = vec3(.0, .0, 1.);\n  }\n  bv = faceforward(bv, -cb, bv);\n  vec3 cc = bv;\n#ifdef HAS_NORMAL_MAP\nbv = c(-vViewPosition, bv);\n#endif\nvec3 cd = vec3(.0);\n  vec3 ce = vec3(.0);\n#ifdef HAS_IBL_LIGHTING\nvec3 bp = mat3(viewMatrixInverse) * bv;\n  vec3 cf = glFragColor.rgb * bu(bp) * .5;\n  cf = bn(cf, bp);\n  cd += n(baseColorFactor.rgb) * cf;\n#endif\nvec3 cg = v();\n#ifdef METAL\nglFragColor.xyz = glFragColor.xyz * (n(cg) + cd + n(baseColorFactor.rgb) + ce);\n#else\nglFragColor.xyz = glFragColor.xyz * (n(cg) + cd + n(baseColorFactor.rgb)) + ce;\n#endif\nvec3 ch;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat ci = shadow_computeShadow();\n  ch = shadow_blend(ch, ci).rgb;\n#endif\n#ifdef HAS_COLOR\nglFragColor = glFragColor * vColor;\n#endif\nglFragColor.rgb += ch;\n  glFragColor.rgb = linearTosRGB(glFragColor.rgb);\n#if defined(HAS_IBL_LIGHTING)\nvec3 cj;\n#if defined(HAS_NORMAL_MAP)\n#ifdef ENVMAP_MODE_REFLECTION\ncj = reflect(-cb, bv);\n#else\ncj = refract(-cb, bv, 1.);\n#endif\n#else\ncj = reflect(-cb, bv);\n#endif\ncj = mat3(viewMatrixInverse) * cj;\n  float ck = 1.;\n  vec3 cl;\n#ifdef HAS_IBL_LIGHTING\ncl = vec3(.0);\n#elif\ncl = ambientColor;\n#endif\ncl *= ck;\n  float bV = dot(cb, bv);\n  if(bV < -1e-2 || reflectivity == .0)\n    bV = 1.;\n  else\n    bV = max(1e-6, bV);\n  vec3 cm;\n  vec3 cn = u();\n#ifdef METAL\ncm = n(cn);\n#else\ncm = bS(n(cn), bV) * (1. - envRotationSin);\n  glFragColor.a = mix(glFragColor.a, bW(glFragColor.a, bV), reflectivity) * envRotationCos;\n  float co = pow(1. - bV * .5, 5.);\n  float cp = (28. / 23.) * (1. - co) * (1. - co);\n  glFragColor.rgb *= cp * (1. - n(cn));\n#endif\nglFragColor.rgb += cl.rgb * bY * cm.rgb;\n#endif\n#if defined(TONEMAP_OUTPUT)\n#if TONEMAP_OUTPUT == 1\nglFragColor.rgb = bi(exposureBias * glFragColor.rgb);\n#elif TONEMAP_OUTPUT == 2\nglFragColor.rgb = bh(exposureBias * glFragColor.rgb);\n#endif\n#endif\nglFragColor.rgb = mix(glFragColor.rgb, themingColor.rgb, themingColor.a);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

var vert$5 = "precision mediump float;\n#include <gl2_vert>\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\n#ifdef HAS_MAP\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\n#else\nattribute vec4 aColor0;\n#endif\nvarying vec4 vColor;\n#endif\nuniform mat4 projMatrix;\nuniform mat3 modelNormalMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform vec2 halton;\nuniform vec2 outSize;\nuniform mat4 projViewMatrix;\n#include <get_output>\n#include <heatmap_render_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\nvarying vec3 vViewPosition;\nvoid main() {\n  \n#ifdef IS_LINE_EXTRUSION\nvec4 c = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 c = getPosition(aPosition);\n#endif\nmat4 d = getPositionMatrix();\n  mat4 e = projMatrix;\n  e[2].xy += halton.xy / outSize.xy;\n#ifdef HAS_MASK_EXTENT\ngl_Position = e * getMaskPosition(d * c, modelMatrix);\n#else\ngl_Position = e * modelViewMatrix * d * c;\n#endif\nvec4 f = modelViewMatrix * d * c;\n  vViewPosition = -f.xyz;\n#ifdef HAS_MAP\nvec2 h = decode_getTexcoord(aTexCoord);\n  vTexCoord = h * uvScale + uvOffset;\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvColor = vec4(aColor0 / 255., 1.);\n#else\nvColor = aColor0 / 255.;\n#endif\n#endif\n}";

const TEMP_MAT4$1 = [];
const environmentTransform = [];
class StandardLiteShader extends MeshShader {
    constructor(config = {}) {
        const modelViewMatrix = [];
        const extraUniforms = config.uniforms;
        const uniforms = [
            {
                name: 'viewMatrixInverse',
                type: 'function',
                fn: (_, props) => {
                    return mat4.invert(TEMP_MAT4$1, props['viewMatrix']);
                }
            },
            {
                name: 'modelViewMatrix',
                type: 'function',
                fn: function (context, props) {
                    return mat4.multiply(modelViewMatrix, props['viewMatrix'], props['modelMatrix']);
                }
            },
            {
                name: 'environmentTransform',
                type: 'function',
                fn: (_, props) => {
                    const orientation = props['environmentOrientation'] || 0;
                    return mat3.fromRotation(environmentTransform, Math.PI * orientation / 180);
                }
            }
        ];
        if (extraUniforms) {
            uniforms.push(...extraUniforms);
        }
        super({
            vert: vert$5,
            frag: frag$8,
            uniforms,
            defines: config.defines || {},
            extraCommandProps: config.extraCommandProps || {}
        });
        this.version = 300;
    }
}

var frag$7 = "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\nuniform sampler2D sceneMap;\nuniform sampler2D scanEffectMap;\nvoid main() {\n  vec4 c = texture2D(sceneMap, vTexCoord);\n  vec4 d = texture2D(scanEffectMap, vTexCoord);\n  glFragColor = c + d;\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

class EffectShader extends QuadShader {
    constructor() {
        super({
            vert: vert$b, frag: frag$7,
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (context, props) => {
                        return props['resolution'][0];
                    },
                    height: (context, props) => {
                        return props['resolution'][1];
                    }
                }
            }
        });
    }
}

var mixVert = "attribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nvarying vec4 vWorldPosition;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  vec4 e = modelMatrix * d * c;\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n  vWorldPosition = e;\n}";

var mixFrag = "precision mediump float;\nvarying vec4 vWorldPosition;\nuniform vec2 fogDist;\nuniform vec3 cameraPosition;\nuniform float rainDepth;\nvoid main() {\n  vec3 c = vec3(vWorldPosition[0] - cameraPosition[0], vWorldPosition[1] - cameraPosition[1], vWorldPosition[2] - cameraPosition[2]);\n  float d = length(c);\n  float e = clamp(1. - (d - fogDist.x) / (fogDist.y - fogDist.x), .0, 1.);\n  if(vWorldPosition[2] < rainDepth) {\n    gl_FragColor = vec4(e, .0, .0, 1.);\n  } else {\n    gl_FragColor = vec4(e, 1., .0, 1.);\n  }\n}";

const modelViewMatrix$4 = [];
class FogPass{
    constructor(regl, viewport, layer) {
        this._regl = regl;
        this._layer = layer;
        this._viewport = viewport;
        this._init();
    }

    _init() {
        this._shader = new MeshShader({
            name: 'fog_mixFactor',
            vert: mixVert,
            frag: mixFrag,
            wgslVert: getWGSLSource('gl_fog_mixFactor_vert'),
            wgslFrag: getWGSLSource('gl_fog_mixFactor_frag'),
            uniforms: [
                {
                    name: 'modelViewMatrix',
                    type: 'function',
                    fn: function (context, props) {
                        return mat4.multiply(modelViewMatrix$4, props['viewMatrix'], props['modelMatrix']);
                    }
                }
            ],
            extraCommandProps: {
                viewport: this._viewport
            }
        });
        const layerRenderer = this._layer.getRenderer();
        const info = layerRenderer.createFBOInfo();
        this._fbo = this._regl.framebuffer(info);
        this._scene = new Scene();
        this.renderer = new Renderer(this._regl);
    }

    render(meshes, options) {
        this._resize();
        this.renderer.clear({
            color : [0, 0, 0, 1],
            depth : 1,
            framebuffer : this._fbo
        });
        this._scene.setMeshes(meshes);
        const uniforms = {
            projMatrix: options.projMatrix,
            viewMatrix: options.viewMatrix,
            cameraPosition: options.cameraPosition,
            fogDist: options.fogDist,
            rainDepth: options.rainDepth
        };
        this.renderer.render(
            this._shader,
            uniforms,
            this._scene,
            this._fbo
        );
        return this._fbo;
    }

    dispose() {
        if (this._fbo) {
            this._fbo.destroy();
        }
        if (this._shader) {
            this._shader.dispose();
        }
    }

    _resize() {
        const width = isFunction$1(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width;
        const height = isFunction$1(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        if (this._fbo && (this._fbo.width !== width || this._fbo.height !== height)) {
            this._fbo.resize(width, height);
        }
    }

}

var frag$6 = "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\n#ifdef HAS_RAIN\nuniform sampler2D ripplesMap;\n#endif\n#ifdef HAS_SNOW\nuniform sampler2D normalMap;\n#endif\n#ifdef HAS_FOG\nuniform vec3 fogColor;\n#endif\nuniform sampler2D sceneMap;\nuniform sampler2D mixFactorMap;\nuniform float time;\nuniform vec2 resolution;\nuniform float snowIntensity;\nfloat c(float a, float b, float w) {\n  return a + w * (b - a);\n}\n#define HASHSCALE1 .1031\n#define HASHSCALE3 vec3(.1031, .1030, .0973)\n#define HASHSCALE4 vec3(.1031, .1030, .0973, .1099)\nfloat d = .5;\nfloat e = .2;\nfloat f = .5;\nfloat h = 20.;\nfloat i(float p) {\n  vec3 j = fract(vec3(p) * HASHSCALE1);\n  j += dot(j, j.yzx + 19.19);\n  return fract((j.x + j.y) * j.z);\n}\nvec2 k(vec2 p) {\n  vec3 j = fract(vec3(p.xyx) * HASHSCALE3);\n  j += dot(j, j.yzx + 19.19);\n  return fract((j.xx + j.yz) * j.zy);\n}\nvec2 l(vec2 m) {\n  float x = fract(sin(dot(m.xy, vec2(122.9898, 783.233))) * 43758.5453);\n  float y = fract(sin(dot(m.xy, vec2(457.6537, 537.2793))) * 37573.5913);\n  return vec2(x, y);\n}\nvec3 n(vec2 o, float u) {\n  vec3 v = vec3(.0);\n  o = o * (2. + u);\n  float A = e * snowIntensity;\n  float B = o.y * (((i(u) * 2. - 1.) * .5 + 1.) * A);\n  float C = (f * time);\n  o += vec2(B, C);\n  vec2 D = k(floor(o) + 31.1759 * u);\n  o = fract(o);\n  o -= (D * 2. - 1.) * .35;\n  o -= .5;\n  float r = length(o);\n  float E = .05 * (1. + .3 * sin(time * d));\n  float F = smoothstep(E, -E, r);\n  vec3 G = vec3(F) * D.x;\n  return G;\n}\nvec3 H() {\n  vec3 v = vec3(0);\n  vec2 o = gl_FragCoord.xy / resolution.xy;\n  o *= vec2(resolution.x / resolution.y, 1.);\n  float I = h * snowIntensity;\n  for(float J = 0.; J < I; J++) {\n    v += n(o, J);\n  }\n  return v;\n}\nvec3 K(vec4 L, vec4 M, float N) {\n  float O = M.b;\n  vec3 P = vec3(1.);\n  if(N < 1.) {\n    float r = c(.5, P.x, O);\n    float g = c(.5, P.y, O);\n    float b = c(.5, P.z, O);\n    return vec3(r, g, b);\n  } else {\n    float r = c(L.r, P.x, O);\n    float g = c(L.g, P.y, O);\n    float b = c(L.b, P.z, O);\n    return vec3(r, g, b);\n  }\n}\nvoid main() {\n  vec4 L = texture2D(sceneMap, vTexCoord);\n  glFragColor = L;\n  vec4 Q = texture2D(mixFactorMap, vTexCoord);\n#ifdef HAS_RAIN\nvec4 R = texture2D(ripplesMap, vTexCoord);\n  if(Q.g < 1.) {\n    L = mix(L, R, .4);\n  }\n  glFragColor = L;\n#endif\n#ifdef HAS_SNOW\nvec3 S = H();\n  glFragColor = vec4(L.rgb + S, L.a);\n#endif\n#ifdef HAS_FOG\nfloat T = Q.r;\n  vec3 U = mix(fogColor, glFragColor.rgb, T);\n  glFragColor = vec4(U, L.a);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

class FogShader extends QuadShader {
    constructor() {
        super({
            name: 'weather',
            frag: frag$6,
            wgslFrag: getWGSLSource('gl_fog_frag'),
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (context, props) => {
                        return props['resolution'][0];
                    },
                    height: (context, props) => {
                        return props['resolution'][1];
                    }
                }
            }
        });
    }

    // getMeshCommand(regl, mesh) {
    //     const key = this.dkey || '';
    //     if (!this.commands[key + '_fxaa']) {
    //         this.commands[key + '_fxaa'] = this.createMeshCommand(
    //             regl,
    //             null,
    //             mesh.getElements()
    //         );
    //     }
    //     return this.commands[key + '_fxaa'];
    // }
}

var ripplesVert = "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nvarying vec2 vTexCoord;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n  vTexCoord = aTexCoord;\n}";

var ripplesFrag = "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\nuniform float rippleRadius;\nuniform float density;\nuniform float time;\nvec3 c(vec2 p) {\n  vec3 q = vec3(dot(p, vec2(127.1, 311.7)), dot(p, vec2(269.5, 183.3)), dot(p, vec2(419.2, 371.9)));\n  return fract(sin(q) * 43758.5453);\n}\nfloat d(in vec2 x) {\n  vec2 e = x * density / 4000.0;\n  vec2 p = floor(e);\n  vec2 f = fract(e);\n  float h = .0;\n  for(int i = -4; i <= 4; i++)\n    for(int k = -4; k <= 4; k++) {\n      vec2 g = vec2(float(k), float(i));\n      vec3 l = c(p + g);\n      vec2 r = g - f + l.xy;\n      float m = sqrt(dot(r, r));\n      float n = max(mix(smoothstep(.99, .999, max(cos(m - time * 2. + (l.x + l.y) * 5.), 0.)), 0., m), 0.);\n      h += n;\n    }\n  return h;\n}\nvoid main() {\n  vec2 u = vTexCoord;\n  float A = 24. / (rippleRadius * .01);\n  float f = d(A * u) * smoothstep(.0, .4, sin(u.x * 3.151592) * sin(u.y * 3.141592));\n  vec3 B = vec3(-dFdx(f), -dFdy(f), -dFdy(f));\n  glFragColor = vec4(B, 1.);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

const modelViewMatrix$3 = [];
const DEFALUT_SCALE$2 = [0.03, 0.03, 0.03];
const TEMP_ROTATE$2 = [], TEMP_SCALE$2 = [], TEMP_MAT$2 = [], DEFAULT_ZOOM$3 = 16.685648411389433;
const Y_UP_TO_Z_UP$2 = mat4.fromRotationTranslation([], quat.fromEuler([], 90, 0, 0), [0, 0, 0]);
class RainRipplePass {
    constructor(regl, viewport) {
        this._regl = regl;
        this._viewport = viewport;
        this._init();
    }

    _init() {
        this._shader = new MeshShader({
            name: 'ripples',
            vert: ripplesVert,
            frag: ripplesFrag,
            wgslVert: getWGSLSource('gl_ripples_vert'),
            wgslFrag: getWGSLSource('gl_ripples_frag'),
            uniforms: [
                {
                    name: 'modelViewMatrix',
                    type: 'function',
                    fn: function (context, props) {
                        return mat4.multiply(modelViewMatrix$3, props['viewMatrix'], props['modelMatrix']);
                    }
                }
            ],
            extraCommandProps: {
                viewport: this._viewport
            },
        });
        this._shader.version = 300;
        this._fbo = this._regl.framebuffer({
            color: this._regl.texture({
                width: this._viewport.width(),
                height: this._viewport.height(),
                wrap: 'clamp',
                mag : 'linear',
                min : 'linear'
            }),
            depth: true
        });
        this._scene = new Scene();
        this.renderer = new Renderer(this._regl);
    }

    _transformRipples(map) {
        const center = map.coordinateToPointAtRes(map.getCenter(), map.getGLRes());
        const ratio = map.getGLScale() / map.getGLScale(this._fixZoom);
        const v3 = vec3.set(TEMP_SCALE$2, ratio, ratio, ratio);
        const scale = vec3.multiply(v3, DEFALUT_SCALE$2, v3);
        const transformat = mat4.identity(TEMP_MAT$2);
        mat4.fromRotationTranslationScale(transformat, quat.fromEuler(TEMP_ROTATE$2, 0, 0, 0), [center.x, center.y, 0], scale);
        mat4.multiply(transformat, transformat, Y_UP_TO_Z_UP$2);
        this._mesh.setLocalTransform(transformat);
    }

    _createRipplesMask(map) {
        this._fixZoom = map.getZoom();
        const pos = Math.pow(2, DEFAULT_ZOOM$3 - this._fixZoom) * 800;
        const vertices = [
            -pos, 0, -pos,
            pos, 0, -pos,
            -pos, 0, pos,
            pos, 0, pos,
        ];
        const normals = [
            0, 1, 0,
            0, 1, 0,
            0, 1, 0,
            0, 1, 0
        ];
        const uvs = [
            0.0, 0.0,
            1.0, 0.0,
            0.0, 1.0,
            1.0, 1.0
        ];
        const indices = [
            3, 1, 0, 0, 2, 3
        ];

        const attributes = {};
        attributes['POSITION'] = vertices;
        attributes['NORMAL'] = normals;
        attributes['TEXCOORD_0'] = uvs;
        const geometry = new Geometry(
            attributes,
            indices,
            0,
            {
                positionAttribute: 'POSITION',
                normalAttribute: 'NORMAL',
                uv0Attribute: 'TEXCOORD_0'
            }
        );
        geometry.generateBuffers(this._regl);
        const material = new Material();
        const mesh = new Mesh(geometry, material);
        return mesh;
    }


    render(map, options) {
        this._resize();
        this.renderer.clear({
            color : [0, 0, 0, 1],
            depth : 1,
            framebuffer : this._fbo
        });
        this._mesh = this._mesh || this._createRipplesMask(map);
        this._scene.setMeshes(this._mesh);
        this._transformRipples(map);
        const uniforms = {
            projMatrix: options.projMatrix,
            viewMatrix: options.viewMatrix,
            time: options.time,
            rippleRadius: options.rippleRadius,
            density: options.density
        };
        this.renderer.render(
            this._shader,
            uniforms,
            this._scene,
            this._fbo
        );
        return this._fbo;
    }

    dispose() {
        if (this._fbo) {
            this._fbo.destroy();
        }
        if (this._shader) {
            this._shader.dispose();
        }
    }

    _resize() {
        const width = isFunction$1(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width;
        const height = isFunction$1(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        if (this._fbo && (this._fbo.width !== width || this._fbo.height !== height)) {
            this._fbo.resize(width, height);
        }
    }
}

var vert$4 = "attribute vec3 aPosition;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\n#ifdef HAS_TEXTURE\nattribute vec2 aTexCoord;\nvarying vec2 uv;\nvarying vec4 vPos;\n#endif\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n  vec4 d = c * getPosition(aPosition);\n  gl_Position = projViewModelMatrix * d;\n#ifdef HAS_TEXTURE\nuv = aTexCoord;\n  vPos = getPosition(aPosition);\n#endif\n}";

var maskColorExtent = "#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec4 maskColor;\n#ifdef HAS_TEXTURE\nuniform sampler2D maskTexture;\nvarying vec2 uv;\nuniform vec3 mask_position0;\nuniform vec3 mask_position1;\nuniform vec3 mask_position2;\nuniform vec3 mask_position3;\nvarying vec4 vPos;\nvec2 c(vec2 d, vec2 a, vec2 b, vec2 e, vec2 f) {\n  vec2 h = vec2(.5);\n  for(int i = 0; i < 10; i++) {\n    float j = h.x;\n    float k = h.y;\n    vec2 l = (1. - j) * (1. - k) * a + j * (1. - k) * b + j * k * e + (1. - j) * k * f;\n    vec2 m = d - l;\n    if(length(m) < .001)\n      break;\n    vec2 n = -(1. - k) * a + (1. - k) * b + k * e - k * f;\n    vec2 o = -(1. - j) * a - j * b + j * e + (1. - j) * f;\n    float A = n.x * o.y - n.y * o.x;\n    if(abs(A) > .0001) {\n      vec2 B = vec2((m.x * o.y - m.y * o.x) / A, (m.y * n.x - m.x * n.y) / A);\n      h += B;\n    }\n    h = clamp(h, .0, 1.);\n  }\n  return h;\n}\n#endif\nvoid main() {\n  \n#ifdef HAS_TEXTURE\nvec2 d = vPos.xy;\n  vec2 C = c(d, mask_position0.xy, mask_position1.xy, mask_position2.xy, mask_position3.xy);\n  gl_FragColor = texture2D(maskTexture, C);\n  gl_FragColor.a *= maskColor.a;\n#else\nif(maskColor.a == .0) {\n    discard;\n  }\n  gl_FragColor = maskColor;\n#endif\n}";

var maskModeExtent = "#ifdef GL_ES\nprecision highp float;\n#endif\nuniform float maskMode;\n#ifdef HAS_MASK_FLAT\nuniform float flatHeight;\n#endif\n#ifdef HAS_MASK_COLOR\nuniform vec2 heightRange;\n#endif\nvoid main() {\n  \n#if defined(HAS_MASK_FLAT)\ngl_FragColor = vec4(maskMode, flatHeight, .0, 1.);\n#elif defined(HAS_MASK_COLOR)\ngl_FragColor = vec4(maskMode, .0, heightRange.x, heightRange.y);\n#else\ngl_FragColor = vec4(maskMode, .0, .0, .0);\n#endif\n}";

const CLEAR_COLOR$1 = [0, 0, 0, 1];
class ExtentPass {
    constructor(regl, viewport) {
        this.regl = regl;
        this._viewport = viewport;
        this.renderer = new Renderer(regl);
        this._init();
    }

    _init() {
        this._maskColorFbo = this.renderer.device.framebuffer({
            color: this.renderer.device.texture({
                width: 1,
                height: 1,
                wrap: 'clamp',
                mag : 'linear',
                min : 'linear'
            }),
            depth: true
        });
        this._maskModeFbo = this.renderer.device.framebuffer({
            color: this.renderer.device.texture({
                width: 1,
                height: 1,
                wrap: 'clamp',
                mag : 'nearest', //采用nearest采样，避免因linear造成的边界附近产生空隙
                min : 'nearest'
            }),
            depth: true
        });
        const uniforms = [
            {
                name: 'projViewModelMatrix',
                type: 'function',
                fn: (context, props) => {
                    return mat4.multiply([], props['projViewMatrix'], props['modelMatrix']);
                }
            }
        ];
        this._maskColorShader = new MeshShader({
            vert: vert$4,
            frag: maskColorExtent,
            uniforms,
            extraCommandProps: {
                viewport: this._viewport,
                depth : {
                    enable : true,
                    func : 'lequal'
                }
            }
        });
        this._maskModeShader = new MeshShader({
            vert: vert$4,
            frag: maskModeExtent,
            uniforms,
            extraCommandProps: {
                viewport: this._viewport,
            }
        });
        this._scene = new Scene();
    }

    render(meshes, projViewMatrix) {
        this._resize();
        this.renderer.clear({
            color : CLEAR_COLOR$1,
            depth : 1,
            framebuffer : this._maskColorFbo
        });
        this.renderer.clear({
            color : CLEAR_COLOR$1,
            depth : 1,
            framebuffer : this._maskModeFbo
        });
        this._scene.setMeshes(meshes);
        const uniforms = {
            projViewMatrix
        };
        this.renderer.render(
            this._maskColorShader,
            uniforms,
            this._scene,
            this._maskColorFbo
        );
        this.renderer.render(
            this._maskModeShader,
            uniforms,
            this._scene,
            this._maskModeFbo
        );
        return { colorExtent: this._maskColorFbo, modeExtent: this._maskModeFbo };
    }

    _resize() {
        const width = isFunction$1(this._viewport.width) ? this._viewport.width() : this._viewport.width.data();
        const height = isFunction$1(this._viewport.height) ? this._viewport.height() : this._viewport.height.data();
        if (this._maskColorFbo && (this._maskColorFbo.width !== width || this._maskColorFbo.height !== height)) {
            this._maskColorFbo.resize(width, height);
            this._maskModeFbo.resize(width, height);
        }
    }

    dispose() {
        if (this._maskColorFbo) {
            this._maskColorFbo.destroy();
            delete this._maskColorFbo;
        }
        if (this._maskModeFbo) {
            this._maskModeFbo.destroy();
            delete this._maskModeFbo;
        }
        if (this._maskColorShader) {
            this._maskColorShader.dispose();
            delete this._maskColorShader;
        }
        if (this._maskModeShader) {
            this._maskModeShader.dispose();
            delete this._maskModeShader;
        }
    }
}

// import vert from './scaneffect.vert';
// import frag from './scaneffect.frag';
const vert$3 = `#include <gl2_vert>
#define SHADER_NAME SCANEFFECT
precision highp float;
attribute vec3 aPosition;
uniform mat4 projMatrix;
uniform mat4 modelMatrix;
uniform mat4 modelViewMatrix;
uniform mat4 positionMatrix;
#include <line_extrusion_vert>
#include <get_output>
varying vec4 vWorldPosition;
void main()
{
    mat4 localPositionMatrix = getPositionMatrix();
    #ifdef IS_LINE_EXTRUSION
        vec3 linePosition = getLineExtrudePosition(aPosition);
        //linePixelScale = tileRatio * resolution / tileResolution
        vec4 localVertex = getPosition(linePosition);
    #else
        vec4 localVertex = getPosition(aPosition);
    #endif
    vec4 worldPosition = modelMatrix * localPositionMatrix * localVertex;
    vWorldPosition = worldPosition;
    gl_Position = projMatrix * modelViewMatrix * localPositionMatrix * localVertex;
}
`;
const frag$5 = `
#ifdef GL_ES
  precision highp float;
#endif
uniform mat3 ring;

uniform float effectTime;
varying vec4 vWorldPosition;

vec3 hsb2rgb(in vec3 c) {
    vec3 rgb = clamp(abs(mod(c.x * 6.0 + vec3(0.0,4.0,2.0), 6.0)-3.0)-1.0, 0.0, 1.0 );
    rgb = rgb*rgb*(3.0-2.0*rgb);
    return c.z * mix( vec3(1.0), rgb, c.y);
}

vec4 glowring(vec4 worldPos, vec2 center, float radius, float speed, vec3 effectColor, float direction, float height) {
  vec2 dir = vec2(worldPos.xy) - center;
  float len = length(dir);
  if (len > radius) {
    return vec4(0.0);
  } else {
    vec2 uv = vec2(0.0);
    if (direction == 0.0) {
      vec2 lefttop = vec2(center.x - radius, center.y + radius);
      vec2 rightbottom = vec2(center.x + radius, center.y - radius);
      uv = vec2(abs(worldPos.x - lefttop.x) / (2.0 * radius), abs(worldPos.y - rightbottom.y) / (2.0 * radius));
      uv.x -= 0.5;
      uv.y -= 0.5;
    } else {
      if (worldPos.z < 0.1) {
        return vec4(0.0);
      }
      uv = vec2(0.0, worldPos.z / height);
    }
    float itime = (effectTime / 2.0) * speed;
    float r = length(uv) * 3.0;
    vec3 color = hsb2rgb(effectColor);

    float a = pow(r, 2.0);
    float b = sin(r * 0.8 - 1.6);
    float c = sin(r - 0.010);
    float s = sin(a - itime * 3.0 + b) * c;
    float t = abs(1.0 / (s * 10.8)) - 0.01;
    color *= t;
    vec4 newColor = vec4(color, t);
    return newColor;
  }
}

void main() {
    vec4 color = vec4(0.0);
    gl_FragColor = color;
}
`;
const modelViewMatrix$2 = [];
class ScanEffectPass {
    constructor(regl, viewport, layer) {
        this._regl = regl;
        this._layer = layer;
        this._viewport = viewport;
        this._init();
        this._effectsLength = 0;
    }

    _init() {
        const layerRenderer = this._layer.getRenderer();
        const info = layerRenderer.createFBOInfo();
        this._fbo = this._regl.framebuffer(info);
        this._scene = new Scene();
        this.renderer = new Renderer(this._regl);
    }

    render(meshes, options) {
        this._resize();
        this.renderer.clear({
            color : [0, 0, 0, 1],
            depth : 1,
            framebuffer : this._fbo
        });
        this._scene.setMeshes(meshes);
        const effectInfos = options.effectInfos;
        if (!this._shader || effectInfos.length !== this._effectsLength) { //数量发生变化
            if (this._shader) {
                this._shader.dispose();
            }
            const fragStr = this._createFragSource(effectInfos);
            this._shader = new MeshShader({
                vert: vert$3,
                frag: fragStr,
                uniforms: [
                    {
                        name: 'modelViewMatrix',
                        type: 'function',
                        fn: function (context, props) {
                            return mat4.multiply(modelViewMatrix$2, props['viewMatrix'], props['modelMatrix']);
                        }
                    }
                ],
                extraCommandProps: {
                    viewport: this._viewport
                }
            });
            this._effectsLength = effectInfos.length;
        }
        const uniforms = {
            projMatrix: options.projMatrix,
            viewMatrix: options.viewMatrix,
            effectTime: options.effectTime,
            minAltitude: 0
        };
        this._updateUniforms(uniforms, effectInfos);
        this.renderer.render(
            this._shader,
            uniforms,
            this._scene,
            this._fbo
        );
        return this._fbo;
    }

    _createFragSource(effectInfos) {
        let fragStr = ``;
        for (let i = 0; i < effectInfos.length; i++) {
            fragStr += `uniform mat3 ring${i};\n`;
        }
        fragStr = frag$5.replace('uniform mat3 ring;', fragStr);
        let colorStr =``;
        for (let i = 0; i < effectInfos.length; i++) {
            colorStr += `
                vec2 center${i} = vec2(ring${i}[0][0], ring${i}[0][1]);
                float radius${i} = ring${i}[0][2];
                float speed${i} = ring${i}[1][0];
                vec3 color${i} = vec3(ring${i}[1][1], ring${i}[1][2], ring${i}[2][0]);
                float direction${i} = ring${i}[2][1];
                float height${i} = ring${i}[2][2];
                vec4 ringColor${i} = glowring(vWorldPosition, center${i}, radius${i}, speed${i}, color${i}, direction${i}, height${i});
                color += ringColor${i};
            `;
        }
        colorStr += 'gl_FragColor = color;';
        fragStr = fragStr.replace('gl_FragColor = color;', colorStr);
        return fragStr;
    }

    _updateUniforms(uniforms, effectInfos) {
        for (let i = 0; i < effectInfos.length; i++) {
            uniforms[`ring${i}`] = effectInfos[i];
        }
    }

    dispose() {
        if (this._fbo) {
            this._fbo.destroy();
        }
        if (this._shader) {
            this._shader.dispose();
        }
    }

    _resize() {
        const width = isFunction$1(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width;
        const height = isFunction$1(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        if (this._fbo && (this._fbo.width !== width || this._fbo.height !== height)) {
            this._fbo.resize(width, height);
        }
    }

}

const globalWorldInverse = [];


const TEX_INFO = {
    width: 4,
    type: 'float'
};
class Skin {
    constructor(regl, joints, inverseBindMatrixData) {
        this._regl = regl;
        this.joints = joints;
        this.inverseBindMatrices = [];
        this.jointMatrices = [];
        this.jointData = new Float32Array(joints.length * 16);
        for (let i = 0; i < joints.length; ++i) {
            this.inverseBindMatrices.push(new Float32Array(
                inverseBindMatrixData.buffer,
                inverseBindMatrixData.byteOffset + Float32Array.BYTES_PER_ELEMENT * 16 * i,
                16));
            this.jointMatrices.push(new Float32Array(
                this.jointData.buffer,
                Float32Array.BYTES_PER_ELEMENT * 16 * i,
                16));
        }
        this.jointTextureSize = [4, 6];
    }

    update(nodeMatrix, nodeMatrixMap, joinTexture) {
        mat4.invert(globalWorldInverse, nodeMatrix);
        for (let j = 0; j < this.joints.length; ++j) {
            const joint = this.joints[j];
            const dst = this.jointMatrices[j];
            mat4.multiply(dst, globalWorldInverse, nodeMatrixMap[joint.nodeIndex]);
            mat4.multiply(dst, dst, this.inverseBindMatrices[j]);
        }
        // const type = this._regl.hasExtension('OES_texture_half_float') ? 'float16' : 'float';
        TEX_INFO.height = this.joints.length;
        TEX_INFO.data = this.jointData;
        const texInfo = TEX_INFO;
        if (!joinTexture) {
            joinTexture = this._regl.texture(texInfo);
        } else {
            joinTexture(texInfo);
        }
        return joinTexture;
    }
}

const EMPTY_TRANS = [0, 0, 0], EMPTY_ROTATION = [0, 0, 0, 1], EMPTY_SCALE = [1, 1, 1], EMPTY_MAT$1 = [];
class TRS {
    constructor(translation = [0, 0, 0], rotation = [0, 0, 0, 1], scale = [1, 1, 1]) {
        this.translation = translation;
        this.rotation = rotation;
        this.scale = scale;
    }

    getMatrix() {
        return mat4.fromRotationTranslationScale(EMPTY_MAT$1, this.rotation, this.translation, this.scale);
    }

    decompose(matrix) {
        mat4.getTranslation(this.translation, matrix);
        mat4.getRotation(this.rotation, matrix);
        mat4.getScaling(this.scale, matrix);
    }

    update(animation) {
        if (!animation) {
            return;
        }
        if (animation.translation && !vec3.equals(animation.translation, EMPTY_TRANS)) {
            vec3.copy(this.translation, animation.translation);
        }
        if (animation.rotation && !quat.equals(animation.rotation, EMPTY_ROTATION)) {
            quat.copy(this.rotation, animation.rotation);
        }
        if (animation.scale && !vec3.equals(animation.scale, EMPTY_SCALE)) {
            vec3.copy(this.scale, animation.scale);
        }
    }
}

class GeometryResource {
    constructor(resource) {
        this._init(resource);
    }

    _init(resource) {
        this.bbox = resource.bbox;
        this.geometry = resource.geometry;
        this.nodeMatrix = resource.nodeMatrix;
        this.materialInfo = resource.materialInfo;
        this.extraInfo = resource.extraInfo;
        this.animationMatrix = resource.animationMatrix;
        this.morphWeights = resource.morphWeights;
        this.skin = resource.skin;
        this.nodeIndex = resource.nodeIndex;
    }

    copyEdgeGeometry() {
        if (!this.copyGeometry) {
            //在重复利用geometry时，之前创建过拷贝份的copyGeometry就不用创建了
            this.copyGeometry = this._copyEdgeGeometry(this.geometry);
        }
    }

    createCopyBarycentric() {
        if (this.copyGeometry && !this.copyGeometry.data.aBarycentric) {
            //重新组织attribute数据，让每个顶点有独立的数据
            this.copyGeometry.buildUniqueVertex();
            //创建barycentric属性数据，参数是attribute名字
            this.copyGeometry.createBarycentric('aBarycentric');
        }
    }


    _copyEdgeGeometry(geometry) {
        const data = geometry.data;
        const indices = geometry.indices || geometry.elements;
        const newData = {};
        for (const p in data) {
            if (p !== geometry.desc.positionAttribute) {
                continue;
            }
            if (isArray(data[p])) {
                newData[p] = data[p].slice();
            } else if (data[p].buffer && data[p].buffer.destroy) {
                newData[p] = { buffer: data[p].buffer };
                if (isArray(data[p].array)) {
                    newData[p].array = data[p].array.slice();
                }
            } else {
                const interleavedArray = geometry._getAttributeData(p);
                if (p !== geometry.desc.positionAttribute) {
                    newData[p] = interleavedArray;
                } else {
                    newData[p] = interleavedArray.slice();
                }
            }
        }

        const newElements = indices.length !== undefined ? indices.slice() : indices;
        const desc = JSON.parse(JSON.stringify(geometry.desc));
        const copyGeometry = new EdgeGeometry(newData, newElements, 0, desc);
        copyGeometry.properties = geometry.properties;
        return copyGeometry;
    }
}

const Y_TO_Z = [1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1];

let timespan = 0;

const MAT4 = [];
const TEMP_VEC$1 = [];

class GLTFPack {

    constructor(gltf, regl) {
        this.gltf = gltf;
        this.regl = regl;
        this.geometries = [];
        if (regl) {
            this._emptyTexture = regl.texture({ width: 2, height: 2 });
        }
    }

    getMeshesInfo() {
        if (!this.gltf) {
            return null;
        }
        if (this.geometries.length) {
            return this.geometries;
        }
        this._createTextures(this.gltf.textures);
        this._createSkins(this.gltf.skins);
        const nodes = this.gltf.scenes[0].nodes;
        nodes.forEach((node) => {
            this._parserNode(node, this.geometries);
        });
        this._checkBaseColorFactor();
        return this.geometries;
    }

    getGLTFBBox(transform) {
        if (!this.gltf) {
            return null;
        }
        const geometries = this.geometries;
        if (!geometries || !geometries.length) {
            return null;
        }
        const min = [Infinity, Infinity, Infinity], max = [-Infinity, -Infinity, -Infinity];
        for (let i = 0; i < geometries.length; i++) {
            const bbox = geometries[i].bbox;
            const bboxMin = bbox.min, bboxMax = bbox.max;
            if (bboxMin[0] < min[0]) {
                min[0] = bboxMin[0];
            }
            if (bboxMin[1] < min[1]) {
                min[1] = bboxMin[1];
            }
            if (bboxMin[2] < min[2]) {
                min[2] = bboxMin[2];
            }

            if (bboxMax[0] > max[0]) {
                max[0] = bboxMax[0];
            }
            if (bboxMax[1] > max[1]) {
                max[1] = bboxMax[1];
            }
            if (bboxMax[2] > max[2]) {
                max[2] = bboxMax[2];
            }
        }
        const bbox = new BoundingBox(min, max);
        if (transform) {
            bbox.transform(transform);
        }

        return bbox;
    }

    _createSkins(skins) {
        if (!skins) {
            return;
        }
        this._skinMap = {};
        for (let i = 0; i < skins.length; i++) {
            const skin = skins[i];
            skin.joints = skin.joints.map(j => this.gltf.nodes[j]);
            this._skinMap[i] = new Skin(this.regl, skin.joints, skin.inverseBindMatrices.array);
            delete skin.inverseBindMatrices;
        }
    }

    _createTextures(textures) {
        if (!textures) {
            return;
        }
        this._textureMap = {};
        for (let i = 0; i < textures.length; i++) {
            const texture = textures[i];
            //避免重复创建纹理对象
            if (!this._textureMap[i]) {
                this._textureMap[i] = this._toTexture(texture);
                //图像数据可能占有较大内存，在创建texture完成后可删除
                delete texture.image;
            }
        }
    }

    //所有baseColorFactor的alpha为0时，设置为1
    _checkBaseColorFactor() {
        if (!this._checkBaseColorFactorAlpha()) {
            for (let i = 0; i < this.geometries.length; i++) {
                const baseColorFactor = this.geometries[i].materialInfo['baseColorFactor'];
                if (baseColorFactor && baseColorFactor[3] === 0) {
                    baseColorFactor[3] = 1;
                }
            }
        }
    }

    _checkBaseColorFactorAlpha() {
        for (let i = 0; i < this.geometries.length; i++) {
            const baseColorFactor = this.geometries[i].materialInfo['baseColorFactor'];
            if (baseColorFactor && baseColorFactor[3] > 0) {
                return true;
            }
        }
        return false;
    }

    dispose() {
        if (this._emptyTexture) {
            this._emptyTexture.destroy();
        }
        const geometries = this.getMeshesInfo();
        if (!geometries) {
            return;
        }
        geometries.forEach(g => {
            g.geometry.dispose();
            for (const m in g.materialInfo) {
                const materialInfo = g.materialInfo[m];
                //如果是texture对象，需要销毁，如果已经销毁过，不能再重复销毁
                if (materialInfo && materialInfo.destroy && !materialInfo[KEY_DISPOSED]) {
                    materialInfo.destroy();
                }
            }
        });
        for (const index in this._textureMap) {
            const tex = this._textureMap[index];
            if (tex && tex.destroy && !tex[KEY_DISPOSED]) {
                tex.destroy();
            }
        }
        delete this.gltf;
    }

    updateAnimation(time, loop, speed, animationName, startTime, nodeMatrixMap, skinMap, animationNodes) {
        const json = this.gltf;
        if (!json) {
            return;
        }
        const gltf = getGLTFLoaderBundle();
        timespan = json.animations ? gltf.GLTFLoader.getAnimationTimeSpan(json, animationName) : null;
        //模型切换过快，会导致上一个模型有动画执行，当前模型没有动画数据，就出现timespan为null的情况
        if (!timespan) {
            return;
        }
        time = time - startTime;
        let animTime = 0;
        if (loop || (!loop && this._isFirstLoop(time, speed, animationName, startTime))) {
            animTime = (time * speed * 0.001) % (timespan.max - timespan.min) + timespan.min;
        } else {
            animTime = time * speed * 0.001 + timespan.min;
        }
        json.scenes[0].nodes.forEach(node => {
            this._updateNodeMatrix(animationName, animTime, node, null, nodeMatrixMap, animationNodes);
        });
        for (const index in this.gltf.nodes) {
            const node = this.gltf.nodes[index];
            const nodeMatrix = nodeMatrixMap[node.nodeIndex];
            if (node.skin && nodeMatrix) {
                const jointTexture = node.skin.update(nodeMatrix, nodeMatrixMap, skinMap[node.nodeIndex] && skinMap[node.nodeIndex].jointTexture);
                if (!skinMap[node.nodeIndex]) {
                    skinMap[node.nodeIndex] =  {
                        jointTextureSize: node.skin.jointTextureSize,
                        numJoints: node.skin.joints.length
                    };
                }
                skinMap[node.nodeIndex].jointTexture = jointTexture;
            }
        }
        return;
    }

    _isFirstLoop(time, speed, animationName, startTime) {
        const json = this.gltf;
        if (!startTime || !json) {
            return true;
        }
        const gltf = getGLTFLoaderBundle();
        timespan = json.animations ? gltf.GLTFLoader.getAnimationTimeSpan(json, animationName) : null;
        return (time* speed * 0.001) / (timespan.max - timespan.min) < 1;
    }

    hasSkinAnimation() {
        return !!this._isAnimation;
    }

    _updateNodeMatrix(animationName, time, node, parentNodeMatrix, nodeMatrixMap, animationNodes) {
        const trs = node.trs;
        if (trs) {
            if (!animationNodes) {
                this._updateNodeTRS(node, time, animationName);
            } else if (animationNodes.indexOf(Number(node.nodeIndex)) > -1) {
                this._updateNodeTRS(node, time, animationName);
            }
        }
        if (parentNodeMatrix) {
            nodeMatrixMap[node.nodeIndex] = mat4.multiply(nodeMatrixMap[node.nodeIndex] || [], parentNodeMatrix, node.matrix || node.trs.getMatrix());
        } else {
            nodeMatrixMap[node.nodeIndex] = mat4.copy(nodeMatrixMap[node.nodeIndex] || [], node.matrix || node.trs.getMatrix());
        }
        if (node.children) {
            node.children.forEach(child => {
                this._updateNodeMatrix(animationName, time, child, nodeMatrixMap[node.nodeIndex], nodeMatrixMap, animationNodes);
            });
        }
    }

    _updateNodeTRS(node, time, animationName) {
        const gltf = getGLTFLoaderBundle();
        const animation = gltf.GLTFLoader.getAnimationClip(this.gltf, Number(node.nodeIndex), time, animationName);
        if (animation.weights) {
            this._updateMorph(node, animation.weights);
        }
        node.trs.update(animation);
    }

    //更新morph的基本思路是，计算node下每一帧的weights，然后对weights排序，最后根据
    //primitives[i].attributes.POSITION +
    //weights[0] * primitives[i].targets[0].POSITION +
    //weights[1] * primitives[i].targets[1].POSITION +
    //weights[2] * primitives[i].targets[2].POSITION + ...
    //方式去更新POSITION
    //如果morphTargets数量超过8个，例如36个，由于shader中对attributes的数量有限制，每次丢到shader中的morphTargets按照gltf规范，数量为8
    //需要实时计算这8个morphTarget的索引，来决定哪几个丢到shader中。
    _updateMorph(node, weights) {
        const length = weights.length;
        if (!node.influencesList) {
            node.influencesList = [];
            for (let i = 0; i < length; i++) {
                node.influencesList[i] = [i, 0];
            }
        }
        const influences = node.influencesList;
        for (let i =  0; i < influences.length; i++) {
            const influence = influences[i];
            influence[0] = i;
            influence[1] = weights[i];
        }
        influences.sort(absNumericalSort);
        const workInfluences = [];
        for (let i = 0; i < 8; i++) {
            workInfluences[i] = [i, 0];
        }
        for (let i = 0; i < 8; i++) {
            if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
        }
        workInfluences.sort(numericalSort);
        const geometries = node.geometries;
        geometries.forEach(geometry => {
            const morphTargets = geometry.properties.morphTargets;
            for (let ii = 0; ii < 8; ii++) {
                const influence = workInfluences[ii];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    geometry.updateData('POSITION' + ii, morphTargets['POSITION_' + index].array);
                    geometry.properties.morphWeights[ii] = value;
                } else {
                    geometry.properties.morphWeights[ii] = 0;
                }
            }
        });
    }


    _parserNode(node, geometries, parentNodeMatrix) {
        if (node.isParsed) {
            return;
        }
        node.nodeMatrix = node.nodeMatrix || mat4.identity([]);
        node.localMatrix = node.localMatrix || mat4.identity([]);
        if (node.matrix) {
            node.trs = new TRS();
            node.trs.decompose(node.matrix);
        } else {
            node.trs = new TRS(node.translation, node.rotation, node.scale);
        }
        node.localMatrix = node.trs.getMatrix();
        if (parentNodeMatrix) {
            mat4.multiply(node.nodeMatrix, parentNodeMatrix, node.matrix || node.localMatrix);
        } else {
            mat4.copy(node.nodeMatrix, node.matrix || node.localMatrix);
        }
        const nodeMatrix = node.nodeMatrix;
        if (node.children) {
            for (let i = 0; i < node.children.length; i++) {
                const child = node.children[i];
                this._parserNode(child, geometries, nodeMatrix);
            }
        }
        if (defined(node.skin)) {
            this._isAnimation = true;
            const skin = node.skin;
            node.trs = new TRS();
            node.skin = this._skinMap[skin];
        }

        if (defined(node.mesh)) {
            const meshIndex = node.mesh;
            node.mesh = this.gltf.meshes[meshIndex];
            node.mesh.node = node;
            node.geometries = node.geometries || [];
            node.mesh.primitives.forEach(primitive => {
                const materialInfo = this._createMaterialInfo(primitive.material);
                const geometry = createGeometry(primitive, this.regl, materialInfo.occlusionTexture);
                geometry.properties.morphTargets = primitive.morphTargets;
                //一个node下可能有多个geometry, node附带的weights会影响其下辖的所有geometry的morph变形结果，这里保存
                //geometries，方便后面morph的运算
                node.geometries.push(geometry);
                let bbox = geometry.boundingBox.copy();
                bbox = bbox.transform(mat4.identity(MAT4), nodeMatrix);
                const info = {
                    geometry,
                    bbox,
                    nodeMatrix,
                    materialInfo,
                    extraInfo: this._createExtralInfo(primitive.material),
                    animationMatrix : node.trs.getMatrix(),
                    morphWeights: node.weights,
                    nodeIndex: node.nodeIndex
                };
                if (node.skin) {
                    info.skin = {
                        jointTextureSize: [4, 6],
                        numJoints: node.skin.joints.length,
                        jointTexture: node.skin.jointTexture
                    };
                }
                const resource = new GeometryResource(info);
                geometries.push(resource);
            });
        }
        node.isParsed = true;
    }

    _createMaterialInfo(materialIndex) {
        const materialUniforms = {
        };
        if (this.gltf.materials && this.gltf.materials[materialIndex]) {
            const material = this.gltf.materials[materialIndex];
            const pbrMetallicRoughness = material.pbrMetallicRoughness;
            if (pbrMetallicRoughness) {
                const metallicRoughnessTexture = pbrMetallicRoughness.metallicRoughnessTexture;
                const baseColorTexture = pbrMetallicRoughness.baseColorTexture;
                if (baseColorTexture) {
                    materialUniforms['baseColorTexture'] = this._getTexture(baseColorTexture);
                    if (baseColorTexture['KHR_texture_transform']) {
                        materialUniforms['khr_offset'] = baseColorTexture['KHR_texture_transform'].offset || [0, 0];
                        materialUniforms['khr_rotation'] = baseColorTexture['KHR_texture_transform'].rotation ||0;
                        materialUniforms['khr_scale'] = baseColorTexture['KHR_texture_transform'].scale || [1, 1];
                    }
                }
                if (pbrMetallicRoughness.baseColorFactor) {
                    materialUniforms['baseColorFactor'] = pbrMetallicRoughness.baseColorFactor;
                }
                if (metallicRoughnessTexture) {
                    materialUniforms['metallicRoughnessTexture'] = this._getTexture(metallicRoughnessTexture);
                } else {
                    materialUniforms['metallicFactor'] = defined(pbrMetallicRoughness.metallicFactor) ? pbrMetallicRoughness.metallicFactor : 1.0;
                    materialUniforms['roughnessFactor'] = defined(pbrMetallicRoughness.roughnessFactor) ? pbrMetallicRoughness.roughnessFactor : 1.0;
                }
            }
            const extensions = material.extensions;
            if (extensions && extensions['KHR_materials_pbrSpecularGlossiness']) {
                const pbrSpecularGlossiness = extensions['KHR_materials_pbrSpecularGlossiness'];
                materialUniforms.name = 'pbrSpecularGlossiness';
                for (const p in pbrSpecularGlossiness) {
                    if (defined(pbrSpecularGlossiness[p].index)) {
                        materialUniforms[p] = this._getTexture(pbrSpecularGlossiness[p]);
                    } else {
                        materialUniforms[p] = pbrSpecularGlossiness[p];
                    }
                }
            }
            if (material.normalTexture) {
                materialUniforms['normalTexture'] = this._getTexture(material.normalTexture);
            }
            if (material.occlusionTexture) {
                materialUniforms['occlusionTexture'] = this._getTexture(material.occlusionTexture);
            }
            if (material.emissiveTexture) {
                materialUniforms['emissiveTexture'] = this._getTexture(material.emissiveTexture);
            }
            if (material.emissiveFactor) {
                materialUniforms['emissiveFactor'] = material.emissiveFactor;
            }
            materialUniforms['alphaCutoff'] = material.alphaCutoff || 0.5;
            materialUniforms['doubleSided'] = material.doubleSided;
            materialUniforms['alphaMode'] = material.alphaMode || 'OPAQUE';
        }
        return materialUniforms;
    }

    _createExtralInfo(material) {
        const info = {};
        if (this.gltf.materials && this.gltf.materials[material]) {
            const mat = this.gltf.materials[material];
            info['doubleSided'] = mat.doubleSided;
            info['alphaMode'] = mat.alphaMode || 'OPAQUE';
        }
        return info;
    }

    _getTexture(texInfo) {
        const extensions = texInfo.extensions;
        const index = texInfo.index;
        if (!defined(index)) {
            return null;
        }
        if (extensions && extensions['KHR_texture_transform']) {
            texInfo['KHR_texture_transform'] = extensions['KHR_texture_transform'];
        }
        const texture = this._textureMap[index];
        texture.texInfo = texInfo;
        return texture;
    }

    _toTexture(texture) {
        if (!texture) {
            // empty texture
            return this._emptyTexture;
        }
        const data = texture.image.array;
        const sampler = texture.sampler || {};
        const width = texture.image.width;
        const height = texture.image.height;
        return new Texture2D({
            width,
            height,
            data,
            mag: getTextureMagFilter(sampler.magFilter) || 'linear',
            min: getTextureMinFilter(sampler.minFilter) || 'linear mipmap linear',
            wrapS: getTextureWrap(sampler.wrapS) || 'repeat',
            wrapT: getTextureWrap(sampler.wrapT) || 'repeat'
        });
    }

    /**
     *
     * @param map
     * @param from
     * @param to
     * @param dist
     * @param rotationZ 模型绕Z轴旋转角度，弧度
     * @param rotationXY 模型绕Z轴与线段的交叉轴的旋转角度，弧度
     * @param gltfScale
     * @param projectionScale
     * @param options
     * @returns
     */
    arrangeAlongLine(from, to, xyDist, gltfScale, projectionScale, rotationScaleMat, options) {
        const items = [];
        const rotationZ = this._getRotationZ(from, to);
        // cm to mi
        const zDist = (from.z || 0) - (to.z || 0);
        const rotationXY = this._getRotationXY(xyDist, zDist);
        let boxWidth = this._calBoxWidth(gltfScale, rotationScaleMat, options);
        boxWidth /= projectionScale;
        const distance = Math.sqrt(xyDist * xyDist + zDist * zDist);
        const times = Math.floor(distance / boxWidth);
        let scaleIndex = (options.direction || 0);
        // scale的scaleIndex已经是Y_UP后的模型，所以和direction不同
        if (scaleIndex === 1) {
            scaleIndex = 2;
        } else if (scaleIndex === 2) {
            scaleIndex = 1;
        }
        //取余缩放
        if (times >= 1) {
            for (let i = 1; i <= times; i++) {
                const t = boxWidth * (i - 0.5) / distance;
                const item = {
                    coordinates: interpolate(from, to, t),
                    t,
                    scale: [1, 1, 1],
                    rotation: [0, 0, rotationZ],
                    rotationZ,
                    rotationXY
                };
                items.push(item);
            }
            //尾巴
            if (options['scaleVertex']) {
                const t = (boxWidth * times + (distance - boxWidth * times) / 2) / distance;
                const scale = (distance - boxWidth * times) / boxWidth;
                const itemScale = [1, 1, 1];
                itemScale[scaleIndex] = scale;
                const item = {
                    coordinates: interpolate(from, to, t),
                    t,
                    scale: itemScale,
                    rotation: [0, 0, rotationZ],
                    rotationZ,
                    rotationXY
                };
                items.push(item);
            }
        } else if (options['scaleVertex']) {
            const scale = distance / boxWidth;
            const itemScale = [1, 1, 1];
            itemScale[scaleIndex] = scale;
            const item = {
                coordinates: interpolate(from, to, 0.5),
                t: 0.5,
                scale: itemScale,
                rotation: [0, 0, rotationZ],
                rotationZ,
                rotationXY
            };
            items.push(item);
        }
        return items;
    }

    calModelHeightScale(out, modelHeight) {
        const bbox = this.getGLTFBBox();
        const fitScale = modelHeight / (Math.abs(bbox.max[1] - bbox.min[1]));//YZ轴做了翻转，所以需要用y方向来算高度比例
        return vec3.set(out, fitScale, fitScale, fitScale);
    }

    _calBoxWidth(scale, rotationScaleMat, options) {
        const mat = mat4.multiply(MAT4, rotationScaleMat, Y_TO_Z);
        const gltfmodelBBox = this.getGLTFBBox(mat);
        const direction = options.direction || 0;
        const boxExtent = vec3.sub(TEMP_VEC$1, gltfmodelBBox.max, gltfmodelBBox.min);
        vec3.multiply(boxExtent, boxExtent, scale);
        const gapLength = options['gapLength'];
        return boxExtent[direction] + gapLength;
    }

    _getRotationZ(from, to) {
        const degree = computeDegree(
            to.x, to.y,
            from.x, from.y
        );
        return degree / Math.PI * 180;
    }

    _getRotationXY(xyDist, zDist) {
        const rotation = Math.atan(zDist / xyDist) * 180 / Math.PI;
        return rotation;
    }
}

function createGeometry(primitive, regl, hasAOMap) {
    const attributes = primitive.attributes;
    const aColor0 = attributes['COLOR_0'];
    //将float类型的颜色值转为0-255的uint8类型
    if (aColor0 && aColor0.array instanceof Float32Array) {
        const color = new Uint8Array(aColor0.array.length);
        for (let i = 0; i < color.length; i++) {
            color[i] = Math.round(aColor0.array[i] * 255);
        }
        aColor0.array = color;
    } else if (aColor0 && (aColor0.array instanceof Uint16Array ||
        aColor0.array instanceof Int16Array ||
        aColor0.array instanceof Uint32Array ||
        aColor0.array instanceof Int32Array)) {
        const color = new Uint8Array(aColor0.array);
        aColor0.array = color;
    }
    if (hasAOMap && attributes['TEXCOORD_0'] && !attributes['TEXCOORD_0']) {
        attributes['TEXCOORD_1'] = attributes['TEXCOORD_0'];
    }
    const attrs = {};
    let positionSize = 3;
    const isWebGPU = regl && !!regl.wgpu;
    for (const name in attributes) {
        // 把原有的array赋给attr，用于计算 bbox、buildUniqueVertex
        attrs[name] = extend$1({}, attributes[name]);
        const isPosition = name === 'POSITION';
        if (isWebGPU) {
            const length = attrs[name].array.length;
            Geometry.padGPUGLTFAttribute(attrs[name]);
            if (isPosition && attrs[name].array.length !== length) {
                positionSize = 4;
            }
        }
        if (regl) {
            attrs[name].buffer = getUniqueREGLBuffer(regl, attrs[name], { dimension: attrs[name].itemSize });
        }
    }

    //如果有morph，需要预先填充morph空数据，动画开启后，会不断向这些空数据中填充morphTargets数据
    if (primitive.morphTargets) {
        const length = isInterleaved(attrs['POSITION']) ? attrs['POSITION'].itemSize * attrs['POSITION'].count : attrs['POSITION'].array.length;
        for (let i = 0; i < 8; i++) {
            if (!attrs[`POSITION${i}`]) {
                attrs[`POSITION${i}`] = new Float32Array(length).fill(0);
            }
        }
        for (let i = 0; i < 4; i++) {
            const length = attrs['NORMAL'].array ? attrs['NORMAL'].array.length : attrs['NORMAL'].length;
            if (!attrs[`NORMAL${i}`]) {
                attrs[`NORMAL${i}`] = new Float32Array(length).fill(0);
            }
        }
    }
    let indices = primitive.indices;
    if (indices && indices.bufferView === undefined && indices.array) {
        indices = indices.array;
    }
    const modelGeometry = new Geometry(
        attrs,
        indices,
        0,
        {
            positionSize,
            //绘制类型，例如 triangle strip, line等，根据gltf中primitive的mode来判断，默认是triangles
            primitive : isNumber$2(primitive.mode) ? getPrimitive(primitive.mode) : primitive.mode,
            positionAttribute: 'POSITION',
            normalAttribute: 'NORMAL',
            uv0Attribute: 'TEXCOORD_0',
            uv1Attribute: 'TEXCOORD_1',
            color0Attribute: 'COLOR_0'
        }
    );
    if (primitive.morphTargets) {
        modelGeometry.properties.morphWeights = [];
    }
    if (primitive.mode > 3 && !modelGeometry.data['NORMAL']) {
        modelGeometry.createNormal('NORMAL');
    }
    return modelGeometry;
}

function numericalSort(a, b) {
    return a[ 0 ] - b[ 0 ];
}

function absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}

function computeDegree(x0, y0, x1, y1) {
    const dx = x1 - x0;
    const dy = y1 - y0;
    return Math.atan2(dy, dx);
}

function interpolate(from, to, t) {
    const x = lerp(from.x, to.x, t);
    const y = lerp(from.y, to.y, t);
    const z1 = from.z || 0;
    const z2 = to.z || 0;
    const z = lerp(z1, z2, t);
    return new from.constructor(x, y, z);
}

function lerp(a, b, t) {
    return a + t * (b - a);
}

// options.fetchOptions
// options.gltfLoaderOptions
function load(url, options) {
    const { Ajax } = getGLTFLoaderBundle();
    const { fetchOptions, gltfLoaderOptions, urlModifier } = options;
    const loaderOptions = gltfLoaderOptions || {};
    loaderOptions.urlModifier = urlModifier;
    const index = url.lastIndexOf('/');
    const root = url.slice(0, index);
    const postfix = url.slice(url.lastIndexOf('.')).toLowerCase();
    if (postfix === '.gltf') {
        return Ajax.getJSON(url, fetchOptions, urlModifier).then(json => {
            return loadGLTF(root, json, loaderOptions);
        });
    }
    else if (postfix === '.glb') {
        return Ajax.getArrayBuffer(url, fetchOptions, urlModifier).then(bin => {
            return loadGLTF(root, { buffer: bin.data, byteOffset: 0 }, loaderOptions);
        });
    }
    return null;
}
function exportGLTFPack(gltf, regl) {
    const gltfpack = new GLTFPack(gltf, regl);
    return gltfpack;
}
function loadGLTF(root, gltf, loaderOptions) {
    const { GLTFLoader } = getGLTFLoaderBundle();
    const loader = new GLTFLoader(root, gltf, loaderOptions);
    return loader.load();
}

var GLTFHelper = /*#__PURE__*/Object.freeze({
    __proto__: null,
    exportGLTFPack: exportGLTFPack,
    load: load,
    loadGLTF: loadGLTF
});

const cubePosition = [1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1,
    1, 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1,
    1, 1, 1, 1, 1, -1, -1, 1, -1, -1, 1, 1,
    -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, -1, 1,
    -1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1,
    1, -1, -1, -1, -1, -1, -1, 1, -1, 1, 1, -1];
const cubeNormal =  [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1,
    1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0,
    0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0,
    -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0,
    0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0,
    0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1];
const cubeIndices = [0, 1, 2, 0, 2, 3,
    4, 5, 6, 4, 6, 7,
    8, 9, 10, 8, 10, 11,
    12, 13, 14, 12, 14, 15,
    16, 17, 18, 16, 18, 19,
    20, 21, 22, 20, 22, 23];
const cubeuv = [
    0.0, 0.0,
    1.0, 0.0,
    0.0, 1.0,
    1.0, 1.0,

    0.0, 0.0,
    1.0, 0.0,
    0.0, 1.0,
    1.0, 1.0,

    0.0, 0.0,
    1.0, 0.0,
    0.0, 1.0,
    1.0, 1.0,

    0.0, 0.0,
    1.0, 0.0,
    0.0, 1.0,
    1.0, 1.0,

    0.0, 0.0,
    1.0, 0.0,
    0.0, 1.0,
    1.0, 1.0,

    0.0, 0.0,
    1.0, 0.0,
    0.0, 1.0,
    1.0, 1.0
];
// BOX template
//    v2----- v1
//   / |     /|
//  v3------v0|
//  |  |v6  | /v5
//  | /     |/
//  v7------v4
const plane = {
    // Create a plane
    //    v2----- v3
    //   /       /
    //  v1------v0
    // Coordinates
    vertices : [
        -1, 0, -1,
        1, 0, -1,
        -1, 0, 1,
        1, 0, 1,
    ],

    // Normal
    normals : [
        0, 1, 0,
        0, 1, 0,
        0, 1, 0,
        0, 1, 0,
    ],
    // Indices of the vertices
    indices : [
        3, 1, 0, 0, 2, 3
    ],

    uv : [
        0.0, 0.0,
        1.0, 0.0,
        0.0, 1.0,
        1.0, 1.0
    ]
};

const pyramid = {
    vertices: [-0.8111000061035156, 2.0102999210357666, -0.8111000061035156, 0, 0.010300000198185444, -0, -0.8111000061035156, 2.0102999210357666, 0.8111000061035156, -0.8111000061035156, 2.0102999210357666, 0.8111000061035156, 0, 0.010300000198185444, -0, 0.8111000061035156, 2.0102999210357666, 0.8111000061035156, 0.8111000061035156, 2.0102999210357666, 0.8111000061035156, 0, 0.010300000198185444, -0, 0.8111000061035156, 2.0102999210357666, -0.8111000061035156, 0.8111000061035156, 2.0102999210357666, -0.8111000061035156, 0, 0.010300000198185444, -0, -0.8111000061035156, 2.0102999210357666, -0.8111000061035156, 0.8111000061035156, 2.0102999210357666, -0.8111000061035156, -0.8111000061035156, 2.0102999210357666, -0.8111000061035156, 0, 2.9419000148773193, -0, 0.8111000061035156, 2.0102999210357666, 0.8111000061035156, 0.8111000061035156, 2.0102999210357666, -0.8111000061035156, 0, 2.9419000148773193, -0, -0.8111000061035156, 2.0102999210357666, -0.8111000061035156, -0.8111000061035156, 2.0102999210357666, 0.8111000061035156, 0, 2.9419000148773193, -0, -0.8111000061035156, 2.0102999210357666, 0.8111000061035156, 0.8111000061035156, 2.0102999210357666, 0.8111000061035156, 0, 2.9419000148773193, -0],

    normals: [-0.9267006516456604, -0.3758002817630768, -0, -0.9267006516456604, -0.3758002817630768, -0, -0.9267006516456604, -0.3758002817630768, -0, 0, -0.3758002817630768, 0.9267006516456604, 0, -0.3758002817630768, 0.9267006516456604, 0, -0.3758002817630768, 0.9267006516456604, 0.9267006516456604, -0.3758002817630768, -0, 0.9267006516456604, -0.3758002817630768, -0, 0.9267006516456604, -0.3758002817630768, -0, 0, -0.3758002817630768, -0.9267006516456604, 0, -0.3758002817630768, -0.9267006516456604, 0, -0.3758002817630768, -0.9267006516456604, 0, 0.656676173210144, -0.7541726231575012, 0, 0.656676173210144, -0.7541726231575012, 0, 0.656676173210144, -0.7541726231575012, 0.7541726231575012, 0.656676173210144, -0, 0.7541726231575012, 0.656676173210144, -0, 0.7541726231575012, 0.656676173210144, -0, -0.7541726231575012, 0.656676173210144, -0, -0.7541726231575012, 0.656676173210144, -0, -0.7541726231575012, 0.656676173210144, -0, 0, 0.656676173210144, 0.7541726231575012, 0, 0.656676173210144, 0.7541726231575012, 0, 0.656676173210144, 0.7541726231575012],

    indices: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
};

const DEFAULT_MODELS = ['cube', 'plane', 'pyramid'];

const simpleModels = {
    'cube': {
        meshes : [{
            primitives : [{
                attributes : {
                    POSITION : {
                        array : new Int8Array(cubePosition)
                    },
                    NORMAL :{
                        array : new Int8Array(cubeNormal)
                    },
                    TEXCOORD_0: {
                        array: new Int8Array(cubeuv)
                    }
                },
                indices : new Uint16Array(cubeIndices),
                mode : 4
            }]
        }],
        scenes : [
            {
                nodes : [
                    {
                        mesh : 0,
                        scale: [
                            60,
                            60,
                            60
                        ]
                    }
                ]
            }
        ]
    },
    'plane-cube': {
        meshes : [{
            primitives : [{
                attributes : {
                    POSITION : {
                        array : new Int8Array(plane.vertices)
                    },
                    TEXCOORD_0: {
                        array : new Int8Array(plane.uv)
                    }
                },
                indices : new Uint16Array(plane.indices),
                mode : 4
            }]
        }],
        scenes : [
            {
                nodes : [
                    {
                        mesh : 0,
                        scale: [60, 60, 60],
                        translation: [0, -60, 0]
                    },
                    {
                        mesh : 0,
                        scale: [60, 60, 60],
                        translation: [0, 60, 0]
                    },
                    {
                        mesh : 0,
                        scale: [60, 60, 60],
                        translation: [60, 0, 0],
                        rotation: [0, 0, 0.7071067811865475, 0.7071067811865476]
                    },
                    {
                        mesh : 0,
                        scale: [60, 60, 60],
                        translation: [-60, 0, 0],
                        rotation: [0, 0, 0.7071067811865475, 0.7071067811865476]
                    },
                    {
                        mesh : 0,
                        scale: [60, 60, 60],
                        translation: [0, 0, 60],
                        rotation: [0.7071067811865475, 0, 0, 0.7071067811865476]
                    },
                    {
                        mesh : 0,
                        scale: [60, 60, 60],
                        translation: [0, 0, -60],
                        rotation: [0.7071067811865475, 0, 0, 0.7071067811865476]
                    }
                ]
            }
        ]
    },
    'plane': {
        meshes : [{
            primitives : [{
                attributes : {
                    POSITION : {
                        array : new Int8Array(plane.vertices)
                    },
                    NORMAL :{
                        array : new Int8Array(plane.normals)
                    },
                    TEXCOORD_0: {
                        array : new Int8Array(plane.uv)
                    }
                },
                indices : new Uint16Array(plane.indices),
                mode : 4
            }]
        }],
        scenes : [
            {
                nodes : [
                    {
                        mesh : 0,
                        scale: [
                            60,
                            60,
                            60
                        ]
                    }
                ]
            }
        ]
    },
    'pyramid': {
        meshes : [{
            primitives : [{
                attributes : {
                    POSITION : {
                        array : new Float32Array(pyramid.vertices)
                    },
                    NORMAL :{
                        array : new Float32Array(pyramid.normals)
                    },
                    TEXCOORD_0: {
                        array : new Float32Array(pyramid.uv)
                    }
                },
                indices : new Uint16Array(pyramid.indices),
                mode : 4
            }]
        }],
        scenes : [
            {
                nodes : [
                    {
                        mesh : 0,
                        scale: [
                            60,
                            60,
                            60
                        ]
                    }
                ]
            }
        ]
    }
};

//简单模型由于会重复使用，为了避免模型结构会影响，需要进行拷贝使用
function getSimpleModel(url) {
    let simpleModel = null;
    if (simpleModels[url]) {
        simpleModel = {
            meshes: simpleModels[url].meshes
        };
        simpleModel.scenes = JSON.parse(JSON.stringify(simpleModels[url].scenes));
    }
    return simpleModel;
}

function setSimpleModel(key, gltfData) {
    if (typeof key === 'string' && DEFAULT_MODELS.indexOf(key) < 0) {
        simpleModels[key] = gltfData;
    }
}

class GLTFManager {
    constructor(regl, options) {
        this.regl = regl;
        this.resourceMap = {};
        this.options = options || {};
    }

    getGLTF(url) {
        return this.resourceMap[url];
    }

    loginGLTF(url, requestor) {
        if (!this.resourceMap[url]) {
            if (simpleModels[url]) { //简单模型不需要request，直接返回数据
                const data = getSimpleModel(url);
                this.resourceMap[url] = this._exportGLTFResource(data, url, false);
            } else if (requestor) {
                this.resourceMap[url] = requestor(url).then(gltf => {
                    this.resourceMap[url] = this._exportGLTFResource(gltf, url);
                    return this.resourceMap[url];
                });
            } else {
                this.resourceMap[url] = this._loadGLTFModel(url);
            }
            this.resourceMap[url].refCount = 1;
        } else {
            this.resourceMap[url].refCount += 1;
        }
    }

    logoutGLTF(url) {
        if (this.resourceMap[url]) {
            this.resourceMap[url].refCount -= 1;
            if (this.resourceMap[url].refCount < 1) {
                const resources = this.resourceMap[url].resources;
                if (resources) {
                    for (let i = 0; i < resources.length; i++) {
                        resources[i].geometry.dispose();
                        if (resources[i].copyGeometry) {
                            resources[i].copyGeometry.dispose();
                        }
                        if (resources[i].material) {
                            resources[i].material.dispose();
                        }
                    }
                }
                if (this.resourceMap[url].gltfPack) {
                    this.resourceMap[url].gltfPack.dispose();
                }
                delete this.resourceMap[url];
            }
        }
    }

    isSimpleModel(url) {
        return simpleModels[url];
    }

    addSimpleModel(id, gltfData) {
        setSimpleModel(id, gltfData);
    }

    removeSimpleModel(id) {
        delete simpleModels[id];
    }

    _exportGLTFResource(gltf, url, useUniqueREGLBuffer = true) {
        if (!gltf) {
            return null;
        }
        const gltfPack = exportGLTFPack(gltf, useUniqueREGLBuffer ? this.regl : null);
        const geometries = gltfPack.getMeshesInfo();
        const bbox = gltfPack.getGLTFBBox();
        const resourceMap = {
            bbox,
            gltfPack,
            resources: geometries,
            //保存gltf的原始结构
            json: gltf.json,
            refCount: this.resourceMap[url] ? this.resourceMap[url].refCount : 0 //这里不能设置为0，由于是异步，会把前面累增的量重置为0
        };
        return resourceMap;
    }

    fetchGLTF(url) {
        return load(url, this.options).then(gltfData => {
            return gltfData;
        });
    }

    _loadGLTFModel(url) {
        return this.fetchGLTF(url).then(data => {
            this.resourceMap[url] = this._exportGLTFResource(data, url);
            return this.resourceMap[url];
        });
    }
}

const renderToCube = function () {
    const cameraPos = [0, 0, 0];

    const fov = 90 * Math.PI / 180;
    const clearColor = [0, 0, 0, 0];
    const pmat = new Array(16);

    return function (regl, fbo, drawCommand, props, cb, up) {
        const captureViews = [
            mat4.lookAt([], cameraPos, [1, 0, 0], up && up[0] || [0, -1, 0]),
            mat4.lookAt([], cameraPos, [-1, 0, 0], up && up[1] || [0, -1, 0]),
            mat4.lookAt([], cameraPos, [0, 1, 0],  up && up[2] || [0, 0, 1]),
            mat4.lookAt([], cameraPos, [0, -1, 0], up && up[3] || [0, 0, -1]),
            mat4.lookAt([], cameraPos, [0, 0, 1],  up && up[4] || [0, -1, 0]),
            mat4.lookAt([], cameraPos, [0, 0, -1], up && up[5] || [0, -1, 0])
        ];
        const aspect = 1;
        const near = 0.5;
        const far = 1.1;
        const isWebGPU = !!regl.wgpu;
        let projMatrix;
        if (isWebGPU) {
            projMatrix = mat4.perspectiveZO(pmat, fov, aspect, near, far);
        } else {
            projMatrix = mat4.perspective(pmat, fov, aspect, near, far);
        }

        const config = {
            context : {
                //每次应用不同的 view matrix
                viewMatrix: function (context, props, batchId) {
                    return captureViews[batchId];
                },
                projMatrix
            }
        };
        if (fbo) {
            if (fbo.faces) {
                //a cube map
                config.framebuffer = function (context, props, batchId) {
                    return fbo.faces[batchId];
                };
            } else {
                config.framebuffer = fbo;
            }
        }

        const setupFace = regl(config);

        setupFace(6, (context, p, batchId) => {
            const cfg = {
                color: clearColor,
                depth: 1
            };
            if (fbo) {
                cfg.framebuffer = fbo.faces ? fbo.faces[batchId] : fbo;
            }
            regl.clear(cfg);
            drawCommand(props);
            if (cb) cb();
        });

        return fbo;
    };
}();

var cubeData = {
    // Create a cube
    //    v6----- v5
    //   /|      /|
    //  v1------v0|
    //  | |     | |
    //  | |v7---|-|v4
    //  |/      |/
    //  v2------v3
    // Coordinates
    vertices : [
        1.0, 1.0, 1.0,  -1.0, 1.0, 1.0,  -1.0, -1.0, 1.0,   1.0, -1.0, 1.0, // v0-v1-v2-v3 front
        1.0, 1.0, 1.0,   1.0, -1.0, 1.0,   1.0, -1.0, -1.0,   1.0, 1.0, -1.0, // v0-v3-v4-v5 right
        1.0, 1.0, 1.0,   1.0, 1.0, -1.0,  -1.0, 1.0, -1.0,  -1.0, 1.0, 1.0, // v0-v5-v6-v1 up
        -1.0, 1.0, 1.0,  -1.0, 1.0, -1.0,  -1.0, -1.0, -1.0,  -1.0, -1.0, 1.0, // v1-v6-v7-v2 left
        -1.0, -1.0, -1.0,   1.0, -1.0, -1.0,   1.0, -1.0, 1.0,  -1.0, -1.0, 1.0, // v7-v4-v3-v2 down
        1.0, -1.0, -1.0,  -1.0, -1.0, -1.0,  -1.0, 1.0, -1.0,   1.0, 1.0, -1.0  // v4-v7-v6-v5 back
        // 2.0, 2.0, 2.0,  -2.0, 2.0, 2.0,  -2.0,-2.0, 2.0,   2.0,-2.0, 2.0, // v0-v1-v2-v3 front
        // 2.0, 2.0, 2.0,   2.0,-2.0, 2.0,   2.0,-2.0,-2.0,   2.0, 2.0,-2.0, // v0-v3-v4-v5 right
        // 2.0, 2.0, 2.0,   2.0, 2.0,-2.0,  -2.0, 2.0,-2.0,  -2.0, 2.0, 2.0, // v0-v5-v6-v1 up
        // -2.0, 2.0, 2.0,  -2.0, 2.0,-2.0,  -2.0,-2.0,-2.0,  -2.0,-2.0, 2.0, // v1-v6-v7-v2 left
        // -2.0,-2.0,-2.0,   2.0,-2.0,-2.0,   2.0,-2.0, 2.0,  -2.0,-2.0, 2.0, // v7-v4-v3-v2 down
        // 2.0,-2.0,-2.0,  -2.0,-2.0,-2.0,  -2.0, 2.0,-2.0,   2.0, 2.0,-2.0  // v4-v7-v6-v5 back
    ],

    // Normal
    // normals : [
    //   0.0, 0.0, 1.0,   0.0, 0.0, 1.0,   0.0, 0.0, 1.0,   0.0, 0.0, 1.0,  // v0-v1-v2-v3 front
    //   1.0, 0.0, 0.0,   1.0, 0.0, 0.0,   1.0, 0.0, 0.0,   1.0, 0.0, 0.0,  // v0-v3-v4-v5 right
    //   0.0, 1.0, 0.0,   0.0, 1.0, 0.0,   0.0, 1.0, 0.0,   0.0, 1.0, 0.0,  // v0-v5-v6-v1 up
    //   -1.0, 0.0, 0.0,  -1.0, 0.0, 0.0,  -1.0, 0.0, 0.0,  -1.0, 0.0, 0.0,  // v1-v6-v7-v2 left
    //   0.0, -1.0, 0.0,   0.0, -1.0, 0.0,   0.0, -1.0, 0.0,   0.0, -1.0, 0.0,  // v7-v4-v3-v2 down
    //   0.0, 0.0, -1.0,   0.0, 0.0, -1.0,   0.0, 0.0, -1.0,   0.0, 0.0, -1.0   // v4-v7-v6-v5 back
    // ],

    textures : [
        1.0, 1.0,   0.0, 1.0,   0.0, 0.0,  1.0, 0.0,
        1.0, 1.0,   0.0, 1.0,   0.0, 0.0,  1.0, 0.0,
        1.0, 1.0,   0.0, 1.0,   0.0, 0.0,  1.0, 0.0,
        1.0, 1.0,   0.0, 1.0,   0.0, 0.0,  1.0, 0.0,
        1.0, 1.0,   0.0, 1.0,   0.0, 0.0,  1.0, 0.0,
        1.0, 1.0,   0.0, 1.0,   0.0, 0.0,  1.0, 0.0
    ],

    // Indices of the vertices
    indices : [
        0, 1, 2,   0, 2, 3,    // front
        4, 5, 6,   4, 6, 7,    // right
        8, 9, 10,   8, 10, 11,    // up
        12, 13, 14,  12, 14, 15,    // left
        16, 17, 18,  16, 18, 19,    // down
        20, 21, 22,  20, 22, 23     // back
    ]
};

var cubemapVS = "#define SHADER_NAME CUBE_MAP\nattribute vec3 aPosition;\nvarying vec3 vWorldPos;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nvoid main() {\n  vWorldPos = aPosition;\n  gl_Position = projMatrix * viewMatrix * vec4(vWorldPos, 1.);\n}";

var cubemapFS = "#define SHADER_NAME CUBEMAP\nprecision highp float;\nuniform samplerCube cubeMap;\nuniform float exposure;\nvarying vec3 vWorldPos;\n#ifdef ENCODE_RGBM\nvec4 c(const in vec3 d, const in float e) {\n  if(e <= .0)\n    return vec4(d, 1.);\n  vec4 f;\n  vec3 h = d / e;\n  f.a = clamp(max(max(h.r, h.g), max(h.b, 1e-6)), .0, 1.);\n  f.a = ceil(f.a * 255.) / 255.;\n  f.rgb = h / f.a;\n  return f;\n}\n#endif\nvoid main() {\n  vec4 i = textureCube(cubeMap, vWorldPos);\n  i.rgb *= exposure;\n#ifdef ENCODE_RGBM\ni = c(i.rgb, 7.);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = i;\n#endif\n}";

var equirectangularMapFS = "precision highp float;\n#define PI 3.1415926\nvarying vec3 vWorldPos;\nuniform sampler2D equirectangularMap;\nconst vec2 c = vec2(.1591, .3183);\nvec2 d(vec3 e) {\n  vec2 f = vec2(atan(e.y, e.x), asin(e.z));\n  f *= c;\n  f += .5;\n  return f;\n}\nvoid main() {\n  vec2 f = d(normalize(vWorldPos));\n  vec4 h = texture2D(equirectangularMap, f);\n  gl_FragColor = vec4(h.rgb, 1.);\n}";

var prefilterFS = "#define SHADER_NAME PBR_prefilter\nprecision highp float;\nvarying vec3 vWorldPos;\nuniform samplerCube environmentMap;\nuniform sampler2D distributionMap;\nuniform float roughness;\nuniform float resolution;\nconst float c = 3.14159265359;\nfloat d(vec3 e, vec3 f, float h) {\n  float a = h * h;\n  float i = a * a;\n  float j = max(dot(e, f), .0);\n  float k = j * j;\n  float l = i;\n  float m = (k * (i - 1.) + 1.);\n  m = c * m * m;\n  return l / m;\n}\nvec3 n(float o, vec3 e, float h) {\n  vec4 u = texture2D(distributionMap, vec2(h, o));\n  vec3 f = u.xyz;\n  float v = sign(u.w - .5);\n  float A = sign(u.w - 200.0 / 255. * clamp(v, .0, 1.) - .15);\n  f.x *= v;\n  f.y *= A;\n  vec3 B = abs(e.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 C = normalize(cross(B, e));\n  vec3 D = cross(e, C);\n  vec3 E = C * f.x + D * f.y + e * f.z;\n  return normalize(E);\n}\nvoid main() {\n  vec3 e = normalize(vWorldPos);\n  vec3 F = e;\n  vec3 G = F;\n  const int I = 1024;\n  vec3 J = vec3(.0);\n  float K = .0;\n  for(int L = 0; L < I; ++L) {\n    vec3 f = n(float(L) / float(I), e, roughness);\n    vec3 M = normalize(2. * dot(G, f) * f - G);\n    float O = max(dot(e, M), .0);\n    if(O > .0) {\n      J += textureCube(environmentMap, M).rgb * O;\n      K += O;\n    }\n  }\n  J = J / K;\n  gl_FragColor = vec4(J, 1.);\n}";

var dfgFS = "precision highp float;\nvarying vec2 vTexCoords;\nuniform sampler2D distributionMap;\nconst float c = 3.14159265359;\nvec4 d(float a, float b) {\n  a *= 65535.;\n  b *= 65535.;\n  vec4 rgba;\n  rgba[0] = mod(a, 255.);\n  rgba[1] = (a - rgba[0]) / 65280.0;\n  rgba[2] = mod(b, 255.);\n  rgba[3] = (b - rgba[2]) / 65280.0;\n  return rgba;\n}\nvec3 e(float f, vec3 h, float i) {\n  vec4 j = texture2D(distributionMap, vec2(i, f));\n  vec3 k = j.xyz;\n  float l = sign(j.w - .5);\n  float m = sign(j.w - clamp(l, .0, 1.) * 200.0 / 255. - .15);\n  k.x *= l;\n  k.y *= m;\n  vec3 n = abs(h.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 o = normalize(cross(n, h));\n  vec3 u = cross(h, o);\n  vec3 v = o * k.x + u * k.y + h * k.z;\n  return normalize(v);\n}\nfloat A(float B, float i) {\n  float a = i;\n  float C = (a * a) / 2.;\n  float D = B;\n  float E = B * (1. - C) + C;\n  return D / E;\n}\nfloat F(float B, float G, float i) {\n  float I = A(B, i);\n  float J = A(G, i);\n  return J * I;\n}\nvec2 K(float B, float i) {\n  vec3 L;\n  L.x = sqrt(1. - B * B);\n  L.y = .0;\n  L.z = B;\n  float M = .0;\n  float O = .0;\n  vec3 h = vec3(.0, .0, 1.);\n  const int P = 1024;\n  for(int Q = 0; Q < P; ++Q) {\n    vec3 k = e(float(Q) / float(P), h, i);\n    vec3 R = normalize(2. * dot(L, k) * k - L);\n    float G = max(R.z, .0);\n    float S = max(k.z, .0);\n    float T = max(dot(L, k), .0);\n    float B = max(dot(h, L), .0);\n    if(G > .0) {\n      float U = F(B, G, i);\n      float W = (U * T) / (S * B);\n      float X = pow(1. - T, 5.);\n      M += (1. - X) * W;\n      O += X * W;\n    }\n  }\n  M /= float(P);\n  O /= float(P);\n  return vec2(M, O);\n}\nvoid main() {\n  vec2 Y = K(vTexCoords.x, vTexCoords.y);\n  gl_FragColor = d(Y.x, Y.y);\n}";

var dfgVS = "attribute vec3 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoords;\nvoid main() {\n  vTexCoords = aTexCoord;\n  gl_Position = vec4(aPosition, 1.);\n}";

/*!
 * from claygl
 * https://github.com/pissang/claygl/
 * License: BSD-2-Clause
 */


function harmonics(normal, index) {
    const x = normal[0];
    const y = normal[1];
    const z = normal[2];
    if (index === 0) {
        return 1.0;
    } else if (index === 1) {
        return x;
    } else if (index === 2) {
        return y;
    } else if (index === 3) {
        return z;
    } else if (index === 4) {
        return x * z;
    } else if (index === 5) {
        return y * z;
    } else if (index === 6) {
        return x * y;
    } else if (index === 7) {
        return 3.0 * z * z - 1.0;
    } else {
        return x * x - y * y;
    }
}

const normalTransform = {
    px: [2, 1, 0, -1, -1, 1],
    nx: [2, 1, 0, 1, -1, -1],
    py: [0, 2, 1, 1, -1, -1],
    ny: [0, 2, 1, 1, 1, 1],
    pz: [0, 1, 2, -1, -1, -1],
    nz: [0, 1, 2, 1, -1, 1]
};

const targets = ['px', 'nx', 'py', 'ny', 'pz', 'nz'];

// Project on cpu.
function projectEnvironmentMapCPU$1(cubePixels, width, height) {
    const coeff = new Array(9);
    const normal = [];
    const texel = [];
    const fetchNormal = [];
    for (let m = 0; m < 9; m++) {
        const result = [0, 0, 0];
        for (let k = 0; k < targets.length; k++) {
            // var pixels = cubePixels[targets[k]];
            const pixels = cubePixels[k];

            const sideResult = [0, 0, 0];
            let divider = 0;
            let i = 0;
            const transform = normalTransform[targets[k]];
            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {

                    normal[0] = x / (width - 1.0) * 2.0 - 1.0;
                    // TODO Flip y?
                    normal[1] = y / (height - 1.0) * 2.0 - 1.0;
                    normal[2] = -1.0;
                    vec3.normalize(normal, normal);

                    fetchNormal[0] = normal[transform[0]] * transform[3];
                    fetchNormal[1] = normal[transform[1]] * transform[4];
                    fetchNormal[2] = normal[transform[2]] * transform[5];

                    texel[0] = pixels[i++] / 255;
                    texel[1] = pixels[i++] / 255;
                    texel[2] = pixels[i++] / 255;
                    // RGBM Decode
                    const scale = pixels[i++] / 255 * 7;
                    texel[0] *= scale;
                    texel[1] *= scale;
                    texel[2] *= scale;

                    vec3.scaleAndAdd(sideResult, sideResult, texel, harmonics(fetchNormal, m) * -normal[2]);
                    // -normal.z equals cos(theta) of Lambertian
                    divider += -normal[2];
                }
            }
            vec3.scaleAndAdd(result, result, sideResult, 1 / divider);
        }

        coeff[m] = vec3.scale(result, result, 1 / 6.0);
    }
    return coeff;
}

let defaultRegl;
function getDefaultREGL() {
    if (!defaultRegl) {
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl');
        defaultRegl = createREGL({
            optionalExtensions: [
                'OES_texture_half_float',
                'OES_texture_half_float_linear',
                'OES_texture_float',
                'OES_texture_float_linear',
            ],
            attributes: {
                alpha: true,
                depth: true,
                stencil: true,
                preserveDrawingBuffer: true,
            },
            gl
        });
        defaultRegl.on('lost', () => {
            defaultRegl.destroy();
            defaultRegl = null;
        });
    }
    return defaultRegl;
}

const skyboxFrag = ShaderLib.compile(skyboxRawFrag);
// import irradianceFS from './glsl/helper/irradiance_convolution.frag';
/**
 * {
 *  envTexture,
 *  envCubeSize,
 *  irradianceCubeSize,
 *  sampleSize,
 *  roughnessLevels,
 *  prefilterCubeSize,
 *  dfgSize
 * }
 * @param regl - regl
 * @param config - config
 */
function createIBLMaps(regl, config = {}) {
    return _createIBLMaps(regl, config);

}

function createIBLMapsAsync(regl, config = {}) {
    return new Promise((resolve) => {
        _createIBLMaps(regl, config, (maps) => {
            maps.updateTime = config.updateTime;
            resolve(maps);
        });
    });
}

function _createIBLMaps(regl, config = {}, callback) {
    regl = getREGL(regl);
    // config values

    const envTexture = config.envTexture;

    const envCubeSize = config.envCubeSize || 512;

    // const irradianceCubeSize = config.irradianceCubeSize || 32;

    const sampleSize = config.sampleSize || 1024;
    const roughnessLevels = config.roughnessLevels || 256;
    const prefilterCubeSize = config.prefilterCubeSize || 256;

    // const dfgSize = config.dfgSize || 256;

    //----------------------------------------------------
    // generate ibl maps
    let envMap;
    let isHDR = false;
    if (!Array.isArray(envTexture)) {
        envMap = createEquirectangularMapCube(regl, envTexture, envCubeSize);
        isHDR = true;
    } else {
        const cube = regl.cube({
            flipY: true,
            faces: envTexture
        });
        // const cube = regl.cube(...envTexture);
        envMap = createSkybox(regl, cube, envCubeSize);
        cube.destroy();
    }

    const { prefilterMap, prefilterMipmap } = createPrefilterCube(regl, envMap, prefilterCubeSize, sampleSize, roughnessLevels, isHDR);

    // const dfgLUT = generateDFGLUT(regl, dfgSize, sampleSize, roughnessLevels);

    let sh;
    if (!config.ignoreSH) {
        const size = prefilterCubeSize;
        // let cubeMap;
        // if (!Array.isArray(envTexture)) {
        //     cubeMap = createEquirectangularMapCube(regl, envTexture, size, false);
        // } else {
        // const cube = regl.cube(...envTexture);
        // cubeMap = createSkybox(regl, cube, size, false);
        // cube.destroy();
        // }
        // const lod = regl.hasExtension('EXT_shader_texture_lod') ? '1.0' : undefined;
        const flat = (shList) => {
            const flatten = [];
            for (let i = 0; i < shList.length; i++) {
                flatten.push(...shList[i]);
            }
            return flatten;
        };
        const faces = getEnvmapPixels(regl, prefilterMap, size, false, config.environmentExposure, true);
        const { projectEnvironmentMapCPU } = config;
        if (projectEnvironmentMapCPU) {
            projectEnvironmentMapCPU({ cubePixels: faces, width: size, height: size }, (shList) => {
                sh = flat(shList);
                callback(createMap());
            });
            return;
        }
        sh = projectEnvironmentMapCPU$1(faces, size, size);

        sh = flat(sh);
        // cubeMap.destroy();
    }

    // const irradianceMap = createIrradianceCube(regl, envMap, irradianceCubeSize);

    function createMap() {
        const maps = {
            envMap,
            isHDR,
            prefilterMap,
            // dfgLUT
        };

        if (sh) {
            maps['sh'] = sh;
        }

        if (config.format === 'array') {
            maps['envMap'] = {
                width: envMap.width,
                height: envMap.height,
                faces: getEnvmapPixels(regl, envMap, envCubeSize, isHDR)
            };
            maps['prefilterMap'] = {
                width: prefilterMap.width,
                height: prefilterMap.height,
                faces: prefilterMipmap
            };
            envMap.destroy();
            prefilterMap.destroy();
        }

        return maps;
    }
    if (callback) {
        callback(createMap());
        return;
    }
    return createMap();
}

function createSkybox(regl, cubemap, size) {
    const drawCube = regl({
        frag: skyboxFrag,
        vert: cubemapVS,
        attributes: {
            'aPosition': cubeData.vertices
        },
        uniforms: {
            'hsv': [0, 0, 0],
            'projMatrix': regl.context('projMatrix'),
            'viewMatrix': regl.context('viewMatrix'),
            'cubeMap': cubemap,
            'bias': 0,
            'size': cubemap.width,
            'environmentExposure': 1,
            'backgroundIntensity': 1
        },
        elements: cubeData.indices
    });
    const color = regl.cube({
        width: size,
        height: size,
        min: 'linear',
        mag: 'linear',
        format: 'rgba',
    });
    const envMapFBO = regl.framebufferCube({
        radius: size,
        color
    });

    // Equirectangular cube 每个面的朝向与skybox不同，所以skybox里每个面的up direction需要重新定义
    renderToCube(regl, envMapFBO, drawCube, { size }, null, [
        [0, 0, -1],
        [0, 0, -1],
        [0, 0, 1],
        [0, 0, 1],
        [0, -1, 0],
        [0, -1, 0],
    ]);
    drawCube.destroy();
    return envMapFBO;
}

function getEnvmapPixels(regl, cubemap, envCubeSize, isHDR, environmentExposure = 1, encodeRGBM = false) {
    const drawCube = regl({
        frag: (encodeRGBM ? '#define ENCODE_RGBM\n' : '') + cubemapFS,
        vert: cubemapVS,
        attributes: {
            'aPosition': cubeData.vertices
        },
        uniforms: {
            'projMatrix': regl.context('projMatrix'),
            'viewMatrix': regl.context('viewMatrix'),
            'cubeMap': cubemap,
            'exposure': environmentExposure
        },
        elements: cubeData.indices
    });
    const faces = [];
    const color = regl.texture({
        radius: envCubeSize,
        min: 'linear',
        mag: 'linear',
        type: isHDR ? 'float' : 'uint8',
        format: 'rgba'
    });
    const tmpFBO = regl.framebuffer({
        radius: envCubeSize,
        color
    });
    renderToCube(regl, tmpFBO, drawCube, {
        size: envCubeSize
    }, function (/* context, props, batchId */) {
        const pixels = regl.read();
        if (isHDR) {
            const uint16 = new Uint16Array(pixels.length);
            for (let i = 0; i < pixels.length; i++) {
                uint16[i] = Math.min(DataUtils.toHalfFloat(pixels[i]), 65504);
            }
            faces.push(uint16);
        } else {
            faces.push(pixels);
        }

    });
    drawCube.destroy();
    tmpFBO.destroy();
    return faces;
}

/**
 * Create a texture cube map from an equirectangular texture
 * @param {REGL} regl - regl reference
 * @param {REGLTexture} texture - a regl texture
 * @param {Number} [size=512] - size of the cubemap, 512 by default
 */
function createEquirectangularMapCube(regl, texture, size) {
    if (!supportFloat16(regl)) {
        throw new Error('HDR is not supported for lack of support for float 16 texture');
    }
    size = size || 512;
    const drawCube = regl({
        frag: equirectangularMapFS,
        vert: cubemapVS,
        attributes: {
            'aPosition': cubeData.vertices
        },
        uniforms: {
            'projMatrix': regl.context('projMatrix'),
            'viewMatrix': regl.context('viewMatrix'),
            'equirectangularMap': texture
        },
        elements: cubeData.indices
    });

    const color = regl.cube({
        width: size,
        height: size,
        min: 'linear mipmap linear',
        mag: 'linear',
        type: 'float16',
        format: 'rgba',
    });
    const envMapFBO = regl.framebufferCube({
        radius: size,
        color
    });

    renderToCube(regl, envMapFBO, drawCube);
    drawCube.destroy();
    return envMapFBO;
}

function createPrefilterMipmap(regl, fromCubeMap, SIZE, sampleSize, roughnessLevels, isHDR) {
    //1. 生成NormalDistribution采样的LUT
    sampleSize = sampleSize || 1024;
    roughnessLevels = roughnessLevels || 256;

    const distro = generateNormalDistribution(sampleSize, roughnessLevels);

    const distributionMap = regl.texture({
        data: distro,
        width: roughnessLevels,
        height: sampleSize,
        min: 'nearest',
        mag: 'nearest'
    });

    const drawCube = regl({
        frag: prefilterFS,
        vert: cubemapVS,
        attributes: {
            'aPosition': cubeData.vertices
        },
        uniforms: {
            'projMatrix': regl.context('projMatrix'),
            'viewMatrix': regl.context('viewMatrix'),
            'environmentMap': fromCubeMap,
            'distributionMap': distributionMap,
            'roughness': regl.prop('roughness'),
            'resolution': SIZE
        },
        elements: cubeData.indices,
        viewport: {
            x: 0,
            y: 0,
            width: regl.prop('size'),
            height: regl.prop('size')
        }
    });
    let size = SIZE;

    const color = regl.texture({
        radius: SIZE,
        min: 'linear',
        mag: 'linear',
        type: isHDR ? 'float' : 'uint8'
    });
    const tmpFBO = regl.framebuffer({
        radius: SIZE,
        color
    });

    const maxLevels = Math.log(size) / Math.log(2);//log2(SIZE); //fix to 4

    //手动构造prefilterMap各mipmap level的数据
    const mipmap = [];
    for (let i = 0; i <= maxLevels; i++) {
        const roughness = i / (maxLevels - 1);
        let faceId = 0;
        //分别绘制六个方向，读取fbo的pixel，作为某个方向的mipmap级别数据
        renderToCube(regl, tmpFBO, drawCube, {
            roughness: roughness,
            size: size
        }, function (/* context, props, batchId */) {
            const pixels = regl.read({ framebuffer: tmpFBO });
            let data = pixels;
            if (isHDR) {
                data = new Uint16Array(pixels.length);
                for (let i = 0; i < pixels.length; i++) {
                    data[i] = Math.min(DataUtils.toHalfFloat(pixels[i]), 65504);
                }
            }

            if (!mipmap[faceId]) {
                //regl要求的cube face的mipmap数据格式
                mipmap[faceId] = {
                    mipmap: []
                };
            }
            mipmap[faceId].mipmap.push(data);
            //下一个面
            faceId++;
        });
        //下一个mipmap level
        size /= 2;
        tmpFBO.resize(size);
    }
    distributionMap.destroy();
    tmpFBO.destroy();
    drawCube.destroy();
    return mipmap;
}

//因webgl限制，framebufferTexImage2D无法指定mip level
//故改用以下步骤生成:
//参考代码：
//https://github.com/JoeyDeVries/LearnOpenGL/blob/master/src/6.pbr/2.2.2.ibl_specular_textured/ibl_specular_textured.cpp#L290
//https://github.com/vorg/pragmatic-pbr/blob/master/local_modules/prefilter-cubemap/index.js
function createPrefilterCube(regl, fromCubeMap, SIZE, sampleSize, roughnessLevels, isHDR) {
    //基于rgbm格式生成mipmap
    // const faces = getEnvmapPixels(regl, fromCubeMap, fromCubeMap.width);
    // const mipmapCube = regl.cube({
    //     faces,
    //     min : 'linear mipmap linear',
    //     mag : 'linear',
    //     width: fromCubeMap.width,
    //     height: fromCubeMap.height,
    //     mipmap: true
    // });

    const mipmap = createPrefilterMipmap(regl, fromCubeMap, SIZE, sampleSize, roughnessLevels, isHDR);
    // debugger
    const prefilterMap = regl.cube({
        width: SIZE,
        height: SIZE,
        min: 'linear',
        mag: 'linear',
        type: isHDR ? 'float16' : 'uint8',
        faces: mipmap,
        format: 'rgba'
    });
    // mipmapCube.destroy();
    return { prefilterMap, prefilterMipmap: mipmap };
}

const quadVertices = new Int8Array([
    // positions     // texture Coords
    -1.0, 1.0, 0.0,
    -1.0, -1.0, 0.0,
    1.0, 1.0, 0.0,
    1.0, -1.0, 0.0,
]);
const quadTexcoords = new Int8Array([
    0.0, 1.0,
    0.0, 0.0,
    1.0, 1.0,
    1.0, 0.0,
]);

function getREGL(regl) {
    return regl.vao && regl || getDefaultREGL();
}

function generateDFGLUT(device, size, sampleSize, roughnessLevels) {
    const regl = getREGL(device);
    size = size || 256;
    sampleSize = sampleSize || 1024;
    roughnessLevels = roughnessLevels || 256;

    const distro = generateNormalDistribution(sampleSize, roughnessLevels);

    // const type = regl.hasExtension('OES_texture_half_float') ? 'float16' : 'float';
    const distributionMap = regl.texture({
        data: distro,
        width: roughnessLevels,
        height: sampleSize,
        min: 'nearest',
        mag: 'nearest'
    });

    const quadBuf = regl.buffer({ data: quadVertices, name: 'aPosition' });
    const quadTexBuf = regl.buffer({ data: quadTexcoords, name: 'aTexCoord' });
    const fbo = regl.framebuffer({
        radius: size,
        colorType: 'uint8',
        colorFormat: 'rgba',
        min: 'linear',
        mag: 'linear'
    });
    // const FSIZE = Float32Array.BYTES_PER_ELEMENT;
    const drawLUT = regl({
        frag: dfgFS,
        vert: dfgVS,
        attributes: {
            'aPosition': {
                buffer: quadBuf,
                // stride : 5 * FSIZE,
                // size : 3
            },
            'aTexCoord': {
                buffer: quadTexBuf,
                // offset : 3 * FSIZE,
                // stride : 5 * FSIZE,
                // size : 2,
            }
        },
        uniforms: {
            'distributionMap': distributionMap
        },
        framebuffer: fbo,
        viewport: {
            x: 0,
            y: 0,
            width: size,
            height: size
        },
        count: quadVertices.length / 3,
        primitive: 'triangle strip'
    });
    drawLUT();

    if (device.wgpu) {
        //webgpu
        const pixels = regl.read({
            framebuffer: fbo
        });
        return new GraphicsTexture(device, {
            data: pixels,
            width: fbo.width,
            height: fbo.height
        });
    }

    drawLUT.destroy();
    quadBuf.destroy();
    quadTexBuf.destroy();
    distributionMap.destroy();

    return fbo;

}

//因为glsl不支持位操作，所以预先生成采样LUT， 代替原代码中的采样逻辑
//https://github.com/JoeyDeVries/LearnOpenGL/blob/master/src/6.pbr/2.2.2.ibl_specular_textured/2.2.2.prefilter.fs
function generateNormalDistribution(sampleSize, roughnessLevels) {
    const pixels = new Float32Array(sampleSize * roughnessLevels * 4);
    for (let i = 0; i < sampleSize; i++) {
        const { x, y } = hammersley(i, sampleSize);

        for (let j = 0; j < roughnessLevels; j++) {
            //原fs中的ImportanceSampleGGX前半部分
            const roughness = j / roughnessLevels;
            const a = roughness * roughness;
            const phi = 2.0 * Math.PI * x;
            const cosTheta = Math.sqrt((1 - y) / (1 + (a * a - 1.0) * y));
            const sinTheta = Math.sqrt(1.0 - cosTheta * cosTheta);
            const offset = (i * roughnessLevels + j) * 4;

            const v0 = sinTheta * Math.cos(phi);
            const v1 = sinTheta * Math.sin(phi);
            pixels[offset] = Math.abs(v0 * 255);
            pixels[offset + 1] = Math.abs(v1 * 255);
            pixels[offset + 2] = cosTheta * 255;
            //在第四位中保留x和y的符号（z永远是正数），算法如下：
            //200 *（x > 0 ? 1 : 0) + 55 * (y > 0 ? 1 : 0)
            //所以片元着色器中 distro.w > 0.5时，x一定为正数
            // (distro.w - 200 / 255 * (x > 0 ? 1 : 0)) > 0.15 时，y一定为正数，55/255 = 0.21，取值0.15是为了避免误差
            pixels[offset + 3] = (v0 > 0 ? 200 : 0) + (v1 > 0 ? 55 : 0);
        }
    }
    return pixels;
}

function hammersley(i, sampleSize) {
    const x = i / sampleSize;
    let y = (i << 16 | i >>> 16) >>> 0;
    y = ((y & 1431655765) << 1 | (y & 2863311530) >>> 1) >>> 0;
    y = ((y & 858993459) << 2 | (y & 3435973836) >>> 2) >>> 0;
    y = ((y & 252645135) << 4 | (y & 4042322160) >>> 4) >>> 0;
    y = (((y & 16711935) << 8 | (y & 4278255360) >>> 8) >>> 0) / 4294967296;

    return { x, y };
}


function supportFloat16(regl) {
    return regl['_gl'] instanceof WebGL2RenderingContext || regl.hasExtension('OES_texture_half_float');
}

var PBRHelper = /*#__PURE__*/Object.freeze({
    __proto__: null,
    createIBLMaps: createIBLMaps,
    createIBLMapsAsync: createIBLMapsAsync,
    generateDFGLUT: generateDFGLUT,
    supportFloat16: supportFloat16
});

const DEFAULT_UNIFORMS = {
    'uvScale': [1, 1],
    'uvOffset': [0, 0],
    'uvRotation': 0,
    'textureOrigin': null,
    'textureWidth': null,
    'baseColorFactor': [1, 1, 1, 1],
    'emissiveFactor': [0, 0, 0],
    'baseColorIntensity': 1, //1
    'emitColorFactor': 1, //1
    'occlusionFactor': 1,
    'roughnessFactor': 0.4,
    'metallicFactor': 0, //0
    'normalMapFactor': 1, //1
    // 'uScatteringFactorPacker', //unused
    // 'uShadowReceive3_bias',
    'specularF0': 0.5, //0.5862
    // 'uStaticFrameNumShadow3', //14
    // 'uSubsurfaceScatteringFactor', //1
    // 'uSubsurfaceScatteringProfile', //unused
    // 'uSubsurfaceTranslucencyFactor': 1, //1
    // 'uSubsurfaceTranslucencyThicknessFactor', //37.4193
    // 'uAnisotropyFlipXY', //unused
    // 'uDrawOpaque', //unused
    'emitMultiplicative': 1, //0
    'normalMapFlipY': 0, //1
    'outputSRGB': 1,
    'baseColorTexture': null,
    'normalTexture': null,
    'occlusionTexture': null,
    'metallicRoughnessTexture': null,
    'emissiveTexture': null,
    'uvOrigin': [0, 0],
    'noiseTexture': null,
    'specularAAVariance': 20,
    'specularAAThreshold': 20,
    'hsv': [0, 0, 0],
    'contrast': 1,
    'bumpTexture': null,
    'bumpScale': 0.05,
    'bumpMinLayers': 5,
    'bumpMaxLayers': 20,
    'alphaTest': 0
};
class StandardMaterial extends Material {
    constructor(uniforms) {
        const defaultUniforms = extend$1({}, DEFAULT_UNIFORMS);
        if (uniforms['metallicRoughnessTexture'] || uniforms['metallicRoughnessTexture']) {
            defaultUniforms['roughnessFactor'] = 1;
            defaultUniforms['metallicFactor'] = 1;
        }
        super(uniforms, defaultUniforms);
    }
    appendDefines(defines, geometry) {
        super.appendDefines(defines, geometry);
        const uniforms = this.uniforms;
        // if (uniforms['HAS_TONE_MAPPING']) {
        //     defines['HAS_TONE_MAPPING'] = 1;
        // }
        const position = geometry.data[geometry.desc.positionAttribute];
        if (position && position.buffer && position.buffer.itemType) {
            if (position.buffer.itemType.startsWith('sint')) {
                defines['POSITION_IS_INT'] = 1;
            }
            else if (position.buffer.itemType.startsWith('uint')) {
                defines['POSITION_IS_UINT'] = 1;
            }
        }
        const normal = geometry.data[geometry.desc.normalAttribute];
        const normalItemType = normal && normal.buffer && normal.buffer.itemType;
        if (normalItemType) {
            if (normalItemType.startsWith('sint')) {
                defines['NORMAL_IS_INT'] = 1;
            }
            else if (normalItemType.startsWith('uint')) {
                defines['NORMAL_IS_UINT'] = 1;
            }
        }
        if (uniforms['GAMMA_CORRECT_INPUT']) {
            defines['GAMMA_CORRECT_INPUT'] = 1;
        }
        if (geometry.data[geometry.desc.colorAttribute]) {
            defines['HAS_COLOR'] = 1;
        }
        const color0 = geometry.data[geometry.desc.color0Attribute];
        if (color0) {
            defines['HAS_COLOR0'] = 1;
            defines['COLOR0_SIZE'] = geometry.getColor0Size();
        }
        if (geometry.data[geometry.desc.tangentAttribute]) {
            defines['HAS_TANGENT'] = 1;
        }
        else if (geometry.data[geometry.desc.normalAttribute]) {
            defines['HAS_NORMAL'] = 1;
        }
        if (geometry.data['aVertexColorType']) {
            defines['HAS_VERTEX_COLOR'] = 1;
        }
        if (!geometry.data[geometry.desc.uv0Attribute]) {
            return defines;
        }
        if (uniforms['baseColorTexture']) {
            defines['HAS_ALBEDO_MAP'] = 1;
        }
        if (uniforms['metallicRoughnessTexture']) {
            defines['HAS_METALLICROUGHNESS_MAP'] = 1;
        }
        if (uniforms['occlusionTexture'] && geometry.data[geometry.desc['uv1Attribute']]) {
            defines['HAS_AO_MAP'] = 1;
        }
        if (uniforms['emissiveTexture']) {
            defines['HAS_EMISSIVE_MAP'] = 1;
        }
        if (uniforms['normalTexture']) {
            defines['HAS_NORMAL_MAP'] = 1;
        }
        if (uniforms['bumpTexture']) {
            defines['HAS_BUMP_MAP'] = 1;
        }
        if (uniforms['skinTexture']) {
            defines['HAS_SKIN_MAP'] = 1;
        }
        if (defines['HAS_ALBEDO_MAP'] ||
            defines['HAS_METALLICROUGHNESS_MAP'] ||
            defines['HAS_AO_MAP'] ||
            defines['HAS_EMISSIVE_MAP'] ||
            defines['HAS_NORMAL_MAP'] ||
            defines['HAS_BUMP_MAP'] ||
            defines['HAS_SKIN_MAP']) {
            defines['HAS_MAP'] = 1;
        }
        if (uniforms['noiseTexture']) {
            defines['HAS_RANDOM_TEX'] = 1;
        }
        if (geometry.data[geometry.desc.tangentAttribute]) {
            defines['HAS_TANGENT'] = 1;
        }
        else if (geometry.data[geometry.desc.normalAttribute]) {
            defines['HAS_NORMAL'] = 1;
        }
        const alphaMode = uniforms['alphaMode'] && uniforms['alphaMode'].toUpperCase();
        if (alphaMode === 'MASK') {
            defines['ALPHA_MODE'] = 1;
        }
        else if (alphaMode === 'OPAQUE') {
            defines['ALPHA_MODE'] = 2;
        }
        return defines;
    }
}

class StandardSpecularGlossinessMaterial extends SpecularGlossinessMixin(StandardMaterial) {
}

var vert$2 = "#include <gl2_vert>\n#define SHADER_NAME PBR\nattribute vec3 aPosition;\n#if defined(HAS_MAP) || defined(HAS_TERRAIN_FLAT_MASK)\nattribute vec2 aTexCoord;\n#include <common_pack_float>\n#endif\n#if defined(HAS_MAP)\nuniform vec2 uvOrigin;\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nuniform float uvRotation;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#if defined(HAS_AO_MAP)\nattribute vec2 aTexCoord1;\nvarying vec2 vTexCoord1;\n#endif\n#endif\nvec3 c;\nvec3 d;\nvec4 e;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projMatrix;\nuniform mediump vec3 cameraPosition;\nuniform mat3 modelNormalMatrix;\n#ifdef HAS_SSR\nuniform mat3 modelViewNormalMatrix;\nvarying vec3 vViewNormal;\n#ifdef HAS_TANGENT\nvarying vec4 vViewTangent;\n#endif\n#endif\nvarying vec3 vModelNormal;\nvarying vec4 vViewVertex;\n#if defined(HAS_TANGENT)\nvarying vec4 vModelTangent;\nvarying vec3 vModelBiTangent;\n#endif\nvarying vec3 vModelVertex;\n#if defined(HAS_MAP)\nvarying vec2 vTexCoord;\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\n#ifdef HAS_OPACITY\nattribute float aOpacity;\n#endif\nvarying float vOpacity;\n#include <highlight_vert>\n#if defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\nvarying vec3 vColor0;\n#else\nattribute vec4 aColor0;\nvarying vec4 vColor0;\n#endif\n#endif\n#include <line_extrusion_vert>\n#include <get_output>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#include <heatmap_render_vert>\n#include <vertex_color_vert>\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nvarying vec3 vTangentViewPos;\nvarying vec3 vTangentFragPos;\n#if __VERSION__ == 100\nmat3 f(in mat3 h) {\n  vec3 i = h[0];\n  vec3 j = h[1];\n  vec3 k = h[2];\n  return mat3(vec3(i.x, j.x, k.x), vec3(i.y, j.y, k.y), vec3(i.z, j.z, k.z));\n}\n#else\nmat3 f(in mat3 h) {\n  return transpose(h);\n}\n#endif\n#endif\nvoid l(const highp vec4 q, out highp vec3 m) {\n  m = vec3(.0, .0, 1.) + vec3(2., -2., -2.) * q.x * q.zwx + vec3(2., 2., -2.) * q.y * q.wzy;\n}\nvoid l(const highp vec4 q, out highp vec3 m, out highp vec3 t) {\n  l(q, m);\n  t = vec3(1., .0, .0) + vec3(-2., 2., -2.) * q.y * q.yxw + vec3(-2., 2., 2.) * q.z * q.zwx;\n}\nconst float o = .5;\nvec2 u(vec2 v, float A) {\n  return vec2(cos(A) * (v.x - o) + sin(A) * (v.y - o) + o, cos(A) * (v.y - o) - sin(A) * (v.x - o) + o);\n}\n#if defined(HAS_MAP)\nvec2 B(vec2 v) {\n  vec2 C = decode_getTexcoord(v);\n#ifdef HAS_RANDOM_TEX\nvec2 D = uvOrigin;\n  vec2 E = C * uvScale + uvOffset;\n  return mod(D, 1.) + E;\n#else\nvec2 D = uvOrigin;\n  vec2 E = C * uvScale;\n  if(uvRotation != .0) {\n    D = u(D, uvRotation);\n    E = u(E, uvRotation);\n  }\n  return mod(D, 1.) + E + uvOffset;\n#endif\n}\n#endif\n#ifdef PICKING_MODE\n#include <fbo_picking_vert>\n#endif\n#include <excavate_vert>\nvoid main() {\n  mat4 F = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec3 G = getLineExtrudePosition(aPosition);\n  vec4 H = getPosition(G);\n#else\nvec4 H = getPosition(aPosition);\n#endif\nvModelVertex = (modelMatrix * H).xyz;\n  vec4 I = F * H;\n  vec4 J = modelViewMatrix * I;\n  vViewVertex = J;\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(I, modelMatrix);\n#else\ngl_Position = projMatrix * J;\n#endif\n#ifdef PICKING_MODE\nfloat K = 1.;\n#if defined(HAS_COLOR)\nK *= aColor.a;\n#endif\n#if defined(HAS_COLOR0) && COLOR0_SIZE == 4\nK *= aColor0.a;\n#endif\nfbo_picking_setData(gl_Position.w, K != .0);\n#else\n#if defined(HAS_MAP)\nvTexCoord = B(aTexCoord);\n#ifdef HAS_AO_MAP\nvTexCoord1 = B(aTexCoord1);\n#endif\n#ifdef HAS_I3S_UVREGION\nvUvRegion = uvRegion / 65535.;\n#endif\n#endif\n#if defined(HAS_TANGENT) || defined(HAS_NORMAL)\nmat3 L = mat3(F);\n  mat3 M = modelNormalMatrix * L;\n#if defined(HAS_TANGENT)\nvec3 t;\n  l(aTangent, d, t);\n  vModelTangent = vec4(M * t, aTangent.w);\n#else\nd = decode_getNormal(aNormal);\n#endif\nvec3 N = d;\n  vModelNormal = M * N;\n#else\nd = vec3(.0);\n  vModelNormal = vec3(.0);\n#endif\n#if defined(HAS_TANGENT)\nvModelBiTangent = cross(vModelNormal, vModelTangent.xyz) * sign(aTangent.w);\n#endif\n#ifdef HAS_SSR\nmat3 O = modelViewNormalMatrix * L;\n  vViewNormal = O * d;\n#if defined(HAS_TANGENT)\nvec4 P = vec4(t, aTangent.w);\n  vViewTangent = vec4(O * P.xyz, P.w);\n#endif\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#endif\n#ifdef HAS_OPACITY\nvOpacity = aOpacity / 255.;\n#else\nvOpacity = 1.;\n#endif\nhighlight_setVarying();\n#if defined(HAS_COLOR0)\nvColor0 = aColor0 / 255.;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(I);\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * F, H);\n#endif\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nmat3 Q = f(mat3(vModelTangent.xyz, vModelBiTangent, vModelNormal));\n  vTangentViewPos = Q * cameraPosition;\n  vTangentFragPos = Q * vModelVertex;\n#endif\n#ifdef HAS_VERTEX_COLOR\nvertexColor_update();\n#endif\n#ifdef HAS_EXCAVATE_ANALYSIS\nvCoordinateTexcoord = getCoordinateTexcoord(I);\n  vExcavateHeight = getWorldHeight(I);\n#endif\n#endif\n}";

var frag$4 = "#define PI 3.141593\n#define RECIPROCAL_PI 1.0\n#if __VERSION__ == 100\n#if defined(GL_EXT_shader_texture_lod)\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#if defined(GL_OES_standard_derivatives)\n#extension GL_OES_standard_derivatives : enable\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\n#define saturate(x)        clamp(x, 0.0, 1.0)\nprecision mediump float;\n#include <gl2_frag>\n#include <hsv_frag>\n#include <srgb_frag>\nuniform vec3 hsv;\nuniform float contrast;\nstruct MaterialUniforms {\n  vec2 roughnessMetalness;\n  vec3 albedo;\n  float alpha;\n  vec3 normal;\n  vec3 emit;\n  float ao;\n  vec3 specularColor;\n  float glossiness;\n  vec4 skinColor;\n} c;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\nuniform vec3 cameraPosition;\nuniform float alphaTest;\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nuniform vec4 diffuseFactor;\nuniform vec3 specularFactor;\nuniform float glossinessFactor;\n#if defined(HAS_DIFFUSE_MAP)\nuniform sampler2D diffuseTexture;\n#endif\n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\nuniform vec3 emissiveFactor;\nuniform vec4 baseColorFactor;\nuniform float baseColorIntensity;\nuniform float emitColorFactor;\nuniform float occlusionFactor;\nuniform float environmentExposure;\nuniform float roughnessFactor;\nuniform float metallicFactor;\nuniform float normalMapFactor;\nuniform float specularF0;\nuniform int emitMultiplicative;\nuniform int normalMapFlipY;\nuniform int outputSRGB;\nuniform mat3 environmentTransform;\n#if defined(HAS_ALBEDO_MAP)\nuniform sampler2D baseColorTexture;\n#endif\n#if defined(HAS_METALLICROUGHNESS_MAP)\nuniform sampler2D metallicRoughnessTexture;\n#endif\n#if defined(HAS_EMISSIVE_MAP)\nuniform sampler2D emissiveTexture;\n#endif\n#if defined(HAS_AO_MAP)\nuniform sampler2D occlusionTexture;\nvarying vec2 vTexCoord1;\n#endif\n#if defined(HAS_NORMAL_MAP) && defined(HAS_TANGENT)\nuniform sampler2D normalTexture;\n#endif\n#if defined(HAS_SKIN_MAP)\nuniform sampler2D skinTexture;\n#endif\n#if defined(ALPHA_MODE) && ALPHA_MODE == 1\nuniform float alphaCutoff;\n#endif\n#ifdef HAS_RANDOM_TEX\nuniform highp vec2 uvOrigin;\nuniform sampler2D noiseTexture;\n#endif\nuniform sampler2D brdfLUT;\n#if defined(HAS_IBL_LIGHTING)\nuniform vec3 hdrHSV;\nuniform samplerCube prefilterMap;\nuniform vec3 diffuseSPH[9];\nuniform vec2 prefilterMiplevel;\nuniform vec2 prefilterSize;\n#else\nuniform vec3 ambientColor;\n#endif\nuniform vec2 cameraNearFar;\nuniform vec3 light0_viewDirection;\nuniform vec4 light0_diffuse;\n#ifdef HAS_SSR\nvarying vec3 vViewNormal;\n#if defined(HAS_TANGENT)\nvarying vec4 vViewTangent;\n#endif\n#endif\nvarying vec3 vModelVertex;\nvarying vec4 vViewVertex;\n#if defined(HAS_MAP)\n#include <compute_texcoord_frag>\n#endif\nvarying vec3 vModelNormal;\n#if defined(HAS_TANGENT)\nvarying vec4 vModelTangent;\nvarying vec3 vModelBiTangent;\n#endif\n#if defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvarying vec3 vColor0;\n#else\nvarying vec4 vColor0;\n#endif\n#endif\n#if defined(HAS_COLOR)\nvarying vec4 vColor;\n#elif defined(IS_LINE_EXTRUSION)\nuniform vec4 lineColor;\n#else\nuniform vec4 polygonFill;\n#endif\n#ifdef HAS_LAYER_OPACITY\nuniform float layerOpacity;\n#endif\nvarying float vOpacity;\n#ifdef HAS_INSTANCE_COLOR\nvarying vec4 vInstanceColor;\n#endif\n#ifdef IS_LINE_EXTRUSION\nuniform float lineOpacity;\n#else\nuniform float polygonOpacity;\n#endif\n#ifdef HAS_PATTERN\nuniform sampler2D linePatternFile;\nuniform vec2 atlasSize;\nuniform float flipY;\nuniform float currentTime;\nuniform float animSpeedScale;\n#ifdef HAS_PATTERN_ANIM\nvarying float vLinePatternAnimSpeed;\n#else\nuniform float linePatternAnimSpeed;\n#endif\n#ifdef HAS_PATTERN_GAP\nvarying float vLinePatternGap;\n#else\nuniform float linePatternGap;\n#endif\nuniform vec4 linePatternGapColor;\nuniform vec2 uvScale;\nvarying float vPatternHeight;\nvarying float vLinesofar;\nvarying vec4 vTexInfo;\nvarying float vNormalY;\nvec2 d(vec2 e) {\n  vec2 f = mod(e, 1.);\n  vec2 h = vTexInfo.xy;\n  vec2 i = vTexInfo.zw;\n  return (h + f * i) / atlasSize;\n}\n#endif\n#include <heatmap_render_frag>\n#include <snow_frag>\n#include <mask_frag>\n#include <terrain_normal_frag>\n#include <vertex_color_frag>\n#include <excavate_frag>\n#ifdef HAS_RANDOM_TEX\nconst float j = .5;\nvec2 k(vec2 f, float l) {\n  return vec2(cos(l) * (f.x - j) + sin(l) * (f.y - j) + j, cos(l) * (f.y - j) - sin(l) * (f.x - j) + j);\n}\nfloat m(vec3 n) {\n  return n.x + n.y + n.z;\n}\n#endif\nvec4 o(sampler2D u, in vec2 f) {\n  \n#ifdef HAS_RANDOM_TEX\nhighp vec2 A = uvOrigin;\n  highp vec2 B = f + A - mod(A, 1.);\n  float C = texture2D(noiseTexture, .005 * B).x;\n  vec2 D = dFdx(B);\n  vec2 E = dFdx(B);\n  float F = C * 8.;\n  float G = fract(F);\n#if 1\nfloat H = floor(F);\n  float I = H + 1.;\n#else\nfloat H = floor(F + .5);\n  float I = floor(F);\n  G = min(G, 1. - G) * 2.;\n#endif\nvec2 J = sin(vec2(3., 7.) * H);\n  vec2 K = sin(vec2(3., 7.) * I);\n  float L = .5;\n  vec4 M = texture2DGradEXT(u, f + L * J, D, E);\n  vec4 N = texture2DGradEXT(u, f + L * K, D, E);\n  return mix(M, N, smoothstep(.2, .8, G - .1 * m(M.xyz - N.xyz)));\n#else\nreturn texture2D(u, f);\n#endif\n}\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nuniform sampler2D bumpTexture;\nuniform float bumpScale;\nuniform float bumpMaxLayers;\nuniform float bumpMinLayers;\nvec2 O(vec2 f, vec3 P) {\n  float Q = mix(bumpMaxLayers, bumpMinLayers, abs(dot(vec3(.0, .0, 1.), P)));\n  float R = 1. / Q;\n  float S = .0;\n  vec2 T = P.xy * bumpScale / (P.z * Q);\n  vec2 U = f;\n  float V = o(bumpTexture, U).r;\n  for(int W = 0; W < 30; W++) {\n    S += R;\n    U -= T;\n    V = o(bumpTexture, U).r;\n    if(V < S) {\n      break;\n    }\n  }\n  vec2 X = U + T;\n  float Y = V - S;\n  float Z = o(bumpTexture, X).r - S + R;\n  return mix(U, X, Y / (Y - Z));\n}\nvarying vec3 vTangentViewPos;\nvarying vec3 vTangentFragPos;\n#endif\n#define SHADER_NAME PBR\nvec3 ba() {\n  return c.albedo;\n}\nfloat bb() {\n  return c.alpha;\n}\nfloat bc() {\n  return c.roughnessMetalness.y;\n}\nfloat bd() {\n  \n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn 1. - c.glossiness;\n#else\nreturn c.roughnessMetalness.x;\n#endif\n}\nvec3 be() {\n  return c.emit;\n}\nvec4 bf() {\n  return c.skinColor;\n}\nvec3 bg() {\n  return c.normal;\n}\nfloat bh() {\n  return c.ao;\n}\nfloat bi(const in vec4 bj) {\n  return bj.r + bj.g / 255.;\n}\nvec3 bk(const in float bl, in vec3 bm, const in vec3 t, const in vec3 b, in vec3 bn) {\n  bm.xy = bl * bm.xy;\n  mat3 bo = mat3(t, b, bn);\n  return normalize(bo * bm);\n}\nfloat bp(const float bq, const vec3 bm, const vec3 br) {\n  float bs = clamp(dot(bm, br), 0., 1.);\n  float a = bq * bq;\n  float bt = a * a;\n  float bu = (bs * bt - bs) * bs + 1.;\n  return bt / (PI * bu * bu);\n}\nvec3 bv(const vec3 bw, const float bx, const in vec3 by, const in vec3 br) {\n  float bz = clamp(dot(by, br), 0., 1.);\n  bz = pow(1. - bz, 5.);\n  return bx * bz + (1. - bz) * bw;\n}\nfloat bA(const in vec3 bm, const in vec3 bB, const in float bq, const float bC) {\n  float bD = clamp(dot(bm, bB), 0., 1.);\n  float a = bq * bq;\n  float bE = bD * (bC * (1. - a) + a);\n  float bF = bC * (bD * (1. - a) + a);\n  return .5 / (bF + bE);\n}\nvec3 bG(const float bq, const vec3 bm, const vec3 bB, const vec3 by, const vec3 bH, const float bC, const float bx) {\n  vec3 br = normalize(bB + by);\n  float bI = bp(bq, bm, br);\n  float bJ = bA(bm, bB, bq, bC);\n  vec3 bK = bv(bH, bx, by, br);\n  return (bI * bJ * PI) * bK;\n}\nvec3 bL(const in vec3 bM) {\n  return RECIPROCAL_PI * bM;\n}\nvoid bN(const in vec3 bm, const in vec3 bB, const in float bC, const in float bq, const in vec3 bO, const in vec3 bH, const in vec3 bP, const in vec3 by, const in float bx, out vec3 bQ, out vec3 bR) {\n  if(bC <= .0) {\n    bR = bQ = vec3(.0);\n    return;\n  }\n  vec3 a = bC * bP;\n  vec3 bS = bG(bq, bm, bB, by, bH, bC, bx);\n  bR = a * bS;\n  bQ = a * bL(bO);\n}\n#if defined(HAS_IBL_LIGHTING)\nvec3 bT(const in vec3 bm) {\n  vec3 bn = environmentTransform * bm;\n  float x = bn.x;\n  float y = bn.y;\n  float z = bn.z;\n  vec3 bU = (diffuseSPH[0] + diffuseSPH[1] * x + diffuseSPH[2] * y + diffuseSPH[3] * z + diffuseSPH[4] * z * x + diffuseSPH[5] * y * z + diffuseSPH[6] * y * x + diffuseSPH[7] * (3. * z * z - 1.) + diffuseSPH[8] * (x * x - y * y));\n  if(length(hdrHSV) > .0) {\n    bU = hsv_apply(bU, hdrHSV);\n  }\n  return max(bU, vec3(.0));\n}\nvec3 bV(const in float bq, const in vec3 bW) {\n  vec3 bX = bW;\n  float bY = prefilterMiplevel.x;\n  float bZ = min(bY, bq * prefilterMiplevel.y);\n  vec3 ca = textureCubeLod(prefilterMap, bX, bZ).rgb;\n  if(length(hdrHSV) > .0) {\n    return hsv_apply(ca, hdrHSV);\n  } else {\n    return ca;\n  }\n}\nvec3 cb(const in vec3 cc, const in vec3 bB, const in float bq, const in vec3 cd, const in vec3 bO) {\n  float ce = 1. - bq;\n  vec3 bW = mix(cc, reflect(-bB, cc), ce * (sqrt(ce) + bq));\n  float bl = clamp(1. + dot(bW, cd), .0, 1.);\n  vec3 cf = bV(bq, environmentTransform * bW) * bl * bl;\n  return cf;\n}\n#else\nvec3 cb(const in vec3 bm, const in vec3 cg, const in float bq, const in vec3 cd, const in vec3 bO) {\n  return ambientColor * bL(bO);\n}\n#endif\nvec3 ch(const in vec3 ci, const in float bq, const in float bD, const in float bx) {\n  vec4 rgba = texture2D(brdfLUT, vec2(bD, bq)) * vec4(255., 65280.0, 255., 65280.0);\n  float b = (rgba[3] + rgba[2]);\n  float a = (rgba[1] + rgba[0]);\n  return (ci * a + b * bx) / 65535.;\n}\nvec3 cj(const in vec3 bm, const in vec3 cg, const in float bD, const in float bq, const in vec3 bH, const in vec3 cd, const in float bx, const in vec3 bO) {\n  return cb(bm, cg, bq, cd, bO) * ch(bH, bq, bD, bx);\n}\nfloat ck(const in float cl, const in float bD) {\n  float bu = bD + cl;\n  return clamp(bu * bu - 1. + cl, .0, 1.);\n}\nvoid cm() {\n  \n#ifdef HAS_MAP\nvec2 f = computeTexCoord(vTexCoord);\n#endif\n#ifdef HAS_UV_FLIP\nf.y = 1. - f.y;\n#endif\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nf = O(f, normalize(vTangentViewPos - vTangentFragPos));\n#endif\nc.albedo = baseColorIntensity * baseColorFactor.rgb;\n  c.alpha = baseColorFactor.a * vOpacity;\n#if defined(HAS_PATTERN)\nfloat cn = vLinesofar;\n  vec2 i = vTexInfo.zw;\n#ifdef HAS_PATTERN_GAP\nfloat co = vLinePatternGap;\n#else\nfloat co = linePatternGap;\n#endif\n#ifdef HAS_PATTERN_ANIM\nfloat cp = vLinePatternAnimSpeed;\n#else\nfloat cp = linePatternAnimSpeed;\n#endif\nfloat cq = ceil(i.x * vPatternHeight / i.y);\n  float cr = cq * (1. + co);\n  cp /= animSpeedScale;\n  cn += mod(currentTime * -cp * .2, cr);\n  float cs = mod(cn / cr, 1.);\n  float ct = mod(flipY * vNormalY, 1.);\n  vec2 f = d(vec2(cs * (1. + co) * uvScale[0], ct * uvScale[1]));\n  vec4 cu = texture2D(linePatternFile, f);\n  float cv = clamp(sign(1. / (1. + co) - cs) + .000001, .0, 1.);\n  cu = mix(linePatternGapColor, cu, cv);\n#ifdef IS_SQUARE_TUBE\nfloat n = clamp(sign(abs(vNormalY) - .999999), .0, 1.);\n  cu = mix(cu, vec4(1.), n);\n#endif\nc.albedo *= cu.rgb;\n  c.alpha *= cu.a;\n#endif\n#if defined(HAS_ALBEDO_MAP)\nvec4 cw = o(baseColorTexture, f);\n  c.albedo *= sRGBToLinear(cw.rgb);\n  c.alpha *= cw.a;\n#endif\n#if defined(HAS_SKIN_MAP)\nvec4 cx = o(skinTexture, f);\n  c.skinColor = cx;\n#endif\n#if defined(HAS_COLOR0)\nc.albedo *= vColor0.rgb;\n#if COLOR0_SIZE == 4\nc.alpha *= vColor0.a;\n#endif\n#endif\n#if defined(HAS_COLOR)\nc.albedo *= vColor.rgb;\n  c.alpha *= vColor.a;\n#elif defined(IS_LINE_EXTRUSION)\nc.albedo *= lineColor.rgb;\n  c.alpha *= lineColor.a;\n#else\nc.albedo *= polygonFill.rgb;\n  c.alpha *= polygonFill.a;\n#endif\n#if defined(HAS_INSTANCE_COLOR)\nc.albedo *= vInstanceColor.rgb;\n  c.alpha *= vInstanceColor.a;\n#endif\n#if defined(HAS_METALLICROUGHNESS_MAP)\nc.roughnessMetalness = o(metallicRoughnessTexture, f).gb * vec2(roughnessFactor, metallicFactor);\n#else\nc.roughnessMetalness = vec2(roughnessFactor, metallicFactor);\n#endif\nc.emit = emissiveFactor;\n#if defined(HAS_EMISSIVE_MAP)\nif(emitMultiplicative == 1) {\n    c.emit *= sRGBToLinear(o(emissiveTexture, f).rgb);\n  } else {\n    c.emit += sRGBToLinear(o(emissiveTexture, f).rgb);\n  }\n#endif\nc.emit *= emitColorFactor;\n#if defined(HAS_AO_MAP)\nvec2 cy = computeTexCoord(vTexCoord1);\n  c.ao = o(occlusionTexture, cy).r;\n#else\nc.ao = 1.;\n#endif\nc.ao *= occlusionFactor;\n#if defined(HAS_NORMAL_MAP) && defined(HAS_TANGENT)\nvec3 cz = o(normalTexture, f).xyz * 2. - 1.;\n  cz.y = normalMapFlipY == 1 ? -cz.y : cz.y;\n  c.normal = cz;\n#else\nc.normal = normalize(vModelNormal);\n#endif\n#if defined(HAS_TERRAIN_NORMAL) && defined(HAS_TANGENT)\nvec3 cz = convertTerrainHeightToNormalMap(f);\n  cz.y = normalMapFlipY == 1 ? -cz.y : cz.y;\n  c.normal = cz;\n#endif\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nc.albedo *= diffuseFactor.rgb;\n  c.alpha *= diffuseFactor.a;\n#if defined(HAS_DIFFUSE_MAP)\nvec4 cA = o(diffuseTexture, f);\n  c.albedo *= sRGBToLinear(cA.rgb);\n  c.alpha *= cA.a;\n#endif\nc.specularColor = specularFactor;\n  c.glossiness = glossinessFactor;\n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nvec4 cB = o(specularGlossinessTexture, f);\n  c.specularColor *= sRGBToLinear(cB.rgb);\n  c.glossiness *= cB.a;\n#endif\n#endif\n}\nvec3 cC(const vec3 x) {\n  const float a = 2.51;\n  const float b = .03;\n  const float cD = 2.43;\n  const float bu = .59;\n  const float cE = .14;\n  return (x * (a * x + b)) / (x * (cD * x + bu) + cE);\n}\nvec3 cF(vec3 cG) {\n  cG = cC(cG);\n  return cG = pow(cG, vec3(1. / 2.2));\n}\nuniform float specularAAVariance;\nuniform float specularAAThreshold;\nfloat cH(float bq, const vec3 cI) {\n  \n#if defined(GL_OES_standard_derivatives) || __VERSION__ == 300\nvec3 cJ = dFdx(cI);\n  vec3 cK = dFdy(cI);\n  float cL = specularAAVariance * (dot(cJ, cJ) + dot(cK, cK));\n  float cM = min(2. * cL, specularAAThreshold);\n  float cN = saturate(bq * bq + cM);\n  return sqrt(cN);\n#else\nreturn bq;\n#endif\n}\n#ifdef HAS_SSR\nuniform sampler2D TextureDepth;\nuniform highp vec2 outSize;\nuniform float ssrFactor;\nuniform float ssrQuality;\nuniform sampler2D TextureReflected;\nuniform highp mat4 projMatrix;\nuniform mat4 invProjMatrix;\nuniform vec4 outputFovInfo[2];\nuniform mat4 reprojViewProjMatrix;\nvec3 cO(const in mat4 cP, const in vec3 cQ) {\n  vec4 cR = cP * vec4(cQ, 1.);\n  return vec3(.5 + .5 * cR.xy / cR.w, cR.w);\n}\nvec3 cS(const in float cT, const in vec2 f) {\n  return texture2D(TextureReflected, f).rgb;\n}\nfloat cU(float cV) {\n  highp mat4 cP = projMatrix;\n  highp float z = cV * 2. - 1.;\n  return -cP[3].z / (z + cP[2].z);\n}\nfloat cW(const vec2 f) {\n  float cV = bi(texture2D(TextureDepth, f));\n  return cV;\n}\nfloat cX(const in vec2 cY, const in float cZ) {\n  vec3 da = vec3(.06711056, .00583715, 52.9829189);\n  return fract(da.z * fract(dot(cY.xy + cZ * vec2(47., 17.) * .695, da.xy))) * .5;\n}\nvec3 db(const in float cZ, const in vec3 dc, const in vec3 dd, const in vec3 de, const in vec3 cg, const in float df) {\n  vec2 dg;\n  dg.x = cX(gl_FragCoord.yx, cZ);\n  dg.y = fract(dg.x * 52.9829189);\n  dg.y = mix(dg.y, 1., .7);\n  float dh = 2. * 3.14159 * dg.x;\n  float di = pow(max(dg.y, .000001), df / (2. - df));\n  float dj = sqrt(1. - di * di);\n  vec3 dk = vec3(dj * cos(dh), dj * sin(dh), di);\n  dk = dk.x * dc + dk.y * dd + dk.z * de;\n  return normalize((2. * dot(cg, dk)) * dk - cg);\n}\nfloat dl(const in float cZ) {\n  return (cX(gl_FragCoord.xy, cZ) - .5);\n}\nvec3 dm(const in vec3 dn, const in float dp, const in vec3 dq) {\n  vec3 dr = cO(projMatrix, vViewVertex.xyz + dq * dp);\n  dr.z = 1. / dr.z;\n  dr -= dn;\n  float ds = min(1., .99 * (1. - dn.x) / max(1e-5, dr.x));\n  float dt = min(1., .99 * (1. - dn.y) / max(1e-5, dr.y));\n  float dw = min(1., .99 * dn.x / max(1e-5, -dr.x));\n  float dx = min(1., .99 * dn.y / max(1e-5, -dr.y));\n  return dr * min(ds, dt) * min(dw, dx);\n}\nfloat dy(const in vec3 dn, const in vec3 dr, inout float dz, inout float dA) {\n  float dB = (dA + dz) * .5;\n  vec3 dC = dn + dr * dB;\n  float z = cW(dC.xy);\n  float cV = cU(z);\n  float dD = -1. / dC.z;\n  dz = cV > dD ? dz : dB;\n  dA = cV > dD ? dB : dA;\n  return dB;\n}\nvec4 dE(const in vec3 dn, const in float dp, in float dF, const in vec3 dq, const in float bq, const in float cZ) {\n  int dG = 20;\n  float dH = 1. / float(dG);\n  dF *= dH;\n  vec3 dr = dm(dn, dp, dq);\n  float dI = dH;\n  vec3 dJ = vec3(.0, dI, 1.);\n  vec3 dC;\n  float z, cV, dD, dK, dL, dM;\n  bool dN;\n  float dO = 1.;\n  float dB;\n  for(int W = 0; W < dG; W++) {\n    dC = dn + dr * dJ.y;\n    z = cW(dC.xy);\n    cV = cU(z);\n    dD = -1. / dC.z;\n    float dP = clamp(sign(.999 - z), .0, 1.);\n    dK = dP * (dD - cV);\n    dK *= clamp(sign(abs(dK) - dp * dH * dH), .0, 1.);\n    dN = abs(dK + dF) < dF;\n    dL = clamp(dJ.x / (dJ.x - dK), .0, 1.);\n    dM = dN ? dJ.y + dL * dH - dH : 1.;\n    dJ.z = min(dJ.z, dM);\n    dJ.x = dK;\n    if(dN) {\n      float dz = dJ.y - dH;\n      float dA = dJ.y;\n      dB = dy(dn, dr, dz, dA);\n      dB = dy(dn, dr, dz, dA);\n      dB = dy(dn, dr, dz, dA);\n      dO = dB;\n      break;\n    }\n    dJ.y += dH;\n  }\n  return vec4(dn + dr * dO, 1. - dO);\n}\nvec4 dQ(in vec4 dR, const in float dS, const in vec3 dT, const in vec3 dU, const in float bq) {\n  vec4 dV = mix(outputFovInfo[0], outputFovInfo[1], dR.x);\n  dR.xyz = vec3(mix(dV.xy, dV.zw, dR.y), 1.) * -1. / dR.z;\n  dR.xyz = (reprojViewProjMatrix * vec4(dR.xyz, 1.)).xyw;\n  dR.xy /= dR.z;\n  float dW = clamp(6. - 6. * max(abs(dR.x), abs(dR.y)), .0, 1.);\n  dR.xy = .5 + .5 * dR.xy;\n  vec3 dX = dU * cS(bq * (1. - dR.w), dR.xy);\n  return vec4(mix(dT, dX, dS * dW), 1.);\n}\nvec3 ssr(const in vec3 dT, const in vec3 dU, const in float bq, const in vec3 bm, const in vec3 cg) {\n  float dY = .0;\n  vec4 bU = vec4(.0);\n  float df = bq * bq;\n  df = df * df;\n  vec3 dZ = abs(bm.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 dc = normalize(cross(dZ, bm));\n  vec3 dd = cross(bm, dc);\n  float dS = ssrFactor * clamp(-4. * dot(cg, bm) + 3.8, .0, 1.);\n  dS *= clamp(4.7 - bq * 5., .0, 1.);\n  vec3 dn = cO(projMatrix, vViewVertex.xyz);\n  dn.z = 1. / dn.z;\n  vec3 dq = db(dY, dc, dd, bm, cg, df);\n  float dp = mix(cameraNearFar.y + vViewVertex.z, -vViewVertex.z - cameraNearFar.x, dq.z * .5 + .5);\n  float dF = .5 * dp;\n  vec4 dR;\n  if(dot(dq, bm) > .001 && dS > .0) {\n    dR = dE(dn, dp, dF, dq, bq, dY);\n    if(dR.w > .0)\n      bU += dQ(dR, dS, dT, dU, bq);\n    \n  }\n  return bU.w > .0 ? bU.rgb / bU.w : dT;\n}\n#endif\n#include <highlight_frag>\nvec4 ea(in vec4 eb) {\n  return vec4(mix(pow(eb.rgb, vec3(.41666)) * 1.055 - vec3(.055), eb.rgb * 12.92, vec3(lessThanEqual(eb.rgb, vec3(.0031308)))), eb.a);\n}\nvec4 ec(vec4 eb) {\n  return (ea(eb));\n}\nvoid main() {\n  cm();\n  vec3 cg = normalize(cameraPosition - vModelVertex.xyz);\n#if defined(HAS_DOUBLE_SIDE)\nvec3 cd = gl_FrontFacing ? normalize(vModelNormal) : -normalize(vModelNormal);\n#else\nvec3 cd = normalize(vModelNormal);\n#endif\n#if defined(HAS_TANGENT)\nvec4 ed;\n  ed = vModelTangent;\n#if defined(HAS_DOUBLE_SIDE)\ned.xyz = gl_FrontFacing ? normalize(ed.xyz) : -normalize(ed.xyz);\n#else\ned.xyz = normalize(ed.xyz);\n#endif\nvec3 ee = normalize(vModelBiTangent);\n#endif\nfloat bw = .08 * specularF0;\n  float ef = bc();\n  vec3 bO = ba();\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nvec3 eg = c.specularColor;\n#else\nvec3 eg = mix(vec3(bw), bO, ef);\n#endif\nbO *= 1. - ef;\n  float eh = clamp(50.0 * eg.g, .0, 1.);\n  float ei = bd();\n  if(specularAAVariance > .0) {\n    ei = cH(ei, cd);\n  }\n  vec3 ej = be();\n  vec3 ek = bg();\n  vec3 el = vec3(ek);\n#if defined(HAS_TANGENT) && (defined(HAS_NORMAL_MAP) || defined(HAS_TERRAIN_NORMAL))\nel = bk(normalMapFactor, el, ed.xyz, ee, cd);\n#endif\nvec3 cA = vec3(.0);\n  vec3 bH = vec3(.0);\n#if defined(HAS_IBL_LIGHTING)\ncA = bO * bT(el) * .5;\n#else\ncA = bO * ambientColor;\n#endif\nfloat bD = dot(el, cg);\n  bH = cj(el, cg, bD, ei, eg, cd, eh, bO);\n  float em;\n  float en = 1.;\n  float eo = bh();\n  cA *= environmentExposure * eo;\n#ifdef HAS_IBL_LIGHTING\nen = ck(eo, bD);\n#endif\n#ifdef HAS_SSR\nvec3 ep = normalize(gl_FrontFacing ? vViewNormal : -vViewNormal);\n  vec3 eq = ep;\n#if defined(HAS_TANGENT) && (defined(HAS_NORMAL_MAP) || defined(HAS_TERRAIN_NORMAL))\nvec4 er;\n  er = vViewTangent;\n  er = gl_FrontFacing ? er : -er;\n  er.xyz = normalize(er.xyz);\n  vec3 es = normalize(cross(ep, er.xyz)) * er.w;\n  eq = bk(normalMapFactor, ek, er.xyz, es, ep);\n#endif\nbH = ssr(bH, eg * en, ei, eq, -normalize(vViewVertex.xyz));\n#endif\nbH *= environmentExposure * en;\n  vec3 et, eu;\n  vec3 ev = vModelNormal;\n  vec3 ew = -light0_viewDirection;\n  float ex = saturate(dot(ew, el));\n  bN(el, cg, ex, max(.045, ei), bO, eg, light0_diffuse.rgb, ew, eh, eu, et);\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat ey = shadow_computeShadow();\n  eu = shadow_blend(eu, ey).rgb;\n  et = shadow_blend(et, ey).rgb;\n#endif\ncA += eu;\n  bH += et;\n  cA += ej;\n  vec3 ez = bH + cA;\n  if(outputSRGB == 1)\n    ez = linearTosRGB(ez);\n  \n#ifdef HAS_SKIN_MAP\nvec4 eA = bf();\n  ez.rgb = ez.rgb * (1. - eA.a) + eA.rgb * eA.a;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nez.rgb = shadow_blend(ez.rgb, ey).rgb;\n#endif\n#endif\nfloat eB = bb();\n  if(eB < alphaTest) {\n    discard;\n  }\n#if defined(ALPHA_MODE)\n#if ALPHA_MODE == 1\nif(eB < alphaCutoff) {\n    discard;\n  } else {\n    eB = 1.;\n  }\n#else\neB = 1.;\n#endif\n#endif\n#if defined(IS_LINE_EXTRUSION)\neB *= lineOpacity;\n#else\neB *= polygonOpacity;\n#endif\nglFragColor = vec4(ez * eB, eB);\n#ifdef HAS_VERTEX_COLOR\nglFragColor *= vertexColor_get();\n#endif\n#ifdef HAS_EXCAVATE_ANALYSIS\nglFragColor = excavateColor(glFragColor);\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\n#ifdef HAS_SNOW\nglFragColor.rgb = snow(glFragColor, bg(), 1.);\n#endif\nif(contrast != 1.) {\n    glFragColor = contrastMatrix(contrast) * glFragColor;\n  }\n  if(length(hsv) > .0) {\n    glFragColor = hsv_apply(glFragColor, hsv);\n  }\n#ifdef OUTPUT_NORMAL\nglFragColor = vec4(cd, 1.);\n#endif\nglFragColor = highlight_blendColor(glFragColor);\n#ifdef HAS_LAYER_OPACITY\nglFragColor *= layerOpacity;\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

//http://codeflow.org/entries/2012/aug/02/easy-wireframe-display-with-barycentric-coordinates/
class StandardShader extends MeshShader {
    constructor(config = {}) {
        let extraCommandProps = config.extraCommandProps || {};
        const extraUniforms = config.uniforms;
        extraCommandProps = extend$1({}, extraCommandProps/*, {
            blend : {
                enable: true,
                func: {
                    src: 'one',
                    dst: 'one minus src alpha'
                    // srcRGB: 'src alpha',
                    // srcAlpha: 1,
                    // dstRGB: 'one minus src alpha',
                    // dstAlpha: 'one minus src alpha'
                },
                equation: 'add'
            }
        }*/);

        const defines = config.defines || {};

        // const modelMatrix = [1, -0.0000, -0.0000, 0, 0, 0.0000, 1, 0, 0.0000, -1, 0.0000, 0, -155.4500, 0, 287.6630, 1];
        // const modelViewMatrix = [-0.2274, -0.5468, 0.8058, 0, 0, 0.8275, 0.5615, 0, -0.9738, 0.1277, -0.1882, 0, 71.0551, 174.0461, -2710.2300, 1];
        // const viewMatrix = mat4.multiply([], modelViewMatrix, mat4.invert([], modelMatrix));
        // const modelView = mat4.multiply([], viewMatrix, modelMatrix);
        // const inverted = mat4.invert(modelView, modelView);
        // const transposed = mat4.transpose(inverted, inverted);
        // console.log(mat3.fromMat4([], transposed));
        const modelNormalMatrix = [];
        const tempMat4 = [];
        const modelViewNormalMatrix = [];
        const modelViewMatrix = [];
        const environmentTransform = [];

        const uniforms = [
            //vert中的uniforms
            {
                name: 'modelNormalMatrix',
                type: 'function',
                fn: (_, props) => {
                    // const model3 = mat3.fromMat4([], props['modelMatrix']);
                    // const transposed = mat3.transpose(model3, model3);
                    // const inverted = mat3.invert(transposed, transposed);
                    // return inverted;
                    return mat3.fromMat4(modelNormalMatrix, props['modelMatrix']);
                }
            },
            {
                name: 'modelViewNormalMatrix',
                type: 'function',
                fn: (_, props) => {
                    const modelView = mat4.multiply(tempMat4, props['viewMatrix'], props['modelMatrix']);
                    const inverted = mat4.invert(modelView, modelView);
                    const transposed = mat4.transpose(inverted, inverted);
                    return mat3.fromMat4(modelViewNormalMatrix, transposed);
                    // const modelView = mat4.multiply([], props['viewMatrix'], props['modelMatrix']);
                    // return mat3.fromMat4([], modelView);
                }
            },
            // {
            //     name: 'uProjViewModelMatrix',
            //     type: 'function',
            //     fn: (_, props) => {
            //         return mat4.multiply([], props['projViewMatrix'], props['modelMatrix']);
            //     }
            // },
            {
                name: 'modelViewMatrix',
                type: 'function',
                fn: (_, props) => {
                    return mat4.multiply(modelViewMatrix, props['viewMatrix'], props['modelMatrix']);
                }
            },
            {
                name: 'environmentTransform',
                type: 'function',
                global: true,
                fn: (_, props) => {
                    const orientation = props['environmentOrientation'] || 0;
                    return mat3.fromRotation(environmentTransform, Math.PI * orientation / 180);
                }
            }

        ];
        if (extraUniforms) {
            uniforms.push(...extraUniforms);
        }
        const vertSource = config.vert || vert$2;
        const fragSource = config.frag || frag$4;
        const wgslVertSource = config.wgslVert || getWGSLSource('gl_standard_vert');
        const wgslFragSource = config.wgslFrag || getWGSLSource('gl_standard_frag');
        const shaderConfig = {
            vert: vertSource,
            frag: fragSource,
            wgslVert: wgslVertSource,
            wgslFrag: wgslFragSource,
            uniforms,
            extraCommandProps,
            defines
        };
        shaderConfig.name = config.name || 'standard';
        super(shaderConfig);
        this.version = 300;
    }

    getGeometryDefines(geometry) {
        const defines = {};
        if (geometry.data[geometry.desc.tangentAttribute]) {
            defines['HAS_TANGENT'] = 1;
        } else if (geometry.data[geometry.desc.normalAttribute]) {
            defines['HAS_NORMAL'] = 1;
        }
        if (geometry.data[geometry.desc.colorAttribute]) {
            defines['HAS_COLOR'] = 1;
        }
        if (geometry.data[geometry.desc.color0Attribute]) {
            defines['HAS_COLOR0'] = 1;
            defines['COLOR0_SIZE'] = geometry.getColor0Size();
        }
        return defines;
    }
}

var vert$1 = "#define SHADER_NAME depth_vert\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projMatrix;\nuniform vec2 outSize;\nuniform vec2 halton;\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec4 d = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 d = getPosition(aPosition);\n#endif\nvec4 e = modelViewMatrix * c * d;\n  mat4 f = projMatrix;\n  f[2].xy += halton.xy / outSize.xy;\n  gl_Position = f * e;\n}";

var frag$3 = "#define SHADER_NAME depth_frag\nprecision highp float;\nvoid main() {\n  gl_FragColor = vec4(1., .0, .0, 1.);\n}";

// 2021-02-05
// ssr逻辑修改后不再需要
class StandardDepthShader extends MeshShader {
    constructor(config = {}) {
        const modelViewMatrix = [];
        const uniforms = [
            {
                name : 'modelViewMatrix',
                type : 'function',
                fn : (context, props) => {
                    return mat4.multiply(modelViewMatrix, props['viewMatrix'], props['modelMatrix']);
                }
            }
        ];
        const extraCommandProps = config.extraCommandProps;
        super({
            vert: vert$1,
            frag: frag$3,
            uniforms,
            extraCommandProps,
            defines: config.defines
        });
    }
}

function loginIBLResOnCanvas$2(canvas, regl, map) {
    if (!canvas.dfgLUT) {
        canvas.dfgLUT = generateDFGLUT(regl);
        canvas.dfgLUT.mtkRefCount = 0;
        if (map) {
            const listener = (...args) => {
                return onUpdatelights.call(this, canvas, regl, ...args);
            };
            map.on('updatelights', listener);
            canvas._iblResListener = listener;
        }
    }
    canvas.dfgLUT.mtkRefCount++;
    const lightManager = map.getLightManager();
    const resource = lightManager && lightManager.getAmbientResource();
    if (!resource) {
        return {
            dfgLUT: canvas.dfgLUT,
            iblTexes: null
        };
    }
    if (!canvas.iblTexes) {
        canvas.iblTexes = createIBLTextures$1(regl, map);
    }

    return {
        dfgLUT: canvas.dfgLUT,
        iblTexes: canvas.iblTexes
    };
}

function getIBLResOnCanvas$2(canvas) {
    const { dfgLUT, iblTexes } = canvas;
    return {
        dfgLUT,
        iblTexes
    };
}

function logoutIBLResOnCanvas$2(canvas, map) {
    let del = false;
    if (canvas.dfgLUT) {
        canvas.dfgLUT.mtkRefCount--;
        if (canvas.dfgLUT.mtkRefCount <= 0) {
            del = true;
            if (map) {
                const listener = canvas._iblResListener;
                map.off('updatelights', listener);
            }
            canvas.dfgLUT.destroy();
            delete canvas.dfgLUT;
        }
    }
    if (canvas.iblTexes && del) {
        disposeIBLTextures$1(canvas.iblTexes);
        delete canvas.iblTexes;
    }
}

function onUpdatelights(canvas, regl, e) {
    if (e.ambientUpdate) {
        const { iblTexes } = canvas;
        const map = e.target;
        if (iblTexes) {
            disposeIBLTextures$1(iblTexes);
            canvas.iblTexes = createIBLTextures$1(regl, map);
        } else {
            canvas.iblTexes = createIBLTextures$1(regl, map);
        }
        map.getRenderer().setToRedraw();
    }

}

const DEFAULT_HALTON = [0, 0];
function getPBRUniforms$2(map, iblTexes, dfgLUT, ssr, jitter) {
    const viewMatrix = map.viewMatrix;
    const projMatrix = map.projMatrix;
    const cameraPosition = map.cameraPosition;
    const canvas = map.getRenderer().canvas;
    const lightUniforms = getLightUniforms(map, iblTexes);
    const uniforms = extend$1({
        viewMatrix,
        projMatrix,
        projViewMatrix: map.projViewMatrix,
        cameraPosition: cameraPosition,
        outSize: [canvas.width, canvas.height],
        cameraNearFar: [map.cameraNear, map.cameraFar]
    }, lightUniforms);
    uniforms['brdfLUT'] = dfgLUT;
    if (ssr && ssr.renderUniforms) {
        extend$1(uniforms, ssr.renderUniforms);
    }
    if (jitter) {
        uniforms['halton'] = jitter;
    } else {
        uniforms['halton'] = DEFAULT_HALTON;
    }
    return uniforms;
}

function getLightUniforms(map, iblTexes) {
    const lightManager = map.getLightManager();
    const iblMaps = lightManager && lightManager.getAmbientResource();
    const ambientLight = lightManager && lightManager.getAmbientLight() || {};
    const directionalLight = lightManager && lightManager.getDirectionalLight() || {};
    let uniforms;
    if (iblMaps) {
        const cubeSize = iblTexes.prefilterMap.width;
        const mipLevel = Math.log(cubeSize) / Math.log(2);
        uniforms = {
            'prefilterMap': iblTexes.prefilterMap,
            'diffuseSPH': iblTexes.sh,
            'prefilterMiplevel': [mipLevel, mipLevel],
            'prefilterSize': [cubeSize, cubeSize],
            'hdrHSV': ambientLight.hsv || [0, 0, 0]
        };
    } else {
        uniforms = {
            'ambientColor': ambientLight.color || [0.2, 0.2, 0.2]
        };
    }
    uniforms['environmentExposure'] = isNumber$2(ambientLight.exposure) ? ambientLight.exposure : 1; //2]
    uniforms['environmentOrientation'] = ambientLight.orientation || 0;

    uniforms['light0_diffuse'] = [...(directionalLight.color || [1, 1, 1]), 1];
    uniforms['light0_viewDirection'] = directionalLight.direction || [1, 1, -1];
    return uniforms;
}

function createIBLTextures$1(regl, map) {
    const lightManager = map.getLightManager();
    const resource = lightManager && lightManager.getAmbientResource();
    if (!resource) {
        return null;
    }
    const isHDR = resource.isHDR;
    return {
        'prefilterMap': regl.cube({
            width: resource.prefilterMap.width,
            height: resource.prefilterMap.height,
            faces: resource.prefilterMap.faces,
            min : 'linear',
            mag : 'linear',
            format: 'rgba',
            type: isHDR ? 'float16' : 'uint8'
            // mipmap: true
        }),
        'envMap': regl.cube({
            width: resource.envMap.width,
            height: resource.envMap.height,
            faces: resource.envMap.faces,
            min : 'linear',
            mag : 'linear',
            format: 'rgba',
            type: isHDR ? 'float16' : 'uint8'
        }),
        'sh': resource.sh
    };
}

function disposeIBLTextures$1(iblTexes) {
    for (const p in iblTexes) {
        if (iblTexes[p] && iblTexes[p].destroy) {
            iblTexes[p].destroy();
        }
        delete iblTexes[p];
    }
}


function isSupported(regl) {
    if (regl.wgpu) {
        return true;
    }
    return regl.hasExtension('EXT_shader_texture_lod');
}

var PBRUtils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    createIBLTextures: createIBLTextures$1,
    disposeIBLTextures: disposeIBLTextures$1,
    getIBLResOnCanvas: getIBLResOnCanvas$2,
    getPBRUniforms: getPBRUniforms$2,
    isSupported: isSupported,
    loginIBLResOnCanvas: loginIBLResOnCanvas$2,
    logoutIBLResOnCanvas: logoutIBLResOnCanvas$2
});

var vsmFrag = "#define SHADER_NAME vsm_mapping\nprecision highp float;\nvarying vec4 vPosition;\n#ifdef PACK_FLOAT\n#include <common_pack_float>\n#endif\nvoid main() {\n  \n#if defined(USE_ESM)\n#ifdef PACK_FLOAT\ngl_FragColor = common_encodeDepth(gl_FragCoord.z);\n#else\ngl_FragColor = vec4(gl_FragCoord.z, .0, .0, 1.);\n#endif\n#endif\n}";

var vsmVert = "attribute vec3 aPosition;\nuniform mat4 lightProjViewModelMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\n#include <line_extrusion_vert>\n#include <get_output>\nvarying vec4 vPosition;\nvoid main() {\n  mat4 c = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec3 d = getLineExtrudePosition(aPosition);\n  vec4 e = getPosition(d);\n#else\nvec4 e = getPosition(aPosition);\n#endif\ngl_Position = lightProjViewModelMatrix * c * e;\n  vPosition = gl_Position;\n}";

class ShadowMapShader extends MeshShader {

    constructor(defines) {
        super({
            name: 'shadow-map',
            vert : vsmVert,
            frag : vsmFrag,
            wgslVert: getWGSLSource('gl_vsm_mapping_vert'),
            wgslFrag: getWGSLSource('gl_vsm_mapping_frag'),
            uniforms : [
                {
                    name : 'lightProjViewModelMatrix',
                    type : 'function',
                    fn : function (context, props) {
                        return mat4.multiply([], props['lightProjViewMatrix'], props['modelMatrix']);
                    }
                }
            ],
            extraCommandProps: {
                // cull: {
                //     enable: true,
                //     face: 'back'
                // }
            },
            defines
        });
    }

    filter(mesh) {
        return mesh.castShadow;
    }
}

var frag$2 = "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D textureSource;\nuniform vec2 resolution;\n#include <common_pack_float>\nvoid main() {\n  float c = .0;\n  float d = .0;\n  for(int x = -BOXBLUR_OFFSET; x <= BOXBLUR_OFFSET; ++x)\n    for(int y = -BOXBLUR_OFFSET; y <= BOXBLUR_OFFSET; ++y) {\n      vec2 e = vTexCoord.st + vec2(float(x) / resolution.x, float(y) / resolution.y);\n      e = clamp(e, .0, 1.);\n      float f = common_decodeDepth(texture2D(textureSource, e));\n      float s = max(.0, sign(1. - f));\n      d += sign(f) * s;\n      c += f;\n    }\n  float h = c / max(1., d);\n  gl_FragColor = common_encodeDepth(h);\n}";

class BoxShadowBlurShader extends QuadShader {

    constructor({ blurOffset }) {
        super({
            name: 'box-shadow-blur',
            frag: frag$2,
            wgslFrag: getWGSLSource('gl_box_shadow_blur_frag'),
            defines : {
                'BOXBLUR_OFFSET' : blurOffset || 2
            }
        });
        this._blurOffset = blurOffset || 2;
    }

    getMeshCommand(regl, mesh) {
        const key = this.dkey + '_box_shadow_blur_' + this._blurOffset;
        if (!this.commands[key]) {
            this.commands[key] = this.createMeshCommand(regl, mesh);
        }
        return this.commands[key];
    }
}

let getFrustumWorldSpace = null, getDirLightCameraProjView = null;

class ShadowPass {
    constructor(renderer, { width, height, blurOffset, defines }) {
        this.renderer = renderer;
        this.width = width || 512;
        this.height = height || 512;
        this.blurOffset = isNil$2(blurOffset) ? 2 : blurOffset;
        this._init(defines);
    }

    render(scene, { cameraProjViewMatrix, lightDir, farPlane, cameraLookAt }) {
        const lightProjViewMatrix = this._renderShadow(scene, cameraProjViewMatrix, lightDir, farPlane, cameraLookAt);
        return {
            lightProjViewMatrix,
            shadowMap : this.blurTex || this.depthTex,
            depthFBO : this.depthFBO,
            blurFBO : this.blurFBO
        };
    }

    resize(width, height) {
        if (this.depthTex) {
            this.depthTex.resize(width, height);
            this.depthFBO.resize(width, height);
        }
        this.width = width;
        if (this.blurFBO) {
            this.blurTex.resize(width, height);
            this.blurFBO.resize(width, height);
        }
        this.height = height;
        return this;
    }

    _renderShadow(scene, cameraProjViewMatrix, lightDir, farPlane, cameraLookAt) {
        const renderer = this.renderer;
        const frustum = getFrustumWorldSpace(cameraProjViewMatrix);
        if (farPlane) {
            for (let i = 4; i < 8; i++) {
                frustum[i] = farPlane[i - 4];
            }
        }
        //TODO 计算Frustum和scene的相交部分，作为光源的frustum
        //TODO 遍历scene中的图形，如果aabb不和frustum相交，就不绘制
        const lightProjViewMatrix = getDirLightCameraProjView(cameraLookAt, frustum, lightDir);
        renderer.clear({
            color : [1, 0, 0, 1],
            depth : 1,
            framebuffer : this.depthFBO
        });
        renderer.render(this.shadowMapShader, { lightProjViewMatrix }, scene, this.depthFBO);
        if (this.blurFBO) {
            if (!this.boxBlurShader) {
                this.boxBlurShader = new BoxShadowBlurShader({
                    blurOffset : this.blurOffset
                });
            }
            renderer.clear({
                color : [1, 0, 0, 1],
                depth : 1,
                framebuffer : this.blurFBO
            });
            const depthTex = this.depthTex;
            const defines = this.boxBlurShader.shaderDefines;
            if (depthTex.texture && depthTex.texture.sampleCount > 1) {
                defines['HAS_MULTISAMPLED'] = 1;
            } else {
                delete defines['HAS_MULTISAMPLED'];
            }
            this.boxBlurShader.setDefines(defines);
            renderer.render(
                this.boxBlurShader,
                {
                    resolution : [depthTex.width, depthTex.height],
                    textureSource : depthTex
                },
                null,
                this.blurFBO
            );
        }
        return lightProjViewMatrix;
    }

    _init(defines) {
        const regl = this.renderer.device;
        const type = 'uint8';
        const width = this.width,
            height = this.height;
        this.depthTex = regl.texture({
            width, height,
            format: 'rgba',
            type,
            min: 'nearest',
            mag: 'nearest',
        });

        this.shadowMapShader = new ShadowMapShader(defines);
        this.shadowMapShader.filter = m => m.castShadow;

        this.depthFBO = regl.framebuffer({
            color : this.depthTex
        });

        if (this.blurOffset <= 0) {
            return;
        }

        this.blurTex = regl.texture({
            width, height,
            format : 'rgba',
            type,
            min : 'linear',
            mag : 'linear'
        });

        this.blurFBO = regl.framebuffer({
            color : this.blurTex
        });
    }


    dispose() {
        if (this.depthTex) {
            this.depthTex.destroy();
            this.depthFBO.destroy();
            delete this.depthTex;
            delete this.depthFBO;
        }
        if (this.blurTex) {
            this.blurTex.destroy();
            this.blurFBO.destroy();
            delete this.blurTex;
            delete this.blurFBO;
        }
        if (this.shadowMapShader) {
            this.shadowMapShader.dispose();
            delete this.shadowMapShader;
        }
        if (this.boxBlurShader) {
            this.boxBlurShader.dispose();
            delete this.boxBlurShader;
        }
    }

}


/**
 * Get camera's frustum's coordinates in world space with given projection view matrix
 * @param {Number[]} cameraProjView camera's projection * view matrix
 */
getFrustumWorldSpace = function () {
    const clipPlanes = [
        // near
        [-1, -1, -1, 1], [1, -1, -1, 1], [1,  1, -1, 1],  [-1,  1, -1, 1],
        // far
        [-1, -1, 1, 1],	[1, -1, 1, 1],	[1,  1, 1, 1],  [-1,  1, 1, 1]
    ];
    const inverseProjectionMatrix = new Array(16);
    return function (cameraProjView) {
        mat4.invert(inverseProjectionMatrix, cameraProjView);
        const frustum = [];

        for (let i = 0; i < clipPlanes.length; i++) {
            const projWorldSpacePosition = vec4.transformMat4([], clipPlanes[i], inverseProjectionMatrix);
            vec4.scale(projWorldSpacePosition,  projWorldSpacePosition, 1 / projWorldSpacePosition[3]);
            frustum.push(projWorldSpacePosition);
        }
        // const cameraPos = vec4.transformMat4([], [0, 0, -1, 1], inverseProjectionMatrix);
        // vec4.scale(cameraPos, cameraPos, 1 / cameraPos[3]);
        return frustum;
    };
}();


//https://www.gamedev.net/forums/topic/672664-fitting-directional-light-in-view-frustum/?page=2
/**
 * Get directional light's camera projection * view matrix in shadow mapping
 * @param {Number[][]} frustum frustum
 * @param {Number[]} lightDir  light direction
 */
getDirLightCameraProjView = function () {
    let transf = new Array(4);
    const lightDirection = new Array(3);
    const frustumCenter = [0, 0, 0, 0];
    const cameraUp = [0, 1, 0];
    const v3 = new Array(3);
    let lvMatrix = new Array(16);
    let lpMatrix = new Array(16);
    const cropMatrix = new Array(16);
    const scaleV = [1, 1, 1];
    const offsetV = [0, 0, 0];
    return function (cameraLookAt, frustum, lightDir) {

        // vec4.scale(frustumCenter, frustumCenter, 0);
        // for (let i = 4; i < frustum.length; i++) {
        //     vec4.add(frustumCenter, frustumCenter, frustum[i]);
        // }
        // vec4.scale(frustumCenter, frustumCenter, 1 / 4);
        vec4.set(frustumCenter, ...cameraLookAt, 1);
        vec3.scale(lightDirection, lightDir, -1);
        lvMatrix = mat4.lookAt(lvMatrix, vec3.add(v3, frustumCenter, vec3.normalize(v3, lightDirection)), frustumCenter, cameraUp);
        vec4.transformMat4(transf, frustum[0], lvMatrix);
        let minZ = transf[2], maxZ = transf[2],
            minX = transf[0], maxX = transf[0],
            minY = transf[1], maxY = transf[1];
        for (let i = 1; i < 8; i++) {
            transf = vec4.transformMat4(transf, frustum[i], lvMatrix);

            if (transf[2] > maxZ) maxZ = transf[2];
            if (transf[2] < minZ) minZ = transf[2];
            if (transf[0] > maxX) maxX = transf[0];
            if (transf[0] < minX) minX = transf[0];
            if (transf[1] > maxY) maxY = transf[1];
            if (transf[1] < minY) minY = transf[1];
        }

        // 可能因为地图空间中y轴是反向的，所以与原贴不同，需要交换minZ和maxZ，即以-maxZ作为近裁面，-minZ作为远裁面
        lpMatrix = mat4.ortho(lpMatrix, -1, 1, -1, 1, -maxZ, -minZ);

        const scaleX = scaleV[0] = 2 / (maxX - minX);
        const scaleY = scaleV[1] = -2 / (maxY - minY);
        offsetV[0] = -0.5 * (minX + maxX) * scaleX;
        offsetV[1] = -0.5 * (minY + maxY) * scaleY;
        // scaleV[0] *= 1 / 4;
        // scaleV[1] *= 1 / 4;

        mat4.identity(cropMatrix);
        mat4.translate(cropMatrix, cropMatrix, offsetV);
        mat4.scale(cropMatrix, cropMatrix, scaleV);

        const projMatrix = mat4.multiply(lpMatrix, cropMatrix, lpMatrix);
        return mat4.multiply(new Array(16), projMatrix, lvMatrix);
    };
}();

var shadowDisplayFrag = "#define SHADER_NAME SHADOW_DISPLAY\nprecision mediump float;\nuniform vec3 color;\n#include <vsm_shadow_frag>\nvoid main() {\n  float c = shadow_computeShadow();\n  float d = 1. - c;\n  gl_FragColor = vec4(color * d, d);\n}";

var shadowDisplayVert = "#define SHADER_NAME SHADOW_DISPLAY\nattribute vec3 aPosition;\nuniform mat4 projViewModelMatrix;\n#include <vsm_shadow_vert>\nvoid main() {\n  vec4 c = vec4(aPosition, 1.);\n  gl_Position = projViewModelMatrix * c;\n  shadow_computeShadowPars(c);\n}";

class ShadowDisplayShader extends MeshShader {

    constructor(defines) {
        const projViewModelMatrix = [];
        super({
            name: 'shadow_display',
            vert : shadowDisplayVert,
            frag : shadowDisplayFrag,
            wgslVert: getWGSLSource('gl_shadow_display_vert'),
            wgslFrag: getWGSLSource('gl_shadow_display_frag'),
            uniforms : [
                {
                    name: 'projViewModelMatrix',
                    type: 'function',
                    fn: function (context, props) {
                        return mat4.multiply(projViewModelMatrix, props['projViewMatrix'], props['modelMatrix']);
                    }
                }
            ],
            defines : defines || {
                'USE_ESM': 1
            },
            extraCommandProps: {
                depth: {
                    enable: true,
                    mask: false
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: (context, props) => {
                        return props['globalTexSize'][0];
                    },
                    height: (context, props) => {
                        return props['globalTexSize'][1];
                    }
                }
            }
        });
    }

    getMeshCommand(regl, mesh) {
        if (!this.commands['shadow_display']) {
            this.commands['shadow_display'] = this.createMeshCommand(regl, mesh);
        }
        return this.commands['shadow_display'];
    }
}

function pack3(array) {
    return array[2] * 256 * 256 + array[1] * 256 + array[0];
}

const UINT8_VIEW = new Uint8Array(4);
const FLOAT_VIEW = new Float32Array(UINT8_VIEW.buffer);

function packDepth(array) {
    UINT8_VIEW[0] = array[3];
    UINT8_VIEW[1] = array[2];
    UINT8_VIEW[2] = array[1];
    UINT8_VIEW[3] = array[0];
    return FLOAT_VIEW[0];
}

let TMP_POINT;
let TMP_COORD;
const TOLERANCE = [1, 1];
const unpackFun = `
    vec3 unpack(highp float f) {
        highp vec3 color;
        color.b = floor(f / 65536.0);
        color.g = floor((f - color.b * 65536.0) / 256.0);
        color.r = f - floor(color.b * 65536.0) - floor(color.g * 256.0);
        // now we have a vec3 with the 3 components in range [0..255]. Let's normalize it!
        return color / 255.0;
    }
`;

const unpackFunWgsl = /*wgsl*/`
fn unpack(f: f32) -> vec3f {
    var color: vec3f;
    color.b = floor(f / 65536.0);
    color.g = floor((f - color.b * 65536.0) / 256.0);
    color.r = f - floor(color.b * 65536.0) - floor(color.g * 256.0);
    return color / 255.0;
}
`;

// picking id and mesh id, only when mesh's count is < 256
const frag0 = `
    precision highp float;

    varying float vPickingId;
    varying float vFbo_picking_visible;

    uniform float fbo_picking_meshId;

    ${unpackFun}

    void main() {
        if (vFbo_picking_visible == 0.0) {
            discard;
            return;
        }
        gl_FragColor = vec4(unpack(vPickingId + 1.0), (fbo_picking_meshId + 1.0) / 255.0);
    }
`;

const frag0Wgsl = /*wgsl*/`
    ${unpackFunWgsl}  // Assuming unpack function is defined in this include

    struct PickingUniforms {
        fbo_picking_meshId: f32,
    };

    @group(0) @binding($b) var<uniform> pickingUniforms: PickingUniforms;


    @fragment
    fn main(vertexOutput: VertexOutput) -> @location(0) vec4f {
        if (vertexOutput.vFbo_picking_visible == 0.0) {
            discard;
        }

        let rgb = unpack(vertexOutput.vPickingId + 1);
        let alpha = (pickingUniforms.fbo_picking_meshId + 1) / 255.0;
        return vec4f(rgb, alpha);
        // return vec4f(1.0, 0.0, 0.0, 1.0);
    }
`;

// only mesh id
const frag1 = `
    precision highp float;

    uniform int fbo_picking_meshId;
    varying float vFbo_picking_visible;

    ${unpackFun}

    void main() {
        if (vFbo_picking_visible == 0.0) {
            discard;
            return;
        }
        gl_FragColor = vec4(unpack(float(fbo_picking_meshId + 1.0)), 1.0);
        // gl_FragColor = vec4(unpack(float(35)), 1.0);
    }
`;

const frag1Wgsl = /*wgsl*/`
    ${unpackFunWgsl}

    struct PickingUniforms {
        fbo_picking_meshId: f32,
    };

    @group(0) @binding(0) var<uniform> pickingUniforms: PickingUniforms;

    @fragment
    fn main(vertexOutput: VertexOutput) -> @location(0) vec4f {
        if (vertexOutput.vFbo_picking_visible == 0.0) {
            discard;
        }

        let meshIdFloat = pickingUniforms.fbo_picking_meshId + 1.0;
        let rgb = unpack(meshIdFloat);

        return vec4f(rgb, 1.0);
    }
`;

// only picking id
const frag2 = `
    precision highp float;

    varying float vFbo_picking_visible;
    varying float vPickingId;

    ${unpackFun}

    void main() {
        if (vFbo_picking_visible == 0.0) {
            discard;
            return;
        }
        gl_FragColor = vec4(unpack(vPickingId + 1.0), 1.0);
    }
`;

const frag2Wgsl = /*wgsl*/`
    ${unpackFunWgsl}

    @fragment
    fn main(vertexOutput: VertexOutput) -> @location(0) vec4f {
        if (vertexOutput.vFbo_picking_visible == 0.0) {
            discard;
        }
        let rgb = unpack(vertexOutput.vPickingId + 1.0);
        return vec4f(rgb, 1.0);
    }
`;

//from https://github.com/mikolalysenko/glsl-read-float
// const depthFrag = `
//     #define SHADER_NAME depth

//     precision highp float;
//     varying float vFbo_picking_viewZ;

//     #include <common_pack_float>

//     void main() {
//         gl_FragColor = common_unpackFloat(vFbo_picking_viewZ);
//         // gl_FragColor = unpack(34678.3456789);
//     }
// `;

const depthFrag = `
    #ifdef GL_ES
        precision highp float;
    #endif
    #if __VERSION__ == 100 && defined(GL_EXT_frag_depth)
        #extension GL_EXT_frag_depth : enable
    #endif
    #include <gl2_frag>
    #include <common_pack_float>
    varying float vFbo_picking_viewZ;
    uniform float logDepthBufFC;
    varying float vFbo_picking_fragDepth;

    const float PackUpscale = 256. / 255.;
    const float UnpackDownscale = 255. / 256.;
    const vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );
    const vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );
    const float ShiftRight8 = 1. / 256.;
    vec4 packDepthToRGBA(const in float v ) {
        vec4 r = vec4(fract(v * PackFactors), v);
        r.yzw -= r.xyz * ShiftRight8;
        return r * PackUpscale;
    }

    void main() {
        float fragDepth = vFbo_picking_fragDepth > 1.0 ? vFbo_picking_fragDepth : vFbo_picking_viewZ + 1.0;
        #if __VERSION__ == 300 || __VERSION__ == 100 && defined(GL_EXT_frag_depth)
            gl_FragDepthEXT = log2(fragDepth) * logDepthBufFC * 0.5;
        #endif
        vec4 depthColor = packDepthToRGBA(fragDepth - 1.0);
        glFragColor = common_unpackFloat(dot(depthColor, UnpackFactors));
        #if __VERSION__ == 100
            gl_FragColor = glFragColor;
        #endif
    }
`;

const depthFragWgsl = /*wgsl*/`
    #include <common_pack_float>

    struct DepthPackingUniforms {
        logDepthBufFC: f32,
    };

    @group(0) @binding($b) var<uniform> depthPackingUniforms: DepthPackingUniforms;

    const PackUpscale = 256.0 / 255.0;
    const UnpackDownscale = 255.0 / 256.0;
    const PackFactors = vec3f(256.0 * 256.0 * 256.0, 256.0 * 256.0, 256.0);
    const UnpackFactors = UnpackDownscale / vec4f(PackFactors, 1.0);
    const ShiftRight8 = 1.0 / 256.0;

    fn packDepthToRGBA(v: f32) -> vec4f {
        var r = vec4f(fract(v * PackFactors), v);
        // r.yzw -= r.xyz * ShiftRight8;
        r = vec4f(r.x, r.yzw - r.xyz * ShiftRight8);
        return r * PackUpscale;
    }

    @fragment
    fn main(vertexOutput: VertexOutput) -> @location(0) vec4f {
        let fragDepth = select(
            vertexOutput.vFbo_picking_viewZ + 1.0,
            vertexOutput.vFbo_picking_fragDepth,
            vertexOutput.vFbo_picking_fragDepth > 1.0
        );

        let depthColor = packDepthToRGBA(fragDepth - 1.0);
        var glFragColor = common_unpackFloat(dot(depthColor, UnpackFactors));

        return glFragColor;
    }
`;


class FBORayPicking {

    constructor(renderer, { name, vert, wgslVert, uniforms, defines, extraCommandProps, enableStencil }, fbo, map) {
        this._renderer = renderer;
        this._fbo = fbo;
        this._map = map;
        this._clearFbo(fbo);
        this._name = name || 'fboraypicking';
        this._vert = vert;
        this._wgslVert = wgslVert;
        this._uniforms = uniforms;
        this._defines = defines;
        this._extraCommandProps = extend$1({}, extraCommandProps);
        delete this._extraCommandProps.blend;
        if (enableStencil) {
            this._extraCommandProps.stencil = {
                enable: enableStencil,
                mask: 0xff,
                func: { cmp: '<', ref: 1, mask: 0xff },
                op: { fail:'keep', zfail:'keep', zpass:'replace' }
            };
        } else {
            delete this._extraCommandProps.stencil;
        }
        this._currentMeshes = [];
        this._init();
    }

    _init() {
        const uniforms = [];
        if (this._uniforms) {
            uniforms.push(...this._uniforms);
        }
        const defines = {
            'ENABLE_PICKING' : 1,
            'HAS_PICKING_ID' : 1
        };
        if (this._defines) {
            for (const p in this._defines) {
                defines[p] = this._defines[p];
            }
        }
        const vert = this._vert,
            wgslVert = this._wgslVert,
            extraCommandProps = this._extraCommandProps;
        this._shader0 = new MeshShader({
            name: this._name + '-0',
            vert,
            frag: frag0,
            wgslVert,
            wgslFrag: frag0Wgsl,
            uniforms,
            defines,
            extraCommandProps
        });
        this._shader2 = new MeshShader({
            name: this._name + '-2',
            vert,
            frag: frag2,
            wgslVert,
            wgslFrag: frag2Wgsl,
            uniforms,
            defines,
            extraCommandProps
        });
        const defines1 = {
            'ENABLE_PICKING' : 1,
            'HAS_PICKING_ID' : 1
        };
        if (this._defines) {
            for (const p in this._defines) {
                defines1[p] = this._defines[p];
            }
        }
        this._shader1 = new MeshShader({
            name: this._name + '-1',
            vert,
            frag: frag1,
            wgslVert,
            wgslFrag: frag1Wgsl,
            uniforms,
            defines : defines1,
            extraCommandProps
        });
        this._depthShader = new MeshShader({
            name: this._name + '-depth',
            vert,
            frag: depthFrag,
            wgslVert,
            wgslFrag: depthFragWgsl,
            uniforms,
            defines : defines1,
            extraCommandProps
        });
        this._scene = new Scene();
        this._scene1 = new Scene();
    }

    filter() {
        return true;
    }

    /**
     * Render meshes to fbo for further picking
     * @param {Mesh[]} meshes - meshes to render
     * @param {Object} uniforms - uniform values
     * @param {Boolean} once - if it's an one time rendering which can gain some performance improvement
     */
    render(meshes, uniforms, once = false) {
        if (!meshes || !meshes.length) {
            return this;
        }
        const fbo = this._fbo;

        if (once) {
            this.clear();
        }
        meshes = meshes.filter(m => m && m.isValid && m.isValid());
        this._scene.setMeshes(meshes);
        const shader = this._getShader(meshes, once);
        shader.filter = this.filter;
        if (this._currentShader && shader !== this._currentShader) {
            this.clear();
        }
        this._currentShader = shader;
        meshes.forEach((m, idx) => {
            m.setUniform('fbo_picking_meshId', idx + this._currentMeshes.length);
        });
        for (let i = 0; i < meshes.length; i++) {
            this._currentMeshes.push(meshes[i]);
        }
        this._renderer.render(shader, uniforms, this._scene, fbo);
        return this;
    }

    pickAll(x, y, tolerance, uniforms, options) {
        tolerance = getTolerance(tolerance);
        const { meshIds, pickingIds, coords, points } = this._pick(x, y, tolerance, uniforms, options);
        const results = [];
        if (pickingIds && meshIds) {
            const checked = {};
            for (let i = 0; i < meshIds.length; i++) {
                const key = `${pickingIds[i]}_${meshIds[i]}`;
                if (meshIds[i] != null && pickingIds[i] != null && !checked[key]) {
                    checked[key] = true;
                    results.push({
                        meshId: meshIds[i],
                        pickingId: pickingIds[i],
                        point: points[i] || null,
                        coordinate: coords[i] || null
                    });
                }
            }
        }
        return results;
    }

    pick(x, y, tolerance, uniforms, options = {}) {
        tolerance = getTolerance(tolerance);
        const { meshIds, pickingIds, width, coords, points } = this._pick(x, y, tolerance, uniforms, options);
        if (pickingIds && meshIds) {
            //从x,y开始从内往外遍历，优先测试离x,y较近的点
            const iterDists = [];
            for (let i = 0; i <= tolerance[0]; i++) {
                iterDists.push(i);
                if (i > 0) {
                    iterDists.push(-i);
                }
            }
            for (let i = 0; i < iterDists.length; i++) { //行
                for (let j = 0; j < iterDists.length; j++) { //列
                    const ii = (iterDists[j] + tolerance[1]) * width + (iterDists[i] + tolerance[0]);
                    if (meshIds[ii] != null) {
                        return {
                            meshId: meshIds[ii],
                            pickingId: pickingIds[ii],
                            point: points[ii] || null,
                            coordinate: coords[ii] || null
                        };
                    }
                }
            }
        }
        return {
            pickingId: null,
            meshId: null,
            point: null
        };
    }

    _pick(x, y, tolerance, uniforms, options = {}) {
        const shader = this._currentShader;
        const meshes = this._currentMeshes;
        if (!shader || !meshes || !meshes.length) {
            return {
                pickingId : null,
                meshId : null,
                point : null
            };
        }

        x = Math.round(x);
        y = Math.round(y);

        const fbo = this._fbo;
        if (x <= 2 || x >= fbo.width - 2 ||
            y <= 2 || y >= fbo.height - 2) {
            return {
                pickingId : null,
                meshId : null,
                point : null
            };
        }

        const { px, py, width, height } = this._getParams(x, y, tolerance, fbo);
        const pixels = new Uint8Array(4 * width * height);

        const regl = this._renderer.device;
        const data = regl.read({
            data: pixels,
            x: px,
            y: py,
            framebuffer : fbo,
            width,
            height
        });

        // const data2 = regl.read({
        //     data: new Uint8Array(4 * fbo.width * fbo.height),
        //     x: 0,
        //     y: 0,
        //     framebuffer: fbo,
        //     width: fbo.width,
        //     height: fbo.height
        // });

        // const canvas = document.createElement('canvas');
        // canvas.width = fbo.width;
        // canvas.height = fbo.height;
        // document.body.appendChild(canvas);
        // for (let i = 0; i < data2.length; i += 4) {
        //     if (data2[i + 3] !== 255) {
        //         data2[i + 3] = 255;
        //     }
        // }

        // canvas.getContext('2d').putImageData(new ImageData(new Uint8ClampedArray(data2), 128), 0, 0);

        const meshIds = [];
        let pickingIds = [];
        for (let i = 0; i < data.length; i += 4) {
            const { pickingId, meshId } = this._packData(data.subarray(i, i + 4), shader);
            meshIds.push(meshId);
            pickingIds.push(pickingId);
        }

        const visited = {};
        const pickedMeshes = meshIds.filter(id => {
            if (id != null && !visited[id]) {
                visited[id] = 1;
                return true;
            }
            return false;
        }).map(id => meshes[id]);

        let firstMesh;
        for (let i = 0; i < pickedMeshes.length; i++) {
            if (pickedMeshes[i] && pickedMeshes[i].geometry) {
                firstMesh = pickedMeshes[i];
                break;
            }
        }
        if (!firstMesh) {
            return {
                pickingId: null,
                meshId: null,
                point: null
            };
        }
        const pickingAttr = firstMesh.geometry.desc.pickingIdAttribute;
        if (meshIds.length && shader === this._shader1 && (firstMesh.getUniform('uPickingId') !== undefined || firstMesh.geometry.data[pickingAttr])) {
            pickingIds = this._getPickingId(px, py, width, height, pixels, pickedMeshes, uniforms);
        }

        const points = [];
        const coords = [];
        if (meshIds.length && options['returnPoint']) {
            const { viewMatrix, projMatrix } = options;
            const depths = this._pickDepth(px, py, width, height, pixels, pickedMeshes, uniforms);
            for (let i = 0; i < depths.length; i++) {
                if (depths[i] && meshIds[i] != null) {
                    const point = this._getWorldPos(x, y, depths[i], viewMatrix, projMatrix);
                    const coord = this._convertPickPoint(point);
                    points.push(point);
                    coords.push(coord);
                } else {
                    points.push(null);
                    coords.push(null);
                }
            }
        }
        return { meshIds, pickingIds, coords, points, width, height };
    }

    _convertPickPoint(point) {
        const map = this._map;
        if (!map) {
            return null;
        }
        const glRes = map.getGLRes();
        if (!TMP_POINT) {
            const center = map.getCenter();
            TMP_COORD = new center.constructor(0, 0, 0);
            const point = map.coordToPoint(center);
            TMP_POINT = new point.constructor(0, 0);
        }
        TMP_POINT.set(point[0], point[1]);
        const coord = map.pointAtResToCoord(TMP_POINT, glRes, TMP_COORD);
        const altitude = map.pointAtResToAltitude(point[2], glRes);
        return [coord.x, coord.y, altitude];
    }

    clear() {
        if (this._fbo) {
            this._clearFbo(this._fbo);
        }
        this._currentMeshes = [];
        delete this._currentShader;
        return this;
    }

    getMeshAt(idx) {
        if (!this._currentMeshes) {
            return null;
        }
        return this._currentMeshes[idx];
    }

    getRenderedMeshes() {
        return this._currentMeshes;
    }

    dispose() {
        this.clear();
        if (this._shader0) {
            this._shader0.dispose();
        }
        if (this._shader1) {
            this._shader1.dispose();
        }
        if (this._shader2) {
            this._shader2.dispose();
        }
        if (this._scene) {
            this._scene.clear();
        }
        if (this._scene1) {
            this._scene1.clear();
        }
    }

    _getWorldPos(x, y, depth, viewMatrix, projMatrix) {
        const fbo = this._fbo;
        const mat = [];

        const w2 = fbo.width / 2 || 1, h2 = fbo.height / 2 || 1;
        const cp0 = [(x - w2) / w2, (h2 - y) / h2, 0, 1],
            cp1 = [(x - w2) / w2, (h2 - y) / h2, 1, 1];

        const inverseProjMatrix = mat4.invert(mat, projMatrix);
        const vcp0 = [], vcp1 = [];
        applyMatrix(vcp0, cp0, inverseProjMatrix);
        applyMatrix(vcp1, cp1, inverseProjMatrix);
        const n = -vcp0[2], f = -vcp1[2];
        const t = (depth - n) / (f - n);

        const projViewMatrix = mat4.multiply(mat, projMatrix, viewMatrix);
        const inverseProjViewMatrix = mat4.invert(mat, projViewMatrix);
        const near = applyMatrix(cp0, cp0, inverseProjViewMatrix),
            far = applyMatrix(cp1, cp1, inverseProjViewMatrix);

        return [interpolate$1(near[0], far[0], t), interpolate$1(near[1], far[1], t), interpolate$1(near[2], far[2], t)];
    }

    _getPickingId(x, y, width, height, pixels, meshes, uniforms) {
        const regl = this._renderer.device;
        const fbo1 = this._getFBO1();
        this._clearFbo(fbo1);
        this._scene1.setMeshes(meshes);
        this._renderer.render(this._shader2, uniforms, this._scene1, fbo1);
        const data = regl.read({
            data: pixels,
            x, y,
            framebuffer : fbo1,
            width,
            height
        });
        const ids = [];
        for (let i = 0; i < data.length; i += 4) {
            ids.push(pack3(data.subarray(i, i + 4)));
        }
        return ids;
    }

    _pickDepth(x, y, width, height, pixels, meshes, uniforms) {
        const regl = this._renderer.device;
        const fbo1 = this._getFBO1();
        //second render to find depth value of point

        // const { count, offset } = this._getPartialMeshForPicking(mesh, pickingId);

        // const geometry = mesh.geometry;
        // geometry.setDrawCount(count);
        // geometry.setDrawOffset(offset);

        this._scene1.setMeshes(meshes);
        this._clearFbo(fbo1);
        uniforms.logDepthBufFC = 2.0 / (Math.log(this._map.cameraFar + 1.0) / Math.LN2);

        this._renderer.render(this._depthShader, uniforms, this._scene1, fbo1);

        // geometry.setDrawCount(null);
        // geometry.setDrawOffset(0);

        const data = regl.read({
            data: pixels,
            x, y,
            framebuffer : fbo1,
            width,
            height
        });
        // this._debugFBO(fbo1);

        const depths = [];
        for (let i = 0; i < data.length; i += 4) {
            depths.push(packDepth(data.subarray(i, i + 4)));
        }
        // console.log(data);
        return depths;
    }

    _packData(data, shader) {
        if (data[0] === 0 && data[1] === 0 &&
            data[2] === 0 && data[3] === 0) {
            return {
                meshId : null,
                pickingId : null
            };
        }
        let pickingId = null;
        let meshId = null;
        if (shader === this._shader1) {
            //only fbo_picking_meshId
            meshId = pack3(data) - 1;
        } else if (shader === this._shader0) {
            meshId = data[3] - 1;
            pickingId = pack3(data) - 1;
        } else {
            meshId = null;
            pickingId = pack3(data) - 1;
        }
        return { meshId, pickingId };
    }

    _clearFbo(framebuffer) {
        this._renderer.device.clear({
            color: [0, 0, 0, 0],
            depth: 1,
            stencil: 255,
            framebuffer
        });
    }

    _getShader(meshes, once) {
        if (once && meshes.length < 255) {
            return this._shader0;
        }
        return this._shader1;
    }

    _getFBO1() {
        const regl = this._renderer.device;
        const fbo = this._fbo;
        if (!this._fbo1) {
            this._fbo1 = regl.framebuffer(fbo.width, fbo.height);
        } else if (this._fbo1.width !== fbo.width || this._fbo1.height !== fbo.height) {
            this._fbo1.resize(fbo.width, fbo.height);
        }
        return this._fbo1;
    }

    _debugFBO(fbo) {
        const regl = this._renderer.device;
        const data2 = regl.read({
            data: new Uint8Array(4 * fbo.width * fbo.height),
            x: 0,
            y: 0,
            framebuffer: fbo,
            width: fbo.width,
            height: fbo.height
        });

        const id = 'picking_debug_canvas';
        let canvas = document.getElementById(id);
        if (!canvas) {
            canvas = document.createElement('canvas');
            canvas.id = id;
            document.body.appendChild(canvas);
        }
        canvas.width = fbo.width;
        canvas.height = fbo.height;
        for (let i = 0; i < data2.length; i += 4) {
            if (data2[i + 3] !== 255) {
                data2[i + 3] = 255;
            }
        }

        canvas.getContext('2d').putImageData(new ImageData(new Uint8ClampedArray(data2), fbo.width), 0, 0);
    }

    // _getPartialMeshForPicking(mesh, pickingId) {
    //     if (!mesh.geometry.rawData || !mesh.geometry.rawData.aPickingId) {
    //         return { count : null, offset : 0 };
    //     }
    //     let pickingMap = mesh._pickingIdMap;
    //     if (!pickingMap) {
    //         const pickingIds = mesh.geometry.rawData.aPickingId;
    //         const map = {};
    //         let offset = 0;
    //         let prev = pickingIds[0];
    //         for (let i = 1, l = pickingIds.length; i < l; i++) {
    //             if (pickingIds[i] !== prev || i === l - 1) {
    //                 map[prev] = {
    //                     offset,
    //                     count : i === l - 1 ? l - offset : i - offset
    //                 };
    //                 offset = i;
    //                 prev = pickingIds[i];
    //             }
    //         }
    //         pickingMap = mesh._pickingIdMap = map;
    //     }

    //     return pickingMap[pickingId];
    // }

    _getParams(px, py, tolerance, fbo) {
        const x = tolerance[0], y = tolerance[1];
        px -= x;
        py = fbo.height - py;
        py -= y;

        let width = 2 * x + 1;
        let height = 2 * y + 1;

        //        ____
        //      |      |
        //height|  x,y |
        //      | ____ | width
        // (px, py)

        const right = px + width;
        const top = py + height;
        if (right > fbo.width) {
            width -= right - fbo.width;
        }
        if (top > fbo.height) {
            height -= top - fbo.height;
        }

        px = px < 0 ? 0 : px;
        py = py < 0 ? 0 : py;

        return { px, py, width, height };
    }

    getPickingVert() {
        return this._vert;
    }

    getPickingWGSLVert() {
        return this._wgslVert;
    }

    getUniformDeclares() {
        return this._uniforms;
    }
}

function applyMatrix(out, v, e) {
    const x = v[0], y = v[1], z = v[2];
    // const e = in;

    const w = 1 / (e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ]);

    out[0] = (e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ]) * w;
    out[1] = (e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ]) * w;
    out[2] = (e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ]) * w;

    return out;
}

function getTolerance(tolerance) {
    if (isNumber$2(tolerance)) { //tolerance增加对x,y方向的支持，同时对原来数字形式的支持
        TOLERANCE[0] = TOLERANCE[1] = tolerance;
        tolerance = TOLERANCE;
    }
    return tolerance;
}

// implementation of GLTF 2.0 extension khr_techniques_webgl
// https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Archived/KHR_techniques_webgl


const excludeFilter = mesh => mesh && mesh.geometry && mesh.geometry.properties.shaderHash === undefined;

const TEMP_MAT4 = [];
const TEMP_MAT3 = [];
const UNIFORM_DECLARES = [
    {
        name: 'modelViewMatrix',
        type: 'function',
        fn: (_, props) => {
            return mat4.multiply(TEMP_MAT4, props['viewMatrix'], props['modelMatrix']);
        }
    },
    {
        name: 'modelViewProjMatrix',
        type: 'function',
        fn: (_, props) => {
            const viewProj = mat4.multiply(TEMP_MAT4, props['viewMatrix'], props['modelMatrix']);
            return mat4.multiply(TEMP_MAT4, props['projMatrix'], viewProj);
        }
    },
    {
        name: 'modelMatrixInverse',
        type: 'function',
        fn: (_, props) => {
            return mat4.invert(TEMP_MAT4, props['modelMatrix']);
        }
    },
    {
        name: 'projMatrixInverse',
        type: 'function',
        fn: (_, props) => {
            return mat4.invert(TEMP_MAT4, props['projMatrix']);
        }
    },
    {
        name: 'modelViewMatrixInverse',
        type: 'function',
        fn: (_, props) => {
            mat4.multiply(TEMP_MAT4, props['viewMatrix'], props['modelMatrix']);
            return mat4.invert(TEMP_MAT4, TEMP_MAT4);
        }
    },
    {
        name: 'modelViewProjMatrixInverse',
        type: 'function',
        fn: (_, props) => {
            const viewProj = mat4.multiply(TEMP_MAT4, props['viewMatrix'], props['modelMatrix']);
            mat4.multiply(TEMP_MAT4, props['projMatrix'], viewProj);
            return mat4.invert(TEMP_MAT4, TEMP_MAT4);
        }
    },
    {
        name: 'modelInverseTransposeMatrix',
        type: 'function',
        fn: (_, props) => {
            const model3 = mat3.fromMat4(TEMP_MAT3, props['modelMatrix']);
            const transposed = mat3.transpose(model3, model3);
            const inverted = mat3.invert(transposed, transposed);
            return inverted;
        }
    },
    {
        name: 'modelViewInverseTransposeMatrix',
        type: 'function',
        fn: (_, props) => {
            const modelView = mat4.multiply(TEMP_MAT4, props['viewMatrix'], props['modelMatrix']);
            const modelView3 = mat3.fromMat4(TEMP_MAT3, modelView);
            const transposed = mat3.transpose(modelView3, modelView3);
            const inverted = mat3.invert(transposed, transposed);
            return inverted;
        }
    },
];

const DEFAULT_UNIFORM_SEMANTICS = {
    'LOCAL': 'positionMatrix',
    'MODEL': 'modelMatrix',
    'VIEW': 'viewMatrix',
    'PROJECTION': 'projMatrix',
    'MODELVIEW': 'modelViewMatrix',
    'MODELVIEWPROJECTION': 'modelViewProjMatrix',
    'MODELINVERSE': 'modelMatrixInverse',
    'VIEWINVERSE': 'viewMatrixInverse',
    'PROJECTIONINVERSE': 'projMatrixInverse',
    'MODELVIEWINVERSE': 'modelViewMatrixInverse',
    'MODELVIEWPROJECTIONINVERSE': 'modelViewProjMatrixInverse',
    'MODELINVERSETRANSPOSE': 'modelInverseTransposeMatrix',
    'MODELVIEWINVERSETRANSPOSE': 'modelViewInverseTransposeMatrix',
    'VIEWPORT': 'viewport',
    'JOINTMATRIX': 'jointMatrix',
    'ALPHACUTOFF': 'alphaCutoff'
};

class KHRTechniquesWebglManager {
    // extraCommandProps是创建shader时统一的 extraCommandProps
    constructor(regl, extraCommandProps, resLoader) {
        this._regl = regl;
        this._khrShaders = {};
        this._commandProps = extraCommandProps;
        this._resLoader = resLoader;
    }

    // 用来排除 KHRTechniquesWebgl Mesh的filter
    getExcludeFilter() {
        return excludeFilter;
    }

    /**
     * 遍历Shader
     *
     * */
    forEachShader(cb) {
        for (const hash in this._khrShaders) {
            const item = this._khrShaders[hash];
            cb(item.shader, item.filter, item.uniformSemantics);
        }
    }

    // khr technique中的shader是webgl 2语法时，需要把useWebGL2参数设为true
    createMesh(primitive, gltf, excludeElementsInVAO, useWebGL2) {
        const extension = gltf.extensions['KHR_techniques_webgl'];
        const matInfo = gltf.materials[primitive.material].extensions['KHR_techniques_webgl'];
        const { technique: techIndex, values } = matInfo;
        const technique = extension.techniques[techIndex];
        const program = extension.programs[technique.program];
        const vert = extension.shaders[program.vertexShader];
        const frag = extension.shaders[program.fragmentShader];
        frag.content = checkFrag(frag.content);

        const vertHash = hashCode(vert.content);
        const fragHash = hashCode(frag.content);
        const hash = vertHash + '-' + fragHash;
        if (!this._khrShaders[hash]) {
            this._khrShaders[hash] = this._createTechniqueShader(hash, extension, techIndex, this._commandProps, useWebGL2);
        }
        const { attributeSemantics } = this._khrShaders[hash];
        const geometry = this._createGeometry(primitive, attributeSemantics, excludeElementsInVAO, hash);
        const matValues = extend$1({}, values);
        for (const p in values) {
            // sampler 2D
            if (technique.uniforms[p] && technique.uniforms[p].type === 35678) {
                const texIndex = values[p].index;
                const texInfo = gltf.textures[texIndex];
                matValues[p] = this._getTexture(texInfo);
            }
        }
        const material = new Material(matValues);
        return { geometry, material };
    }

    _createGeometry(gltfMesh, attributeSemantics, excludeElementsInVAO, shaderHash) {
        // TODO buffer只创建一次
        const attributes = gltfMesh.attributes;
        const color0Name = 'COLOR_0';
        // 把Float32类型的color0改为uint8类型数组
        if (attributes[color0Name]) {
            const colors =  attributes[color0Name].array || attributes[color0Name];
            if (colors instanceof Float32Array) {
                const color = new Uint8Array(colors.length);
                for (let i = 0; i < color.length; i++) {
                    color[i] = Math.round(colors[i] * 255);
                }
                if (attributes[color0Name].array) {
                    attributes[color0Name].array = color;
                    attributes[color0Name].componentType = 5121;
                } else {
                    attributes[color0Name] = color;
                }

            }
        }
        const attrs = {};
        for (const p in attributes) {
            const buffer = getUniqueREGLBuffer(this._regl, attributes[p], { dimension: attributes[p].itemSize, name: p });
            // 优先采用 attributeSemantics中定义的属性
            const name = attributeSemantics[p] || p;
            attrs[name] = {
                buffer
            };
            if (attributes[p].quantization) {
                attrs[name].quantization = attributes[p].quantization;
            }
            if (name === attributeSemantics['POSITION']) {
                // 用来计算vertexCount和boundingbox
                attrs[name].array = attributes[p].array;
            }
        }
        const geometry = new Geometry(
            attrs,
            gltfMesh.indices.array ? gltfMesh.indices.array : gltfMesh.indices,
            0,
            {
                positionAttribute: attributeSemantics['POSITION'],
                normalAttribute: attributeSemantics['NORMAL'],
                uv0Attribute: attributeSemantics['TEXCOORD_0'],
                uv1Attribute: attributeSemantics['TEXCOORD_1'],
                color0Attribute: attributeSemantics['COLOR_0'],
                tangentAttribute: attributeSemantics['TANGENT'],
                textureCoordMatrixAttribute: attributeSemantics['TextureCoordMatrix'],//for s3m
                primitive: gltfMesh.mode === undefined ? 'triangles' : getPrimitive(gltfMesh.mode)
            }
        );
        geometry.generateBuffers(this._regl, { excludeElementsInVAO });
        geometry.properties.shaderHash = shaderHash;
        const positionData = geometry.data[geometry.desc.positionAttribute];
        if (positionData && positionData.array) {
            delete positionData.array;
        }
        return geometry;
    }

    _getTexture(texInfo) {
        // texInfo.image.color 表示图片被精简成了颜色
        const config = {
            type : texInfo.type ? getMaterialType(texInfo.type) : 'uint8',
            format : texInfo.format ? getMaterialFormat(texInfo.format) : 'rgba',
            flipY : !!texInfo.flipY
        };

        const image = texInfo.image;
        if (image.array) {
            config.data = image.array;
        } else if (image.mipmap) {
            config.mipmap = image.mipmap;
        }
        config.width = image.width;
        config.height = image.height;

        const sampler = texInfo.sampler || texInfo.texture.sampler;
        if (sampler) {
            if (sampler.magFilter) config['mag'] = getTextureMagFilter(sampler.magFilter);
            if (sampler.minFilter) config['min'] = getTextureMinFilter(sampler.minFilter);
            if (sampler.wrapS) config['wrapS'] = getTextureWrap(sampler.wrapS);
            if (sampler.wrapT) config['wrapT'] = getTextureWrap(sampler.wrapT);
        }

        return new Texture2D(config, this._resLoader);

    }

    _createTechniqueShader(hash, extension, techIndex, extraCommandProps, useWebGL2) {
        const { techniques, programs, shaders } = extension;
        const technique = techniques[techIndex];
        const program = programs[technique.program];
        const vert = shaders[program.vertexShader].content;
        const frag = shaders[program.fragmentShader].content;
        const uniformSemantics = {};
        for (const name in technique.uniforms) {
            const semantic = technique.uniforms[name];
            if (semantic.semantic) {
                uniformSemantics[semantic.semantic] = name;
            }
        }
        const uniformDeclares = UNIFORM_DECLARES.slice();//extend({}, UNIFORM_DECLARES);
        for (const semanticName in uniformSemantics) {
            const name = uniformSemantics[semanticName];
            uniformDeclares.push({
                name,
                type: 'function',
                fn:  (_, props) => {
                    const realName = DEFAULT_UNIFORM_SEMANTICS[semanticName];
                    return props[realName];
                }
            });
        }
        const shader = new MeshShader({
            vert, frag,
            uniforms: uniformDeclares,
            extraCommandProps
        });
        if (useWebGL2) {
            shader.version = 300;
        }
        const attributeSemantics = {};
        for (const name in technique.attributes) {
            const semantic = technique.attributes[name];
            attributeSemantics[semantic.semantic] = name;
        }
        return {
            shader,
            filter: mesh => mesh && mesh.geometry && mesh.geometry.properties.shaderHash === hash,
            uniformSemantics,
            attributeSemantics
        };
    }


    dispose() {
        for (const p in this._khrShaders) {
            const { shader } = this._khrShaders[p];
            shader.dispose();
        }
        this._khrShaders = {};
    }
}

function checkFrag(fragCode) {
    if (fragCode && fragCode.indexOf('precision') < 0) {
        // 有些模型的frag里缺少precision定义
        return 'precision mediump float;\n' + fragCode;
    }
    return fragCode;
}

// contains codes from playcanvas
// https://github.com/playcanvas/engine
// MIT License
class DynamicBufferPool {
    /**
     * Create the system of dynamic buffers.
     *
     * @param device - The graphics device.
     * @param bufferSize - The size of the underlying large buffers.
     * @param bufferAlignment - Alignment of each allocation.
     */
    constructor(device, bufferSize, bufferAlignment) {
        /**
         * @type {DynamicBufferAllocation|null}
         */
        this.activeBuffer = null;
        this.device = device;
        this.usedBuffers = [];
        this.poolBuffers = [];
        this.bufferSize = bufferSize;
        this.bufferAlignment = bufferAlignment;
    }
    /**
     * Destroy the system of dynamic buffers.
     */
    destroy() {
        this.poolBuffers.forEach((poolBuffer) => {
            poolBuffer.gpuBuffer.destroy();
        });
        this.poolBuffers.length = 0;
        this.usedBuffers.length = 0;
        this.activeBuffer = null;
    }
    /**
     * Allocate an aligned space of the given size from a dynamic buffer.
     *
     * @param {DynamicBufferAllocation} allocation - The allocation info to fill.
     * @param {number} size - The size of the allocation.
     */
    alloc(allocation, size) {
        // if we have active buffer without enough space
        if (this.activeBuffer) {
            const alignedStart = roundUp(this.activeBuffer.size, this.bufferAlignment);
            const space = this.bufferSize - alignedStart;
            if (space < size) {
                // we're done with this buffer, schedule it for submit
                this.scheduleSubmit();
            }
        }
        // if we don't have an active buffer, allocate new one
        if (!this.activeBuffer) {
            // gpu buffer
            this.activeBuffer = this.poolBuffers.pop();
            if (!this.activeBuffer) {
                this.activeBuffer = {
                    gpuBuffer: this.createBuffer(this.device, this.bufferSize),
                    storage: new ArrayBuffer(this.bufferSize),
                    offset: 0,
                    size: 0
                };
            }
            this.activeBuffer.offset = 0;
            this.activeBuffer.size = 0;
        }
        // allocate from active buffer
        const activeBuffer = this.activeBuffer;
        const alignedStart = roundUp(activeBuffer.size, this.bufferAlignment);
        // Debug.assert(alignedStart + size <= this.bufferSize, `The allocation size of ${size} is larger than the buffer size of ${this.bufferSize}`);
        allocation.gpuBuffer = activeBuffer.gpuBuffer;
        allocation.offset = alignedStart;
        allocation.storage = activeBuffer.storage;
        // take the allocation from the buffer
        activeBuffer.size = alignedStart + size;
    }
    createBuffer(device, size) {
        return device.createBuffer({
            size: size,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
    }
    scheduleSubmit() {
        if (this.activeBuffer) {
            this.usedBuffers.push(this.activeBuffer);
            this.activeBuffer = null;
        }
    }
    submit() {
        // schedule currently active buffer for submit
        this.scheduleSubmit();
        // submit all used buffers
        const count = this.usedBuffers.length;
        if (count) {
            const device = this.device;
            const poolBuffers = this.poolBuffers;
            // run this loop backwards to preserve the order of buffers in gpuBuffers array
            for (let i = count - 1; i >= 0; i--) {
                const usedBuffer = this.usedBuffers[i];
                const { storage, gpuBuffer, offset, size } = usedBuffer;
                device.queue.writeBuffer(gpuBuffer, 0, storage, offset, size);
                poolBuffers.push(usedBuffer);
            }
            this.usedBuffers.length = 0;
        }
    }
}

class GraphicsCubeTexture extends GraphicsTexture {
    get arrayLayers() {
        return 6;
    }
    getMipLevelCount() {
        const data = this.config.faces && this.config.faces[0];
        if (data && data.mipmap) {
            return data.mipmap.length;
        }
        return 1;
    }
    fillData(texture, width, height) {
        const config = this.config;
        if (config.faces) {
            for (let i = 0; i < 6; i++) {
                const data = config.faces[i];
                const origin = [0, 0, i];
                if (this.isArrayData(data)) {
                    this.fillArrayData(texture, data, width, height, origin);
                }
                else {
                    this.fillImageData(texture, data, width, height, origin);
                }
            }
        }
    }
}

let uid = 0;
class GraphicsDevice {
    constructor(device, context, adapter) {
        //@internal
        this.commandBuffers = [];
        //@internal
        this._readTargets = {};
        //@internal
        this._destroyList = [];
        this.wgpu = device;
        this.adapter = adapter;
        const presentationFormat = navigator.gpu.getPreferredCanvasFormat();
        context.configure({
            device,
            format: presentationFormat,
            alphaMode: 'premultiplied'
        });
        this.context = context;
        // 1M for each buffer
        const bufferSize = 1024 * 1024;
        const limits = device.limits;
        this.dynamicBufferPool = new DynamicBufferPool(device, bufferSize, limits.minUniformBufferOffsetAlignment);
    }
    // mock of regl's hasExtension
    hasExtension(extension) {
        if (!this._supportedFormats) {
            this._supportedFormats = getSupportedFormats(this.wgpu);
        }
        if (this._supportedFormats[extension]) {
            return true;
        }
        //TODO 这里可能存在webgl支持，但webgpu不支持的扩展
        return true;
    }
    getCommandEncoder() {
        // use existing or create new encoder
        let commandEncoder = this.commandEncoder;
        if (!commandEncoder) {
            commandEncoder = this.wgpu.createCommandEncoder();
            this.commandEncoder = commandEncoder;
        }
        return commandEncoder;
    }
    endCommandEncoder() {
        const { commandEncoder } = this;
        if (commandEncoder) {
            const cb = commandEncoder.finish();
            this.addCommandBuffer(cb, false);
            this.commandEncoder = null;
        }
    }
    getDefaultFramebuffer() {
        let fbo = this._defaultFramebuffer;
        if (!fbo) {
            const canvas = this.context.canvas;
            fbo = this._defaultFramebuffer = new GraphicsFramebuffer(this, {
                width: canvas.width,
                height: canvas.height,
                depthStencil: true
            });
            fbo.uid = uid++;
        }
        return fbo;
    }
    getRenderPassEncoder(fbo) {
        fbo = fbo || this.getDefaultFramebuffer();
        const desc = fbo.getRenderPassDescriptor();
        const commandEncoder = this.getCommandEncoder();
        const renderPass = commandEncoder.beginRenderPass(desc);
        renderPass.desc = desc;
        return renderPass;
    }
    addCommandBuffer(commandBuffer, front) {
        if (front) {
            this.commandBuffers.unshift(commandBuffer);
        }
        else {
            this.commandBuffers.push(commandBuffer);
        }
    }
    submit() {
        // end the current encoder
        this.endCommandEncoder();
        // copy dynamic buffers data to the GPU (this schedules the copy CB to run before all other CBs)
        this.dynamicBufferPool.submit();
        if (this.commandBuffers.length > 0) {
            this.wgpu.queue.submit(this.commandBuffers);
            this.commandBuffers.length = 0;
        }
        for (let i = 0; i < this._destroyList.length; i++) {
            const resource = this._destroyList[i];
            resource.destroy();
        }
        this._destroyList = [];
    }
    addToDestroyList(texture) {
        this._destroyList.push(texture);
    }
    preserveDrawingBuffer(canvas) {
        canvas.width = this.context.canvas.width;
        canvas.height = this.context.canvas.height;
        canvas.getContext('2d').drawImage(this.context.canvas, 0, 0);
    }
    // implementation of regl.buffer
    buffer(options) {
        return Geometry.createBuffer(this, options, options.name);
    }
    elements(options) {
        const data = options.data || options;
        return Geometry.createElementBuffer(this, data);
    }
    // implementation of regl.framebuffer
    framebuffer(width, height) {
        let reglFBODescriptor;
        if (!isNumber$2(width)) {
            reglFBODescriptor = width;
        }
        else {
            if (height === undefined) {
                height = width;
            }
            reglFBODescriptor = { color: true, depthStencil: true, width, height };
        }
        return new GraphicsFramebuffer(this, reglFBODescriptor);
    }
    // implementation of regl.texture
    texture(width, height) {
        if (width === undefined) {
            width = 1;
        }
        let config = width;
        if (isNumber$2(width)) {
            config = {
                width,
                height: isNumber$2(height) ? height : width
            };
        }
        return new GraphicsTexture(this, config);
    }
    // implementation of regl.cube
    cube(options) {
        return new GraphicsCubeTexture(this, options);
    }
    // implementation of regl.clear
    clear(options) {
        const fbo = (options.framebuffer || this.getDefaultFramebuffer());
        fbo.setClearOptions(options);
        //ensure at least one command buffer is submitted to clear canvas
        this._renderToClear(fbo);
    }
    // implementation of regl.read
    read(options) {
        // https://github.com/tensorflow/tfjs/pull/7576/files
        // https://github.com/tensorflow/tfjs/blob/master/tfjs-backend-webgpu/src/backend_webgpu.ts#L379
        // 可以参考tf.js实现同步读取数据。
        // 1. 将数据绘制到一个OffscreenCanvas
        // 2. 将OffscreenCanvas绘制到一个canvas 2d上
        // 3. 从canvas 2d上读取数据
        const framebuffer = options.framebuffer || this._defaultFramebuffer;
        const fboWidth = framebuffer.width;
        const fboHeight = framebuffer.height;
        let { width, height } = options;
        if (!width) {
            width = fboWidth;
        }
        if (!height) {
            height = fboHeight;
        }
        const device = this.wgpu;
        this.submit();
        // regl.read 参数y从左上角开始，但读取的结果垂直翻转（webgpu不会垂直翻转）
        // 因此为了和webgl保持一致，webgpu 原点的 y 是距离底部 y + height 像素处，并将结果图像上下翻转
        const origin = { x: options.x, y: fboHeight - options.y - height, z: 0 };
        // if (origin.x + width > fboWidth) {
        //     origin.x = fboWidth - width;
        // }
        // if (origin.y + height > fboHeight) {
        //     origin.y = fboHeight - height;
        // }
        const data = options.pixels || new Uint8Array(width * height * 4);
        if (framebuffer === this._defaultFramebuffer) {
            // read default framebuffer
            const stagingHostStorage = new OffscreenCanvas(width, height);
            const ctx = stagingHostStorage.getContext('2d', {
                willReadFrequently: true,
            });
            ctx.drawImage(this.context.canvas, origin.x, origin.y, width, height, 0, 0, width, height);
            const stagingValues = ctx.getImageData(0, 0, width, height).data;
            for (let k = 0; k < data.length; k += 4) {
                data[k] = stagingValues[k];
                data[k + 1] = stagingValues[k + 1];
                data[k + 2] = stagingValues[k + 2];
                data[k + 3] = stagingValues[k + 3];
            }
            return data;
        }
        const alphaModes = ['opaque', 'premultiplied'];
        const stagingDeviceStorage = alphaModes.map(() => new OffscreenCanvas(width, height));
        // TODO: use rgba8unorm format when this format is supported on Mac.
        // https://bugs.chromium.org/p/chromium/issues/detail?id=1298618
        stagingDeviceStorage.map((storage, index) => {
            const context = storage.getContext('webgpu');
            context.configure({
                device,
                format: 'rgba8unorm',
                usage: GPUTextureUsage.COPY_DST,
                alphaMode: alphaModes[index]
            });
            return context.getCurrentTexture();
        }).map((storageTexture, index) => {
            const encoder = device.createCommandEncoder();
            encoder.copyTextureToTexture({ texture: framebuffer.colorTexture.texture, origin }, { texture: storageTexture }, { width, height });
            this.wgpu.queue.submit([encoder.finish()]);
            const stagingHostStorage = new OffscreenCanvas(width, height);
            const ctx = stagingHostStorage.getContext('2d', {
                willReadFrequently: true,
            });
            // 为了和webgl保持一致，垂直翻转图像
            ctx.scale(1, -1);
            ctx.drawImage(stagingDeviceStorage[index], 0, -height);
            const stagingValues = ctx.getImageData(0, 0, width, height).data;
            const alphaMode = alphaModes[index];
            for (let k = 0; k < data.length; k += 4) {
                if (alphaMode === 'premultiplied') {
                    // premultiplied 模式获取 a
                    data[k + 3] = stagingValues[k + 3];
                }
                else {
                    // opaque模式获取rgb
                    data[k] = stagingValues[k];
                    data[k + 1] = stagingValues[k + 1];
                    data[k + 2] = stagingValues[k + 2];
                }
            }
        });
        return data;
        // const { bytesPerTexel } = colorTexture.gpuFormat;
        // let bytesPerRow = options.width * bytesPerTexel;
        // bytesPerRow = Math.ceil( bytesPerRow / 256 ) * 256; // Align to 256 bytes
        // const encoder = device.createCommandEncoder();
        // const bufferSize = width * height * bytesPerTexel;
        // let readBuffer = this._readTargets[bufferSize];
        // if (!readBuffer) {
        //     readBuffer = device.createBuffer(
        //         {
        //             size: width * height * bytesPerTexel,
        //             usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        //         }
        //     );
        // }
        // encoder.copyTextureToBuffer(
        // 	{
        // 		texture: colorTexture.texture,
        // 		origin: { x: options.x, y: options.y, z: 0 },
        // 	},
        // 	{
        // 		buffer: readBuffer,
        // 		bytesPerRow: bytesPerRow
        // 	},
        // 	{
        // 		width,
        // 		height
        // 	}
        // );
        // const typedArrayType = options.data.constructor;
        // device.queue.submit([encoder.finish()]);
        // await readBuffer.mapAsync(GPUMapMode.READ);
        // const buffer = readBuffer.getMappedRange();
        // const result = new typedArrayType(buffer);
        // options.data.set(result);
        // readBuffer.unmap();
    }
    destroy() {
        if (this._defaultFramebuffer) {
            this._defaultFramebuffer.destroy();
            delete this._defaultFramebuffer;
        }
        if (this.dynamicBufferPool) {
            this.dynamicBufferPool.destroy();
            delete this.dynamicBufferPool;
        }
        for (const p in this._readTargets) {
            const buffer = this._readTargets[p];
            if (buffer) {
                buffer.destroy();
            }
        }
        if (this.wgpu) {
            this.wgpu.destroy();
            delete this.wgpu;
        }
        this._readTargets = {};
        this._clearPipelines = {};
    }
    incrDrawCall() {
        this._drawCount++;
    }
    resetDrawCalls() {
        this._drawCount = 0;
    }
    getDrawCalls() {
        return this._drawCount;
    }
    _renderToClear(fbo) {
        if (fbo && fbo.isDestroyed()) {
            return;
        }
        const pass = this.getRenderPassEncoder(fbo);
        const pipeline = this._getClearPipeline(fbo);
        pass.setPipeline(pipeline);
        pass.draw(3);
        pass.end();
        this.submit();
    }
    _getClearPipeline(fbo) {
        const isDefault = fbo === this.getDefaultFramebuffer();
        const sampleCount = fbo.colorTexture && fbo.colorTexture.config.sampleCount || 1;
        const depthFormat = isDefault || fbo.depthTexture && fbo.depthTexture.gpuFormat.format;
        let format;
        if (fbo.colorTexture) {
            format = fbo.colorTexture.gpuFormat.format;
        }
        else {
            format = navigator.gpu.getPreferredCanvasFormat();
        }
        this._clearPipelines = this._clearPipelines || {};
        const key = format + '-' + isDefault + '-' + depthFormat + '-' + sampleCount;
        if (this._clearPipelines[key]) {
            return this._clearPipelines[key];
        }
        const device = this.wgpu;
        const module = device.createShaderModule({
            code: /* wgsl */ `
            @vertex fn vs(
                @builtin(vertex_index) vertexIndex : u32
            ) -> @builtin(position) vec4f {
                let pos = array(
                    vec2f(2,  2.5),
                    vec2f(1.5, 1.5),
                    vec2f(2.5, 1.5)
                );
                return vec4f(pos[vertexIndex], 0.0, 1.0);
            }
            @fragment fn fs() -> @location(0) vec4f {
                return vec4f(0, 0, 0, 0);
            }
            `,
        });
        const options = {
            label: 'clear',
            layout: 'auto',
            vertex: { module },
            fragment: {
                module,
                targets: [{ format }],
            },
        };
        if (depthFormat) {
            options.depthStencil = {
                depthWriteEnabled: false,
                depthCompare: 'always',
                format: depthFormat === true ? 'depth24plus-stencil8' : depthFormat,
            };
        }
        if (sampleCount > 1) {
            options.multisample = { count: sampleCount };
        }
        const pipeline = device.createRenderPipeline(options);
        pipeline.options = options;
        this._clearPipelines[key] = pipeline;
        return this._clearPipelines[key];
    }
}

const HDR = { parseHDR: parseRGBE };
const pbr = {
    PBRHelper,
    StandardMaterial,
    StandardSpecularGlossinessMaterial,
    StandardShader,
    StandardDepthShader,
    PBRUtils
    // LitShader,
    // LitMaterial,
    // ClothShader,
    // ClothMaterial,
    // SubsurfaceShader,
    // SubsurfaceMaterial
};
const earcut = earcut$1;
earcut.flatten = flatten;

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AbstractTexture: AbstractTexture,
    BloomPass: BloomPass,
    BoundingBox: BoundingBox,
    BoxBlurShader: BoxBlurShader,
    Constants: Constants,
    CopyShader: CopyShader,
    EdgeGeometry: EdgeGeometry,
    EdgeShader: EdgeShader,
    ExtentPass: ExtentPass,
    FBORayPicking: FBORayPicking,
    FogPass: FogPass,
    FogShader: FogShader,
    FxaaShader: FxaaShader,
    GLTFHelper: GLTFHelper,
    GLTFManager: GLTFManager,
    Geometry: Geometry,
    GraphicsDevice: GraphicsDevice,
    GraphicsFramebuffer: GraphicsFramebuffer,
    GraphicsTexture: GraphicsTexture,
    HDR: HDR,
    HeatmapDisplayShader: HeatmapDisplayShader,
    HeatmapShader: HeatmapShader,
    ImageShader: ImageShader,
    InstancedMesh: InstancedMesh,
    Jitter: Jitter,
    KHRTechniquesWebglManager: KHRTechniquesWebglManager,
    Material: Material,
    Mesh: Mesh,
    MeshShader: MeshShader,
    PhongMaterial: PhongMaterial,
    PhongShader: PhongShader,
    PhongSpecularGlossinessMaterial: PhongSpecularGlossinessMaterial,
    Plane: Plane,
    PointLineShader: PointLineShader,
    PostProcessShader: PostProcessShader,
    QuadShader: QuadShader,
    REGLHelper: REGLHelper,
    RainRipplesPass: RainRipplePass,
    Renderer: Renderer,
    ResourceLoader: ResourceLoader,
    ScanEffectPass: ScanEffectPass,
    ScanEffectShader: EffectShader,
    Scene: Scene,
    Shader: GPUShader,
    ShaderLib: ShaderLib,
    ShadowDisplayShader: ShadowDisplayShader,
    ShadowMapShader: ShadowMapShader,
    ShadowPass: ShadowPass,
    SkyboxShader: SkyboxShader,
    SsrPass: SsrPass,
    StandardLiteMaterial: StandardLiteMaterial,
    StandardLiteShader: StandardLiteShader,
    Texture2D: Texture2D,
    Util: Util,
    WGSLParseDefines: WGSLParseDefines$1,
    WaterShader: WaterShader,
    WebGLConstants: WebGLConstants,
    WgslShaderLib: WgslShaderLib,
    WireFrameMaterial: WireFrameMaterial,
    WireframeShader: WireframeShader,
    earcut: earcut,
    glMatrix: glMatrix,
    mat2: mat2,
    mat2d: mat2d,
    mat3: mat3,
    mat4: mat4,
    pbr: pbr,
    quat: quat,
    quat2: quat2,
    vec2: vec2,
    vec3: vec3,
    vec4: vec4
});

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var colorString$1 = {exports: {}};

var colorName$1 = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

var simpleSwizzle = {exports: {}};

var isArrayish$1 = function isArrayish(obj) {
	if (!obj || typeof obj === 'string') {
		return false;
	}

	return obj instanceof Array || Array.isArray(obj) ||
		(obj.length >= 0 && (obj.splice instanceof Function ||
			(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
};

var isArrayish = isArrayish$1;

var concat = Array.prototype.concat;
var slice = Array.prototype.slice;

var swizzle$1 = simpleSwizzle.exports = function swizzle(args) {
	var results = [];

	for (var i = 0, len = args.length; i < len; i++) {
		var arg = args[i];

		if (isArrayish(arg)) {
			// http://jsperf.com/javascript-array-concat-vs-push/98
			results = concat.call(results, slice.call(arg));
		} else {
			results.push(arg);
		}
	}

	return results;
};

swizzle$1.wrap = function (fn) {
	return function () {
		return fn(swizzle$1(arguments));
	};
};

var simpleSwizzleExports = simpleSwizzle.exports;

/* MIT license */

var colorNames = colorName$1;
var swizzle = simpleSwizzleExports;
var hasOwnProperty = Object.hasOwnProperty;

var reverseNames = Object.create(null);

// create a list of reverse color names
for (var name in colorNames) {
	if (hasOwnProperty.call(colorNames, name)) {
		reverseNames[colorNames[name]] = name;
	}
}

var cs = colorString$1.exports = {
	to: {},
	get: {}
};

cs.get = function (string) {
	var prefix = string.substring(0, 3).toLowerCase();
	var val;
	var model;
	switch (prefix) {
		case 'hsl':
			val = cs.get.hsl(string);
			model = 'hsl';
			break;
		case 'hwb':
			val = cs.get.hwb(string);
			model = 'hwb';
			break;
		default:
			val = cs.get.rgb(string);
			model = 'rgb';
			break;
	}

	if (!val) {
		return null;
	}

	return {model: model, value: val};
};

cs.get.rgb = function (string) {
	if (!string) {
		return null;
	}

	var abbr = /^#([a-f0-9]{3,4})$/i;
	var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
	var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
	var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
	var keyword = /^(\w+)$/;

	var rgb = [0, 0, 0, 1];
	var match;
	var i;
	var hexAlpha;

	if (match = string.match(hex)) {
		hexAlpha = match[2];
		match = match[1];

		for (i = 0; i < 3; i++) {
			// https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
			var i2 = i * 2;
			rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
		}

		if (hexAlpha) {
			rgb[3] = parseInt(hexAlpha, 16) / 255;
		}
	} else if (match = string.match(abbr)) {
		match = match[1];
		hexAlpha = match[3];

		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i] + match[i], 16);
		}

		if (hexAlpha) {
			rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
		}
	} else if (match = string.match(rgba)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i + 1], 0);
		}

		if (match[4]) {
			if (match[5]) {
				rgb[3] = parseFloat(match[4]) * 0.01;
			} else {
				rgb[3] = parseFloat(match[4]);
			}
		}
	} else if (match = string.match(per)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
		}

		if (match[4]) {
			if (match[5]) {
				rgb[3] = parseFloat(match[4]) * 0.01;
			} else {
				rgb[3] = parseFloat(match[4]);
			}
		}
	} else if (match = string.match(keyword)) {
		if (match[1] === 'transparent') {
			return [0, 0, 0, 0];
		}

		if (!hasOwnProperty.call(colorNames, match[1])) {
			return null;
		}

		rgb = colorNames[match[1]];
		rgb[3] = 1;

		return rgb;
	} else {
		return null;
	}

	for (i = 0; i < 3; i++) {
		rgb[i] = clamp(rgb[i], 0, 255);
	}
	rgb[3] = clamp(rgb[3], 0, 1);

	return rgb;
};

cs.get.hsl = function (string) {
	if (!string) {
		return null;
	}

	var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
	var match = string.match(hsl);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = ((parseFloat(match[1]) % 360) + 360) % 360;
		var s = clamp(parseFloat(match[2]), 0, 100);
		var l = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);

		return [h, s, l, a];
	}

	return null;
};

cs.get.hwb = function (string) {
	if (!string) {
		return null;
	}

	var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
	var match = string.match(hwb);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = ((parseFloat(match[1]) % 360) + 360) % 360;
		var w = clamp(parseFloat(match[2]), 0, 100);
		var b = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
		return [h, w, b, a];
	}

	return null;
};

cs.to.hex = function () {
	var rgba = swizzle(arguments);

	return (
		'#' +
		hexDouble(rgba[0]) +
		hexDouble(rgba[1]) +
		hexDouble(rgba[2]) +
		(rgba[3] < 1
			? (hexDouble(Math.round(rgba[3] * 255)))
			: '')
	);
};

cs.to.rgb = function () {
	var rgba = swizzle(arguments);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
		: 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};

cs.to.rgb.percent = function () {
	var rgba = swizzle(arguments);

	var r = Math.round(rgba[0] / 255 * 100);
	var g = Math.round(rgba[1] / 255 * 100);
	var b = Math.round(rgba[2] / 255 * 100);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
		: 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};

cs.to.hsl = function () {
	var hsla = swizzle(arguments);
	return hsla.length < 4 || hsla[3] === 1
		? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
		: 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
cs.to.hwb = function () {
	var hwba = swizzle(arguments);

	var a = '';
	if (hwba.length >= 4 && hwba[3] !== 1) {
		a = ', ' + hwba[3];
	}

	return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};

cs.to.keyword = function (rgb) {
	return reverseNames[rgb.slice(0, 3)];
};

// helpers
function clamp(num, min, max) {
	return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
	var str = Math.round(num).toString(16).toUpperCase();
	return (str.length < 2) ? '0' + str : str;
}

var colorStringExports = colorString$1.exports;

var conversions$2 = {exports: {}};

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */

var cssKeywords = colorName;

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in cssKeywords) {
	if (cssKeywords.hasOwnProperty(key)) {
		reverseKeywords[cssKeywords[key]] = key;
	}
}

var convert$2 = conversions$2.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert$2) {
	if (convert$2.hasOwnProperty(model)) {
		if (!('channels' in convert$2[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert$2[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert$2[model].labels.length !== convert$2[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert$2[model].channels;
		var labels = convert$2[model].labels;
		delete convert$2[model].channels;
		delete convert$2[model].labels;
		Object.defineProperty(convert$2[model], 'channels', {value: channels});
		Object.defineProperty(convert$2[model], 'labels', {value: labels});
	}
}

convert$2.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert$2.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert$2.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert$2.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert$2.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert$2.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in cssKeywords) {
		if (cssKeywords.hasOwnProperty(keyword)) {
			var value = cssKeywords[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert$2.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert$2.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert$2.rgb.lab = function (rgb) {
	var xyz = convert$2.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert$2.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert$2.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert$2.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert$2.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert$2.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert$2.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert$2.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert$2.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert$2.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert$2.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert$2.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert$2.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert$2.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert$2.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert$2.rgb.ansi16(convert$2.hsv.rgb(args), args[2]);
};

convert$2.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert$2.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert$2.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert$2.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert$2.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert$2.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert$2.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert$2.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert$2.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert$2.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert$2.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert$2.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert$2.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert$2.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert$2.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert$2.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert$2.gray.hsl = convert$2.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert$2.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert$2.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert$2.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert$2.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert$2.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};

var conversionsExports = conversions$2.exports;

var conversions$1 = conversionsExports;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions$1);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions$1[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions$1[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions$1[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route$1 = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var conversions = conversionsExports;
var route = route$1;

var convert$1 = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert$1[fromModel] = {};

	Object.defineProperty(convert$1[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert$1[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert$1[fromModel][toModel] = wrapRounded(fn);
		convert$1[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert$1;

var colorString = colorStringExports;
var convert = colorConvert;

var _slice = [].slice;

var skippedModels = [
	// to be honest, I don't really feel like keyword belongs in color convert, but eh.
	'keyword',

	// gray conflicts with some method names, and has its own method defined.
	'gray',

	// shouldn't really be in color-convert either...
	'hex'
];

var hashedModelKeys = {};
Object.keys(convert).forEach(function (model) {
	hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
});

var limiters = {};

function Color(obj, model) {
	if (!(this instanceof Color)) {
		return new Color(obj, model);
	}

	if (model && model in skippedModels) {
		model = null;
	}

	if (model && !(model in convert)) {
		throw new Error('Unknown model: ' + model);
	}

	var i;
	var channels;

	if (obj == null) { // eslint-disable-line no-eq-null,eqeqeq
		this.model = 'rgb';
		this.color = [0, 0, 0];
		this.valpha = 1;
	} else if (obj instanceof Color) {
		this.model = obj.model;
		this.color = obj.color.slice();
		this.valpha = obj.valpha;
	} else if (typeof obj === 'string') {
		var result = colorString.get(obj);
		if (result === null) {
			throw new Error('Unable to parse color from string: ' + obj);
		}

		this.model = result.model;
		channels = convert[this.model].channels;
		this.color = result.value.slice(0, channels);
		this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
	} else if (obj.length) {
		this.model = model || 'rgb';
		channels = convert[this.model].channels;
		var newArr = _slice.call(obj, 0, channels);
		this.color = zeroArray(newArr, channels);
		this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
	} else if (typeof obj === 'number') {
		// this is always RGB - can be converted later on.
		obj &= 0xFFFFFF;
		this.model = 'rgb';
		this.color = [
			(obj >> 16) & 0xFF,
			(obj >> 8) & 0xFF,
			obj & 0xFF
		];
		this.valpha = 1;
	} else {
		this.valpha = 1;

		var keys = Object.keys(obj);
		if ('alpha' in obj) {
			keys.splice(keys.indexOf('alpha'), 1);
			this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
		}

		var hashedKeys = keys.sort().join('');
		if (!(hashedKeys in hashedModelKeys)) {
			throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
		}

		this.model = hashedModelKeys[hashedKeys];

		var labels = convert[this.model].labels;
		var color = [];
		for (i = 0; i < labels.length; i++) {
			color.push(obj[labels[i]]);
		}

		this.color = zeroArray(color);
	}

	// perform limitations (clamping, etc.)
	if (limiters[this.model]) {
		channels = convert[this.model].channels;
		for (i = 0; i < channels; i++) {
			var limit = limiters[this.model][i];
			if (limit) {
				this.color[i] = limit(this.color[i]);
			}
		}
	}

	this.valpha = Math.max(0, Math.min(1, this.valpha));

	if (Object.freeze) {
		Object.freeze(this);
	}
}

Color.prototype = {
	toString: function () {
		return this.string();
	},

	toJSON: function () {
		return this[this.model]();
	},

	string: function (places) {
		var self = this.model in colorString.to ? this : this.rgb();
		self = self.round(typeof places === 'number' ? places : 1);
		var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
		return colorString.to[self.model](args);
	},

	percentString: function (places) {
		var self = this.rgb().round(typeof places === 'number' ? places : 1);
		var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
		return colorString.to.rgb.percent(args);
	},

	array: function () {
		return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
	},

	object: function () {
		var result = {};
		var channels = convert[this.model].channels;
		var labels = convert[this.model].labels;

		for (var i = 0; i < channels; i++) {
			result[labels[i]] = this.color[i];
		}

		if (this.valpha !== 1) {
			result.alpha = this.valpha;
		}

		return result;
	},

	unitArray: function () {
		var rgb = this.rgb().color;
		rgb[0] /= 255;
		rgb[1] /= 255;
		rgb[2] /= 255;

		if (this.valpha !== 1) {
			rgb.push(this.valpha);
		}

		return rgb;
	},

	unitObject: function () {
		var rgb = this.rgb().object();
		rgb.r /= 255;
		rgb.g /= 255;
		rgb.b /= 255;

		if (this.valpha !== 1) {
			rgb.alpha = this.valpha;
		}

		return rgb;
	},

	round: function (places) {
		places = Math.max(places || 0, 0);
		return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
	},

	alpha: function (val) {
		if (arguments.length) {
			return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
		}

		return this.valpha;
	},

	// rgb
	red: getset('rgb', 0, maxfn(255)),
	green: getset('rgb', 1, maxfn(255)),
	blue: getset('rgb', 2, maxfn(255)),

	hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) { return ((val % 360) + 360) % 360; }), // eslint-disable-line brace-style

	saturationl: getset('hsl', 1, maxfn(100)),
	lightness: getset('hsl', 2, maxfn(100)),

	saturationv: getset('hsv', 1, maxfn(100)),
	value: getset('hsv', 2, maxfn(100)),

	chroma: getset('hcg', 1, maxfn(100)),
	gray: getset('hcg', 2, maxfn(100)),

	white: getset('hwb', 1, maxfn(100)),
	wblack: getset('hwb', 2, maxfn(100)),

	cyan: getset('cmyk', 0, maxfn(100)),
	magenta: getset('cmyk', 1, maxfn(100)),
	yellow: getset('cmyk', 2, maxfn(100)),
	black: getset('cmyk', 3, maxfn(100)),

	x: getset('xyz', 0, maxfn(100)),
	y: getset('xyz', 1, maxfn(100)),
	z: getset('xyz', 2, maxfn(100)),

	l: getset('lab', 0, maxfn(100)),
	a: getset('lab', 1),
	b: getset('lab', 2),

	keyword: function (val) {
		if (arguments.length) {
			return new Color(val);
		}

		return convert[this.model].keyword(this.color);
	},

	hex: function (val) {
		if (arguments.length) {
			return new Color(val);
		}

		return colorString.to.hex(this.rgb().round().color);
	},

	rgbNumber: function () {
		var rgb = this.rgb().color;
		return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.rgb().color;

		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}

		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();

		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}

		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	isDark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.rgb().color;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	isLight: function () {
		return !this.isDark();
	},

	negate: function () {
		var rgb = this.rgb();
		for (var i = 0; i < 3; i++) {
			rgb.color[i] = 255 - rgb.color[i];
		}
		return rgb;
	},

	lighten: function (ratio) {
		var hsl = this.hsl();
		hsl.color[2] += hsl.color[2] * ratio;
		return hsl;
	},

	darken: function (ratio) {
		var hsl = this.hsl();
		hsl.color[2] -= hsl.color[2] * ratio;
		return hsl;
	},

	saturate: function (ratio) {
		var hsl = this.hsl();
		hsl.color[1] += hsl.color[1] * ratio;
		return hsl;
	},

	desaturate: function (ratio) {
		var hsl = this.hsl();
		hsl.color[1] -= hsl.color[1] * ratio;
		return hsl;
	},

	whiten: function (ratio) {
		var hwb = this.hwb();
		hwb.color[1] += hwb.color[1] * ratio;
		return hwb;
	},

	blacken: function (ratio) {
		var hwb = this.hwb();
		hwb.color[2] += hwb.color[2] * ratio;
		return hwb;
	},

	grayscale: function () {
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var rgb = this.rgb().color;
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		return Color.rgb(val, val, val);
	},

	fade: function (ratio) {
		return this.alpha(this.valpha - (this.valpha * ratio));
	},

	opaquer: function (ratio) {
		return this.alpha(this.valpha + (this.valpha * ratio));
	},

	rotate: function (degrees) {
		var hsl = this.hsl();
		var hue = hsl.color[0];
		hue = (hue + degrees) % 360;
		hue = hue < 0 ? 360 + hue : hue;
		hsl.color[0] = hue;
		return hsl;
	},

	mix: function (mixinColor, weight) {
		// ported from sass implementation in C
		// https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		if (!mixinColor || !mixinColor.rgb) {
			throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
		}
		var color1 = mixinColor.rgb();
		var color2 = this.rgb();
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return Color.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue(),
				color1.alpha() * p + color2.alpha() * (1 - p));
	}
};

// model conversion methods and static constructors
Object.keys(convert).forEach(function (model) {
	if (skippedModels.indexOf(model) !== -1) {
		return;
	}

	var channels = convert[model].channels;

	// conversion methods
	Color.prototype[model] = function () {
		if (this.model === model) {
			return new Color(this);
		}

		if (arguments.length) {
			return new Color(arguments, model);
		}

		var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
		return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
	};

	// 'static' construction methods
	Color[model] = function (color) {
		if (typeof color === 'number') {
			color = zeroArray(_slice.call(arguments), channels);
		}
		return new Color(color, model);
	};
});

function roundTo(num, places) {
	return Number(num.toFixed(places));
}

function roundToPlace(places) {
	return function (num) {
		return roundTo(num, places);
	};
}

function getset(model, channel, modifier) {
	model = Array.isArray(model) ? model : [model];

	model.forEach(function (m) {
		(limiters[m] || (limiters[m] = []))[channel] = modifier;
	});

	model = model[0];

	return function (val) {
		var result;

		if (arguments.length) {
			if (modifier) {
				val = modifier(val);
			}

			result = this[model]();
			result.color[channel] = val;
			return result;
		}

		result = this[model]().color[channel];
		if (modifier) {
			result = modifier(result);
		}

		return result;
	};
}

function maxfn(max) {
	return function (v) {
		return Math.max(0, Math.min(max, v));
	};
}

function assertArray(val) {
	return Array.isArray(val) ? val : [val];
}

function zeroArray(arr, length) {
	for (var i = 0; i < length; i++) {
		if (typeof arr[i] !== 'number') {
			arr[i] = 0;
		}
	}

	return arr;
}

var color = Color;

var Color$1 = /*@__PURE__*/getDefaultExportFromCjs(color);

const supportAssign = typeof Object.assign === 'function';

/**
 * Merges the properties of sources into destination object.
 * @param  {Object} dest   - object to extend
 * @param  {...Object} src - sources
 * @return {Object}
 */
const TEMP_VEC = [];
function extend(dest) {
    if (supportAssign) {
        Object.assign.apply(Object, arguments);
    } else {
        for (let i = 1; i < arguments.length; i++) {
            const src = arguments[i];
            for (const k in src) {
                dest[k] = src[k];
            }
        }
    }
    return dest;
}

function isNil$1(v) {
    return v === undefined || v === null;
}

function isNumber$1(val) {
    return (typeof val === 'number') && !isNaN(val);
}

/**
 * Check whether the object is a function
 * @param {Object} obj
 * @return {Boolean}
 * @memberOf Util
 */
function isFunction(obj) {
    if (isNil$1(obj)) {
        return false;
    }
    return typeof obj === 'function' || (obj.constructor !== null && obj.constructor === Function);
}

const SCALE$1 = [];
function getGroundTransform(out, map) {
    const extent = map['_get2DExtentAtRes'](map.getGLRes());
    const scaleX = extent.getWidth(), scaleY = extent.getHeight();
    const localTransform = out;
    mat4.identity(localTransform);
    const trans = vec3.copy(TEMP_VEC, map.cameraLookAt);
    trans[2] = 0;//避免地图中心点存在高度情况下，地面跟着抬升
    mat4.translate(localTransform, localTransform, trans);
    mat4.scale(localTransform, localTransform, vec3.set(SCALE$1, scaleX, scaleY, 1));
    return localTransform;
}

function hasOwn(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

function pushIn(dest) {
    for (let i = 1; i < arguments.length; i++) {
        const src = arguments[i];
        if (src) {
            for (let ii = 0, ll = src.length; ii < ll; ii++) {
                dest.push(src[ii]);
            }
        }
    }
    return dest.length;
}

const colorCache = {};

function normalizeColor(out, color) {
    if (!Array.isArray(color)) {
        const key = color;
        color = colorCache[key] = colorCache[key] || Color$1(color).unitArray();
    }
    for (let i = 0; i < color.length; i++) {
        out[i] = color[i];
    }
    if (color.length === 3) {
        out[3] = 1;
    }
    return out;
}

function normalizeColor255(out, color) {
    if (!Array.isArray(color)) {
        const key = color;
        color = colorCache[key] = colorCache[key] || Color$1(color).unitArray();
    }
    for (let i = 0; i < color.length; i++) {
        out[i] = color[i] * 255;
    }
    if (out.length === 3) {
        out.push(255);
    }
    return out;
}

function coordinateToWorld$2(map, coordinate, z = 0) {
    if (!map || !(coordinate instanceof Coordinate)) {
        return null;
    }
    const p = map.coordinateToPointAtRes(coordinate, map.getGLRes());
    return [p.x, p.y, z];
}

const EMPTY_HALTON = [0, 0];
const DEFAULT_SHADOW_COLOR = [0, 0, 0];
//阴影覆盖的pitch范围
const SHADOW_MAX_PITCH = 62;
let VISUAL_EXTENT;

class ShadowProcess {
    static getUniformDeclares() {
        const shadowLightProjViewModelMatrix = [];
        const uniforms = [];
        uniforms.push({
            name: 'shadow_lightProjViewModelMatrix',
            type: 'function',
            fn: function (context, props) {
                const lightProjViews = props['shadow_lightProjViewMatrix'];
                const model = props['modelMatrix'];
                return  mat4.multiply(shadowLightProjViewModelMatrix, lightProjViews, model);
            }
        });
        return uniforms;
    }

    constructor(regl, layer) {
        this.renderer = new Renderer(regl);
        this._esmShadowThreshold = 0.3;
        this._layer = layer;
        this._init();
    }

    resize() {
        const canvas = this.canvas;
        canvas.width = this._layer.getRenderer().canvas.width;
        canvas.height = this._layer.getRenderer().canvas.height;
    }

    _init() {
        const sceneConfig =  this._layer._getSceneConfig() || {};
        const shadowConfig = sceneConfig.shadow || {};
        const shadowRes = this._getShadowRes();
        const defines = this.getDefines();
        this._shadowPass = new ShadowPass(this.renderer, { width: shadowRes, height: shadowRes, blurOffset: shadowConfig.blurOffset, defines });
        this._shadowDisplayShader = new ShadowDisplayShader(defines);

        this._createGround();
    }

    _getShadowRes() {
        const sceneConfig =  this._layer._getSceneConfig() || {};
        const shadowConfig = sceneConfig.shadow || {};
        let shadowRes = 2048;
        const quality = shadowConfig.quality;
        if (quality === 'medium') {
            shadowRes = 1024;
        } else if (quality === 'low') {
            shadowRes = 512;
        }
        return shadowRes;
    }

    getDefines() {
        const defines = {
            'HAS_SHADOWING': 1,
            'PACK_FLOAT': 1,
            'USE_ESM': 1
        };
        return defines;
    }

    render(displayShadow, projMatrix, viewMatrix, color, opacity, lightDirection, scene, halton, framebuffer, forceRefresh) {
        this._transformGround();
        const map = this._layer.getMap();
        const shadowRes = this._getShadowRes();
        const changed = forceRefresh || shadowRes !== this._shadowPass.width || this._shadowChanged(map, scene, !!displayShadow);
        let matrix, smap;
        if (changed) {
            if (shadowRes !== this._shadowPass.width) {
                this._shadowPass.resize(shadowRes, shadowRes);
            }
            this._tempMat0 = this._tempMat0 || [];
            this._tempMat1 = this._tempMat1 || [];
            const cameraProjViewMatrix = mat4.multiply(this._tempMat0, projMatrix, viewMatrix);
            const lightDir = vec3.normalize(this._tempMat1, lightDirection);

            if (!VISUAL_EXTENT) {
                VISUAL_EXTENT = map.getContainerExtent();
            }
            //只渲染pitch < SHADOW_MAX_PITCH的范围内的mesh，提高shadowmap精度
            let visualHeight = map.height;
            if (map.getPitch() > SHADOW_MAX_PITCH) {
                visualHeight = map['_getVisualHeight'](SHADOW_MAX_PITCH);
            }
            const containerExtent = VISUAL_EXTENT.set(0, map.height - visualHeight, map.width, map.height);
            const extent = containerExtent.convertTo(c => map['_containerPointToPointAtRes'](c, map.getGLRes()));

            const arr = extent.toArray();
            if (displayShadow) {
                scene.addMesh(this._ground);
            }
            const farPlane = arr.map(c => [c.x, c.y, 0, 1]);
            const { lightProjViewMatrix, shadowMap, /* depthFBO, */ blurFBO } = this._shadowPass.render(
                scene,
                { cameraProjViewMatrix, lightDir, farPlane, cameraLookAt: map.cameraLookAt }
            );
            matrix = this._lightProjViewMatrix = lightProjViewMatrix;
            smap = this._shadowMap = shadowMap;
            this._blurFBO = blurFBO;
            this._renderedShadows = scene.getMeshes().reduce((ids, m) => {
                if (m.castShadow && m.geometry) {
                    ids[m.uuid] = {
                        v0: m.version,
                        v1: m.geometry.version
                    };
                }
                return ids;
            }, {});
            this._renderedView = {
                count: scene.getMeshes().length - +!!displayShadow,
                displayShadow: !!displayShadow
            };
            this._updated = true;
        } else {
            matrix = this._lightProjViewMatrix;
            smap = this._shadowMap;
            // fbo = this._blurFBO;
            this._updated = false;
        }
        this._projMatrix = projMatrix;
        this._viewMatrix = viewMatrix;
        if (isNil$1(opacity)) {
            opacity = 1;
        }
        if (displayShadow && scene.getMeshes().length) {
            this.displayShadow(color, opacity, halton, framebuffer);
        }
        const uniforms = {
            'shadow_lightProjViewMatrix': matrix,
            'shadow_shadowMap': smap,
            'shadow_opacity': opacity,
            'shadow_color': color || DEFAULT_SHADOW_COLOR,
            'esm_shadow_threshold': this._esmShadowThreshold
        };

        return uniforms;
    }

    displayShadow(color, opacity, halton, framebuffer) {
        const matrix = this._lightProjViewMatrix;
        const ground = this._ground;
        const groundLightProjViewModelMatrix = this._groundLightProjViewModelMatrix || [];
        const projViewMatrix = this._projViewMatrix || [];
        const canvas = this._layer.getRenderer().canvas;
        const texSize = this._texSize = this._texSize || [];
        texSize[0] = canvas.width;
        texSize[1] = canvas.height;
        //display ground shadows
        this.renderer.render(this._shadowDisplayShader, {
            'halton': halton || EMPTY_HALTON,
            'globalTexSize': texSize,
            'projMatrix': this._projMatrix,
            'viewMatrix': this._viewMatrix,
            'projViewMatrix': mat4.multiply(projViewMatrix, this._projMatrix, this._viewMatrix),
            'shadow_lightProjViewModelMatrix': mat4.multiply(groundLightProjViewModelMatrix, matrix, ground.localTransform),
            'shadow_shadowMap': this._shadowMap,
            'esm_shadow_threshold': this._esmShadowThreshold,
            'shadow_opacity': opacity,
            'shadow_color': DEFAULT_SHADOW_COLOR,
            'color': color || DEFAULT_SHADOW_COLOR
        }, this._groundScene, framebuffer);
    }

    dispose() {
        this._shadowPass.dispose();
        this._shadowDisplayShader.dispose();
        // if (this._shadowMap) {
        // //已经在shadowPass中destroy了
        //     this._shadowMap.destroy();
        // }
        // if (this._blurFBO) {
        //     this._blurFBO.destroy();
        // }
        if (this._ground) {
            this._ground.geometry.dispose();
            this._ground.dispose();
        }
        delete this.renderer;
    }

    isUpdated() {
        return this._updated !== false;
    }

    _shadowChanged(map, scene, displayShadow) {
        // if (this._rendered || !this._rendered && scene.getMeshes().length > 5) {
        //     this._rendered = true;
        //     return false;
        // }
        if (!this._renderedShadows) {
            return true;
        }
        const renderedView = this._renderedView;
        if (scene.getMeshes().length !== renderedView.count || displayShadow !== renderedView.displayShadow) {
            return true;
        }
        const meshes = scene.getMeshes();
        const changed = false;
        for (let i = 0; i < meshes.length; i++) {
            const saved = this._renderedShadows[meshes[i].uuid];
            if (meshes[i].castShadow &&
                (meshes[i].hasSkinAnimation() || !saved ||
                    saved.v0 !== meshes[i].version ||
                    saved.v1 !== meshes[i].geometry.version)) {
                return true;
            }
        }

        return changed;
    }

    _createGround() {
        const planeGeo = new Plane();
        planeGeo.generateBuffers(this.renderer.device);
        this._ground = new Mesh(planeGeo);
        this._groundScene = new Scene([this._ground]);
    }

    _transformGround() {
        const map = this._layer.getMap();
        const localTransform = getGroundTransform(this._ground.localTransform, map);
        this._ground.setLocalTransform(localTransform);
    }
}

var fillVert = "#define SHADER_NAME BACK_FILL\nattribute vec3 aPosition;\nuniform mat4 projViewModelMatrix;\nuniform mat4 modelMatrix;\n#ifdef HAS_PATTERN\nattribute vec2 aTexCoord;\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nvarying vec2 vTexCoord;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\nvoid main() {\n  \n#ifdef HAS_PATTERN\nvTexCoord = aTexCoord * uvScale + uvOffset;\n#endif\nvec3 c = vec3(aPosition);\n  gl_Position = projViewModelMatrix * vec4(c, 1.);\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(vec4(c, 1.));\n#endif\n}";

var fillFrag = "#define SHADER_NAME BACK_FILL\nprecision mediump float;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#ifdef HAS_PATTERN\nuniform sampler2D polygonPatternFile;\nvarying vec2 vTexCoord;\n#endif\nuniform vec4 polygonFill;\nuniform float polygonOpacity;\nvoid main() {\n  \n#ifdef HAS_PATTERN\nvec4 c = texture2D(polygonPatternFile, vTexCoord);\n#else\nvec4 c = polygonFill;\n#endif\ngl_FragColor = c * polygonOpacity;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat d = shadow_computeShadow();\n  gl_FragColor.rgb = shadow_blend(gl_FragColor.rgb, d);\n#endif\n}";

function getFillShaderCodes() {
    const fillWgslVert = getWGSLSource('gl_fill_vert');
    const fillWgslFrag = getWGSLSource('gl_fill_frag');
    return { fillVert, fillFrag, fillWgslVert, fillWgslFrag };
}

const DEFAULT_TEX_OFFSET$1 = [0, 0];
const COORD0$1 = new maptalks.Coordinate(0, 0);
const COORD1 = new maptalks.Coordinate(0, 0);
const ARR2_0 = [];
const ARR2_1$1 = [];
const UNIFORMS = [];

function computeUVUniforms(map,
    xmin, ymin,
    patternOrigin, patternWidth, patternHeight, texAspect,
    uvScale,
    isOffsetInMeter, offsetValue, uvOffsetAnim) {
    const glRes = map.getGLRes();
    if (patternOrigin) {
        COORD0$1.set(patternOrigin[0], patternOrigin[1]);
        map.coordToPointAtRes(COORD0$1, glRes, COORD1);
        xmin = xmin - COORD1.x;
        ymin = ymin - COORD1.y;
    }

    const pointOrigin = patternOrigin ? COORD0$1 : null;
    // compute uv offset
    offsetValue = vec2.copy(ARR2_1$1, offsetValue);
    const uvOffset = !isOffsetInMeter && offsetValue || DEFAULT_TEX_OFFSET$1;
    let meterOffset = isOffsetInMeter && offsetValue || DEFAULT_TEX_OFFSET$1;
    meterOffset = vec2.copy(ARR2_0, meterOffset);
    if (meterOffset[0]) {
        meterOffset[0] = meterToPoint(map, meterOffset[0], pointOrigin);
    }
    if (meterOffset[1]) {
        meterOffset[1] = meterToPoint(map, meterOffset[1], pointOrigin, 1);
    }

    // compute uv scale
    let texWidth = 0.5;
    if (patternWidth) {
        texWidth = meterToPoint(map, patternWidth, pointOrigin);
    }

    let texHeight = texWidth / texAspect;
    if (patternHeight) {
        texHeight = meterToPoint(map, patternHeight, pointOrigin, 1);
    }

    const hasUVAnim = uvOffsetAnim && (uvOffsetAnim[0] || uvOffsetAnim[1]);
    if (hasUVAnim) {
        const timeStamp = performance.now() / 1000;
        // 256 是noiseTexture的高宽，乘以256可以保证动画首尾平滑过渡，不会出现跳跃
        // const speed = hasNoise ? 50000 : 1000;
        // const scale = (hasNoise ? 256 : 1);
        let animX = uvOffsetAnim[0];
        let animY = uvOffsetAnim[1];
        if (isOffsetInMeter) {
            animX = -meterToPoint(map, uvOffsetAnim[0], pointOrigin);
            animY = -meterToPoint(map, uvOffsetAnim[1], pointOrigin, 1);
        }
        if (uvOffsetAnim[0]) {
            if (isOffsetInMeter) {
                meterOffset[0] = timeStamp * animX;
            } else {
                uvOffset[0] = timeStamp * animX;
            }
        }
        if (uvOffsetAnim[1]) {
            if (isOffsetInMeter) {
                meterOffset[1] = timeStamp * animY;
            } else {
                uvOffset[1] = timeStamp * animY;
            }
        }
    }

    const uvStartX = ((xmin + meterOffset[0]) / (texWidth / uvScale[0]));
    const uvStartY = ((ymin - meterOffset[1]) / (texHeight / uvScale[1]));

    UNIFORMS[0] = texWidth / uvScale[0];
    UNIFORMS[1] = texHeight / uvScale[1];
    UNIFORMS[2] = uvStartX;
    UNIFORMS[3] = uvStartY;
    UNIFORMS[4] = uvOffset;
    return UNIFORMS;
}

function meterToPoint(map, meter, patternOrigin, isYAxis) {
    const glRes = map.getGLRes();
    const point = map.distanceToPointAtRes(meter, meter, glRes, patternOrigin ? COORD0$1 : null, COORD1);
    return isYAxis ? point.y : point.x;
}

const { getIBLResOnCanvas: getIBLResOnCanvas$1, logoutIBLResOnCanvas: logoutIBLResOnCanvas$1, getPBRUniforms: getPBRUniforms$1, loginIBLResOnCanvas: loginIBLResOnCanvas$1 } = pbr.PBRUtils;
const DEFAULT_TEX_OFFSET = [0, 0];
const DEFAULT_TEX_SCALE = [1, 1];
const ARR2_1 = [];
const ARR2_2 = [];
const ARR2_3 = [];
const ARR2_4 = [];
const ARR2_5 = [];
class GroundPainter {
    static getGroundTransform(out, map) {
        return getGroundTransform(out, map);
    }
    constructor(regl, layer) {
        this._regl = regl;
        this.renderer = new Renderer(regl);
        this._layer = layer;
        this._loader = new ResourceLoader(null);
        this._bindOnMaterialComplete = (...args) => {
            return this._onMaterialComplete.call(this, ...args);
        };
        this._init();
        const canvas = this.getMap().getRenderer().canvas;
        loginIBLResOnCanvas$1(canvas, regl, this.getMap());
    }
    needToRedraw() {
        const uvOffsetAnim = this._getUVOffsetAnim();
        return uvOffsetAnim && (uvOffsetAnim[0] || uvOffsetAnim[1]);
    }
    getMap() {
        return this._layer && this._layer.getMap();
    }
    getSymbol() {
        const ground = this._layer.getGroundConfig();
        return ground && ground.symbol;
    }
    isEnable() {
        const ground = this._layer.getGroundConfig();
        return ground && ground.enable;
    }
    paint(context) {
        if (!this.isEnable()) {
            return false;
        }
        const shader = this._getShader();
        if (this._isInSSRPhase(context) && shader === this._fillShader) {
            return false;
        }
        const defines = this._getGroundDefines(context);
        if (defines) {
            this._ground.setDefines(defines);
        }
        if (this._ground.material !== this.material) {
            this._ground.setMaterial(this.material);
        }
        const groundConfig = this._layer.getGroundConfig();
        const symbol = groundConfig && groundConfig.symbol;
        if (symbol.ssr) {
            this._ground.ssr = 1;
        }
        else {
            this._ground.ssr = 0;
        }
        this._transformGround();
        const uniforms = this._getUniformValues(context);
        uniforms['offsetFactor'] = context.offsetFactor;
        uniforms['offsetUnits'] = context.offsetUnits;
        const fbo = context && context.renderTarget && context.renderTarget.fbo;
        const renderer = this._layer.getRenderer();
        if (shader === this._fillShader) {
            //如果是drawSSR阶段不绘制fill ground，fuzhenn/maptalks-studio#461
            this.renderer.render(shader, uniforms, this._groundScene, fbo);
            if (renderer.setCanvasUpdated) {
                renderer.setCanvasUpdated();
            }
            return true;
        }
        shader.filter = context.sceneFilter;
        this.renderer.render(shader, uniforms, this._groundScene, fbo);
        if (renderer.setCanvasUpdated) {
            renderer.setCanvasUpdated();
        }
        return true;
    }
    _isInSSRPhase(context) {
        const enableSSR = this._layer.getRenderer().isEnableSSR && this._layer.getRenderer().isEnableSSR();
        if (!enableSSR) {
            return false;
        }
        return !!(context && context.ssr);
    }
    update() {
        const groundConfig = this._layer.getGroundConfig();
        if (!groundConfig) {
            return;
        }
        const symbol = groundConfig && groundConfig.symbol;
        const urlModifier = groundConfig.urlModifier;
        if (!symbol) {
            this._polygonFill = [1, 1, 1, 1];
            this._polygonOpacity = 1;
            if (this._polygonPatternFile) {
                this._polygonPatternFile.destroy();
                delete this._polygonPatternFile;
            }
        }
        else {
            this._polygonFill = this._parseColor(symbol['polygonFill'] || [1, 1, 1, 1]);
            this._polygonOpacity = symbol['polygonOpacity'] === undefined ? 1 : symbol['polygonOpacity'];
            const polygonPatternFile = symbol.polygonPatternFile;
            if (polygonPatternFile) {
                if (!this._polygonPatternFile || this._polygonPatternFile['_pattern_src'] !== polygonPatternFile) {
                    const image = new Image();
                    image.onload = () => {
                        if (this._polygonPatternFile) {
                            this._polygonPatternFile.destroy();
                        }
                        this._polygonPatternFile = this._createPatternTexture(image);
                        this._polygonPatternFile['_pattern_src'] = polygonPatternFile;
                        this.setToRedraw();
                    };
                    image.src = urlModifier && urlModifier(polygonPatternFile) || polygonPatternFile;
                }
            }
            else if (this._polygonPatternFile) {
                this._polygonPatternFile.destroy();
                delete this._polygonPatternFile;
            }
        }
        this._updateMaterial();
    }
    setToRedraw() {
        const renderer = this._layer.getRenderer();
        if (!renderer) {
            return;
        }
        renderer.setToRedraw();
    }
    dispose() {
        if (this.material) {
            this.material.dispose();
            delete this.material;
        }
        if (this._ground) {
            this._ground.geometry.dispose();
            if (this._ground.material) {
                this._ground.material.dispose();
            }
            this._ground.dispose();
            delete this._ground;
        }
        if (this._polygonPatternFile) {
            this._polygonPatternFile.destroy();
            delete this._polygonPatternFile;
        }
        if (this._fillShader) {
            this._fillShader.dispose();
            delete this._fillShader;
        }
        if (this._standardShader) {
            this._standardShader.dispose();
            delete this._standardShader;
        }
        this._disposeIblTextures();
    }
    _getShader() {
        const groundConfig = this._layer.getGroundConfig();
        if (!groundConfig || !groundConfig.renderPlugin) {
            return this._fillShader;
        }
        const type = groundConfig.renderPlugin.type;
        if (type === 'lit') {
            return this._standardShader;
        }
        else if (type === 'fill') {
            return this._fillShader;
        }
        else {
            throw new Error('unsupported render plugin of ' + type + ' for layer ground');
        }
    }
    _getUniformValues(context) {
        const uniforms = this._getCommonUniforms(context);
        uniforms.polygonFill = this._polygonFill;
        uniforms.polygonOpacity = this._polygonOpacity;
        const shader = this._getShader();
        if (shader === this._fillShader && this._polygonPatternFile) {
            uniforms.polygonPatternFile = this._polygonPatternFile;
        }
        return uniforms;
    }
    _getCommonUniforms(context) {
        const groundConfig = this._layer.getGroundConfig();
        const type = groundConfig.renderPlugin.type;
        let uniforms;
        if (type === 'lit') {
            const canvas = this.getMap().getRenderer().canvas;
            const { iblTexes, dfgLUT } = getIBLResOnCanvas$1(canvas);
            uniforms = getPBRUniforms$1(this.getMap(), iblTexes, dfgLUT, context && context.ssr, context && context.jitter);
        }
        else {
            const map = this.getMap();
            uniforms = {
                projViewMatrix: map.projViewMatrix
            };
        }
        this._setIncludeUniformValues(uniforms, context);
        return uniforms;
    }
    _setIncludeUniformValues(uniforms, context) {
        const includes = context && context.includes;
        if (includes) {
            for (const p in includes) {
                if (includes[p]) {
                    if (context[p].renderUniforms) {
                        extend(uniforms, context[p].renderUniforms);
                    }
                }
            }
        }
    }
    _disposeIblTextures() {
        const canvas = this.getMap().getRenderer().canvas;
        logoutIBLResOnCanvas$1(canvas, this.getMap());
    }
    _init() {
        //fill shader
        const extraCommandProps = this._getExtraCommandProps();
        const fillUniforms = ShadowProcess.getUniformDeclares();
        const projViewModelMatrix = [];
        fillUniforms.push({
            name: 'projViewModelMatrix',
            type: 'function',
            fn: function (context, props) {
                return mat4.multiply(projViewModelMatrix, props['projViewMatrix'], props['modelMatrix']);
            }
        });
        const { fillVert, fillFrag, fillWgslVert, fillWgslFrag } = getFillShaderCodes();
        this._fillShader = new MeshShader({
            name: 'ground-fill',
            vert: fillVert,
            frag: fillFrag,
            wgslVert: fillWgslVert,
            wgslFrag: fillWgslFrag,
            uniforms: fillUniforms,
            extraCommandProps,
            defines: {}
        });
        //standard shader
        const uniforms = ShadowProcess.getUniformDeclares();
        uniforms.push(...SsrPass.getUniformDeclares());
        this._standardShader = new pbr.StandardShader({
            uniforms,
            extraCommandProps
        });
        this._createGround();
        this.update();
    }
    _getExtraCommandProps() {
        const defaultRange = [0, 1];
        const canvas = this._layer.getRenderer().canvas;
        return {
            viewport: {
                x: 0,
                y: 0,
                width: () => {
                    return canvas.width;
                },
                height: () => {
                    return canvas.height;
                }
            },
            cull: {
                enable: true
            },
            depth: {
                enable: true,
                mask: () => {
                    const ground = this._layer.getGroundConfig();
                    return ground.depth || ground.depth === undefined;
                },
                range: () => {
                    const groundConfig = this._layer.getGroundConfig();
                    const groundSceneConfig = groundConfig && groundConfig.renderPlugin.sceneConfig;
                    return groundSceneConfig && groundSceneConfig['depthRange'] || defaultRange;
                },
                //如果设成'<'，会有低级别下地面消失的问题，fuzhenn/maptalks-studio#460
                func: '<='
            },
            blend: {
                enable: true,
                func: {
                    src: 'src alpha',
                    dst: 'one minus src alpha'
                },
                equation: 'add'
            },
            polygonOffset: {
                enable: true,
                offset: {
                    factor: (context, props) => {
                        return props['offsetFactor'];
                    },
                    units: (context, props) => {
                        return props['offsetUnits'];
                    }
                }
            }
        };
    }
    _hasIBL() {
        const lightManager = this.getMap().getLightManager();
        const resource = lightManager && lightManager.getAmbientResource();
        return !!resource;
    }
    _createGround() {
        const planeGeo = new Plane();
        planeGeo.data.aTexCoord = new Float32Array([
            0, 0,
            1, 0,
            0, 1,
            1, 1
        ]);
        planeGeo.createTangent();
        planeGeo.generateBuffers(this.renderer.device);
        //TODO 还需要构造 tangent
        this._ground = new Mesh(planeGeo, null, { castShadow: false });
        const defines = this._standardShader.getGeometryDefines(planeGeo);
        this._ground.setDefines(defines);
        this._groundScene = new Scene([this._ground]);
    }
    _transformGround() {
        const map = this.getMap();
        const localTransform = GroundPainter.getGroundTransform(this._ground.localTransform, map);
        this._ground.setLocalTransform(localTransform);
        const glRes = map.getGLRes();
        const extent = map['_get2DExtentAtRes'](glRes);
        const width = extent.getWidth();
        const height = extent.getHeight();
        const center = map.cameraLookAt;
        const xmin = center[0] - width;
        const ymin = center[1] - height;
        const texAspect = this._polygonPatternFile ? this._polygonPatternFile.width / this._polygonPatternFile.height : 1;
        const symbol = this.getSymbol();
        const patternOrigin = this.material ? this.material.get('textureOrigin') : symbol.polygonPatternFileOrigin;
        const isOffsetInMeter = !!(this.material ? this.material.get('uvOffsetInMeter') : symbol.uvOffsetInMeter);
        const offsetValue = (this.material ? this.material.get('uvOffset') : symbol.uvOffset) || DEFAULT_TEX_OFFSET;
        const uvScale = this.material && this.material.get('uvScale') || DEFAULT_TEX_SCALE;
        const patternWidth = this.material ? this.material.get('textureWidth') : symbol.polygonPatternFileWidth;
        const patternHeight = this.material ? patternWidth * (uvScale[1] / uvScale[0]) : symbol.polygonPatternFileHeight;
        const uvOffsetAnim = this._getUVOffsetAnim();
        const [textureWidth, textureHeight, uvStartX, uvStartY, uvOffset] = computeUVUniforms(map, xmin, ymin, patternOrigin, patternWidth, patternHeight, texAspect, uvScale, isOffsetInMeter, offsetValue, uvOffsetAnim);
        // 乘以2是因为plane的长宽是extent的2倍
        const scaleX = extent.getWidth() * 2 / textureWidth;
        const scaleY = extent.getHeight() * 2 / textureHeight;
        if (!this.material) {
            // fill
            this._ground.setUniform('uvScale', vec2.set(ARR2_1, scaleX, scaleY));
            this._ground.setUniform('uvOffset', vec2.set(ARR2_2, uvStartX % 1 + uvOffset[0], uvStartY % 1 + uvOffset[1]));
            return;
        }
        this._ground.setUniform('uvScale', vec2.set(ARR2_5, scaleX, scaleY));
        this._ground.setUniform('uvOffset', vec2.set(ARR2_3, uvStartX % 1 + uvOffset[0], uvStartY % 1 + uvOffset[1]));
        // uvOrigin 是 uvStart的整数部分
        this._ground.setUniform('uvOrigin', vec2.set(ARR2_4, uvStartX - (uvStartX % 1), uvStartY - (uvStartY % 1)));
        this._ground.setUniform('uvRotation', 0);
    }
    _getGroundDefines(context) {
        let updated = false;
        const defines = this._ground.defines;
        const sceneConfig = this._layer._getSceneConfig && this._layer._getSceneConfig();
        const groundConfig = this._layer.getGroundConfig();
        function update(has, name) {
            if (has) {
                if (!defines[name]) {
                    defines[name] = 1;
                    updated = true;
                }
            }
            else if (defines[name]) {
                delete defines[name];
                updated = true;
            }
        }
        update(this._hasIBL(), 'HAS_IBL_LIGHTING');
        const hasSSR = context && context.ssr && groundConfig && groundConfig.symbol && groundConfig.symbol.ssr;
        update(hasSSR, 'HAS_SSR');
        const hasShadow = context && sceneConfig && sceneConfig.shadow && sceneConfig.shadow.enable;
        update(hasShadow, 'HAS_SHADOWING');
        update(hasShadow, 'USE_ESM');
        const hasPattern = !!this._polygonPatternFile;
        update(hasPattern, 'HAS_PATTERN');
        // const hasSSAO = context && context.ssao;
        // update(hasSSAO, 'HAS_SSAO');
        if (!updated) {
            return null;
        }
        return defines;
    }
    _updateMaterial() {
        const materialConfig = this.getSymbol() && this.getSymbol().material || {};
        const material = {};
        let hasTexture = false;
        const ground = this._layer.getGroundConfig();
        this._loader.setURLModifier(ground.urlModifier);
        for (const p in materialConfig) {
            if (hasOwn(materialConfig, p)) {
                if (p.indexOf('Texture') > 0) {
                    //纹理图片
                    let texConf = materialConfig[p];
                    if (!texConf) {
                        continue;
                    }
                    texConf = typeof texConf === 'string' ? {
                        url: texConf,
                        wrap: 'repeat',
                    } : texConf;
                    texConf.flipY = true;
                    texConf.min = 'linear mipmap linear';
                    texConf.mag = 'linear';
                    texConf.flipY = true;
                    // texConf.aniso = 4;
                    material[p] = new Texture2D(texConf, this._loader);
                    hasTexture = true;
                }
                else {
                    material[p] = materialConfig[p];
                }
            }
        }
        if (!this.material) {
            this.material = new pbr.StandardMaterial(material);
            this.material.once('complete', this._bindOnMaterialComplete, this);
        }
        else {
            this._loadingMaterial = new pbr.StandardMaterial(material);
            if (this._loadingMaterial.isReady()) {
                this._onMaterialComplete();
            }
            else {
                this._loadingMaterial.once('complete', this._bindOnMaterialComplete);
            }
        }
        if (!hasTexture) {
            this._onMaterialComplete();
        }
    }
    _onMaterialComplete() {
        if (this._loadingMaterial) {
            this.material.dispose();
            this.material = this._loadingMaterial;
            delete this._loadingMaterial;
        }
        this.setToRedraw();
    }
    _createPatternTexture(image) {
        image = resizeToPowerOfTwo(image);
        const regl = this._regl;
        const config = {
            width: image.width,
            height: image.height,
            data: image,
            mag: 'linear',
            min: 'linear mipmap linear',
            flipY: true,
            wrap: 'repeat'
        };
        return regl.texture(config);
    }
    _parseColor(c) {
        return normalizeColor([], c);
    }
    _getUVOffsetAnim() {
        return this.material && this.material.get('uvOffsetAnim');
    }
    getRenderMeshes() {
        return this._groundScene.getMeshes();
    }
}

const { createIBLTextures, disposeIBLTextures } = pbr.PBRUtils;

const EMPTY_HSV = [0, 0, 0];
const HSV = [];
const OUTSIZE = [];

class EnvironmentPainter {
    constructor(regl, layer) {
        this._maxLevel = 4;
        this._regl = regl;
        this.renderer = new Renderer(regl);
        this._layer = layer;
        this._init();
        this._updateMode();
    }

    paint(context) {
        if (!this.isEnable() || !this._resource) {
            return;
        }
        const uniforms = this._getUniformValues(context);
        const fbo = context && context.renderTarget && context.renderTarget.fbo;
        this.renderer.render(this._shader, uniforms, null, fbo);
    }

    update() {
        const map = this.getMap();
        if (!map || !this.isEnable()) {
            return;
        }
        const lightManager = map.getLightManager();
        const resource = lightManager && lightManager.getAmbientResource();
        if (resource !== this._resource && this._iblTexes) {
            disposeIBLTextures(this._iblTexes);
            delete this._iblTexes;
        }
        this._resource = resource;
        this._updateMode();
    }

    dispose() {
        this._shader.dispose();
        disposeIBLTextures(this._iblTexes);
        delete this._shader;
        delete this._iblTexes;
        delete this._resource;
    }

    getMap() {
        return this._layer.getMap();
    }

    _updateMode() {
        if (!this._resource) {
            return;
        }
        const sceneConfig = this._layer._getSceneConfig();
        const environment = sceneConfig.environment || {};
        this._shader.setMode(environment.toneMapping, environment.mode ? 1 : 0);
    }

    isEnable() {
        const sceneConfig = this._layer._getSceneConfig();
        return this._hasIBL() && sceneConfig && sceneConfig.environment && sceneConfig.environment.enable;
    }

    _hasIBL() {
        const lightManager = this.getMap().getLightManager();
        const resource = lightManager && lightManager.getAmbientResource();
        return !!resource;
    }

    _getUniformValues() {
        const map = this.getMap();
        const lightManager = this.getMap().getLightManager();
        const ambient = lightManager && lightManager.getAmbientLight();
        let iblTexes = this._iblTexes;
        if (!iblTexes) {
            iblTexes = this._iblTexes = createIBLTextures(this._regl, map);
            // const lightManager = this.getMap().getLightManager();
            // const resource = lightManager.getAmbientResource();
            //     this._iblTexes.prefilterMap = this._regl.cube({
            //     width: resource.prefilterMap.width,
            //     height: resource.prefilterMap.height,
            //     faces: resource.prefilterMap.faces,
            //     min : 'linear mipmap linear',
            //     mag : 'linear',
            //     format: 'rgba',
            //     // mipmap: true
            // })
        }
        const canvas = this._layer.getRenderer().canvas;
        const envConfig = this._layer._getSceneConfig().environment || {};
        const level = envConfig.level || 0;
        const cubeSize = iblTexes.prefilterMap.width;
        const transform = this._transform = this._transform || [];
        const hsv = ambient && ambient.hsv || EMPTY_HSV;
        const brightness = envConfig.brightness || 0;
        const intensity = envConfig.intensity || 1;
        vec3.copy(HSV, hsv);
        if (brightness) {
            HSV[2] += brightness;
        }
        OUTSIZE[0] = canvas.width;
        OUTSIZE[1] = canvas.height;
        return {
            'cubeMap': iblTexes.prefilterMap,
            'bias': level,
            'size': cubeSize / Math.pow(2, Math.max(0, level - 1)),
            'environmentExposure': isNumber$1(ambient && ambient.exposure) ? ambient.exposure : 1,
            'backgroundIntensity': intensity,
            'diffuseSPH': iblTexes.sh,
            'viewMatrix': map.viewMatrix,
            'projMatrix': map.projMatrix,
            'resolution': OUTSIZE,
            'hsv': HSV,
            'transformMatrix': mat3.fromRotation(transform, ambient && Math.PI / 180 * -ambient.orientation || 0)
        };
    }

    _init() {
        const map = this.getMap();
        map.on('updatelights', this.update, this);
        this._shader = new SkyboxShader();
        if (map.options.lights) {
            const lightManager = this.getMap().getLightManager();
            const resource = lightManager.getAmbientResource();
            this._resource = resource;
        }
    }
}

var rainVert = "attribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform vec3 cameraPosition;\nuniform float top;\nuniform float bottom;\nuniform float time;\nvarying vec2 vTexCoord;\n#include <get_output>\nfloat c(float x, float y) {\n  return atan(y, x);\n}\nvec2 d(vec2 e, vec2 f, vec2 h) {\n  vec2 i = vec2(.0);\n  float j = distance(h, f);\n  float a = c(e.x - f.x, e.y - f.y);\n  h.x > f.x ? a -= .785 : a += .785;\n  i.x = cos(a) * j;\n  i.y = sin(a) * j;\n  return i + f;\n  return i;\n}\nvoid main() {\n  vec4 k = getPosition(aPosition);\n  mat4 l = getPositionMatrix();\n  vec2 m = d(vec2(cameraPosition.x, cameraPosition.z), vec2(aNormal.x, aNormal.z), vec2(k.x, k.z));\n  float n = top - bottom;\n  float y = aNormal.y - bottom - n * time;\n  y = y + (y < .0 ? n : .0);\n  float o = (1. - y / n) * (1. - y / n);\n  y = n * (1. - o);\n  y += bottom;\n  y += aPosition.y - aNormal.y;\n  k = vec4(m.x, y, m.y, 1.);\n  gl_Position = projMatrix * modelViewMatrix * l * k;\n  vTexCoord = aTexCoord;\n}";

var rainFrag = "precision mediump float;\nvarying vec2 vTexCoord;\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D rainMap;\nvoid main() {\n  vec4 c = texture2D(rainMap, vTexCoord);\n  vec4 d = vec4(diffuse, opacity);\n  d *= c;\n  gl_FragColor = d;\n}";

const modelViewMatrix$1 = [];
const DEFALUT_SCALE$1 = [0.03, 0.03, 0.03];
const TEMP_ROTATE$1 = [], TEMP_SCALE$1 = [], TEMP_MAT$1 = [];
const DEFAULT_COLOR = [1, 1, 1];
const DEFAULT_EXTENT = {
        min:[-1200, -1200, 0],
        max:[1200, 1200, 1000]
    }, DEFAULT_ZOOM$2 = 16.685648411389433, extent = {min: [], max: []};
const Y_UP_TO_Z_UP$1 = mat4.fromRotationTranslation([], quat.fromEuler([], 90, 0, 0), [0, 0, 0]);

class RainPainer {
    constructor(regl, layer) {
        this._regl = regl;
        this.renderer = new Renderer(regl);
        this._layer = layer;
        this._timer = new Clock();
        this._init();
    }

    getMap() {
        return this._layer && this._layer.getMap();
    }

    _init() {
        const canvas = this._layer.getRenderer().canvas;
        const viewport = {
            x : 0,
            y : 0,
            width : () => {
                return canvas.width;
            },
            height : () => {
                return canvas.height;
            }
        };
        this._shader = new MeshShader({
            name: 'rain',
            vert: rainVert,
            frag: rainFrag,
            wgslVert: getWGSLSource('gl_rain_vert'),
            wgslFrag: getWGSLSource('gl_rain_frag'),
            uniforms: [
                {
                    name: 'modelViewMatrix',
                    type: 'function',
                    fn: function (context, props) {
                        return mat4.multiply(modelViewMatrix$1, props['viewMatrix'], props['modelMatrix']);
                    }
                }
            ],
            extraCommandProps: {
                viewport,
                depth: {
                    enable: true,
                    mask: false,
                    func: 'less',
                    range: [0, 1]
                },
                blend: {
                    enable: true,
                    func: {
                        src: 'src alpha',
                        dst: 'one minus src alpha'
                    },
                    equation: 'add'
                }
            },
        });
        this._createScene();
    }

    _createScene() {
        const emptyTexture = this._regl.texture({ width: 2, height: 2});
        this._mesh = this._createRain();
        if (!this._mesh) {
            return;
        }
        this._scene = new Scene(this._mesh);
        const rainConfig = this._getRainConfig();
        if (!rainConfig.rainTexture) {
            this._mesh.material.set('rainMap', emptyTexture);
            console.warn('should set rain texture.');
        } else {
            this._creatRainTexture(rainConfig.rainTexture).then(rainMap => {
                this._mesh.material.set('rainMap', rainMap);
            });
        }
    }

    _createRain() {
        const map = this.getMap();
        const rainConfig = this._getRainConfig();
        if (!rainConfig) {
            return null;
        }
        this._fixZoom = map.getZoom();
        const box = this._getFixExtent();
        // const box = DEFAULT_EXTENT;
        const rainDensity = this._rainDensity = rainConfig.density;

        const rainWidth = this._rainWidth = rainConfig.rainWidth || 1;
        const rainHeight = this._rainHeight = rainConfig.rainHeight || 1;
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        for (let i = 0; i < rainDensity; i++) {
            const pos = {};
            pos.x = Math.random() * (box.max[0] - box.min[0]) + box.min[0];
            pos.y = Math.random() * (box.max[2] - box.min[2]) + box.min[2];
            pos.z = Math.random() * (box.max[1] - box.min[1]) + box.min[1];
            //雨滴的高宽比3:1
            const height = ((box.max[2] - box.min[2]) / 37.5) * rainHeight;
            const width = (height / 3) * rainWidth;

            vertices.push(
                pos.x + width,
                pos.y + height,
                pos.z,
                pos.x - width,
                pos.y + height,
                pos.z,
                pos.x - width,
                pos.y,
                pos.z,
                pos.x + width,
                pos.y,
                pos.z
            );

            normals.push(
                pos.x,
                pos.y - height / 2,
                pos.z,
                pos.x,
                pos.y - height / 2,
                pos.z,
                pos.x,
                pos.y - height / 2,
                pos.z,
                pos.x,
                pos.y - height / 2,
                pos.z
            );

            uvs.push(1, 1, 0, 1, 0, 0, 1, 0);

            indices.push(
                i * 4 + 0,
                i * 4 + 1,
                i * 4 + 2,
                i * 4 + 0,
                i * 4 + 2,
                i * 4 + 3
            );
        }
        const attributes = {};
        attributes['POSITION'] = vertices;
        attributes['NORMAL'] = normals;
        attributes['TEXCOORD_0'] = uvs;
        const geometry = new Geometry(
            attributes,
            indices,
            0,
            {
                primitive : 'triangles',
                positionAttribute: 'POSITION',
                normalAttribute: 'NORMAL',
                uv0Attribute: 'TEXCOORD_0'
            }
        );
        geometry.generateBuffers(this.renderer.device);
        const material = new Material({
            rainMap: this._regl.texture({ width: 2, height: 2 }),
            diffuse: rainConfig.color || [1, 1, 1],
            opacity: rainConfig.opacity || 1
        });
        const modelMesh = new Mesh(geometry, material);
        modelMesh.setUniform('top', box.max[2]);
        modelMesh.setUniform('bottom', box.min[2]);
        this._transformRain(modelMesh);
        modelMesh.transparent = true;
        return modelMesh;
    }

    _creatRainTexture(rainTexture) {
        const rainImage = new Image();
        rainImage.src = this._rainTexture = rainTexture;
        return new Promise((resolve, reject) => {
            rainImage.onload = () => {
                const rainMap = this._regl.texture({
                    mag: 'linear',
                    min: 'linear mipmap nearest',
                    wrapS: 'clamp',
                    wrapT: 'clamp',
                    data: rainImage
                });
                resolve(rainMap);
            };
            rainImage.onerror = (err) => {
                reject(err);
            };
        });
    }

    paint(context) {
        if (!this._scene) {
            return;
        }
        const rainConfig = this._getRainConfig();
        const uniforms = {};
        const map = this.getMap();
        uniforms['projMatrix'] = map.projMatrix;
        uniforms['viewMatrix'] = map.viewMatrix;
        uniforms['cameraPosition'] = map.cameraPosition;
        const speed = rainConfig.speed || 1.0;
        const time = this._timer.getElapsedTime() / (2 / speed) % 1;
        uniforms['time'] = time;
        this._mesh.material.set('diffuse', rainConfig.color || DEFAULT_COLOR);
        this._mesh.material.set('opacity', rainConfig.opacity || 1);
        this._transformRain(this._mesh);
        const fbo = context && context.renderTarget && context.renderTarget.fbo;
        this.renderer.render(this._shader, uniforms, this._scene, fbo);
        this._layer.getRenderer().setCanvasUpdated();
    }

    _transformRain(mesh) {
        const map = this.getMap();
        const center = map.coordinateToPointAtRes(map.getCenter(), map.getGLRes());
        const ratio = map.getGLScale() / map.getGLScale(this._fixZoom);
        const v3 = vec3.set(TEMP_SCALE$1, ratio, ratio, ratio);
        const scale = vec3.multiply(v3, DEFALUT_SCALE$1, v3);
        const transformat = mat4.identity(TEMP_MAT$1);
        const config = this._getRainConfig();
        const bearing = map.getBearing();
        mat4.fromRotationTranslationScale(transformat, quat.fromEuler(TEMP_ROTATE$1, config.windDirectionX || 0, config.windDirectionY || 0, -bearing + 90), [center.x, center.y, 0], scale);
        mat4.multiply(transformat, transformat, Y_UP_TO_Z_UP$1);
        mesh.setLocalTransform(transformat);
    }

    setToRedraw() {
        const renderer = this._layer.getRenderer();
        if (!renderer) {
            return;
        }
        renderer.setToRedraw();
    }

    update() {
        const rainConfig = this._getRainConfig();
        if (!rainConfig) {
            return;
        }
        if (!this._mesh) {
            this._createScene();
        }
        //更改雨量大小，需要重新创建mesh
        if (rainConfig.density !== this._rainDensity || rainConfig.rainWidth !== this._rainWidth || rainConfig.rainHeight !== this._rainHeight) {
            const rainMap = this._mesh.material.get('rainMap');
            this._mesh.geometry.dispose();
            this._mesh.dispose();
            this._scene.clear();
            this._mesh = this._createRain();
            this._mesh.material.set('rainMap', rainMap);
            this._scene.setMeshes(this._mesh);
        }
        if (rainConfig.rainTexture !== this._rainTexture) {
            this._creatRainTexture(rainConfig.rainTexture).then(rainMap => {
                this._mesh.material.set('rainMap', rainMap);
            });
        }
    }

    dispose() {
        if (this._mesh) {
            this._mesh.geometry.dispose();
            if (this._mesh.material) {
                this._mesh.material.dispose();
            }
            this._mesh.dispose();
            delete this._mesh;
        }
        if (this._shader) {
            this._shader.dispose();
            delete this._shader;
        }
    }

    isEnable() {
        const config = this._getRainConfig();
        return config && config.enable;
    }

    _getRainConfig() {
        const weatherConfig = this._layer.getWeatherConfig();
        return weatherConfig && weatherConfig.rain;
    }

    _getFixExtent() {
        const map = this.getMap();
        const zoom = map.getZoom();
        const ratio = DEFAULT_ZOOM$2 - zoom;
        vec3.scale(extent.min, DEFAULT_EXTENT.min, Math.pow(2, ratio));
        vec3.scale(extent.max, DEFAULT_EXTENT.max, Math.pow(2, ratio));
        return extent;
    }
}

class Clock {
    constructor(autoStart) {
        this.autoStart = (autoStart !== undefined ) ? autoStart : true;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }

    start () {
        this.startTime = ( typeof performance === 'undefined' ? Date : performance ).now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }

    stop () {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }

    getElapsedTime () {
        this.getDelta();
        return this.elapsedTime;
    }

    getDelta () {
        let diff = 0;
        if ( this.autoStart && ! this.running ) {
            this.start();
            return 0;
        }

        if ( this.running ) {
            const newTime = ( typeof performance === 'undefined' ? Date : performance ).now();
            diff = ( newTime - this.oldTime ) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return 0;
    }
}

var snowVert = "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n  vec4 d = getPosition(aPosition);\n  gl_Position = projMatrix * modelViewMatrix * c * d;\n  vTexCoord = aTexCoord;\n}";

var snowFrag = "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nprecision mediump float;\nuniform sampler2D perlinTexture;\nvarying vec2 vTexCoord;\nfloat c(float a, float b, float w) {\n  return a + w * (b - a);\n}\nvoid main() {\n  float d = texture2D(perlinTexture, vTexCoord).r;\n  vec3 e = vec3(1.);\n  float r = c(.5, e.x, d);\n  float g = c(.5, e.y, d);\n  float b = c(.5, e.z, d);\n  glFragColor = vec4(r, g, b, 1.);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

const modelViewMatrix = [];
const DEFALUT_SCALE = [0.03, 0.03, 0.03];
const TEMP_ROTATE = [], TEMP_SCALE = [], TEMP_MAT = [], DEFAULT_ZOOM$1 = 16.685648411389433;
const Y_UP_TO_Z_UP = mat4.fromRotationTranslation([], quat.fromEuler([], 90, 0, 0), [0, 0, 0]);

class SnowPainter {
    constructor(regl, layer) {
        this._regl = regl;
        this._layer = layer;
        this._init();
    }

    _init() {
        const canvas = this._layer.getRenderer().canvas;
        const viewport = {
            x : 0,
            y : 0,
            width : () => {
                return canvas.width;
            },
            height : () => {
                return canvas.height;
            }
        };
        this._shader = new MeshShader({
            name: 'snow',
            vert: snowVert,
            frag: snowFrag,
            wgslVert: getWGSLSource('gl_snow_vert'),
            wgslFrag: getWGSLSource('gl_snow_frag'),
            uniforms: [
                {
                    name: 'modelViewMatrix',
                    type: 'function',
                    fn: function (context, props) {
                        return mat4.multiply(modelViewMatrix, props['viewMatrix'], props['modelMatrix']);
                    }
                }
            ],
            extraCommandProps: {
                viewport
            }
        });
        this._shader.version = 300;
        this._scene = new Scene();
        this._groundMask = this._createGroundMask();
        this._scene.setMeshes(this._groundMask);
        this.renderer = new Renderer(this._regl);
        const snowConfig = this._getSnowConfig();
        if (!snowConfig) {
            return;
        }
        if (!snowConfig.snowGroundTexture) {
            this._groundNormal = this._regl.texture({width: 2, height: 2});
            console.warn('should set snow ground texture.');
        } else {
            this._createSnowTexture(snowConfig.snowGroundTexture);
        }
    }

    render(context) {
        if (this._groundNormal) {
            this._groundMask.material.set('perlinTexture', this._groundNormal);
        }
        const map = this._layer.getMap();
        this._transformMask(map);
        const uniforms = {
            projMatrix: map.projMatrix,
            viewMatrix: map.viewMatrix,
            cameraPosition: map.cameraPosition
        };
        const fbo = context && context.renderTarget && context.renderTarget.fbo;
        this.renderer.render(
            this._shader,
            uniforms,
            this._scene,
            fbo
        );
        this._layer.getRenderer().setCanvasUpdated();
    }

    _transformMask(map) {
        const center = map.coordinateToPointAtRes(map.getCenter(), map.getGLRes());
        const ratio = map.getGLScale() / map.getGLScale(this._fixZoom);
        const v3 = vec3.set(TEMP_SCALE, ratio, ratio, ratio);
        const scale = vec3.multiply(v3, DEFALUT_SCALE, v3);
        const transformat = mat4.identity(TEMP_MAT);
        mat4.fromRotationTranslationScale(transformat, quat.fromEuler(TEMP_ROTATE, 0, 0, 0), [center.x, center.y, 0.005], scale);
        mat4.multiply(transformat, transformat, Y_UP_TO_Z_UP);
        this._groundMask.setLocalTransform(transformat);
    }

    _createSnowTexture(snowGroundTexture) {
        const image = new Image();
        image.onload = () => {
            this._groundNormal = this._regl.texture({
                mag: 'linear',
                min: 'linear mipmap nearest',
                wrapS: 'repeat',
                wrapT: 'repeat',
                data: image
            });
        };
        image.onerror = (err) => {
            console.log(err);
        };
        image.src = this._snowGroundTexture = snowGroundTexture;
    }

    _createGroundMask() {
        const map = this._layer.getMap();
        this._fixZoom = map.getZoom();
        const pos = Math.pow(2, DEFAULT_ZOOM$1 - this._fixZoom) * 16000;
        const vertices = [
            -pos, 0, -pos,
            pos, 0, -pos,
            -pos, 0, pos,
            pos, 0, pos,
        ];
        const normals = [
            0, 1, 0,
            0, 1, 0,
            0, 1, 0,
            0, 1, 0
        ];
        const uvs = [
            0.0, 0.0,
            1.0, 0.0,
            0.0, 1.0,
            1.0, 1.0
        ];
        const indices = [
            3, 1, 0, 0, 2, 3
        ];

        const attributes = {};
        attributes['POSITION'] = vertices;
        attributes['NORMAL'] = normals;
        attributes['TEXCOORD_0'] = uvs;
        const geometry = new Geometry(
            attributes,
            indices,
            0,
            {
                positionAttribute: 'POSITION',
                normalAttribute: 'NORMAL',
                uv0Attribute: 'TEXCOORD_0'
            }
        );
        geometry.generateBuffers(this._regl);
        const material = new Material({
            perlinTexture: this._regl.texture({ width: 2, height: 2 })
        });
        const mesh = new Mesh(geometry, material);
        return mesh;
    }

    getMeshes() {
        return this._groundMask;
    }

    dispose() {
        if (this._groundMask) {
            this._groundMask.geometry.dispose();
            if (this._groundMask.material) {
                this._groundMask.material.dispose();
            }
            this._groundMask.dispose();
            delete this._groundMask;
        }
        if (this._shader) {
            this._shader.dispose();
            delete this._shader;
        }
    }

    update() {
        const snowConfig = this._getSnowConfig();
        if (!snowConfig) {
            return;
        }
        if (snowConfig.snowGroundTexture === !this._snowGroundTexture) {
            this._createSnowTexture(snowConfig.snowGroundTexture);
        }
    }

    isEnable() {
        const config = this._getSnowConfig();
        return config && config.enable;
    }

    _getSnowConfig() {
        const weatherConfig = this._layer.getWeatherConfig();
        return weatherConfig && weatherConfig.snow;
    }

}

const RESOLUTION$2 = [],  DEFAULT_ZOOM = 16.685648411389433;
class WeatherPainter {
    constructor(regl, layer, config) {
        this._regl= regl;
        this._layer = layer;
        this._config = config;
        this._init();
    }

    _init() {
        this.renderer = new Renderer(this._regl);
        const layerRenderer = this._layer.getRenderer();
        const viewport = this._viewport = {
            x : 0,
            y : 0,
            width : () => {
                return layerRenderer.canvas ? layerRenderer.canvas.width : 1;
            },
            height : () => {
                return layerRenderer.canvas ? layerRenderer.canvas.height : 1;
            }
        };
        this._width = viewport.width, this._height = viewport.height;
        this._fbo = this._regl.framebuffer({
            color: this._regl.texture({
                width: layerRenderer.canvas ? layerRenderer.canvas.width : 1,
                height: layerRenderer.canvas ? layerRenderer.canvas.height : 1,
                wrap: 'clamp',
                mag : 'linear',
                min : 'linear'
            }),
            depth: true
        });
        this.EMPTY_TEXTURE = this._regl.texture({ width: 2, height: 2 });
        this._rainPainter = new RainPainer(this._regl, this._layer);
        this._rainRipplesPass = new RainRipplePass(this._regl, viewport);
        this._snowPainter = new SnowPainter(this._regl, this._layer);
        this._fogPass = new FogPass(this._regl, viewport, this._layer);
        this._weatherShader = new FogShader();
        this._weatherShader.version = 300;
    }

    getMap() {
        return this._layer && this._layer.getMap();
    }

    renderScene(drawContext) {
        this.renderSnowMask(drawContext);
        this.renderRain(drawContext);
    }

    renderRain(drawContext) {
        if (!this.isEnableRain()) {
            return;
        }
        this._rainPainter.paint(drawContext);
    }

    renderSnowMask(drawContext) {
        if (!this.isEnableSnow() || !this._showSnowGround()) {
            return;
        }
        const map = this.getMap();
        this._snowPainter.render(drawContext, map);
    }

    paint(tex, meshes) {
        if (!meshes || !meshes.length) {
            return tex;
        }
        this._resize();
        const config = this._layer.getWeatherConfig();
        const uniforms = {};
        const shaderDefines = extend({}, this._weatherShader.shaderDefines);
        if (this.isEnableRain()) {
            uniforms['ripplesMap'] = this._renderRainRipples();
            shaderDefines['HAS_RAIN'] = 1;
        } else {
            delete shaderDefines['HAS_RAIN'];
        }
        if (this.isEnableSnow()) {
            shaderDefines['HAS_SNOW'] = 1;
            uniforms['snowIntensity'] = isNumber$2(config.snow.snowIntensity) ? config.snow.snowIntensity : 0.5;
            meshes.forEach(mesh => {
                mesh.defines['HAS_SNOW'] = 1;
            });
        } else {
            delete shaderDefines['HAS_SNOW'];
            meshes.forEach(mesh => {
                delete mesh.defines['HAS_SNOW'];
            });
        }
        if (this.isEnableFog()) {
            const fogConfig = config.fog;
            uniforms['fogColor'] = fogConfig.color || [0.9, 0.9, 0.9];
            shaderDefines['HAS_FOG'] = 1;
        } else {
            delete shaderDefines['HAS_FOG'];
        }
        let isMultiSampled = tex.texture && tex.texture.sampleCount > 1;
        if (isMultiSampled) {
            shaderDefines['HAS_MULTISAMPLED'] = 1;
        } else {
            delete shaderDefines['HAS_MULTISAMPLED'];
        }
        const mixFactorMap = this._renderMixFactor(meshes) || this.EMPTY_TEXTURE;
        if (isMultiSampled && mixFactorMap !== this.EMPTY_TEXTURE) {
            shaderDefines['HAS_MULTISAMPLED_MAP'] = 1;
        } else {
            delete shaderDefines['HAS_MULTISAMPLED_MAP'];
        }
        this._weatherShader.setDefines(shaderDefines);
        uniforms['mixFactorMap'] = mixFactorMap;
        uniforms['sceneMap'] = tex;
        uniforms['time'] = this._getTimeSpan() / 1000;
        uniforms['resolution'] = vec2.set(RESOLUTION$2, this._fbo.width, this._fbo.height);
        this.renderer.render(this._weatherShader, uniforms, null, this._fbo);
        this._renderMeshes = meshes;
        return this._fbo;
    }

    _renderMixFactor(meshes) {
        const options = {};
        const map = this.getMap();
        const zoom = map.getZoom();
        const ratio = Math.pow(2, DEFAULT_ZOOM - zoom);
        const config = this._layer.getWeatherConfig();
        const fogConfig = config.fog;
        if (!fogConfig || !fogConfig.enable) {
            return null;
        }
        const start = fogConfig.start || 0.1, end = fogConfig.end || 100;
        options['projMatrix'] = map.projMatrix;
        options['viewMatrix'] = map.viewMatrix;
        options['cameraPosition'] = map.cameraPosition;
        options['fogDist'] = [start * ratio, end * ratio];
        options['rainDepth'] = map.altitudeToPoint((config.rain && config.rain.rainDepth) || 0.1, map.getGLRes());
        const mixFactorMap = this._fogPass.render(meshes, options);
        const layerRenderer = this._layer.getRenderer();
        return layerRenderer._getFBOColor(mixFactorMap);
    }

    _renderRainRipples() {
        const map = this.getMap();
        const weatherConfig = this._layer.getWeatherConfig();
        const rippleRadius = weatherConfig.rain.rippleRadius || 24;
        const options = {};
        options['projMatrix'] = map.projMatrix;
        options['viewMatrix'] = map.viewMatrix;
        options['time'] = this._getTimeSpan() / 1000;
        options['rippleRadius'] = rippleRadius;
        options['density'] = weatherConfig.rain.density || 2000;

        const ripplesMap = this._rainRipplesPass.render(map, options);
        return ripplesMap;
    }

    _getTimeSpan() {
        if (!this._layer) {
            return 0;
        }
        if (this._currentFrameTime === undefined) {
            this._currentFrameTime = 0;
        }
        if (this.isPlaying()) {
            const render = this._layer.getRenderer();
            this._currentFrameTime = render.getFrameTime();
        }
        return  this._currentFrameTime;
    }

    isEnable() {
        const weatherConfig = this._layer.getWeatherConfig();
        return weatherConfig && weatherConfig.enable;
    }

    isEnableRain() {
        const weatherConfig = this._layer.getWeatherConfig();
        return weatherConfig && weatherConfig.enable && weatherConfig.rain && weatherConfig.rain.enable;
    }

    isEnableFog() {
        const weatherConfig = this._layer.getWeatherConfig();
        return weatherConfig && weatherConfig.enable && weatherConfig.fog && weatherConfig.fog.enable;
    }

    isEnableSnow() {
        const weatherConfig = this._layer.getWeatherConfig();
        return weatherConfig && weatherConfig.enable && weatherConfig.snow && weatherConfig.snow.enable;
    }

    _showSnowGround() {
        const weatherConfig = this._layer.getWeatherConfig();
        return this.isEnableSnow() && weatherConfig.snow.showGround === false;
    }

    isPlaying() {
        const weatherConfig = this._layer.getWeatherConfig();
        if (weatherConfig) {
            if (weatherConfig.playing === false) {//明确指定暂停天气动画
                return false;
            }
            return true;
        }
        return false;
    }

    _hasWeather() {
        return this.isEnableRain() || this.isEnableFog() || this.isEnableSnow();
    }

    update() {
        if (!this.isEnable() && this._renderMeshes) {
            this._renderMeshes.forEach(mesh => {
                delete mesh.defines['HAS_SNOW'];
                delete mesh.defines['HAS_RAIN'];
                delete mesh.defines['HAS_FOG'];
            });
        }
        if (this.isEnableRain()) {
            this._rainPainter = this._rainPainter || new RainPainer(this._regl, this._layer);
            this._rainPainter.update();
        }
        if (this.isEnableSnow()) {
            this._snowPainter = this._snowPainter || new SnowPainter(this._regl, this._layer);
            this._snowPainter.update();
        }
    }

    getShadowMeshes() {
        return this._snowPainter.getMeshes();
    }

    _resize() {
        const width = this._width(), height =this._height();
        if (this._fbo && (this._fbo.width !== width || this._fbo.height !== height)) {
            this._fbo.resize(width, height);
        }
    }

    dispose() {
        if (this._fbo) {
            this._fbo.destroy();
        }
        if (this._weatherShader) {
            this._weatherShader.dispose();
            delete this._weatherShader;
        }
        if (this._rainPainter) {
            this._rainPainter.dispose();
            delete this._rainPainter;
        }
        if (this._snowPainter) {
            this._snowPainter.dispose();
            delete this._snowPainter;
        }
    }
}

const RESOLUTION$1 = [];
const bloomFilter = m => !!m.bloom;
const ssrFilter = m => !!m.ssr;

class PostProcess {
    constructor(regl, layer) {
        this._regl = regl;
        this._layer = layer;
        this._renderer = new Renderer(regl);
        this._fxaaShader = new FxaaShader();
        // this._taaPass = new reshader.TaaPass(this._renderer, jitter);
        this._copyShader = new CopyShader();
        this._ssrPass = new SsrPass(this._regl);
    }

    setContextIncludes(/*context*/) {
        // if (this._layer.getRenderer().isEnableSSAO() && this._ssaoPass && !context.ssao) {
        //     const ssao = {
        //         defines: reshader.SsrPass.getDefines(),
        //         uniformDeclares: reshader.SsrPass.getUniformDeclares()
        //     };
        //     ssao.renderUniforms = {
        //         prevProjViewMatrix: this._ssaoPass.getPrevProjViewMatrix(),
        //         sSsaoTexture: this._ssaoPass.getSsaoTexture()
        //     };
        //     context.ssao = ssao;
        //     context.includes.ssao = 1;
        // }
    }

    bloom(curTex, noAaTex, pointTex, threshold, bloomFactor, bloomRadius, enableAA) {
        if (!this._bloomPass) {
            this._bloomPass = new BloomPass(this._regl);
        }
        const renderer = this._layer.getRenderer();
        const bloomTex = renderer._getFBOColor(this._bloomFBO);
        return this._bloomPass.render(curTex, bloomTex, threshold, bloomFactor, bloomRadius, noAaTex, pointTex, enableAA);
    }

    drawBloom(depthTex) {
        const layerRenderer = this._layer.getRenderer();

        const regl = this._regl;
        const bloomFBO = this._bloomFBO;
        if (!bloomFBO) {
            const info = this._createFBOInfo(depthTex);
            this._bloomFBO = regl.framebuffer(info);
        } else {
            const { width, height } = depthTex;
            if (bloomFBO.width !== width || bloomFBO.height !== height) {
                bloomFBO.resize(width, height);
            }
            regl.clear({
                color: [0, 0, 0, 0],
                framebuffer: bloomFBO
            });
        }
        const timestamp = layerRenderer.getFrameTime();
        const event = layerRenderer.getFrameEvent();
        const context = layerRenderer.getFrameContext();
        const renderMode = context.renderMode;
        const sceneFilter = context.sceneFilter;
        const renderTarget = context.renderTarget;
        context.isPostProcess = true;
        context.renderMode = 'default';
        context['sceneFilter'] = bloomFilter;
        context.renderTarget = {
            fbo: this._bloomFBO,
            getFramebuffer: getFramebuffer$1,
            getDepthTexture: getDepthTexture$1
        };
        layerRenderer.resetDrawCalls();
        if (event) {
            layerRenderer.forEachRenderer(renderer => {
                layerRenderer.clearStencil(renderer, bloomFBO);
                renderer.drawOnInteracting(event, timestamp, context);
            });
        } else {
            layerRenderer.forEachRenderer(renderer => {
                layerRenderer.clearStencil(renderer, bloomFBO);
                renderer.draw(timestamp, context);
            });
        }
        delete context.isPostProcess;
        context.renderMode = renderMode;
        context.sceneFilter = sceneFilter;
        context.renderTarget = renderTarget;

        return layerRenderer.getDrawCalls();
    }

    genSsrMipmap(tex, depthTex) {
        const projViewMatrix = this._layer.getMap().projViewMatrix;
        this._ssrPass.genMipMap(tex, depthTex, projViewMatrix);
    }

    getPrevSsrProjViewMatrix() {
        return this._ssrPass && this._ssrPass.getPrevProjViewMatrix();
    }

    drawSSR(depthTex, fbo, isCopyDepth) {
        if (isCopyDepth) {
            this._ssrPass.copyDepthTex(depthTex);
        }
        //遍历开启了ssr的mesh重新绘制一遍，并只绘制有ssr的像素，discard掉其他像素
        const layerRenderer = this._layer.getRenderer();
        const timestamp = layerRenderer.getFrameTime();
        const event = layerRenderer.getFrameEvent();
        const context = layerRenderer.getFrameContext();
        context.isPostProcess = true;
        context.ssr = this.getSSRContext();
        const renderMode = context.renderMode;
        const filter = context['sceneFilter'];
        context.renderMode = 'default';
        context['sceneFilter'] = ssrFilter;
        context.renderTarget.fbo = fbo;
        let cleared = false;
        if (event) {
            layerRenderer.forEachRenderer(renderer => {
                layerRenderer.clearStencil(renderer, fbo);
                if (!cleared) {
                    layerRenderer.resetDrawCalls();
                    cleared = true;
                }
                renderer.drawOnInteracting(event, timestamp, context);
            });
        } else {
            layerRenderer.forEachRenderer(renderer => {
                layerRenderer.clearStencil(renderer, fbo);
                if (!cleared) {
                    layerRenderer.resetDrawCalls();
                    cleared = true;
                }
                renderer.draw(timestamp, context);
            });
        }
        const groundPainted = layerRenderer.drawGround();
        //以免和bloom冲突
        delete context.ssr;
        delete context.isPostProcess;
        context.renderMode = renderMode;
        context['sceneFilter'] = filter;
        this._ssrPainted = layerRenderer.getDrawCalls() > 0;
        return groundPainted;
    }

    getSSRUniforms() {
        const sceneConfig =  this._layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        const map = this._layer.getMap();
        return this._ssrPass.getSSRUniforms(map, config.ssr.factor, config.ssr.quality);
    }

    getSSRContext() {
        const sceneConfig =  this._layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        const map = this._layer.getMap();
        const uniforms = this._ssrPass.getSSRUniforms(map, config.ssr.factor, config.ssr.quality);
        if (!uniforms) {
            return null;
        }
        const context = {
            renderUniforms: uniforms,
            defines: {
                'HAS_SSR': 1
            }
        };
        return context;
    }

    // taa(curTex, depthTex, {
    //     projMatrix, needClear
    // }) {
    //     const pass = this._taaPass;
    //     const outputTex = pass.render(
    //         curTex, depthTex,
    //         projMatrix, needClear
    //     );
    //     const redraw = pass.needToRedraw();
    //     return {
    //         outputTex,
    //         redraw
    //     };
    // }

    // isTaaNeedRedraw() {
    //     return this._taaPass.needToRedraw();
    // }

    // ssao(sourceTex, depthTex, uniforms) {
    //     if (!this._ssaoPass) {
    //         this._ssaoPass = new reshader.SsaoPass(this._renderer);
    //         this._layer.getRenderer().setToRedraw();
    //     }
    //     return this._ssaoPass.render({
    //         projMatrix: uniforms['projMatrix'],
    //         cameraNear: uniforms['cameraNear'],
    //         cameraFar: uniforms['cameraFar'],
    //         bias: uniforms['ssaoBias'],
    //         radius: uniforms['ssaoRadius'],
    //         intensity: uniforms['ssaoIntensity'],
    //         quality: 0.6
    //     }, sourceTex, depthTex);
    // }

    fxaa(fbo, source, enableFXAA, enableToneMapping, enableSharpen, pixelRatio, sharpFactor,
        textureOutline, highlightFactor, outlineFactor, outlineWidth, outlineColor) {
        if (fbo && (fbo.width !== source.fbo || fbo.height !== source.height)) {
            fbo.resize(source.width, source.height);
        }
        const shaderDefines = {};
        // if (taaTextureSource) {
        //     shaderDefines['HAS_TAA_TEX'] = 1;
        // } else {
        //     delete shaderDefines['HAS_TAA_TEX'];
        // }
        // if (fxaaTextureSource) {
        //     shaderDefines['HAS_FXAA_TEX'] = 1;
        // } else {
        //     delete shaderDefines['HAS_FXAA_TEX'];
        // }
        if (textureOutline) {
            shaderDefines['HAS_OUTLINE_TEX'] = 1;
        } else {
            delete shaderDefines['HAS_OUTLINE_TEX'];
        }
        const useMultiSample = this._layer.options.antialias === true;
        if (useMultiSample) {
            shaderDefines['HAS_MULTISAMPLED'] = 1;
        } else {
            delete shaderDefines['HAS_MULTISAMPLED'];
        }
        // if (noAaSource) {
        //     shaderDefines['HAS_NOAA_TEX'] = 1;
        // } else {
        //     delete shaderDefines['HAS_NOAA_TEX'];
        // }
        // if (pointSource) {
        //     shaderDefines['HAS_POINT_TEX'] = 1;
        // } else {
        //     delete shaderDefines['HAS_POINT_TEX'];
        // }
        this._fxaaShader.setDefines(shaderDefines);
        this._renderer.render(this._fxaaShader, {
            textureSource: source,
            resolution: vec2.set(RESOLUTION$1, source.width, source.height),
            enableFXAA,
            enableToneMapping,
            enableSharpen, pixelRatio, sharpFactor,
            textureOutline,
            highlightFactor,
            outlineFactor,
            outlineWidth,
            outlineColor
        }, null, fbo);
    }

    renderFBOToScreen(fbo, enableSharpen, sharpFactor, pixelRatio) {
        if (!this._copyFBOSize) {
            this._copyFBOSize = [];
        }
        this._copyFBOSize[0] = fbo.width;
        this._copyFBOSize[1] = fbo.height;

        const shaderDefines = {};
        const renderer = this._layer.getRenderer();
        const texture =  fbo.color && renderer._getFBOColor(fbo) || fbo;
        const useMultiSample = texture.texture && texture.texture.sampleCount > 1;
        if (useMultiSample) {
            shaderDefines['HAS_MULTISAMPLED'] = 1;
        } else {
            delete shaderDefines['HAS_MULTISAMPLED'];
        }
        this._copyShader.setDefines(shaderDefines);

        this._renderer.render(this._copyShader, {
            texture,
            size: this._copyFBOSize,
            enableSharpen: +(!!enableSharpen),
            sharpFactor,
            pixelRatio
        });
    }

    //filmic grain + vigenett
    postprocess(fbo, uniforms, src) {
        if (!this._postProcessShader) {
            this._postProcessShader = new PostProcessShader();
        }
        const renderer = this._layer && this._layer.getRenderer();
        const source = src || renderer._getFBOColor(fbo);
        uniforms['resolution'] = vec2.set(RESOLUTION$1, source.width, source.height);
        uniforms['textureSource'] = source;
        uniforms['timeGrain'] = performance.now();
        this._renderer.render(this._postProcessShader, uniforms);
        return this._target;
    }

    dispose() {
        if (this._bloomFBO) {
            this._bloomFBO.destroy();
            delete this._bloomFBO;
        }
        // if (this._taaPass) {
        //     this._taaPass.dispose();
        //     delete this._taaPass;
        // }
        // if (this._ssaoPass) {
        //     this._ssaoPass.dispose();
        //     delete this._ssaoPass;
        // }
        if (this._bloomPass) {
            this._bloomPass.dispose();
            delete this._bloomPass;
        }
        if (this._postProcessShader) {
            this._postProcessShader.dispose();
            delete this._postProcessShader;
        }
        if (this._fxaaShader) {
            this._fxaaShader.dispose();
            delete this._fxaaShader;
        }
        if (this._copyShader) {
            this._copyShader.dispose();
            delete this._copyShader;
        }
    }

    _createFBOInfo(depthTex, colorFormat) {
        const { width, height } = this._layer.getRenderer().canvas;
        const regl = this._regl;
        const renderer = this._layer.getRenderer();
        let color;
        if (renderer._isUseMultiSample()) {
            color = regl.renderbuffer({
                width,
                height,
                samples: this._layer.options['multiSamples'],
                format: 'rgba8'
            });
        } else {
            const isAntialias = this._layer.options.antialias;
            const sampleCount = isAntialias ? 4 : 1;
            color = regl.texture({
                min: 'nearest',
                mag: 'nearest',
                format: colorFormat || 'rgba',
                width,
                height,
                // webgpu
                sampleCount
            });
        }
        const fboInfo = {
            width,
            height,
            colors: [color]
        };
        if (depthTex) {
            fboInfo.depthStencil = depthTex;
        }
        return fboInfo;
    }
}

function getFramebuffer$1(fbo) {
    return fbo['_framebuffer'].framebuffer;
}

function getDepthTexture$1(fbo) {
    //TODO 也可能是renderbuffer
    return fbo.depthStencil._texture.texture;
}

var frag$1 = "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\n#ifdef HAS_FLOODANALYSE\nuniform vec3 flood_waterColor;\nuniform float flood_waterOpacity;\nuniform sampler2D floodMap;\n#endif\n#ifdef HAS_SKYLINE\nuniform sampler2D skylineMap;\n#endif\n#ifdef HAS_VIEWSHED\nuniform vec4 viewshed_visibleColor;\nuniform vec4 viewshed_invisibleColor;\nuniform sampler2D viewshedMap;\n#endif\n#ifdef HAS_INSIGHT\nuniform vec4 insight_visibleColor;\nuniform vec4 insight_invisibleColor;\nuniform sampler2D insightMap;\n#endif\n#ifdef HAS_CUT\nuniform sampler2D meshesMap;\nuniform sampler2D invisibleMap;\n#endif\n#ifdef HAS_EXCAVATE\nuniform sampler2D excavateMap;\n#endif\n#ifdef HAS_CROSSCUT\nuniform sampler2D crosscutMap;\nuniform vec4 cutLineColor;\n#endif\n#ifdef HAS_HEIGHTLIMIT\nuniform vec3 limitColor;\nuniform sampler2D heightLimitMap;\n#endif\nuniform sampler2D sceneMap;\nvoid main() {\n  vec4 c = texture2D(sceneMap, vTexCoord);\n  glFragColor = c;\n#ifdef HAS_VIEWSHED\nvec4 d = texture2D(viewshedMap, vTexCoord);\n  if(d.r > .99) {\n    glFragColor = vec4(mix(viewshed_invisibleColor.rgb, c.rgb, viewshed_invisibleColor.a), c.a);\n  } else if(d.g > .99) {\n    glFragColor = vec4(mix(viewshed_visibleColor.rgb, c.rgb, viewshed_visibleColor.a), c.a);\n  } else if(d.a < .01) {\n    glFragColor = vec4(d.rgb, 1.);\n  }\n  \n  \n#endif\n#ifdef HAS_FLOODANALYSE\nvec4 e = texture2D(floodMap, vTexCoord);\n  if(e.r > .0) {\n    glFragColor = vec4(mix(glFragColor.rgb, flood_waterColor, flood_waterOpacity), glFragColor.a);\n  }\n#endif\n#ifdef HAS_SKYLINE\nvec4 f = texture2D(skylineMap, vTexCoord);\n  if(f.r > .0 || f.g > .0 || f.b > .0) {\n    glFragColor = f;\n  }\n#endif\n#ifdef HAS_INSIGHT\nvec4 h = texture2D(insightMap, vTexCoord);\n  if(h.g > .0) {\n    glFragColor = insight_visibleColor;\n  } else if(h.r > .0) {\n    glFragColor = insight_invisibleColor;\n  }\n  \n#endif\n#ifdef HAS_CUT\nvec4 i = texture2D(invisibleMap, vTexCoord);\n  vec4 j = texture2D(meshesMap, vTexCoord);\n  if(i.r == 1. && i.g == .0 && i.b == .0) {\n    glFragColor = j;\n  } else if(i.r == .0 && i.g == 1. && i.b == .0) {\n    glFragColor = j;\n  } else if(i.r == .0 && i.g == .0 && i.b == 1.) {\n    glFragColor = c;\n  }\n  \n  \n#endif\n#ifdef HAS_EXCAVATE\nvec4 k = texture2D(excavateMap, vTexCoord);\n  if(k.r == 1. && k.g == .0 && k.b == .0) {\n    glFragColor = c;\n  } else {\n    glFragColor = k;\n  }\n#endif\n#ifdef HAS_CROSSCUT\nvec4 l = texture2D(crosscutMap, vTexCoord);\n  if(l.r > .0) {\n    glFragColor = vec4(mix(cutLineColor.rgb, glFragColor.rgb, .99), glFragColor.a);\n  }\n#endif\n#ifdef HAS_HEIGHTLIMIT\nvec4 m = texture2D(heightLimitMap, vTexCoord);\n  if(m.r > .0) {\n    glFragColor = vec4(mix(limitColor, glFragColor.rgb, .6), glFragColor.a);\n  }\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

class AnalysisShader extends QuadShader {
    constructor(viewport) {
        super({
            name: 'analysis',
            frag: frag$1,
            wgslFrag: getWGSLSource('gl_analysis_frag'),
            extraCommandProps: {
                viewport,
                cull: {
                    enable: true
                },
                blend: {
                    enable: true,
                    func: {
                        srcRGB: 'src alpha',
                        srcAlpha: 1,
                        dstRGB: 'one minus src alpha',
                        dstAlpha: 'one minus src alpha'
                    },
                    equation: 'add'
                }
            }
        });
    }
}

class AnalysisPainter {
    constructor(regl, layer, config) {
        this._regl= regl;
        this._layer = layer;
        this._config = config;
        this._init();
    }

    _init() {
        this.renderer = new Renderer(this._regl);
        const layerRenderer = this._layer.getRenderer();
        const viewport = this._viewport = {
            x : 0,
            y : 0,
            width : () => {
                return layerRenderer.canvas ? layerRenderer.canvas.width : 1;
            },
            height : () => {
                return layerRenderer.canvas ? layerRenderer.canvas.height : 1;
            }
        };
        this._fbo = this._regl.framebuffer({
            color: this._regl.texture({
                width: layerRenderer.canvas ? layerRenderer.canvas.width : 1,
                height: layerRenderer.canvas ? layerRenderer.canvas.height : 1,
                wrap: 'clamp',
                mag : 'linear',
                min : 'linear'
            }),
            depth: true
        });
        this._shader = new AnalysisShader(viewport);
    }

    getMap() {
        return this._layer && this._layer.getMap();
    }

    paint(tex, layers) {
        if (!layers && layers.length) {
            return tex;
        }
        this._resize();
        const uniforms = {};
        const analysisTaskList = this._layer._analysisTaskList;
        if (!this._hasAnalysis()) {
            return tex;
        }
        this._regl.clear({
            color: [0, 0, 0, 0],
            depth: 1,
            stencil : 0,
            framebuffer : this._fbo
        });
        const shaderDefines = extend({}, this._shader.shaderDefines);
        delete shaderDefines['HAS_FLOODANALYSE'];
        delete shaderDefines['HAS_VIEWSHED'];
        delete shaderDefines['HAS_SKYLINE'];
        delete shaderDefines['HAS_INSIGHT'];
        delete shaderDefines['HAS_CUT'];
        delete shaderDefines['HAS_CROSSCUT'];
        delete shaderDefines['HAS_HEIGHTLIMIT'];
        if (tex.texture && tex.texture.sampleCount > 1) {
            shaderDefines['HAS_MULTISAMPLED'] = 1;
        }
        for (let i = 0; i < analysisTaskList.length; i++) {
            const task = analysisTaskList[i];
            if (!task.isEnable()) {
                continue;
            }
            const defines = task.getDefines();
            extend(shaderDefines, defines);
            const map = this.getMap();
            const width = map.width, height = map.height;
            const toAanalysisMeshes = this._getToAnalysisMeshes(layers, task.getExcludeLayers());
            const analysisUniforms = task.renderAnalysis(toAanalysisMeshes, width, height);
            if (analysisUniforms) {
                extend(uniforms, analysisUniforms);
            }
        }
        uniforms['sceneMap'] = tex;
        uniforms['resolution'] = [this._fbo.width, this._fbo.height];
        this._shader.setDefines(shaderDefines);
        this.renderer.render(this._shader, uniforms, null, this._fbo);
        return this._fbo;
    }

    _getToAnalysisMeshes(layers, excludeLayers) {
        let toAnalysisMeshes = [];
        for (let i = 0; i < layers.length; i++) {
            if (excludeLayers.indexOf(layers[i].getId()) > -1) {
                continue;
            }
            const renderder = layers[i].getRenderer();
            if (renderder && renderder.getAnalysisMeshes) {
                const meshes = renderder.getAnalysisMeshes();
                meshes.forEach(mesh => {
                    mesh.setUniform('useAnalysis', 1);
                });
                toAnalysisMeshes = toAnalysisMeshes.concat(meshes);
            }
        }
        return toAnalysisMeshes;
    }

    getViewportSize() {
        let width, height;
        if (this._viewport.width.data) {
            width = Util$1.isFunction(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width;
            height = Util$1.isFunction(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        } else {
            width = Util$1.isFunction(this._viewport.width) ? this._viewport.width() : this._viewport.width;
            height = Util$1.isFunction(this._viewport.height) ? this._viewport.height() : this._viewport.height;
        }
        return { width, height };
    }

    _resize() {
        const { width, height } = this.getViewportSize();
        if (this._fbo && (this._fbo.width !== width || this._fbo.height !== height)) {
            this._fbo.resize(width, height);
        }
    }

    _hasAnalysis() {
        const tasks = this._layer && this._layer._analysisTaskList;
        if (!tasks) {
            return false;
        }
        for (let i = 0; i < tasks.length;i++) {
            if (tasks[i].isEnable()) {
                return true;
            }
        }
        return false;
    }
}

const RESOLUTION = [];
const TEMP_COORD$1 = new maptalks.Coordinate(0, 0);
let EMPTY_MAT3_MAP = {};
class ScanEffectPainter {
    constructor(regl, layer) {
        this._regl = regl;
        this._layer = layer;
        this._init();
    }

    _init() {
        this.renderer = new Renderer(this._regl);
        const layerRenderer = this._layer.getRenderer();
        const viewport = this._viewport = {
            x : 0,
            y : 0,
            width : () => {
                return layerRenderer.canvas ? layerRenderer.canvas.width : 1;
            },
            height : () => {
                return layerRenderer.canvas ? layerRenderer.canvas.height : 1;
            }
        };
        this._width = viewport.width, this._height = viewport.height;
        this._fbo = this._regl.framebuffer({
            color: this._regl.texture({
                width: layerRenderer.canvas ? layerRenderer.canvas.width : 1,
                height: layerRenderer.canvas ? layerRenderer.canvas.height : 1,
                wrap: 'clamp',
                mag : 'linear',
                min : 'linear'
            }),
            depth: true
        });
        this.EMPTY_TEXTURE = this._regl.texture({ width: 2, height: 2 });
        this._shader = new EffectShader();
        this._pass = new ScanEffectPass(this._regl, viewport, this._layer);
        this._shader.version = 300;
    }

    getMap() {
        return this._layer && this._layer.getMap();
    }

    paint(tex, meshes) {
        if (!meshes || !meshes.length) {
            return tex;
        }
        const map = this._layer.getMap();
        this._resize();
        const config = this._layer.getScanEffectConfig();
        const uniforms = {};
        const { effects } = config;
        const glRes = map.getGLRes();
        const effectInfos = [];
        if (this._effectLength !== effects.length) { //减少临时数组的生成
            EMPTY_MAT3_MAP = {};
        }
        for (let i = 0; i < effects.length; i++) {
            const { center, radius, speed, color, direction, height } = effects[i];
            const coord = toCoordinate(center);
            const effectCenter = map.coordinateToPointAtRes(coord, glRes, TEMP_COORD$1).toArray();
            const effectRadius = map.distanceToPointAtRes(radius, 0, glRes).x;
            const dir = direction === 'vertical' ? 1 : 0;
            const h = map.altitudeToPoint(height || 0, glRes);
            EMPTY_MAT3_MAP[i] = EMPTY_MAT3_MAP[i] || [];
            const effectInfo = mat3.set(EMPTY_MAT3_MAP[i], effectCenter[0], effectCenter[1], effectRadius, speed, color[0], color[1], color[2], dir, h);
            effectInfos.push(effectInfo);
        }
        const options = {
            projMatrix: map.projMatrix,
            viewMatrix: map.viewMatrix,
            effectInfos,
            effectTime: this._getTimeSpan() / 1000
        };
        const layerRenderer = this._layer.getRenderer();
        const fbo = this._pass.render(meshes, options) || this.EMPTY_TEXTURE;
        uniforms['scanEffectMap'] = layerRenderer._getFBOColor(fbo);
        uniforms['sceneMap'] = tex;
        uniforms['resolution'] = vec2.set(RESOLUTION, this._fbo.width, this._fbo.height);
        this.renderer.render(this._shader, uniforms, null, this._fbo);
        return this._fbo;
    }

    _getTimeSpan() {
        if (!this._layer) {
            return 0;
        }
        if (this._currentFrameTime === undefined) {
            this._currentFrameTime = 0;
        }
        if (this.isPlaying()) {
            const render = this._layer.getRenderer();
            this._currentFrameTime = render.getFrameTime();
        }
        return  this._currentFrameTime;
    }

    isPlaying() {
        const config = this._layer.getScanEffectConfig();
        if (config) {
            if (config.playing === false) {//明确指定暂停扫描动画
                return false;
            }
            return true;
        }
        return false;
    }

    _resize() {
        const width = this._width(), height =this._height();
        if (this._fbo && (this._fbo.width !== width || this._fbo.height !== height)) {
            this._fbo.resize(width, height);
        }
    }

    dispose() {
        if (this._fbo) {
            this._fbo.destroy();
        }
        if (this._shader) {
            this._shader.dispose();
            delete this._shader;
        }
        if (this._pass) {
            this._pass.dispose();
        }
    }
}

function toCoordinate(center) {
    if (Array.isArray(center)) {
        TEMP_COORD$1.x = center[0];
        TEMP_COORD$1.y = center[1];
        return TEMP_COORD$1;
    }
    return center;
}

function createWebGLContext(canvas, preserveDrawingBuffer, onlyWebGL1, extensions, optionalExtensions) {
    const attributes = {
        alpha: true,
        depth: true,
        stencil: true,
        preserveDrawingBuffer: preserveDrawingBuffer
    };
    const gl = createGLContext(canvas, attributes, onlyWebGL1);
    initGL(gl, extensions, optionalExtensions);
    gl.wrap = () => {
        const ctx = new GLContext(gl);
        return ctx;
    };
    const reglGL = gl.wrap();
    const regl = createREGL({
        gl: reglGL,
        attributes,
        extensions: extensions,
        optionalExtensions: optionalExtensions
    });
    const context = {
        gl: gl,
        reglGL: reglGL,
        regl,
        device: regl,
        getImageData: (sx, sy, sw, sh) => {
            const pixels = new Uint8Array(sw * sh * 4);
            regl.read({
                x: sx,
                y: canvas.height - sy,
                width: sw,
                height: sh,
                data: pixels
            });
            return new ImageData(new Uint8ClampedArray(pixels.buffer), sw, sh);
        }
    };
    return {
        gl, reglGL, regl, context
    };
}
function initGL(gl, extensions, optionalExtensions) {
    if (extensions) {
        extensions.forEach(ext => {
            gl.getExtension(ext);
        });
    }
    if (optionalExtensions) {
        optionalExtensions.forEach(ext => {
            gl.getExtension(ext);
        });
    }
}
function createGLContext(canvas, options, onlyWebGL1) {
    const names = onlyWebGL1 ? ['webgl', 'experimental-webgl'] : ['webgl2', 'webgl', 'experimental-webgl'];
    let gl = null;
    /* eslint-disable no-empty */
    for (let i = 0; i < names.length; ++i) {
        try {
            gl = canvas.getContext(names[i], options);
        }
        catch (e) { }
        if (gl) {
            break;
        }
    }
    if (!gl) {
        console.error('Browser doesn\'t support WebGL.');
    }
    return gl;
    /* eslint-enable no-empty */
}

const canvasCompatible = function (Base) {
    const compatible = class extends Base {
        // create context in MapCanvasRenderer
        createContext() {
            this.createCanvas();
            const map = this.getMap();
            const { preserveDrawingBuffer, onlyWebGL1, extensions, optionalExtensions } = map.options;
            const { gl, regl, reglGL, context } = createWebGLContext(this.canvas, preserveDrawingBuffer, onlyWebGL1, extensions, optionalExtensions);
            this.gl = gl;
            this.regl = regl;
            this.reglGL = reglGL;
            this.context = context;
            this.context.device = regl;
            this.device = this.regl;
        }
    };
    return compatible;
};

const { LayerAbstractRenderer: LayerAbstractRenderer$3 } = maptalks.renderer;

const EMPTY_COLOR$1 = [0, 0, 0, 0];
const DEFAULT_LIGHT_DIRECTION = [1, 1, -1];

const MIN_SSR_PITCH = -0.001;
const NO_JITTER = [0, 0];

const noPostFilter = m => !m.bloom && !m.ssr;
const noBloomFilter = m => !m.bloom;
const noSsrFilter = m => !m.ssr;

const SSR_STATIC = 1;
const SSR_IN_ONE_FRAME = 2;

class GroupGLLayerRenderer extends canvasCompatible(LayerAbstractRenderer$3) {

    setToRedraw() {
        this.setRetireFrames();
        super.setToRedraw();
    }

    onAdd() {
        super.onAdd();
        const map = this.getMap();
        const mapRenderer = map.getRenderer();
        if (mapRenderer.ready) {
            this.prepareCanvas();
        }
    }

    updateSceneConfig() {
        if (this._groundPainter) {
            this._groundPainter.update();
        }
        if (this._envPainter) {
            this._envPainter.update();
        }
        if (this._weatherPainter) {
            this._weatherPainter.update();
        }
        this.setToRedraw();
    }


    render(...args) {
        if (!this.getMap() || !this.layer.isVisible()) {
            return;
        }
        this.forEachRenderer((renderer) => {
            if (renderer['_replacedDrawFn']) {
                return;
            }
            renderer.draw = this._buildDrawFn(renderer.draw);
            renderer.drawOnInteracting = this._buildDrawOnInteractingFn(renderer.drawOnInteracting);
            renderer.setToRedraw = this._buildSetToRedrawFn(renderer.setToRedraw);
            renderer['_replacedDrawFn'] = true;
        });
        this.prepareRender();
        this.prepareCanvas();
        this.layer._updatePolygonOffset();
        this['_toRedraw'] = false;
        this._renderChildLayers('render', args);
        this._renderOutlines();
        this._postProcess();
    }

    prepareCanvas() {
        super.prepareCanvas();
        this.resizeCanvas();
        this.forEachRenderer(renderer => {
            renderer.prepareCanvas();
        });
    }

    drawOnInteracting(...args) {
        if (!this.getMap() || !this.layer.isVisible()) {
            return;
        }
        this.layer._updatePolygonOffset();
        this['_toRedraw'] = false;
        this._renderChildLayers('drawOnInteracting', args);
        this._renderOutlines();
        this._postProcess();
    }

    _renderChildLayers(methodName, args) {
        this._renderMode = 'default';
        const hasRenderTarget = this.hasRenderTarget();
        const drawContext = this._getDrawContext(args);
        if (hasRenderTarget) {
            // reset renderTarget before drawing ground and child layers
            this._drawContext.renderTarget = this._getFramebufferTarget();
        }
        this._envPainter.paint(drawContext);
        //如果放到图层后画，会出现透明图层下的ground消失的问题，#145
        this.drawGround(true);
        if (!hasRenderTarget) {
            this._renderInMode('default', null, methodName, args, true);
            return;
        }
        // const fGL = this.reglGL;

        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        const ssrMode = this.isSSROn();

        // const enableTAA = this.isEnableTAA();
        // const jitter = drawContext.jitter;
        drawContext.jitter = NO_JITTER;
        const groundConfig = this.layer.getGroundConfig();
        drawContext.hasSSRGround = !!(ssrMode && groundConfig && groundConfig.enable && groundConfig.symbol && groundConfig.symbol.ssr);
        // fGL.resetDrawCalls();
        // this._renderInMode(enableTAA ? 'fxaaBeforeTaa' : 'fxaa', this._targetFBO, methodName, args);
        this._renderInMode('default', this._targetFBO, methodName, args, true);
        // this._fxaaDrawCount = fGL.getDrawCalls();

        // 重用上一帧的深度纹理，先绘制ssr图形
        // 解决因TAA jitter偏转，造成的ssr图形与taa图形的空白缝隙问题
        // #1545 SSR_ONE_FRAME模式里，建筑透明时，ssr后画会造成建筑后的ssr图形丢失，改为永远在每帧的开始，都绘制ssr图形
        if (ssrMode) {
            this._postProcessor.drawSSR(this._blitDepthTex(), this._targetFBO);
        }



        // if (enableTAA) {
        //     const map = this.getMap();
        //     const needRefresh = this._postProcessor.isTaaNeedRedraw() || this._needRetireFrames || map.getRenderer().isViewChanged();
        //     drawContext.jitter = needRefresh ? jitter : this._jitGetter.getAverage();
        //     drawContext.onlyUpdateDepthInTaa = !needRefresh;
        //     let taaFBO = this._taaFBO;
        //     if (!taaFBO) {
        //         const regl = this.regl;
        //         const info = this.createFBOInfo(config, this._depthTex);
        //         taaFBO = this._taaFBO = regl.framebuffer(info);
        //     } else if (taaFBO.width !== this._targetFBO.width || taaFBO.height !== this._targetFBO.height) {
        //         taaFBO.resize(this._targetFBO.width, this._targetFBO.height);
        //     }
        //     fGL.resetDrawCalls();
        //     this._renderInMode('taa', taaFBO, methodName, args);
        //     this._taaDrawCount = fGL.getDrawCalls();
        //     delete drawContext.onlyUpdateDepthInTaa;
        //     drawContext.jitter = NO_JITTER;

        //     let fxaaFBO = this._fxaaFBO;
        //     if (!fxaaFBO) {
        //         const regl = this.regl;
        //         const info = this.createFBOInfo(config, this._depthTex);
        //         fxaaFBO = this._fxaaFBO = regl.framebuffer(info);
        //     } else if (fxaaFBO.width !== this._targetFBO.width || fxaaFBO.height !== this._targetFBO.height) {
        //         fxaaFBO.resize(this._targetFBO.width, this._targetFBO.height);
        //     }
        //     fGL.resetDrawCalls();
        //     this._renderInMode('fxaaAfterTaa', this._fxaaFBO, methodName, args);
        //     this._fxaaAfterTaaDrawCount = fGL.getDrawCalls();
        // } else if (this._taaFBO) {
        //     this._taaFBO.destroy();
        //     this._fxaaFBO.destroy();
        //     delete this._taaFBO;
        //     delete this._fxaaFBO;
        //     delete this._fxaaAfterTaaDrawCount;
        // }

        // let tex = this._fxaaFBO ? this._getFBOColor(this._fxaaFBO) : this._getFBOColor(this._targetFBO);

        // bloom的绘制放在ssr之前，更新深度缓冲，避免ssr绘制时，深度值不正确
        const enableBloom = config.bloom && config.bloom.enable;
        if (enableBloom) {
            this._bloomPainted = this._postProcessor.drawBloom(this._depthTex);
        }

        // ssr如果放到noAa之后，ssr图形会遮住noAa中的图形
        if (ssrMode === SSR_IN_ONE_FRAME) {
            this._postProcessor.drawSSR(this._blitDepthTex(), this._targetFBO, true);
        }

        // noAa的绘制放在bloom后，避免noAa的数据覆盖了bloom效果
        // this.resetDrawCalls();
        // this._renderInMode('noAa', this._noAaFBO, methodName, args);
        // this._noaaDrawCount = fGL.getDrawCalls();

        // this.resetDrawCalls();
        // this._renderInMode('point', this._pointFBO, methodName, args, true);
        this._weatherPainter.renderScene(drawContext);
        // this._pointDrawCount = fGL.getDrawCalls();

        // return tex;
    }

    _renderInMode(mode, fbo, methodName, args, isFinalRender) {
        //noAA需要最后绘制，如果有noAa的图层，分为aa和noAa两个阶段分别绘制
        this._renderMode = mode;
        const drawContext = this._getDrawContext(args);
        drawContext.renderMode = this._renderMode;
        if (drawContext.renderTarget) {
            drawContext.renderTarget.fbo = fbo;
        }
        if (isFinalRender) {
            drawContext.isFinalRender = true;
        }

        this.forEachRenderer((renderer, layer) => {
            if (!layer.isVisible()) {
                return;
            }
            // if (mode === 'default' ||
            //     !renderer.supportRenderMode && (mode === 'fxaa' || mode === 'fxaaAfterTaa') ||
            //     renderer.supportRenderMode && renderer.supportRenderMode(mode)) {
            //     this.clearStencil(renderer, fbo);
            //     renderer[methodName].apply(renderer, args);
            // }
            this.clearStencil(renderer, fbo);
            renderer[methodName].apply(renderer, args);
        });
    }

    _getDrawContext(args) {
        let timestamp = args[0];
        if (!isNumber(timestamp)) {
            timestamp = args[1];
        }
        if (timestamp !== this._contextFrameTime) {
            this.forEachRenderer((renderer, layer) => {
                if (!layer.isVisible()) {
                    return;
                }
                if (renderer.needRetireFrames && renderer.needRetireFrames()) {
                    this.setRetireFrames();
                }
            });
            this._drawContext = this._prepareDrawContext(timestamp);
            this._contextFrameTime = timestamp;
            this._frameEvent = isNumber(args[0]) ? null : args[0];
        }
        return this._drawContext;
    }

    _renderOutlines() {
        if (!this.isEnableOutline()) {
            return;
        }
        const fbo = this._getOutlineFBO();

        this.resetDrawCalls();
        this.forEachRenderer((renderer, layer) => {
            if (!layer.isVisible()) {
                return;
            }
            if (renderer.drawOutline) {
                renderer.drawOutline(fbo);
            }
        });
        this._outlineCounts = this.getDrawCalls();
    }

    _getOutlineFBO() {
        const { width, height } = this.canvas;
        let fbo = this._outlineFBO;
        if (!fbo) {
            const isWebGPU = this.device && this.device.wgpu;
            const format = isWebGPU ? 'rgba' : 'rgba4';
            const isAntialias = this.layer.options.antialias;
            const sampleCount = isAntialias ? 4 : 1;
            const outlineTex = this.device.texture({
                width: width,
                height: height,
                format,
                // needed by webgpu
                sampleCount
            });
            fbo = this._outlineFBO = this.device.framebuffer({
                width: width,
                height: height,
                colors: [outlineTex],
                depth: false,
                stencil: false
            });
        } else if (width !== fbo.width || height !== fbo.height) {
            fbo.resize(width, height);
        }
        return fbo;
    }

    _getFBOColor(fbo) {
        if (this._isUseMultiSample()) {
            const blitFBO = this._getBlitFBO(fbo);
            if (blitFBO.width !== fbo.width || blitFBO.height !== fbo.height) {
                blitFBO.resize(fbo.width, fbo.height);
            } else {
                this.regl.clear({
                    color: [0, 0, 0, 0],
                    framebuffer: blitFBO
                });
            }
            blitFBO.blit(fbo);
            return blitFBO.color[0];
        } else {
            return fbo.color[0];
        }
    }

    _blitDepthTex() {
        const isWebGPU = !!this.device.wgpu;
        if (isWebGPU || this._depthTex.subimage) {
            return this._depthTex;
        }
        const { width, height } = this._depthTex;
        // multi sampled depth stencil renderbuffer
        if (!this._blitDepthFBO) {
            const regl = this.regl;
            const depthStencilTexture = regl.texture({
                min: 'nearest',
                mag: 'nearest',
                mipmap: false,
                type: 'depth stencil',
                width,
                height,
                format: 'depth stencil'
            });
            const rb = regl.renderbuffer({
                width,
                height,
                format: 'rgba4'
            });
            const info = {
                depthStencil: depthStencilTexture,
                colors: [rb],
                colorFormat: 'rgba4',
                width,
                height
            };
            this._blitDepthFBO = regl.framebuffer(info);
        }
        if (this._blitDepthFBO.width !== width || this._blitDepthFBO.height !== height) {
            this._blitDepthFBO.resize(width, height);
        }
        this.regl.clear({
            color: [0, 0, 0, 0],
            depth: 1,
            framebuffer: this._blitDepthFBO
        });
        this._blitDepthFBO.blit(this._targetFBO, 0x00000100, 'nearest');
        return this._blitDepthFBO.depthStencil;
    }

    _getBlitFBO(fbo) {
        if (!this._blitFBOs) {
            this._blitFBOs = [];
        }
        if (!fbo._blitFBO) {
            const info = this._createSimpleFBOInfo(true, fbo.width, fbo.height);
            const blitFbo = this.regl.framebuffer(info);
            this._blitFBOs.push(blitFbo);
            fbo._blitFBO = blitFbo;
        }
        return fbo._blitFBO;
    }

    _isUseMultiSample() {
        if (this.device && this.device.wgpu) {
            // in webgpu, multisample is set in device.createPipeline, doesn't need further more setup.
            return false;
        }
        const regl = this.regl;
        const isWebGL2 = regl.limits['version'].indexOf('WebGL 2.0') === 0;
        return isWebGL2 && this.layer.options.antialias;
    }

    hasRenderTarget() {
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        if (!config || !config.enable) {
            return false;
        }
        return true;
    }

    testIfNeedRedraw() {
        if (this.layer.options['forceRedrawPerFrame']) {
            return true;
        }
        if (this['_toRedraw']) {
            this['_toRedraw'] = false;
            return true;
        }
        const map = this.getMap();
        if (map.isInteracting() && (this._groundPainter && this._groundPainter.isEnable() || this._envPainter && this._envPainter.isEnable())) {
            return true;
        }
        if (this._weatherPainter && this._weatherPainter.isEnable()) {
            return true;
        }
        if (this.isEnableScanEffect()) {
            return true;
        }
        const terrainLayer = this.layer.getTerrainLayer();
        if (terrainLayer) {
            const renderer = terrainLayer.getRenderer();
            if (renderer && renderer.testIfNeedRedraw()) {
                this._needUpdateSSR = true;
                return true;
            }
        }
        const layers = this._getLayers();
        for (const layer of layers) {
            if (!layer) {
                continue;
            }
            const renderer = layer.getRenderer();
            if (renderer && renderer.testIfNeedRedraw()) {
                // 如果图层发生变化，保存的depthTexture可能发生变化，所以ssr需要多重绘一次，更新depthTexture
                this._needUpdateSSR = true;
                return true;
            }
        }
        return false;
    }

    // _isLayerEnableTAA(renderer) {
    //     return this.isEnableTAA() && renderer.supportRenderMode && renderer.supportRenderMode('taa');
    // }

    isRenderComplete() {
        const layers = this._getLayers();
        for (const layer of layers) {
            const renderer = layer.getRenderer();
            if (renderer && !renderer.isRenderComplete()) {
                return false;
            }
        }
        return true;
    }

    mustRenderOnInteracting() {
        const layers = this._getLayers();
        for (const layer of layers) {
            const renderer = layer.getRenderer();
            if (renderer && renderer.mustRenderOnInteracting()) {
                return true;
            }
        }
        return false;
    }

    isCanvasUpdated() {
        if (super.isCanvasUpdated()) {
            return true;
        }
        const layers = this._getLayers();
        for (const layer of layers) {
            const renderer = layer.getRenderer();
            if (renderer && renderer.isCanvasUpdated()) {
                return true;
            }
        }
        return false;
    }

    isBlank() {
        if (this._groundPainter && this._groundPainter.isEnable()) {
            return false;
        }
        if (this._envPainter && this._envPainter.isEnable()) {
            return false;
        }
        const terrainLayer = this.layer.getTerrainLayer();
        if (terrainLayer) {
            const renderer = terrainLayer.getRenderer();
            if (renderer && !renderer.isBlank()) {
                return false;
            }
        }
        const layers = this._getLayers();
        for (const layer of layers) {
            const renderer = layer.getRenderer();
            if (renderer && !renderer.isBlank()) {
                return false;
            }
        }
        return true;
    }

    initContext() {
        super.initContext();
        if (!this.context) {
            return;
        }
        this.forEachRenderer(renderer => {
            if (renderer.canvas) {
                renderer.initContext();
            }
        });
        const layer = this.layer;
        const { regl, gl, reglGL, device } = this.context;
        this.device = device || regl;
        this.regl = regl;
        this.reglGL = reglGL;
        this.gl = gl;
        // 为老的webgl插件提供兼容性
        this.canvas.gl = this.gl;
        this._jitter = [0, 0];
        const graphics = regl || device;
        this._groundPainter = new GroundPainter(graphics, this.layer);
        this._envPainter = new EnvironmentPainter(graphics, this.layer);
        const weatherConfig = this.layer.getWeatherConfig();
        this._weatherPainter = new WeatherPainter(graphics, layer, weatherConfig);
        this._analysisPainter = new AnalysisPainter(graphics, layer);
        this._scanEffectPainter = new ScanEffectPainter(graphics, layer);

        const sceneConfig = this.layer._getSceneConfig() || {};
        const config = sceneConfig && sceneConfig.postProcess;
        const ratio = config && config.antialias && config.antialias.jitterRatio || 0.2;
        this._jitGetter = new Jitter(ratio);
        this._postProcessor = new PostProcess(graphics, this.layer, this._jitGetter);

        this._shadowProcess = new ShadowProcess(graphics, this.layer);
    }

    clearContext() {
        super.clearContext();
        this._clearFramebuffers();
    }

    _clearFramebuffers() {
        const device = this.device;
        if (this._targetFBO) {
            device.clear({
                color: EMPTY_COLOR$1,
                depth: 1,
                stencil: 0,
                framebuffer: this._targetFBO
            });
        }
        if (this._outlineFBO) {
            device.clear({
                color: EMPTY_COLOR$1,
                depth: 1,
                stencil: 0,
                framebuffer: this._outlineFBO
            });
        }
    }

    resizeCanvas() {
        const width = this.canvas.width;
        const height = this.canvas.height;
        if (this._targetFBO && (this._targetFBO.width !== width ||
            this._targetFBO.height !== height)) {
            super.resizeCanvas();
            this._targetFBO.resize(width, height);
            // this._noAaFBO.resize(width, height);
            // this._pointFBO.resize(width, height);
            // if (this._taaFBO) {
            //     this._taaFBO.resize(width, height);
            // }
            // if (this._fxaaFBO) {
            //     this._fxaaFBO.resize(width, height);
            // }
            this._clearFramebuffers();
            this.forEachRenderer(renderer => {
                if (renderer.canvas) {
                    renderer.resizeCanvas();
                }
            });
        }

    }

    _getLayers() {
        return this.layer._getLayers();
    }

    forEachRenderer(fn) {
        const layers = this._getLayers();
        for (const layer of layers) {
            if (!layer.isVisible() || !layer.options['renderBeforeTerrain']) {
                continue;
            }
            const renderer = layer.getRenderer();
            if (renderer) {
                fn(renderer, layer);
            }
        }
        const terrainLayer = this.layer.getTerrainLayer();
        if (terrainLayer) {
            const renderer = terrainLayer.getRenderer();
            if (renderer) {
                fn(renderer, terrainLayer);
            }
        }
        for (const layer of layers) {
            if (!layer.isVisible() || layer.options['renderBeforeTerrain']) {
                continue;
            }
            const renderer = layer.getRenderer();
            if (renderer) {
                fn(renderer, layer);
            }
        }

    }

    clearStencil(renderer, fbo) {
        const stencilValue = renderer.getStencilValue ? renderer.getStencilValue() : 0xFF;
        const config = {
            stencil: stencilValue
        };
        if (fbo) {
            config['framebuffer'] = fbo;
        }
        this.device.clear(config);
    }

    onRemove() {
        //regl framebuffer for picking created by children layers
        if (!this.canvas) {
            super.onRemove();
            return;
        }
        const pickingFBO = this.canvas.pickingFBO;
        if (pickingFBO && pickingFBO.destroy && !pickingFBO['___disposed']) {
            pickingFBO['___disposed'] = true;
            pickingFBO.destroy();
        }
        this._destroyFramebuffers();
        if (this._groundPainter) {
            this._groundPainter.dispose();
            delete this._groundPainter;
        }
        if (this._envPainter) {
            this._envPainter.dispose();
            delete this._envPainter;
        }
        if (this._shadowProcess) {
            this._shadowProcess.dispose();
            delete this._shadowProcess;
        }
        if (this._postProcessor) {
            this._postProcessor.dispose();
            delete this._postProcessor;
        }
        if (this._outlineFBO) {
            this._outlineFBO.destroy();
            delete this._outlineFBO;
        }
        if (this._weatherPainter) {
            this._weatherPainter.dispose();
            delete this._weatherPainter;
        }
        delete this.gl;
        delete this.regl;
        super.onRemove();
    }

    hitDetect(/* point */) {
        return false;
    }

    _destroyFramebuffers() {
        if (this._targetFBO) {
            this._targetFBO.destroy();
            // this._noAaFBO.destroy();
            // this._pointFBO.destroy();
            // if (this._taaFBO) {
            //     this._taaFBO.destroy();
            //     delete this._taaFBO;
            // }
            // if (this._fxaaFBO) {
            //     this._fxaaFBO.destroy();
            //     delete this._fxaaFBO;
            // }
            delete this._targetFBO;
            // delete this._noAaFBO;
            // delete this._pointFBO;
            if (this._postFBO) {
                this._postFBO.destroy();
                delete this._postFBO;
            }
            if (this._blitDepthFBO) {
                this._blitDepthFBO.destroy();
                delete this._blitDepthFBO;
            }
            if (this._blitFBOs) {
                for (let i = 0; i < this._blitFBOs.length; i++) {
                    if (this._blitFBOs[i]) {
                        this._blitFBOs[i].destroy();
                    }
                }
                delete this._blitFBOs;
            }
        }
    }

    setRetireFrames() {
        this._needRetireFrames = true;
    }

    getFrameTime() {
        return this._contextFrameTime;
    }

    getFrameEvent() {
        return this._frameEvent;
    }

    getFrameContext() {
        return this._drawContext;
    }

    drawGround(forceRender) {
        const config = this.layer.getGroundConfig();
        if (!config || !config.enable) {
            return false;
        }
        if (!this._groundPainter) {
            return false;
        }
        const context = this.getFrameContext();
        const jitter = context.jitter;
        //地面绘制不用引入jitter，会导致地面的晃动
        context.jitter = NO_JITTER;
        // 1 是留给开启了ssr的图形的
        const polygonOffsetCount = this.layer.getPolygonOffsetCount();
        // 加一是为了防止有ssr的图形的polygonOffset被设置成1
        context.offsetFactor = polygonOffsetCount + 1;
        context.offsetUnits = polygonOffsetCount + 1;
        let sceneFilter;
        if (forceRender) {
            // 第一次绘制 ground 应该忽略 sceneFilter
            // 否则 noSSRFilter 会把 ground 过滤掉
            // 但当场景有透明物体时，物体背后没画ground，出现绘制问题。
            sceneFilter = context.sceneFilter;
            delete context.sceneFilter;
        }
        const drawn = this._groundPainter.paint(context);
        if (this._groundPainter.needToRedraw()) {
            this.setToRedraw();
        }
        if (sceneFilter) {
            context.sceneFilter = sceneFilter;
        }
        context.jitter = jitter;
        return drawn;
    }

    _buildDrawFn(drawMethod) {
        const me = this;
        //drawBloom中会手动创建context
        return function (timestamp, context) {
            context = context || me._drawContext;
            const hasRenderTarget = context && context.renderTarget;
            if (hasRenderTarget) {
                context.renderTarget.getFramebuffer = getFramebuffer;
                context.renderTarget.getDepthTexture = getDepthTexture;
            }
            return drawMethod.call(this, timestamp, context);
        };
    }

    _buildDrawOnInteractingFn(drawMethod) {
        const me = this;
        //drawBloom中会手动创建context
        return function (event, timestamp, context) {
            context = context || me._drawContext;
            const hasRenderTarget = context && context.renderTarget;
            if (hasRenderTarget) {
                context.renderTarget.getFramebuffer = getFramebuffer;
                context.renderTarget.getDepthTexture = getDepthTexture;
            }
            return drawMethod.call(this, event, timestamp, context);
        };
    }

    _buildSetToRedrawFn(fn) {
        return function (...args) {
            return fn.apply(this, args);
        };
    }

    isEnableSSR() {
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        return config && config.enable && config.ssr && config.ssr.enable;
    }

    isSSROn() {
        const enable = this.isEnableSSR();
        const map = this.getMap();
        if (!enable || map.getPitch() <= MIN_SSR_PITCH) {
            return 0;
        }
        const projViewMat = map.projViewMatrix;
        const prevSsrMat = this._postProcessor.getPrevSsrProjViewMatrix();
        return prevSsrMat && mat4.exactEquals(prevSsrMat, projViewMat) ? SSR_STATIC : SSR_IN_ONE_FRAME;
        // return SSR_IN_ONE_FRAME;
        // SSR_STATIC的思路是直接利用上一帧的深度纹理，来绘制ssr，这样无需额外的ssr pass。
        // 但当场景里有透明的物体时，被物体遮住的倒影会在SSR_STATIC阶段中绘制，但在SSR_IN_ONE_FRAME中不绘制，出现闪烁，故取消SSR_STATIC
        // 2021-01-11 fuzhen 该问题通过在ssr shader中，通过手动比较深度值，决定是否绘制解决
        // 2021-02-05 fuzhen 通过在drawSSR前copyDepth，ssr统一在StandardShader中绘制，不再需要ssr后处理, 之后SSR_IN_ONE_FRAME相比SSR_STATIC，只是多了drawSSR
        // 2021-02-07 fuzhen ssr绘制顺序不同，会导致一些绘制问题，改为统一用SSR_IN_ONE_FRAME
        // 2021-02-11 fuzhen 重新分为SSR_STATIC和SSR_IN_ONE_FRAME，SSR_STATIC时重用上一帧depth纹理，在taa前绘制ssr图形，解决taa抖动造成的ssr图形边缘缝隙问题
    }

    isEnableTAA() {
        // const sceneConfig =  this.layer._getSceneConfig();
        // const config = sceneConfig && sceneConfig.postProcess;
        // return config && config.antialias && config.antialias.enable && config.antialias.taa;
        return false;
    }

    isEnableSSAO() {
        // const sceneConfig =  this.layer._getSceneConfig();
        // const config = sceneConfig && sceneConfig.postProcess;
        // return config && config.enable && config.ssao && config.ssao.enable;
        return false;
    }

    isEnableOutline() {
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        return config && config.enable && config.outline && config.outline.enable;
    }

    isEnableWeather() {
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.weather;
        return config && config.enable;
    }

    _getViewStates() {
        const map = this.layer.getMap();

        const renderedView = this._renderedView;
        if (!renderedView) {
            this._renderedView = {
                center: map.getCenter(),
                bearing: map.getBearing(),
                pitch: map.getPitch(),
                res: map.getResolution()
                // count: scene.getMeshes().length - (displayShadow ? 1 : 0)
            };
            let lightDirectionChanged = false;
            if (map.options.lights) {
                const lightManager = map.getLightManager();
                const lightDirection = lightManager.getDirectionalLight().direction || DEFAULT_LIGHT_DIRECTION;
                this._renderedView.lightDirection = vec3.copy([], lightDirection);
                lightDirectionChanged = true;
            }
            return {
                viewChanged: true,
                lightDirectionChanged
            };
        }
        const res = map.getResolution();
        const scale = res / this._renderedView.res;
        // const maxPitch = map.options['cascadePitches'][2];
        // const pitch = map.getPitch();
        const cp = map.coordToContainerPoint(this._renderedView.center);
        const viewMoveThreshold = this.layer.options['viewMoveThreshold'];
        // const viewPitchThreshold = this.layer.options['viewPitchThreshold'];
        const viewChanged = (cp['_sub'](map.width / 2, map.height / 2).mag() > viewMoveThreshold) || scale < 0.95 || scale > 1.05;
        // Math.abs(renderedView.bearing - map.getBearing()) > 30 ||
        // (renderedView.pitch < maxPitch || pitch < maxPitch) && Math.abs(renderedView.pitch - pitch) > viewPitchThreshold;
        let lightDirectionChanged = false;
        if (map.options.lights) {
            const lightManager = map.getLightManager();
            const lightDirection = lightManager.getDirectionalLight().direction || DEFAULT_LIGHT_DIRECTION;
            lightDirectionChanged = !vec3.equals(this._renderedView.lightDirection || [], lightDirection);
            if (lightDirectionChanged) {
                this._renderedView.lightDirection = vec3.copy([], lightDirection);
            }
        }
        //update renderView
        if (viewChanged) {
            this._renderedView.center = map.getCenter();
            this._renderedView.bearing = map.getBearing();
            this._renderedView.pitch = map.getPitch();
            this._renderedView.res = map.getResolution();
        }
        return {
            viewChanged,
            lightDirectionChanged
        };
    }



    _prepareDrawContext(timestamp) {
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        const weatherConfig = sceneConfig && sceneConfig.weather;
        const context = {
            timestamp,
            renderMode: this._renderMode || 'default',
            includes: {},
            states: this._getViewStates(),
            testSceneFilter: mesh => {
                return !context.sceneFilter || context.sceneFilter(mesh);
            },
            isFinalRender: false,
            weather: {//drawContext传递到各个子图层中，用来渲染天气相关
                fog: weatherConfig && weatherConfig.fog
            }
        };

        const ratio = config && config.antialias && config.antialias.jitterRatio || 0.2;
        const jitGetter = this._jitGetter;
        if (jitGetter) {
            jitGetter.setRatio(ratio);
        }

        const ssrMode = this.isSSROn();
        let renderTarget;
        if (!config || !config.enable) {
            this._destroyFramebuffers();
        } else {
            const hasJitter = this.isEnableTAA();
            if (hasJitter) {
                const map = this.getMap();
                if (map.isInteracting() || this._needRetireFrames) {
                    jitGetter.reset();
                }
                jitGetter.getJitter(this._jitter);
                jitGetter.frame();
            } else {
                vec2.set(this._jitter, 0, 0);
            }
            context['jitter'] = this._jitter;
            const enableBloom = config.bloom && config.bloom.enable;
            if (enableBloom && ssrMode) {
                context['bloom'] = 1;
                context['sceneFilter'] = noPostFilter;
            } else if (enableBloom) {
                context['bloom'] = 1;
                context['sceneFilter'] = noBloomFilter;
            } else if (ssrMode) {
                context['sceneFilter'] = noSsrFilter;
            }

            renderTarget = this._getFramebufferTarget();
            if (renderTarget) {
                context.renderTarget = renderTarget;
            }
        }
        if (this._renderMode !== 'noAa') {

            this._shadowContext = this._prepareShadowContext(context);
            if (this._shadowContext) {
                context.includes.shadow = 1;
            }
            this._includesState = this._updateIncludesState(context);
        }
        if (this._shadowContext) {
            context.shadow = this._shadowContext;
            context.includes.shadow = 1;
        }
        context.states.includesChanged = this._includesState;
        if (config && config.enable && this._postProcessor) {
            this._postProcessor.setContextIncludes(context);
        }
        // 2021-02-20 ssr的绘制全部统一到了drawSSR中，而不会在平时的绘制阶段绘制ssr了
        // if (ssrMode === SSR_STATIC) {
        //     const ssr = this._postProcessor.getSSRContext();
        //     if (ssr) {
        //         context.ssr = ssr;
        //     }
        // }
        return context;
    }

    _renderAnalysis(tex) {
        const layers = this._getLayers().filter(layer => {
            return layer.isVisible();
        });
        if (this.layer.getTerrainLayer()) {
            layers.push(this.layer.getTerrainLayer());
        }
        return this._analysisPainter.paint(tex, layers);
    }

    _updateIncludesState(context) {
        let state = false;
        const includeKeys = Object.keys(context.includes);
        const prevKeys = this._prevIncludeKeys;
        if (prevKeys) {
            const difference = includeKeys
                .filter(x => prevKeys.indexOf(x) === -1)
                .concat(prevKeys.filter(x => includeKeys.indexOf(x) === -1));
            if (difference.length) {
                state = difference.reduce((accumulator, currentValue) => {
                    accumulator[currentValue] = 1;
                    return accumulator;
                }, {});
            }
        }
        this._prevIncludeKeys = includeKeys;
        return state;
    }

    _prepareShadowContext(context) {
        const sceneConfig = this.layer._getSceneConfig();
        if (!sceneConfig || !sceneConfig.shadow || !sceneConfig.shadow.enable) {
            if (this._shadowProcess) {
                this._shadowProcess.dispose();
                delete this._shadowProcess;
            }
            return null;
        }
        if (!this._shadowProcess) {
            this._shadowProcess = new ShadowProcess(this.device, this.layer);
        }
        const shadow = {
            config: sceneConfig.shadow,
            defines: this._shadowProcess.getDefines(),
            uniformDeclares: ShadowProcess.getUniformDeclares()
        };
        shadow.renderUniforms = this._renderShadow(context);
        return shadow;
    }

    _renderShadow(context) {
        const fbo = context.renderTarget && context.renderTarget.fbo;
        const sceneConfig = this.layer._getSceneConfig();
        const meshes = [];
        let forceUpdate = context.states.lightDirectionChanged || context.states.viewChanged;
        this.forEachRenderer((renderer, layer) => {
            if (!renderer.getShadowMeshes || !layer.isVisible()) {
                return;
            }
            const shadowMeshes = renderer.getShadowMeshes();
            if (Array.isArray(shadowMeshes)) {
                for (let i = 0; i < shadowMeshes.length; i++) {
                    if (!shadowMeshes[i]) {
                        continue;
                    }
                    if (shadowMeshes[i].needUpdateShadow) {
                        forceUpdate = true;
                        shadowMeshes[i].needUpdateShadow = false;
                    }
                    if (shadowMeshes[i].hasFunctionUniform) {
                        if (!shadowMeshes[i].hasFunctionUniform('minAltitude')) {
                            shadowMeshes[i].setFunctionUniform('minAltitude', () => {
                                return layer && layer.options.altitude || 0;
                            });
                        }
                        meshes.push(shadowMeshes[i]);
                    }
                }
            }
        });
        // if (!meshes.length) {
        //     return null;
        // }
        if (!this._shadowScene) {
            this._shadowScene = new Scene();
        }
        this._shadowScene.setMeshes(meshes);
        const map = this.getMap();
        const shadowConfig = sceneConfig.shadow;
        const lightManager = map.getLightManager();
        const lightDirection = lightManager && lightManager.getDirectionalLight().direction || DEFAULT_LIGHT_DIRECTION;
        const displayShadow = !sceneConfig.ground || !sceneConfig.ground.enable;
        const uniforms = this._shadowProcess.render(displayShadow, map.projMatrix, map.viewMatrix, shadowConfig.color, shadowConfig.opacity, lightDirection, this._shadowScene, this._jitter, fbo, forceUpdate);
        // if (this._shadowProcess.isUpdated()) {
        //     this.setRetireFrames();
        // }
        return uniforms;
    }

    _renderWeather(tex) {
        let meshes = [];
        this.forEachRenderer((renderer, layer) => {
            if (!renderer.getAnalysisMeshes || !layer.isVisible()) {
                return;
            }
            const renderMeshes = renderer.getAnalysisMeshes();
            meshes = meshes.concat(renderMeshes);
        });
        if (this._groundPainter) {
            const groundMesh = this._groundPainter.getRenderMeshes();
            meshes = meshes.concat(groundMesh);
        }
        const weatherConfig = this.layer.getWeatherConfig();
        return this._weatherPainter.paint(tex, meshes, weatherConfig);
    }

    _renderScanEffect(tex) {
        let meshes = [];
        this.forEachRenderer((renderer, layer) => {
            if (!renderer.getAnalysisMeshes || !layer.isVisible()) {
                return;
            }
            const renderMeshes = renderer.getAnalysisMeshes();
            meshes = meshes.concat(renderMeshes);
        });
        if (this._groundPainter) {
            const groundMesh = this._groundPainter.getRenderMeshes();
            meshes = meshes.concat(groundMesh);
        }
        return this._scanEffectPainter.paint(tex, meshes);
    }

    getGroundMesh() {
        if (this._groundPainter) {
            const groundMesh = this._groundPainter.getRenderMeshes();
            return groundMesh;
        }
        return [];
    }

    _getFramebufferTarget() {
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        if (!this._targetFBO) {
            const device = this.device;
            let depthTex = this._depthTex;
            if (!depthTex || !depthTex['_texture'] || depthTex['_texture'].refCount <= 0) {
                depthTex = null;
            }
            const fboInfo = this.createFBOInfo(config, depthTex);
            this._depthTex = fboInfo.depth || fboInfo.depthStencil;
            this._targetFBO = device.framebuffer(fboInfo);
            // const noAaInfo = this.createFBOInfo(config, this._depthTex);
            // this._noAaFBO = regl.framebuffer(noAaInfo);
            // const pointInfo = this.createFBOInfo(config, this._depthTex);
            // this._pointFBO = regl.framebuffer(pointInfo);
            this._clearFramebuffers();
        }
        return {
            fbo: this._targetFBO
        };
    }

    _createSimpleFBOInfo(forceTexture, width, height) {
        width = width || this.canvas.width, height = height || this.canvas.height;
        const regl = this.device;
        const useMultiSamples = this._isUseMultiSample();
        const isAntialias = this.layer.options.antialias;
        let color;
        if (!forceTexture && useMultiSamples) {
            // rgba8 是webgl中的格式，regl支持，对应的还有rgba4
            color = regl.renderbuffer({
                width,
                height,
                samples: this.layer.options['multiSamples'],
                format: 'rgba8'
            });
        } else {
            const sampleCount = isAntialias ? 4 : 1;
            const type = 'uint8';//colorType || regl.hasExtension('OES_texture_half_float') ? 'float16' : 'float';
            color = regl.texture({
                min: 'nearest',
                mag: 'nearest',
                type,
                width,
                height,
                // needed by webgpu
                sampleCount
            });
        }
        const fboInfo = {
            width,
            height,
            colors: [color],
            // stencil: true,
            // colorCount,
            colorFormat: useMultiSamples ? 'rgba8' : 'rgba'
        };

        return fboInfo;
    }

    createFBOInfo(config, depthTex) {
        let { width, height } = this.canvas;
        width = width || 1;
        height = height || 1;
        const regl = this.device;
        const fboInfo = this._createSimpleFBOInfo();
        const useMultiSamples = this._isUseMultiSample();
        const enableDepthTex = !this.regl || regl.hasExtension('WEBGL_depth_texture');
        if (useMultiSamples) {
            const renderbuffer = depthTex || regl.renderbuffer({
                width,
                height,
                format: 'depth24 stencil8',
                samples: this.layer.options['multiSamples']
            });
            fboInfo.depthStencil = renderbuffer;
        } else {
            //depth(stencil) buffer 是可以共享的
            if (enableDepthTex) {
                const isAntialias = this.layer.options.antialias;
                const sampleCount = isAntialias ? 4 : 1;
                const depthStencilTexture = depthTex || regl.texture({
                    min: 'nearest',
                    mag: 'nearest',
                    mipmap: false,
                    type: 'depth stencil',
                    width,
                    height,
                    format: 'depth stencil',
                    // needed by webgpu
                    sampleCount
                });
                fboInfo.depthStencil = depthStencilTexture;
            } else {
                const renderbuffer = depthTex || regl.renderbuffer({
                    width,
                    height,
                    format: 'depth stencil'
                });
                fboInfo.depthStencil = renderbuffer;
            }
        }

        return fboInfo;
    }

    _postProcess() {
        if (!this._targetFBO) {
            this._needRetireFrames = false;
            return;
        }
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        if (!config || !config.enable) {
            if (this.isEnableWeather()) {
                throw new Error('you must enable the post process to turn on weather');
            }
            return;
        }
        this.layer.fire('postprocessstart');
        const map = this.layer.getMap();

        // const enableTAA = this.isEnableTAA();
        // let taaTex;
        // if (enableTAA) {
        //     const needClear = this._needRetireFrames || map.getRenderer().isViewChanged();
        //     if (needClear) {
        //         this.layer.fire('taastart');
        //     }
        //     const { outputTex, redraw } = this._postProcessor.taa(this._getFBOColor(this._taaFBO), this._blitDepthTex(), {
        //         projMatrix: map.projMatrix,
        //         needClear
        //     });
        //     taaTex = outputTex;
        //     if (redraw) {
        //         this.setToRedraw();
        //     } else {
        //         this.layer.fire('taaend');
        //     }
        //     this._needRetireFrames = false;
        // }

        let sharpFactor = config.sharpen && config.sharpen.factor;
        if (!sharpFactor && sharpFactor !== 0) {
            sharpFactor = 0.2;// 0 - 5
        }

        let enableOutline = 0;
        let highlightFactor = 0.2;
        let outlineFactor = 0.3;
        let outlineWidth = 1;
        let outlineColor = [1, 1, 0];
        if (config.outline) {
            enableOutline = +!!config.outline.enable;
            highlightFactor = getValueOrDefault(config.outline, 'highlightFactor', highlightFactor);
            outlineFactor = getValueOrDefault(config.outline, 'outlineFactor', outlineFactor);
            outlineWidth = getValueOrDefault(config.outline, 'outlineWidth', outlineWidth);
            outlineColor = getValueOrDefault(config.outline, 'outlineColor', outlineColor);
        }

        // const enableSSAO = this.isEnableSSAO();
        const enableSSR = config.ssr && config.ssr.enable;
        const enableBloom = config.bloom && config.bloom.enable;
        // const bloomPainted = enableBloom && this._bloomPainted;
        // const enableAntialias = +!!(config.antialias && config.antialias.enable);
        const enableAnalysis = this._analysisPainter._hasAnalysis();
        const enableWeather = this._weatherPainter._hasWeather();
        const enableScanEffect = this.isEnableScanEffect();
        const hasPost = /*enableSSAO || */enableBloom || enableSSR || enableAnalysis || enableWeather || enableScanEffect;

        let postFBO = this._postFBO;
        if (hasPost) {
            if (!postFBO) {
                const info = this._createSimpleFBOInfo();
                if (this._isUseMultiSample()) {
                    info.depthStencil = this.regl.renderbuffer({
                        width: this.canvas.width,
                        height: this.canvas.height,
                        samples: this.layer.options['multiSamples'],
                        format: 'depth24 stencil8'
                    });
                }
                postFBO = this._postFBO = this.device.framebuffer(info);
            }
            const { width, height } = this.canvas;
            if (postFBO.width !== width || postFBO.height !== height) {
                postFBO.resize(width, height);
            }
        } else {
            postFBO = null;
            if (this._postFBO) {
                this._postFBO.destroy();
                delete this._postFBO;
            }
        }

        let tex = this._getFBOColor(this._targetFBO);
        // const noAaTex = this._noaaDrawCount && this._getFBOColor(this._noAaFBO);
        // const pointTex = this._pointDrawCount && this._getFBOColor(this._pointFBO);

        // const enableFXAA = config.antialias && config.antialias.enable && (config.antialias.fxaa || config.antialias.fxaa === undefined);

        // 2024-10-09 disable fxaa to ensure layer's render order except for ssr/bloom/outline, maptalks/issues#750
        this._postProcessor.fxaa(
            postFBO,
            tex,
            0,//+(!hasPost && enableAntialias),
            // +!!enableFXAA,
            // 1,
            +!!(config.toneMapping && config.toneMapping.enable),
            +!!(!hasPost && config.sharpen && config.sharpen.enable),
            map.getDevicePixelRatio(),
            sharpFactor,
            enableOutline && this._outlineCounts > 0 && this._getOutlineFBO(),
            highlightFactor,
            outlineFactor,
            outlineWidth,
            outlineColor
        );

        if (postFBO) {
            tex = this._getFBOColor(postFBO);
        }

        // if (enableSSAO && (this._fxaaAfterTaaDrawCount || this._taaDrawCount || this._fxaaDrawCount)) {
        //     //TODO 合成时，SSAO可能会被fxaaFBO上的像素遮住
        //     //generate ssao texture for the next frame
        //     tex = this._postProcessor.ssao(tex, this._blitDepthTex(), {
        //         projMatrix: map.projMatrix,
        //         cameraNear: map.cameraNear,
        //         cameraFar: map.cameraFar,
        //         ssaoBias: config.ssao && config.ssao.bias || 10,
        //         ssaoRadius: config.ssao && config.ssao.radius || 100,
        //         ssaoIntensity: config.ssao && config.ssao.intensity || 0.5
        //     });
        // }

        if (enableBloom && this._bloomPainted) {
            const bloomConfig = config.bloom;
            const threshold = +bloomConfig.threshold || 0;
            const factor = getValueOrDefault(bloomConfig, 'factor', 1);
            const radius = getValueOrDefault(bloomConfig, 'radius', 1);
            tex = this._postProcessor.bloom(tex, null, null, threshold, factor, radius, 0);
        }

        if (enableSSR) {
            this._postProcessor.genSsrMipmap(tex, this._blitDepthTex());
            if (this._needUpdateSSR) {
                const needRetireFrames = this._needRetireFrames;
                this.setToRedraw();
                this._needRetireFrames = needRetireFrames;
                this._needUpdateSSR = false;
            }
        }
        if (this._scanEffectPainter && this.isEnableScanEffect()) {
            tex = this._renderScanEffect(tex);
        }
        if (this._analysisPainter) {
            tex = this._renderAnalysis(tex);
        }
        if (this.isEnableWeather()) {
            tex = this._renderWeather(tex);
        }

        if (hasPost) {
            this._postProcessor.renderFBOToScreen(tex, +!!(config.sharpen && config.sharpen.enable), sharpFactor, map.getDevicePixelRatio());
        }
        this.layer.fire('postprocessend');
    }

    isEnableScanEffect() {
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess && sceneConfig.postProcess.scanEffect;
        return config && config.enable && config.effects.length;
    }

    resetDrawCalls() {
        if (this.reglGL) {
            this.reglGL.resetDrawCalls();
        }
        if (this.device && this.device.wgpu) {
            this.device.resetDrawCalls();
        }
    }

    getDrawCalls() {
        if (this.reglGL) {
            return this.reglGL.getDrawCalls();
        }
        if (this.device && this.device.wgpu) {
            return this.device.getDrawCalls();
        }
    }
}


function isNil(obj) {
    return obj == null;
}

function isNumber(val) {
    return (typeof val === 'number') && !isNaN(val);
}

function getFramebuffer(fbo) {
    return fbo['_framebuffer'].framebuffer;
}

function getDepthTexture(fbo) {
    //TODO 也可能是renderbuffer
    return fbo.depthStencil._texture.texture;
}


function getValueOrDefault(v, key, defaultValue) {
    if (isNil(v[key])) {
        return defaultValue;
    }
    return v[key];
}

class TerrainWorkerConnection extends maptalks.worker.Actor {
    constructor(mapId) {
        super('@maptalks/terrain');
        this.mapId = mapId;
    }

    checkUrl(url) {
        if (!url || !maptalks.Util.isString(url)) {
            return url;
        }
        //The URL is processed. Here, only the relative protocol is processed
        return maptalks.Util.getAbsoluteURL(url);

    }

    fetchTerrain(url, options, cb) {
        url = this.checkUrl(url);
        const tileImage = options.tileImage;
        const data = {
            actorId: this.actorId,
            mapId: this.mapId,
            command: 'fetchTerrain',
            params: {
                url,
                origin: location.origin,
                terrainWidth: options.terrainWidth,
                type: options.type,
                accessToken: options.accessToken,
                cesiumIonTokenURL: options.cesiumIonTokenURL,
                error: options.error,
                colors: options.colors,
                tileSize: options.tileSize,
                tileImage
            }
        };
        const buffers = [];
        if (tileImage) {
            buffers.push(tileImage);
        }
        this.send(data, buffers, (err, data) => {
            if (err) {
                cb(err);
                return;
            }
            cb(err, data);
        });
    }

    abortTerrain(url, cb) {
        const data = {
            actorId: this.actorId,
            mapId: this.mapId,
            command: 'abortTerrain',
            params: {
                url
            }
        };
        this.broadcast(data, null, cb);
    }

    addLayer(layerId, options, cb) {
        const data = {
            actorId: this.actorId,
            mapId: this.mapId,
            layerId,
            command: 'addLayer',
            params: {
            }
        };

        this.broadcast(data, null, cb);
    }

    createTerrainMesh(params, cb) {
        const data = {
            actorId: this.actorId,
            command: 'createTerrainMesh',
            params
        };
        this.send(data, [params.terrainHeights.data.buffer], (err, data) => {
            if (err) {
                cb(err);
                return;
            }
            cb(err, data);
        });
    }

    removeLayer(layerId, options, cb) {
        const data = {
            mapId: this.mapId,
            layerId,
            command: 'removeLayer'
        };
        this.broadcast(data, null, cb);
    }
}

var skinVert = "#define SHADER_NAME TERRAIN_SKIN\nattribute vec2 aPosition;\nvoid main() {\n  gl_Position = vec4(aPosition, .0, 1.);\n}";

var skinFrag = "#define SHADER_NAME TERRAIN_SKIN\nprecision mediump float;\nuniform float tileSize;\nuniform sampler2D skinTexture;\nuniform vec3 skinDim;\nuniform float opacity;\nvoid main() {\n  vec2 c = gl_FragCoord.xy / 2.;\n  vec2 d = vec2(tileSize);\n  vec2 e = (c - skinDim.xy) / (d * skinDim.z);\n  if(e.x >= .0 && e.x <= 1. && e.y >= .0 && e.y <= 1.) {\n    gl_FragColor = texture2D(skinTexture, e) * opacity;\n  } else {\n    gl_FragColor = vec4(.0);\n  }\n}";

class Martini {
    constructor(gridSize = 257) {
        this.gridSize = gridSize;
        const tileSize = gridSize - 1;
        if (tileSize & (tileSize - 1)) throw new Error(
            `Expected grid size to be 2^n+1, got ${gridSize}.`);

        this.numTriangles = tileSize * tileSize * 2 - 2;
        this.numParentTriangles = this.numTriangles - tileSize * tileSize;

        this.indices = new Uint32Array(this.gridSize * this.gridSize);

        // coordinates for all possible triangles in an RTIN tile
        this.coords = new Uint16Array(this.numTriangles * 4);

        // get triangle coordinates from its index in an implicit binary tree
        for (let i = 0; i < this.numTriangles; i++) {
            let id = i + 2;
            let ax = 0, ay = 0, bx = 0, by = 0, cx = 0, cy = 0;
            if (id & 1) {
                bx = by = cx = tileSize; // bottom-left triangle
            } else {
                ax = ay = cy = tileSize; // top-right triangle
            }
            while ((id >>= 1) > 1) {
                const mx = (ax + bx) >> 1;
                const my = (ay + by) >> 1;

                if (id & 1) { // left half
                    bx = ax; by = ay;
                    ax = cx; ay = cy;
                } else { // right half
                    ax = bx; ay = by;
                    bx = cx; by = cy;
                }
                cx = mx; cy = my;
            }
            const k = i * 4;
            this.coords[k + 0] = ax;
            this.coords[k + 1] = ay;
            this.coords[k + 2] = bx;
            this.coords[k + 3] = by;
        }
    }

    createTile(terrain) {
        return new Tile(terrain, this);
    }
}

class Tile {
    constructor(terrain, martini) {
        const size = martini.gridSize;
        if (terrain.length !== size * size) throw new Error(
            `Expected terrain data of length ${size * size} (${size} x ${size}), got ${terrain.length}.`);

        this.terrain = terrain;
        this.martini = martini;
        this.errors = new Float32Array(terrain.length);
        this.update();
    }

    update() {
        const {numTriangles, numParentTriangles, coords, gridSize: size} = this.martini;
        const {terrain, errors} = this;

        // iterate over all possible triangles, starting from the smallest level
        for (let i = numTriangles - 1; i >= 0; i--) {
            const k = i * 4;
            const ax = coords[k + 0];
            const ay = coords[k + 1];
            const bx = coords[k + 2];
            const by = coords[k + 3];
            const mx = (ax + bx) >> 1;
            const my = (ay + by) >> 1;
            const cx = mx + my - ay;
            const cy = my + ax - mx;

            // calculate error in the middle of the long edge of the triangle
            const interpolatedHeight = (terrain[ay * size + ax] + terrain[by * size + bx]) / 2;
            const middleIndex = my * size + mx;
            const middleError = Math.abs(interpolatedHeight - terrain[middleIndex]);

            errors[middleIndex] = Math.max(errors[middleIndex], middleError);

            if (i < numParentTriangles) { // bigger triangles; accumulate error with children
                const leftChildIndex = ((ay + cy) >> 1) * size + ((ax + cx) >> 1);
                const rightChildIndex = ((by + cy) >> 1) * size + ((bx + cx) >> 1);
                errors[middleIndex] = Math.max(errors[middleIndex], errors[leftChildIndex], errors[rightChildIndex]);
            }
        }
    }

    getMesh(maxError = 0) {
        const {gridSize: size, indices} = this.martini;
        const {errors} = this;
        let numVertices = 0;
        let numTriangles = 0;
        const max = size - 1;

        // use an index grid to keep track of vertices that were already used to avoid duplication
        indices.fill(0);

        // retrieve mesh in two stages that both traverse the error map:
        // - countElements: find used vertices (and assign each an index), and count triangles (for minimum allocation)
        // - processTriangle: fill the allocated vertices & triangles typed arrays

        function countElements(ax, ay, bx, by, cx, cy) {
            const mx = (ax + bx) >> 1;
            const my = (ay + by) >> 1;

            if (Math.abs(ax - cx) + Math.abs(ay - cy) > 1 && errors[my * size + mx] > maxError) {
                countElements(cx, cy, ax, ay, mx, my);
                countElements(bx, by, cx, cy, mx, my);
            } else {
                indices[ay * size + ax] = indices[ay * size + ax] || ++numVertices;
                indices[by * size + bx] = indices[by * size + bx] || ++numVertices;
                indices[cy * size + cx] = indices[cy * size + cx] || ++numVertices;
                numTriangles++;
            }
        }
        countElements(0, 0, max, max, max, 0);
        countElements(max, max, 0, 0, 0, max);

        const vertices = new Uint16Array(numVertices * 2);
        const triangles = new Uint32Array(numTriangles * 3);
        let triIndex = 0;

        function processTriangle(ax, ay, bx, by, cx, cy) {
            const mx = (ax + bx) >> 1;
            const my = (ay + by) >> 1;

            if (Math.abs(ax - cx) + Math.abs(ay - cy) > 1 && errors[my * size + mx] > maxError) {
                // triangle doesn't approximate the surface well enough; drill down further
                processTriangle(cx, cy, ax, ay, mx, my);
                processTriangle(bx, by, cx, cy, mx, my);

            } else {
                // add a triangle
                const a = indices[ay * size + ax] - 1;
                const b = indices[by * size + bx] - 1;
                const c = indices[cy * size + cx] - 1;

                vertices[2 * a] = ax;
                vertices[2 * a + 1] = ay;

                vertices[2 * b] = bx;
                vertices[2 * b + 1] = by;

                vertices[2 * c] = cx;
                vertices[2 * c + 1] = cy;

                triangles[triIndex++] = a;
                triangles[triIndex++] = b;
                triangles[triIndex++] = c;
            }
        }
        processTriangle(0, 0, max, max, max, 0);
        processTriangle(max, max, 0, 0, 0, max);

        return {vertices, triangles};
    }

    // isolateSkirtVertices for correct normal values
    getMeshWithSkirts(maxError = 0, isolateSkirtVertices) {
        const {gridSize: size, indices} = this.martini;
        const {errors} = this;
        let numVertices = 0;
        let numTriangles = 0;
        const max = size - 1;
        let aIndex, bIndex, cIndex = 0;
        // Skirt indices
        const leftSkirtIndices = [];
        const rightSkirtIndices = [];
        const bottomSkirtIndices = [];
        const topSkirtIndices = [];
        // use an index grid to keep track of vertices that were already used to avoid duplication
        indices.fill(0);

        // retrieve mesh in two stages that both traverse the error map:
        // - countElements: find used vertices (and assign each an index), and count triangles (for minimum allocation)
        // - processTriangle: fill the allocated vertices & triangles typed arrays
        function countElements(ax, ay, bx, by, cx, cy) {
            const mx = (ax + bx) >> 1;
            const my = (ay + by) >> 1;

            if (Math.abs(ax - cx) + Math.abs(ay - cy) > 1 && errors[my * size + mx] > maxError) {
                countElements(cx, cy, ax, ay, mx, my);
                countElements(bx, by, cx, cy, mx, my);
            } else {
                aIndex = ay * size + ax;
                bIndex = by * size + bx;
                cIndex = cy * size + cx;

                if (indices[aIndex] === 0) {
                    if (ax === 0)
                        leftSkirtIndices.push(numVertices);
                    else if (ax === max)
                        rightSkirtIndices.push(numVertices);
                    if (ay === 0)
                        bottomSkirtIndices.push(numVertices);
                    else if (ay === max)
                        topSkirtIndices.push(numVertices);
                    indices[aIndex] = ++numVertices;
                }
                if (indices[bIndex] === 0) {
                    if (bx === 0)
                        leftSkirtIndices.push(numVertices);
                    else if (bx === max)
                        rightSkirtIndices.push(numVertices);
                    if (by === 0)
                        bottomSkirtIndices.push(numVertices);
                    else if (by === max)
                        topSkirtIndices.push(numVertices);
                    indices[bIndex] = ++numVertices;
                }
                if (indices[cIndex] === 0) {
                    if (cx === 0)
                        leftSkirtIndices.push(numVertices);
                    else if (cx === max)
                        rightSkirtIndices.push(numVertices);
                    if (cy === 0)
                        bottomSkirtIndices.push(numVertices);
                    else if (cy === max)
                        topSkirtIndices.push(numVertices);
                    indices[cIndex] = ++numVertices;
                }
                numTriangles++;
            }
        }
        countElements(0, 0, max, max, max, 0);
        countElements(max, max, 0, 0, 0, max);

        let numTotalVertices;
        if (isolateSkirtVertices) {
            numTotalVertices = (
                numVertices +
                leftSkirtIndices.length * 3 - 2 +
                rightSkirtIndices.length * 3 - 2 +
                bottomSkirtIndices.length * 3 - 2 +
                topSkirtIndices.length * 3 - 2) * 2;
        } else {
            numTotalVertices = (
                numVertices +
                leftSkirtIndices.length +
                rightSkirtIndices.length +
                bottomSkirtIndices.length +
                topSkirtIndices.length) * 2;
        }
        const numTotalTriangles = (
            numTriangles +
            ((leftSkirtIndices.length - 1) * 2) +
            ((rightSkirtIndices.length - 1) * 2) +
            ((bottomSkirtIndices.length - 1) * 2) +
            ((topSkirtIndices.length - 1) * 2)) * 3;

        const vertices = new Uint16Array(numTotalVertices);
        const triangles = new Uint32Array(numTotalTriangles);

        let triIndex = 0;
        function processTriangle(ax, ay, bx, by, cx, cy) {
            const mx = (ax + bx) >> 1;
            const my = (ay + by) >> 1;

            if (Math.abs(ax - cx) + Math.abs(ay - cy) > 1 && errors[my * size + mx] > maxError) {
                // triangle doesn't approximate the surface well enough; drill down further
                processTriangle(cx, cy, ax, ay, mx, my);
                processTriangle(bx, by, cx, cy, mx, my);

            } else {
                // add a triangle
                const a = indices[ay * size + ax] - 1;
                const b = indices[by * size + bx] - 1;
                const c = indices[cy * size + cx] - 1;

                vertices[2 * a] = ax;
                vertices[2 * a + 1] = ay;

                vertices[2 * b] = bx;
                vertices[2 * b + 1] = by;

                vertices[2 * c] = cx;
                vertices[2 * c + 1] = cy;
                triangles[triIndex++] = a;
                triangles[triIndex++] = b;
                triangles[triIndex++] = c;
            }
        }
        processTriangle(0, 0, max, max, max, 0);
        processTriangle(max, max, 0, 0, 0, max);

        // Sort skirt indices to create adjacent triangles
        leftSkirtIndices.sort((a, b) => vertices[2 * a + 1] - vertices[2 * b + 1]);

        // Reverse (b - a) to match triangle winding
        rightSkirtIndices.sort((a, b) => vertices[2 * b + 1] - vertices[2 * a + 1]);

        bottomSkirtIndices.sort((a, b) => vertices[2 * b] - vertices[2 * a]);

        // Reverse (b - a) to match triangle winding
        topSkirtIndices.sort((a, b) => vertices[2 * a] - vertices[2 * b]);

        let skirtIndex = numVertices * 2;
        let currIndex, nextIndex, currentSkirt, nextSkirt, skirtLength = 0;

        // Add skirt vertices from index of last mesh vertex
        function constructSkirt(skirt) {
            skirtLength = skirt.length;
            // Loop through indices in groups of two to generate triangles
            for (let i = 0; i < skirtLength - 1; i++) {
                currIndex = skirt[i];
                nextIndex = skirt[i + 1];
                currentSkirt = skirtIndex / 2;
                nextSkirt = (skirtIndex + (isolateSkirtVertices ? 6 : 2)) / 2;

                vertices[skirtIndex++] = 2 * currIndex;
                vertices[skirtIndex++] = 2 * currIndex + 1;

                if (isolateSkirtVertices) {
                    vertices[skirtIndex++] = 2 * currIndex;
                    vertices[skirtIndex++] = 2 * currIndex + 1;
                    vertices[skirtIndex++] = 2 * nextIndex;
                    vertices[skirtIndex++] = 2 * nextIndex + 1;
                }

                if (isolateSkirtVertices) {
                    triangles[triIndex++] = currentSkirt + 1;
                    triangles[triIndex++] = currentSkirt;
                    triangles[triIndex++] = currentSkirt + 2;

                    triangles[triIndex++] = currentSkirt;
                    triangles[triIndex++] = nextSkirt;
                    triangles[triIndex++] = currentSkirt + 2;
                } else {
                    triangles[triIndex++] = currIndex;
                    triangles[triIndex++] = currentSkirt;
                    triangles[triIndex++] = nextIndex;

                    triangles[triIndex++] = currentSkirt;
                    triangles[triIndex++] = nextSkirt;
                    triangles[triIndex++] = nextIndex;
                }
            }
            // Add vertices of last skirt not added above (i < skirtLength - 1)
            vertices[skirtIndex++] = 2 * skirt[skirtLength - 1];
            vertices[skirtIndex++] = 2 * skirt[skirtLength - 1] + 1;
        }
        constructSkirt(leftSkirtIndices);
        const leftSkirtIndex = skirtIndex;
        constructSkirt(rightSkirtIndices);
        const rightSkirtIndex = skirtIndex;
        constructSkirt(bottomSkirtIndices);
        const bottomSkirtIndex = skirtIndex;
        constructSkirt(topSkirtIndices);
        const topSkirtIndex = skirtIndex;

        // Return vertices and triangles and index into vertices array where skirts start
        return {vertices, triangles, numVerticesWithoutSkirts: numVertices, numTrianglesWithoutSkirts: numTriangles, leftSkirtIndex, rightSkirtIndex, bottomSkirtIndex, topSkirtIndex};
    }
}

const martinis = {};

function createMartiniData(error, heights, width, hasSkirts) {
    let martini = martinis[width];
    if (!martini) {
        martini = martinis[width] = new Martini(width);
    }
    const terrainTile = martini.createTile(heights);
    //TODO 需要增加判断，只有pbr渲染时，才需要把isolateSkirtVertices设成true
    const isolateSkirtVertices = true;
    let mesh;
    if (hasSkirts) {
        mesh = terrainTile.getMeshWithSkirts(error, isolateSkirtVertices);
    } else {
        mesh = terrainTile.getMesh(error);
    }

    const { triangles, vertices, leftSkirtIndex, rightSkirtIndex, bottomSkirtIndex, topSkirtIndex } = mesh;
    let { numVerticesWithoutSkirts, numTrianglesWithoutSkirts } = mesh;
    if (!numVerticesWithoutSkirts) {
        numVerticesWithoutSkirts = vertices.length / 2;
        numTrianglesWithoutSkirts = triangles.length / 3;
    }
    const count = vertices.length / 2;
    const positions = new Float32Array(count * 3), texcoords = new Float32Array(count * 2);
    const skirtOffset = 0;//terrainStructure.skirtOffset;
    let minHeight = Infinity;
    let maxHeight = -Infinity;
    const maxWidth = width - 1;
    for (let i = 0; i < count; i++) {
        const x = vertices[i * 2], y = vertices[i * 2 + 1];
        if (i >= numVerticesWithoutSkirts) {
            // positions.push(0);
            const index = x / 2 * 3;
            let height;
            // 侧面因为顶底uv[1]相等，导致和normal合并计算tangent时会出现NaN，导致侧面的normal结果错误
            // 给skirt顶面的uv的x和y都增加一点偏移量即能解决该问题
            let texOffset = 0.001;
            {
                const start = i < leftSkirtIndex / 2 ? numVerticesWithoutSkirts :
                    i < rightSkirtIndex / 2 ? leftSkirtIndex / 2 :
                        i < bottomSkirtIndex / 2 ? rightSkirtIndex / 2 : bottomSkirtIndex / 2;
                if ((i - start) % 3 === 0) {
                    height = Math.min(0, minHeight);
                    texOffset = 0;
                } else {
                    height = positions[index + 2];
                }
            }
            positions[i * 3] = positions[index];
            positions[i * 3 + 1] = positions[index + 1];
            positions[i * 3 + 2] = height;

            texcoords[i * 2] = positions[index] / maxWidth + texOffset;
            texcoords[i * 2 + 1] = -positions[index + 1] / maxWidth + texOffset;
        } else {
            const height = heights[y * width + x];
            positions[i * 3] = x * (1 + skirtOffset);
            positions[i * 3 + 1] = -y * (1 + skirtOffset);
            positions[i * 3 + 2] = height;

            texcoords[i * 2] = x / maxWidth;
            texcoords[i * 2 + 1] = y / maxWidth;

            if (height < minHeight) {
                minHeight = height;
            }
            if (height > maxHeight) {
                maxHeight = height;
            }
        }
    }
    const terrain = {
        positions, texcoords, triangles,
        leftSkirtIndex,
        rightSkirtIndex,
        bottomSkirtIndex,
        topSkirtIndex,
        numTrianglesWithoutSkirts,
        numVerticesWithoutSkirts,
        minHeight: Math.min(0, minHeight),
        maxHeight,
        terrainWidth: width
    };
    return terrain;
}

function getCascadeTileIds(layer, x, y, z, center, offset, terrainTileScaleY, scale, levelLimit) {
    const result = {};
    for (let i = 0; i < levelLimit; i++) {
        result[i + ''] = getTileIdsAtLevel(layer, x, y, z, center, offset, terrainTileScaleY, scale, i);
    }
    return result;
}

const EMPTY_ARRAY$1 = [];
/**
 * 通过 layerA 的x，y 编号，计算 layerB 在 zoom 级别上的所有瓦片id
 * @param {*} layerB
 * @param {*} ax layerA瓦片的x方向编号
 * @param {*} ay layerA瓦片的y方向编号
 * @param {*} bz layerB瓦片的zoom级别
 * @param {*} aNW layerA瓦片的northwest
 * @param {*} offset
 * @param {*} aScaleY layerA 的 tileSystem.scale.y
 * @param {*} scale layerA 和 layerB 编号的scale
 * @param {*} level
 * @returns
 */
function getTileIdsAtLevel(layerB, ax, ay, bz, aNW, offset, aScaleY, scale, level) {
    bz -= level;
    if (bz <= 0) {
        return EMPTY_ARRAY$1;
    }
    // 这里假设 tile offset 还在tileSize范围内，而不是跨越或超过1整张瓦片的那种偏移方式
    const tileSize = layerB.getTileSize().width;
    const layerOffset = layerB['_getTileOffset'](bz, aNW);
    const tileOffsetX = offset[0] - layerOffset[0];
    const tileOffsetY = layerOffset[1] - offset[1];
    const tileConfig = layerB['_getTileConfig']();
    const sr = layerB.getSpatialReference();
    const tileRes = sr.getResolution(bz);
    const layerTileYScale = tileConfig.tileSystem.scale.y;

    const delta = 1E-7;
    scale = scale / Math.pow(2, level);
    let xStart = 0;
    let yStart = 0;
    let xEnd = scale;
    let yEnd = scale;
    if (tileOffsetX < 0) {
        xEnd += Math.ceil(-tileOffsetX / tileSize - delta);
    } else if (tileOffsetX > 0) {
        xStart -= Math.ceil(tileOffsetX / tileSize - delta);
    }
    if (tileOffsetY > 0) {
        yStart -= Math.ceil(tileOffsetY / tileSize - delta);
    } else if (tileOffsetY < 0) {
        yEnd += Math.ceil(-tileOffsetY / tileSize - delta);
    }
    if (xStart === 0 && yStart === 0 && xEnd <= 1 && yEnd <= 1) {
        const tx = Math.floor(ax * scale);
        let ty = Math.floor(ay * scale);
        const skinY = ty;
        if (layerTileYScale !== aScaleY) {
            ty = getReverseY(tileConfig, ty, tileRes);
        }
        return [
            {
                x: tx,
                y: ty,
                skinY,
                z: bz,
                offset: layerOffset,
                tileSize,
                id: layerB['_getTileId'](tx, ty, bz)
            }
        ];
    }
    const result = [];
    for (let i = xStart; i < xEnd; i++) {
        for (let j = yStart; j < yEnd; j++) {
            const tx = ax * scale + i;
            let ty = ay * scale + j;
            const skinY = ty;
            if (layerTileYScale !== aScaleY) {
                ty = getReverseY(tileConfig, ty, tileRes);
            }
            result.push({
                x: tx,
                y: ty,
                skinY,
                z: bz,
                offset: layerOffset,
                tileSize,
                id: layerB['_getTileId'](tx, ty, bz)
            });
        }
    }
    return result;
}

// 地形瓦片与skin瓦片编号的scale
function getSkinTileScale(res, size, terrainRes, terrainSize) {
    let scale = res / terrainRes * terrainSize / size;
    if (scale < 1) {
        scale = 1 / scale;
        scale = 1 / Math.round(scale);
    } else {
        scale = Math.round(scale);
    }
    return scale;
}

function getSkinTileRes(sr, z, terrainRes) {
    const resAtZ = sr.getResolution(z);
    const zoom = z - Math.log(terrainRes / resAtZ) * Math.LOG2E;
    const myRes = sr.getResolution(zoom);
    return { zoom, res: myRes };
}

new maptalks.Point(0, 0);

// from Leaflet's GridLayer.js
function getReverseY(tileConfig, y, res) {
    const fullExtent = tileConfig.fullExtent;
    const tileSize = tileConfig.tileSize.width;
    const max = Math.max(fullExtent.top, fullExtent.bottom);
    const min = Math.min(fullExtent.top, fullExtent.bottom);
    const top = Math.ceil(max / tileSize / res) - 1;
    const bottom = Math.floor(min / tileSize / res);
    return (top - bottom) - y;
}

function createEmtpyTerrainHeights(height, size) {
    const length = size * size;
    const data = height !== 0 ? new Float32Array(length) : new Uint8Array(length);
    data.fill(height);
    return {
        data,
        width: size,
        height: size,
        max: height,
        min: height
    };
}

const emptyHeights = createEmtpyTerrainHeights(0, 5);
const EMPTY_TERRAIN_GEO =  createMartiniData(1, emptyHeights.data, emptyHeights.width, true);
EMPTY_TERRAIN_GEO.empty = true;

function fillIncludes(defines, uniformDeclares, context) {
    const includes = context && context.includes;
    if (includes) {
        for (const p in includes) {
            if (includes[p]) {
                if (context[p].uniformDeclares) {
                    uniformDeclares.push(...context[p].uniformDeclares);
                }
                if (context[p].defines) {
                    extend(defines, context[p].defines);
                }
            }
        }
    }
}

function setIncludeUniformValues(uniforms, context) {
    const includes = context && context.includes;
    if (includes) {
        for (const p in includes) {
            if (includes[p]) {
                if (context[p].renderUniforms) {
                    extend(uniforms, context[p].renderUniforms);
                }
            }
        }
    }
}

var context = /*#__PURE__*/Object.freeze({
    __proto__: null,
    fillIncludes: fillIncludes,
    setIncludeUniformValues: setIncludeUniformValues
});

var vert = "#define SHADER_NAME TERRAIN_MESH\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nuniform float minAltitude;\nuniform mat4 projViewModelMatrix;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform float heightScale;\nvarying vec2 vUv;\nuniform sampler2D flatMask;\n#include <common_pack_float>\n#include <mask_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\nvoid main() {\n  vec2 c = aTexCoord;\n  c.y = 1. - c.y;\n  vec4 d = texture2D(flatMask, c);\n  float e = aPosition.z;\n  if(length(d) < 2.) {\n    float f = decodeFloat32(d);\n    e = min(aPosition.z, f);\n  }\n  vec4 h = vec4(aPosition.xy, (e + minAltitude) * heightScale, 1.);\n  h = positionMatrix * h;\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(h, modelMatrix);\n#else\ngl_Position = projViewModelMatrix * h;\n#endif\nvUv = aTexCoord;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(h);\n#endif\n}";

var frag = "#define SHADER_NAME TERRAIN_MESH\nprecision mediump float;\nuniform sampler2D skin;\nuniform float polygonOpacity;\nuniform float layerOpacity;\nvarying vec2 vUv;\n#include <mask_frag>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\nvoid main() {\n  vec2 c = vec2(vUv);\n  c.y = 1. - c.y;\n  vec4 d = texture2D(skin, c);\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat e = shadow_computeShadow();\n  d.rgb = shadow_blend(d.rgb, e).rgb;\n#endif\ngl_FragColor = d * polygonOpacity * layerOpacity;\n#ifdef HAS_MASK_EXTENT\ngl_FragColor = setMask(gl_FragColor);\n#endif\n}";

const V3 = [];
const SCALE3 = [];

class TerrainPainter {
    constructor(layer) {
        this.layer = layer;
        const renderer = layer.getRenderer();
        this.device = renderer.regl || renderer.device;
        this.renderer = new Renderer(this.device);
        this._leafScene = new Scene();
        const pixels = new Uint8Array(16);
        pixels.fill(255);
        this._emptyTileTexture = this.device.texture({
            width: 2,
            height: 2,
            data: pixels
        });
        this._resLoader = new ResourceLoader(this._emptyTileTexture);
        this._createEmptyTerrainGeo();
    }

    setToRedraw() {
        this.layer.getRenderer().setToRedraw();
    }

    getMap() {
        return this.layer.getMap();
    }

    startFrame(context) {
        if (context && context.states && context.states.includesChanged) {
            this.shader.dispose();
            delete this.shader;
        }
        if (!this.shader) {
            this.initShader(context);
        }
        this._leafScene.clear();
    }

    createTerrainMesh(tileInfo, terrainImage) {
        const { mesh: terrainGeo, image: heightTexture } = terrainImage;
        let mesh = terrainImage.terrainMesh;
        const { positions, texcoords, triangles, empty } = terrainGeo;
        if (mesh && mesh.geometry !== this._emptyTerrainGeometry) {
            mesh.geometry.updateData('aPosition', positions);
            mesh.geometry.updateData('aTexCoord', texcoords);
            mesh.geometry.setElements(triangles);
            mesh.geometry.generateBuffers(this.device);
        } else {
            const geo = empty ?
                this._emptyTerrainGeometry :
                new Geometry({
                    aPosition: positions,
                    aTexCoord: texcoords
                },
                triangles,
                0);
            if (geo !== this._emptyTerrainGeometry) {
                geo.generateBuffers(this.device);
            }
            if (mesh) {
                mesh.geometry = geo;
            } else {
                mesh = new Mesh(geo, null, {
                    disableVAO: true
                });
            }
        }
        if (!mesh.uniforms.skin) {
            const emptyTexture = this.getEmptyTexture();
            mesh.setUniform('skin', emptyTexture);
        }
        if (!mesh.uniforms.flatMask) {
            const emptyTexture = this.getEmptyTexture();
            mesh.setUniform('flatMask', emptyTexture);
            mesh.setUniform('maskResolution', [emptyTexture.width, emptyTexture.height]);
        }

        mesh.setUniform('heightTexture', heightTexture);
        this.prepareMesh(mesh, tileInfo, terrainImage);
        return mesh;
    }

    _updateMaskDefines(mesh) {
        const renderer = this.layer.getRenderer();
        if (renderer) {
            renderer.updateMaskDefines(mesh);
        }
    }

    _getPositionMatrix(out) {
        const heightScale = this._getHeightScale();
        const positionMatrix = mat4.identity(out);
        mat4.scale(positionMatrix, positionMatrix, [1, 1, heightScale]);
        return positionMatrix;
    }

    _getHeightScale() {
        let exaggeration = this.layer.options.exaggeration;
        if (isNil$1(exaggeration)) {
            exaggeration = 1;
        }
        return this._getPointZ(100) / 100 * exaggeration;
    }

    _getLocalTransform(out, tileInfo, terrainWidth) {
        const map = this.getMap();
        const tileSize = this.layer.getTileSize().width;
        const scale = tileInfo.res / map.getGLRes();

        const terrainScale = tileSize / (terrainWidth - 1);

        const { extent2d, offset } = tileInfo;
        vec3.set(V3, (extent2d.xmin - offset[0]) * scale, (tileInfo.extent2d.ymax - offset[1]) * scale, 0);
        const localTransform = mat4.identity(out);
        mat4.translate(localTransform, localTransform, V3);

        vec3.set(SCALE3, scale * terrainScale, scale * terrainScale, 1);
        mat4.scale(localTransform, localTransform, SCALE3);
        return localTransform;
    }

    prepareMesh(mesh, tileInfo, terrainImage) {
        if (!mesh.isValid()) {
            return;
        }
        const { mesh: terrainGeo } = terrainImage;
        this._updateMaskDefines(mesh);
        const { triangles, numTrianglesWithoutSkirts, terrainWidth } = terrainGeo;
        mesh.localTransform = this._getLocalTransform(mesh.localTransform || [], tileInfo, terrainWidth);
        mesh.positionMatrix = this._getPositionMatrix(mesh.positionMatrix || []);
        mesh.properties.skirtOffset = numTrianglesWithoutSkirts * 3;
        mesh.properties.skirtCount = triangles.length - numTrianglesWithoutSkirts * 3;
        mesh.properties.z = tileInfo.z;
        mesh.properties.minHeight = terrainGeo.minHeight;
        mesh.properties.maxHeight = terrainGeo.maxHeight;
        mesh.properties.terrainWidth = terrainWidth;
        mesh.castShadow = false;
        if (!hasOwn(mesh.uniforms, 'minAltitude')) {
            // for empty terrain
            Object.defineProperty(mesh.uniforms, 'minAltitude', {
                enumerable: true,
                get: () => {
                    return terrainImage.minAltitude || 0;
                }
            });
        }
    }

    addTerrainImage(tileInfo, tileImage) {
        const mesh = tileImage.terrainMesh;
        if (mesh && mesh.geometry && tileImage.skin) {
            mesh.setUniform('skin', tileImage.skin.color[0]);
            const mask = tileImage.mask.color[0];
            mesh.setUniform('flatMask', mask);
            mesh.setUniform('maskResolution', [mask.width, mask.height]);
            mesh.setUniform('polygonOpacity', 1.0);
            // const { skirtOffset, skirtCount } = mesh.properties;
            // mesh.geometry.setDrawOffset(skirtOffset);
            // mesh.geometry.setDrawCount(skirtCount);
            this._leafScene.addMesh(mesh);
        }
    }

    endFrame(context$1) {
        this.updateIBLDefines(this.shader);
        let renderCount = 0;

        const uniforms = this.getUniformValues();

        const fbo = this._getRenderFBO(context$1);
        this.shader.filter = context$1 && context$1.sceneFilter;
        setIncludeUniformValues(uniforms, context$1);
        this._leafScene.getMeshes().forEach((mesh) => {
            this._updateMaskDefines(mesh);
        });
        renderCount += this.renderer.render(this.shader, uniforms, this._leafScene, fbo);
        return renderCount;
    }

    delete() {
        if (this.shader) {
            this.shader.dispose();
            delete this.shader;
        }
        if (this._emptyTileTexture) {
            this._emptyTileTexture.destroy();
            delete this._emptyTileTexture;
        }
        if (this._emptyTerrainGeometry) {
            this._emptyTerrainGeometry.dispose();
            delete this._emptyTerrainGeometry;
        }
    }

    deleteMesh(terrainMesh) {
        if (!terrainMesh) {
            return;
        }
        const geo = terrainMesh.geometry;
        terrainMesh.dispose();
        if (geo !== this._emptyTerrainGeometry) {
            geo.dispose();
        }
    }

    initShader(context$1) {
        const projViewModelMatrix = [], modelViewMatrix = [];
        const defines = {};
        const uniformDeclares = [];
        fillIncludes(defines, uniformDeclares, context$1);
        this.shader = new MeshShader({
            name: 'terrain-mesh',
            vert,
            frag,
            wgslVert: getWGSLSource('gl_terrain_vert'),
            wgslFrag: getWGSLSource('gl_terrain_frag'),
            uniforms: uniformDeclares.concat([
                {
                    name: 'modelViewMatrix',
                    type: 'function',
                    fn: function (context, props) {
                        return mat4.multiply(modelViewMatrix, props['viewMatrix'], props['modelMatrix']);
                    }
                },
                {
                    name: 'projViewModelMatrix',
                    type: 'function',
                    fn: function (context, props) {
                        return mat4.multiply(projViewModelMatrix, props['projViewMatrix'], props['modelMatrix']);
                    }
                }
            ]),
            defines,
            extraCommandProps: this.getExtraCommandProps()
        });
    }

    getExtraCommandProps() {
        const canvas = this.layer.getRenderer().canvas;
        const extraCommandProps = {
            viewport: {
                x : 0,
                y : 0,
                width : () => {
                    return canvas ? canvas.width : 1;
                },
                height : () => {
                    return canvas ? canvas.height : 1;
                }
            },
            cull: {
                enable: true,
                face: 'back'
            },
            depth: {
                enable: true,
                mask: () => {
                    const depthMask = this.layer.options['depthMask'];
                    return !!depthMask;
                },
                func: this.layer.options['depthFunc'] || '<='
                // func: (_, props) => {
                //     if (props['depthFunc']) {
                //         return props['depthFunc'];
                //     }
                //     return this.layer.options['depthFunc'] || '<=';
                // },
            },
            blend: {
                enable: true,
                func: { src: this.layer.options.blendSrc, dst: this.layer.options.blendDst },
                equation: 'add'
            },
        };
        return extraCommandProps;
    }

    _getRenderFBO(context) {
        //优先采用不aa的fbo
        return context && context.renderTarget && context.renderTarget.fbo;
    }

    getUniformValues() {
        const map = this.getMap();
        const projViewMatrix = map.projViewMatrix;
        const renderer = this.layer.getRenderer();
        const maskUniforms = renderer.getMaskUniforms();
        let layerOpacity = this.layer.options['opacity'];
        if (isNil$1(layerOpacity)) {
            layerOpacity = 1;
        }
        const uniforms = {
            viewMatrix: map.viewMatrix,
            projMatrix: map.projMatrix,
            projViewMatrix,
            heightScale: 1,
            layerOpacity
        };
        extend(uniforms, maskUniforms);
        return uniforms;
    }

    _getPointZ(height) {
        const map = this.layer.getMap();
        if (!map) {
            return null;
        }
        const altitude = map.altitudeToPoint(height, map.getGLRes());
        return altitude;
    }

    getEmptyTexture() {
        return this._emptyTileTexture;
    }

    hasIBL() {
        const lightManager = this.getMap().getLightManager();
        const resource = lightManager && lightManager.getAmbientResource();
        return !!resource;
    }

    updateIBLDefines(shader) {
        const shaderDefines = shader.shaderDefines;
        let updated = false;
        if (this.hasIBL()) {
            if (!shaderDefines[['HAS_IBL_LIGHTING']]) {
                shaderDefines['HAS_IBL_LIGHTING'] = 1;
                updated = true;
            }
        } else if (shaderDefines[['HAS_IBL_LIGHTING']]) {
            delete shaderDefines['HAS_IBL_LIGHTING'];
            updated = true;
        }
        if (updated) {
            shader.shaderDefines = shaderDefines;
        }
    }

    _createEmptyTerrainGeo() {
        const emptyTerrainGeo = EMPTY_TERRAIN_GEO;
        const { positions, texcoords, triangles } = emptyTerrainGeo;
        this._emptyTerrainGeometry = new Geometry({
            aPosition: positions,
            aTexCoord: texcoords
        },
        triangles,
        0);
        this._emptyTerrainGeometry.generateBuffers(this.device);
    }
}

// function terrainMeshCompare(m0, m1) {
//     return m1.properties.z - m0.properties.z;
// }

const { getIBLResOnCanvas, getPBRUniforms, loginIBLResOnCanvas, logoutIBLResOnCanvas } = pbr.PBRUtils;

const DEFAULT_MATERIAL = {
    baseColorFactor: [1, 1, 1, 1],
    emissiveFactor: [0, 0, 0],
    baseColorIntensity: 1,
    emitColorFactor: 1,
    roughnessFactor: 1,
    metallicFactor: 0,
    emitMultiplicative: 1,
    outputSRGB: 1,
    hsv: [0, 0, 0],
    contrast: 1,
    alphaTest: 0,
};

class TerrainLitPainter extends TerrainPainter {
    constructor(...args) {
        super(...args);
        this.createIBLTextures();
        this._matVer = 0;
    }

    updateMaterial(mat, matVer) {
        this._matVer = matVer;
        this._material = this._material || {};
        extend(this._material, mat);
        this.setToRedraw();
    }

    setMaterial(mat, matVer) {
        this._matVer = matVer;
        this._material = extend({}, DEFAULT_MATERIAL, mat);
        this.setToRedraw();
    }

    createIBLTextures() {
        const canvas = this.getMap().getRenderer().canvas;
        loginIBLResOnCanvas(canvas, this.device, this.getMap());
        this.layer.fire('iblupdated');
    }

    disposeIBLTextures() {
        const canvas = this.getMap().getRenderer().canvas;
        logoutIBLResOnCanvas(canvas, this.getMap());
    }

    createTerrainMesh(tileInfo, terrainImage) {
        const { mesh: terrainGeo, image: heightTexture } = terrainImage;
        const { positions, texcoords, triangles, leftSkirtIndex, rightSkirtIndex, bottomSkirtIndex, numVerticesWithoutSkirts, tangents } = terrainGeo;
        const normals = new Int8Array(positions.length);
        for (let i = 2; i < normals.length; i += 3) {
            if (i < numVerticesWithoutSkirts * 3) {
                normals[i] = 1;
            } else if (i < leftSkirtIndex / 2 * 3) {
                normals[i - 2] = -1;
            } else if (i < rightSkirtIndex / 2 * 3) {
                normals[i - 2] = 1;
            } else if (i < bottomSkirtIndex / 2 * 3) {
                normals[i - 1] = -1;
            } else {
                // top
                normals[i - 1] = 1;
            }
        }
        const geo = new Geometry({
            aPosition: positions,
            aTexCoord: texcoords,
            aNormal: normals
        }, triangles, 0);
        // 共用端点时，法线值会出现错误，造成视觉上不连续，所以需要唯一化
        // 唯一化后，三角形数量不变，但端点数组大概会膨胀5倍以上
        // geo.buildUniqueVertex();
        // geo.createNormal();
        geo.createTangent('aTangent', tangents);
        delete geo.data.aNormal;

        geo.generateBuffers(this.device);

        let terrainHeightTexture;
        if (heightTexture) {
            const isWebGPU = !!this.device.wgpu;
            terrainHeightTexture = this.device.texture({
                width: heightTexture.width,
                height: heightTexture.height,
                data: heightTexture,
                min: 'linear',
                mag: 'linear',
                flipY: isWebGPU
            });
        } else {
            terrainHeightTexture = this.getEmptyTexture();
        }

        const emptyTexture = this.getEmptyTexture();
        const matInfo = extend({}, DEFAULT_MATERIAL, this.layer.options['material'] || {});
        matInfo.skinTexture = emptyTexture;
        matInfo.terrainHeightTexture = terrainHeightTexture;
        const material = new pbr.StandardMaterial(matInfo);
        const mesh = new Mesh(geo, material);
        mesh.properties.matVer = this._matVer;
        if (!mesh.uniforms.flatMask) {
            const emptyTexture = this.getEmptyTexture();
            mesh.setUniform('flatMask', emptyTexture);
            mesh.setUniform('maskResolution', [emptyTexture.width, emptyTexture.height]);
        }
        const defines = mesh.defines;
        const isWebGPU = !!this.device.wgpu;
        defines['HAS_UV_FLIP'] = isWebGPU ? 0 : 1;
        defines['HAS_TERRAIN_NORMAL'] = 1;
        defines['HAS_MAP'] = 1;
        defines['HAS_LAYER_OPACITY'] = 1;
        defines['HAS_TERRAIN_FLAT_MASK'] = 1;
        mesh.defines = defines;
        // mesh.setUniform('terrainTileResolution', tileInfo.res);
        this.prepareMesh(mesh, tileInfo, terrainImage);
        return mesh;
    }

    addTerrainImage(tileInfo, tileImage) {
        const mesh = tileImage.terrainMesh;
        if (mesh) {
            if (this._material && mesh.properties.matVer !== this._matVer) {
                for (const p in this._material) {
                    mesh.material.set(p, this._material[p]);
                }
                mesh.properties.matVer = this._matVer;
            }
            if (tileImage.skin) {
                mesh.material.set('skinTexture', tileImage.skin.color[0]);
            }
            if (tileImage.mask) {
                const mask = tileImage.mask.color[0];
                mesh.setUniform('flatMask', mask);
                mesh.setUniform('maskResolution', [mask.width, mask.height]);
            }
            mesh.setUniform('polygonOpacity', 1.0);
            // const { skirtOffset, skirtCount } = mesh.properties;
            // mesh.geometry.setDrawOffset(skirtOffset);
            // mesh.geometry.setDrawCount(skirtCount);
            this._leafScene.addMesh(mesh);
        }
    }

    getUniformValues() {
        const map = this.getMap();
        // const layer = this.layer;
        const canvas = map.getRenderer().canvas;
        const { iblTexes, dfgLUT } = getIBLResOnCanvas(canvas);
        const uniforms = getPBRUniforms(map, iblTexes, dfgLUT);
        const tileSize = this.layer.getTileSize().width;
        const renderer = this.layer.getRenderer();
        const maskUniforms = renderer.getMaskUniforms();
        // const terrainHeightScale = this._getHeightScale();
        let layerOpacity = this.layer.options['opacity'];
        if (isNil$1(layerOpacity)) {
            layerOpacity = 1;
        }
        extend(uniforms, {
            viewMatrix: map.viewMatrix,
            projMatrix: map.projMatrix,
            projViewMatrix: map.projViewMatrix,
            outSize: [canvas.width, canvas.height],
            polygonFill: [1, 1, 1, 1],
            terrainHeightMapResolution: [tileSize, tileSize],
            terrainResolution: [canvas.width, canvas.height],
            // terrainHeightScale,
            terrainUnpackFactors: [6553.6, 25.6, 0.1, 10000.0],
            layerOpacity
        });
        extend(uniforms, maskUniforms);
        return uniforms;
    }


    initShader(context$1) {
        const defines = {};
        const uniformDeclares = [];
        fillIncludes(defines, uniformDeclares, context$1);
        this.shader = new pbr.StandardShader({
            uniforms: uniformDeclares,
            defines,
            extraCommandProps: this.getExtraCommandProps()
        });
    }

    delete() {
        this.disposeIBLTextures();
        return super.delete();
    }
}

function renderExtentMap(extent, projViewMatrix, ratio, minHeight) {
    const maskMeshes = getMaskMeshes.call(this, ratio, minHeight);
    this['_projViewMatrix'] = projViewMatrix;
    const { colorExtent, modeExtent } = this['_extentPass'].render(maskMeshes, projViewMatrix);
    this['_maskUniforms'] = this['_maskUniforms'] || {};
    this['_maskUniforms']['mask_colorExtent'] = colorExtent;
    this['_maskUniforms']['mask_extent'] = extent;
    this['_maskUniforms']['mask_modeExtent'] = modeExtent;
    this['_maskUniforms']['mask_hasFlatOut'] = hasOutMask.call(this, 'flat-outside');
    this['_maskUniforms']['mask_hasClipOut'] = hasOutMask.call(this, 'clip-outside');
    this['_maskUniforms']['mask_hasVideo'] = hasOutMask.call(this, 'video');
    this['_maskUniforms']['mask_heightRatio'] = ratio;
    this['_maskUniforms']['mask_heightOffset'] = minHeight;
    this.setToRedraw();
}

function getMaskMeshes(ratio, minHeight) {
    const meshes = [];
    const masks = this.layer.getMasks();
    for (let i = 0; i < masks.length; i++) {
        const mesh = masks[i].getMesh(this.regl, ratio, minHeight);
        if (mesh) {
            meshes.push(mesh);
        }
    }
    return meshes;
}

function updateVideoMask() {
    if (!this['_extentPass'] || !this['_maskUniforms']) {
        return;
    }
    const ratio = this['_maskUniforms']['mask_heightRatio'];
    const minHeight = this['_maskUniforms']['mask_heightOffset'];
    const maskMeshes = getMaskMeshes.call(this, ratio, minHeight);
    this['_extentPass'].render(maskMeshes, this['_projViewMatrix']);
    const masks = this.layer.getMasks();
    for (let i = 0; i < masks.length; i++) {
        if (masks[i]._update) {
            masks[i]._update();
        }
    }
}

function hasOutMask(outType) {
    const masks = this.layer.getMasks();
    for (let i = 0; i < masks.length; i++) {
        if (masks[i].getMode() === outType) {
            return 1;
        }
    }
    return 0;
}


function hasPlayingVideoMask() {
    const masks = this.layer.getMasks();
    if (!masks) {
        return false;
    }
    for (let i = 0; i < masks.length; i++) {
        if (masks[i]._needUpdate) {
            return masks[i]._needUpdate();
        }
    }
    return false;
}

function MaskRendererMixin (Base) {
    return class extends Base {
        setMask(extent, projViewMatrix, ratio, minHeight) {
            if (!this.viewport) {
                this.viewport = {
                    x : 0,
                    y : 0,
                    width : () => {
                        return this.canvas ? this.canvas.width : 1;
                    },
                    height : () => {
                        return this.canvas ? this.canvas.height : 1;
                    }
                };
            }
            if (!this['_extentPass']) {
                if (this.regl) {
                    this['_extentPass'] = new ExtentPass(this.regl, this.viewport);
                    renderExtentMap.call(this, extent, projViewMatrix, ratio, minHeight);
                } else {
                    this.layer.once('contextcreate', () => {
                        this['_extentPass'] = new ExtentPass(this.regl, this.viewport);
                        renderExtentMap.call(this, extent, projViewMatrix, ratio, minHeight);
                    }, this);
                }
            } else {
                renderExtentMap.call(this, extent, projViewMatrix, ratio, minHeight);
            }
        }

        needToRedraw() {
            if (super.needToRedraw()) {
                return true;
            }
            if (hasPlayingVideoMask.call(this)) {
                return true;
            }
            return false;
        }

        getMaskUniforms() {
            if (hasPlayingVideoMask.call(this)) {
                updateVideoMask.call(this);
            }
            this.layer.updateMaskExtent();
            return this['_maskUniforms'];
        }

        getMaskDefines() {
            if (!this['_maskDefines']) {
                this['_maskDefines'] = {};
            }
            if (this['_maskUniforms'] && this['_maskUniforms']['mask_colorExtent']) {
                this['_maskDefines']['HAS_MASK_EXTENT'] = 1;
            } else {
                delete this['_maskDefines']['HAS_MASK_EXTENT'];
            }
            return this._maskDefines;
        }

        updateMaskDefines(mesh) {
            const defines = mesh.getDefines();
            delete defines['HAS_MASK_EXTENT'];
            const maskDefines = this.getMaskDefines();
            extend(defines, maskDefines);
            mesh.setDefines(defines);
        }

        _clearMask() {
            this._deleteMaskUniforms();
            if (this._extentPass) {
                this._extentPass.dispose();
                delete this._extentPass;
            }
            this.setToRedraw();
        }

        _deleteMaskUniforms() {
            delete this._maskUniforms;
        }
    }
}

class LRUPool {
    constructor(max, onRemove) {
        this.max = max;
        this.onRemove = onRemove;
        this.reset();
    }

    reset() {
        if (this.data) {
            const values = this.data.values();
            for (const p of values) {
                this.onRemove(p);
            }
        }

        this.data = new Map();
        return this;
    }

    clear() {
        this.reset();
        delete this.onRemove;
    }

    add(key, data) {
        if (!data) {
            return this;
        }
        if (this.has(key)) {
            this.data.delete(key);
            this.data.set(key, data);
        } else {
            this.data.set(key, data);
        }

        return this;
    }

    keys() {
        const keys = new Array(this.data.size);
        let i = 0;
        const iterator = this.data.keys();
        for (const k of iterator) {
            keys[i++] = k;
        }
        return keys;
    }

    has(key) {
        return this.data.has(key);
    }

    getAndRemove(key) {
        if (!this.has(key)) { return null; }

        const data = this.data.get(key);
        this.data.delete(key);
        return data;
    }

    get(key) {
        if (!this.has(key)) { return null; }

        const data = this.data.get(key);
        return data;
    }

    pop() {
        if (this.data.size < this.max) {
            return null;
        }
        const first = this.data.keys().next();
        const data = this.data.get(first.value);
        if (data.current) {
            this.max += Math.ceil(this.max / 2);
            return null;
        }
        return this.getAndRemove(first.value);
    }

    remove(key) {
        if (!this.has(key)) { return this; }

        const data = this.data.get(key);
        this.data.delete(key);
        this.onRemove(data);

        return this;
    }

    resetCurrent(current) {
        if (!this.data) {
            return;
        }
        this.data.forEach(v => {
            v.current = current;
        });
    }
}

const { TileLayerRendererable: TileLayerRendererable$1, LayerAbstractRenderer: LayerAbstractRenderer$2 } = maptalks.renderer;

const POINT0$1 = new maptalks.Point(0, 0);
const POINT1 = new maptalks.Point(0, 0);
const TEMP_EXTENT = new maptalks.PointExtent(0, 0, 0, 0);
const TEMP_POINT$3 = new maptalks.Point(0, 0);

const TERRAIN_CLEAR = {
    color: [0, 0, 0, 0],
    depth: 1,
    stencil: 0
};

const TERRAIN_MASK_CLEAR = {
    color: [1, 1, 1, 1],
    depth: 0,
    stencil: 0
};

const SKIN_LEVEL_LIMIT = 1;

class TerrainLayerRenderer extends MaskRendererMixin(TileLayerRendererable$1(LayerAbstractRenderer$2)) {

    constructor(...args) {
        super(...args);
        this.init();
    }

    isDrawable() {
        return true;
    }

    getTempTileOnLoading(tileInfo, tile) {
        if (tile.image && !tile.image.reset) {
            return tile;
        }
        this._debugTile(tileInfo, 'getTempTileOnLoading');
        const tempTerrain = this._createTerrainFromParent(tileInfo);
        tempTerrain.temp = true;
        if (!tile.image) {
            tile.image = tempTerrain;
        }
        delete tile.image.reset;
        tile.current = true;
        tile.info = tileInfo;
        extend(tile.image, tempTerrain);
        this._createMesh(tile.image, tileInfo);
        return tile;
    }

    _resetTerrainImage(info, image, skinImagesToDel) {
        image.reset = true;
        delete image.data;
        delete image.loadTime;
        delete image.minAltitude;
        const refKey = info.id + '-temp';

        const skinImages = image.skinImages;
        if (skinImages) {
            for (let i = 0; i < skinImages.length; i++) {
                const cachedImages = skinImages[i];
                if (!cachedImages) {
                    continue;
                }
                for (let ii = 0; ii < cachedImages.length; ii++) {
                    const cached = cachedImages[ii];
                    if (!cached) {
                        continue;
                    }
                    cached.refs.delete(refKey);
                    if (!cached.refs.size) {
                        skinImagesToDel.push(cached);
                    }
                }
                delete cachedImages.currentSkins;
                delete cachedImages.tileIds;
            }
        }
        delete image.sourceZoom;
        delete image.skinImages;
        delete image.skinStatus;
        delete image.skinTileIds;
        if (image.debugTexture) {
            // need to rewrite debug text
            image.debugTexture.destroy();
            delete image.debugTexture;
        }
    }

    _createTerrainFromParent(tile, parentTile) {
        parentTile = parentTile || this.findParentTile(tile);
        while (parentTile && parentTile.image && (parentTile.image.sourceZoom === -1 || parentTile.image.originalError)) {
            parentTile = this.findParentTile(parentTile.info);
        }
        const res = tile.res;
        const error = this.getMap().pointAtResToDistance(1, 1, res);
        const heights = parentTile && parentTile.image && parentTile.image.data && this._clipParentTerrain(parentTile, tile);
        const sourceZoom = heights && parentTile.image.sourceZoom !== -1 ? parentTile.info.z : -1;
        if (!heights || heights.width <= 1) {
            // find sibling tile's minAltitude
            const minAltitude = this._findTileMinAltitude(tile, parentTile);
            return { data: createEmtpyTerrainHeights(minAltitude || 0, 5), minAltitude, mesh: EMPTY_TERRAIN_GEO, sourceZoom };
        }
        const terrainWidth = heights.width;
        const errorScale = this.layer._getErrorScale();
        const hasSkirts = this.layer.options['hasSkirts'];
        const mesh = createMartiniData(error * errorScale, heights.data, terrainWidth, hasSkirts);

        return { data: heights, mesh, sourceZoom, colorsTexture: heights.colorsTexture };
    }

    _findTileMinAltitude(tile, parentTile) {
        if (parentTile && parentTile.minAltitude) {
            return parentTile.minAltitude;
        }
        const { idx, idy, z } = tile;
        for (let i = -1; i <= 1; i++) {
            for (let j = -1; j <= 1; j++) {
                if (i === 0 && j === 0) {
                    continue;
                }
                const id = this.layer.getTileId(idx + i, idy + j, z);
                const tileInfoCache = this.layer.tileInfoCache;
                const info = tileInfoCache && tileInfoCache.get(id);
                if (info && info.minAltitude) {
                    return info.minAltitude;
                }
            }
        }
        return 0;
    }

    consumeTile(tileImage, tileInfo) {
        this._debugTile(tileInfo, 'consumeTile');
        if (tileImage.empty && !tileImage.mesh) {
            const parentTile = this.findParentTile(tileInfo);
            if (!parentTile || parentTile.image && parentTile.image.empty) {
                tileImage.mesh = EMPTY_TERRAIN_GEO;
                const minAltitude = this._findTileMinAltitude(tileInfo);
                tileImage.data = createEmtpyTerrainHeights(minAltitude || 0, 5);
                tileImage.minAltitude = minAltitude;
                tileImage.sourceZoom = -1;
            } else {
                tileImage = this._createTerrainFromParent(tileInfo, parentTile);
                wrapTileColorsTexture(tileInfo, tileImage);
            }
        }
        this._createMesh(tileImage, tileInfo);
        super.consumeTile(tileImage, tileInfo);
        this._recenterMapOnTerrain(tileInfo);
    }

    _createMesh(tileImage, tileInfo) {
        if (tileImage && tileImage.mesh) {
            // console.log(tileImage,tileInfo);
            tileImage.terrainMesh = this._painter.createTerrainMesh(tileInfo, tileImage);
            tileInfo.minAltitude = tileImage.data.min;
            tileInfo.maxAltitude = tileImage.data.max;
            delete tileImage.mesh;
            const tileInfoCache = this.layer.tileInfoCache;
            if (tileInfoCache && tileInfo.parent && !tileImage.empty && !tileImage.temp) {
                const parentNode = tileInfoCache.get(tileInfo.parent);
                if (parentNode) {
                    const { minAltitude, maxAltitude } = tileInfo;
                    if (parentNode.minAltitude === undefined || parentNode.minAltitude > minAltitude) {
                        parentNode.minAltitude = minAltitude;
                    }
                    if (parentNode.maxAltitude === undefined || parentNode.maxAltitude < maxAltitude) {
                        parentNode.maxAltitude = maxAltitude;
                    }
                }
            }
        }
    }

    _recenterMapOnTerrain(tileInfo) {
        const map = this.getMap();
        if (map.updateCenterAltitude && map.centerAltitude === undefined && tileInfo.z === this.getCurrentTileZoom()) {
            const prjCenter = map['_getPrjCenter']();
            const centerPoint = map['_prjToPointAtRes'](prjCenter, tileInfo.res, TEMP_POINT$3);
            if (tileInfo.extent2d.contains(centerPoint)) {
                map.updateCenterAltitude();
            }
        }
    }

    draw(timestamp, parentContext) {
        this._createPainter();
        this._painter.startFrame(parentContext);
        super.draw(timestamp, parentContext);
        this._endFrame(parentContext);
    }

    drawTile(tileInfo, tileImage) {
        const map = this.getMap();
        if (!tileInfo || !map || !tileImage) {
            return;
        }
        if (!this.drawingCurrentTiles && !this.drawingChildTiles) {
            return;
        }
        this._debugTile(tileInfo, 'drawTile');
        let opacity = this.drawingCurrentTiles ? this.getTileOpacity(tileImage) : 1;
        opacity *= (this.layer.options.opacity || 1);
        this._painter.addTerrainImage(tileInfo, tileImage, opacity);
    }

    _drawTiles(tiles, parentTiles, childTiles, placeholders, context, missedTiles, incompleteTiles) {
        const skinImagesToDel = [];
        this._newTerrainTileCounter = 0;
        const skinCount = this.layer.getSkinCount();
        const visitedSkinTiles = new Set();
        if (incompleteTiles && incompleteTiles.length) {
            pushIn(missedTiles, incompleteTiles.map(t => t.info));
            for (let i = 0; i < skinCount; i++) {
                this._renderChildTerrainSkin(i, incompleteTiles, visitedSkinTiles, skinImagesToDel);
            }
        }
        //TODO tiles中如果存在empty瓦片，且sourceZoom精度不够的，可以重新切分精度更高的数据
        const tempTiles = this._getTempTilesForMissed(missedTiles, skinImagesToDel);
        pushIn(tiles, tempTiles);
        // this._tempTilesPool.shrink();

        // 集中对每个SkinLayer调用renderTerrainSkin，减少 program 的切换开销
        this._debugTile(tiles, 'drawTiles');
        for (let i = 0; i < skinCount; i++) {
            this._renderChildTerrainSkin(i, tiles, visitedSkinTiles, skinImagesToDel);
        }

        for (let i = 0; i < tiles.length; i++) {
            this._renderTerrainMeshSkin(tiles[i].info, tiles[i].image);
        }

        for (let i = 0; i < skinImagesToDel.length; i++) {
            if (skinImagesToDel[i]) {
                if (skinImagesToDel[i].texture && !skinImagesToDel[i].refs.size) {
                    this._skinImageCache.delete(skinImagesToDel[i].tile.id);
                    this._deleteSkinImage(skinImagesToDel[i]);
                }
            }
        }

        this._clearCachdeSkinImages();
        return super._drawTiles(...arguments);
    }

    _getTempTilesForMissed(missedTiles, skinImagesToDel) {
        const tempTiles = [];
        let pool = this._tempTilesPool;
        if (!pool) {
            pool = this._tempTilesPool = new LRUPool(this.layer.options['tempTileCacheSize'], tile => {
                const { info, image } = tile;
                this._deleteTerrainImage(info, image);
            });
        }
        pool.resetCurrent(false);

        for (let i = 0; i < missedTiles.length; i++) {
            const tileInfo = missedTiles[i];
            this._debugTile(tileInfo, 'getTempTilesForMissed');
            let tile;
            if (pool.has(tileInfo.id)) {
                tile = pool.getAndRemove(tileInfo.id);
            } else {
                tile = pool.pop();
                if (!tile) {
                    tile = { info: tileInfo };
                } else if (tile.image) {
                    this._resetTerrainImage(tile.info, tile.image, skinImagesToDel);
                    tile.image.temp = true;
                }
            }
            tile.current = true;
            pool.add(tileInfo.id, tile);
            tempTiles.push(tile);
        }

        for (let i = 0; i < missedTiles.length; i++) {
            this.getTempTileOnLoading(missedTiles[i], tempTiles[i]);
        }
        return tempTiles;
    }

    _forEachCachedTile(fn) {
        for (const tile of this.tileCache.data.values()) {
            fn(tile);
        }

        for (const p in this.tilesInView) {
            const tile = this.tilesInView[p];
            fn(tile);
        }

        if (this._tempTilesPool) {
            for (const tile of this._tempTilesPool.data.values()) {
                fn(tile);
            }
        }
    }

    _clearCachdeSkinImages() {
        if (!this._skinImageCache) {
            return;
        }
        // 每十秒对skinImageCache做一次统一的排查回收，将没人引用的图片删除掉
        // 虽然流程中尽量做了删除，但skinImageCache中仍会出现没人引用的冗余image对象
        // 因为排查困难，且未来的逻辑修改可能会带来新的内存泄露，采用该机制至少能彻底防止skinImageCache中的
        const currentTimestamp = this.getCurrentTimestamp();
        if (this._clearSkinImageTimestamp && currentTimestamp - this._clearSkinImageTimestamp < 1000) {
            return;
        }
        const currentImages = new Set();
        this._forEachCachedTile(tile => {
            this._collectSkinImages(tile, currentImages);
        });


        if (!currentImages.size) {
            return;
        }

        this._skinImageCache.forEach((v, id) => {
            if (!currentImages.has(id)) {
                console.log('deleted:', id);
                this._deleteSkinImage(this._skinImageCache.get(id));
                this._skinImageCache.delete(id);
            }
        });
        this._clearSkinImageTimestamp = currentTimestamp;
    }

    _collectSkinImages(tile, currentImages) {
        const skinImages = tile.image && tile.image.skinImages;
        if (!skinImages || !skinImages.length) {
            return;
        }
        for (let i = 0; i < skinImages.length; i++) {
            const currentSkins = skinImages[i] && skinImages.currentSkins;
            if (currentSkins) {
                for (const tileId of currentSkins) {
                    currentImages.add(tileId);
                }
            }
        }

    }

    _renderChildTerrainSkin(skinIndex, terrainTiles, visitedSkinTiles, skinImagesToDel) {
        const skinLayer = this.layer.getSkinLayer(skinIndex);
        const renderer = skinLayer.getRenderer();
        if (!renderer) {
            return;
        }
        const id = skinLayer.getId();
        const layerSkinImages = [];
        for (let i = 0; i < terrainTiles.length; i++) {
            const { info, image } = terrainTiles[i];
            this._prepareMask(info, image);
            this._debugTile(info, 'renderChildTerrainSkin');
            if (this._prepareChildTerrainSkin(id, info, image, skinImagesToDel)) {
                const skinImages = image.skinImages[id];
                for (let j = 0; j < skinImages.length; j++) {
                    const tileId = skinImages[j].tile.info.id;

                    // 检查是否存在重复的瓦片，重复的瓦片只需要绘制一次
                    if (!visitedSkinTiles.has(tileId)) {
                        skinImages[j].terrainMaskFBO = image.mask;
                        layerSkinImages.push(skinImages[j]);
                        visitedSkinTiles.add(tileId);
                    }
                }
            }
        }
        // render terrain skin of skin layer
        renderer.renderTerrainSkin(this.device, this.layer, layerSkinImages);
    }

    _prepareMask(terrainTileInfo, tileImage) {
        if (!tileImage.mask) {
            tileImage.mask = this._createTerrainMaskTexture(terrainTileInfo, tileImage);
            tileImage.mask.id = terrainTileInfo.id;
        }
    }

    _clearMask(maskFBO) {
        TERRAIN_MASK_CLEAR.framebuffer = maskFBO;
        this.device.clear(TERRAIN_MASK_CLEAR);
    }

    _prepareChildTerrainSkin(skinLayerId, terrainTileInfo, terrainTileImage, skinImagesToDel) {
        const map = this.getMap();
        delete terrainTileImage.path;
        if (!terrainTileInfo || !map || !terrainTileImage) {
            return false;
        }
        const mesh = terrainTileImage.terrainMesh;
        if (!mesh) {
            return false;
        }
        const skinLayer = this.layer.getSkinLayerById(skinLayerId);
        const renderer = skinLayer.getRenderer();
        if (!renderer) {
            return false;
        }
        if (!terrainTileImage.skinImages) {
            // if (map.isInteracting()) {
            //     const limit = this.layer.options['newTerrainTileRenderLimitPerFrameOnInteracting'];
            //     if (limit > 0 && this._newTerrainTileCounter > limit) {
            //         return false;
            //     }
            // }
            terrainTileImage.skinImages = {};
        }
        if (!terrainTileImage.skinStatus) {
            terrainTileImage.skinStatus = {};
        }
        if (!terrainTileImage.skinTileIds) {
            terrainTileImage.skinTileIds = {};
        }
        const isInDebug = this.layer.options['debug'];

        const isAnimating = renderer.isAnimating && renderer.isAnimating();

        let isSameVersion = true;
        const skinImages = terrainTileImage.skinImages[skinLayerId] || [];
        for (let i = 0; i < skinImages.length; i++) {
            if (skinImages[i].version !== renderer.version) {
                isSameVersion = false;
                terrainTileImage.skinStatus[skinLayerId] = 0;
                break;
            }
        }
        const status = terrainTileImage.skinStatus[skinLayerId];

        const isLayerAskToRefresh = renderer.needToRefreshTerrainTileOnZooming && renderer.needToRefreshTerrainTileOnZooming();
        const needRefreshTerrainTile = isAnimating || isLayerAskToRefresh && terrainTileImage.renderedZoom !== map.getZoom();
        if (!isInDebug && status && !needRefreshTerrainTile) {
            return false;
        }
        const sr = skinLayer.getSpatialReference();
        const { x, y, z, res, offset } = terrainTileInfo;
        let nw = terrainTileInfo.nw;
        if (!nw) {
            nw = terrainTileInfo.nw = this.getMap().pointAtResToCoord(terrainTileInfo.extent2d.getMin(POINT0$1), terrainTileInfo.res);
        }
        const tileSize = this.layer.getTileSize().width;
        // const zoom = this.getCurrentTileZoom();
        let { res: myRes, zoom } = getSkinTileRes(sr, z, res);

        const myTileSize = skinLayer.getTileSize().width;

        let scale = getSkinTileScale(myRes, myTileSize, res, tileSize);

        let skinTileIds = terrainTileImage.skinTileIds[skinLayerId];
        if (!skinTileIds) {
            const terrainTileScaleY = this.layer['_getTileConfig']().tileSystem.scale.y;
            const maxAvailableZoom = skinLayer.options.maxAvailableZoom;
            if (!isNil$1(maxAvailableZoom) && maxAvailableZoom >= 0 && zoom > maxAvailableZoom) {
                scale *= Math.pow(2, maxAvailableZoom - zoom);
                zoom = maxAvailableZoom;
            }
            skinTileIds = terrainTileImage.skinTileIds[skinLayerId] = getCascadeTileIds(skinLayer, x, y, zoom, nw, offset, terrainTileScaleY, scale, SKIN_LEVEL_LIMIT);
        }
        const level0 = skinTileIds['0'];
        let complete = true;
        const tiles = [];
        for (let i = 0; i < level0.length; i++) {
            const cachedTile = renderer.getCachedTile(level0[i], false);
            if (!cachedTile) {
                complete = false;
                const parentTile = renderer.findParentTile(level0[i]);
                if (parentTile) {
                    tiles.push(parentTile);
                }
                continue;
            }
            // if (!cachedTile.info.terrainTileInfos) {
            //     // 预先存好terrain的tileIndex，vt图层中查询高程时，无需再单独计算
            //     cachedTile.info.terrainTileInfos = [];
            // }
            // if (cachedTile.info.terrainTileInfos.indexOf(terrainTileInfo) < 0) {
            //     cachedTile.info.terrainTileInfos.push(terrainTileInfo);
            // }
            tiles.push(cachedTile);
        }

        skinImages.currentSkins = skinImages.currentSkins || new Set();
        const prevSkins = new Set();
        let skinImageRetired = false;
        for (let i = 0; i < skinImages.length; i++) {
            if (!skinImages[i].tile) {
                skinImageRetired = true;
                continue;
            }
            const id = skinImages[i].tile.info.id;
            prevSkins.add(id);
        }
        if (!tiles.length) {
            skinImages.currentSkins.clear();
            terrainTileImage.skinImages[skinLayerId] = [];
            // this._clearPrevSkinImages(terrainTileInfo, terrainTileImage, prevSkins, null, skinImagesToDel);
            return false;

        }

        const ids = tiles.map(t => t.info.id).join();
        if (isSameVersion && !isInDebug && !needRefreshTerrainTile && !skinImageRetired && skinImages.tileIds === ids) {
            return false;
        }
        skinImages.tileIds = ids;
        let updated = false;
        // if (skinImages.length < tiles.length) {
        skinImages.currentSkins.clear();
        skinImages.length = 0;
        const currentSkins = skinImages.currentSkins;
        let refKey = terrainTileInfo.id;
        if (terrainTileImage.temp) {
            refKey += '-temp';
        }

        // 为每个 skin tile 创建一个 skin texture
        // 当 skin tile 范围比 terrain tile 更大时，每个 skin tile 只需绘制一次
        for (let i = 0; i < tiles.length; i++) {
            const tileId = tiles[i].info.id;
            currentSkins.add(tileId);
            let cached = this._getCachedSkinImage(tileId);
            if (!cached || !isValidSkinImage(cached)) {
                cached = {
                    layer: skinLayer,
                    refs: new Set(),
                    texture: renderer.createTerrainTexture(this.device)
                };
                this._saveCachedSkinImage(tileId, cached);
            }
            cached.tile = extend({}, tiles[i]),
            cached.refs.add(refKey);
            cached.version = renderer.version;
            skinImages.push(cached);
            updated = true;
        }

        this._clearPrevSkinImages(terrainTileInfo, terrainTileImage, prevSkins, currentSkins, skinImagesToDel);

        // }
        if (updated) {
            this._newTerrainTileCounter++;
        }
        terrainTileImage.skinImages[skinLayerId] = skinImages;

        skinLayer.fire('renderterrainskin', { tile: terrainTileInfo, skinTiles: tiles });
        if (complete) {
            terrainTileImage.skinStatus[skinLayerId] = 1;
            // save some memory
            // if (!needRefresh) {
            //     terrainTileImage.skinTileIds = [];
            //     terrainTileImage.skinImages[skinIndex] = null;
            // }
        }
        return true;
    }

    _clearPrevSkinImages(terrainTileInfo, tileImage, prevSkins, currentSkins, skinImagesToDel) {
        if (!prevSkins.size) {
            return;
        }
        let refKey = terrainTileInfo.id;
        if (tileImage.temp) {
            refKey += '-temp';
        }
        for (const tileId of prevSkins) {
            if (!currentSkins || !currentSkins.has(tileId)) {
                const cached = this._getCachedSkinImage(tileId);
                this._deleteCachedSkinImage(cached, refKey, skinImagesToDel);
            }
        }
    }

    _getCachedSkinImage(id) {
        if (!this._skinImageCache) {
            this._skinImageCache = new Map();
        }
        return this._skinImageCache.get(id);
    }

    _saveCachedSkinImage(id, cached) {
        // console.log(this._skinImageCache.size);
        this._skinImageCache.set(id, cached);
    }


    _renderTerrainMeshSkin(terrainTileInfo, terrainTileImage) {
        // render a terrain tile's skin
        const map = this.getMap();
        if (!terrainTileInfo || !map || !terrainTileImage) {
            return;
        }
        this._debugTile(terrainTileInfo, '_renderTerrainMeshSkin');
        // if (!skinImages) {
        //     return;
        // }
        const isSkinReady = this._isSkinReady(terrainTileImage);
        if (!isSkinReady) {
            delete terrainTileImage.renderedZoom;
        }
        const needRefreshSkins = this._needRefreshTerrainSkins(terrainTileImage.renderedZoom);
        if (!needRefreshSkins) {
            return;
        }
        if (!terrainTileImage.skin) {
            terrainTileImage.skin = this._createTerrainSkinTexture(terrainTileInfo, terrainTileImage);
            this._prepareMask(terrainTileInfo, terrainTileImage);
        } else {
            TERRAIN_CLEAR.framebuffer = terrainTileImage.skin;
            this.device.clear(TERRAIN_CLEAR);
        }
        this._initSkinShader();
        const enableDebug = this.layer.options.debug;
        const meshes = [];
        const debugMeshes = enableDebug && [];

        const tileSize = this.layer.getTileSize().width;
        const skinImages = terrainTileImage.skinImages;
        if (skinImages) {
            const isWebGPU = !!this.device.wgpu;
            const skinLayers = this.layer.getSkinLayers();
            for (let i = 0; i < skinLayers.length; i++) {
                const id = skinLayers[i].getId();
                const layerSkinImages = skinImages[id];
                if (!layerSkinImages || !layerSkinImages.length) {
                    continue;
                }
                for (let ii = 0; ii < layerSkinImages.length; ii++) {
                    const { tile, texture, layer } = layerSkinImages[ii];
                    const hasOffset = (tile.info.offset[0] || tile.info.offset[1]);
                    if (hasOffset && terrainTileInfo.skinTileIds) {
                        const skinTileIds = terrainTileInfo.skinTileIds[layer.getId()];
                        for (let j = 0; j < skinTileIds.length; j++) {
                            if (tile.info.x === skinTileIds[j].x && tile.info.y === skinTileIds[j].y) {
                                tile.info.offset = skinTileIds[j].offset;
                                break;
                            }
                        }

                    }

                    const mesh = layerSkinImages[ii].skinMesh || new Mesh(this._skinGeometry);

                    // 如果不是FBO，WebGPU 上的 texture 本身需要上下翻转，位置也需要上下调整
                    const isFBO = checkIfFBO(texture);
                    const skinDim = computeSkinDimension(terrainTileInfo, tile, tileSize, isFBO, isWebGPU);
                    if (!isFBO) {
                        mesh.setUniform('flipY', 1);
                    } else {
                        mesh.setUniform('flipY', 0);
                    }

                    mesh.setUniform('skinTexture', texture);
                    const skinTileOpacity = layer.getOpacity();
                    mesh.setUniform('opacity', isNil$1(skinTileOpacity) ? 1 : skinTileOpacity);
                    mesh.setUniform('skinDim', skinDim);
                    mesh.setUniform('tileSize', tileSize);
                    mesh.setUniform('x', terrainTileInfo.x);
                    mesh.setUniform('y', terrainTileInfo.y);
                    layerSkinImages[ii].skinMesh = mesh;
                    meshes.push(mesh);

                }
            }
        }
        if (enableDebug) {
            const debugMesh = terrainTileImage.skinDebugMesh || new Mesh(this._skinGeometry);
            debugMesh.setUniform('tileSize', tileSize);
            const debugTexture = terrainTileImage.debugTexture || this._createDebugTexture(terrainTileInfo, tileSize, terrainTileImage.temp);
            terrainTileImage.debugTexture = debugTexture;
            terrainTileImage.skinDebugMesh = debugMesh;
            debugMesh.setUniform('flipY', 1);
            debugMesh.setUniform('opacity', 1);
            debugMesh.setUniform('skinTexture', debugTexture);
            debugMesh.setUniform('skinDim', [0, 0, 1]);
            debugMesh.setUniform('tileSize', tileSize);
            debugMeshes.push(debugMesh);
        }
        if (meshes.length) {
            this._skinScene.setMeshes(meshes);
            try {
                this.renderer.render(this._skinShader, null, this._skinScene, terrainTileImage.skin);
            } catch (err) {
                console.error(terrainTileImage);
                throw err;
            }

        }

        if (debugMeshes && debugMeshes.length && this.layer.options.debug) {
            this._skinScene.setMeshes(debugMeshes);
            this.renderer.render(this._skinShader, null, this._skinScene, terrainTileImage.skin);
        }
        if (isSkinReady) {
            terrainTileImage.renderedZoom = map.getZoom();
        }
    }

    _createDebugTexture(tileInfo, tileSize, isTemp) {
        tileSize *= 2;

        const { x, y, z } = tileInfo;
        const debugInfo = `terrain:${x}/${y}/${z}` + (isTemp ? '-temp' : '');

        const canvas = document.createElement('canvas');
        canvas.width = tileSize;
        canvas.height = tileSize;
        const ctx = canvas.getContext('2d');
        ctx.font = '60px monospace';

        const color = this.layer.options['debugOutline'];
        ctx.fillStyle = color;
        ctx.strokeStyle = color;
        ctx.fillText(debugInfo, 20, tileSize - 40);
        ctx.beginPath();
        ctx.lineWidth = 4;
        ctx.moveTo(0, 0);
        ctx.lineTo(tileSize, 0);
        ctx.lineTo(tileSize, tileSize);
        ctx.lineTo(0, tileSize);
        ctx.lineTo(0, 0);
        ctx.stroke();

        return this.device.texture({
            data: canvas,
            flipY: true,
            mag: 'linear',
            min: 'linear'
        });
    }

    _createTerrainMaskTexture() {
        const regl = this.device;
        const tileSize = this.layer.getTileSize().width;
        const width = tileSize / 2;
        const height = tileSize / 2;
        const color = regl.texture({
            // min 和 mag 必须用nearest，选择别的值会造成mask的高程值发生错误
            min: 'nearest',
            mag: 'nearest',
            type: 'uint8',
            format: 'rgba',
            width,
            height
        });
        if (!this._terrainMaskDepthStencil) {
            this._terrainMaskDepthStencil = regl.texture({
                width,
                height,
                format: 'depth stencil'
            });
        }
        const fboInfo = {
            width,
            height,
            colors: [color],
            // stencil: true,
            // colorCount,
            colorFormat: 'rgba',
            ignoreStatusCheck: true
        };
        fboInfo.depthStencil = this._terrainMaskDepthStencil;
        const texture = regl.framebuffer(fboInfo);
        texture.colorTex = color;
        this._clearMask(texture);
        texture.clearTerrainMask = () => {
            if (!texture._timestamp) {
                texture._timestamp = 0;
            }
            const timestamp = this.getFrameTimestamp();
            if (timestamp > texture._timestamp) {
                TERRAIN_MASK_CLEAR.framebuffer = texture;
                regl.clear(TERRAIN_MASK_CLEAR);
                texture._timestamp = timestamp;
            }
        };
        // 单独创建的 color 必须要手动destroy回收，光destroy framebuffer，color是不会销毁的
        return texture;
    }

    _createTerrainSkinTexture(tileInfo/*, tileImage*/) {
        const tileSize = this.layer.getTileSize().width;
        // 乘以2是为了瓦片（缩放时）被放大后保持清晰度
        let width = tileSize * 2;
        let height = tileSize * 2;
        const regl = this.device;
        const colorsTexture = tileInfo.colorsTexture;
        let color;
        if (maptalks.Util.isImageBitMap(colorsTexture) && colorsTexture.width > 0) {
            //不同的打包环境下，framebuffer 的大小和texture不同的，有的报错，有的不报错，why? 我也不知道
            //确保framebuffer 的大小和texture相同
            width = colorsTexture.width;
            height = colorsTexture.height;
            color = regl.texture({
                data: colorsTexture,
                min: 'linear',
                mag: 'linear',
                type: 'uint8',
                width,
                height,
                flipY: true
            });
        } else {
            color = regl.texture({
                min: 'linear',
                mag: 'linear',
                type: 'uint8',
                width,
                height,
                flipY: true
            });
        }
        const fboInfo = {
            width,
            height,
            colors: [color],
            // stencil: true,
            // colorCount,
            colorFormat: 'rgba',
            ignoreStatusCheck: true,
            depthStencil: false,
            depth: false,
            stencil: false
        };
        const texture = regl.framebuffer(fboInfo);
        texture.colorTex = color;
        return texture;
    }

    _endFrame(context) {
        const renderCount = this._painter.endFrame(context);
        if (renderCount && !Object.keys(this.tilesLoading).length) {
            this.layer.fire('terrainreadyandrender');
        }
    }

    _clipParentTerrain(parentTile, tile) {
        const { image, info } = parentTile;
        const terrainData = image.data;
        const terrainWidth = terrainData.width;
        const { extent2d: parentExtent, res: parentRes } = info;
        const { extent2d, res } = tile;
        const width = parentExtent.getWidth();
        const height = parentExtent.getHeight();
        let xmin = (extent2d.xmin * res / parentRes - parentExtent.xmin) / width * (terrainWidth - 1);
        let ymin = (parentExtent.ymax - extent2d.ymax * res / parentRes) / height * (terrainWidth - 1);
        const xmax = (extent2d.xmax * res / parentRes - parentExtent.xmin) / width * (terrainWidth - 1);

        let tileWidth = Math.round(xmax - xmin);
        const log = Math.log2(tileWidth);
        tileWidth = Math.pow(2, Math.round(log)) + 1;
        xmin = Math.floor(xmin);
        ymin = Math.floor(ymin);

        let colorsTexture;
        //parent tile has colorstexture
        if (info.colorsTexture) {
            const { width, height } = info.colorsTexture;
            if (width * height > 0) {
                const x1 = info.extent2d.xmin;
                const x2 = info.extent2d.xmax;
                const y1 = info.extent2d.ymin;
                const y2 = info.extent2d.ymax;
                const ax = (width) / (x2 - x1), ay = height / (y2 - y1);
                const minx = (extent2d.xmin * res / parentRes - parentExtent.xmin) * ax;
                const maxx = (extent2d.xmax * res / parentRes - parentExtent.xmin) * ax;
                const miny = (extent2d.ymin * res / parentRes - parentExtent.ymin) * ay;
                const maxy = (extent2d.ymax * res / parentRes - parentExtent.ymin) * ay;
                //clip texture from parent tile texture
                colorsTexture = clipTileTexture(info.colorsTexture, minx, miny, maxx, maxy);
            }


        }

        // const tileSize = tileWidth - 1;
        // if (tileSize & (tileSize - 1)) {
        //     debugger
        // }
        // 先行再列
        const heights = new Float32Array(tileWidth * tileWidth);
        let min = Infinity;
        let max = -Infinity;
        for (let i = 0; i < tileWidth; i++) {
            for (let j = 0; j < tileWidth; j++) {
                let x = i + xmin;
                let y = j + ymin;
                if (x > terrainWidth - 1) {
                    x = terrainWidth - 1;
                } else if (x < 0) {
                    x = 0;
                }
                if (y > terrainWidth - 1) {
                    y = terrainWidth - 1;
                } else if (y < 0) {
                    y = 0;
                }
                const height = terrainData.data[x + y * terrainWidth];
                // if (height === undefined) {
                //     debugger
                // }
                heights[i + j * tileWidth] = height;
                if (height < min) {
                    min = height;
                }
                if (height > max) {
                    max = height;
                }
            }
        }

        return {
            width: tileWidth,
            height: tileWidth,
            data: heights,
            min,
            max,
            colorsTexture
        };
    }

    getTileOpacity(tileImage) {
        if (!this._isSkinReady(tileImage)) {
            this.resetTileLoadTime(tileImage);
            return 0;
        }
        return super.getTileOpacity(tileImage);
    }

    _isSkinReady(tileImage) {
        const skinCount = this.layer.getSkinCount();
        if (!skinCount) {
            return true;
        }
        if (!tileImage.skinStatus) {
            // 还没有初始化
            return false;
        }
        for (let i = 0; i < skinCount; i++) {
            if (!tileImage.skinStatus[i]) {
                return false;
            }
        }
        return true;
    }

    _needRefreshTerrainSkins(renderedZoom) {
        if (isNil$1(renderedZoom)) {
            return true;
        }
        // 只在有缩放地图，或者layer有动画时，才重绘skin
        const zoom = this.getMap().getZoom();
        const skinLayers = this.layer.getSkinLayers();
        for (let i = 0; i < skinLayers.length; i++) {
            const renderer = skinLayers[i] && skinLayers[i].getRenderer();
            if (!renderer) {
                continue;
            }
            if (renderer.isAnimating && renderer.isAnimating()) {
                return true;
            }
            if (renderer.needToRefreshTerrainTileOnZooming && renderer.needToRefreshTerrainTileOnZooming() && renderedZoom !== zoom) {
                return true;
            }
        }
        return false;
    }

    isValidCachedTile(tile) {
        // parent或者child tile没有初始化时，也允许加到parentsTile里，执行初始化逻辑
        const notInitialized = !tile.image.skinStatus;
        return tile.image && !tile.image.temp && (notInitialized || this._isSkinReady(tile.image));
    }

    isTileComplete(tile) {
        return tile.image && !tile.image.temp && this._isSkinReady(tile.image);
    }

    _getTerrainWidth() {
        const layerOptions = this.layer.options;
        const tileSize = this.layer.getTileSize().width;
        return isNil$1(layerOptions.terrainWidth) ? (tileSize / 4) + 1 : layerOptions.terrainWidth;
    }

    _getParentTileRequest(tile, createIfNotExists) {
        const maxAvailableZoom = this.layer.options['maxAvailableZoom'] - this.layer.options['zoomOffset'];
        const diff = tile.z - maxAvailableZoom;
        const scale = Math.pow(2, diff);
        const x = Math.floor(tile.x / scale);
        const y = Math.floor(tile.y / scale);
        const idx = Math.floor(tile.idx / scale);
        const idy = Math.floor(tile.idy / scale);
        const reqKey = getParentRequestKey(x, y);
        if (!this._parentRequests) {
            this._parentRequests = {};
        }
        const isFirst = !this._parentRequests[reqKey];
        if (isFirst && createIfNotExists) {
            this._parentRequests[reqKey] = new Set();
            this._parentRequests[reqKey].url = this.layer.getTileUrl(x, y, maxAvailableZoom + this.layer.options['zoomOffset']);
        }
        return {
            x, y, idx, idy, requests: this._parentRequests[reqKey], isFirst, key: reqKey
        };
    }

    loadTile(tile) {
        const layer = this.layer;
        const terrainWidth = this._getTerrainWidth();
        const sp = layer.getSpatialReference();
        const res = sp.getResolution(tile.z);
        let error = this.getMap().pointAtResToDistance(1, 1, res);

        const zoomOffset = layer.options['zoomOffset'] || 0;
        const maxAvailableZoom = layer.options['maxAvailableZoom'] && (layer.options['maxAvailableZoom'] - zoomOffset);

        if (maxAvailableZoom && tile.z > maxAvailableZoom) {

            // 检查 maxAvailableZoom 的tile是否存在，如果没有存在，则请求它，并在返回结果后clip
            const terrainData = this._createTerrainFromParent(tile);
            if (terrainData.sourceZoom === -1) {
                //改为请求maxAvailableZoom上的瓦片
                const { requests, isFirst, x, y, idx, idy } = this._getParentTileRequest(tile, true);
                requests.add(tile);
                if (!isFirst) {
                    return terrainData;
                }
                const diff = tile.z - maxAvailableZoom;
                error = error * Math.pow(2, diff);
                const res = tile.res * Math.pow(2, diff);
                const args = [x, y, maxAvailableZoom, idx, idy, res, tile.error * Math.pow(2, diff)];
                tile = layer.createTileNode ? layer.createTileNode(...args) : layer._createTileNode(...args);
            } else {
                wrapTileColorsTexture(tile, terrainData);
                this.onTileLoad(terrainData, tile);
                return terrainData;
            }
        }

        const terrainUrl = tile.url;
        const terrainData = {};
        const layerOptions = layer.options;

        const tileSize = layer.getTileSize();

        const options = {
            terrainWidth,
            type: layerOptions.type,
            accessToken: layerOptions.accessToken,
            cesiumIonTokenURL: layerOptions.cesiumIonTokenURL,
            error: error * layer._getErrorScale(),
            colors: layerOptions.colors,
            tileSize: tileSize ? [tileSize.width, tileSize.height] : [256, 256],
            command: 'loadTile'
        };

        const fetchTerrain = () => {
            this.workerConn.fetchTerrain(terrainUrl, options, (err, resource) => {
                if (this._parentRequests) {
                    const reqKey = getParentRequestKey(tile.x, tile.y);
                    const childTiles = this._parentRequests[reqKey];
                    if (childTiles && childTiles.size) {
                        this.tileCache.add(tile.id, { info: tile, image: terrainData });
                        for (const tile of childTiles) {
                            this.removeTileLoading(tile);
                        }
                    }
                    delete this._parentRequests[reqKey];
                }
                if (err) {
                    fetchError(err);
                    return;
                }
                maptalks.Util.extend(terrainData, resource);

                // this.consumeTile(terrainData, tile);
                wrapTileColorsTexture(tile, terrainData);
                this.onTileLoad(terrainData, tile);
            });
        };
        const fetchError = (err) => {
            if (err && err.canceled) {
                return;
            }
            console.warn(err);
            this.onTileError(terrainData, tile);
            return;
        };
        if (this.loadTileBitmap && isFunction(this.loadTileBitmap)) {
            this.loadTileBitmap(terrainUrl, tile, (err, bitmap) => {
                if (err) {
                    fetchError(err);
                    return;
                }
                if (bitmap && bitmap instanceof ImageBitmap) {
                    options.tileImage = bitmap;
                    fetchTerrain();
                } else {
                    fetchError(new Error('bitmap is not ImageBitmap'));
                }
            }, options);
        } else {
            fetchTerrain();
        }

        return terrainData;
    }

    deleteTile(tile) {
        if (!tile || !tile.image) {
            return;
        }
        super.deleteTile(tile);
        const { info, image } = tile;
        if (image.temp) {
            return;
        }
        delete info.skinTileIds;
        this._deleteTerrainImage(tile.info, image);

    }

    _deleteTerrainImage(tileInfo, image) {
        if (tileInfo && tileInfo.colorsTexture) {
            if (tileInfo.colorsTexture.close) {
                tileInfo.colorsTexture.close();
            }
            delete tileInfo.colorsTexture;
        }
        const skin = image.skin;
        if (skin) {
            skin.destroy();
            skin.colorTex.destroy();
            delete skin.colorTex;
        }
        const mask = image.mask;
        if (mask) {
            mask.destroy();
            mask.colorTex.destroy();
            delete mask.colorTex;
        }
        if (image.debugTexture) {
            image.debugTexture.destroy();
            delete image.debugTexture;
            image.skinDebugMesh.dispose();
            delete image.skinDebugMesh;
        }
        const skinImages = image.skinImages;
        if (skinImages && skinImages.length) {
            let refKey = tileInfo.id;
            if (image.temp) {
                refKey += '-temp';
            }
            for (let i = 0; i < skinImages.length; i++) {
                const layerSkinImages = skinImages[i];
                if (!layerSkinImages) {
                    continue;
                }
                for (let ii = 0; ii < layerSkinImages.length; ii++) {
                    if (!layerSkinImages[ii] || !layerSkinImages[ii].tile) {
                        continue;
                    }
                    const skinTileId = layerSkinImages[ii].tile.info.id;
                    const cached = this._skinImageCache && this._skinImageCache.get(skinTileId);
                    if (cached) {
                        this._deleteCachedSkinImage(cached, refKey);
                    }
                }
                layerSkinImages.length = 0;
            }
        }
        if (image.terrainMesh) {
            this._painter.deleteMesh(image.terrainMesh);
        }
        if (image.image && image.image.close) {
            // imageBitmap
            image.image.close();
        }
        delete image.skinImages;
        delete image.skin;
        delete image.mask;
        delete image.skinStatus;
        delete image.skinTileIds;
        delete image.terrainMesh;
        delete image.image;
        delete image.data;
        delete image.mesh;
        // delete image.temp;
    }

    _deleteCachedSkinImage(cached, refKey, skinImagesToDel) {
        if (!cached) {
            return;
        }
        cached.refs.delete(refKey);
        if (!cached.refs.size) {
            if (skinImagesToDel) {
                skinImagesToDel.push(cached);
            } else {
                this._deleteSkinImage(cached);
            }
        }
    }

    _deleteSkinImage(cached) {
        if (!cached || !cached.tile) {
            return;
        }
        const skinTileId = cached.tile.info.id;
        const renderer = cached.layer.getRenderer();
        delete cached.canvas;
        delete cached.layer;
        cached.refs.clear();
        if (cached.texture) {
            if (!renderer) {
                if (cached.texture.destroy) {
                    cached.texture.destroy();
                }
            } else {
                renderer.deleteTerrainTexture(cached.texture);
            }
            delete cached.texture;
        }
        if (cached.skinMesh) {
            cached.skinMesh.dispose();
            delete cached.skinMesh;
        }
        if (renderer) {
            if (renderer.removeTileCache) {
                renderer.removeTileCache(skinTileId);
            }
            if (renderer.deleteTile) {
                renderer.constructor.prototype.deleteTile.call(renderer, cached.tile);
            }
        }
        delete cached.tile;
        this._skinImageCache.delete(skinTileId);
    }

    _clearSkinImageCache() {
        if (!this._skinImageCache) {
            return;
        }
        const keys = this._skinImageCache.keys();
        for (const id of keys) {
            const cached = this._getCachedSkinImage(id);
            this._deleteSkinImage(cached);
        }
        this._skinImageCache.clear();
    }

    abortTileLoading(tileImage, tileInfo) {
        const layer = this.layer;
        const maxAvailableZoom = layer.options.maxAvailableZoom && (layer.options.maxAvailableZoom - layer.options.zoomOffset);

        const abortTile = (url, tile) => {
            if (this.loadTileBitmap && isFunction(this.loadTileBitmap)) {
                this.loadTileBitmap(url, tile, () => {

                }, {
                    command: 'abortTile'
                });
            } else if (this.workerConn) {
                this.workerConn.abortTerrain(url);
            }
        };
        if (tileInfo) {
            if (maxAvailableZoom && tileInfo.z > maxAvailableZoom) {
                const { requests, key } = this._getParentTileRequest(tileInfo);
                if (requests && requests.size) {
                    requests.delete(tileInfo);
                    if (!requests.size) {
                        // 中止 maxAvailableZoom 瓦片的请求
                        delete this._parentRequests[key];
                        abortTile(requests.url, tileInfo);
                    }
                }
            } else {
                if (tileInfo && tileInfo.url) {
                    abortTile(tileInfo.url, tileInfo);
                }
            }
        }

        super.abortTileLoading(tileImage, tileInfo);
    }

    onTileError(data, tile) {
        // TODO
        super.onTileError(data, tile);
    }

    _getTerrainTileAtPrjCoord(prjCoord) {
        const zoom = this.getCurrentTileZoom();
        const sp = this.layer.getSpatialReference();
        const res = sp.getResolution(zoom);
        const tileIndex = this.layer['_getTileConfig']().getTileIndex(prjCoord, res, this.layer.options['repeatWorld']);
        tileIndex.z = zoom;
        return tileIndex;
    }

    _queryTerrain(out, terrainTileId, tileIndex, worldPos, res) {
        const minZoom = this.layer.getMinZoom();
        const terrainData = this._findTerrainData(terrainTileId, tileIndex.x, tileIndex.y, tileIndex.z, minZoom);
        if (terrainData && terrainData.image && terrainData.image.data) {
            const extent2d = terrainData.info.extent2d;
            const terrainRes = terrainData.info.res;
            const scale = terrainRes / res;
            const x = worldPos.x - extent2d.xmin * scale;
            const y = extent2d.ymax * scale - worldPos.y;
            let altitude = this._queryAltitudeInHeights(terrainData.image.data, x / (extent2d.getWidth() * scale), y / (extent2d.getHeight() * scale));
            const exaggeration = this.layer._getExaggeration();
            if (exaggeration !== 0) {
                altitude = altitude * exaggeration;
            }
            out[0] = altitude;
            out[1] = altitude === null ? 0 : +(terrainData.info.z === tileIndex.z);
        } else {
            out[0] = null;
            out[1] = 0;
        }
        return out;
    }

    _findTerrainData(terrainTileId, x, y, z, limit) {
        if (!terrainTileId) {
            terrainTileId = this.layer['_getTileId'](x, y, z);
        }
        const terrainData = this.tilesInView[terrainTileId] || this.tileCache.get(terrainTileId);
        if (!terrainData && z - 1 >= limit) {
            return this._findTerrainData(null, Math.floor(x / 2), Math.floor(y / 2), z - 1, limit);
        }
        return terrainData;
    }

    _queryAltitudeInHeights(terrainData, x, y) {
        const { width, height, data } = terrainData;
        // 减一是因为width索引范围是从0到width-1
        const tx = Math.floor((width - 1) * x);
        // 减一是因为height索引范围是从0到height-1
        const ty = Math.floor((height - 1) * y);
        const index = ty * width + tx;
        if (data[index] === undefined) {
            return null;
        }
        return data[index];
    }

    _queryTileAltitude(out, extent, targetRes) {
        if (!out) {
            out = {
                tiles: {},
                dirty: true,
                complete: false
            };
        }
        const layer = this.layer;

        const z = this.getCurrentTileZoom();
        const sp = layer.getSpatialReference();
        const res = sp.getResolution(z);
        const { xmin, ymin, xmax, ymax } = extent;

        const config = layer['_getTileConfig']();

        POINT0$1.set(xmin, ymin)._multi(targetRes);
        const minIndex = config['_getTileNum'](POINT0$1, targetRes, true);
        POINT1.set(xmax, ymax)._multi(targetRes);
        const maxIndex = config['_getTileNum'](POINT1, targetRes, true);

        const txmin = Math.min(minIndex.x, maxIndex.x);
        const txmax = Math.max(minIndex.x, maxIndex.x);

        const tymin = Math.min(minIndex.y, maxIndex.y);
        const tymax = Math.max(minIndex.y, maxIndex.y);

        const scale = targetRes / res;
        POINT0$1.set(xmin, ymin)._multi(scale);
        POINT1.set(xmax, ymax)._multi(scale);
        const extent2d = TEMP_EXTENT.set(POINT0$1.x, POINT0$1.y, POINT1.x, POINT1.y);

        // martini 需要一点多余的数据
        const terrainSize = layer.getTileSize().width + 1;
        // 扩大一个像素
        extent2d._expand(extent2d.getWidth() / terrainSize);
        out.array = out.array || new Float32Array(terrainSize * terrainSize);
        const tiles = out.tiles;
        out.complete = true;
        out.array.fill(0);
        for (let i = txmin; i <= txmax; i++) {
            for (let j = tymin; j <= tymax; j++) {
                const tileId = this.layer['_getTileId'](i, j, z);
                if (tiles[tileId]) {
                    continue;
                }
                const terrainData = this.tileCache.get(tileId);
                // 如果当前瓦片找不到，则查询父级瓦片
                if (terrainData) {
                    this._fillAltitudeData(out.array, terrainData, extent2d, terrainSize);
                    out.dirty = true;
                    tiles[tileId] = 1;
                } else {
                    out.dirty = out.dirty || out.tiles[tileId] !== undefined;
                    if (out.tiles[tileId]) {
                        delete out.tiles[tileId];
                    }
                    out.complete = false;
                }
            }
        }
        return out;
    }

    _fillAltitudeData(out, terrainData, extent2d, terrainSize) {
        const terrainExtent = terrainData.info.extent2d;
        const intersection = terrainExtent.intersection(extent2d);
        const { xmin, ymin, xmax, ymax } = intersection;

        const { data: terrain } = terrainData.image;
        const width = terrain.width;
        const unit = extent2d.getWidth() / terrainSize;

        const xstart = Math.floor((xmin - extent2d.xmin) / unit);
        const ystart = Math.floor((ymin - extent2d.ymin) / unit);
        const xend = Math.floor((xmax - extent2d.xmin) / unit);
        const yend = Math.floor((ymax - extent2d.ymin) / unit);

        const xspan = xend - xstart;
        const yspan = yend - ystart;

        const tunit = terrainExtent.getWidth() / width;
        const tstartx = Math.floor((xmin - terrainExtent.xmin) / tunit);
        const tstarty = Math.floor((ymin - terrainExtent.ymin) / tunit);

        const stride = Math.floor(unit / tunit);

        for (let i = 0; i <= xspan; i++) {
            for (let j = 0; j <= yspan; j++) {
                const index = i + xstart + (ystart + j) * terrainSize;
                let height = 0;
                for (let k = 0; k < stride; k++) {
                    for (let kk = 0; kk < stride; kk++) {
                        // const terrainIndex = tstartx + Math.floor(i * stride) + k + (tstarty + Math.floor(j * stride)) * width + kk;
                        const terrainIndex = (tstartx + Math.floor(i * stride)) * width + k + tstarty + Math.floor(j * stride) + kk;
                        height += terrain.data[terrainIndex];
                    }
                }
                out[index] = height / Math.max(stride, 1);
                // if (isNaN(out[index])) {
                //     debugger
                // }
            }
        }
        return out;
    }

    clear() {
        this.clearTempResources();
        this.clearTileCaches();
        return super.clear();
    }

    clearTempResources() {
        if (this._tempTilesPool) {
            this._tempTilesPool.reset();
            delete this._tempTilesPool;
        }
        if (this._skinImageCache) {
            this._clearSkinImageCache();
        }
    }

    onAdd() {
        super.onAdd();
        this.prepareWorker();
    }

    onRemove() {
        if (this.workerConn) {
            this.workerConn.removeLayer(this.layer.getId(), err => {
                if (err) throw err;
            });
            this.workerConn.remove();
            delete this.workerConn;
        }
        this.clearTempResources();
        if (this._skinShader) {
            this._skinShader.dispose();
            delete this._skinShader;
        }
        if (this._skinGeometry) {
            this._skinGeometry.dispose();
            delete this._skinGeometry;
        }
        if (this._terrainMaskDepthStencil) {
            if (this._terrainMaskDepthStencil.colorTex) {
                this._terrainMaskDepthStencil.colorTex.destroy();
            }
            this._terrainMaskDepthStencil.destroy();
            delete this._terrainMaskDepthStencil;
        }
        delete this._parentRequests;
        super.onRemove();
        if (this._painter) {
            this._painter.delete();
            delete this._painter;
        }
    }

    prepareWorker() {
        const map = this.layer.getMap();
        if (!this.workerConn) {
            this.workerConn = new TerrainWorkerConnection(map.id);
        }
        const workerConn = this.workerConn;
        if (!workerConn.isActive()) {
            return;
        }
        const options = this.layer.options || {};
        const id = this.layer.getId();
        workerConn.addLayer(id, options, err => {
            if (err) throw err;
            if (!this.layer) return;
            this.ready = true;
            this.setToRedraw();
            this.layer.fire('workerready');
        });
    }

    initContext() {
        super.initContext();
        const { regl, device } = this.context;
        this.regl = regl;
        this.device = device || regl;

        this.renderer = new Renderer(regl || device);
        this.layer.fire('contextcreate', { regl, device });
    }

    _createPainter() {
        const painter = this._painter;
        if (this.layer.options.shader === 'lit' || this.layer.options.shader === 'pbr') {
            if (painter && painter.constructor === TerrainPainter || !painter) {
                if (painter) {
                    painter.delete();
                    this.clear();
                    this.setToRedraw();
                }
                this._painter = new TerrainLitPainter(this.layer);
                this.layer.fire('paintercreated');
            }

        } else {
            if (painter && painter.constructor === TerrainLitPainter || !painter) {
                if (painter) {
                    painter.delete();
                    this.clear();
                    this.setToRedraw();
                }
                this._painter = new TerrainPainter(this.layer);
                this.layer.fire('paintercreated');
            }
        }
    }

    _initSkinShader() {
        if (this._skinShader) {
            return;
        }

        const tileSize = this.layer.getTileSize().width;
        this._skinShader = new MeshShader({
            name: 'terrain-skin',
            vert: skinVert,
            frag: skinFrag,
            wgslVert: getWGSLSource('gl_terrain_skin_vert'),
            wgslFrag: getWGSLSource('gl_terrain_skin_frag'),
            extraCommandProps: {
                cull: {
                    enable: false
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: tileSize * 2,
                    height: tileSize * 2
                },
                depth: {
                    enable: false
                },
                blend: {
                    enable: true,
                    func: { src: 'one', dst: 'one minus src alpha' },
                    equation: 'add'
                }
            }
        });

        const aPosition = new Int16Array([
            -1, -1,
            1, 1,
            -1, 1,

            1, 1,
            -1, -1,
            1, -1
        ]);
        this._skinGeometry = this._skinGeometry || new Geometry({
            aPosition
        }, 0, 6, { positionSize: 2 });
        this._skinGeometry.generateBuffers(this.device);
        this._skinScene = this._skinScene || new Scene();
    }

    updateMaterial(mat) {
        if (!this._painter || !mat) {
            return;
        }
        if (!this._painter.updateMaterial) {
            return;
        }
        if (this._matVer === undefined) {
            this._matVer = 1;
        }
        this._painter.updateMaterial(mat, this._matVer++);
    }

    setMaterial(mat) {
        if (!this._painter || !mat) {
            return;
        }
        if (!this._painter.setMaterial) {
            return;
        }
        if (this._matVer === undefined) {
            this._matVer = 1;
        }
        this._painter.setMaterial(mat, this._matVer++);
    }

    getAnalysisMeshes() {
        if (this._painter && this._painter._leafScene) {
            return this._painter._leafScene.getMeshes();
        }
        return [];
    }

    _debugTile(tileInfo, name, debugOn) {
        if (this.layer.options['debugTile']) {
            if (Array.isArray(tileInfo)) {
                for (let i = 0; i < tileInfo.length; i++) {
                    if (!tileInfo[i]) {
                        continue;
                    }
                    this._debugTile(tileInfo[i], name + ' at ' + i, debugOn);
                }
                return;
            }
            if (!tileInfo) {
                return;
            }
            const { x, y, z } = this.layer.options['debugTile'];
            const { info } = tileInfo;
            if (info) {
                tileInfo = info;
            }
            if (x === tileInfo.x && y === tileInfo.y && z === tileInfo.z) {
                console.log(`Found debug tile in TerrainLayerRenderer.${name}:`, tileInfo);
                if (debugOn) {
                    // eslint-disable-next-line no-debugger
                    debugger
                }
            }
        }
    }

    _clearStaleSkins(staleSkinLayers) {
        // return;
        if (!staleSkinLayers.length) {
            return;
        }
        this._forEachCachedTile(tile => {
            const { image } = tile;
            if (!image || !image.skinImages) {
                return;
            }
            const { skinImages, skinStatus, skinTileIds } = image;
            for (let i = 0; i < staleSkinLayers.length; i++) {
                const layerId = staleSkinLayers[i].getId();
                if (skinImages[layerId]) {
                    delete skinImages[layerId];
                }
                if (skinStatus) {
                    delete skinStatus[layerId];
                }
                if (skinTileIds) {
                    delete skinTileIds[layerId];
                }
            }
        });
        this._skinImageCache.forEach(cached => {
            const { layer } = cached;
            if (staleSkinLayers.includes(layer)) {
                this._deleteSkinImage(cached);
            }
        });
    }
}

// function drawTileImage(ctx, extent, terrainOffset, tile, res, debug) {
//     const scale = tile.info.res / res;
//     const { info, image } = tile;
//     const offset = info.offset;
//     const width = image.width * scale;
//     const height = image.height * scale;
//     const xmin = info.extent2d.xmin * scale;
//     const ymax = info.extent2d.ymax * scale;
//     const left = xmin - extent.xmin;
//     const top = extent.ymax - ymax;
//     const dx = terrainOffset[0] - offset[0];
//     const dy = offset[1] - terrainOffset[1];
//     ctx.drawImage(image, left + dx, top + dy, width, height);
//     if (debug) {
//         const { x, y, z } = tile.info;
//         drawDebug(ctx, `${x}/${y}/${z}`, 'yellow', 1, left + dx, top + dy, width, height, -18);
//     }
// }

function computeSkinDimension(terrainTileInfo, tile, terrainTileSize, isFBO, isWebGPU) {
    const { res, extent2d: terrainExtent, offset: terrainOffset } = terrainTileInfo;
    const { info } = tile;
    const scale = info.res / res;
    const offset = info.offset;
    const xmin = info.extent2d.xmin * scale;
    const ymax = info.extent2d.ymax * scale;
    const ymin = info.extent2d.ymin * scale;
    const dx = terrainOffset[0] - offset[0];
    const dy = offset[1] - terrainOffset[1];
    const left = xmin - terrainExtent.xmin + dx;
    let bottom = terrainExtent.ymin - ymin + dy;
    if (!isFBO && isWebGPU) {
        bottom = -(terrainExtent.ymax - ymax + dy);
    }
    return [left, -bottom, scale * info.tileSize / terrainTileSize];
}

function isValidSkinImage(image) {
    return image && image.texture;
}

function getParentRequestKey(x, y) {
    return x + '-' + y;
}

function isPowerOfTwo(value) {
    return (value & (value - 1)) === 0 && value !== 0;
}

let tempCanvas;

function clipTileTexture(image, x1, y1, x2, y2) {
    if (maptalks.Browser.decodeImageInWorker) {
        if (!tempCanvas) {
            tempCanvas = new OffscreenCanvas(1, 1);
        }
        const width = Math.floor(x2 - x1), height = Math.floor((y2 - y1));
        if (!isPowerOfTwo(width) || !isPowerOfTwo(height)) {
            return;
        }
        tempCanvas.width = width;
        tempCanvas.height = height;
        const ctx = tempCanvas.getContext('2d');
        ctx.clearRect(0, 0, width, height);
        ctx.drawImage(image, x1, y1, width, height, 0, 0, width, height);
        return tempCanvas.transferToImageBitmap();
    }
}

function wrapTileColorsTexture(tile, terrainData) {
    const colorsTexture = terrainData.colorsTexture;
    delete terrainData.colorsTexture;
    if (colorsTexture) {
        if (tile.info) {
            tile.info.colorsTexture = colorsTexture;
        } else {
            tile.colorsTexture = colorsTexture;
        }
    }
}

function checkIfFBO(texture) {
    return !!(texture.colorTexture || texture.color);
}

const MASK_MODES = {
    'clip-inside': 0.1, 'clip-outside': 0.2, 'flat-inside': 0.3, 'flat-outside': 0.4, 'color': 0.5, 'texture': 0.6, 'elevate': 0.7
};
const QUAT = [], SCALE = [1, 1, 1];
const DEFAULT_SYMBOL = {
    polygonFill: [255, 0, 0],
    polygonOpacity: 0.8
};
const TRIANGLE_POINT_A = new Coordinate(0, 0), TRIANGLE_POINT_B = new Coordinate(0, 0), TRIANGLE$1 = [];
const TEMP_COORD = new Coordinate(0, 0), TEMP_POINT0 = new Point(0, 0), TEMP_POINT1 = new Point(0, 0), TEMP_POINT2 = new Point(0, 0);
class Mask extends Polygon {
    getMode() {
        return this._mode;
    }

    remove() {
        const layer = this.getLayer();
        if (!layer) {
            return this;
        }
        layer.removeMask(this);
        this._dispose();
        super.remove();
        return this;
    }

    getMesh(regl, ratio, minHeight) {
        if (!this.isVisible() || !this.getLayer()) {
            return null;
        }
        if (!this._mesh) {
            this._mesh = this._createMesh(regl, ratio, minHeight);
        }
        this._updateUniforms(this._mesh, ratio, minHeight);
        return this._mesh;
    }

    setCoordinates(coordinates) {
        super.setCoordinates(coordinates);
        const layer = this.getLayer();
        if (layer) {
            delete layer['_maskProjViewMatrix'];
            delete layer['_maskExtentInWorld'];
        }
        if (!this._mesh) {
            return this;
        }
        const mode = this.getMode();
        const geojson = this.toGeoJSON();
        geojson.geometry.coordinates[0].reverse();
        const data = earcut$1.flatten(geojson.geometry.coordinates);
        const { positions, uvs, triangles } =  mode === 'texture' ? this._createBilinearPOSITON(data) : this._createPOSITION(data);
        const geometry = this._mesh.geometry;
        geometry.updateData('POSITION', positions);
        geometry.updateData('TEXCOORD', uvs);
        geometry.setElements(triangles);
        this._setLocalTransform(this._mesh);
        if (this._copyMesh) {
            const positionWithHeight = this._createPOSITION(earcut$1.flatten(geojson.geometry.coordinates), true).positions;
            this._copyMesh.geometry.updateData('POSITION', positionWithHeight);
            this._setLocalTransform(this._copyMesh);
        }
    }

    _createGeometry(regl) {
        const mode = this.getMode();
        const geojson = this.toGeoJSON();
        geojson.geometry.coordinates[0].reverse();
        const data = earcut$1.flatten(geojson.geometry.coordinates);
        const { positions, uvs, triangles } =  mode === 'texture' ? this._createBilinearPOSITON(data) : this._createPOSITION(data);
        const positionWithHeight = this._createPOSITION(earcut$1.flatten(geojson.geometry.coordinates), true).positions;
        const geometry = new Geometry({
            POSITION: positions,
            TEXCOORD: uvs
        },
            triangles,
            0,
            {
                positionAttribute: 'POSITION',
                uv0Attribute: 'TEXCOORD'
            });
        geometry.generateBuffers(regl);
        const copyGeometry = new Geometry({
            POSITION: positionWithHeight,
            TEXCOORD: uvs
        },
            triangles,
            0,
            {
                positionAttribute: 'POSITION',
                uv0Attribute: 'TEXCOORD'
            });
        copyGeometry.generateBuffers(regl);
        return mode === 'texture' ? { geometry, copyGeometry } : geometry;
    }

    _createPOSITION(data, hasHeight) {
        const map = this.getMap();
        const dimension = data.dimensions;
        for (let ii = 0; ii < data.vertices.length; ii += dimension) {
            TEMP_COORD.x = data.vertices[ii];
            TEMP_COORD.y = data.vertices[ii + 1];
            const point = coordinateToWorld$2(map, TEMP_COORD);
            data.vertices[ii] = point[0];
            data.vertices[ii + 1] = point[1];
        }
        const centerPos = coordinateToWorld$2(map, this.getCenter());
        const pos = [];
        const idx = this.getLayer().getMasks().indexOf(this);
        const heightOffset = idx * 0.01;
        const len = this.getMode() === 'texture' ? 4 : data.vertices.length / dimension;
        for (let i = 0; i < len; i++) {
            pos.push(data.vertices[i * dimension] - centerPos[0]);
            pos.push(data.vertices[i * dimension + 1] - centerPos[1]);
            pos.push(heightOffset + hasHeight ? map.altitudeToPoint(data.vertices[i * dimension + 2], map.getGLRes()) : 0);
        }
        const uvs = this._createTexcoords(data.vertices, dimension);
        const indices = earcut$1(pos, data.holes, 3);
        return { positions: pos, uvs, triangles: indices };
    }

    _createTexcoords(vertices, dimension) {
        const texcoords = [0.0, 0.0, 0.0, 1.0, 1.0, 1.0, 1.0, 0.0];
        if (this.hasHoles()) {
            const count = vertices.length / dimension * 2;
            for (let i = texcoords.length / 2 - 1; i < count; i += 2) {
                texcoords[i] = texcoords[i + 1] = 0.0;
            }
        }
        return texcoords;
    }

    _createBilinearPOSITON(data) {
        const rows = 20;
        const cols = 20;
        const dimension = data.dimensions;
        const positions = [];
        const uvs = [];
        const indices = [];
        const map = this.getMap();
        for (let ii = 0; ii < data.vertices.length; ii += dimension) {
            TEMP_COORD.x = data.vertices[ii];
            TEMP_COORD.y = data.vertices[ii + 1];
            const point = coordinateToWorld$2(map, TEMP_COORD);
            data.vertices[ii] = point[0];
            data.vertices[ii + 1] = point[1];
        }
        const centerPos = coordinateToWorld$2(this.getMap(), this.getCenter());
        const vertices = {};
        vertices['a'] = { x: data.vertices[0 * dimension] - centerPos[0], y: data.vertices[0 * dimension + 1] - centerPos[1] };
        vertices['b'] = { x: data.vertices[1 * dimension] - centerPos[0], y: data.vertices[1 * dimension + 1] - centerPos[1] };
        vertices['c'] = { x: data.vertices[2 * dimension] - centerPos[0], y: data.vertices[2 * dimension + 1] - centerPos[1] };
        vertices['d'] = { x: data.vertices[3 * dimension] - centerPos[0], y: data.vertices[3 * dimension + 1] - centerPos[1] };
        this._positions = [];
        for (let i = 0; i < 4; i++) {
            this._positions.push(data.vertices[i * dimension] - centerPos[0]);
            this._positions.push(data.vertices[i * dimension + 1] - centerPos[1]);
            this._positions.push(0);
        }
        // 生成顶点
        for(let i = 0; i <= rows; i++) {
            for(let j = 0; j <= cols; j++) {
                const u = j / cols;
                const v = i / rows;

                // 双线性插值计算实际位置
                const x = (1 - u) * (1 - v) * vertices.a.x +
                            u * (1 - v) * vertices.b.x +
                            u * v * vertices.c.x +
                            (1 - u) * v * vertices.d.x;

                const y = (1 - u) * (1 - v) * vertices.a.y +
                            u * (1 - v) * vertices.b.y +
                            u * v * vertices.c.y +
                            (1 - u) * v * vertices.d.y;

                positions.push(x, y, 0);
                uvs.push(u, 1 - v); // 注意v坐标翻转
            }
        }
        for(let i = 0; i < rows; i++) {
            for(let j = 0; j < cols; j++) {
                const a = i * (cols + 1) + j;
                const b = a + 1;
                const c = (i + 1) * (cols + 1) + j;
                const d = c + 1;

                indices.push(a, b, d);
                indices.push(a, d, c);
            }
        }
        return { positions, uvs, triangles: indices };
    }

    clearMesh() {
        this._dispose();
        delete this._mesh;
        if (this.maskGeoJSON) {
            this.maskGeoJSON = null;
        }
    }

    _getMaskMode() {
        return MASK_MODES[this._mode];
    }

    _getMaskColor() {
        const symbol = this.getSymbol();
        const { polygonFill, polygonOpacity } = symbol || DEFAULT_SYMBOL;
        const maskColor = normalizeColor([], polygonFill);
        maskColor[3] = isNumber$1(polygonOpacity) ? polygonOpacity : (this.getMode() === 'texture' ? 1 : DEFAULT_SYMBOL.polygonOpacity);
        return maskColor;
    }

    _altitudeToPoint(altitude = 0) {
        const map = this.getMap();
        const res = map.getGLRes();
        return map.altitudeToPoint(altitude, res);
    }

    _setLocalTransform(mesh) {
        const map = this.getMap();
        const centerPos = coordinateToWorld$2(map, this.getCenter());
        const mMatrix = mat4.fromRotationTranslationScale(mesh.localTransform, quat.identity(QUAT), centerPos, SCALE);
        mesh.localTransform = mMatrix;
    }


    _dispose() {
        if (!this._mesh) {
            return;
        }
        if (this._mesh.material) {
            this._mesh.material.dispose();
        }
        if (this._mesh.geometry) {
            this._mesh.geometry.dispose();
        }
        if (this._copyMesh && this._copyMesh.geometry) {
            this._copyMesh.geometry.dispose();
            this._copyMesh.dispose();
        }
        this._mesh.dispose();
        delete this._mesh;
        delete this._copyMesh;
    }

    containsPoint(coordinate) {
        const extent = this.getExtent();
        TEMP_COORD.set(coordinate[0], coordinate[1]);
        if (!extent || !extent.contains(TEMP_COORD)) {
            return false;
        }
        const holes = this.getHoles();
        for (let i = 0; i < holes.length; i++) {
            if (this._contains(holes[i], coordinate)) {
                return false;
            }
        }
        const coordinates = this.getShell();
        return this._contains(coordinates, coordinate);
    }

    _contains(coordinates, coordinate) {
        const area = this._calArea(coordinates);
        let totalArea = 0;
        for (let i = 0; i < coordinates.length; i++) {
            TRIANGLE_POINT_A.x = coordinates[i].x;
            TRIANGLE_POINT_A.y = coordinates[i].y;
            const index = i + 1 >= coordinates.length ? 0 : i + 1;
            TRIANGLE_POINT_B.x = coordinates[index].x;
            TRIANGLE_POINT_B.y = coordinates[index].y;
            TEMP_COORD.x = coordinate[0];
            TEMP_COORD.y = coordinate[1];
            TRIANGLE$1[0] = TEMP_COORD;
            TRIANGLE$1[1] = TRIANGLE_POINT_A;
            TRIANGLE$1[2] = TRIANGLE_POINT_B;
            const area = this._calArea(TRIANGLE$1);
            totalArea += area;
        }
        if (Math.abs(totalArea - area) > 1e-8) {
            return false;
        }
        return true;
    }

    _calArea(coordinates) {
        const map = this.getMap();
        let area = 0;
        const glRes = map.getGLRes();
        const point0 = map.coordToPointAtRes(coordinates[0], glRes, TEMP_POINT0);
        for (let i = 1; i < coordinates.length - 1; i++) {
            const point1 = map.coordToPointAtRes(coordinates[i], glRes, TEMP_POINT1);
            const point2 = map.coordToPointAtRes(coordinates[i + 1], glRes, TEMP_POINT2);
            area += det(point0, point1, point2) / 2;
        }
        return area;
    }
}

//叉乘
function det(p0, p1, p2) {
    return (p1.x - p0.x) * (p2.y - p0.y) - (p1.y - p0.y) * (p2.x - p0.x);
}

/*!
* Contains code from THREE.js
* MIT License
* https://github.com/mrdoob/three.js
*/

var planes = [];
for (var i = 0; i < 6; i++) {
    planes[i] = [];
}

var p = [];

function intersectsBox(matrix, box, mask) {
    setPlanes(matrix);
    for (var i = 0; i < 6; i++) {
        var plane = planes[i];
        // corner at max distance
        p[0] = plane[0] > 0 ? box[1][0] : box[0][0];
        p[1] = plane[1] > 0 ? box[1][1] : box[0][1];
        p[2] = plane[2] > 0 ? box[1][2] : box[0][2];

        if (distanceToPoint(plane, p) < 0) {
            return false;
        }
    }

    return true;
}

function setPlanes(m) {
    var me = m;
    var me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
    var me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
    var me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
    var me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];

    //right
    setComponents(planes[0], me3 - me0, me7 - me4, me11 - me8, me15 - me12);
    //left
    setComponents(planes[1], me3 + me0, me7 + me4, me11 + me8, me15 + me12);
    //bottom
    setComponents(planes[2], me3 + me1, me7 + me5, me11 + me9, me15 + me13);
    //top
    setComponents(planes[3], me3 - me1, me7 - me5, me11 - me9, me15 - me13);
    //z-far
    setComponents(planes[4], me3 - me2, me7 - me6, me11 - me10, me15 - me14);
    //z-near
    setComponents(planes[5], me3 + me2, me7 + me6, me11 + me10, me15 + me14);
}

function setComponents(out, x, y, z, w) {
    // THREE.js Plane.js
    var inverseNormalLength = 1 / Math.sqrt(x * x + y * y + z * z);
    out[0] = x * inverseNormalLength;
    out[1] = y * inverseNormalLength;
    out[2] = z * inverseNormalLength;
    out[3] = w * inverseNormalLength;
    return out;
}

function distanceToPoint(plane, p) {
    return plane[0] * p[0] + plane[1] * p[1] + plane[2] * p[2] + plane[3];
}

// const maskLayerEvents = ['shapechange', 'heightrangechange', 'flatheightchange'];
const COORD_EXTENT = new Coordinate(0, 0);
const EXTENT_MIN = [0, 0, 0], EXTENT_MAX = [0, 0, 0];
const EMPTY_MAT4 = mat4.identity([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
function clearMasks() {
    if (!this['_maskList']) {
        return this;
    }
    this['_maskList'].forEach(mask => {
        mask.remove();
    });
    this['_maskList'] = [];
    this.updateMaskExtent();
    return this;
}
function normalizeHeight(minHeight, maxHeight) {
    const min = minHeight === Infinity ? 0 : minHeight;
    const max = maxHeight === -Infinity ? 0 : maxHeight;
    const range = Math.abs(max - min);
    if (range === 0) {
        return { ratio: 1, minHeight: 0 };
    }
    const ratio = Math.pow(range, -1);
    return { ratio, minHeight: min };
}
function hasVisibleMask() {
    for (let i = 0; i < this['_maskList'].length; i++) {
        if (this['_maskList'][i].isVisible()) {
            return true;
        }
    }
    return false;
}
function MaskLayerMixin (Base) {
    return class MaskLayerMixin extends Base {
        removeMask(masks) {
            if (!this['_maskList']) {
                return this;
            }
            if (!masks) {
                clearMasks.call(this);
                return this;
            }
            const maskList = Array.isArray(masks) ? masks : [masks];
            for (let i = 0; i < maskList.length; i++) {
                const mask = maskList[i];
                const index = this['_maskList'].indexOf(mask);
                if (index > -1) {
                    this['_maskList'].splice(index, 1);
                }
            }
            this.updateMaskExtent();
            this['fire']('removemask', { masks });
            return this;
        }
        setMask(masks) {
            this['removeMask'](null);
            if (!this['_maskList']) {
                this['_maskList'] = [];
            }
            if (Array.isArray(masks)) {
                masks.forEach(mask => {
                    this['_maskList'].push(mask);
                });
            }
            else {
                this['_maskList'].push(masks);
            }
            this['_maskList'].forEach(mask => {
                mask['_bindLayer'](this);
                if (mask._updateCoordinates) {
                    mask._updateCoordinates();
                }
            });
            this.updateMaskExtent();
            this['fire']('setmask', { masks });
            return this;
        }
        onAdd() {
            super['onAdd']();
            this.updateMaskExtent();
        }
        getMasks() {
            return this['_maskList'] || [];
        }
        //@internal
        onGeometryEvent(param) {
            if (!param || !param['target']) {
                return;
            }
            const type = param['type'];
            if (type === 'shapechange' && param['target'] instanceof Mask) {
                param['target'].clearMesh();
            }
            if (param['target'] instanceof Mask) {
                this.updateMaskExtent();
            }
            if (super['onGeometryEvent']) {
                super['onGeometryEvent'](param);
            }
        }
        identifyMask(point, options) {
            const map = this['getMap']();
            if (!map) {
                return [];
            }
            if (!this['_maskList'] || !this['_maskList'].length) {
                return [];
            }
            const opts = extend({}, options);
            opts['excludeMasks'] = true; //此处调用identifyAtPoint时，不需要去identifyMask
            const identifyData = this['identifyAtPoint'](point, opts);
            const coordinate = identifyData.length && identifyData[0].coordinate;
            if (coordinate) {
                const masks = this['_maskList'];
                if (!masks) {
                    return [];
                }
                const hits = [];
                for (let i = 0; i < masks.length; i++) {
                    const maskMode = masks[i].getMode();
                    if (masks[i].containsPoint(coordinate) && (maskMode === 'color' || maskMode === 'texture')) {
                        hits.push(masks[i]);
                    }
                }
                return hits;
            }
            return [];
        }
        remove() {
            if (this['_maskList'] && this['_maskList'].length) {
                this['_maskList'].forEach(mask => {
                    mask.remove();
                });
            }
            super['remove']();
        }
        updateMask(extent) {
            const map = this['getMap']();
            const { projViewMatrix, mapExtent } = this.getProjViewMatrixInOrtho(extent);
            COORD_EXTENT.x = mapExtent.xmin;
            COORD_EXTENT.y = mapExtent.ymin;
            const extentPointMin = coordinateToWorld$1(EXTENT_MIN, COORD_EXTENT, map);
            COORD_EXTENT.x = mapExtent.xmax;
            COORD_EXTENT.y = mapExtent.ymax;
            const extentPointMax = coordinateToWorld$1(EXTENT_MAX, COORD_EXTENT, map);
            const extentInWorld = [extentPointMin[0], extentPointMin[1], extentPointMax[0], extentPointMax[1]];
            return { projViewMatrix, extentInWorld };
        }
        getProjViewMatrixInOrtho(extent) {
            const map = this['getMap']();
            const preView = map.getView();
            const zoom = map.getFitZoom(extent);
            const center = extent.getCenter();
            map.setView({ center, zoom, pitch: 0, bearing: 0 });
            const mapExtent = map.getExtent();
            const pvMatrix = mat4.copy(EMPTY_MAT4, map.projViewMatrix);
            map.setView(preView);
            return { mapExtent, projViewMatrix: pvMatrix };
        }
        updateMaskExtent() {
            if (!this['_maskList']) {
                return;
            }
            const map = this['getMap']();
            if (!map) {
                return;
            }
            const renderer = this['getRenderer']();
            if (renderer && !this['_maskList'].length) {
                renderer['_clearMask']();
                return;
            }
            if (renderer && !hasVisibleMask.call(this)) {
                renderer['_deleteMaskUniforms']();
                renderer.setToRedraw();
                return;
            }
            const maskExtent = this.getMaskExtent();
            if (!maskExtent) {
                return;
            }
            const { extent, ratio, minHeight } = maskExtent;
            const { projViewMatrix, extentInWorld } = this.updateMask(extent);
            this._maskProjViewMatrix = projViewMatrix;
            this._maskExtentInWorld = extentInWorld;
            if (renderer) {
                renderer.setMask(this._maskExtentInWorld, this._maskProjViewMatrix, ratio, minHeight);
            }
            else {
                this['once']('renderercreate', e => {
                    e.renderer.setMask(this._maskExtentInWorld, this._maskProjViewMatrix, ratio, minHeight);
                });
            }
        }
        getMaskExtent() {
            let xmin = Infinity, ymin = Infinity, xmax = -Infinity, ymax = -Infinity, maxheight = -Infinity, minheight = Infinity;
            let hasMaskInExtent = false;
            const map = this['getMap']();
            for (let i = 0; i < this['_maskList'].length; i++) {
                const mask = this['_maskList'][i];
                if (!mask.isVisible()) {
                    continue;
                }
                const extent = mask.getExtent();
                if (!extent) {
                    continue;
                }
                //不在视野范围内的mask不参与运算，以免造成extent的增大，从而降低采样的精度
                if (mask._mesh && mask.getBBox) {
                    const bbox = mask.getBBox();
                    if (!intersectsBox(map.projViewMatrix, bbox)) {
                        continue;
                    }
                }
                hasMaskInExtent = true;
                if (extent.xmin < xmin) {
                    xmin = extent.xmin;
                }
                if (extent.ymin < ymin) {
                    ymin = extent.ymin;
                }
                if (extent.xmax > xmax) {
                    xmax = extent.xmax;
                }
                if (extent.ymax > ymax) {
                    ymax = extent.ymax;
                }
                if (mask._getHeightRange) {
                    const heightRange = mask._getHeightRange();
                    if (heightRange[0] < minheight) {
                        minheight = heightRange[0];
                    }
                    if (heightRange[1] > maxheight) {
                        maxheight = heightRange[1];
                    }
                }
            }
            if (!hasMaskInExtent) {
                return null;
            }
            const { ratio, minHeight } = normalizeHeight(minheight, maxheight);
            const extent = new Extent(xmin, ymin, xmax, ymax);
            return { extent, ratio, minHeight };
        }
    };
}
function coordinateToWorld$1(out, coordinate, map, z = 0) {
    if (!map || !(coordinate instanceof Coordinate)) {
        return null;
    }
    const p = map.coordinateToPointAtRes(coordinate, map.getGLRes());
    out[0] = p.x;
    out[1] = p.y;
    out[2] = z;
    return out;
}

const COORD0 = new maptalks.Coordinate(0, 0);
const TEMP_POINT$2 = new maptalks.Coordinate(0, 0);
const POINT0 = new maptalks.Point(0, 0);
const EMPTY_ARRAY = [];

const options$2 = {
    'forceRenderOnMoving': true,
    'forceRenderOnZooming': true,
    'forceRenderOnRotating': true,
    'fadeAnimation': false,
    'fadeDuration': (1000 / 60 * 15),
    'tileLimitPerFrame': 2,
    'newTerrainTileRenderLimitPerFrameOnInteracting': 1,
    'opacity': 1.0,
    'renderer': 'gl',
    'pyramidMode': 1,
    'tileSize': 512,
    'terrainWidth': null,
    'backZoomOffset': 0,
    'depthMask': true,
    'blendSrc': 'one',
    'blendDst': 'one minus src alpha',
    'requireSkuToken': true,
    'cesiumIonTokenURL': 'https://api.cesium.com/v1/assets/1/endpoint?access_token=',
    'tileRetryCount': 0,
    'shader': 'default',
    'terrainTileMode': true,
    'tempTileCacheSize': 64,
    'tileStackStartDepth': 7,
    'tileStackDepth': 6,
    'currentTilesFirst': false,
    'exaggeration': 1,
    'errorScale': 1,
    'hasSkirts': true,
    'colors': []
};

const EMPTY_TILE_GRIDS = {
    tileGrids: [],
    count: 0
};


const SKU_ID = '01';
const TOKEN_VERSION = '1';
const base62chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

// terrain 的渲染流程：
// 1. TerrainLayer 计算有哪些瓦片, terrainTiles
// 2. 每个skinLayer根据 terrainTiles 计算出自己需求请求哪些瓦片 skinTiles（需要注意多个terrainTile可能共享skinTile）
// 3. 遍历 skinTiles，为每个 skinTiles 创建必要的 skinTexture，并绘制 skinTiles 到 skinTexture 中，因为做过去重，每个skinTile只会绘制一次
// 4. 遍历 terrainTiles， 为每个 terrainTiles 创建 terrainMesh，并在frag shader中合成 skinTiles 的 skinTexture，最终绘制到地图场景中
class TerrainLayer extends MaskLayerMixin(maptalks.TileLayer) {
    constructor(id, options) {
        if (options && !options.tileSystem) {
            if ((options.type === 'cesium' || options.type === 'cesium-ion')) {
                options.tileSystem = [1, 1, -180, -90];
            } else if (options.type === 'tianditu') {
                options.tileSystem = [1, -1, -180, 90];
            }
        }
        if (!options.tileSize) {
            if (options.type === 'mapbox') {
                options.tileSize = 512;
            }
        }
        if (!options.spatialReference) {
            if (options.type === 'mapbox') {
                options.spatialReference = 'preset-3857-512';
            }
        }
        super(id, options);
    }

    onAdd() {
        const options = this.options;
        const map = this.getMap();
        const projection = map.getProjection();
        const is4326 = projection.code === "EPSG:4326" || projection.code === "EPSG:4490";
        const is3857 = projection.code === "EPSG:3857";
        if (options.tileSize === 512 && !options.spatialReference) {
            if (options.type === 'mapbox') {
                if (is4326) {
                    options.spatialReference = 'preset-4326-512';
                } else if (is3857) {
                    options.spatialReference = 'preset-3857-512';
                }
            } else if (options.type === 'cesium' || options.type === 'cesium-ion') {
                options.spatialReference = 'preset-4326-512';
            } else if (options.type === 'tianditu') {
                options.spatialReference = {
                    'projection': 'EPSG:4326',
                    'fullExtent': {
                        'top': 90,
                        'left': -180,
                        'bottom': -90,
                        'right': 180
                    },
                    'resolutions': (function () {
                        const resolutions = [];
                        for (let i = 0; i <= 22; i++) {
                            resolutions[i] = 180 / 2 / (Math.pow(2, i) * 128);
                        }
                        return resolutions;
                    })()
                };
            }
        }
        if (!options.terrainWidth && options.type === 'tianditu') {
            // tianditu's terrainWidth has to be 65, decided by the terrain format
            options.terrainWidth = 65;
        }
    }

    getTileUrl(x, y, z) {
        let terrainUrl = super.getTileUrl(x, y, z);
        const type = this.options.type;
        // if (type === 'cesium') {
        //     z = z - 1;
        //     const yTiles = 1 << z;
        //     y =  yTiles - y - 1;
        // }
        if (type === 'mapbox' && this.options['requireSkuToken']) {
            if (!this._skuToken) {
                this._skuToken = this._createSkuToken();
            }
            if (terrainUrl.indexOf('?') > -1) {
                terrainUrl += '&sku=' + this._skuToken;
            } else {
                terrainUrl += '?sku=' + this._skuToken;
            }
        }/* else if (type === 'cesium') {
            terrainUrl += '?extensions=octvertexnormals-watermask-metadata&v=1.2.0';
        }*/
        return terrainUrl;
    }

    getMaxAvailableZoom() {
        // 这里重载了TileLayer里的getMaxAvailableZoom，没有读取 layer.options.maxAvalibleZoom
        // 原因是在TerrainLayerRenderer中会用maxAvaibleZoom的瓦片数据，实时切分出当前请求请求的瓦片
        // 例如如果 maxAvailbleZoom 是14，16级的地形瓦片是从14级瓦片中切分出来的。
        // 这样可以让skin layer的渲染逻辑更简单明确
        const sr = this.getSpatialReference();
        return sr.getMaxZoom();
    }

    _createSkuToken() {
        // https://github.com/mapbox/mapbox-gl-js/blob/6971327e188b9aa045622925a59800aa8ee940ac/src/util/sku_token.js
        let sessionRandomizer = '';
        for (let i = 0; i < 10; i++) {
            sessionRandomizer += base62chars[Math.floor(Math.random() * 62)];
        }
        const token = [TOKEN_VERSION, SKU_ID, sessionRandomizer].join('');
        return token;
    }

    _getExaggeration() {
        let exaggeration = this.options.exaggeration;
        if (isNil$1(exaggeration)) {
            exaggeration = 1;
        }
        return exaggeration;
    }

    setSkinLayers(skinLayers) {
        skinLayers = skinLayers || [];
        const currentLayers = this._skinLayers;
        this._skinLayers = skinLayers;
        const renderer = this.getRenderer();
        if (renderer) {
            if (currentLayers) {
                const staleSkinLayers = getStaleSkinLayers(currentLayers, skinLayers);
                renderer._clearStaleSkins(staleSkinLayers);
            }
            renderer.setToRedraw();
        }
    }

    getSkinTiles(layer) {
        const renderer = this.getRenderer();
        if (!renderer) {
            return EMPTY_TILE_GRIDS;
        }
        const tileGrids = renderer.getTileGridsInCurrentFrame();
        const grid = tileGrids.tileGrids[0];
        if (!grid) {
            return EMPTY_TILE_GRIDS;
        }
        const layerId = layer.getId();
        const tileSysScale = this._getTileConfig().tileSystem.scale;
        const tileSize = layer.getTileSize().width;
        const tiles = grid.tiles;
        if (!tiles.length) {
            return EMPTY_TILE_GRIDS;
        }
        const map = this.getMap();
        const parents = grid.parents || EMPTY_ARRAY;
        const parentCount = parents.length;
        const allTiles = parents.concat(tiles);

        const sr = layer.getSpatialReference();
        const size = tiles[0].extent2d.getWidth();

        const dx = tileSysScale.x;
        const dy = tileSysScale.y;

        const parentSkinTiles = [];
        const skinTiles = [];
        const allSkinTileIds = new Set();
        const scaleY = this['_getTileConfig']().tileSystem.scale.y;

        for (let i = 0; i < allTiles.length; i++) {
            const info = allTiles[i];
            const { res } = info;
            let nw = info.nw;
            if (!nw) {
                nw = info.nw = map.pointAtResToCoord(info.extent2d.getMin(POINT0), info.res);
            }
            const { res: skinRes, zoom } = getSkinTileRes(sr, info.z, res);
            const resScale = skinRes / res;
            const scale = getSkinTileScale(skinRes, tileSize, res, size);

            const { extent2d, offset } = info;
            const leftX = scale * info.x;
            const topY = scale * info.y;
            if (!info.skinTileIds) {
                info.skinTileIds = {};
            }
            if (!info.skinTileIds[layerId]) {
                const skinTileIds = new Set();
                const layerTiles = [];
                const tileIds = getTileIdsAtLevel(layer, info.x, info.y, zoom, nw, offset, dy, scale, 0);
                for (let j = 0; j < tileIds.length; j++) {
                    const skinTile = tileIds[j];
                    if (skinTileIds.has(skinTile.id)) {
                        continue;
                    }
                    skinTile.idx = skinTile.x;
                    skinTile.idy = skinTile.y;
                    skinTile.res = skinRes;
                    skinTile.url = layer.getTileUrl(skinTile.x, skinTile.y, skinTile.z + layer.options['zoomOffset']);

                    const xOffset = dx * (skinTile.x - leftX) * tileSize;
                    const yOffset = dy * (skinTile.skinY - topY) * tileSize;
                    const xmin = extent2d.xmin * resScale + xOffset;
                    const ymax = extent2d.ymax * resScale + yOffset;
                    const ymin = extent2d.ymin * resScale + yOffset;
                    if (scaleY > 0) {
                        skinTile.extent2d = new maptalks.PointExtent(
                            xmin,
                            ymin,
                            xmin + tileSize,
                            ymin + tileSize
                        );
                    } else {
                        skinTile.extent2d = new maptalks.PointExtent(
                            xmin,
                            ymax - tileSize,
                            xmin + tileSize,
                            ymax
                        );
                    }

                    skinTileIds.add(skinTile.id);
                    layerTiles.push(skinTile);
                }
                info.skinTileIds[layerId] = layerTiles;
            }
            const tileSkinTiles = info.skinTileIds[layerId];
            for (let j = 0; j < tileSkinTiles.length; j++) {
                if (!allSkinTileIds.has(tileSkinTiles[j].id)) {
                    if (i < parentCount) {
                        parentSkinTiles.push(tileSkinTiles[j]);
                    } else {
                        skinTiles.push(tileSkinTiles[j]);
                    }
                    allSkinTileIds.add(tileSkinTiles[j].id);
                }
            }
        }
        return {
            tileGrids: [
                {
                    extent: grid.extent,
                    tiles: skinTiles,
                    parents: parentSkinTiles,
                    count: skinTiles.length
                }
            ],
            count: skinTiles.length
        };
    }

    getSkinLayer(index) {
        return this.getSkinLayers()[index];
    }

    getSkinLayerById(id) {
        return this.getSkinLayers().filter(layer => layer.getId() === id)[0];
    }

    getSkinLayers() {
        return this._skinLayers || EMPTY_ARRAY;
    }

    getSkinCount() {
        return this._skinLayers && this._skinLayers.length || 0;
    }

    queryTerrainByProjCoord(prjCoord, out) {
        out = out || [];
        const renderer = this.getRenderer();
        if (!renderer) {
            out[0] = null;
            out[1] = 0;
            return out;
        }
        const map = this.getMap();
        const tileInfo = renderer._getTerrainTileAtPrjCoord(prjCoord);
        if (!tileInfo) {
            out[0] = null;
            out[1] = 0;
            return out;
        }
        const worldPos = map['_prjToPointAtRes'](prjCoord, 1, POINT0);
        return renderer._queryTerrain(out, tileInfo.id, tileInfo, worldPos, 1);
    }

    queryTileTerrainByProjCoord(prjCoord, tileId, tileIndex, out) {
        out = out || [];
        const renderer = this.getRenderer();
        if (!renderer) {
            out[0] = null;
            out[1] = 0;
            return out;
        }
        const map = this.getMap();
        const worldPos = map['_prjToPointAtRes'](prjCoord, 1, POINT0);
        return renderer._queryTerrain(out, tileId, tileIndex, worldPos, 1);
    }

    queryTileTerrainByPointAtRes(point, res, tileId, tileIndex, out) {
        out = out || [];
        const renderer = this.getRenderer();
        if (!renderer) {
            out[0] = null;
            out[1] = 0;
            return out;
        }
        return renderer._queryTerrain(out, tileId, tileIndex, point, res);
    }

    queryTerrain(coordinate, out) {
        out = out || [];
        const renderer = this.getRenderer();
        if (!renderer) {
            out[0] = null;
            out[1] = 0;
            return out;
        }
        const projection = this.getMap().getProjection();
        const projCoord = projection.project(coordinate, COORD0);
        return this.queryTerrainByProjCoord(projCoord, out);
    }

    queryTileMesh(tile, cb) {
        const renderer = this.getRenderer();
        if (!renderer) {
            return;
        }
        renderer._queryTileMesh(tile, cb);
    }

    // get terrain tiles against tileInfo of the given layer
    getTerrainTiles(layer, tileInfo) {
        const { x, y, z, res, offset } = tileInfo;
        const tileSize = tileInfo.extent2d.getWidth();
        const tc = this['_getTileConfig']();
        const layerTC = layer['_getTileConfig']();
        const sr = this.getSpatialReference();
        const { res: terrainRes, zoom } = getSkinTileRes(sr, z, res);

        const terrainTileSize = this.getTileSize().width;

        const scale = getSkinTileScale(terrainRes, terrainTileSize, res, tileSize);
        let nw = tileInfo.nw;
        if (!nw) {
            nw = tileInfo.nw = this.getMap().pointAtResToCoord(tileInfo.extent2d.getMin(POINT0), tileInfo.res);
        }

        const terrainTiles = getCascadeTileIds(this, x, y, zoom, nw, offset, layerTC.tileSystem.scale.y, scale, 1)[0];
        for (let i = 0; i < terrainTiles.length; i++) {
            const { x: tx, y: ty } = terrainTiles[i];
            const nw = tc.getTilePointNW(tx, ty, terrainRes, POINT0);
            terrainTiles[i].res = terrainRes;
            terrainTiles[i].extent2d = new maptalks.PointExtent(nw.x, nw.y, nw.x + terrainTileSize, nw.y - terrainTileSize);
        }
        return terrainTiles;
    }

    isTerrainTileLoaded(tileId) {
        const renderer = this.getRenderer();
        if (!renderer) {
            return false;
        }
        return renderer.isTileCached(tileId);
    }

    updateMaterial(mat) {
        if (!mat) {
            return;
        }
        if (!this.options['material']) {
            this.options['material'] = {};
        }
        extend(this.options['material'], mat);
        const renderer = this.getRenderer();
        if (!renderer) {
            return;
        }
        renderer.updateMaterial(mat);
    }

    setMaterial(mat) {
        if (!mat) {
            return;
        }
        this.options['material'] = mat;
        const renderer = this.getRenderer();
        if (!renderer) {
            return;
        }
        renderer.setMaterial(mat);
    }

    _createTileNode(x, y, z, idx, idy, res, error, parentId, extent2d, tileId) {
        const map = this.getMap();
        const zoomOffset = this.options['zoomOffset'];
        if (!extent2d) {
            const tileConfig = this._getTileConfig();
            extent2d = tileConfig.getTilePrjExtent(x, y, res).convertTo(c => map._prjToPointAtRes(c, res, TEMP_POINT$2));
        }
        const offset = this._getTileOffset(z);

        return {
            parent: parentId,
            layer: this.getId(),
            x: x,
            y,
            z,
            idx,
            idy,
            res,
            extent2d,
            id: tileId || this._getTileId(x, y, z),
            url: this.getTileUrl(x, y, z + zoomOffset),
            offset,
            error,
            children: []
        };
    }

    _getErrorScale() {
        return this.options.errorScale / 6;
    }
}

// TerrainLayer.include({
//     getTileId: (x, y, z) => {
//         // always assume terrain layer is pyramid mode
//         // 由字符串操作改为数值操作，提升性能
//         const total = Math.pow(4, z + 1);
//         const row = Math.sqrt(total / 4);
//         return '' + (total + x * row + y);
//     }
// })

TerrainLayer.mergeOptions(options$2);
TerrainLayer.registerJSONType('TerrainLayer');

TerrainLayer.registerRenderer('gl', TerrainLayerRenderer);
TerrainLayer.registerRenderer('gpu', TerrainLayerRenderer);

function getStaleSkinLayers(currentLayers, layers) {
    const result = [];
    for (let i = 0; i < currentLayers.length; i++) {
        if (layers.indexOf(currentLayers[i]) === -1) {
            result.push(currentLayers[i]);
        }
    }
    return result;
}

const TRIANGLE = [], POS_A = [], POS_B = [], POS_C = [], TEMP_POINT$1 = new Point(0, 0), NULL_ALTITUDES = [];
const TEMP_VEC_AB = [], TEMP_VEC_AC = [];
const EMPTY_MAT = [];
const pA_VEC = [], pB_VEC = [], pC_VEC = [];
const INTERSECT_POINT = [];
const bboxIntersects = [];
class RayCaster {
    constructor(from, to, isLngLat = true) {
        this._from = from;
        this._to = to;
        this._isLngLat = isLngLat;
    }

    setFromPoint(from) {
        this._from = Array.isArray(from) ? new Coordinate(from) : from;
    }

    setToPoint(to) {
        this._to = Array.isArray(to) ? new Coordinate(to) : to;
    }

    test(meshes, map, options = {}) {
        const count = options.count || 0;
        const results = [];
        let from = this._from;
        let to = this._to;
        if (this._isLngLat) {
            from = coordinateToWorld(map, this._from.x, this._from.y, this._from.z);
            to = coordinateToWorld(map, this._to.x, this._to.y, this._to.z);
        }
        const ray = new maptalks.math.Ray(from, to);
        for (let i = 0; i < meshes.length; i++) {
            const mesh = meshes[i];
            if (!this._checkBBox(mesh.getBoundingBox(), ray)) {
                continue;
            }
            const localTransform = mesh.localTransform;
            const geometry = mesh.geometry;
            const positions = geometry.data[geometry.desc.positionAttribute].array;
            const altitudes = (geometry.data[geometry.desc.altitudeAttribute] && geometry.data[geometry.desc.altitudeAttribute].array) || NULL_ALTITUDES;
            const geoIndices = geometry.indices;
            if (!positions || !positions.length || !geoIndices || !geoIndices.length) {
                // console.warn('there are no POSITION or inidces in mesh');
                continue;
            }
            const matrix = mat4.multiply(EMPTY_MAT, localTransform, mesh.positionMatrix);
            const coordinates = this._testMesh(mesh, ray, map, positions, altitudes, geoIndices, geometry.desc.positionSize, matrix, count);
            if (coordinates) {
                // const { coordinate, indices } = intersect;
                const result = {
                    mesh,
                    coordinates
                };
                results.push(result);
                if (count !== 0 && results.length >= count) {
                    break;
                }
            }
        }
        return results;
    }

    _testMesh(mesh, ray, map, positions, altitudes, indices, dim, matrix, count) {
        const coordinates = [];
        const glRes = map.getGLRes();
        for (let j = 0; j < indices.length; j += 3) {
            if (j > mesh.properties.skirtOffset) {
                break;
            }
            const a = indices[j];
            const b = indices[j + 1];
            const c = indices[j + 2];
            const aindex = a * dim, bindex = b * dim, cindex = c * dim;
            //高频操作,尽可能的减少function(vec3.set) call,
            pA_VEC[0] = positions[aindex];
            pA_VEC[1] = positions[aindex + 1];
            pA_VEC[2] = positions[aindex + 2];

            pB_VEC[0] = positions[bindex];
            pB_VEC[1] = positions[bindex + 1];
            pB_VEC[2] = positions[bindex + 2];

            pC_VEC[0] = positions[cindex];
            pC_VEC[1] = positions[cindex + 1];
            pC_VEC[2] = positions[cindex + 2];


            const pA = this._toWorldPosition(POS_A, map, pA_VEC, altitudes[a] / 100, matrix);
            const pB = this._toWorldPosition(POS_B, map, pB_VEC, altitudes[b] / 100, matrix);
            const pC = this._toWorldPosition(POS_C, map, pC_VEC, altitudes[c] / 100, matrix);

            // const positionsA = vec3.set(pA_VEC, positions[a * dim], positions[a * dim + 1], positions[a * dim + 2]);
            // const pA = this._toWorldPosition(POS_A, map, positionsA, altitudes[a] / 100, matrix);
            // const positionsB = vec3.set(pB_VEC, positions[b * dim], positions[b * dim + 1], positions[b * dim + 2]);
            // const pB = this._toWorldPosition(POS_B, map, positionsB, altitudes[b] / 100, matrix);
            // const positionsC = vec3.set(pC_VEC, positions[c * dim], positions[c * dim + 1], positions[c * dim + 2]);
            // const pC = this._toWorldPosition(POS_C, map, positionsC, altitudes[c] / 100, matrix);

            const triangle = vec3.set(TRIANGLE, pA, pB, pC);
            const vAB = vec3.sub(TEMP_VEC_AB, pA, pB);
            const vAC = vec3.sub(TEMP_VEC_AC, pA, pC);
            const intersectPoint = this._testIntersection(INTERSECT_POINT, triangle, ray);
            if (intersectPoint) {
                const altitude = map.pointAtResToAltitude(intersectPoint[2], glRes);
                TEMP_POINT$1.x = intersectPoint[0];
                TEMP_POINT$1.y = intersectPoint[1];
                const coord = map.pointAtResToCoordinate(TEMP_POINT$1, glRes);
                coord.z = altitude;
                coordinates.push({
                    coordinate: coord,
                    indices: [a, b, c],
                    normal: vec3.cross([], vAB, vAC)
                });
                if (count !== 0 && coordinates.length >= count) {
                    break;
                }
            }
        }
        return coordinates.length ? coordinates : null;
    }

    _toWorldPosition(out, map, pos, altitude, matrix) {
        let alt;
        if (Util$1.isNumber(altitude)) {
            alt = map.altitudeToPoint(altitude, map.getGLRes());
            vec4.set(out, pos[0], pos[1], 0, 1);
            vec4.transformMat4(out, out, matrix);
            out[2] = alt;
        } else {
            vec4.set(out, pos[0], pos[1], pos[2], 1);
            vec4.transformMat4(out, out, matrix);
        }
        return out;
    }

    _testIntersection(out, triangle, ray) {
        return ray.intersectTriangle(triangle[0], triangle[1], triangle[2], true, out);
    }

    _checkBBox(bbox, ray) {
        if (!bbox) {
            return false;
        }
        return ray.intersectBox(bbox, bboxIntersects);
    }
}


const COORD = new Coordinate(0, 0);

function coordinateToWorld(map, x, y, z) {
    if (!map) {
        return null;
    }
    COORD.set(x, y);
    const p = map.coordinateToPointAtRes(COORD, map.getGLRes());
    const height = map.altitudeToPoint(z || 0, map.getGLRes());
    return [p.x, p.y, height];
}

const options$1 = {
    renderer: 'gl',
    antialias: true,
    extensions: [],
    single: true,
    onlyWebGL1: false,
    optionalExtensions: [
        'ANGLE_instanced_arrays',
        'OES_element_index_uint',
        'OES_standard_derivatives',
        'OES_vertex_array_object',
        'OES_texture_half_float',
        'OES_texture_half_float_linear',
        'OES_texture_float',
        'OES_texture_float_linear',
        'WEBGL_depth_texture',
        'EXT_shader_texture_lod',
        'EXT_frag_depth',
        'EXT_texture_filter_anisotropic',
        // compressed textures
        'WEBGL_compressed_texture_astc',
        'WEBGL_compressed_texture_etc',
        'WEBGL_compressed_texture_etc1',
        'WEBGL_compressed_texture_pvrtc',
        'WEBGL_compressed_texture_s3tc',
        'WEBGL_compressed_texture_s3tc_srgb'
    ],
    forceRenderOnZooming: true,
    forceRenderOnMoving: true,
    forceRenderOnRotating: true,
    viewMoveThreshold: 100,
    geometryEvents: true,
    multiSamples: 4,
    forceRedrawPerFrame: false
};
//
const emptyMethod = () => { return; };
const EMPTY_COORD0 = new maptalks.Coordinate(0, 0);
const TEMP_VEC3 = [0, 0, 0];
const coord0 = [0, 0, 0], coord1 = [0, 0, 0];
class GroupGLLayer extends maptalks.Layer {
    /**
     * Reproduce a GroupGLLayer from layer's profile JSON.
     * @param  {Object} layerJSON - layer's profile JSON
     * @return {GroupGLLayer}
     * @static
     * @private
     * @function
     */
    static fromJSON(layerJSON) {
        if (!layerJSON || layerJSON['type'] !== 'GroupGLLayer') {
            return null;
        }
        const layers = layerJSON['layers'].map(json => maptalks.Layer.fromJSON(json));
        return new GroupGLLayer(layerJSON['id'], layers, layerJSON['options']);
    }
    /**
     * @param id    - layer's id
     * @param layers      - layers to add
     * @param  [options=null]          - construct options
     */
    constructor(id, layers, options) {
        super(id, options);
        this.layers = layers && layers.slice() || [];
        this.layers.forEach(layer => {
            if (layer.getMap()) {
                throw new Error(`layer(${layer.getId()} is already added on map`);
            }
        });
        this._checkChildren();
        this.sortLayersByZIndex();
        this._layerMap = {};
    }
    sortLayersByZIndex() {
        if (!this.layers || !this.layers.length) {
            return;
        }
        for (let i = 0, l = this.layers.length; i < l; i++) {
            this.layers[i]['__group_gl_order'] = i;
        }
        this.layers.sort(sortLayersByZIndex);
    }
    setSceneConfig(sceneConfig) {
        this.options.sceneConfig = sceneConfig;
        const renderer = this.getRenderer();
        if (renderer) {
            renderer.updateSceneConfig();
        }
        return this;
    }
    getSceneConfig() {
        return JSON.parse(JSON.stringify(this._getSceneConfig()));
    }
    //@internal
    _getSceneConfig() {
        return this.options.sceneConfig || {};
    }
    getGroundConfig() {
        const sceneConfig = this._getSceneConfig();
        return sceneConfig.ground;
    }
    getWeatherConfig() {
        const sceneConfig = this._getSceneConfig();
        return sceneConfig.weather;
    }
    getScanEffectConfig() {
        const sceneConfig = this._getSceneConfig();
        return sceneConfig.postProcess && sceneConfig.postProcess.scanEffect;
    }
    /**
     * Add a new Layer.
     * @param layer - new layer
     * @param index - index to insert
     * @returns {GroupGLLayer} this
     */
    addLayer(layer, index) {
        if (layer.getMap()) {
            throw new Error(`layer(${layer.getId()}) is already added on map`);
        }
        if (layer.options['renderer'] !== 'gl') {
            throw new Error(`layer(${layer.getId()})'s renderer is canvas, not supported to be added to GroupGLLayer`);
        }
        if (index === undefined) {
            this.layers.push(layer);
        }
        else {
            this.layers.splice(index, 0, layer);
        }
        this._checkChildren();
        this.sortLayersByZIndex();
        const renderer = this.getRenderer();
        if (!renderer) {
            // not loaded yet
            return this;
        }
        this._prepareLayer(layer);
        this._updateTerrainSkinLayers();
        renderer.setToRedraw();
        return this;
    }
    removeLayer(layer) {
        if (maptalks.Util.isString(layer)) {
            layer = this.getChildLayer(layer);
        }
        const idx = this.layers.indexOf(layer);
        if (idx < 0) {
            return this;
        }
        const layerRenderer = layer.getRenderer();
        if (layerRenderer && layerRenderer.setTerrainHelper) {
            layerRenderer.setTerrainHelper(null);
        }
        layer['_doRemove']();
        this._unbindChildListeners(layer);
        delete this._layerMap[layer.getId()];
        this.layers.splice(idx, 1);
        const renderer = this.getRenderer();
        if (!renderer) {
            // not loaded yet
            return this;
        }
        this._updateTerrainSkinLayers();
        renderer.setToRedraw();
        return this;
    }
    clearLayers() {
        const layers = this.getLayers();
        for (let i = 0; i < layers.length; i++) {
            if (layers[i]) {
                layers[i].remove();
            }
        }
        return this;
    }
    //@internal
    _updatePolygonOffset() {
        let total = 0;
        for (let i = 0; i < this.layers.length; i++) {
            const layer = this.layers[i];
            if (layer.setPolygonOffset && layer.getPolygonOffsetCount) {
                total += layer.getPolygonOffsetCount();
            }
        }
        let offset = 0;
        const len = this.layers.length;
        for (let i = len - 1; i >= 0; i--) {
            const layer = this.layers[i];
            if (layer.setPolygonOffset && layer.getPolygonOffsetCount) {
                layer.setPolygonOffset(offset, total);
                offset += layer.getPolygonOffsetCount();
            }
        }
        this._polygonOffset = offset;
    }
    getPolygonOffsetCount() {
        return this._polygonOffset;
    }
    /**
     * Get children TileLayer
     * @returns {TileLayer[]}
     */
    getLayers() {
        return this.layers.slice();
    }
    //@internal
    _getLayers() {
        return this.layers;
    }
    /**
     * 导出GroupGLLayer的序列化JSON对象，可以用于反序列化为一个GroupGLLayer对象。
     * @english
     * Export the GroupGLLayer's profile json. <br>
     * Layer's profile is a snapshot of the layer in JSON format. <br>
     * It can be used to reproduce the instance by [fromJSON]{@link Layer#fromJSON} method
     * @return layer's profile JSON
     */
    toJSON() {
        const layers = [];
        if (this.layers) {
            for (let i = 0; i < this.layers.length; i++) {
                const layer = this.layers[i];
                if (!layer) {
                    continue;
                }
                if (layer && layer.toJSON) {
                    layers.push(layer.toJSON());
                }
            }
        }
        const profile = {
            'type': this.getJSONType(),
            'id': this.getId(),
            'layers': layers,
            'options': this.config()
        };
        return profile;
    }
    onLoadEnd() {
        this.layers.forEach(layer => {
            this._prepareLayer(layer);
        });
        if (this.options['terrain']) {
            this._initTerrainLayer();
        }
        super.onLoadEnd();
    }
    //@internal
    _prepareLayer(layer) {
        const renderer = this.getRenderer();
        this._layerMap[layer.getId()] = layer;
        layer['_canvas'] = renderer.canvas;
        layer['_bindMap'](this);
        layer.once('renderercreate', this._onChildRendererCreate, this);
        // layer.on('setstyle updatesymbol', this._onChildLayerStyleChanged, this);
        layer.remove = () => {
            this.removeLayer(layer);
            layer.constructor.prototype.remove.call(layer);
            delete layer.remove;
            return this;
        };
        layer.load();
        this._bindChildListeners(layer);
    }
    _onChildLayerZIndexChanged() {
        this.sortLayersByZIndex();
        this._updateTerrainSkinLayers();
    }
    onRemove() {
        this._removeTerrainLayer();
        this.layers.forEach(layer => {
            this._resetSkinLayer(layer);
            layer['_doRemove']();
            this._unbindChildListeners(layer);
        });
        this._layerMap = {};
        this.clearAnalysis();
        super.onRemove();
    }
    getChildLayer(id) {
        const layer = this._layerMap[id];
        return layer || null;
    }
    getLayer(id) {
        return this.getChildLayer(id);
    }
    //@internal
    _bindChildListeners(layer) {
        layer.on('show hide', this._onLayerShowHide, this);
        layer.on('idchange', this._onLayerIDChange, this);
        layer.on('setzindex', this._onChildLayerZIndexChanged, this);
    }
    //@internal
    _unbindChildListeners(layer) {
        layer.off('show hide', this._onLayerShowHide, this);
        layer.off('idchange', this._onLayerIDChange, this);
        layer.off('setzindex', this._onChildLayerZIndexChanged, this);
    }
    //@internal
    _onLayerShowHide() {
        const renderer = this.getRenderer();
        if (renderer) {
            renderer.setToRedraw();
        }
    }
    //@internal
    _onLayerIDChange(e) {
        const newId = e.new;
        const oldId = e.old;
        const layer = this.getLayer(oldId);
        delete this._layerMap[oldId];
        this._layerMap[newId] = layer;
    }
    //@internal
    _onChildRendererCreate(e) {
        e.renderer.clearCanvas = empty;
    }
    // _onChildLayerStyleChanged() {
    //     const renderer = (this as any).getRenderer();
    //     if (renderer) {
    //         renderer.setTaaOutdated();
    //     }
    // }
    // isVisible() {
    //     if (!super.isVisible()) {
    //         return false;
    //     }
    //     const children = this.layers;
    //     for (let i = 0, l = children.length; i < l; i++) {
    //         if (children[i].isVisible()) {
    //             return true;
    //         }
    //     }
    //     return false;
    // }
    //@internal
    _checkChildren() {
        const ids = {};
        this.layers.forEach(layer => {
            const layerId = layer.getId();
            if (ids[layerId]) {
                throw new Error(`Duplicate child layer id (${layerId}) in the GroupGLLayer (${this.getId()})`);
            }
            else {
                ids[layerId] = 1;
            }
        });
    }
    addAnalysis(analysis) {
        this._analysisTaskList = this._analysisTaskList || [];
        this._analysisTaskList.push(analysis);
        const renderer = this.getRenderer();
        if (renderer) {
            renderer.setToRedraw();
        }
    }
    removeAnalysis(analysis) {
        if (this._analysisTaskList) {
            const index = this._analysisTaskList.indexOf(analysis);
            if (index > -1) {
                this._analysisTaskList.splice(index, 1);
                analysis.remove();
            }
        }
        const renderer = this.getRenderer();
        if (renderer) {
            renderer.setToRedraw();
        }
    }
    clearAnalysis() {
        if (this._analysisTaskList) {
            this._analysisTaskList.forEach(analysis => {
                analysis.remove();
            });
            this._analysisTaskList = [];
        }
        const renderer = this.getRenderer();
        if (renderer) {
            renderer.setToRedraw();
        }
    }
    /**
     * 查询给定坐标上的数据要素
     *
     * @english
     * Identify the geometries on the given coordinate
     * @param  coordinate   - coordinate to identify
     * @param  options      - options
     * @return
     */
    identify(coordinate, options) {
        const map = this.getMap();
        const renderer = this.getRenderer();
        if (!map || !renderer) {
            return [];
        }
        const cp = map.coordToContainerPoint(new maptalks.Coordinate(coordinate));
        return this.identifyAtPoint(cp, options);
    }
    /**
     * 查询给定容器坐标（containerPoint）上的数据要素
     * @english
     * Identify the data at the given point
     * @param point - container point to identify
     * @param options - the identify options
     **/
    identifyAtPoint(point, options = {}) {
        const isMapGeometryEvent = options.includeInternals;
        const childLayers = this.getLayers();
        const layers = (options && options.childLayers) || childLayers;
        const map = this.getMap();
        if (!map) {
            return [];
        }
        const count = isNil$1(options.count) ? 1 : options.count;
        let result = [];
        const len = layers.length;
        for (let i = len - 1; i >= 0; i--) {
            const layer = layers[i];
            if (childLayers.indexOf(layer) < 0 || !layer.identifyAtPoint) {
                continue;
            }
            const geometryEvents = layer.options['geometryEvents'];
            if (isMapGeometryEvent && (geometryEvents === undefined || geometryEvents === false || geometryEvents === 0)) {
                continue;
            }
            if (layer.isGeometryListening && isMapGeometryEvent && options.eventTypes.indexOf('mousemove') >= 0) {
                if (!layer.isGeometryListening(options.eventTypes)) {
                    continue;
                }
            }
            const picks = layer.identifyAtPoint(point, options);
            if (!picks || !picks.length) {
                continue;
            }
            const id = layer.getId();
            for (let j = 0; j < picks.length; j++) {
                if (picks[j]) {
                    picks[j].layer = id;
                }
            }
            result.push(...picks);
        }
        if (options.orderByCamera) {
            const cameraPosition = map.cameraPosition;
            result.sort((a, b) => {
                if (!b.point) {
                    return -1;
                }
                else if (!a.point) {
                    return 1;
                }
                return vec3.dist(a.point, cameraPosition) - vec3.dist(b.point, cameraPosition);
            });
        }
        if (count) {
            result = result.slice(0, count);
        }
        return result;
    }
    getTerrain() {
        return this.options.terrain;
    }
    setTerrain(info) {
        this.options.terrain = info;
        if (!this.getRenderer()) {
            return this;
        }
        this._initTerrainLayer();
        this.getMap().updateCenterAltitude();
        return this;
    }
    removeTerrain() {
        return this.setTerrain(null);
    }
    updateTerrainMaterial(mat) {
        if (!this._terrainLayer || !mat) {
            return;
        }
        if (!this.options.terrain.material) {
            this.options.terrain.material = mat;
        }
        else {
            extend(this.options.terrain.material, mat);
        }
        this._terrainLayer.updateMaterial(mat);
    }
    //@internal
    _initTerrainLayer() {
        const renderer = this.getRenderer();
        if (renderer) {
            renderer.setToRedraw();
        }
        const info = this.options['terrain'];
        if (this._terrainLayer) {
            const terrainLayer = this._terrainLayer;
            const options = terrainLayer.options;
            if (!info || options.urlTemplate !== info.urlTemplate || options.spatialReference !== info.spatialReference) {
                this._removeTerrainLayer();
            }
            else {
                for (const p in info) {
                    if (p === 'material') {
                        terrainLayer.setMaterial(info[p]);
                    }
                    else if (p !== 'urlTemplate' && p !== 'spatialReference') {
                        terrainLayer.config(p, info[p]);
                    }
                }
                return this;
            }
        }
        this._resetTerrainSkinLayers();
        if (!info) {
            return this;
        }
        this._terrainLayer = new TerrainLayer('__terrain_in_group', info);
        this._updateTerrainSkinLayers();
        const terrainLayer = this._terrainLayer;
        terrainLayer.on('tileload', this._onTerrainTileLoad, this);
        this._prepareLayer(terrainLayer);
        const masks = info.masks;
        if (masks && masks.length) {
            terrainLayer.setMask(masks);
        }
        else {
            terrainLayer.removeMask();
        }
        this.fire('terrainlayercreated');
        return this;
    }
    queryTerrain(coord, out) {
        if (!this._terrainLayer) {
            if (out) {
                out[0] = null;
                out[1] = 0;
            }
            return [null, 0];
        }
        return this._terrainLayer.queryTerrain(coord, out);
    }
    // 结果需要与queryTerrain统一起来
    queryTerrainAtPoint(containerPoint) {
        if (!this._terrainLayer) {
            return null;
        }
        const terrainLayer = this._terrainLayer;
        const terrainRenderer = terrainLayer.getRenderer();
        const meshes = terrainRenderer.getAnalysisMeshes();
        return this._queryRayCast(containerPoint, meshes);
    }
    query3DTilesAtPoint(containerPoint) {
        const layers = this._getLayers();
        const tilesLayers = layers.filter(layer => layer && layer.isGeo3DTilesLayer);
        if (!tilesLayers.length) {
            return null;
        }
        const options = { excludeMasks: true };
        for (let i = 0; i < tilesLayers.length; i++) {
            const renderer = tilesLayers[i].getRenderer();
            if (!renderer) {
                continue;
            }
            const hits = tilesLayers[i].identifyAtPoint(containerPoint, options);
            if (hits.length) {
                return new maptalks.Coordinate(hits[0].coordinate);
            }
        }
        return null;
    }
    _queryRayCast(containerPoint, meshes) {
        const map = this.getMap();
        const glRes = map.getGLRes();
        map.getContainerPointRay(coord0, coord1, containerPoint);
        const raycaster = new RayCaster(coord0, coord1, false);
        const results = raycaster.test(meshes, map, { count: 1 });
        const coordinates = [];
        results.forEach(result => {
            result.coordinates.forEach(c => {
                coordinates.push(c.coordinate);
            });
        });
        const from = map.pointAtResToCoordinate(new maptalks.Point(coord0[0], coord0[1]), glRes, EMPTY_COORD0);
        if (!this._meterToGLPoint) {
            this._meterToGLPoint = map.altitudeToPoint(1, glRes);
        }
        from.z = coord0[2] / this._meterToGLPoint;
        const fromPoint = vec3.set(TEMP_VEC3, from.x, from.y, from.z);
        coordinates.sort((a, b) => {
            return vec3.dist(a.toArray(), fromPoint) - vec3.dist(b.toArray(), fromPoint);
        });
        return coordinates[0];
    }
    queryTerrainByProjCoord(projCoord, out) {
        if (!this._terrainLayer) {
            if (out) {
                out[0] = null;
                out[1] = 0;
            }
            return [null, 0];
        }
        return this._terrainLayer.queryTerrainByProjCoord(projCoord, out);
    }
    //@internal
    _updateTerrainSkinLayers() {
        if (!this._terrainLayer) {
            return;
        }
        const layers = this.layers;
        const skinLayers = [];
        for (let i = 0; i < layers.length; i++) {
            if (!layers[i]) {
                continue;
            }
            const layer = layers[i];
            const renderer = layer.getRenderer();
            if (renderer.renderTerrainSkin) {
                if (renderer.deleteTile === emptyMethod) {
                    // 已经被初始化过了
                    skinLayers.push(layers[i]);
                    continue;
                }
                const getTilesFn = layer.getTiles;
                layer.getTiles = (...args) => {
                    // debugger
                    if (!layer.options['awareOfTerrain']) {
                        return getTilesFn.call(layer, ...args);
                    }
                    return this._terrainLayer && this._terrainLayer.getSkinTiles(layer);
                };
                // 重载原有的drawTile方法
                // 如果renderer定义了drawTileOnTerrain，则代替原有的drawTile，否则用空方法代替
                const drawTileFn = renderer.drawTile;
                if (renderer.drawTileOnTerrain) {
                    renderer.drawTile = (...args) => {
                        if (!layer.options['awareOfTerrain']) {
                            return drawTileFn.call(renderer, ...args);
                        }
                        return renderer.drawTileOnTerrain(...args);
                    };
                }
                else {
                    renderer.drawTile = (...args) => {
                        if (!layer.options['awareOfTerrain']) {
                            return drawTileFn.call(renderer, ...args);
                        }
                    };
                }
                // skinLayer的deleteTile交由TerrainLayerRenderer.deleteTile中手动执行
                const deleteTileFn = renderer.deleteTile;
                renderer.deleteTile = (...args) => {
                    if (!layer.options['awareOfTerrain']) {
                        return deleteTileFn.call(renderer, ...args);
                    }
                };
                skinLayers.push(layers[i]);
            }
            if (renderer.setTerrainHelper) {
                renderer.setTerrainHelper(this._terrainLayer);
            }
        }
        this._terrainLayer.setSkinLayers(skinLayers);
    }
    //@internal
    _resetSkinLayer(layer) {
        if (!isTerrainSkin(layer)) {
            return;
        }
        const renderer = layer.getRenderer();
        if (renderer) {
            if (renderer.setTerrainHelper) {
                renderer.setTerrainHelper(null);
            }
            if (renderer.clear) {
                renderer.clear();
            }
            delete renderer.drawTile;
            delete renderer.deleteTile;
        }
        delete layer.getTiles;
    }
    //@internal
    _resetTerrainSkinLayers() {
        const layers = this.layers;
        for (let i = 0; i < layers.length; i++) {
            if (!layers[i]) {
                continue;
            }
            this._resetSkinLayer(layers[i]);
        }
    }
    //@internal
    _onTerrainTileLoad() {
        const renderer = this.getRenderer();
        if (renderer) {
            renderer.setToRedraw();
        }
    }
    //@internal
    _removeTerrainLayer() {
        if (this._terrainLayer) {
            const layer = this._terrainLayer;
            layer.off('tileload', this._onTerrainTileLoad, this);
            this._unbindChildListeners(layer);
            this._terrainLayer['_doRemove']();
            delete this._terrainLayer;
            this.fire('terrainlayerremoved');
        }
    }
    getTerrainLayer() {
        return this._terrainLayer;
    }
    //@internal
    _bindMap(...args) {
        if (this.options['single']) {
            const map = args[0];
            const layers = map.getLayers();
            for (let i = 0; i < layers.length; i++) {
                if (layers[i] instanceof GroupGLLayer) {
                    throw new Error('Only one GroupGLLayer is allowed in a map instance. Set options.single to false if you want to add two or more GroupGLLayers.');
                }
            }
        }
        return super['_bindMap'](...args);
    }
    fire(...args) {
        if (args[0] === 'layerload') {
            const layers = this._getLayers();
            for (const layer of layers) {
                const renderer = layer.getRenderer();
                if (renderer && renderer.isRenderComplete()) {
                    layer.fire('layerload');
                }
            }
        }
        //@ts-expect-error-error
        super.fire(...args);
    }
}
GroupGLLayer.mergeOptions(options$1);
GroupGLLayer.registerJSONType('GroupGLLayer');
GroupGLLayer.registerRenderer('gl', GroupGLLayerRenderer);
GroupGLLayer.registerRenderer('gpu', GroupGLLayerRenderer);
GroupGLLayer.registerRenderer('canvas', null);
function empty() { return; }
function sortLayersByZIndex(a, b) {
    const c = a.getZIndex() - b.getZIndex();
    if (c === 0) {
        return a['__group_gl_order'] - b['__group_gl_order'];
    }
    return c;
}
function isTerrainSkin(layer) {
    if (!layer) {
        return false;
    }
    const renderer = layer.getRenderer();
    if (!renderer) {
        return false;
    }
    return !!renderer.renderTerrainSkin;
}
var SkyboxMode;
(function (SkyboxMode) {
    SkyboxMode[SkyboxMode["AMBIENT"] = 0] = "AMBIENT";
    SkyboxMode[SkyboxMode["REALISTIC"] = 1] = "REALISTIC";
})(SkyboxMode || (SkyboxMode = {}));

let actor;
function getWorkerActor() {
    if (!actor) {
        actor = new worker.Actor('maplight');
    }
    return actor;
}

//cal projectEnvironmentMapCPU by worker
function projectEnvironmentMapCPU(params, callback) {
    const { cubePixels, width, height } = params;
    const buffers = cubePixels.map(face => {
        return face.buffer;
    });
    getWorkerActor().send({
        cubePixels: buffers,
        width,
        height,
    }, buffers, (err, data) => {
        if (err) {
            console.error(err);
            return;
        }
        callback(data.shList);
    });

}

const PREFILTER_CUBE_SIZE = 512;

class LightManager {

    constructor(map) {
        this._map = map;
        this._loader = new ResourceLoader();
        this.updateTime = Util$1.now();
    }

    getDirectionalLight() {
        return this._config && this._config.directional || {};
    }

    getAmbientLight() {
        return this._config && this._config.ambient || {};
    }

    getAmbientResource() {
        return this._iblMaps;
    }

    setConfig(config) {
        const oldConfig = this._config;
        this._urlModifier = config.urlModifier;
        this._config = JSON.parse(JSON.stringify(config));
        let ambientUpdate = false;
        if (!config || !config.ambient || !config.ambient.resource) {
            this._disposeCubeLight();
            ambientUpdate = oldConfig && oldConfig.ambient && oldConfig.ambient.resource;
        } else if (!oldConfig || !oldConfig.ambient || !ambientEqual(oldConfig.ambient, config.ambient)) {
            this._initAmbientResources();
            return;
        } else if (this._iblMaps) {
            const oldResource = oldConfig.ambient && oldConfig.ambient.resource;
            const resource = config.ambient.resource;
            if (resource && resource.prefilterCubeSize !== oldResource && oldResource.prefilterCubeSize) {
                this._onHDRLoaded();
            }
            ambientUpdate = true;
            if (config.ambient.resource.sh) {
                this._iblMaps.sh = config.ambient.resource.sh;
            }
        }
        this._map.fire('updatelights', { ambientUpdate });
    }

    _tryToGetREGLContext(map) {
        const layers = map.getLayers();
        for (let i = 0; i < layers.length; i++) {
            const renderer = layers[i] && layers[i].getRenderer();
            if (!renderer) {
                continue;
            }
            if (renderer.regl) {
                return renderer.regl;
            }
        }
        const canvas = document.createElement('canvas');
        const regl = createREGL({
            canvas,
            attributes: {
                depth: false,
                stencil: false,
                alpha: false
            },
            optionalExtensions: [
                'OES_standard_derivatives',
                'OES_texture_half_float',
                'OES_texture_half_float_linear',
                'OES_texture_float',
                'OES_texture_float_linear',
            ]
        });
        regl._temp = true;
        return regl;
    }

    _initAmbientResources() {
        const resource = this._config.ambient.resource;
        const url = resource && resource.url;
        if (!url) {
            return;
        }
        const images = [];
        let count = 0;
        let currentCount = 0;
        const onload = () => {
            currentCount++;
            if (currentCount >= count) {
                this._onSkyboxLoaded(images);
            }
        };
        const onerror = function () {
            throw new Error(`skybox image with url(${this.src}) failed to load, please check the image's url.`);
        };
        const urlModifier = this._urlModifier;
        if (url.top || url.nx) {
            // ambient with 6 images
            const { front, back, right, left, top, bottom } = url;
            const { nx, ny, px, py, nz, pz } = url;
            let envUrls;
            if (front) {
                envUrls = [left, right, back, front, top, bottom];
            } else {
                envUrls = [nx, px, nz, pz, py, ny];
            }
            count = envUrls.length;
            const crossOrigin = resource.crossOrigin;
            for (let i = 0; i < count; i++) {
                const img = new Image();
                img.onload = onload;
                img.onerror = onerror;
                if (!Util$1.isNil(crossOrigin)) {
                    img.crossOrigin = crossOrigin;
                }
                img.src = urlModifier && urlModifier(envUrls[i]) || envUrls[i];
                images[i] = img;
            }
        } else {
            const props = {
                url: resource.url,
                arrayBuffer: true,
                hdr: true,
                // type: 'uint8',
                // format: 'rgba',
                flipY: true
            };
            this._loader.setURLModifier(urlModifier);
            this._hdr = new Texture2D(
                props,
                this._loader
            );
            this._hdr.once('complete', () => {
                this._onHDRLoaded();
            });
            this._hdr.once('error', () => {
                this._onHDRError();
            });
        }
    }

    dispose() {
        this._disposeCubeLight();
    }

    _onHDRLoaded() {
        if (this._hdr) {
            this._createIBLMaps(this._hdr).then(maps => {
                this._iblMaps = maps;
                this._map.fire('updatelights', { 'ambientUpdate': true });
                if (this.getAmbientLight().debug) {
                    console.log(`ambientLight hdr loadend`);
                }
            });
            // this._hdr.dispose();
            // delete this._hdr;

        }
    }

    _onHDRError() {
        this._map.fire('hdrerror');
    }

    _onSkyboxLoaded(images) {
        this._createIBLMaps(images).then(maps => {
            this._iblMaps = maps;
            this._map.fire('updatelights', { 'ambientUpdate': true });
            if (this.getAmbientLight().debug) {
                console.log(`ambientLight skybox loadend`);
            }
        });
    }

    _createIBLMaps(envTexture) {
        this.updateTime = Util$1.now();
        return new Promise((resolve) => {
            const config = this._config.ambient.resource;
            const cubeSize = config.prefilterCubeSize || PREFILTER_CUBE_SIZE;
            const regl = this._tryToGetREGLContext(this._map);
            const asynchronous = config.asynchronous;
            pbr.PBRHelper.createIBLMapsAsync(regl, {
                updateTime: this.updateTime,
                asynchronous,
                envTexture: Array.isArray(envTexture) ? envTexture : envTexture.getREGLTexture(regl),
                ignoreSH: !!config['sh'],
                envCubeSize: cubeSize,
                prefilterCubeSize: cubeSize,
                environmentExposure: this._config.ambient.exposure,
                format: 'array',
                projectEnvironmentMapCPU: asynchronous ? projectEnvironmentMapCPU : null
            }).then((maps) => {
                //单位时间内多次更新，永远使用最新的
                if (maps.updateTime !== this.updateTime) {
                    return;
                }
                // hdr.dispose();
                if (config['sh']) {
                    maps.sh = config['sh'];
                    //兼容老的[[], [], ..]形式的sh
                    if (Array.isArray(maps['sh'][0])) {
                        const sh = maps['sh'];
                        const flatten = [];
                        for (let i = 0; i < sh.length; i++) {
                            flatten.push(...sh[i]);
                        }
                        maps['sh'] = flatten;
                    }
                }
                if (regl._temp) {
                    delete this._hdr;
                    regl.destroy();
                }
                resolve(maps);
            });

        });

    }

    _disposeCubeLight() {
        if (this._hdr) {
            this._hdr.dispose();
            delete this._hdr;
        }
        delete this._iblMaps;
    }

}

function ambientEqual(config0, config1) {
    if (!config0.resource) {
        return false;
    }
    if (config0.resource.url !== config1.resource.url) {
        return false;
    }
    return true;
}

Map$1.include({
    setLights(config) {
        this.options['lights'] = config;
        this._initLightManager();
        return this;
    },

    getLights() {
        return this.options['lights'];
    },

    _initLightManager() {
        if (!this._lightManager) {
            this._lightManager = new LightManager(this);
        }
        this._lightManager.setConfig(this.getLights());
    },

    getLightManager() {
        if (!this._lightManager) {
            // if (typeof console && !this._warned) {
            //     this._warned = true;
            //     // console.warn('map\'s light config is not set, use map.setLights(config) to set lights.');
            // }
            return null;
        }
        return this._lightManager;
    }
});


Map$1.addOnLoadHook(function () {
    if (this.options['lights']) {
        this._initLightManager();
    }
});

let postCanvas;
let regl;
let texture;
let emptyLutTexture;
let postProcess;
const CLEAR_COLOR = {
    color: [0, 0, 0, 0]
};
const DEFAULT_CONFIG = { enable: false };

Map$1.include({
    setPostProcessConfig(config) {
        this.options['postProcessConfig'] = config;
        return this;
    },

    getPostProcessConfig() {
        return this.options['postProcessConfig'];
    }
});

const drawLayerCanvas = renderer.MapCanvasRenderer.prototype.drawLayerCanvas;
renderer.MapCanvasRenderer.prototype.drawLayerCanvas = function () {
    const updated = drawLayerCanvas.apply(this, arguments);
    if (updated) {
        doPostProcess(this, this.canvas);
    }
    return updated;
};

const renderFrame = renderer.MapCanvasRenderer.prototype.renderFrame;
renderer.MapCanvasRenderer.prototype.renderFrame = function () {
    const rendered = renderFrame.apply(this, arguments);
    const config = this.map.getPostProcessConfig();
    //filmicGrain animation
    const grainConfig = config && config.filmicGrain;
    if (grainConfig && (grainConfig.enable === undefined || grainConfig.enable === true)) {
        this.setToRedraw();
    }
    return rendered;
};

function doPostProcess(renderer, canvas) {
    const config = renderer.map.getPostProcessConfig();
    if (!config || !config.enable) {
        return;
    }
    if (!postCanvas) {
        createContext(canvas.width, canvas.height);
    }
    if (postCanvas.width !== canvas.width || postCanvas.height !== canvas.height) {
        postCanvas.width = canvas.width;
        postCanvas.height = canvas.height;
    }
    regl.clear(CLEAR_COLOR);
    const grainConfig = config.filmicGrain || DEFAULT_CONFIG;
    if (grainConfig.enable === undefined) {
        grainConfig.enable = true;
    }
    const vignetteConfig = config.vignette || DEFAULT_CONFIG;
    if (vignetteConfig.enable === undefined) {
        vignetteConfig.enable = true;
    }
    const lutConfig = config.colorLUT || DEFAULT_CONFIG;
    if (lutConfig.enable === undefined) {
        lutConfig.enable = true;
    }
    if (!renderer._postProcessContext) {
        renderer._postProcessContext = {};
    }
    const context = renderer._postProcessContext;
    if (lutConfig.enable) {
        const url = lutConfig.lut;
        if (!context['lutTexture'] || context['lutTexture'].url !== url) {
            const image = new Image();
            image.onload = function () {
                const texInfo = {
                    data: image,
                    min: 'linear',
                    mag: 'linear'
                };
                const texture = context['lutTexture'] ? context['lutTexture'].texture(texInfo) : regl.texture(texInfo);
                context['lutTexture'] = {
                    url,
                    texture
                };
            };
            image.src = url;
        }
    }
    const uniforms = {
        'enableGrain': +!!grainConfig.enable,
        'grainFactor': grainConfig.factor === undefined ? 0.15 : grainConfig.factor,
        'timeGrain': performance.now(),

        'enableVignette': +!!vignetteConfig.enable,
        'lensRadius': vignetteConfig.lensRadius || [0.8, 0.25],
        'frameMod': 1,

        'enableLut': +!!lutConfig.enable,
        'lookupTable': context['lutTexture'] ? context['lutTexture'].texture : emptyLutTexture
    };
    if (!postProcess) {
        postProcess = new PostProcess(regl);
    }
    postProcess.postprocess(null, uniforms, texture({
        width: postCanvas.width,
        height: postCanvas.height,
        data: canvas,
        flipY: true,
        mag: 'linear',
        min: 'linear',
        mipmap: false
    }));

    renderer.context.drawImage(postCanvas, 0, 0, postCanvas.width, postCanvas.height);
}

function createContext(width, height) {
    postCanvas = document.createElement('canvas', width, height);
    // const viewport = {
    //     x: 0,
    //     y: 0,
    //     width: () => {
    //         return postCanvas.width;
    //     },
    //     height: () => {
    //         return postCanvas.height;
    //     }
    // };
    regl = createREGL({
        canvas: postCanvas,
        attributes: {
            depth: false,
            stencil: false,
            alpha: true,
            antialias: false,
            premultipliedAlpha: false
        }
    });
    texture = regl.texture({
        mag: 'linear',
        min: 'linear',
        mipmap: false,
        flipY: true,
        width,
        height
    });
    emptyLutTexture = regl.texture();
}

class MapGLRenderer extends renderer.MapAbstractRenderer {
    // createCanvas, createContext, getContextInstance, clearLayerCanvasContext 和 clearCanvas 方法都应该动态注入

    clearCanvas() {
        if (!this.device) {
            return;
        }
        // depth and stencil will be cleared in clearLayerCanvasContext
        this.device.clear({
            color: [0, 0, 0, 0]
        });
    }

    clearLayerCanvasContext(layer) {
        if (!this.device) {
            return;
        }
        this.device.clear({
            depth: 1,
            stencil: 0
        });
        const renderer = layer.getRenderer();
        renderer.clearContext();
    }

    createContext() {
        const map = this.map;
        const { preserveDrawingBuffer, onlyWebGL1, extensions, optionalExtensions } = map.options;
        const canvas = map.getRenderer().canvas;
        const { gl, regl, reglGL, context } = createWebGLContext(canvas, preserveDrawingBuffer, onlyWebGL1, extensions, optionalExtensions);
        this.gl = gl;
        this.regl = regl;
        this.reglGL = reglGL;
        this.device = regl;
        this.context = context;
        return Promise.resolve();
    }

    _initGL() {
        const map = this.map;
        const gl = this.gl;
        const extensions = map.options['extensions'];
        if (extensions) {
            extensions.forEach(ext => {
                gl.getExtension(ext);
            });
        }
        const optionalExtensions = map.options['optionalExtensions'];
        if (optionalExtensions) {
            optionalExtensions.forEach(ext => {
                gl.getExtension(ext);
            });
        }
    }

    getContextInstance() {
        return this.gl.wrap();
    }

    isWebGL() {
        return true;
    }

    isWebGPU() {
        return false;
    }
}

Map$1.registerRenderer('gl', MapGLRenderer);

// Map.mergeOptions({
//     renderer: ['gl', 'gpu']
// });

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

let gpuAdapter;
let gpuDevice;
function initGPUDevice() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        if (gpuDevice) {
            return { gpuDevice, gpuAdapter };
        }
        gpuAdapter = yield ((_a = navigator.gpu) === null || _a === void 0 ? void 0 : _a.requestAdapter());
        gpuDevice = yield (gpuAdapter === null || gpuAdapter === void 0 ? void 0 : gpuAdapter.requestDevice({
        // requiredLimits: {
        //     maxVertexBuffers: 16
        // }
        }));
        return { gpuDevice, gpuAdapter };
    });
}
class MapGPURenderer extends MapGLRenderer {
    drawLayers(layers, framestamp) {
        const updated = super.drawLayers(layers, framestamp);
        if (updated) {
            this.device.submit();
            if (this.map.options['preserveGpuDrawingBuffer']) {
                const mapCanvas = this.canvas;
                const canvas = mapCanvas.readbackCanvas = mapCanvas.readbackCanvas || document.createElement('canvas');
                this.device.preserveDrawingBuffer(canvas);
            }
        }
        return updated;
    }
    createContext() {
        return initGPUDevice().then(({ gpuDevice, gpuAdapter }) => {
            const context = this.canvas.getContext('webgpu');
            this.device = new GraphicsDevice(gpuDevice, context, gpuAdapter);
            this.context = {
                context,
                device: this.device,
                getImageData: (sx, sy, sw, sh) => {
                    const pixels = new Uint8Array(sw * sh * 4);
                    const canvas = this.canvas;
                    this.device.read({
                        x: sx,
                        y: canvas.height - sy,
                        width: sw,
                        height: sh,
                        data: pixels
                    });
                    return new ImageData(new Uint8ClampedArray(pixels.buffer), sw, sh);
                }
            };
        });
    }
    isWebGL() {
        return false;
    }
    isWebGPU() {
        return true;
    }
}
Map$1.registerRenderer('gpu', MapGPURenderer);

const COLOR = [];


function clearShowOnly(mesh) {
    if (!mesh.properties.showOnlyTimestamp) {
        return;
    }
    delete mesh.properties.showOnlyTimestamp;
    restoreOldElements(mesh);
}

function saveOldElements(mesh, elements) {
    const geoProps = mesh.geometry.properties;
    if (!geoProps.oldElementsBeforeHighlight) {
        geoProps.oldElementsBeforeHighlight = mesh.geometry.elements;
    }
    if (geoProps.elements) {
        if (!geoProps.oldElementsArrBeforeHighlight) {
            geoProps.oldElementsArrBeforeHighlight = geoProps.elements;
        }
        geoProps.elements = elements;
    }
}

function restoreOldElements(mesh) {
    const oldElementsBeforeHighlight = mesh.geometry.properties.oldElementsBeforeHighlight;
    if (!oldElementsBeforeHighlight || mesh.geometry.elements === oldElementsBeforeHighlight) {
        return;
    }
    mesh.geometry.deleteElements();
    mesh.geometry.setElements(mesh.geometry.properties.oldElementsBeforeHighlight);
    if (mesh.geometry.properties.oldElementsArrBeforeHighlight) {
        mesh.geometry.properties.elements = mesh.geometry.properties.oldElementsArrBeforeHighlight;
        delete mesh.geometry.properties.oldElementsArrBeforeHighlight;
    }
    delete mesh.geometry.properties.hasInvisible;
    delete mesh.geometry.properties.oldElementsBeforeHighlight;
}

function showOnly(regl, mesh, items, timestamp, feaIdIndiceMap) {
    const { showOnlyTimestamp } = mesh.properties;
    if (!items) {
        if (showOnlyTimestamp) {
            clearShowOnly(mesh);
        }
        return;
    }
    if (timestamp === showOnlyTimestamp) {
        return;
    }
    mesh.properties.showOnlyTimestamp = timestamp;
    const ids = items.keys();
    const elements = [];
    for (const id of ids) {
        if (!feaIdIndiceMap.has(id)) {
            continue;
        }
        const indices = feaIdIndiceMap.get(id);
        if (indices) {
            pushIn(elements, indices);
        }
    }

    saveOldElements(mesh, elements);
    if (mesh.geometry.elements !== mesh.geometry.properties.oldElementsBeforeHighlight && mesh.geometry.elements.destroy) {
        mesh.geometry.deleteElements();
    }
    const info = {
        data: elements,
        // type: mesh.geometry.getElementsType(elements),
        primitive: mesh.geometry.getPrimitive()
    };
    mesh.geometry.setElements(regl.elements(info));
    mesh.geometry.generateBuffers(regl);
}

function clearHighlight(mesh) {
    if (!mesh.properties.highlightTimestamp) {
        return;
    }
    const defines = mesh.defines;
    delete defines['HAS_HIGHLIGHT_COLOR'];
    delete defines['HAS_HIGHLIGHT_OPACITY'];
    mesh.setDefines(defines);
    delete mesh.properties.highlightTimestamp;
    restoreOldElements(mesh);
    deleteHighlightBloomMesh(mesh);
}

function highlightMesh(regl, mesh, highlighted, timestamp, feaIdIndiceMap) {
    const { highlightTimestamp } = mesh.properties;
    if (!highlighted) {
        if (highlightTimestamp) {
            clearHighlight(mesh);
        }
        return;
    }
    if (timestamp === highlightTimestamp) {
        return;
    }
    const isInstanced = mesh instanceof InstancedMesh;
    const vertexCount = isInstanced ? mesh.instanceCount : mesh.geometry.getVertexCount();
    let { aHighlightColor, aHighlightOpacity } = mesh.geometry.properties;
    if (aHighlightColor) {
        aHighlightColor.fill(0);
    }
    if (aHighlightOpacity) {
        aHighlightOpacity.fill(255);
    }
    let hasColor = false;
    let hasOpacity = false;
    const ids = highlighted.keys();
    let hlElements = null;
    let invisibleIds = null;
    for (const id of ids) {
        if (feaIdIndiceMap.has(id)) {
            // update attribute data
            const highlightedData = highlighted.get(id);
            const { color, bloom, visible, nodeIndex } = highlightedData;
            if (!isNil$1(nodeIndex) && nodeIndex !== mesh.properties.nodeIndex) {
                continue;
            }
            let { opacity } = highlightedData;
            let normalizedColor;
            if (color) {
                if (!hasColor) {
                    if (!aHighlightColor) {
                        aHighlightColor = new Uint8Array(vertexCount * 4);
                    }
                    hasColor = true;
                }
                normalizedColor = normalizeColor255(COLOR, color);
            }
            opacity = isNil$1(opacity) ? 1 : opacity;
            if (opacity < 1) {
                if (!hasOpacity) {
                    if (!aHighlightOpacity) {
                        aHighlightOpacity = new Uint8Array(vertexCount);
                        aHighlightOpacity.fill(255);
                    }
                    hasOpacity = true;
                }
            }
            if (visible === false) {
                if (!invisibleIds) {
                    invisibleIds = new Set();
                }
                invisibleIds.add(id);
            }
            if (normalizedColor || opacity < 1 || bloom) {
                const indices = feaIdIndiceMap.get(id);
                if (indices) {
                    for (let j = 0; j < indices.length; j++) {
                        const idx = indices[j];
                        if (normalizedColor) {
                            vec4.set(aHighlightColor.subarray(idx * 4, idx * 4 + 4), ...normalizedColor);
                        }
                        if (opacity < 1) {
                            aHighlightOpacity[idx] = opacity * 255;
                        }
                        if (bloom) {
                            if (!hlElements) {
                                hlElements = [];
                            }
                            hlElements.push(idx);
                        }
                    }
                }
            }
        }
    }


    const geometry = mesh.geometry;
    const defines = mesh.defines;
    if (hasColor) {
        if (isInstanced) {
            mesh.updateInstancedData('aHighlightColor', aHighlightColor);
            mesh.generateInstancedBuffers(regl);
        } else {
            if (!geometry.data.aHighlightColor) {
                geometry.data.aHighlightColor = aHighlightColor;
                geometry.generateBuffers(regl);
            } else {
                geometry.updateData('aHighlightColor', aHighlightColor);
            }
            geometry.properties.aHighlightColor = aHighlightColor;
        }
        defines['HAS_HIGHLIGHT_COLOR'] = 1;
    } else if (defines['HAS_HIGHLIGHT_COLOR']) {
        if (isInstanced) {
            mesh.updateInstancedData('aHighlightColor', aHighlightColor);
            mesh.generateInstancedBuffers(regl);
        } else {
            geometry.updateData('aHighlightColor', aHighlightColor);
        }
        delete defines['HAS_HIGHLIGHT_COLOR'];
    }
    if (hasOpacity) {
        if (isInstanced) {
            mesh.updateInstancedData('aHighlightOpacity', aHighlightOpacity);
            mesh.generateInstancedBuffers(regl);
        } else {
            if (!geometry.data.aHighlightOpacity) {
                geometry.data.aHighlightOpacity = aHighlightOpacity;
                geometry.generateBuffers(regl);
            } else {
                geometry.updateData('aHighlightOpacity', aHighlightOpacity);
            }
            geometry.properties.aHighlightOpacity = aHighlightOpacity;
        }

        defines['HAS_HIGHLIGHT_OPACITY'] = 1;
    } else if (defines['HAS_HIGHLIGHT_OPACITY']) {
        if (isInstanced) {
            mesh.updateInstancedData('aHighlightOpacity', aHighlightOpacity);
            mesh.generateInstancedBuffers(regl);
        } else {
            geometry.updateData('aHighlightOpacity', aHighlightOpacity);
        }
        delete defines['HAS_HIGHLIGHT_OPACITY'];
    }
    if (invisibleIds && invisibleIds.size > 0) {
        let elements = [];
        feaIdIndiceMap.forEach((value, key) => {
            if (invisibleIds.has(key)) {
                return;
            }
            pushIn(elements, value);
        });
        geometry.properties.hasInvisible = true;
        saveOldElements(mesh, elements);
        const info = {
            data: elements,
            // type: geometry.getElementsType(elements),
            primitive: geometry.getPrimitive()
        };
        if (geometry.elements !== geometry.properties.oldElementsBeforeHighlight && geometry.elements.destroy) {
            geometry.deleteElements();
        }
        elements = regl.elements(info);
        geometry.setElements(elements);
        geometry.generateBuffers(regl);
    } else if (geometry.properties.hasInvisible) {
        restoreOldElements(mesh);
    }
    mesh.setDefines(defines);
    mesh.properties.highlightTimestamp = timestamp;

    let hlBloomMesh = mesh.properties.hlBloomMesh;
    if (hlElements && hlElements.length) {
        if (!hlBloomMesh) {
            const geo = new Geometry(geometry.data, hlElements, 0, geometry.desc);
            geo.generateBuffers(regl);
            const material = mesh.material;
            hlBloomMesh = new Mesh(geo, material, mesh.config);
            const uniforms = mesh.uniforms;
            for (const p in uniforms) {
                Object.defineProperty(hlBloomMesh.uniforms, p, {
                    enumerable: true,
                    get: function () {
                        return mesh.getUniform(p);
                    }
                });
            }

            const defines = extend({}, mesh.defines);
            defines['HAS_BLOOM'] = 1;
            const localTransform = mat4.copy([], mesh.localTransform);
            const positionMatrix = mat4.copy([], mesh.positionMatrix);
            hlBloomMesh.setLocalTransform(localTransform);
            hlBloomMesh.setPositionMatrix(positionMatrix);
            extend(hlBloomMesh.properties, mesh.properties);
            extend(geo.properties, geometry.properties);
            hlBloomMesh.setDefines(defines);
            hlBloomMesh.bloom = 1;
        } else {
            const localTransform = mat4.copy(hlBloomMesh.localTransform, mesh.localTransform);
            const positionMatrix = mat4.copy(hlBloomMesh.positionMatrix, mesh.positionMatrix);
            hlBloomMesh.setLocalTransform(localTransform);
            hlBloomMesh.setPositionMatrix(positionMatrix);
            mesh.properties.hlBloomMesh.geometry.setElements(hlElements);
        }
        mesh.properties.hlBloomMesh = hlBloomMesh;
    } else if (hlBloomMesh) {
        deleteHighlightBloomMesh(mesh);
    }
}

function deleteHighlightBloomMesh(mesh) {
    if (!mesh) {
        return;
    }
    const { hlBloomMesh } = mesh.properties;
    if (hlBloomMesh) {
        const hlGeo = hlBloomMesh.geometry;
        if (hlGeo.elements && hlGeo.elements.destroy) {
            hlGeo.deleteElements();
        }
        hlBloomMesh.dispose();
        delete mesh.properties.hlBloomMesh;
    }
}

var highlight = /*#__PURE__*/Object.freeze({
    __proto__: null,
    clearHighlight: clearHighlight,
    clearShowOnly: clearShowOnly,
    deleteHighlightBloomMesh: deleteHighlightBloomMesh,
    highlightMesh: highlightMesh,
    showOnly: showOnly
});

const TexturePoolable = function (Base) {
    const poolable = class extends Base {
        constructor() {
            super(...arguments);
            this._textures = [];
        }
        /**
         * Get a texture from cache or create one if cache is empty
         */
        getTexture() {
            if (!this._textures) {
                this._textures = [];
            }
            const textures = this._textures;
            return textures && textures.length > 0 ? textures.pop() : null;
        }
        /**
         * Save a texture to the cache
         */
        saveTexture(texture) {
            this._textures.push(texture);
        }
        disposeTexturePool() {
            const textures = this._textures;
            for (let i = 0; i < textures.length; i++) {
                textures[i].dispose();
            }
            this._textures = [];
        }
    };
    return poolable;
};

const TILE_POINT = new maptalks.Point(0, 0);
const DEFAULT_BASE_COLOR = [1, 1, 1, 1];
function createImageMesh(geometry, image, extent2d, offset, scale, uniforms) {
    const width = extent2d.xmax - extent2d.xmin;
    const height = extent2d.ymax - extent2d.ymin;
    offset = offset || [0, 0];
    const point = TILE_POINT.set(extent2d.xmin - offset[0], extent2d.ymax - offset[1]);
    const x = point.x * scale, y = point.y * scale;
    const config = {
        data: image,
        mag: 'nearest',
        mipmap: true,
        premultiplyAlpha: true
    };
    if (!image || image.width === 0 || image.height === 0) {
        image = new Uint8Array([0, 0, 0, 0]);
        config.width = 1;
        config.height = 1;
        config.data = image;
    }
    let texture = this.getTexture();
    if (!texture) {
        texture = new Texture2D(config);
    }
    else {
        texture.setConfig(config);
    }
    // image.texture = texture;
    uniforms = extend(uniforms || {}, {
        opacity: 1,
        debugLine: 0,
        alphaTest: 0,
        baseColor: DEFAULT_BASE_COLOR,
        baseColorTexture: texture
    });
    const material = new Material(uniforms);
    const mesh = new Mesh(geometry, material);
    mesh.properties.minFilter = GL_NEAREST;
    const localTransform = mat4.identity([]);
    mat4.translate(localTransform, localTransform, [x || 0, y || 0, 0]);
    mat4.scale(localTransform, localTransform, [scale * width, scale * height, 1]);
    mesh.localTransform = localTransform;
    return mesh;
}
function updateFilter(mesh, map, res) {
    const cache = maptalks.MapStateCache[map.id];
    const zoom = cache ? cache.zoom : map.getZoom();
    const dpr = cache ? cache.devicePixelRatio : map.getDevicePixelRatio();
    const minFilter = getTexMinFilter(map, zoom);
    if (mesh.properties.minFilter !== minFilter) {
        const baseColorTexture = mesh.material.get('baseColorTexture');
        baseColorTexture.setMinFilter(minFilter);
        mesh.properties.minFilter = minFilter;
    }
    const resized = map.getResolution() !== res;
    let magFilter = GL_NEAREST;
    if (dpr !== 1 || resized) {
        magFilter = GL_LINEAR;
    }
    if (mesh.properties.magFilter !== magFilter) {
        const baseColorTexture = mesh.material.get('baseColorTexture');
        baseColorTexture.setMagFilter(magFilter);
        mesh.properties.magFilter = magFilter;
    }
}
function getTexMinFilter(map, zoom) {
    const blurTexture = map.isMoving() && map.getRenderer().isViewChanged();
    let minFilter;
    if (blurTexture) {
        minFilter = GL_LINEAR_MIPMAP_LINEAR;
    }
    else if (!map.getBearing() && !map.getPitch() && Number.isInteger(zoom)) {
        minFilter = GL_NEAREST;
    }
    else {
        minFilter = GL_LINEAR;
    }
    return minFilter;
}

const { TileLayerRendererable, LayerAbstractRenderer: LayerAbstractRenderer$1 } = maptalks.renderer;
const positionData$1 = new Int16Array([
    0, 0, 0, -1, 1, 0, 1, -1
]);
const texCoords$1 = new Uint16Array([
    0.0, 0.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0
]);
const MESH_TO_TEST = { properties: {} };
const DEBUG_POINT = new maptalks.Point(20, 20);
class TileLayerGLRenderer2 extends TexturePoolable(canvasCompatible(TileLayerRendererable(LayerAbstractRenderer$1))) {
    constructor(layer) {
        super(layer);
        this.init();
    }
    onResize(param) {
        super.onResize(param);
        this.resizeCanvas();
    }
    onDrawTileStart(context, parentContext) {
        if (!this._tileGeometry) {
            this._shader = new ImageShader({
                extraCommandProps: this._getCommandProps()
            });
            this._tileGeometry = new Geometry({
                aPosition: positionData$1,
                aTexCoord: texCoords$1
            }, 4, 0, {
                positionSize: 2,
                primitive: 'triangle strip'
            });
            const { regl, device } = this.context;
            this._tileGeometry.generateBuffers(regl || device);
            this._tileMeshes = [];
            this._tileScene = new Scene(this._tileMeshes);
            this._renderer = new Renderer(regl || device);
        }
        this._tileMeshes.length = 0;
        this.clearStencil(parentContext);
    }
    clearStencil(parentContext) {
        let fbo;
        if (parentContext && parentContext.renderTarget) {
            fbo = parentContext.renderTarget.fbo;
        }
        const { regl, device } = this.context;
        (regl || device).clear({
            stencil: 0xFF,
            fbo
        });
    }
    _drawCurrentTiles(tiles, parentTiles) {
        super._drawCurrentTiles(tiles, parentTiles);
        this._submitMeshes(parentTiles);
    }
    _drawChildTiles(childTiles, parentContext) {
        super._drawChildTiles(childTiles, parentContext);
        this._submitMeshes(parentContext);
    }
    _drawParentTiles(parentTiles, parentContext) {
        super._drawChildTiles(parentTiles, parentContext);
        this._submitMeshes(parentContext);
    }
    onDrawTileEnd(_, parentContext) {
        this._submitMeshes(parentContext);
    }
    _submitMeshes(parentContext) {
        const uniformValues = this._getUniformValues();
        let fbo;
        if (parentContext && parentContext.renderTarget) {
            fbo = parentContext.renderTarget.fbo;
        }
        this._tileScene.setMeshes(this._tileMeshes);
        this._renderer.render(this._shader, uniformValues, this._tileScene, fbo);
        this._tileMeshes.length = 0;
    }
    _getUniformValues() {
        const map = this.getMap();
        return {
            'projViewMatrix': map.projViewMatrix
        };
    }
    consumeTile(tileImage, tileInfo) {
        let mesh = tileImage.mesh;
        if (!mesh) {
            mesh = this._createTileMesh(tileInfo, tileImage);
            tileImage.mesh = mesh;
        }
        return super.consumeTile(tileImage, tileInfo);
    }
    drawTile(tileInfo, tileImage, parentContext) {
        if (parentContext && parentContext.sceneFilter) {
            if (!parentContext.sceneFilter(MESH_TO_TEST)) {
                return;
            }
        }
        const map = this.getMap();
        if (!tileInfo || !map || !tileImage) {
            return;
        }
        let mesh = tileImage.mesh;
        if (!mesh) {
            mesh = this._createTileMesh(tileInfo, tileImage);
            tileImage.mesh = mesh;
        }
        const defines = mesh.getDefines();
        if (this.layer.options['debug']) {
            let debugTexture = mesh.material.get('debugTexture');
            if (!debugTexture) {
                debugTexture = this._createDebugTexture(tileInfo, tileImage.width, tileImage.height);
                mesh.material.set('debugTexture', debugTexture);
                tileImage.debugTexture = debugTexture;
            }
            if (!defines['HAS_DEBUG']) {
                mesh.setDefines({
                    'HAS_DEBUG': 1
                });
            }
        }
        else if (defines['HAS_DEBUG']) {
            mesh.setDefines({});
        }
        updateFilter(mesh, map, tileInfo.res);
        let opacity = this.getTileOpacity(tileImage, tileInfo);
        let layerOpacity = this.layer.options['opacity'];
        if (isNil$1(layerOpacity)) {
            layerOpacity = 1;
        }
        opacity *= layerOpacity;
        mesh.material.set('opacity', opacity);
        mesh.setUniform('isCurrentTiles', +!!this.drawingCurrentTiles);
        this._tileMeshes.push(mesh);
        if (this.getTileFadingOpacity(tileImage) < 1) {
            this.setToRedraw();
        }
    }
    _createDebugTexture(tileInfo, width, height) {
        const debugInfo = this.getDebugInfo(tileInfo.id);
        const dpr = this.getMap().getDevicePixelRatio() > 1 ? 2 : 1;
        const canvas = this._debugInfoCanvas = document.createElement('canvas');
        canvas.width = width * dpr;
        canvas.height = height * dpr;
        const ctx = canvas.getContext('2d');
        ctx.font = '20px monospace';
        ctx.scale(dpr, dpr);
        const color = this.layer.options['debugOutline'];
        ctx.fillStyle = color;
        ctx.strokeStyle = color;
        ctx.lineWidth = 3;
        ctx.fillText(debugInfo, 20, height - 12);
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(width, 0);
        ctx.lineTo(width, height);
        ctx.lineTo(0, height);
        ctx.lineTo(0, 0);
        ctx.stroke();
        const config = {
            data: canvas,
            width: canvas.width,
            height: canvas.height
        };
        let texture = this.getTexture();
        if (!texture) {
            texture = new Texture2D(config);
        }
        else {
            texture.setConfig(config);
        }
        const { device, regl } = this.context;
        texture.getREGLTexture(device || regl);
        return texture;
    }
    _createTileMesh(tileInfo, tileImage) {
        const map = this.getMap();
        const scale = tileInfo.res / map.getGLRes();
        const uniforms = {
            zoom: tileInfo.z,
        };
        const mesh = createImageMesh.call(this, this._tileGeometry, tileImage, tileInfo.extent2d, tileInfo.offset, scale, uniforms);
        const texture = mesh.material.get('baseColorTexture');
        tileImage.texture = texture;
        return mesh;
    }
    loadTileImage(tileImage, url) {
        // image must set cors in webgl
        const crossOrigin = this.layer.options['crossOrigin'];
        tileImage.crossOrigin = crossOrigin !== null ? crossOrigin : '';
        tileImage.src = url;
        return;
    }
    deleteTile(tile) {
        if (!tile || !tile.image) {
            return super.deleteTile(tile);
        }
        const image = tile.image;
        if (image.texture) {
            this.saveTexture(image.texture);
        }
        if (image.debugTexture) {
            this.saveTexture(image.debugTexture);
        }
        delete image.texture;
        delete image.debugTexture;
        const mesh = image.mesh;
        if (mesh) {
            // 因为meterial中的texture是在TexturePoolable中集中管理的，不能在material.dispose中销毁
            mesh.material.set('baseColorTexture', null, false);
            mesh.material.set('debugTexture', null, false);
            mesh.material.dispose();
            mesh.dispose();
            delete image.mesh;
        }
        return super.deleteTile(tile);
    }
    onRemove() {
        if (this._tileGeometry) {
            this._shader.dispose();
            this._tileGeometry.dispose();
            delete this._shader;
            delete this._tileGeometry;
            delete this._renderer;
            delete this._tileScene;
            delete this._tileMeshes;
        }
        this.disposeTexturePool();
        super.onRemove();
    }
    _getCommandProps() {
        const canvas = this.getMap().getRenderer().canvas;
        const viewport = {
            x: 0,
            y: 0,
            width: () => {
                return canvas ? canvas.width : 1;
            },
            height: () => {
                return canvas ? canvas.height : 1;
            }
        };
        const offsetFactor = {
            units: 0,
            factor: 0
        };
        return {
            stencil: {
                enable: true,
                func: {
                    cmp: '<=',
                    ref: (_, props) => {
                        const ref = Math.abs(this.getCurrentTileZoom() - props.zoom);
                        return ref;
                    }
                },
                op: {
                    fail: 'keep',
                    zfail: 'keep',
                    zpass: 'replace'
                }
            },
            depth: {
                enable: true,
                func: '<=',
                mask: () => {
                    return !!this.layer.options['depthMask'];
                }
            },
            blend: {
                enable: true,
                func: {
                    src: 1,
                    dst: 'one minus src alpha'
                },
                equation: 'add'
            },
            viewport,
            polygonOffset: {
                enable: true,
                offset: (_, props) => {
                    let polygonOffset = this.layer.getPolygonOffset();
                    polygonOffset = props.isCurrentTiles ? polygonOffset : polygonOffset + 1;
                    offsetFactor.factor = polygonOffset;
                    offsetFactor.units = polygonOffset;
                    return offsetFactor;
                }
            }
        };
    }
    renderTerrainSkin(regl, terrainLayer, skinImages) {
        const tileSize = this.layer.getTileSize().width;
        const debug = terrainLayer.options['debug'];
        for (let i = 0; i < skinImages.length; i++) {
            const { tile, texture } = skinImages[i];
            if (!tile.image) {
                continue;
            }
            const canvas = document.createElement('canvas');
            skinImages[i].canvas = canvas;
            canvas.width = tileSize;
            canvas.height = tileSize;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(tile.image, 0, 0);
            if (debug) {
                const { x, y, z } = tile.info;
                drawDebug(ctx, `${x}/${y}/${z}`, 'yellow', 1, 0, 0, tileSize, tileSize, -18);
            }
            const config = {
                data: canvas,
                width: tileSize,
                height: tileSize,
                flipY: true,
                min: 'linear mipmap linear',
                mag: 'linear'
            };
            if (texture.update) {
                //webgpu
                texture.update(config);
            }
            else {
                //webgl
                texture(config);
            }
        }
    }
    createTerrainTexture(regl) {
        const tileSize = this.layer.getTileSize().width;
        const config = {
            width: tileSize,
            height: tileSize,
            flipY: true,
            min: 'linear mipmap linear',
            mag: 'linear',
            depthStencil: false,
            depth: false,
            stencil: false
        };
        return regl.texture(config);
    }
    deleteTerrainTexture(texture) {
        texture.destroy();
    }
    clear() {
        this.clearTileCaches();
        super.clear();
    }
}
maptalks.TileLayer.registerRenderer('gl', TileLayerGLRenderer2);
maptalks.TileLayer.registerRenderer('gpu', TileLayerGLRenderer2);
function drawDebug(ctx, debugInfo, color, lineWidth, left, top, width, height, textOffsetY = 0) {
    ctx.font = '20px monospace';
    ctx.fillStyle = color;
    DEBUG_POINT.y = height - 30;
    ctx.globalAlpha = 1;
    ctx.fillText(debugInfo, DEBUG_POINT.x + left, DEBUG_POINT.y + top + textOffsetY);
    ctx.globalAlpha = 0.6;
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.beginPath();
    ctx.moveTo(left, top);
    ctx.lineTo(left + width, top);
    ctx.lineTo(left + width, top + height);
    ctx.lineTo(left, top + height);
    ctx.lineTo(left, top);
    ctx.stroke();
    ctx.globalAlpha = 1;
}

const { LayerAbstractRenderer, ImageLayerRenderable } = maptalks.renderer;
const positionData = new Int16Array([
    0, 0, 0, -1, 1, 0, 1, -1
]);
const texCoords = new Uint16Array([
    0.0, 0.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0
]);
class ImageLayerGLRenderer2 extends TexturePoolable(canvasCompatible(ImageLayerRenderable(LayerAbstractRenderer))) {
    constructor() {
        super(...arguments);
        //@internal
        this._imageMeshes = [];
    }
    isDrawable() {
        return true;
    }
    drawImage(image, extent, opacity) {
        let mesh = image.mesh;
        if (!mesh) {
            mesh = this._createImageMesh(image, extent);
            image.mesh = mesh;
        }
        const map = this.getMap();
        updateFilter(mesh, map, map.getGLRes());
        if (map.getRenderer().canvas === this.canvas) {
            let layerOpacity = this.layer.options['opacity'];
            if (isNil$1(layerOpacity)) {
                layerOpacity = 1;
            }
            opacity *= layerOpacity;
        }
        mesh.material.set('opacity', opacity);
        this._imageMeshes.push(mesh);
    }
    _createImageMesh(image, extent) {
        const scale = 1;
        const mesh = createImageMesh.call(this, this._imageGeometry, image, extent, null, scale);
        const texture = mesh.material.get('baseColorTexture');
        image.texture = texture;
        return mesh;
    }
    drawImages(timestamp, context) {
        this._imageMeshes.length = 0;
        super.drawImages(timestamp, context);
        const uniformValues = this._getUniformValues();
        let fbo;
        if (context && context.renderTarget) {
            fbo = context.renderTarget.fbo;
        }
        this._imageScene.setMeshes(this._imageMeshes);
        this._renderer.render(this._shader, uniformValues, this._imageScene, fbo);
    }
    _getUniformValues() {
        const map = this.getMap();
        return {
            'projViewMatrix': map.projViewMatrix
        };
    }
    retireImage(image) {
        const texture = image.texture;
        if (texture) {
            this.saveTexture(texture);
            delete image.texture;
        }
        if (image.mesh) {
            const mesh = image.mesh;
            mesh.material.set('baseColorTexture', null, false);
            mesh.material.dispose();
            image.mesh.dispose();
        }
        delete image.mesh;
        return super.retireImage(image);
    }
    initContext() {
        this._shader = new ImageShader({
            extraCommandProps: this._getCommandProps()
        });
        this._imageGeometry = new Geometry({
            aPosition: positionData,
            aTexCoord: texCoords
        }, 4, 0, {
            positionSize: 2,
            primitive: 'triangle strip'
        });
        const { regl, device } = this.context;
        this._imageGeometry.generateBuffers(regl || device);
        this._imageMeshes = [];
        this._imageScene = new Scene(this._imageMeshes);
        this._renderer = new Renderer(regl || device);
    }
    _getCommandProps() {
        const canvas = this.getMap().getRenderer().canvas;
        const viewport = {
            x: 0,
            y: 0,
            width: () => {
                return canvas ? canvas.width : 1;
            },
            height: () => {
                return canvas ? canvas.height : 1;
            }
        };
        return {
            viewport,
            depth: {
                enable: true,
                func: this.layer.options['depthFunc'],
                mask: !!this.layer.options['depthMask']
            },
            blend: {
                enable: true,
                func: {
                    src: 1,
                    dst: 'one minus src alpha'
                },
                equation: 'add'
            },
        };
    }
    onRemove() {
        this.disposeTexturePool();
        return super.onRemove();
    }
}
maptalks.ImageLayer.registerRenderer('gl', ImageLayerGLRenderer2);
maptalks.ImageLayer.registerRenderer('gpu', ImageLayerGLRenderer2);

//参考:
//  * https://blog.mapbox.com/introducing-heatmaps-in-mapbox-gl-js-71355ada9e6c
//  * https://codepen.io/fuzhenn/pen/vYOgQwX
// import { mat4, vec3 } from 'gl-matrix';

const EMPTY_COLOR = [0, 0, 0, 0];

class HeatmapProcess {

    constructor(regl, sceneConfig, layer, colorStops, stencil, polygonOffset) {
        this.renderer = new Renderer(regl);
        this.sceneConfig = sceneConfig;
        this._layer = layer;
        this._colorStops = colorStops;
        this._stencil = stencil;
        this._polygonOffset = polygonOffset || { factor: 0, units: 0 };
        this._init();
        this._outputSize = [];
    }

    render(scene, uniforms, fbo) {
        this._check();
        const map = this._layer.getMap();
        this.renderer.device.clear({
            color: EMPTY_COLOR,
            depth: 1,
            stencil: 0xFF,
            framebuffer: this._heatmapFBO
        });
        this.renderer.render(this._heatmapShader, uniforms, scene, this._heatmapFBO);
        const canvas = this._layer.getRenderer().canvas;
        this._outputSize[0] = canvas.width;
        this._outputSize[1] = canvas.height;
        const displayUniforms = extend({
            colorRamp: this._colorRampTex,
            inputTexture: this._heatmapFBO,
            projViewMatrix: map.projViewMatrix,
            textureOutputSize: this._outputSize
        }, uniforms);
        this._transformGround();
        return this.renderer.render(this._displayShader, displayUniforms, this._groundScene, fbo);
    }

    dispose() {
        if (this._heatmapShader) {
            this._heatmapShader.dispose();
            delete this._heatmapShader;
        }
        if (this._displayShader) {
            this._displayShader.dispose();
            delete this._displayShader;
        }
        if (this._ground) {
            this._ground.geometry.dispose();
            this._ground.dispose();
            delete this._ground;
            delete this._groundScene;
        }
        if (this._heatmapFBO) {
            this._heatmapFBO.destroy();
            delete this._heatmapFBO;
        }
    }

    _createColorRamp() {
        const colorStops = this._colorStops;
        let canvas = this._rampCanvas;
        let ctx = this._rampCtx;
        if (!ctx) {
            canvas = this._rampCanvas = document.createElement('canvas');
            canvas.width = 256;
            canvas.height = 1;
            ctx = this._rampCtx = canvas.getContext('2d');
        } else {
            ctx.clearRect(0, 0, 256, 1);
        }
        const gradient = ctx.createLinearGradient(0, 0, 256, 1);
        for (let i = 0; i < colorStops.length; i++) {
            gradient.addColorStop(colorStops[i][0], colorStops[i][1]);
        }
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 256, 1);
        if (this._colorRampTex) {
            this._colorRampTex.destroy();
        }
        const regl = this.renderer.device;
        this._colorRampTex = regl.texture({
            width: 256,
            height: 1,
            data: canvas,
            min: 'linear',
            mag: 'linear',
            premultiplyAlpha: true
        });
    }

    _check() {
        const canvas = this._layer.getRenderer().canvas;
        const width = Math.ceil(canvas.width / 4);
        const height = Math.ceil(canvas.height / 4);
        const fbo = this._heatmapFBO;
        if (fbo.width !== width || fbo.height !== height) {
            fbo.resize(width, height);
        }
    }

    _init() {
        this._createColorRamp();
        this._createShader();
        this._createHeatmapTex();
        this._createGround();
    }

    _createGround() {
        const planeGeo = new Plane();
        planeGeo.generateBuffers(this.renderer.device);
        this._ground = new Mesh(planeGeo);
        this._groundScene = new Scene([this._ground]);
    }

    _transformGround() {
        const map = this._layer.getMap();
        const localTransform = GroundPainter.getGroundTransform(this._ground.localTransform, map);
        this._ground.setLocalTransform(localTransform);
    }

    _createHeatmapTex() {
        const canvas = this._layer.getRenderer().canvas;
        const regl = this.renderer.device;
        const colorType = regl.hasExtension('OES_texture_half_float') ? 'half float' : 'float';
        const width = Math.ceil(canvas.width / 4);
        const height = Math.ceil(canvas.height / 4);
        const tex = regl.texture({
            width, height,
            type: colorType,
            min: 'linear',
            mag: 'linear',
            format: 'rgba'
        });
        this._heatmapFBO = regl.framebuffer({
            width,
            height,
            color: [tex]
        });
    }

    _createShader() {
        const layer = this._layer;
        const canvas = layer.getRenderer().canvas;
        const depthRange = this.sceneConfig.depthRange;
        const extraCommandProps = {
            viewport: {
                x: 0,
                y: 0,
                width: () => {
                    return canvas ? Math.ceil(canvas.width / 4) : 1;
                },
                height: () => {
                    return canvas ? Math.ceil(canvas.height / 4) : 1;
                }
            },
            depth: {
                enable: true,
                func: 'always'
            }
        };
        if (this._stencil) {
            extraCommandProps.stencil = this._stencil;
        }
        this._heatmapShader = new HeatmapShader({
            extraCommandProps
        });

        this._displayShader = new HeatmapDisplayShader({
            x: 0,
            y: 0,
            width: () => {
                return canvas ? canvas.width : 1;
            },
            height: () => {
                return canvas ? canvas.height : 1;
            }
        },{
            extraCommandProps: {
                depth: {
                    enable: true,
                    range: depthRange || [0, 1],
                    func: '<='
                },
                polygonOffset: {
                    enable: true,
                    offset: this._polygonOffset
                }
            }
        });
    }
}

class ClipMask extends Mask {
    constructor(coordinates, options) {
        super(coordinates, options);
    }

    _createMesh(regl) {
        const geometry = this._createGeometry(regl);
        const mesh = new Mesh(geometry);
        this._setDefines(mesh);
        this._setLocalTransform(mesh);
        return mesh;
    }

    _updateUniforms(mesh, ratio, minHeight) {
        const maskMode = this._getMaskMode();
        mesh.setUniform('maskMode', maskMode);
        const color = this._getMaskColor();
        mesh.setUniform('maskColor', color);
        if (isNumber$1(ratio)) {
            const heightRange = this._getHeightRange();
            heightRange[0] = (heightRange[0] - minHeight) * ratio;
            heightRange[1] = (heightRange[1] - minHeight) * ratio;
            mesh.setUniform('heightRange', heightRange);
        }
    }

    setHeightRange(heightRange) {
        this.options.heightRange = heightRange;
        this['_fireEvent']('heightrangechange');
    }

    getHeightRange() {
        return this.options.heightRange;
    }

    _getHeightRange() {
        const heightRange = [0, 0];
        if (this.options.heightRange) {
            heightRange[0] = this._altitudeToPoint(this.options.heightRange[0]);
            heightRange[1] = this._altitudeToPoint(this.options.heightRange[1]);
        }
        return heightRange;
    }

    _setDefines(mesh) {
        const defines = mesh.getDefines();
        defines['HAS_MASK_COLOR'] = 1;
        mesh.setDefines(defines);
    }
}

class ClipInsideMask extends ClipMask {
    constructor(coordinates, options) {
        super(coordinates, options);
        this._mode = 'clip-inside';
    }
}

class ClipOutsideMask extends ClipMask {
    constructor(coordinates, options) {
        super(coordinates, options);
        this._mode = 'clip-outside';
    }
}

class FlatMask extends Mask {
    constructor(coordinates, options) {
        super(coordinates, options);
    }

    setFlatheight(flatHeight) {
        this.options.flatHeight = flatHeight;
        this['_fireEvent']('flatheightchange');
    }

    _createMesh(regl) {
        const geometry = this._createGeometry(regl);
        const mesh = new Mesh(geometry);
        this._setDefines(mesh);
        this._setLocalTransform(mesh);
        return mesh;
    }

    _updateUniforms(mesh) {
        const maskMode = this._getMaskMode();
        mesh.setUniform('maskMode', maskMode);
        const color = this._getMaskColor();
        mesh.setUniform('maskColor', color);
        const flatHeight = this._altitudeToPoint(this.options.flatHeight || 0);
        mesh.setUniform('flatHeight', flatHeight);
    }

    _setDefines(mesh) {
        const defines = mesh.getDefines();
        defines['HAS_MASK_FLAT'] = 1;
        mesh.setDefines(defines);
    }

    _getHeightRange() {
        const heightRange = [0, this.options.flatHeight];
        heightRange[1] = this._altitudeToPoint(heightRange[1]);
        return heightRange;
    }
}

let FlatInsideMask$1 = class FlatInsideMask extends FlatMask {
    constructor(coordinates, options) {
        super(coordinates, options);
        this._mode = 'flat-inside';
    }
};

class FlatInsideMask extends FlatMask {
    constructor(coordinates, options) {
        super(coordinates, options);
        this._mode = 'flat-outside';
    }
}

class ColorMask extends Mask {
    constructor(coordinates, options) {
        super(coordinates, options);
        this._mode = 'color';
    }

    setHeightRange(heightRange) {
        this.options.heightRange = heightRange;
        this['_fireEvent']('heightrangechange');
    }

    _createMesh(regl) {
        const geometry = this._createGeometry(regl);
        const mesh = new Mesh(geometry);
        this._setDefines(mesh);
        this._setLocalTransform(mesh);
        return mesh;
    }

    _updateUniforms(mesh, ratio, minHeight) {
        const maskMode = this._getMaskMode();
        mesh.setUniform('maskMode', maskMode);
        const color = this._getMaskColor();
        mesh.setUniform('maskColor', color);
        if (isNumber$1(ratio)) {
            const heightRange = this._getHeightRange();
            heightRange[0] = (heightRange[0] - minHeight) * ratio;
            heightRange[1] = (heightRange[1] - minHeight) * ratio;
            mesh.setUniform('heightRange', heightRange);
        }
    }

    _setDefines(mesh) {
        const defines = mesh.getDefines();
        defines['HAS_MASK_COLOR'] = 1;
        mesh.setDefines(defines);
    }

    _getHeightRange() {
        const heightRange = [0, 0];
        if (this.options.heightRange) {
            heightRange[0] = this._altitudeToPoint(this.options.heightRange[0]);
            heightRange[1] = this._altitudeToPoint(this.options.heightRange[1]);
        }
        return heightRange;
    }
}

class VideoMask extends Mask {
    constructor(coordinates, options) {
        super(coordinates, options);
        this._mode = 'texture';
    }

    play() {
        if (this._video) {
            this._video.play();
        }
    }

    pause() {
        if (this._video) {
            this._video.pause();
        }
    }

    setAudio(audio) {
        if (this._video) {
            this.video.muted = audio;
        }
    }

    setUrl(url) {
        this.options.url = url;
        this._createVideo(url);
    }

    getState() {
        return this._videoState;
    }

    _createMesh(regl) {
        const { geometry, copyGeometry } = this._createGeometry(regl);
        const mesh = new Mesh(geometry);
        const videoTexture = this._createVideoTexture(regl);
        mesh.material = new Material({ maskTexture: videoTexture });
        this._setDefines(mesh);
        this._setLocalTransform(mesh);
        this._copyMesh = new Mesh(copyGeometry);
        this._setLocalTransform(this._copyMesh);
        return mesh;
    }

    _updateUniforms(mesh) {
        const maskMode = this._getMaskMode();
        mesh.setUniform('maskMode', maskMode);
        if (this._positions && this._positions.length) {
            for (let i = 0; i < 4; i++) {
                mesh.setUniform('mask_position' + i, this._positions.slice(i * 3, i * 3 + 3));
            }
        }
        const color = this._getMaskColor();
        mesh.setUniform('maskColor', color);
    }

    _setDefines(mesh) {
        const defines = mesh.getDefines();
        defines['HAS_TEXTURE'] = 1;
        mesh.setDefines(defines);
    }

    _createVideoTexture(regl) {
        this._createVideo();
        const videoTexture = regl.texture();
        return videoTexture;
    }


    _createVideo() {
        this._videoState = 'stop';
        const url = this.options.url;
        const id = this.options.elementId;
        let video = document.getElementById(id);
        if (url) {
            video = document.createElement('video');
            video.src = url;
        }
        if (!video) {
            throw new Error('there is no element or url setting for video mask');
        }
        video.autoplay = this.options.autoplay || true;
        video.loop = this.options.loop || true;
        video.muted = this.options.muted || true;
        video.play();
        video.addEventListener('playing', () => {
            this._videoState = 'playing';
        });
        video.addEventListener('pause', () => {
            this._videoState = 'pause';
        });
        this._video = video;
    }

    _update() {
        const mesh = this._mesh;
        if (!mesh) {
            return;
        }
        if (mesh.material) {
            const videoTexture = mesh.material.get('maskTexture');
            if (videoTexture && this._video && this._needUpdate()) {
                videoTexture(this._video);
            }
        }
    }

    _needUpdate() {
        return this._videoState === 'playing';
    }
}

class ImageMask extends Mask {
    /**
     * @param  {Object} options.url   image resource url
     */
    constructor(coordinates, options) {
        super(coordinates, options);
        this._mode = 'texture';
    }

    setUrl(url) {
        this.options.url = url;
        const mesh = this._mesh;
        if (!mesh) {
            return;
        }
        if (mesh.material) {
            const maskTexture = mesh.material.get('maskTexture');
            if (maskTexture) {
                this._createTexture(maskTexture);
                const layer = this.getLayer();
                if (layer) {
                    layer.getRenderer().setToRedraw();
                }
            }
        }
    }

    _createMesh(regl) {
        const { geometry, copyGeometry } = this._createGeometry(regl);
        const mesh = new Mesh(geometry);
        const texture = regl.texture();
        this._createTexture(texture);
        mesh.material = new Material({ maskTexture: texture });
        this._setDefines(mesh);
        this._setLocalTransform(mesh);
        //this._copyMesh用于后面insect frustum的判断，之所以不直接用this._mesh，有高度的考量
        this._copyMesh = new Mesh(copyGeometry);
        this._setLocalTransform(this._copyMesh);
        return mesh;
    }

    _updateUniforms(mesh) {
        const maskMode = this._getMaskMode();
        mesh.setUniform('maskMode', maskMode);
        const color = this._getMaskColor();
        mesh.setUniform('maskColor', color);
        if (this._positions && this._positions.length) {
            for (let i = 0; i < 4; i++) {
                mesh.setUniform('mask_position' + i, this._positions.slice(i * 3, i * 3 + 3));
            }
        }
    }

    _setDefines(mesh) {
        const defines = mesh.getDefines();
        defines['HAS_TEXTURE'] = 1;
        mesh.setDefines(defines);
    }

    _createTexture(imageTexture) {
        const image = new Image();
        image.src = this.options.url;
        image.crossOrigin = 'anonymous';
        image.onload = function () {
            imageTexture(image);
        };
        image.onerror = function () {
            console.warn('Image load error');
        };
    }

    getBBox() {
        return this._copyMesh.getBoundingBox();
    }
}

class ElevateMask extends FlatMask {
    constructor(coordinates, options) {
        super(coordinates, options);
        this.setElevation(options.elevation);
        this._mode = 'elevate';
    }

    setElevation(elevation) {
        this.options.elevation = elevation;
        this.setFlatheight(this.options.elevation);
    }
}

const LEFT_POINT = new Point(0, 0), RIGHT_POINT = new Point(0, 0), CENTER_POINT = new Point(0, 0), TEMP_POINT = new Point(0, 0);

class BoxClipMask extends ClipMask {
    constructor(position, options) {
        super([], options);
        this._position = position;
    }

    setPosition(position) {
        this._position = position;
        this._updateCoordinates();
    }

    getPosition() {
        return this._position;
    }

    setWidth(width) {
        this.options['width'] = width;
        this._updateCoordinates();
    }

    setLength(length) {
        this.options['length'] = length;
        this._updateCoordinates();
    }

    setHeight(height) {
        this.options['height'] = height;
        this._updateCoordinates();
    }

    setRotation(rotation) {
        this.options['rotation'] = rotation;
        this._updateCoordinates();
    }

    _updateCoordinates() {
        const layer = this.getLayer();
        if (!layer) {
            return;
        }
        const map = layer.getMap();
        if (map) {
            const { length, width, height } = this.options;
            const center = this._position;
            const rotation = this.options['rotation'] || 0;
            const { coordinates, heightRange } = this._generateCoordinates(map, center, length, width, height, rotation);
            this.setCoordinates(coordinates);
            this.setHeightRange(heightRange);
        }
    }

    _generateCoordinates(map, center, length, width, height, rotation) {
        const glRes = map.getGLRes();
        const pointLeft = map.distanceToPointAtRes(width / 2, 0, glRes, LEFT_POINT);
        const pointTop = map.distanceToPointAtRes(0, length / 2, glRes, RIGHT_POINT);
        const pointCenter = map.coordinateToPointAtRes(center, glRes, CENTER_POINT);
        const leftPointX = pointCenter.x - pointLeft.x;
        const rightPointX = pointCenter.x + pointLeft.x;
        const topPointY = pointCenter.y + pointTop.y;
        const buttomPointY = pointCenter.y - pointTop.y;
        const points = this._rotatePoint([[leftPointX, topPointY], [rightPointX, topPointY], [rightPointX, buttomPointY], [leftPointX, buttomPointY]], pointCenter, rotation);
        TEMP_POINT.set(points[0][0], points[0][1]);
        const lt = map.pointAtResToCoordinate(TEMP_POINT, glRes);
        TEMP_POINT.set(points[1][0], points[1][1]);
        const rt = map.pointAtResToCoordinate(TEMP_POINT, glRes);
        TEMP_POINT.set(points[2][0], points[2][1]);
        const rb = map.pointAtResToCoordinate(TEMP_POINT, glRes);
        TEMP_POINT.set(points[3][0], points[3][1]);
        const lb = map.pointAtResToCoordinate(TEMP_POINT, glRes);
        const buttom = center.z - height / 2;
        const top = center.z + height / 2;
        const heightRange = [buttom, top];
        const coordinates = [[lt.x, lt.y, buttom], [rt.x, rt.y, buttom], [rb.x, rb.y, buttom], [lb.x, lb.y, buttom], [lt.x, lt.y, buttom]];
        return { coordinates, heightRange };
    }

    _rotatePoint(points, center, rotation) {
        for (let i = 0; i < points.length; i++) {
            vec2.rotate(points[i], points[i], [center.x, center.y], rotation * Math.PI / 180);
        }
        return points;
    }
}

class BoxInsideClipper extends BoxClipMask {
    constructor(position, options) {
        super(position, options);
        this._mode = 'clip-inside';
    }
}

class BoxOutsideClipper extends BoxClipMask {
    constructor(position, options) {
        super(position, options);
        this._mode = 'clip-outside';
    }
}

const options = {
    'mode': 'LineString',
    'language': 'zh-CN', //'en-US'
    'metric': true,
    'imperial': false,
    'once': true,
    'symbol': {
        'lineColor': "#e8542b",
        'lineWidth': 2,
        'polygonFill': '#eee',
        'polygonOpacity': 0.5
    },
    'vertexSymbol': {
        'markerType': 'ellipse',
        'markerFill': '#e8542b',
        'markerLineColor': '#fff',
        'markerLineWidth': 2,
        'markerWidth': 10,
        'markerHeight': 10,
        'markerDy': 0
    },
    'labelSymbol': {
        'boxStyle' : {
            'padding' : [15, 6],
            'verticalAlignment' : 'top',
            'horizontalAlignment' : 'left',
            'minWidth' : 150,
            'minHeight' : 30,
            'symbol' : {
                'markerType': 'square',
                'markerFill': 'rgb(60, 60, 60)',
                'markerFillOpacity' : 0.8,
                'markerLineColor': '#fff',
                'markerLineWidth': 2,
                'textDx': -110
            }
        },
        'textSymbol': {
            'textFill': '#fff',
            'textSize': 16,
            'textVerticalAlignment': 'top'
        }
    }
};
class Measure3DTool extends maptalks.DrawTool {
    constructor(options) {
        super(options);
        this.on('enable', this._afterEnable, this);
        this.on('disable', this._afterDisable, this);
        this._drawCoordinates = [];
    }

    addTo(map) {
        if (map) {
            super.addTo(map);
            this._map = map;
            this._addHelperLayer();
        }
        return this;
    }

    _addHelperLayer() {
        const id = maptalks.INTERNAL_LAYER_PREFIX + 'drawtool';
        const drawtoolLayer = this._map.getLayer(id);
        if (drawtoolLayer) {
            drawtoolLayer.hide();
        }
    }

    _afterEnable() {
        this.on('drawstart', this._msOnDrawStart, this)
            .on('drawvertex', this._msOnDrawVertex, this)
            .on('mousemove', this._msOnMouseMove, this)
            .on('drawend', this._msOnDrawEnd, this);
    }

    _afterDisable() {
        this.off('drawstart', this._msOnDrawStart, this)
            .off('drawvertex', this._msOnDrawVertex, this)
            .off('mousemove', this._msOnMouseMove, this)
            .off('drawend', this._msOnDrawEnd, this);
    }

    _getPickedCoordinate(e) {
        const { coordinate, containerPoint } = e;
        const gllayer = this._map.getLayers((layer) => {
            return layer.queryTerrainAtPoint;
        })[0];
        if (!gllayer) {
            coordinate.z = coordinate.z || 0;
            return coordinate;
        }
        const identifyData = gllayer.identify(coordinate, { includeInternals: false })[0];
        const pickedPoint = identifyData && identifyData.coordinate;
        let pickCoord = null;
        if (pickedPoint) {
            pickCoord = new maptalks.Coordinate(identifyData.coordinate);
        } else {
            coordinate.z = coordinate.z || 0;
            pickCoord = coordinate;
        }
        if (gllayer.getTerrainLayer()) {
            const pickedTerrainCoord = gllayer.queryTerrainAtPoint(containerPoint);
            return pickedTerrainCoord && pickedTerrainCoord.z > pickCoord.z ? pickedTerrainCoord : pickCoord;
        }
        return pickCoord;
    }

    _msOnDrawStart(e) {
        const coordinate = this._getPickedCoordinate(e);
        if (!coordinate) {
            return;
        }
        this._first = true;
        this._drawCoordinates.push(coordinate);
        this._addHelperGeometry(coordinate);
    }

    _msOnDrawVertex(e) {
        const coordinate = this._getPickedCoordinate(e);
        if (!coordinate) {
            return;
        }
        this._first = true;
        this._drawCoordinates[this._drawCoordinates.length - 1] = coordinate;
        this._drawVertexMarker();
        const tempGeometry = this.getTempGeometry();
        if (tempGeometry) {
            tempGeometry.hide();
        }
    }

    _msOnMouseMove(e) {
        const coordinate = this._getPickedCoordinate(e);
        if (!coordinate) {
            return;
        }
        if (this._first) {
            this._drawCoordinates.push(coordinate);
        } else {
            this._drawCoordinates[this._drawCoordinates.length - 1] = coordinate;
        }
        this._drawVertexMarker();
        this._first = false;
    }

    _msOnDrawEnd(e) {
        const coordinate = this._getPickedCoordinate(e);
        if (!coordinate) {
            return;
        }
        this._drawCoordinates.push(coordinate);
        this._drawEnd();
    }

    _drawEnd() {
        this._drawVertexMarker();
        this._drawCoordinates = [];
        this._helperGeometry = null;
        this._label = null;
    }

    remove() {
        if (this._helperLayer) {
            this._helperLayer.remove();
        }
        if (this._markerLayer) {
            this._markerLayer.remove();
        }
    }

    clear() {
        if (this._helperLayer) {
            this._helperLayer.clear();
        }
        if (this._markerLayer) {
            this._markerLayer.clear();
        }
    }
}

Measure3DTool.mergeOptions(options);

class Distance3DTool extends Measure3DTool {

    _addHelperLayer() {
        super._addHelperLayer();
        this._helperLayer = new maptalks.DrawToolLayer(maptalks.INTERNAL_LAYER_PREFIX + '_distance3dtool').addTo(this._map);
        this._markerLayer = new maptalks.DrawToolLayer(maptalks.INTERNAL_LAYER_PREFIX + '_distance3dtool_marker').addTo(this._map);
    }

    _drawVertexMarker() {
        this._helperGeometry.setCoordinates(this._drawCoordinates);
        const markers = this._markerLayer.getGeometries();
        const geometryCount = this._helperLayer.getGeometries().length;
        for (let i = 0; i < markers.length; i++) {
            const id = markers[i].getId();
            if ( id !== 'label' + geometryCount && id.indexOf(`${geometryCount}_`) > -1) {
                markers[i].remove();
            }
        }
        for (let i = 0; i < this._drawCoordinates.length; i++) {
            new maptalks.Marker(this._drawCoordinates[i], {
                id: geometryCount + '_' + i,
                symbol: this.options['vertexSymbol'],
            }).addTo(this._markerLayer);
        }
        this._drawLabel();
    }

    _drawLabel() {
        const distance = this.getMeasureResult();
        const language = this.options['language'] === 'zh-CN' ? 0 : 1;
        const unitContent = this._getUnitContent(distance);
        const content = (!language ? '距离: ' : 'distance: ') + unitContent;
        const labelCoordinate = this._drawCoordinates[this._drawCoordinates.length - 1];
        const geometryCount = this._helperLayer.getGeometries().length;
        const options = maptalks.Util.extend({ id: 'label' + geometryCount }, this.options.labelSymbol);
        if (!this._label) {
            this._label = new maptalks.Label(content, labelCoordinate, options).addTo(this._markerLayer);
        } else {
            this._label.setContent(content);
            this._label.setCoordinates(labelCoordinate);
        }
    }

    _getUnitContent(length) {
        let units;
        if (this.options['language'] === 'zh-CN') {
            units = [' 米', ' 公里', ' 英尺', ' 英里'];
        } else {
            units = [' m', ' km', ' feet', ' mile'];
        }
        let content = '';
        if (this.options['metric']) {
            this._measure = length < 1000 ? length.toFixed(1) : (length / 1000).toFixed(2);
            this._units = length < 1000 ? units[0] : units[1];
        }
        if (this.options['imperial']) {
            length *= 3.2808399;
            if (content.length > 0) {
                content += '\n';
            }
            this._measure = length < 5280 ? length.toFixed(1) : (length / 5280).toFixed(2);
            this._units = length < 5280 ? units[2] : units[3];
        }
        content += this._measure + this._units;
        return content;
    }

    _addHelperGeometry(coordinate) {
        if (!this._helperGeometry) {
            this._helperGeometry = new maptalks.LineString([coordinate], {
                symbol: this.options.symbol
            }).addTo(this._helperLayer);
        }
        this._drawVertexMarker();
        this._first = true;
    }

    getMeasureResult() {
        return this._helperGeometry.getLength();
    }
}

class Area3DTool extends Measure3DTool {

    _addHelperLayer() {
        super._addHelperLayer();
        this._helperLayer = new maptalks.DrawToolLayer(maptalks.INTERNAL_LAYER_PREFIX + '_area3dtool').addTo(this._map);
        this._markerLayer = new maptalks.DrawToolLayer(maptalks.INTERNAL_LAYER_PREFIX + '_area3dtool_marker').addTo(this._map);
    }

    _drawVertexMarker() {
        const coordinates = this._getPolygonCoordinates(this._drawCoordinates);
        this._helperGeometry.setCoordinates(coordinates);
        this._polygon.setCoordinates(coordinates);
        const markers = this._markerLayer.getGeometries();
        const geometryCount = this._helperLayer.getGeometries().length;
        for (let i = 0; i < markers.length; i++) {
            const id = markers[i].getId();
            if ( id !== 'label' + geometryCount && id.indexOf(`${geometryCount}_`) > -1) {
                markers[i].remove();
            }
        }
        for (let i = 0; i < this._drawCoordinates.length; i++) {
            new maptalks.Marker(this._drawCoordinates[i], {
                id: geometryCount + '_' + i,
                symbol: this.options['vertexSymbol']
            }).addTo(this._markerLayer);
        }
        this._drawLabel();
    }

    _getPolygonCoordinates(coordinates) {
        const polygonCoords = coordinates.map(coord => { return coord; });
        if (coordinates.length > 2) {
            polygonCoords.push(coordinates[0]);
        }
        return polygonCoords;
    }

    _drawLabel() {
        const distance = this.getMeasureResult();
        const language = this.options['language'] === 'zh-CN' ? 0 : 1;
        const unitContent = this._getUnitContent(distance);
        const content = (!language ? '面积: ' : 'area: ') + unitContent;
        const labelCoordinate = this._drawCoordinates[this._drawCoordinates.length - 1];
        const geometryCount = this._helperLayer.getGeometries().length;
        const options = maptalks.Util.extend({ id: 'label' + geometryCount }, this.options.labelSymbol);
        if (!this._label) {
            this._label = new maptalks.Label(content, labelCoordinate, options).addTo(this._markerLayer);
        } else {
            this._label.setContent(content);
            this._label.setCoordinates(labelCoordinate);
        }
    }

    _getUnitContent(area) {
        let units;
        if (this.options['language'] === 'zh-CN') {
            units = [' 平方米', ' 平方公里', ' 平方英尺', ' 平方英里'];
        } else {
            units = [' sq.m', ' sq.km', ' sq.ft', ' sq.mi'];
        }
        let content = '';
        if (this.options['metric']) {
            this._measure = area < 1E6 ? area.toFixed(2) :  (area / 1E6).toFixed(2);
            this._units = area < 1E6 ? units[0] : units[1];
        }
        if (this.options['imperial']) {
            area *= 3.2808399;
            if (content.length > 0) {
                content += '\n';
            }
            const sqmi = 5280 * 5280;
            this._measure = area < sqmi ? area.toFixed(2) :  (area / sqmi).toFixed(2);
            this._units =  area < sqmi ? units[2] : units[3];
        }
        content += this._measure + this._units;
        return content;
    }


    _addHelperGeometry(coordinate) {
        if (!this._helperGeometry) {
            this._helperGeometry = new maptalks.LineString([coordinate], {
                symbol: this.options.symbol
            }).addTo(this._helperLayer);
            this._polygon =  new maptalks.Polygon([coordinate]);
        }
        this._drawVertexMarker();
        this._first = true;
    }

    getMeasureResult() {
        return this._polygon.getArea();
    }
}

const MEASURE_HEIGHT_NAMES = [['直线距离', '垂直高度', '水平距离'], ['spatial distance', 'vertical height', 'horizontal distance']];
class Height3DTool extends Measure3DTool {

    _addHelperLayer() {
        super._addHelperLayer();
        this._helperLayer = new maptalks.DrawToolLayer(maptalks.INTERNAL_LAYER_PREFIX + '_height3dtool').addTo(this._map);
        this._markerLayer = new maptalks.DrawToolLayer(maptalks.INTERNAL_LAYER_PREFIX + '_height3dtool_marker').addTo(this._map);
    }

    _msOnDrawVertex(e) {
        super._msOnDrawVertex(e);
        if (this._drawCoordinates.length > 1) {
            this._drawEnd();
            this.disable();
        }
    }

    _drawVertexMarker() {
        const markers = this._markerLayer.getGeometries();
        const geometryCount = this._helperLayer.getGeometries().length;
        for (let i = 0; i < markers.length; i++) {
            const id = markers[i].getId();
            if ( id !== 'label' + geometryCount + '_' + i && id.indexOf(`${geometryCount}_`) === 0) {
                markers[i].remove();
            }
        }
        for (let i = 0; i < this._drawCoordinates.length; i++) {
            new maptalks.Marker(this._drawCoordinates[i], {
                id: geometryCount + '_' + i,
                symbol: this.options['vertexSymbol']
            }).addTo(this._markerLayer);
        }
        const len = this._drawCoordinates.length;
        if (len > 1) {
            const x = this._drawCoordinates[len - 1].x, y = this._drawCoordinates[len - 1].y, z = this._drawCoordinates[len - 2].z;
            const coord = new maptalks.Coordinate([x, y, z]);
            new maptalks.Marker(coord, {
                id: geometryCount + '_' + 2,
                symbol: this.options['vertexSymbol']
            }).addTo(this._markerLayer);
            const coordinates = [].concat(this._drawCoordinates);
            coordinates.push(coord);
            coordinates.push(this._drawCoordinates[0]);
            const altitude = coordinates.map(c => { return c.z;});
            this._helperGeometry.setCoordinates(coordinates);
            this._helperGeometry.setProperties({ altitude });
            const horizontalDistance = this._map.getProjection().measureLenBetween(coordinates[0], coordinates[2]);
            const height = coordinates[1].z - coordinates[2].z;
            const distance = Math.sqrt(Math.pow(horizontalDistance, 2) + Math.pow(height, 2));
            this._drawLabel(coordinates, [distance, height, horizontalDistance]);
        }
    }

    _drawLabel(coordinates, distances) {
        for (let i = 0; i < coordinates.length - 1; i++) {
            const from = coordinates[i], to = coordinates[i + 1];
            const distance = distances[i];
            const language = this.options['language'] === 'zh-CN' ? 0 : 1;
            const unitContent = this._getUnitContent(distance);
            const content = MEASURE_HEIGHT_NAMES[language][i] + ':' + unitContent;
            const geometryCount = this._helperLayer.getGeometries().length;
            const id = 'label' + geometryCount + '_' + i;
            const options = JSON.parse(JSON.stringify(this.options.labelSymbol));
            options.id = id;
            if (i < 2) {
                options.boxStyle.symbol.textDx *= -1;
            }
            const labelCoordinate = i === 1 ? from : new maptalks.Coordinate((from.x + to.x) / 2, (from.y + to.y) / 2, (from.z + to.z) / 2);
            const label = this._markerLayer.getGeometryById(id);
            const markerId = `${id}_marker`;
            const marker = this._markerLayer.getGeometryById(markerId);
            if (!label) {
                new maptalks.Label(content, labelCoordinate, options).addTo(this._markerLayer);
                new maptalks.Marker(labelCoordinate, {
                    id: markerId,
                    symbol: this.options['vertexSymbol']
                }).addTo(this._markerLayer);
            } else {
                label.setContent(content);
                label.setCoordinates(labelCoordinate);
                marker.setCoordinates(labelCoordinate);
            }
        }
    }

    _getUnitContent(length) {
        let units;
        if (this.options['language'] === 'zh-CN') {
            units = [' 米', ' 公里', ' 英尺', ' 英里'];
        } else {
            units = [' m', ' km', ' feet', ' mile'];
        }
        let content = '';
        if (this.options['metric']) {
            this._measure = length < 1000 ? length.toFixed(1) : (length / 1000).toFixed(2);
            this._units = length < 1000 ? units[0] : units[1];
        }
        if (this.options['imperial']) {
            length *= 3.2808399;
            if (content.length > 0) {
                content += '\n';
            }
            this._measure = length < 5280 ? length.toFixed(1) : (length / 5280).toFixed(2);
            this._units = length < 5280 ? units[2] : units[3];
        }
        content += this._measure + this._units;
        return content;
    }

    _addHelperGeometry(coordinate) {
        if (!this._helperGeometry) {
            this._helperGeometry = new maptalks.LineString([coordinate], {
                symbol: this.options.symbol
            }).addTo(this._helperLayer);
        }
        this._drawVertexMarker();
        this._first = true;
    }

    getMeasureResult() {
        return this._helperGeometry.getLength();
    }
}

const e = "${"; const code$1 = `function(t){
/*!
     * @maptalks/gltf-loader v0.124.4
     * LICENSE : UNLICENSED
     * (c) 2016-2026 maptalks.org
     */
var e,r,n="undefined"!=typeof Float32Array?Float32Array:Array;function i(){var t=new n(3);return n!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t}function s(t,e,r){var i=new n(3);return i[0]=t,i[1]=e,i[2]=r,i}function a(){var t=new n(4);return n!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t[3]=1,t}Math.hypot||(Math.hypot=function(){for(var t=0,e=arguments.length;e--;)t+=arguments[e]*arguments[e];return Math.sqrt(t)}),i(),e=new n(4),n!=Float32Array&&(e[0]=0,e[1]=0,e[2]=0,e[3]=0),i(),s(1,0,0),s(0,1,0),a(),a(),r=new n(9),n!=Float32Array&&(r[1]=0,r[2]=0,r[3]=0,r[5]=0,r[6]=0,r[7]=0),r[0]=1,r[4]=1,r[8]=1;let o=0;function h(t){for(let e=1;e<arguments.length;e++){const r=arguments[e];for(const e in r)t[e]=r[e]}return t}!function(t){t[0]=0,t[1]=0,t[2]=0,t[3]=1}([]),"undefined"!=typeof TextDecoder&&new TextDecoder("utf-8");const c={get:function(t,e={},r){e||(e={}),e=h({},e);const n=new AbortController,i=n.signal,s=h({},e);s.signal=i,s.method||(s.method="GET"),s.referrerPolicy=s.referrerPolicy||"origin","undefined"==typeof window||s.referrer||(s.referrer=window.location.href),r&&(t=r(t));const a=fetch(t,s).then((t=>{const r=this._parseResponse(t,e.responseType);return r.message?r:r.then((r=>"arraybuffer"===e.responseType?{data:r,cacheControl:t.headers.get("Cache-Control"),expires:t.headers.get("Expires"),contentType:t.headers.get("Content-Type")}:r)).catch((t=>{if(!t.code||t.code!==DOMException.ABORT_ERR)throw t}))})).catch((t=>{if(!t.code||t.code!==DOMException.ABORT_ERR)throw t}));return a.xhr=n,a},_parseResponse:(t,e)=>200!==t.status?{status:t.status,statusText:t.statusText,message:\`incorrect http request with status code(${e}t.status}): ${e}t.statusText}\`}:"arraybuffer"===e?t.arrayBuffer():"json"===e?t.json():t.text(),getArrayBuffer:(t,e={},r)=>(e||(e={}),e.responseType="arraybuffer",c.get(t,e,r)),getJSON:function(t,e={},r){return e&&e.jsonp?c.jsonp(t):((e=e||{}).responseType="json",c.get(t,e,r))},jsonp:function(t){const e="_maptalks_jsonp_"+o++;t.match(/\\?/)?t+="&callback="+e:t+="?callback="+e;let r=document.createElement("script");return r.type="text/javascript",r.src=t,new Promise((t=>{window[e]=function(n){document.getElementsByTagName("head")[0].removeChild(r),r=null,delete window[e],t(n)},document.getElementsByTagName("head")[0].appendChild(r)}))}};if("undefined"!=typeof TextDecoder&&new TextDecoder("utf-8"),"undefined"!=typeof OffscreenCanvas){let t;try{t=new OffscreenCanvas(2,2).getContext("2d")}catch(n){}}"undefined"!=typeof document&&document.createElement("canvas"),
/** @license zlib.js 2012 - imaya [ https://github.com/imaya/zlib.js ] The MIT License */function(){function t(t){throw t}var e=void 0,r=!0,n=this;function i(t,r){var i,s=t.split("."),a=n;!(s[0]in a)&&a.execScript&&a.execScript("var "+s[0]);for(;s.length&&(i=s.shift());)s.length||r===e?a=a[i]?a[i]:a[i]={}:a[i]=r}var s="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Uint32Array&&"undefined"!=typeof DataView;function a(e,r){this.index="number"==typeof r?r:0,this.i=0,this.buffer=e instanceof(s?Uint8Array:Array)?e:new(s?Uint8Array:Array)(32768),2*this.buffer.length<=this.index&&t(Error("invalid index")),this.buffer.length<=this.index&&this.f()}a.prototype.f=function(){var t,e=this.buffer,r=e.length,n=new(s?Uint8Array:Array)(r<<1);if(s)n.set(e);else for(t=0;t<r;++t)n[t]=e[t];return this.buffer=n},a.prototype.d=function(t,e,r){var n,i=this.buffer,s=this.index,a=this.i,o=i[s];if(r&&1<e&&(t=8<e?(u[255&t]<<24|u[t>>>8&255]<<16|u[t>>>16&255]<<8|u[t>>>24&255])>>32-e:u[t]>>8-e),8>e+a)o=o<<e|t,a+=e;else for(n=0;n<e;++n)o=o<<1|t>>e-n-1&1,8==++a&&(a=0,i[s++]=u[o],o=0,s===i.length&&(i=this.f()));i[s]=o,this.buffer=i,this.i=a,this.index=s},a.prototype.finish=function(){var t,e=this.buffer,r=this.index;return 0<this.i&&(e[r]<<=8-this.i,e[r]=u[e[r]],r++),s?t=e.subarray(0,r):(e.length=r,t=e),t};var o,h=new(s?Uint8Array:Array)(256);for(o=0;256>o;++o){for(var c=l=o,f=7,l=l>>>1;l;l>>>=1)c<<=1,c|=1&l,--f;h[o]=(c<<f&255)>>>0}var u=h;function g(t){this.buffer=new(s?Uint16Array:Array)(2*t),this.length=0}function d(t){var e,r,n,i,a,o,h,c,f,l,u=t.length,g=0,d=Number.POSITIVE_INFINITY;for(c=0;c<u;++c)t[c]>g&&(g=t[c]),t[c]<d&&(d=t[c]);for(e=1<<g,r=new(s?Uint32Array:Array)(e),n=1,i=0,a=2;n<=g;){for(c=0;c<u;++c)if(t[c]===n){for(o=0,h=i,f=0;f<n;++f)o=o<<1|1&h,h>>=1;for(l=n<<16|c,f=o;f<e;f+=a)r[f]=l;++i}++n,i<<=1,a<<=1}return[r,g,d]}function p(t,e){this.h=m,this.w=0,this.input=s&&t instanceof Array?new Uint8Array(t):t,this.b=0,e&&(e.lazy&&(this.w=e.lazy),"number"==typeof e.compressionType&&(this.h=e.compressionType),e.outputBuffer&&(this.a=s&&e.outputBuffer instanceof Array?new Uint8Array(e.outputBuffer):e.outputBuffer),"number"==typeof e.outputIndex&&(this.b=e.outputIndex)),this.a||(this.a=new(s?Uint8Array:Array)(32768))}g.prototype.getParent=function(t){return 2*((t-2)/4|0)},g.prototype.push=function(t,e){var r,n,i,s=this.buffer;for(r=this.length,s[this.length++]=e,s[this.length++]=t;0<r&&(n=this.getParent(r),s[r]>s[n]);)i=s[r],s[r]=s[n],s[n]=i,i=s[r+1],s[r+1]=s[n+1],s[n+1]=i,r=n;return this.length},g.prototype.pop=function(){var t,e,r,n,i,s=this.buffer;for(e=s[0],t=s[1],this.length-=2,s[0]=s[this.length],s[1]=s[this.length+1],i=0;!((n=2*i+2)>=this.length)&&(n+2<this.length&&s[n+2]>s[n]&&(n+=2),s[n]>s[i]);)r=s[i],s[i]=s[n],s[n]=r,r=s[i+1],s[i+1]=s[n+1],s[n+1]=r,i=n;return{index:t,value:e,length:this.length}};var y,m=2,b={NONE:0,r:1,k:m,N:3},w=[];for(y=0;288>y;y++)switch(r){case 143>=y:w.push([y+48,8]);break;case 255>=y:w.push([y-144+400,9]);break;case 279>=y:w.push([y-256+0,7]);break;case 287>=y:w.push([y-280+192,8]);break;default:t("invalid literal: "+y)}function A(t,e){this.length=t,this.G=e}p.prototype.j=function(){var n,i,o,h,c=this.input;switch(this.h){case 0:for(o=0,h=c.length;o<h;){var f,l,u,g=i=s?c.subarray(o,o+65535):c.slice(o,o+65535),d=(o+=i.length)===h,p=e,y=e,b=this.a,A=this.b;if(s){for(b=new Uint8Array(this.a.buffer);b.length<=A+g.length+5;)b=new Uint8Array(b.length<<1);b.set(this.a)}if(f=d?1:0,b[A++]=0|f,u=65536+~(l=g.length)&65535,b[A++]=255&l,b[A++]=l>>>8&255,b[A++]=255&u,b[A++]=u>>>8&255,s)b.set(g,A),A+=g.length,b=b.subarray(0,A);else{for(p=0,y=g.length;p<y;++p)b[A++]=g[p];b.length=A}this.b=A,this.a=b}break;case 1:var v=new a(s?new Uint8Array(this.a.buffer):this.a,this.b);v.d(1,1,r),v.d(1,2,r);var k,x,M,I=E(this,c);for(k=0,x=I.length;k<x;k++)if(M=I[k],a.prototype.d.apply(v,w[M]),256<M)v.d(I[++k],I[++k],r),v.d(I[++k],5),v.d(I[++k],I[++k],r);else if(256===M)break;this.a=v.finish(),this.b=this.a.length;break;case m:var S,D,F,B,z,N,_,C,O,R,P,j,q,L,H,Y=new a(s?new Uint8Array(this.a.buffer):this.a,this.b),W=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],V=Array(19);for(S=m,Y.d(1,1,r),Y.d(S,2,r),D=E(this,c),_=U(N=T(this.L,15)),O=U(C=T(this.K,7)),F=286;257<F&&0===N[F-1];F--);for(B=30;1<B&&0===C[B-1];B--);var Z,G,$,J,K,X,Q=F,tt=B,et=new(s?Uint32Array:Array)(Q+tt),rt=new(s?Uint32Array:Array)(316),nt=new(s?Uint8Array:Array)(19);for(Z=G=0;Z<Q;Z++)et[G++]=N[Z];for(Z=0;Z<tt;Z++)et[G++]=C[Z];if(!s)for(Z=0,J=nt.length;Z<J;++Z)nt[Z]=0;for(Z=K=0,J=et.length;Z<J;Z+=G){for(G=1;Z+G<J&&et[Z+G]===et[Z];++G);if($=G,0===et[Z])if(3>$)for(;0<$--;)rt[K++]=0,nt[0]++;else for(;0<$;)(X=138>$?$:138)>$-3&&X<$&&(X=$-3),10>=X?(rt[K++]=17,rt[K++]=X-3,nt[17]++):(rt[K++]=18,rt[K++]=X-11,nt[18]++),$-=X;else if(rt[K++]=et[Z],nt[et[Z]]++,3>--$)for(;0<$--;)rt[K++]=et[Z],nt[et[Z]]++;else for(;0<$;)(X=6>$?$:6)>$-3&&X<$&&(X=$-3),rt[K++]=16,rt[K++]=X-3,nt[16]++,$-=X}for(n=s?rt.subarray(0,K):rt.slice(0,K),R=T(nt,7),L=0;19>L;L++)V[L]=R[W[L]];for(z=19;4<z&&0===V[z-1];z--);for(P=U(R),Y.d(F-257,5,r),Y.d(B-1,5,r),Y.d(z-4,4,r),L=0;L<z;L++)Y.d(V[L],3,r);for(L=0,H=n.length;L<H;L++)if(j=n[L],Y.d(P[j],R[j],r),16<=j){switch(L++,j){case 16:q=2;break;case 17:q=3;break;case 18:q=7;break;default:t("invalid code: "+j)}Y.d(n[L],q,r)}var it,st,at,ot,ht,ct,ft,lt,ut=[_,N],gt=[O,C];for(ht=ut[0],ct=ut[1],ft=gt[0],lt=gt[1],it=0,st=D.length;it<st;++it)if(at=D[it],Y.d(ht[at],ct[at],r),256<at)Y.d(D[++it],D[++it],r),ot=D[++it],Y.d(ft[ot],lt[ot],r),Y.d(D[++it],D[++it],r);else if(256===at)break;this.a=Y.finish(),this.b=this.a.length;break;default:t("invalid compression type")}return this.a};var v=function(){function e(e){switch(r){case 3===e:return[257,e-3,0];case 4===e:return[258,e-4,0];case 5===e:return[259,e-5,0];case 6===e:return[260,e-6,0];case 7===e:return[261,e-7,0];case 8===e:return[262,e-8,0];case 9===e:return[263,e-9,0];case 10===e:return[264,e-10,0];case 12>=e:return[265,e-11,1];case 14>=e:return[266,e-13,1];case 16>=e:return[267,e-15,1];case 18>=e:return[268,e-17,1];case 22>=e:return[269,e-19,2];case 26>=e:return[270,e-23,2];case 30>=e:return[271,e-27,2];case 34>=e:return[272,e-31,2];case 42>=e:return[273,e-35,3];case 50>=e:return[274,e-43,3];case 58>=e:return[275,e-51,3];case 66>=e:return[276,e-59,3];case 82>=e:return[277,e-67,4];case 98>=e:return[278,e-83,4];case 114>=e:return[279,e-99,4];case 130>=e:return[280,e-115,4];case 162>=e:return[281,e-131,5];case 194>=e:return[282,e-163,5];case 226>=e:return[283,e-195,5];case 257>=e:return[284,e-227,5];case 258===e:return[285,e-258,0];default:t("invalid length: "+e)}}var n,i,s=[];for(n=3;258>=n;n++)i=e(n),s[n]=i[2]<<24|i[1]<<16|i[0];return s}(),k=s?new Uint32Array(v):v;function E(n,i){function a(e,n){var i,s,a,o,h=e.G,c=[],f=0;switch(i=k[e.length],c[f++]=65535&i,c[f++]=i>>16&255,c[f++]=i>>24,r){case 1===h:s=[0,h-1,0];break;case 2===h:s=[1,h-2,0];break;case 3===h:s=[2,h-3,0];break;case 4===h:s=[3,h-4,0];break;case 6>=h:s=[4,h-5,1];break;case 8>=h:s=[5,h-7,1];break;case 12>=h:s=[6,h-9,2];break;case 16>=h:s=[7,h-13,2];break;case 24>=h:s=[8,h-17,3];break;case 32>=h:s=[9,h-25,3];break;case 48>=h:s=[10,h-33,4];break;case 64>=h:s=[11,h-49,4];break;case 96>=h:s=[12,h-65,5];break;case 128>=h:s=[13,h-97,5];break;case 192>=h:s=[14,h-129,6];break;case 256>=h:s=[15,h-193,6];break;case 384>=h:s=[16,h-257,7];break;case 512>=h:s=[17,h-385,7];break;case 768>=h:s=[18,h-513,8];break;case 1024>=h:s=[19,h-769,8];break;case 1536>=h:s=[20,h-1025,9];break;case 2048>=h:s=[21,h-1537,9];break;case 3072>=h:s=[22,h-2049,10];break;case 4096>=h:s=[23,h-3073,10];break;case 6144>=h:s=[24,h-4097,11];break;case 8192>=h:s=[25,h-6145,11];break;case 12288>=h:s=[26,h-8193,12];break;case 16384>=h:s=[27,h-12289,12];break;case 24576>=h:s=[28,h-16385,13];break;case 32768>=h:s=[29,h-24577,13];break;default:t("invalid distance")}for(i=s,c[f++]=i[0],c[f++]=i[1],c[f++]=i[2],a=0,o=c.length;a<o;++a)m[b++]=c[a];A[c[0]]++,v[c[3]]++,w=e.length+n-1,d=null}var o,h,c,f,l,u,g,d,p,y={},m=s?new Uint16Array(2*i.length):[],b=0,w=0,A=new(s?Uint32Array:Array)(286),v=new(s?Uint32Array:Array)(30),E=n.w;if(!s){for(c=0;285>=c;)A[c++]=0;for(c=0;29>=c;)v[c++]=0}for(A[256]=1,o=0,h=i.length;o<h;++o){for(c=l=0,f=3;c<f&&o+c!==h;++c)l=l<<8|i[o+c];if(y[l]===e&&(y[l]=[]),u=y[l],!(0<w--)){for(;0<u.length&&32768<o-u[0];)u.shift();if(o+3>=h){for(d&&a(d,-1),c=0,f=h-o;c<f;++c)p=i[o+c],m[b++]=p,++A[p];break}0<u.length?(g=x(i,o,u),d?d.length<g.length?(p=i[o-1],m[b++]=p,++A[p],a(g,0)):a(d,-1):g.length<E?d=g:a(g,0)):d?a(d,-1):(p=i[o],m[b++]=p,++A[p])}u.push(o)}return m[b++]=256,A[256]++,n.L=A,n.K=v,s?m.subarray(0,b):m}function x(t,e,r){var n,i,s,a,o,h,c=0,f=t.length;a=0,h=r.length;t:for(;a<h;a++){if(n=r[h-a-1],s=3,3<c){for(o=c;3<o;o--)if(t[n+o-1]!==t[e+o-1])continue t;s=c}for(;258>s&&e+s<f&&t[n+s]===t[e+s];)++s;if(s>c&&(i=n,c=s),258===s)break}return new A(c,e-i)}function T(t,e){var r,n,i,a,o,h=t.length,c=new g(572),f=new(s?Uint8Array:Array)(h);if(!s)for(a=0;a<h;a++)f[a]=0;for(a=0;a<h;++a)0<t[a]&&c.push(a,t[a]);if(r=Array(c.length/2),n=new(s?Uint32Array:Array)(c.length/2),1===r.length)return f[c.pop().index]=1,f;for(a=0,o=c.length/2;a<o;++a)r[a]=c.pop(),n[a]=r[a].value;for(i=function(t,e,r){function n(t){var r=d[t][p[t]];r===e?(n(t+1),n(t+1)):--u[r],++p[t]}var i,a,o,h,c,f=new(s?Uint16Array:Array)(r),l=new(s?Uint8Array:Array)(r),u=new(s?Uint8Array:Array)(e),g=Array(r),d=Array(r),p=Array(r),y=(1<<r)-e,m=1<<r-1;for(f[r-1]=e,a=0;a<r;++a)y<m?l[a]=0:(l[a]=1,y-=m),y<<=1,f[r-2-a]=(f[r-1-a]/2|0)+e;for(f[0]=l[0],g[0]=Array(f[0]),d[0]=Array(f[0]),a=1;a<r;++a)f[a]>2*f[a-1]+l[a]&&(f[a]=2*f[a-1]+l[a]),g[a]=Array(f[a]),d[a]=Array(f[a]);for(i=0;i<e;++i)u[i]=r;for(o=0;o<f[r-1];++o)g[r-1][o]=t[o],d[r-1][o]=o;for(i=0;i<r;++i)p[i]=0;for(1===l[r-1]&&(--u[0],++p[r-1]),a=r-2;0<=a;--a){for(h=i=0,c=p[a+1],o=0;o<f[a];o++)(h=g[a+1][c]+g[a+1][c+1])>t[i]?(g[a][o]=h,d[a][o]=e,c+=2):(g[a][o]=t[i],d[a][o]=i,++i);p[a]=0,1===l[a]&&n(a)}return u}(n,n.length,e),a=0,o=r.length;a<o;++a)f[r[a].index]=i[a];return f}function U(t){var e,r,n,i,a=new(s?Uint16Array:Array)(t.length),o=[],h=[],c=0;for(e=0,r=t.length;e<r;e++)o[t[e]]=1+(0|o[t[e]]);for(e=1,r=16;e<=r;e++)h[e]=c,c+=0|o[e],c<<=1;for(e=0,r=t.length;e<r;e++)for(c=h[t[e]],h[t[e]]+=1,n=a[e]=0,i=t[e];n<i;n++)a[e]=a[e]<<1|1&c,c>>>=1;return a}function M(e,r){switch(this.l=[],this.m=32768,this.e=this.g=this.c=this.q=0,this.input=s?new Uint8Array(e):e,this.s=!1,this.n=S,this.B=!1,!r&&(r={})||(r.index&&(this.c=r.index),r.bufferSize&&(this.m=r.bufferSize),r.bufferType&&(this.n=r.bufferType),r.resize&&(this.B=r.resize)),this.n){case I:this.b=32768,this.a=new(s?Uint8Array:Array)(32768+this.m+258);break;case S:this.b=0,this.a=new(s?Uint8Array:Array)(this.m),this.f=this.J,this.t=this.H,this.o=this.I;break;default:t(Error("invalid inflate mode"))}}var I=0,S=1,D={D:I,C:S};M.prototype.p=function(){for(;!this.s;){var n=$(this,3);switch(1&n&&(this.s=r),n>>>=1){case 0:var i=this.input,a=this.c,o=this.a,h=this.b,c=i.length,f=e,l=o.length,u=e;switch(this.e=this.g=0,a+1>=c&&t(Error("invalid uncompressed block header: LEN")),f=i[a++]|i[a++]<<8,a+1>=c&&t(Error("invalid uncompressed block header: NLEN")),f===~(i[a++]|i[a++]<<8)&&t(Error("invalid uncompressed block header: length verify")),a+f>i.length&&t(Error("input buffer is broken")),this.n){case I:for(;h+f>o.length;){if(f-=u=l-h,s)o.set(i.subarray(a,a+u),h),h+=u,a+=u;else for(;u--;)o[h++]=i[a++];this.b=h,o=this.f(),h=this.b}break;case S:for(;h+f>o.length;)o=this.f({v:2});break;default:t(Error("invalid inflate mode"))}if(s)o.set(i.subarray(a,a+f),h),h+=f,a+=f;else for(;f--;)o[h++]=i[a++];this.c=a,this.b=h,this.a=o;break;case 1:this.o(V,G);break;case 2:var g,p,y,m,b=$(this,5)+257,w=$(this,5)+1,A=$(this,4)+4,v=new(s?Uint8Array:Array)(N.length),k=e,E=e,x=e,T=e,U=e;for(U=0;U<A;++U)v[N[U]]=$(this,3);if(!s)for(U=A,A=v.length;U<A;++U)v[N[U]]=0;for(g=d(v),k=new(s?Uint8Array:Array)(b+w),U=0,m=b+w;U<m;)switch(E=J(this,g),E){case 16:for(T=3+$(this,2);T--;)k[U++]=x;break;case 17:for(T=3+$(this,3);T--;)k[U++]=0;x=0;break;case 18:for(T=11+$(this,7);T--;)k[U++]=0;x=0;break;default:x=k[U++]=E}p=d(s?k.subarray(0,b):k.slice(0,b)),y=d(s?k.subarray(b):k.slice(b)),this.o(p,y);break;default:t(Error("unknown BTYPE: "+n))}}return this.t()};var F,B,z=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],N=s?new Uint16Array(z):z,_=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,258,258],C=s?new Uint16Array(_):_,O=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0],R=s?new Uint8Array(O):O,P=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577],j=s?new Uint16Array(P):P,q=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],L=s?new Uint8Array(q):q,H=new(s?Uint8Array:Array)(288);for(F=0,B=H.length;F<B;++F)H[F]=143>=F?8:255>=F?9:279>=F?7:8;var Y,W,V=d(H),Z=new(s?Uint8Array:Array)(30);for(Y=0,W=Z.length;Y<W;++Y)Z[Y]=5;var G=d(Z);function $(e,r){for(var n,i=e.g,s=e.e,a=e.input,o=e.c,h=a.length;s<r;)o>=h&&t(Error("input buffer is broken")),i|=a[o++]<<s,s+=8;return n=i&(1<<r)-1,e.g=i>>>r,e.e=s-r,e.c=o,n}function J(e,r){for(var n,i,s=e.g,a=e.e,o=e.input,h=e.c,c=o.length,f=r[0],l=r[1];a<l&&!(h>=c);)s|=o[h++]<<a,a+=8;return(i=(n=f[s&(1<<l)-1])>>>16)>a&&t(Error("invalid code length: "+i)),e.g=s>>i,e.e=a-i,e.c=h,65535&n}function K(t){if("string"==typeof t){var e,r,n=t.split("");for(e=0,r=n.length;e<r;e++)n[e]=(255&n[e].charCodeAt(0))>>>0;t=n}for(var i,s=1,a=0,o=t.length,h=0;0<o;){o-=i=1024<o?1024:o;do{a+=s+=t[h++]}while(--i);s%=65521,a%=65521}return(a<<16|s)>>>0}function X(e,r){var n,i;if(this.input=e,this.c=0,!r&&(r={})||(r.index&&(this.c=r.index),r.verify&&(this.M=r.verify)),n=e[this.c++],i=e[this.c++],(15&n)===Q)this.method=Q;else t(Error("unsupported compression method"));0!=((n<<8)+i)%31&&t(Error("invalid fcheck flag:"+((n<<8)+i)%31)),32&i&&t(Error("fdict flag is not supported")),this.A=new M(e,{index:this.c,bufferSize:r.bufferSize,bufferType:r.bufferType,resize:r.resize})}M.prototype.o=function(t,e){var r=this.a,n=this.b;this.u=t;for(var i,s,a,o,h=r.length-258;256!==(i=J(this,t));)if(256>i)n>=h&&(this.b=n,r=this.f(),n=this.b),r[n++]=i;else for(o=C[s=i-257],0<R[s]&&(o+=$(this,R[s])),i=J(this,e),a=j[i],0<L[i]&&(a+=$(this,L[i])),n>=h&&(this.b=n,r=this.f(),n=this.b);o--;)r[n]=r[n++-a];for(;8<=this.e;)this.e-=8,this.c--;this.b=n},M.prototype.I=function(t,e){var r=this.a,n=this.b;this.u=t;for(var i,s,a,o,h=r.length;256!==(i=J(this,t));)if(256>i)n>=h&&(h=(r=this.f()).length),r[n++]=i;else for(o=C[s=i-257],0<R[s]&&(o+=$(this,R[s])),i=J(this,e),a=j[i],0<L[i]&&(a+=$(this,L[i])),n+o>h&&(h=(r=this.f()).length);o--;)r[n]=r[n++-a];for(;8<=this.e;)this.e-=8,this.c--;this.b=n},M.prototype.f=function(){var t,e,r=new(s?Uint8Array:Array)(this.b-32768),n=this.b-32768,i=this.a;if(s)r.set(i.subarray(32768,r.length));else for(t=0,e=r.length;t<e;++t)r[t]=i[t+32768];if(this.l.push(r),this.q+=r.length,s)i.set(i.subarray(n,n+32768));else for(t=0;32768>t;++t)i[t]=i[n+t];return this.b=32768,i},M.prototype.J=function(t){var e,r,n,i=this.input.length/this.c+1|0,a=this.input,o=this.a;return t&&("number"==typeof t.v&&(i=t.v),"number"==typeof t.F&&(i+=t.F)),2>i?r=(n=(a.length-this.c)/this.u[2]/2*258|0)<o.length?o.length+n:o.length<<1:r=o.length*i,s?(e=new Uint8Array(r)).set(o):e=o,this.a=e},M.prototype.t=function(){var t,e,r,n,i,a=0,o=this.a,h=this.l,c=new(s?Uint8Array:Array)(this.q+(this.b-32768));if(0===h.length)return s?this.a.subarray(32768,this.b):this.a.slice(32768,this.b);for(e=0,r=h.length;e<r;++e)for(n=0,i=(t=h[e]).length;n<i;++n)c[a++]=t[n];for(e=32768,r=this.b;e<r;++e)c[a++]=o[e];return this.l=[],this.buffer=c},M.prototype.H=function(){var t,e=this.b;return s?this.B?(t=new Uint8Array(e)).set(this.a.subarray(0,e)):t=this.a.subarray(0,e):(this.a.length>e&&(this.a.length=e),t=this.a),this.buffer=t},X.prototype.p=function(){var e,r=this.input;return e=this.A.p(),this.c=this.A.c,this.M&&((r[this.c++]<<24|r[this.c++]<<16|r[this.c++]<<8|r[this.c++])>>>0!==K(e)&&t(Error("invalid adler-32 checksum"))),e};var Q=8;function tt(t,e){this.input=t,this.a=new(s?Uint8Array:Array)(32768),this.h=et.k;var r,n={};for(r in!e&&(e={})||"number"!=typeof e.compressionType||(this.h=e.compressionType),e)n[r]=e[r];n.outputBuffer=this.a,this.z=new p(this.input,n)}var et=b;function rt(t,e){var r,n,s,a;if(Object.keys)r=Object.keys(e);else for(n in r=[],s=0,e)r[s++]=n;for(s=0,a=r.length;s<a;++s)i(t+"."+(n=r[s]),e[n])}tt.prototype.j=function(){var e,r,n,i,a,o,h,c=0;if(h=this.a,(e=Q)===Q)r=Math.LOG2E*Math.log(32768)-8;else t(Error("invalid compression method"));if(n=r<<4|e,h[c++]=n,e===Q)switch(this.h){case et.NONE:a=0;break;case et.r:a=1;break;case et.k:a=2;break;default:t(Error("unsupported compression type"))}else t(Error("invalid compression method"));return i=a<<6,h[c++]=i|31-(256*n+i)%31,o=K(this.input),this.z.b=c,c=(h=this.z.j()).length,s&&((h=new Uint8Array(h.buffer)).length<=c+4&&(this.a=new Uint8Array(h.length+4),this.a.set(h),h=this.a),h=h.subarray(0,c+4)),h[c++]=o>>24&255,h[c++]=o>>16&255,h[c++]=o>>8&255,h[c++]=255&o,h},i("Zlib.Inflate",X),i("Zlib.Inflate.prototype.decompress",X.prototype.p),rt("Zlib.Inflate.BufferType",{ADAPTIVE:D.C,BLOCK:D.D}),i("Zlib.Deflate",tt),i("Zlib.Deflate.compress",(function(t,e){return new tt(t,e).j()})),i("Zlib.Deflate.prototype.compress",tt.prototype.j),rt("Zlib.Deflate.CompressionType",{NONE:et.NONE,FIXED:et.r,DYNAMIC:et.k})}.call(self);var f="undefined"!=typeof Float32Array?Float32Array:Array;Math.hypot||(Math.hypot=function(){for(var t=0,e=arguments.length;e--;)t+=arguments[e]*arguments[e];return Math.sqrt(t)});var l,u=function(t,e,r){return t[0]=e[0]-r[0],t[1]=e[1]-r[1],t[2]=e[2]-r[2],t};function g(t,e,r){return t[0]=e,t[1]=r,t}l=new f(3),f!=Float32Array&&(l[0]=0,l[1]=0,l[2]=0),function(){var t=function(){var t=new f(2);return f!=Float32Array&&(t[0]=0,t[1]=0),t}()}();class d{constructor(t=257){this.gridSize=t;const e=t-1;if(e&e-1)throw new Error(\`Expected grid size to be 2^n+1, got ${e}t}.\`);this.numTriangles=e*e*2-2,this.numParentTriangles=this.numTriangles-e*e,this.indices=new Uint32Array(this.gridSize*this.gridSize),this.coords=new Uint16Array(4*this.numTriangles);for(let t=0;t<this.numTriangles;t++){let r=t+2,n=0,i=0,s=0,a=0,o=0,h=0;for(1&r?s=a=o=e:n=i=h=e;(r>>=1)>1;){const t=n+s>>1,e=i+a>>1;1&r?(s=n,a=i,n=o,i=h):(n=s,i=a,s=o,a=h),o=t,h=e}const c=4*t;this.coords[c+0]=n,this.coords[c+1]=i,this.coords[c+2]=s,this.coords[c+3]=a}}createTile(t){return new p(t,this)}}class p{constructor(t,e){const r=e.gridSize;if(t.length!==r*r)throw new Error(\`Expected terrain data of length ${e}r*r} (${e}r} x ${e}r}), got ${e}t.length}.\`);this.terrain=t,this.martini=e,this.errors=new Float32Array(t.length),this.update()}update(){const{numTriangles:t,numParentTriangles:e,coords:r,gridSize:n}=this.martini,{terrain:i,errors:s}=this;for(let a=t-1;a>=0;a--){const t=4*a,o=r[t+0],h=r[t+1],c=r[t+2],f=r[t+3],l=o+c>>1,u=h+f>>1,g=l+u-h,d=u+o-l,p=(i[h*n+o]+i[f*n+c])/2,y=u*n+l,m=Math.abs(p-i[y]);if(s[y]=Math.max(s[y],m),a<e){const t=(h+d>>1)*n+(o+g>>1),e=(f+d>>1)*n+(c+g>>1);s[y]=Math.max(s[y],s[t],s[e])}}}getMesh(t=0){const{gridSize:e,indices:r}=this.martini,{errors:n}=this;let i=0,s=0;const a=e-1;function o(a,h,c,f,l,u){const g=a+c>>1,d=h+f>>1;Math.abs(a-l)+Math.abs(h-u)>1&&n[d*e+g]>t?(o(l,u,a,h,g,d),o(c,f,l,u,g,d)):(r[h*e+a]=r[h*e+a]||++i,r[f*e+c]=r[f*e+c]||++i,r[u*e+l]=r[u*e+l]||++i,s++)}r.fill(0),o(0,0,a,a,a,0),o(a,a,0,0,0,a);const h=new Uint16Array(2*i),c=new Uint32Array(3*s);let f=0;function l(i,s,a,o,u,g){const d=i+a>>1,p=s+o>>1;if(Math.abs(i-u)+Math.abs(s-g)>1&&n[p*e+d]>t)l(u,g,i,s,d,p),l(a,o,u,g,d,p);else{const t=r[s*e+i]-1,n=r[o*e+a]-1,l=r[g*e+u]-1;h[2*t]=i,h[2*t+1]=s,h[2*n]=a,h[2*n+1]=o,h[2*l]=u,h[2*l+1]=g,c[f++]=t,c[f++]=n,c[f++]=l}}return l(0,0,a,a,a,0),l(a,a,0,0,0,a),{vertices:h,triangles:c}}getMeshWithSkirts(t=0,e){const{gridSize:r,indices:n}=this.martini,{errors:i}=this;let s=0,a=0;const o=r-1;let h,c,f=0;const l=[],u=[],g=[],d=[];function p(e,y,m,b,w,A){const v=e+m>>1,k=y+b>>1;Math.abs(e-w)+Math.abs(y-A)>1&&i[k*r+v]>t?(p(w,A,e,y,v,k),p(m,b,w,A,v,k)):(h=y*r+e,c=b*r+m,f=A*r+w,0===n[h]&&(0===e?l.push(s):e===o&&u.push(s),0===y?g.push(s):y===o&&d.push(s),n[h]=++s),0===n[c]&&(0===m?l.push(s):m===o&&u.push(s),0===b?g.push(s):b===o&&d.push(s),n[c]=++s),0===n[f]&&(0===w?l.push(s):w===o&&u.push(s),0===A?g.push(s):A===o&&d.push(s),n[f]=++s),a++)}let y;n.fill(0),p(0,0,o,o,o,0),p(o,o,0,0,0,o),y=e?2*(s+3*l.length-2+3*u.length-2+3*g.length-2+3*d.length-2):2*(s+l.length+u.length+g.length+d.length);const m=3*(a+2*(l.length-1)+2*(u.length-1)+2*(g.length-1)+2*(d.length-1)),b=new Uint16Array(y),w=new Uint32Array(m);let A=0;function v(e,s,a,o,h,c){const f=e+a>>1,l=s+o>>1;if(Math.abs(e-h)+Math.abs(s-c)>1&&i[l*r+f]>t)v(h,c,e,s,f,l),v(a,o,h,c,f,l);else{const t=n[s*r+e]-1,i=n[o*r+a]-1,f=n[c*r+h]-1;b[2*t]=e,b[2*t+1]=s,b[2*i]=a,b[2*i+1]=o,b[2*f]=h,b[2*f+1]=c,w[A++]=t,w[A++]=i,w[A++]=f}}v(0,0,o,o,o,0),v(o,o,0,0,0,o),l.sort(((t,e)=>b[2*t+1]-b[2*e+1])),u.sort(((t,e)=>b[2*e+1]-b[2*t+1])),g.sort(((t,e)=>b[2*e]-b[2*t])),d.sort(((t,e)=>b[2*t]-b[2*e]));let k,E,x,T,U=2*s,M=0;function I(t){M=t.length;for(let r=0;r<M-1;r++)k=t[r],E=t[r+1],x=U/2,T=(U+(e?6:2))/2,b[U++]=2*k,b[U++]=2*k+1,e&&(b[U++]=2*k,b[U++]=2*k+1,b[U++]=2*E,b[U++]=2*E+1),e?(w[A++]=x+1,w[A++]=x,w[A++]=x+2,w[A++]=x,w[A++]=T,w[A++]=x+2):(w[A++]=k,w[A++]=x,w[A++]=E,w[A++]=x,w[A++]=T,w[A++]=E);b[U++]=2*t[M-1],b[U++]=2*t[M-1]+1}I(l);const S=U;I(u);const D=U;I(g);const F=U;I(d);return{vertices:b,triangles:w,numVerticesWithoutSkirts:s,numTrianglesWithoutSkirts:a,leftSkirtIndex:S,rightSkirtIndex:D,bottomSkirtIndex:F,topSkirtIndex:U}}}const y={};let m;const b={width:100,height:10};let w=!1;try{const t=new OffscreenCanvas(1,1);t.getContext("2d").fillText("hello",0,0),w=!0}catch(t){w=!1}function A(){if(!m){const{width:t,height:e}=b;w?m=new OffscreenCanvas(t,e):(m=document.createElement("canvas"),m.width=t,m.height=e)}return m}class v{constructor(t,e={}){if(!Array.isArray(t))return void console.error("colors is not array");if(t.length<2)return void console.error("colors.length should >1");this.colors=t;let r=1/0,n=-1/0;for(let e=0,i=t.length;e<i;e++){const i=t[e][0];r=Math.min(i,r),n=Math.max(i,n)}this.min=r,this.max=n,this.valueOffset=this.max-this.min,this.options=Object.assign({},b,e),this._initImgData()}getImageData(){return this.imgData}_initImgData(){const t=A(),{width:e,height:r}=this.options;t.width=e,t.height=r;const n=t.getContext("2d");n.clearRect(0,0,t.width,t.height);const i=n.createLinearGradient(0,0,t.width,0),{colors:s,valueOffset:a}=this;for(let t=0,e=s.length;t<e;t++){const[e,r]=s[t],n=(e-this.min)/a;i.addColorStop(n,r)}n.fillStyle=i,n.fillRect(0,0,t.width,t.height),this.imgData=n.getImageData(0,0,t.width,t.height)}getColor(t){t=Math.max(this.min,t);const e=((t=Math.min(t,this.max))-this.min)/this.valueOffset;let r=Math.round(e*this.imgData.width);r=Math.min(r,this.imgData.width-1);const n=4*r;return[this.imgData.data[n],this.imgData.data[n+1],this.imgData.data[n+2],this.imgData.data[n+3]]}}var k="undefined"!=typeof Float32Array?Float32Array:Array;function E(t,e){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t}function x(t,e,r,n){return t[0]=e,t[1]=r,t[2]=n,t}function T(t,e,r){return t[0]=e[0]+r[0],t[1]=e[1]+r[1],t[2]=e[2]+r[2],t}function U(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]}var M=function(t,e,r){return t[0]=e[0]-r[0],t[1]=e[1]-r[1],t[2]=e[2]-r[2],t};
/*!
     * Contains code from THREE.JS
     * https://github.com/mrdoob/three.js/
     * License MIT
     * 
     * Generate tangents per vertex.
     */
function I(t,e,r,n,i){const s=t.length/3,a=new Array(4*s),o=[],h=[];for(let t=0;t<s;t++)o[t]=[0,0,0],h[t]=[0,0,0];const c=[0,0,0],f=[0,0,0],l=[0,0,0],u=[0,0],g=[0,0],d=[0,0],p=[0,0,0],y=[0,0,0];function m(e,n,i){S(c,t,3*e),S(f,t,3*n),S(l,t,3*i),D(u,r,2*e),D(g,r,2*n),D(d,r,2*i);const s=f[0]-c[0],a=l[0]-c[0],m=f[1]-c[1],b=l[1]-c[1],w=f[2]-c[2],A=l[2]-c[2],v=g[0]-u[0],k=d[0]-u[0],E=g[1]-u[1],U=d[1]-u[1],M=1/(v*U-k*E);x(p,(U*s-E*a)*M,(U*m-E*b)*M,(U*w-E*A)*M),x(y,(v*a-k*s)*M,(v*b-k*m)*M,(v*A-k*w)*M),T(o[e],o[e],p),T(o[n],o[n],p),T(o[i],o[i],p),T(h[e],h[e],y),T(h[n],h[n],y),T(h[i],h[i],y)}for(let t=0,e=n.length;t<e;t+=3)m(n[t+0],n[t+1],n[t+2]);const b=[],w=[],A=[],v=[];let k,I,F;function B(t){S(A,e,3*t),E(v,A),I=o[t],E(b,I),M(b,b,function(t,e,r){return t[0]=e[0]*r,t[1]=e[1]*r,t[2]=e[2]*r,t}(A,A,U(A,I))),function(t,e){var r=e[0],n=e[1],i=e[2],s=r*r+n*n+i*i;s>0&&(s=1/Math.sqrt(s),t[0]=e[0]*s,t[1]=e[1]*s,t[2]=e[2]*s)}(b,b),function(t,e,r){var n=e[0],i=e[1],s=e[2],a=r[0],o=r[1],h=r[2];t[0]=i*h-s*o,t[1]=s*a-n*h,t[2]=n*o-i*a}(w,v,I),F=U(w,h[t]),k=F<0?-1:1,a[4*t]=b[0],a[4*t+1]=b[1],a[4*t+2]=b[2],a[4*t+3]=k}for(let t=0,e=n.length;t<e;t+=3)B(n[t+0]),B(n[t+1]),B(n[t+2]);return a}function S(t,e,r){return t[0]=e[r],t[1]=e[r+1],t[2]=e[r+2],t}function D(t,e,r){return t[0]=e[r],t[1]=e[r+1],t}function F(t){return"number"==typeof t&&!isNaN(t)}let B;!function(){var t=function(){var t=new k(3);return k!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t}()}();let z=null,N=null;const _=[0,0,0],C=[256,256];function O(){try{z||(z=new OffscreenCanvas(1,1))}catch(t){console.error(t)}}const R={},P={},j={width:64,height:64,elementsPerHeight:3,heightOffset:-1e3,exaggeration:1,heightScale:.001,elementMultiplier:256,stride:4,skirtHeight:.002,skirtOffset:.01},q={cesium_request_token:{Accept:"application/json,*/*;q=0.01","Accept-Encoding":"gzip, deflate, br"},tianditu:{"Accept-Encoding":"gzip, deflate, br"},cesium:{"Accept-Encoding":"gzip, deflate, br",Accept:"application/vnd.quantized-mesh,application/octet-stream;q=0.9,*/*;q=0.01"},mapbox:{Accept:"image/webp,*/*"}};q["cesium-ion"]=q.cesium;const L=32767;let H=null,Y=null;function W(t,e){const r=function(t){if(t.length<1e3)return null;const e=new Zlib.Inflate(t);return e?e.decompress():null}(new Uint8Array(t));if(!r)throw new Error((n=new Uint8Array(t),V.decode(n)));var n;const i=function(t){const e=t,r=j.width,n=j.height,i=new Uint8Array(r*n*j.stride);let s,a,o,h,c;for(let t=0;t<n;t++)for(let f=0;f<r;f++){h=parseInt(149*t/(n-1)),c=parseInt(149*f/(r-1)),a=2*(150*h+c),s=e[a]+256*e[a+1],(s>1e4||s<-2e3)&&(s=0),o=4*(t*r+f);const l=(s+1e3)/j.heightScale,u=j.elementMultiplier;i[o]=l/(u*u),i[o+1]=(l-i[o]*u*u)/u,i[o+2]=l-i[o]*u*u-i[o+1]*u,i[o+3]=255}return i}(r),s=function(t,e){const r=e,n=e,i=r+1,s=n+1,a=j.elementsPerHeight,o=j.heightOffset,h=j.heightScale,c=j.elementMultiplier,f=j.skirtHeight,l=new Float32Array(i*s);let u=0,g=1/0,d=-1/0;for(let e=0;e<i;e++){const i=e>=n?n-1:e;for(let e=0;e<s;e++){let n=0;const s=i*(4*r)+4*(e>=r?r-1:e);for(let e=0;e<a;e++)n=n*c+t[s+e];n=1*(n*h+o),n-=f,l[u]=n,n<g&&(g=n),n>d&&(d=n),u++}}return{data:l,min:g,max:d}}(i,e-1);return s.width=s.height=e,s}const V=new TextDecoder("utf-8");function Z(t){return t>>1^-(1&t)}const G=[];function $(t){let e=0;const r=3*Float64Array.BYTES_PER_ELEMENT,n=3*Uint16Array.BYTES_PER_ELEMENT;let i=Uint16Array.BYTES_PER_ELEMENT;const s=new DataView(t);e+=r;const a=s.getFloat32(e,!0);e+=Float32Array.BYTES_PER_ELEMENT;const o=s.getFloat32(e,!0);e+=Float32Array.BYTES_PER_ELEMENT,e+=r;const h=s.getFloat64(e,!0);e+=Float64Array.BYTES_PER_ELEMENT,e+=r;const c=s.getUint32(e,!0);e+=Uint32Array.BYTES_PER_ELEMENT;const f=new Uint16Array(t,e,3*c);e+=c*n,c>65536&&(i=Uint32Array.BYTES_PER_ELEMENT);!function(t,e,r){const n=t.length;let i=0,s=0,a=0;for(let o=0;o<n;++o)i+=Z(t[o]),s+=Z(e[o]),t[o]=i,e[o]=s,r&&(a+=Z(r[o]),r[o]=a)}(f.subarray(0,c),f.subarray(c,2*c),f.subarray(2*c,3*c)),e%i!=0&&(e+=i-e%i);const l=s.getUint32(e,!0);e+=Uint32Array.BYTES_PER_ELEMENT;const u=c>65536?new Uint32Array(t,e,3*l):new Uint16Array(t,e,3*l);let g=0;const d=u.length;for(let t=0;t<d;++t){const e=u[t];u[t]=g-e,0===e&&++g}const p={minimumHeight:a,maximumHeight:o,quantizedVertices:f,indices:u}.quantizedVertices,y=p.length/3,m=p.subarray(0,y),b=p.subarray(y,2*y),w=p.subarray(2*y,3*y),A=G;for(let t=0;t<y;++t){const e=m[t],r=b[t],n=e/L,i=r/L,s=(v=a,k=o,(1-(E=w[t]/L))*v+E*k);A[3*t]=n,A[3*t+1]=1-i,A[3*t+2]=s}var v,k,E;return{positions:A,radius:h,min:a,max:o,indices:u}}const J=[],K=[],X=[],Q=[],tt=[];class et{constructor(t,e,r,n,i){this.p0=[],this.p1=[],this.p2=[],this.normal=[],this.min=[],this.max=[],this.set(t,e,r,n,i)}set(t,e,r,n,i){this.radius=i;let s=3*e,a=3*e+1,o=3*e+2;this.p0[0]=t[s]*i,this.p0[1]=t[a]*i,this.p0[2]=t[o],s=3*r,a=3*r+1,o=3*r+2,this.p1[0]=t[s]*i,this.p1[1]=t[a]*i,this.p1[2]=t[o],s=3*n,a=3*n+1,o=3*n+2,this.p2[0]=t[s]*i,this.p2[1]=t[a]*i,this.p2[2]=t[o],this.min[0]=Math.min(this.p0[0],this.p1[0],this.p2[0]),this.min[1]=Math.min(this.p0[1],this.p1[1],this.p2[1]),this.max[0]=Math.max(this.p0[0],this.p1[0],this.p2[0]),this.max[1]=Math.max(this.p0[1],this.p1[1],this.p2[1]);const h=u(J,this.p1,this.p0),c=u(K,this.p2,this.p1);this.normal=function(t,e){var r=e[0],n=e[1],i=e[2],s=r*r+n*n+i*i;return s>0&&(s=1/Math.sqrt(s)),t[0]=e[0]*s,t[1]=e[1]*s,t[2]=e[2]*s,t}(this.normal,function(t,e,r){var n=e[0],i=e[1],s=e[2],a=r[0],o=r[1],h=r[2];return t[0]=i*h-s*o,t[1]=s*a-n*h,t[2]=n*o-i*a,t}(this.normal,h,c))}contains(t,e){if(t<this.min[0]||t>this.max[0]||e<this.min[1]||e>this.max[1])return!1;g(X,this.p0[0],this.p0[1]),g(Q,this.p1[0],this.p1[1]),g(tt,this.p2[0],this.p2[1]);const r=st(X[0],X[1],Q[0],Q[1],tt[0],tt[1]);return st(t,e,X[0],X[1],tt[0],tt[1])+st(t,e,X[0],X[1],Q[0],Q[1])+st(t,e,Q[0],Q[1],tt[0],tt[1])-r<=1e-4}getHeight(t,e){const r=this.normal;return this.p0[2]-((t-this.p0[0])*r[0]+(e-this.p0[1])*r[1])/r[2]}}let rt=null;function nt(t,e,r){if(rt&&rt.contains(e,r))return rt.getHeight(e,r);for(let n=0;n<t.length;n++)if(t[n].contains(e,r))return rt=t[n],t[n].getHeight(e,r);return 0}const it=[];function st(t,e,r,n,i,s){return.5*Math.abs(t*n+r*s+i*e-t*s-r*e-i*n)}function at(t,e,r,n,i,s,a){"cesium-ion"===r&&(e.Authorization="Bearer "+H),function(t,e,r){const n={method:"GET",referrer:r,headers:e},i=c.getArrayBuffer(t,n),s=i.xhr;return P[t]=s,i.then((e=>(delete P[t],e)))}(t,e,origin).then((t=>{if(!t||t.message)a(t?{empty:!0,originalError:t}:{error:{canceled:!0}});else{const e=t.data;let o=null;if("tianditu"===r){const t=W(e,n);ht(i,t,n,null,s,a)}else if("cesium-ion"===r||"cesium"===r){o=$(e);const t=function(t,e){const{positions:r,min:n,max:i,indices:s,radius:a}=t,o=[];let h=0;for(let t=0;t<s.length;t+=3){let e=it[h];e?e.set(r,s[t],s[t+1],s[t+2],2*a):e=it[h]=new et(r,s[t],s[t+1],s[t+2],2*a),h++,o.push(e)}const c=new Float32Array(e*e);h=0;for(let t=0;t<e;t++)for(let r=0;r<e;r++)c[h++]=nt(o,r/e*a*2,t/e*a*2);return{data:c,min:n,max:i,width:e,height:e}}(o,n);ht(i,t,n,null,s,a)}else"mapbox"===r&&(o=function(t){const e=new self.Blob([new Uint8Array(t)]);return self.createImageBitmap(e)}(e),o.then((t=>{const e=ft(ct(t),n);ht(i,e,n,t,s,a)})))}})).catch((e=>{delete P[t],a({empty:!0,originalError:e})}))}function ot(t,e){const r=Math.floor(10*(t+1e4)),n=r>>16,i=r>>8&255,s=255&r;return e?(e[0]=n,e[1]=i,e[2]=s,e):[n,i,s]}function ht(t,e,r,n,i,s){const a=function(t,e,r,n){let i,s=y[r];s||(s=y[r]=new d(r)),i=s.createTile(e).getMeshWithSkirts(t,!0);const{triangles:a,vertices:o,leftSkirtIndex:h,rightSkirtIndex:c,bottomSkirtIndex:f,topSkirtIndex:l}=i;let{numVerticesWithoutSkirts:u,numTrianglesWithoutSkirts:g}=i;u||(u=o.length/2,g=a.length/3);const p=o.length/2,m=new Float32Array(3*p),b=new Float32Array(2*p);let w=1/0,A=-1/0;const v=r-1;for(let t=0;t<p;t++){const n=o[2*t],i=o[2*t+1];if(t>=u){const e=n/2*3;let r,i=.001;(t-(t<h/2?u:t<c/2?h/2:t<f/2?c/2:f/2))%3==0?(r=Math.min(0,w),i=0):r=m[e+2],m[3*t]=m[e],m[3*t+1]=m[e+1],m[3*t+2]=r,b[2*t]=m[e]/v+i,b[2*t+1]=-m[e+1]/v+i}else{const s=e[i*r+n];m[3*t]=1*n,m[3*t+1]=1*-i,m[3*t+2]=s,b[2*t]=n/v,b[2*t+1]=i/v,s<w&&(w=s),s>A&&(A=s)}}return{positions:m,texcoords:b,triangles:a,leftSkirtIndex:h,rightSkirtIndex:c,bottomSkirtIndex:f,topSkirtIndex:l,numTrianglesWithoutSkirts:g,numVerticesWithoutSkirts:u,minHeight:Math.min(0,w),maxHeight:A,terrainWidth:r}}(t,e.data,r),o=[a.positions.buffer,a.texcoords.buffer,a.triangles.buffer];n||(n=function(t){if(O(),!z)return;const{width:e,height:r,data:n}=t;if(e&&r&&n)try{let t=z.getContext("2d",{willReadFrequently:!0});const i=t.createImageData(e,r);for(let t=0,e=n.length;t<e;t++){const e=n[t],[r,s,a]=ot(e,_),o=4*t;i.data[o]=r,i.data[o+1]=s,i.data[o+2]=a,i.data[o+3]=255}return z.width=e,z.height=r,t=z.getContext("2d",{willReadFrequently:!0}),lt(t),t.putImageData(i,0,0),z.transferToImageBitmap()}catch(t){console.log(t)}}(e)),n&&o.push(n);const h={mesh:a};h.image=n,h.data=e,o.push(e.data.buffer),s(h,o)}function ct(t){const{width:e,height:r}=t;return z||(z=new OffscreenCanvas(1,1),N=z.getContext("2d",{willReadFrequently:!0})),z.width=e,z.height=r,N.drawImage(t,0,0,e,r),N.getImageData(0,0,e,r)}function ft(t,e){const{data:r,width:n}=t;let i=1/0,s=-1/0;const a=new Float32Array(e*e),o=Math.round(n/e);for(let t=0;t<e;t++)for(let h=0;h<e;h++){const c=t+h*e;let f=0,l=0;const u=t,g=h;for(let t=0;t<o;t++)for(let e=0;e<o;e++){let i=u*o+t,s=g*o+e;s>n-1&&(s=n-1),i>n-1&&(i=n-1);const a=i+s*n,h=r[4*a],c=r[4*a+1],d=r[4*a+2];0===r[4*a+3]?l+=1:f+=.1*(256*h*256+256*c+d)-1e4}f/=o*o-l||1,f>s&&(s=f),f<i&&(i=f),a[c]=f}return{data:a,width:e,height:e,min:i,max:s}}function lt(t){const e=t.canvas,{width:r,height:n}=e;t.clearRect(0,0,r,n)}function ut(t,e,r){if(!e||!Array.isArray(e)||e.length<2)return;if(!t||!t.image)return null;let{width:n,height:i}=t.image;(r=r||C)[0]===n&&r[1]===i||(n=r[0],i=r[1]),n*=2,i*=2;try{if(O(),!z)return;const r=z;r.width=n,r.height=i;const s=r.getContext("2d",{willReadFrequently:!0});lt(s),s.drawImage(t.image,0,0,n,i);const a=s.getImageData(0,0,n,i);!function(t,e){const r=JSON.stringify(e);R[r]||(R[r]=new v(e));const n=R[r],i=t.data;for(let t=0,e=i.length;t<e;t+=4){const e=i[t],r=i[t+1],s=i[t+2];let a=0;0!==i[t+3]&&(a=.1*(256*e*256+256*r+s)-1e4,a=Math.max(a,0));const[o,h,c]=n.getColor(a);i[t]=o,i[t+1]=h,i[t+2]=c,i[t+3]=255}}(a,e),s.putImageData(a,0,0);const o=r.transferToImageBitmap();s.save(),s.scale(1,-1),s.drawImage(o,0,-i,n,i),s.restore();const h=r.transferToImageBitmap();return o.close(),h}catch(t){console.error(t)}}t.initialize=function(){},t.onmessage=function(t,e){const r=t.data;if("addLayer"===r.command||"removeLayer"===r.command)B=t.workerId,self.postMessage({type:"<response>",actorId:r.actorId,workerId:B,params:"ok",callback:t.callback});else if("fetchTerrain"===r.command){const t=(r.params||{}).colors,n=(r.params||{}).tileSize;!function(t,e){const{url:r,origin:n,type:i,accessToken:s,terrainWidth:a,error:o,tileImage:h}=t,c=!0;if(h&&h.close){const t=ft(ct(h),a);return void ht(o,t,a,h,0,e)}const f=t.headers||q[i];if("tianditu"===i)at(r,f,i,a,o,c,e);else if("cesium-ion"===i){const h=t.cesiumIonTokenURL+s;H?at(r,f,i,a,o,c,e):(Y||(Y=fetch(h,{responseType:"json",method:"GET",referrer:n,headers:{Accept:"application/json,*/*;q=0.01","Accept-Encoding":"gzip, deflate, br"}}).then((t=>t.json())).then((t=>{H=t.accessToken,Y=null}))),Y.then((()=>{at(r,f,i,a,o,c,e)})))}else("cesium"===i||"mapbox"===i)&&at(r,f,i,a,o,c,e)}(r.params,((r,i)=>{i=i||[];const s=ut(r,t,n);s&&(r.colorsTexture=s,i.push(s));const a=function(t){if(!t)return;const{positions:e,texcoords:r,triangles:n,leftSkirtIndex:i,rightSkirtIndex:s,bottomSkirtIndex:a,numVerticesWithoutSkirts:o}=t;if(!e||!r||!n)return;if(!(F(i)&&F(s)&&F(a)&&F(o)))return;const h=new Int8Array(e.length);for(let t=2;t<h.length;t+=3)t<3*o?h[t]=1:t<i/2*3?h[t-2]=-1:t<s/2*3?h[t-2]=1:h[t-1]=t<a/2*3?-1:1;const c=I(e,h,r,n);return new Float32Array(c)}(r.mesh);a&&r.mesh&&(r.mesh.tangents=a,i.push(a.buffer)),e(r.error,r,i)}))}else"abortTerrain"===r.command&&(n=r.params.url,P[n]&&(P[n].abort(),delete P[n]));var n}}`;

const code = `function(t){var n,r="undefined"!=typeof Float32Array?Float32Array:Array;function o(t,n,r){return t[0]=n[0]*r,t[1]=n[1]*r,t[2]=n[2]*r,t}function e(t,n,r,o){return t[0]=n[0]+r[0]*o,t[1]=n[1]+r[1]*o,t[2]=n[2]+r[2]*o,t}function a(t,n){var r=n[0],o=n[1],e=n[2],a=r*r+o*o+e*e;return a>0&&(a=1/Math.sqrt(a)),t[0]=n[0]*a,t[1]=n[1]*a,t[2]=n[2]*a,t}
/*!
   * from claygl
   * https://github.com/pissang/claygl/
   * License: BSD-2-Clause
   */
function i(t,n){const r=t[0],o=t[1],e=t[2];return 0===n?1:1===n?r:2===n?o:3===n?e:4===n?r*e:5===n?o*e:6===n?r*o:7===n?3*e*e-1:r*r-o*o}Math.hypot||(Math.hypot=function(){for(var t=0,n=arguments.length;n--;)t+=arguments[n]*arguments[n];return Math.sqrt(t)}),n=new r(3),r!=Float32Array&&(n[0]=0,n[1]=0,n[2]=0);const c={px:[2,1,0,-1,-1,1],nx:[2,1,0,1,-1,-1],py:[0,2,1,1,-1,-1],ny:[0,2,1,1,1,1],pz:[0,1,2,-1,-1,-1],nz:[0,1,2,1,-1,1]},u=["px","nx","py","ny","pz","nz"];t.initialize=function(){},t.onmessage=function(t,n){const r=t.data||{},{cubePixels:s,width:f,height:l}=r;if(!s||!f||!l){const t="Invalid parameters to create light projectEnvironmentMapCPU.";return console.error(r),void n({error:t})}const p=function(t,n,r){const s=new Array(9),f=[],l=[],p=[];for(let h=0;h<9;h++){const y=[0,0,0];for(let o=0;o<u.length;o++){const s=t[o],d=[0,0,0];let v=0,x=0;const A=c[u[o]];for(let t=0;t<r;t++)for(let o=0;o<n;o++){f[0]=o/(n-1)*2-1,f[1]=t/(r-1)*2-1,f[2]=-1,a(f,f),p[0]=f[A[0]]*A[3],p[1]=f[A[1]]*A[4],p[2]=f[A[2]]*A[5],l[0]=s[x++]/255,l[1]=s[x++]/255,l[2]=s[x++]/255;const c=s[x++]/255*7;l[0]*=c,l[1]*=c,l[2]*=c,e(d,d,l,i(p,h)*-f[2]),v+=-f[2]}e(y,y,d,1/v)}s[h]=o(y,y,1/6)}return s}(s.map((t=>new Uint8Array(t))),f,l);n(null,{shList:p})}}`;

registerGLTFLoaderBundle(gltfLoaderExport);
maptalks.registerWorkerAdapter('@maptalks/terrain', code$1);
maptalks.registerWorkerAdapter('maplight', code);

export { Area3DTool, BoxInsideClipper as BoxInsideClipMask, BoxOutsideClipper as BoxOutsideClipMask, canvasCompatible as CanvasCompatible, ClipInsideMask, ClipOutsideMask, ColorMask, context as ContextUtil, Distance3DTool, ElevateMask, FlatInsideMask$1 as FlatInsideMask, FlatInsideMask as FlatOutsideMask, GroundPainter, GroupGLLayer, HeatmapProcess, Height3DTool, highlight as HighlightUtil, ImageMask, MapGLRenderer, MapGPURenderer, MaskLayerMixin, MaskRendererMixin, Measure3DTool, RayCaster, VideoMask, Color$1 as color, earcut$1 as earcut, getWGSLSource, registerWGSLSource, index as reshader, transcoders };

typeof console !== 'undefined' && console.log('@maptalks/gl v0.124.4');
//# sourceMappingURL=maptalksgl.es.js.map
